/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2=globalThis,e$8=t$2.ShadowRoot&&(void 0===t$2.ShadyCSS||t$2.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$2=Symbol(),o$7=new WeakMap;let n$6 = class n{constructor(t,e,o){if(this._$cssResult$=true,o!==s$2)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$8&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=o$7.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&o$7.set(s,t));}return t}toString(){return this.cssText}};const r$6=t=>new n$6("string"==typeof t?t:t+"",void 0,s$2),i$7=(t,...e)=>{const o=1===t.length?t[0]:e.reduce((e,s,o)=>e+(t=>{if(true===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[o+1],t[0]);return new n$6(o,t,s$2)},S$1=(s,o)=>{if(e$8)s.adoptedStyleSheets=o.map(t=>t instanceof CSSStyleSheet?t:t.styleSheet);else for(const e of o){const o=document.createElement("style"),n=t$2.litNonce;void 0!==n&&o.setAttribute("nonce",n),o.textContent=e.cssText,s.appendChild(o);}},c$2=e$8?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$6(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:i$6,defineProperty:e$7,getOwnPropertyDescriptor:h$1,getOwnPropertyNames:r$5,getOwnPropertySymbols:o$6,getPrototypeOf:n$5}=Object,a$2=globalThis,c$1=a$2.trustedTypes,l$3=c$1?c$1.emptyScript:"",p$2=a$2.reactiveElementPolyfillSupport,d$1=(t,s)=>t,u$2={toAttribute(t,s){switch(s){case Boolean:t=t?l$3:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,s){let i=t;switch(s){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t);}catch(t){i=null;}}return i}},f$1=(t,s)=>!i$6(t,s),b$1={attribute:true,type:String,converter:u$2,reflect:false,useDefault:false,hasChanged:f$1};Symbol.metadata??=Symbol("metadata"),a$2.litPropertyMetadata??=new WeakMap;let y$1 = class y extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??=[]).push(t);}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,s=b$1){if(s.state&&(s.attribute=false),this._$Ei(),this.prototype.hasOwnProperty(t)&&((s=Object.create(s)).wrapped=true),this.elementProperties.set(t,s),!s.noAccessor){const i=Symbol(),h=this.getPropertyDescriptor(t,i,s);void 0!==h&&e$7(this.prototype,t,h);}}static getPropertyDescriptor(t,s,i){const{get:e,set:r}=h$1(this.prototype,t)??{get(){return this[s]},set(t){this[s]=t;}};return {get:e,set(s){const h=e?.call(this);r?.call(this,s),this.requestUpdate(t,h,i);},configurable:true,enumerable:true}}static getPropertyOptions(t){return this.elementProperties.get(t)??b$1}static _$Ei(){if(this.hasOwnProperty(d$1("elementProperties")))return;const t=n$5(this);t.finalize(),void 0!==t.l&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties);}static finalize(){if(this.hasOwnProperty(d$1("finalized")))return;if(this.finalized=true,this._$Ei(),this.hasOwnProperty(d$1("properties"))){const t=this.properties,s=[...r$5(t),...o$6(t)];for(const i of s)this.createProperty(i,t[i]);}const t=this[Symbol.metadata];if(null!==t){const s=litPropertyMetadata.get(t);if(void 0!==s)for(const[t,i]of s)this.elementProperties.set(t,i);}this._$Eh=new Map;for(const[t,s]of this.elementProperties){const i=this._$Eu(t,s);void 0!==i&&this._$Eh.set(i,t);}this.elementStyles=this.finalizeStyles(this.styles);}static finalizeStyles(s){const i=[];if(Array.isArray(s)){const e=new Set(s.flat(1/0).reverse());for(const s of e)i.unshift(c$2(s));}else void 0!==s&&i.push(c$2(s));return i}static _$Eu(t,s){const i=s.attribute;return  false===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=false,this.hasUpdated=false,this._$Em=null,this._$Ev();}_$Ev(){this._$ES=new Promise(t=>this.enableUpdating=t),this._$AL=new Map,this._$E_(),this.requestUpdate(),this.constructor.l?.forEach(t=>t(this));}addController(t){(this._$EO??=new Set).add(t),void 0!==this.renderRoot&&this.isConnected&&t.hostConnected?.();}removeController(t){this._$EO?.delete(t);}_$E_(){const t=new Map,s=this.constructor.elementProperties;for(const i of s.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t);}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return S$1(t,this.constructor.elementStyles),t}connectedCallback(){this.renderRoot??=this.createRenderRoot(),this.enableUpdating(true),this._$EO?.forEach(t=>t.hostConnected?.());}enableUpdating(t){}disconnectedCallback(){this._$EO?.forEach(t=>t.hostDisconnected?.());}attributeChangedCallback(t,s,i){this._$AK(t,i);}_$ET(t,s){const i=this.constructor.elementProperties.get(t),e=this.constructor._$Eu(t,i);if(void 0!==e&&true===i.reflect){const h=(void 0!==i.converter?.toAttribute?i.converter:u$2).toAttribute(s,i.type);this._$Em=t,null==h?this.removeAttribute(e):this.setAttribute(e,h),this._$Em=null;}}_$AK(t,s){const i=this.constructor,e=i._$Eh.get(t);if(void 0!==e&&this._$Em!==e){const t=i.getPropertyOptions(e),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==t.converter?.fromAttribute?t.converter:u$2;this._$Em=e;const r=h.fromAttribute(s,t.type);this[e]=r??this._$Ej?.get(e)??r,this._$Em=null;}}requestUpdate(t,s,i,e=false,h){if(void 0!==t){const r=this.constructor;if(false===e&&(h=this[t]),i??=r.getPropertyOptions(t),!((i.hasChanged??f$1)(h,s)||i.useDefault&&i.reflect&&h===this._$Ej?.get(t)&&!this.hasAttribute(r._$Eu(t,i))))return;this.C(t,s,i);} false===this.isUpdatePending&&(this._$ES=this._$EP());}C(t,s,{useDefault:i,reflect:e,wrapped:h},r){i&&!(this._$Ej??=new Map).has(t)&&(this._$Ej.set(t,r??s??this[t]),true!==h||void 0!==r)||(this._$AL.has(t)||(this.hasUpdated||i||(s=void 0),this._$AL.set(t,s)),true===e&&this._$Em!==t&&(this._$Eq??=new Set).add(t));}async _$EP(){this.isUpdatePending=true;try{await this._$ES;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??=this.createRenderRoot(),this._$Ep){for(const[t,s]of this._$Ep)this[t]=s;this._$Ep=void 0;}const t=this.constructor.elementProperties;if(t.size>0)for(const[s,i]of t){const{wrapped:t}=i,e=this[s];true!==t||this._$AL.has(s)||void 0===e||this.C(s,void 0,i,e);}}let t=false;const s=this._$AL;try{t=this.shouldUpdate(s),t?(this.willUpdate(s),this._$EO?.forEach(t=>t.hostUpdate?.()),this.update(s)):this._$EM();}catch(s){throw t=false,this._$EM(),s}t&&this._$AE(s);}willUpdate(t){}_$AE(t){this._$EO?.forEach(t=>t.hostUpdated?.()),this.hasUpdated||(this.hasUpdated=true,this.firstUpdated(t)),this.updated(t);}_$EM(){this._$AL=new Map,this.isUpdatePending=false;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return  true}update(t){this._$Eq&&=this._$Eq.forEach(t=>this._$ET(t,this[t])),this._$EM();}updated(t){}firstUpdated(t){}};y$1.elementStyles=[],y$1.shadowRootOptions={mode:"open"},y$1[d$1("elementProperties")]=new Map,y$1[d$1("finalized")]=new Map,p$2?.({ReactiveElement:y$1}),(a$2.reactiveElementVersions??=[]).push("2.1.2");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1=globalThis,i$5=t=>t,s$1=t$1.trustedTypes,e$6=s$1?s$1.createPolicy("lit-html",{createHTML:t=>t}):void 0,h="$lit$",o$5=`lit$${Math.random().toFixed(9).slice(2)}$`,n$4="?"+o$5,r$4=`<${n$4}>`,l$2=document,c=()=>l$2.createComment(""),a$1=t=>null===t||"object"!=typeof t&&"function"!=typeof t,u$1=Array.isArray,d=t=>u$1(t)||"function"==typeof t?.[Symbol.iterator],f="[ \t\n\f\r]",v=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_=/-->/g,m$1=/>/g,p$1=RegExp(`>|${f}(?:([^\\s"'>=/]+)(${f}*=${f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g=/'/g,$=/"/g,y=/^(?:script|style|textarea|title)$/i,x=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),b=x(1),w=x(2),E=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),C=new WeakMap,P=l$2.createTreeWalker(l$2,129);function V(t,i){if(!u$1(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e$6?e$6.createHTML(i):i}const N=(t,i)=>{const s=t.length-1,e=[];let n,l=2===i?"<svg>":3===i?"<math>":"",c=v;for(let i=0;i<s;i++){const s=t[i];let a,u,d=-1,f=0;for(;f<s.length&&(c.lastIndex=f,u=c.exec(s),null!==u);)f=c.lastIndex,c===v?"!--"===u[1]?c=_:void 0!==u[1]?c=m$1:void 0!==u[2]?(y.test(u[2])&&(n=RegExp("</"+u[2],"g")),c=p$1):void 0!==u[3]&&(c=p$1):c===p$1?">"===u[0]?(c=n??v,d=-1):void 0===u[1]?d=-2:(d=c.lastIndex-u[2].length,a=u[1],c=void 0===u[3]?p$1:'"'===u[3]?$:g):c===$||c===g?c=p$1:c===_||c===m$1?c=v:(c=p$1,n=void 0);const x=c===p$1&&t[i+1].startsWith("/>")?" ":"";l+=c===v?s+r$4:d>=0?(e.push(a),s.slice(0,d)+h+s.slice(d)+o$5+x):s+o$5+(-2===d?i:x);}return [V(t,l+(t[s]||"<?>")+(2===i?"</svg>":3===i?"</math>":"")),e]};class S{constructor({strings:t,_$litType$:i},e){let r;this.parts=[];let l=0,a=0;const u=t.length-1,d=this.parts,[f,v]=N(t,i);if(this.el=S.createElement(f,e),P.currentNode=this.el.content,2===i||3===i){const t=this.el.content.firstChild;t.replaceWith(...t.childNodes);}for(;null!==(r=P.nextNode())&&d.length<u;){if(1===r.nodeType){if(r.hasAttributes())for(const t of r.getAttributeNames())if(t.endsWith(h)){const i=v[a++],s=r.getAttribute(t).split(o$5),e=/([.?@])?(.*)/.exec(i);d.push({type:1,index:l,name:e[2],strings:s,ctor:"."===e[1]?I:"?"===e[1]?L:"@"===e[1]?z:H}),r.removeAttribute(t);}else t.startsWith(o$5)&&(d.push({type:6,index:l}),r.removeAttribute(t));if(y.test(r.tagName)){const t=r.textContent.split(o$5),i=t.length-1;if(i>0){r.textContent=s$1?s$1.emptyScript:"";for(let s=0;s<i;s++)r.append(t[s],c()),P.nextNode(),d.push({type:2,index:++l});r.append(t[i],c());}}}else if(8===r.nodeType)if(r.data===n$4)d.push({type:2,index:l});else {let t=-1;for(;-1!==(t=r.data.indexOf(o$5,t+1));)d.push({type:7,index:l}),t+=o$5.length-1;}l++;}}static createElement(t,i){const s=l$2.createElement("template");return s.innerHTML=t,s}}function M(t,i,s=t,e){if(i===E)return i;let h=void 0!==e?s._$Co?.[e]:s._$Cl;const o=a$1(i)?void 0:i._$litDirective$;return h?.constructor!==o&&(h?._$AO?.(false),void 0===o?h=void 0:(h=new o(t),h._$AT(t,s,e)),void 0!==e?(s._$Co??=[])[e]=h:s._$Cl=h),void 0!==h&&(i=M(t,h._$AS(t,i.values),h,e)),i}class R{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:s}=this._$AD,e=(t?.creationScope??l$2).importNode(i,true);P.currentNode=e;let h=P.nextNode(),o=0,n=0,r=s[0];for(;void 0!==r;){if(o===r.index){let i;2===r.type?i=new k(h,h.nextSibling,this,t):1===r.type?i=new r.ctor(h,r.name,r.strings,this,t):6===r.type&&(i=new Z(h,this,t)),this._$AV.push(i),r=s[++n];}o!==r?.index&&(h=P.nextNode(),o++);}return P.currentNode=l$2,e}p(t){let i=0;for(const s of this._$AV) void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class k{get _$AU(){return this._$AM?._$AU??this._$Cv}constructor(t,i,s,e){this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cv=e?.isConnected??true;}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t?.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=M(this,t,i),a$1(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==E&&this._(t):void 0!==t._$litType$?this.$(t):void 0!==t.nodeType?this.T(t):d(t)?this.k(t):this._(t);}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t));}_(t){this._$AH!==A&&a$1(this._$AH)?this._$AA.nextSibling.data=t:this.T(l$2.createTextNode(t)),this._$AH=t;}$(t){const{values:i,_$litType$:s}=t,e="number"==typeof s?this._$AC(t):(void 0===s.el&&(s.el=S.createElement(V(s.h,s.h[0]),this.options)),s);if(this._$AH?._$AD===e)this._$AH.p(i);else {const t=new R(e,this),s=t.u(this.options);t.p(i),this.T(s),this._$AH=t;}}_$AC(t){let i=C.get(t.strings);return void 0===i&&C.set(t.strings,i=new S(t)),i}k(t){u$1(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const h of t)e===i.length?i.push(s=new k(this.O(c()),this.O(c()),this,this.options)):s=i[e],s._$AI(h),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,s){for(this._$AP?.(false,true,s);t!==this._$AB;){const s=i$5(t).nextSibling;i$5(t).remove(),t=s;}}setConnected(t){ void 0===this._$AM&&(this._$Cv=t,this._$AP?.(t));}}class H{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,s,e,h){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=h,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A;}_$AI(t,i=this,s,e){const h=this.strings;let o=false;if(void 0===h)t=M(this,t,i,0),o=!a$1(t)||t!==this._$AH&&t!==E,o&&(this._$AH=t);else {const e=t;let n,r;for(t=h[0],n=0;n<h.length-1;n++)r=M(this,e[s+n],i,n),r===E&&(r=this._$AH[n]),o||=!a$1(r)||r!==this._$AH[n],r===A?t=A:t!==A&&(t+=(r??"")+h[n+1]),this._$AH[n]=r;}o&&!e&&this.j(t);}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"");}}class I extends H{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===A?void 0:t;}}class L extends H{constructor(){super(...arguments),this.type=4;}j(t){this.element.toggleAttribute(this.name,!!t&&t!==A);}}class z extends H{constructor(t,i,s,e,h){super(t,i,s,e,h),this.type=5;}_$AI(t,i=this){if((t=M(this,t,i,0)??A)===E)return;const s=this._$AH,e=t===A&&s!==A||t.capture!==s.capture||t.once!==s.once||t.passive!==s.passive,h=t!==A&&(s===A||e);e&&this.element.removeEventListener(this.name,this,s),h&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){"function"==typeof this._$AH?this._$AH.call(this.options?.host??this.element,t):this._$AH.handleEvent(t);}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){M(this,t);}}const B=t$1.litHtmlPolyfillSupport;B?.(S,k),(t$1.litHtmlVersions??=[]).push("3.3.3");const D=(t,i,s)=>{const e=s?.renderBefore??i;let h=e._$litPart$;if(void 0===h){const t=s?.renderBefore??null;e._$litPart$=h=new k(i.insertBefore(c(),t),t,void 0,s??{});}return h._$AI(t),h};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const s=globalThis;let i$4 = class i extends y$1{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){const t=super.createRenderRoot();return this.renderOptions.renderBefore??=t.firstChild,t}update(t){const r=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D(r,this.renderRoot,this.renderOptions);}connectedCallback(){super.connectedCallback(),this._$Do?.setConnected(true);}disconnectedCallback(){super.disconnectedCallback(),this._$Do?.setConnected(false);}render(){return E}};i$4._$litElement$=true,i$4["finalized"]=true,s.litElementHydrateSupport?.({LitElement:i$4});const o$4=s.litElementPolyfillSupport;o$4?.({LitElement:i$4});(s.litElementVersions??=[]).push("4.2.2");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const o$3={attribute:true,type:String,converter:u$2,reflect:false,hasChanged:f$1},r$3=(t=o$3,e,r)=>{const{kind:n,metadata:i}=r;let s=globalThis.litPropertyMetadata.get(i);if(void 0===s&&globalThis.litPropertyMetadata.set(i,s=new Map),"setter"===n&&((t=Object.create(t)).wrapped=true),s.set(r.name,t),"accessor"===n){const{name:o}=r;return {set(r){const n=e.get.call(this);e.set.call(this,r),this.requestUpdate(o,n,t,true,r);},init(e){return void 0!==e&&this.C(o,void 0,t,e),e}}}if("setter"===n){const{name:o}=r;return function(r){const n=this[o];e.call(this,r),this.requestUpdate(o,n,t,true,r);}}throw Error("Unsupported decorator location: "+n)};function n$3(t){return (e,o)=>"object"==typeof o?r$3(t,e,o):((t,e,o)=>{const r=e.hasOwnProperty(o);return e.constructor.createProperty(o,t),r?Object.getOwnPropertyDescriptor(e,o):void 0})(t,e,o)}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function r$2(r){return n$3({...r,state:true,attribute:false})}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$5=(e,t,c)=>(c.configurable=true,c.enumerable=true,Reflect.decorate&&"object"!=typeof t&&Object.defineProperty(e,t,c),c);

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function e$4(e,r){return (n,s,i)=>{const o=t=>t.renderRoot?.querySelector(e)??null;return e$5(n,s,{get(){return o(this)}})}}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let e$3;function r$1(r){return (n,o)=>e$5(n,o,{get(){return (this.renderRoot??(e$3??=document.createDocumentFragment())).querySelectorAll(r)}})}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function o$2(o){return (e,n)=>{const{slot:r,selector:s}=o??{},c="slot"+(r?`[name=${r}]`:":not([name])");return e$5(e,n,{get(){const t=this.renderRoot?.querySelector(c),e=t?.assignedElements(o)??[];return void 0===s?e:e.filter(t=>t.matches(s))}})}}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function n$2(n){return (o,r)=>{const{slot:e}=n??{},s="slot"+(e?`[name=${e}]`:":not([name])");return e$5(o,r,{get(){const t=this.renderRoot?.querySelector(s);return t?.assignedNodes(n)??[]}})}}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * Tag that allows expressions to be used in localized non-HTML template
 * strings.
 *
 * Example: msg(str`Hello ${this.user}!`);
 *
 * The Lit html tag can also be used for this purpose, but HTML will need to be
 * escaped, and there is a small overhead for HTML parsing.
 *
 * Untagged template strings with expressions aren't supported by lit-localize
 * because they don't allow for values to be captured at runtime.
 */
const _str = (strings, ...values) => ({
    strTag: true,
    strings,
    values,
});
const str = _str;
const isStrTagged = (val) => typeof val !== 'string' && 'strTag' in val;
/**
 * Render the result of a `str` tagged template to a string. Note we don't need
 * to do this for Lit templates, since Lit itself handles rendering.
 */
const joinStringsAndValues = (strings, values, valueOrder) => {
    let concat = strings[0];
    for (let i = 1; i < strings.length; i++) {
        concat += values[i - 1];
        concat += strings[i];
    }
    return concat;
};

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * Default identity msg implementation. Simply returns the input template with
 * no awareness of translations. If the template is str-tagged, returns it in
 * string form.
 */
const defaultMsg = ((template) => isStrTagged(template)
    ? joinStringsAndValues(template.strings, template.values)
    : template);

/**
 * Make a string or lit-html template localizable.
 *
 * @param template A string, a lit-html template, or a function that returns
 * either a string or lit-html template.
 * @param options Optional configuration object with the following properties:
 *   - id: Optional project-wide unique identifier for this template. If
 *     omitted, an id will be automatically generated from the template strings.
 *   - desc: Optional description
 */
let msg = defaultMsg;

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Deferred {
    constructor() {
        this.settled = false;
        this.promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    resolve(value) {
        this.settled = true;
        this._resolve(value);
    }
    reject(error) {
        this.settled = true;
        this._reject(error);
    }
}

/**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */
// This module is derived from the file:
// https://github.com/tjwebb/fnv-plus/blob/1e2ce68a07cb7dd4c3c85364f3d8d96c95919474/index.js#L309
//
// Changes:
// - Only the _hash64_1a_fast function is included.
// - Removed loop unrolling.
// - Converted to TypeScript ES module.
// - var -> let/const
//
// TODO(aomarks) Upstream improvements to https://github.com/tjwebb/fnv-plus/.
for (let i = 0; i < 256; i++) {
    ((i >> 4) & 15).toString(16) + (i & 15).toString(16);
}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let loading = new Deferred();
// The loading promise must be initially resolved, because that's what we should
// return if the user immediately calls setLocale(sourceLocale).
loading.resolve();

function newEditEventV2(edit, options) {
    return new CustomEvent('oscd-edit-v2', {
        composed: true,
        bubbles: true,
        detail: { ...options, edit },
    });
}

const appliedClassMixins = new WeakMap();

/** Vefify if the Mixin was previously applyed
 * @private
 * @param {function} mixin      Mixin being applyed
 * @param {object} superClass   Class receiving the new mixin
 * @returns {boolean}
 */
function wasMixinPreviouslyApplied(mixin, superClass) {
  let klass = superClass;
  while (klass) {
    if (appliedClassMixins.get(klass) === mixin) {
      return true;
    }
    klass = Object.getPrototypeOf(klass);
  }
  return false;
}

/** Apply each mixin in the chain to make sure they are not applied more than once to the final class.
 * @export
 * @param {function} mixin      Mixin to be applyed
 * @returns {object}            Mixed class with mixin applied
 */
function dedupeMixin(mixin) {
  return superClass => {
    if (wasMixinPreviouslyApplied(mixin, superClass)) {
      return superClass;
    }
    const mixedClass = mixin(superClass);
    appliedClassMixins.set(mixedClass, mixin);
    return mixedClass;
  };
}

/**
 * @typedef {import('./types.js').ScopedElementsHost} ScopedElementsHost
 * @typedef {import('./types.js').ScopedElementsMap} ScopedElementsMap
 * @typedef {import('./types.js').ScopedElementsHostConstructor} ScopedElementsHostConstructor
 */

const version = '3.0.0';
const versions = window.scopedElementsVersions || (window.scopedElementsVersions = []);
if (!versions.includes(version)) {
  versions.push(version);
}

/**
 * @template {import('./types.js').Constructor<HTMLElement>} T
 * @param {T} superclass
 * @return {T & import('./types.js').Constructor<ScopedElementsHost> & ScopedElementsHostConstructor}
 */
const ScopedElementsMixinImplementation$1 = superclass =>
  /** @type {ScopedElementsHost} */
  class ScopedElementsHost extends superclass {
    /**
     * Obtains the scoped elements definitions map if specified.
     *
     * @type {ScopedElementsMap=}
     */
    static scopedElements;

    static get scopedElementsVersion() {
      return version;
    }

    /** @type {CustomElementRegistry=} */
    static __registry;

    /**
     * Obtains the CustomElementRegistry associated to the ShadowRoot.
     *
     * @returns {CustomElementRegistry=}
     */
    get registry() {
      return /** @type {typeof ScopedElementsHost} */ (this.constructor).__registry;
    }

    /**
     * Set the CustomElementRegistry associated to the ShadowRoot
     *
     * @param {CustomElementRegistry} registry
     */
    set registry(registry) {
      /** @type {typeof ScopedElementsHost} */ (this.constructor).__registry = registry;
    }

    /**
     * @param {ShadowRootInit} options
     * @returns {ShadowRoot}
     */
    attachShadow(options) {
      const { scopedElements } = /** @type {typeof ScopedElementsHost} */ (this.constructor);

      const shouldCreateRegistry =
        !this.registry ||
        // @ts-ignore
        (this.registry === this.constructor.__registry &&
          !Object.prototype.hasOwnProperty.call(this.constructor, '__registry'));

      /**
       * Create a new registry if:
       * - the registry is not defined
       * - this class doesn't have its own registry *AND* has no shared registry
       * This is important specifically for superclasses/inheritance
       */
      if (shouldCreateRegistry) {
        this.registry = new CustomElementRegistry();
        for (const [tagName, klass] of Object.entries(scopedElements ?? {})) {
          this.registry.define(tagName, klass);
        }
      }

      return super.attachShadow({
        ...options,
        // The polyfill currently expects the registry to be passed as `customElements`
        customElements: this.registry,
        // But the proposal has moved forward, and renamed it to `registry`
        // For backwards compatibility, we pass it as both
        registry: this.registry,
      });
    }
  };

const ScopedElementsMixin$1 = dedupeMixin(ScopedElementsMixinImplementation$1);

/**
 * @typedef {import('./types.js').ScopedElementsHost} ScopedElementsHost
 * @typedef {import('./types.js').ScopedElementsMap} ScopedElementsMap
 * @typedef {import('./types.js').ScopedElementsHostConstructor} ScopedElementsHostConstructor
 * @typedef {import('lit').CSSResultOrNative} CSSResultOrNative
 * @typedef {import('lit').LitElement} LitElement
 * @typedef {typeof import('lit').LitElement} TypeofLitElement
 * @typedef {import('@open-wc/dedupe-mixin').Constructor<LitElement>} LitElementConstructor
 */

/**
 * @template {LitElementConstructor} T
 * @param {T} superclass
 * @return {T & import('@open-wc/dedupe-mixin').Constructor<ScopedElementsHost> & ScopedElementsHostConstructor}
 */
const ScopedElementsMixinImplementation = superclass =>
  /** @type {ScopedElementsHost} */
  class ScopedElementsHost extends ScopedElementsMixin$1(superclass) {
    createRenderRoot() {
      const { shadowRootOptions, elementStyles } = /** @type {TypeofLitElement} */ (
        this.constructor
      );

      const shadowRoot = this.attachShadow(shadowRootOptions);
      // @ts-ignore
      this.renderOptions.creationScope = shadowRoot;

      S$1(shadowRoot, elementStyles);

      this.renderOptions.renderBefore ??= shadowRoot.firstChild;

      return shadowRoot;
    }
  };

const ScopedElementsMixin = dedupeMixin(ScopedElementsMixinImplementation);

const oscdMd3Mappings = i$7 `
  :host {
    --md-sys-color-error: var(--oscd-theme-error, #dc322f);
    --md-sys-color-error-container: var(--oscd-theme-base2, #eee8d5);
    --md-sys-color-inverse-on-surface: var(--oscd-theme-base3, #fdf6e3);
    --md-sys-color-inverse-surface: var(--oscd-theme-base03, #002b36);
    --md-sys-color-on-error: var(--oscd-theme-base3, #fdf6e3);
    --md-sys-color-on-error-container: var(--oscd-theme-base00, #657b83);
    --md-sys-color-on-primary: var(--oscd-theme-base3, #fdf6e3);
    --md-sys-color-on-primary-container: var(--oscd-theme-base00, #657b83);
    --md-sys-color-on-secondary: var(--oscd-theme-base3, #fdf6e3);
    --md-sys-color-on-secondary-container: var(--oscd-theme-base00, #657b83);
    --md-sys-color-on-surface: var(--oscd-theme-base00, #657b83);
    --md-sys-color-on-surface-variant: var(--oscd-theme-base0, #839496);
    --md-sys-color-on-tertiary-container: var(--oscd-theme-base00, #657b83);
    --md-sys-color-outline: var(--oscd-theme-base01, #586e75);
    --md-sys-color-outline-variant: var(--oscd-theme-base1, #93a1a1);
    --md-sys-color-primary: var(--oscd-theme-primary, #2aa198);
    --md-sys-color-primary-container: var(--oscd-theme-base2, #eee8d5);
    --md-sys-color-scrim: #000;
    --md-sys-color-secondary: var(--oscd-theme-secondary, #6c71c4);
    --md-sys-color-secondary-container: var(--oscd-theme-base2, #eee8d5);
    --md-sys-color-shadow: #000;
    --md-sys-color-surface: var(--oscd-theme-base3, #fdf6e3);
    --md-sys-color-surface-container: var(--oscd-theme-base2, #eee8d5);
    --md-sys-color-surface-container-high: var(--oscd-theme-base2, #eee8d5);
    --md-sys-color-surface-container-highest: var(--oscd-theme-base2, #eee8d5);
    --md-sys-color-surface-container-low: var(--oscd-theme-base3, #fdf6e3);
    --md-sys-color-tertiary: var(--oscd-theme-secondary, #6c71c4);
    --md-sys-color-tertiary-container: var(--oscd-theme-base2, #eee8d5);
  }
`;
i$7 `
  :host {
    --oscd-ace-editor-syntax-keyword-color: var(
      --oscd-theme-secondary,
      #0b335b
    );
    --oscd-ace-editor-syntax-string-color: var(--oscd-theme-base00, #46505d);
    --oscd-ace-editor-syntax-tag-color: var(--oscd-theme-secondary, #0b335b);
    --oscd-ace-editor-syntax-attribute-name-color: var(
      --oscd-theme-primary,
      #2485e5
    );
    --oscd-ace-editor-syntax-comment-color: var(--oscd-theme-base01, #3d4651);
    --oscd-ace-editor-syntax-number-color: var(--oscd-theme-base00, #46505d);
    --oscd-ace-editor-syntax-invalid-color: var(--oscd-theme-error, #dc322f);
    --oscd-ace-editor-syntax-storage-color: var(--oscd-theme-primary, #2485e5);
    --oscd-ace-editor-syntax-operator-color: var(--oscd-theme-base01, #3d4651);
    --oscd-ace-editor-syntax-parameter-color: var(
      --oscd-theme-warning,
      #b58900
    );
    --oscd-ace-editor-syntax-regex-color: var(--oscd-theme-error, #dc322f);
    --oscd-ace-editor-step-color: var(--oscd-theme-warning, #b58900);
  }
`;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t={ATTRIBUTE:1,PROPERTY:3,BOOLEAN_ATTRIBUTE:4},e$2=t=>(...e)=>({_$litDirective$:t,values:e});let i$3 = class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i;}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}};

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$1={},i$2=e$2(class extends i$3{constructor(){super(...arguments),this.ot=e$1;}render(r,t){return t()}update(t,[s,e]){if(Array.isArray(s)){if(Array.isArray(this.ot)&&this.ot.length===s.length&&s.every((r,t)=>r===this.ot[t]))return E}else if(this.ot===s)return E;return this.ot=Array.isArray(s)?Array.from(s):s,this.render(s,e)}});

const eqTypes = [
    'CAB',
    'CAP',
    'CBR',
    'CTR',
    'DIS',
    'GEN',
    'IFL',
    'LIN',
    'MOT',
    'REA',
    'RES',
    'SAR',
    'SMC',
    'VTR',
];
function isEqType(str) {
    return eqTypes.includes(str);
}
const ringedEqTypes = new Set(['GEN', 'MOT', 'SMC']);
const singleTerminal = new Set([
    'BAT',
    'EFN',
    'FAN',
    'GEN',
    'IFL',
    'MOT',
    'PMP',
    'RRC',
    'SAR',
    'SMC',
    'VTR',
]);

w `<path
  d="M120 616v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 640v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80v80h-80Zm160 0v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160V296H600v-80h240v240h-80ZM120 936V696h80v160h160v80H120Z"
/>`;
const resizeTLPath = w `<path
  d="m 120,616 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 320,0 H 600 V 216 H 840 Z M 120,936 V 696 h 80 v 160 z" /> `;
const resizeBRPath = w `<path
  d="m 440,936 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 V 296 l 80,-80 v 240 z m -640,480 80,-80 h 160 v 80 z" />`;
// TODO: remove alt icons if unneeded
w `<path
  d="m 120,616 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z M 760,936 V 296 H 600 v -80 h 240 v 720 z m -640,0 V 696 h 80 v 160 h 560 v 80 z" /> `;
w `<path
  d="m 440,936 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 V 296 H 200 V 216 H 840 V 456 Z M 120,936 V 216 h 80 v 640 h 160 v 80 z" />`;
w `<path
  d="m 120,616 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z M 760,456 V 296 H 600 V 216 H 840 V 456 Z M 120,936 V 696 h 80 v 160 h 160 v 80 z" /> `;
w `<path
  d="m 440,936 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 160,0 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 v -80 h 80 v 80 z m 0,-160 V 296 H 600 V 216 H 840 V 456 Z M 120,936 V 696 h 80 v 160 h 160 v 80 z" />`;
const zigPath = w `
  <line x1="1.5" y1="1.5" x2="1.5" y2="1.25" />
  <line transform="rotate(240 1.5 1.25)" x1="1.5" y1="1.5" x2="1.5" y2="1.25" />
`;
const zigZagPath = w `
<g>${zigPath}</g>
<g transform="rotate(120 1.5 1.5)">${zigPath}</g>
<g transform="rotate(240 1.5 1.5)">${zigPath}</g>
`;
const zigZag2WTransform = 'matrix(0.8, 0, 0, 0.8, 0.3, 0.3) translate(0 -0.1) rotate(-20 1.5 1.5)';
const equipmentPaths = {
    CAB: w `
  <path
    d="M 9.4,4.2 H 15.6 L 12.5,8.3 Z"
    fill="currentColor"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  <path
    d="m 12.5,8.3 v 9"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  <path
    d="m 9.4,21.3 h 6.2 l -3.1,-4.1 z"
    fill="currentColor"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  `,
    CAP: w `
  <path
    d="M 6.5,10.1 H 18.5"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  <path
    d="M 12.5,4 V 10.1"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  <path
    d="M 6.5,14.9 H 18.5"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  <path
    d="M 12.5,14.9 V 21"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  `,
    CBR: w `
  <line
    x1="12.5"
    y1="21"
    x2="4"
    y2="5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <line
    x1="9.5"
    y1="1"
    x2="15.5"
    y2="7"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <line
    x1="9.5"
    y1="7"
    x2="15.5"
    y2="1"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    CTR: w `
  <line
    x1="12.5"
    y1="4"
    x2="12.5"
    y2="21"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <circle
    cx="12.5"
    cy="12.5"
    r="7.5"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    DIS: w `
  <path
    d="M 12.5 21 L 4 4"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M 8 4 L 17 4"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    GEN: w `
  <path
    d="m 16.2,12.5 v 4.2 q -0.2,0.2 -0.6,0.6 -0.4,0.4 -1.1,0.7 -0.7,0.3 -1.8,0.3 -1.8,0 -2.9,-1.2 -1.1,-1.2 -1.1,-3.6 v -2.1 q 0,-2.4 1,-3.6 1,-1.1 2.9,-1.1 1.7,0 2.6,0.9 0.9,0.9 1,2.6 h -1.4 q -0.1,-1.1 -0.6,-1.6 -0.5,-0.6 -1.5,-0.6 -1.3,0 -1.8,0.9 -0.5,0.9 -0.5,2.6 v 2.1 q 0,1.8 0.7,2.7 0.7,0.9 1.9,0.9 1,0 1.4,-0.3 0.4,-0.3 0.6,-0.5 v -2.6 h -2.1 v -1.2 z"
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0.3"
    stroke-linecap="round"
  />
  `,
    IFL: w `
  <polygon
    points="4,4 12.5,21 21,4"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linejoin="round"
    stroke-linecap="round"
  />
  `,
    LIN: w `
  <path
    d="M 12.5,4 V 21"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="m 10.3,12.5 4.3,-2.5"
    fill="currentColor"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="m 10.3,15 4.3,-2.5"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    MOT: w `
  <path
    d="m 12.5,15.5 2.3,-7.8 h 1.4 v 9.6 h -1.1 v -3.7 l 0.1,-3.7 -2.3,7.4 h -0.9 L 9.8,9.8 9.9,13.6 v 3.7 H 8.8 V 7.7 h 1.4 z"
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0.3"
    stroke-linecap="round"
  />
  `,
    REA: w `
  <path
    d="m 4.5,12.5 h 8 V 4"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="m 4.5,12.5 a 8,8 0 0 1 8,-8 8,8 0 0 1 8,8 8,8 0 0 1 -8,8"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M 12.5,20.5 V 21"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    RES: w `
  <rect
    y="4"
    x="8.5"
    height="17"
    width="8"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    SAR: w `
  <path
    d="M 12.5,4 V 8"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    />
  <path
    d="m 12.5,21 v 4"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <line
    x1="10"
    y1="24.25"
    x2="15"
    y2="24.25"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M 11.2,8 12.5,11 13.8,8 Z"
    fill="currentColor"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="round"
  />
  <rect
    y="4"
    x="8.5"
    height="17"
    width="8"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `,
    SMC: w `
  <path
    d="m 16.6,12.5 c -0.7,1.4 -1.3,2.8 -2.1,2.8 -1.5,0 -2.6,-5.6 -4.1,-5.6 -0.7,0 -1.4,1.4 -2.1,2.8"
    stroke="currentColor"
    fill="none"
    stroke-width="1.2"
    stroke-linecap="round"
  />
  `,
    VTR: w `
  <circle
    cx="12.5"
    cy="9.5"
    r="5.25"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <circle
    cx="12.5"
    cy="15.5"
    r="5.25"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
`,
};
const eqRingPath = w `
  <circle
    cx="12.5"
    cy="12.5"
    r="8.5"
    stroke="currentColor"
    fill="none"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  `;
const defaultEquipmentPath = w `
  <circle
    cx="12.5"
    cy="12.5"
    r="11"
    stroke-width="1.5"
    stroke="currentColor"
    fill="none"
  />
  <path
    d=" M 7.5 17.5
    L 12 13
    Z"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
    stroke-linecap="round"
  />
  <path
    d="	M 11 7
      L 10 8
      C 5 13, 11 20, 17 15
      L 18 14
      Z"
    fill="currentColor"
    stroke="currentColor"
    stroke-linejoin="round"
  />
  <path
    d=" M 13 9
    L 16 6
    Z"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
    stroke-linecap="round"
  />
  <path
    d=" M 16 12
    L 19 9
    Z"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
    stroke-linecap="round"
  />
`;
function equipmentPath(equipmentType) {
    if (equipmentType && isEqType(equipmentType)) {
        return equipmentPaths[equipmentType];
    }
    return defaultEquipmentPath;
}
function equipmentSymbol(equipmentType) {
    return w `<symbol
    id="${equipmentType}"
    viewBox="0 0 25 25"
    width="1" height="1"
  >
    ${equipmentPath(equipmentType)}
  </symbol>`;
}
const iedSymbol = w `<symbol
    id="IED"
    viewBox="0 0 25 25"
    width="1" height="1"
  >
  <path
    fill="currentColor"
    d="M22 9V7h-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-2h-2v-2h2v-2h-2V9zm-4 10H4V5h14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
  />
  </symbol>`;
const groundedMarker = w `<marker
  markerWidth="20" markerHeight="20"
  refX="12.5" refY="12.5"
  viewBox="0 0 25 25"
  id="grounded"
  orient="auto-start-reverse"
>
  <line
    y1="17"
    y2="8"
    x1="12.5"
    x2="12.5"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-width="1.5"
  />
  <line
    y1="15.5"
    y2="9.5"
    x1="14.7"
    x2="14.7"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-width="1.5"
  />
  <line
    y1="14.5"
    y2="10.5"
    x1="16.8"
    x2="16.8"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-width="1.5"
  />
</marker>`;
const arrowMarker = w `
<marker
  id="arrow"
  viewBox="0 0 10 10"
  refX="5"
  refY="5"
  markerWidth="6"
  markerHeight="6"
  orient="auto-start-reverse">
  <path d="M 0 0 L 10 5 L 0 10 z" fill="currentColor" />
</marker>
`;
const symbols = w `
  <defs>
  <pattern id="halfgrid" patternUnits="userSpaceOnUse" width="1" height="1" viewBox="0 0 1 1">
  <circle cx="0.1" cy="0.25" r="0.035" style="fill: var(--oscd-sld-grid-color)" opacity="0.3" />
  <circle cx="0.6" cy="0.25" r="0.035" style="fill: var(--oscd-sld-grid-color)" opacity="0.3" />
  <circle cx="0.1" cy="0.75" r="0.035" style="fill: var(--oscd-sld-grid-color)" opacity="0.3" />
  <circle cx="0.6" cy="0.75" r="0.035" style="fill: var(--oscd-sld-grid-color)" opacity="0.3" />
  </pattern>
  <pattern id="grid" patternUnits="userSpaceOnUse" width="1" height="1" viewBox="0 0 1 1">
  <line x1="0" y1="0" x2="0" y2="1" style="stroke: var(--oscd-sld-grid-color)" stroke-opacity="0.3" stroke-width="0.06" />
  <line x1="0" y1="0" x2="1" y2="0" style="stroke: var(--oscd-sld-grid-color)" stroke-opacity="0.3" stroke-width="0.06" />
  <line x1="1" y1="0" x2="1" y2="1" style="stroke: var(--oscd-sld-grid-color)" stroke-opacity="0.3" stroke-width="0.06" />
  <line x1="0" y1="1" x2="1" y2="1" style="stroke: var(--oscd-sld-grid-color)" stroke-opacity="0.3" stroke-width="0.06" />
  </pattern>
  ${eqTypes.map(eqType => equipmentSymbol(eqType))}
  ${equipmentSymbol('ConductingEquipment')}
  ${iedSymbol}
  ${groundedMarker}
  ${arrowMarker}
  </defs>
`;

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const e=e$2(class extends i$3{constructor(t$1){if(super(t$1),t$1.type!==t.ATTRIBUTE||"class"!==t$1.name||t$1.strings?.length>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return " "+Object.keys(t).filter(s=>t[s]).join(" ")+" "}update(s,[i]){if(void 0===this.st){this.st=new Set,void 0!==s.strings&&(this.nt=new Set(s.strings.join(" ").split(/\s/).filter(t=>""!==t)));for(const t in i)i[t]&&!this.nt?.has(t)&&this.st.add(t);return this.render(i)}const r=s.element.classList;for(const t of this.st)t in i||(r.remove(t),this.st.delete(t));for(const t in i){const s=!!i[t];s===this.st.has(t)||this.nt?.has(t)||(s?(r.add(t),this.st.add(t)):(r.remove(t),this.st.delete(t)));}return E}});

/** Utility function to create element with `tagName` and its`attributes` */
/** @returns the cartesian product of `arrays` */
function crossProduct(...arrays) {
    return arrays.reduce((a, b) => a.flatMap((d) => b.map((e) => [d, e].flat())), [[]]);
}

const tAbstractConductingEquipment = [
    "TransformerWinding",
    "ConductingEquipment",
];
const tEquipment = [
    "GeneralEquipment",
    "PowerTransformer",
    ...tAbstractConductingEquipment,
];
const tEquipmentContainer = ["Substation", "VoltageLevel", "Bay"];
const tGeneralEquipmentContainer = ["Process", "Line"];
const tAbstractEqFuncSubFunc = ["EqSubFunction", "EqFunction"];
const tPowerSystemResource = [
    "SubFunction",
    "Function",
    "TapChanger",
    "SubEquipment",
    ...tEquipment,
    ...tEquipmentContainer,
    ...tGeneralEquipmentContainer,
    ...tAbstractEqFuncSubFunc,
];
const tLNodeContainer = ["ConnectivityNode", ...tPowerSystemResource];
const tCertificate = ["GOOSESecurity", "SMVSecurity"];
const tNaming = ["SubNetwork", ...tCertificate, ...tLNodeContainer];
const tAbstractDataAttribute = ["BDA", "DA"];
const tControlWithIEDName = ["SampledValueControl", "GSEControl"];
const tControlWithTriggerOpt = ["LogControl", "ReportControl"];
const tControl = [...tControlWithIEDName, ...tControlWithTriggerOpt];
const tControlBlock = ["GSE", "SMV"];
const tUnNaming = [
    "ConnectedAP",
    "PhysConn",
    "SDO",
    "DO",
    "DAI",
    "SDI",
    "DOI",
    "Inputs",
    "RptEnabled",
    "Server",
    "ServerAt",
    "SettingControl",
    "Communication",
    "Log",
    "LDevice",
    "DataSet",
    "AccessPoint",
    "IED",
    "NeutralPoint",
    ...tControl,
    ...tControlBlock,
    ...tAbstractDataAttribute,
];
const tAnyLN = ["LN0", "LN"];
const tAnyContentFromOtherNamespace = [
    "Text",
    "Private",
    "Hitem",
    "AccessControl",
];
const tCert = ["Subject", "IssuerName"];
const tDurationInMilliSec = ["MinTime", "MaxTime"];
const tIDNaming = ["LNodeType", "DOType", "DAType", "EnumType"];
const tServiceYesNo = [
    "FileHandling",
    "TimeSyncProt",
    "CommProt",
    "SGEdit",
    "ConfSG",
    "GetDirectory",
    "GetDataObjectDefinition",
    "DataObjectDirectory",
    "GetDataSetValue",
    "SetDataSetValue",
    "DataSetDirectory",
    "ReadWrite",
    "TimerActivatedControl",
    "GetCBValues",
    "GSEDir",
    "ConfLdName",
];
const tServiceWithMaxAndMaxAttributes = ["DynDataSet", "ConfDataSet"];
const tServiceWithMax = [
    "GSSE",
    "GOOSE",
    "ConfReportControl",
    "SMVsc",
    ...tServiceWithMaxAndMaxAttributes,
];
const tServiceWithMaxNonZero = ["ConfLogControl", "ConfSigRef"];
const tServiceSettings = [
    "ReportSettings",
    "LogSettings",
    "GSESettings",
    "SMVSettings",
];
const tBaseElement = ["SCL", ...tNaming, ...tUnNaming, ...tIDNaming];
const sCLTags = [
    ...tBaseElement,
    ...tAnyContentFromOtherNamespace,
    "Header",
    "LNode",
    "Val",
    "Voltage",
    "Services",
    ...tCert,
    ...tDurationInMilliSec,
    "Association",
    "FCDA",
    "ClientLN",
    "IEDName",
    "ExtRef",
    "Protocol",
    ...tAnyLN,
    ...tServiceYesNo,
    "DynAssociation",
    "SettingGroups",
    ...tServiceWithMax,
    ...tServiceWithMaxNonZero,
    ...tServiceSettings,
    "ConfLNs",
    "ClientServices",
    "SupSubscription",
    "ValueHandling",
    "RedProt",
    "McSecurity",
    "KDC",
    "Address",
    "P",
    "ProtNs",
    "EnumVal",
    "Terminal",
    "BitRate",
    "Authentication",
    "DataTypeTemplates",
    "History",
    "OptFields",
    "SmvOpts",
    "TrgOps",
    "SamplesPerSec",
    "SmpRate",
    "SecPerSamples",
];
const tagSet = new Set(sCLTags);
function isSCLTag(tag) {
    return tagSet.has(tag);
}

/** @returns object reference acc. IEC 61850-7-3 for control block elements */
function controlBlockObjRef(ctrlBlock) {
    const iedName = ctrlBlock.closest("IED")?.getAttribute("name");
    const ldInst = ctrlBlock.closest("LDevice")?.getAttribute("inst");
    const parentLn = ctrlBlock.closest("LN,LN0");
    const prefix = parentLn?.getAttribute("prefix") ?? "";
    const lnClass = parentLn?.getAttribute("lnClass");
    const lnInst = parentLn?.getAttribute("inst") ?? "";
    const cbName = ctrlBlock.getAttribute("name");
    if (!iedName || !ldInst || !lnClass || !cbName)
        return null;
    return `${iedName}${ldInst}/${prefix}${lnClass}${lnInst}.${cbName}`;
}

function isInputLeaf(input, allInputs) {
    let sameInputs = 0;
    for (const value of allInputs)
        if (value === input)
            sameInputs++;
    return input.querySelectorAll("ExtRef").length === sameInputs;
}
/**
 * Makes sure to not leave empty `Inputs` element after removing
 * its child `ExtRef` elements using [[`extRefedits`]]
 * @returns edits to remove `Inputs` when empty
 * */
function removeInputs(extRefs) {
    const removeInputs = [];
    const parentInputs = extRefs
        .map((remove) => remove.node.parentElement)
        .filter((input) => input);
    parentInputs.forEach((input, _index, inputs) => {
        const inputNotRemovedYet = !removeInputs.some((removeInput) => removeInput.node === input);
        if (isInputLeaf(input, inputs) && inputNotRemovedYet)
            removeInputs.push({ node: input });
    });
    return extRefs.concat(removeInputs);
}

/**
 * Locates control block from an ExtRef element.
 * NOTE: Only supports > Edition 2 using the srcXXX attributes.
 * @param extRef - SCL ExtRef element.
 * @returns Either ReportControl/GSEControl/SampledValueControl or null
 * if not found.
 */
function sourceControlBlock(extRef) {
    const [iedName, srcPrefix, srcLNInst, srcCBName] = [
        "iedName",
        "srcPrefix",
        "srcLNInst",
        "srcCBName",
    ].map((attr) => extRef.getAttribute(attr));
    const doc = extRef.ownerDocument;
    const srcLDInst = extRef.getAttribute("srcLDInst") ?? extRef.getAttribute("ldInst");
    const srcLNClass = extRef.getAttribute("srcLNClass") ?? "LLN0";
    const serviceType = extRef.getAttribute("serviceType") ?? extRef.getAttribute("pServT");
    if (!iedName || !srcLDInst || !srcCBName || serviceType === "Poll")
        return null;
    const lDevice = `:root > IED[name="${iedName}"] > AccessPoint > Server > LDevice[inst="${srcLDInst}"]`;
    const maybeReport = !serviceType || serviceType === "Report";
    const maybeGSE = !serviceType || serviceType === "GOOSE";
    const maybeSMV = !serviceType || serviceType === "SMV";
    const anyLN = srcLNClass === "LLN0" ? "LN0" : "LN";
    const lnClass = `[lnClass="${srcLNClass}"]`;
    let lnPrefixQualifiers;
    if (anyLN === "LN") {
        lnPrefixQualifiers =
            srcPrefix && srcPrefix !== ""
                ? [`[prefix="${srcPrefix}"]`]
                : [":not([prefix])", '[prefix=""]'];
    }
    else {
        lnPrefixQualifiers = [":not([prefix])"];
    }
    // On LN0 srcLNInst missing on the ExtRef means an inst=""
    // On LN inst must be a non-empty string and so srcLNInst
    // must also be a non-empty string and be present
    const lnInst = anyLN !== "LN0" && srcLNInst ? `[inst="${srcLNInst}"]` : '[inst=""]';
    const cbName = `[name="${srcCBName}"]`;
    const cbTypes = [
        maybeReport ? `ReportControl${cbName}` : null,
        maybeGSE ? `GSEControl${cbName}` : null,
        maybeSMV ? `SampledValueControl${cbName}` : null,
    ].filter((s) => !!s);
    return doc.querySelector(crossProduct([`${lDevice}>${anyLN}${lnClass}${lnInst}`], lnPrefixQualifiers, [">"], cbTypes)
        .map((strings) => strings.join(""))
        .join(","));
}

/** maximum value for `lnInst` attribute */
const maxLnInst = 99;
Array(maxLnInst)
    .fill(1)
    .map((_, i) => `${i + 1}`);

/** @returns Whether child `DA` with name `setSrcRef` can edited by SCL editor */
function isSrcRefEditable(supervisionLn) {
    const lnClass = supervisionLn.getAttribute("lnClass");
    const cbRefType = lnClass === "LGOS" ? "GoCBRef" : "SvCBRef";
    if (supervisionLn.querySelector(`:scope > DOI[name="${cbRefType}"] > 
        DAI[name="setSrcRef"][valImport="true"][valKind="RO"],
       :scope > DOI[name="${cbRefType}"] > 
        DAI[name="setSrcRef"][valImport="true"][valKind="Conf"]`))
        return true;
    const rootNode = supervisionLn.ownerDocument;
    const lnType = supervisionLn.getAttribute("lnType");
    const goOrSvCBRef = rootNode.querySelector(`DataTypeTemplates > 
        LNodeType[id="${lnType}"][lnClass="${lnClass}"] > DO[name="${cbRefType}"]`);
    const cbRefId = goOrSvCBRef?.getAttribute("type");
    const setSrcRef = rootNode.querySelector(`DataTypeTemplates > DOType[id="${cbRefId}"] > DA[name="setSrcRef"]`);
    return ((setSrcRef?.getAttribute("valKind") === "Conf" ||
        setSrcRef?.getAttribute("valKind") === "RO") &&
        setSrcRef.getAttribute("valImport") === "true");
}

/** @returns Element to remove the subscription supervision */
function removableSupervisionElement(ctrlBlock, subscriberIed) {
    const supervisionType = ctrlBlock.tagName === "GSEControl" ? "LGOS" : "LSVS";
    const doiName = ctrlBlock.tagName === "GSEControl" ? "GoCBRef" : "SvCBRef";
    const valElement = Array.from(subscriberIed.querySelectorAll(`LN[lnClass="${supervisionType}"] > DOI[name="${doiName}"] > DAI[name="setSrcRef"] > Val`)).find((val) => val.textContent === controlBlockObjRef(ctrlBlock));
    if (!valElement)
        return null;
    const ln = valElement.closest("LN");
    // do not remove logical nodes `LGOS`, `LSVS` unless privately tagged
    const canRemoveLn = ln.querySelector(':scope > Private[type="OpenSCD.create"]');
    if (canRemoveLn)
        return ln;
    return (Array.from(valElement.childNodes).find((child) => child.nodeType === Node.TEXT_NODE) ?? null);
}
/** @returns Whether `DA` with name `setSrcRef` can edited by SCL editor */
function isSupervisionEditable(ctrlBlock, subscriberIed) {
    const supervisionElement = removableSupervisionElement(ctrlBlock, subscriberIed);
    if (!supervisionElement)
        return false;
    let supervisionLn = null;
    if (supervisionElement.nodeType === Node.TEXT_NODE) {
        supervisionLn = supervisionElement.parentElement?.closest("LN") ?? null;
    }
    else {
        supervisionLn = supervisionElement.closest("LN") ?? null;
    }
    if (!supervisionLn)
        return false;
    return isSrcRefEditable(supervisionLn);
}
/** @returns Whether other subscribed ExtRef of the same control block exist */
function isControlBlockSubscribed(extRefs) {
    const [srcCBName, srcLDInst, srcLNClass, iedName, srcPrefix, srcLNInst, serviceType,] = [
        "srcCBName",
        "srcLDInst",
        "srcLNClass",
        "iedName",
        "srcPrefix",
        "srcLNInst",
        "serviceType",
    ].map((attr) => extRefs[0].getAttribute(attr));
    const parentIed = extRefs[0].closest("IED");
    return Array.from(parentIed.getElementsByTagName("ExtRef")).some((otherExtRef) => !extRefs.includes(otherExtRef) &&
        (otherExtRef.getAttribute("srcPrefix") ?? "") === (srcPrefix ?? "") &&
        (otherExtRef.getAttribute("srcLNInst") ?? "") === (srcLNInst ?? "") &&
        otherExtRef.getAttribute("srcCBName") === srcCBName &&
        otherExtRef.getAttribute("srcLDInst") === srcLDInst &&
        otherExtRef.getAttribute("srcLNClass") === srcLNClass &&
        otherExtRef.getAttribute("iedName") === iedName &&
        otherExtRef.getAttribute("serviceType") === serviceType);
}
function cannotRemoveSupervision(extRefGroup) {
    return (isControlBlockSubscribed(extRefGroup.extRefs) ||
        !isSupervisionEditable(extRefGroup.ctrlBlock, extRefGroup.subscriberIed));
}
function groupPerControlBlock(extRefs) {
    const groupedExtRefs = {};
    extRefs.forEach((extRef) => {
        const ctrlBlock = sourceControlBlock(extRef);
        if (ctrlBlock) {
            const ctrlBlockRef = controlBlockObjRef(ctrlBlock);
            if (groupedExtRefs[ctrlBlockRef])
                groupedExtRefs[ctrlBlockRef].extRefs.push(extRef);
            else
                groupedExtRefs[ctrlBlockRef] = {
                    extRefs: [extRef],
                    ctrlBlock,
                    subscriberIed: extRef.closest("IED"),
                };
        }
    });
    return groupedExtRefs;
}
/** Removes subscription supervision - `LGOS` or `LSVS` - when no other data
 * of a given `GSEControl` or `SampledValueControl`
 * @param extRefs - An array of external reference elements
 * @returns edits to remove subscription supervision `LGOS` or `LSVS`
 */
function removeSubscriptionSupervision(extRefs) {
    if (extRefs.length === 0)
        return [];
    const groupedExtRefs = groupPerControlBlock(extRefs);
    return Object.values(groupedExtRefs)
        .map((extRefGroup) => {
        if (cannotRemoveSupervision(extRefGroup))
            return null;
        return removableSupervisionElement(extRefGroup.ctrlBlock, extRefGroup.subscriberIed);
    })
        .filter((element) => element).map((node) => ({ node }));
}

/**
 * Remove link between sending IED data to receiving IED external
 * references - unsubscribing.
 * ```md
 * 1. Unsubscribes external references itself:
 * -Update `ExtRef` in case later binding is used (existing `intAddr` attribute)
 * -Remove `ExtRef` in case `intAddr` is missing
 *
 * 2. Removes leaf `Input` elements as well
 * 3. Removes subscription supervision (can be disabled through options.ignoreSupervision)
 * - when all external references of one control block are unsubscribed
 * - when `valKind` RO|Conf and `valImport` true
 * ```
 * In case the external reference
 * @param extRefs - Array of external references
 * @returns An array of update and/or remove edit representing changes required
 * to unsubscribe.
 */
function unsubscribe(extRefs, options = { ignoreSupervision: false }) {
    const SetAttributesEdits = [];
    const removeEdits = [];
    extRefs.map((extRef) => {
        if (extRef.getAttribute("intAddr"))
            SetAttributesEdits.push({
                element: extRef,
                attributes: {
                    iedName: null,
                    ldInst: null,
                    prefix: null,
                    lnClass: null,
                    lnInst: null,
                    doName: null,
                    daName: null,
                    srcLDInst: null,
                    srcPrefix: null,
                    srcLNClass: null,
                    srcLNInst: null,
                    srcCBName: null,
                    ...(extRef.getAttribute("pServT") && { serviceType: null }),
                },
            });
        else
            removeEdits.push({ node: extRef });
    });
    return [
        ...removeInputs(removeEdits),
        ...SetAttributesEdits,
        ...(options.ignoreSupervision
            ? []
            : removeSubscriptionSupervision(extRefs)),
    ];
}

/** @returns Whether a ExtRef to FCDA reference match */
function matchDataAttributes(extRef, fcda) {
    return (extRef.getAttribute("ldInst") === fcda.getAttribute("ldInst") &&
        (extRef.getAttribute("prefix") ?? "") ===
            (fcda.getAttribute("prefix") ?? "") &&
        extRef.getAttribute("lnClass") === fcda.getAttribute("lnClass") &&
        (extRef.getAttribute("lnInst") ?? "") ===
            (fcda.getAttribute("lnInst") ?? "") &&
        extRef.getAttribute("doName") === fcda.getAttribute("doName") &&
        (extRef.getAttribute("daName") ?? "") ===
            (fcda.getAttribute("daName") ?? ""));
}

const maxGseMacAddress = 0x010ccd0101ff;
const minGseMacAddress = 0x010ccd010000;
const maxSmvMacAddress = 0x010ccd0401ff;
const minSmvMacAddress = 0x010ccd040000;
function convertToMac(mac) {
    const str = 0 + mac.toString(16).toUpperCase();
    const arr = str.match(/.{1,2}/g);
    return arr.join("-");
}
Array(maxGseMacAddress - minGseMacAddress)
    .fill(1)
    .map((_, i) => convertToMac(minGseMacAddress + i));
Array(maxSmvMacAddress - minSmvMacAddress)
    .fill(1)
    .map((_, i) => convertToMac(minSmvMacAddress + i));

const maxGseAppId = 0x3fff;
const minGseAppId = 0x0000;
// APPID range for Type1A(Trip) GOOSE acc. IEC 61850-8-1
const maxGseTripAppId = 0xbfff;
const minGseTripAppId = 0x8000;
const maxSmvAppId = 0x7fff;
const minSmvAppId = 0x4000;
Array(maxGseAppId - minGseAppId)
    .fill(1)
    .map((_, i) => (minGseAppId + i).toString(16).toUpperCase().padStart(4, "0"));
Array(maxGseTripAppId - minGseTripAppId)
    .fill(1)
    .map((_, i) => (minGseTripAppId + i).toString(16).toUpperCase().padStart(4, "0"));
Array(maxSmvAppId - minSmvAppId)
    .fill(1)
    .map((_, i) => (minSmvAppId + i).toString(16).toUpperCase().padStart(4, "0"));

await fetch(new URL(new URL('assets/nsd-BZ5JISRf.json', import.meta.url).href)).then((res) => res.json());

const nsd72 = `<?xml version="1.0" encoding="UTF-8"?>
<NS xmlns="http://www.iec.ch/61850/2016/NSD"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xsi:schemaLocation="http://www.iec.ch/61850/2016/NSD NSD.xsd"
    id="IEC 61850-7-2"
    version="2007"
    revision="B"
    release="5"
    umlVersion="WG10built12"
    umlDate="2024-01-15"
    publicationStage="IS"
    appVersion="j61850DocBuilder 02.03 based on jCleanCim noNS beta9.3 (derived from jCleanCim 02-02)"
    namespaceType="basic"
    nsdVersion="2017"
    nsdRevision="B"
    nsdRelease="5">
   <Copyright>
         <Notice>
			COPYRIGHT (c) IEC, www.iec.ch/tc57/supportdocuments. This version of this NSD is part of IEC_61850-7-2:2010 Edition 2.1; see the IEC_61850-7-2:2010 Edition 2.1 for full legal notices. In case of any differences between the here-below code and the IEC published content, the here-below definition supersedes the IEC publication; it may contain updates. See history files. The whole document has to be taken into account to have a full description of this code component.
			See www.iec.ch/CCv1 for copyright details.
			</Notice>
         <License uri="www.iec.ch/CCv1" kind="Standard"/>
      </Copyright>
   <Changes version="2007"
            revision="B"
            tissues="1781, 1782, 1801, 1841, 1847, 1822"/>
   <BasicTypes>
         <BasicType name="BOOLEAN" descID="IEC61850_7_2.BasicTypes::P_BOOLEAN.cl.desc"/>
         <BasicType name="INT8" descID="IEC61850_7_2.BasicTypes::P_INT8.cl.desc"/>
         <BasicType name="INT16" descID="IEC61850_7_2.BasicTypes::P_INT16.cl.desc"/>
         <BasicType name="INT32" descID="IEC61850_7_2.BasicTypes::P_INT32.cl.desc"/>
         <BasicType name="INT64" descID="IEC61850_7_2.BasicTypes::P_INT64.cl.desc"/>
         <BasicType name="INT8U" descID="IEC61850_7_2.BasicTypes::P_INT8U.cl.desc"/>
         <BasicType name="INT16U" descID="IEC61850_7_2.BasicTypes::P_INT16U.cl.desc"/>
         
         <BasicType name="INT32U" descID="IEC61850_7_2.BasicTypes::P_INT32U.cl.desc"/>
         <BasicType name="FLOAT32" descID="IEC61850_7_2.BasicTypes::P_FLOAT32.cl.desc"/>
         <BasicType name="Octet64" descID="IEC61850_7_2.BasicTypes::P_Octet64.cl.desc"/>
         <BasicType name="VisString64"
                 descID="IEC61850_7_2.BasicTypes::P_VisString64.cl.desc"/>
         <BasicType name="VisString129"
                 descID="IEC61850_7_2.BasicTypes::P_VisString129.cl.desc"/>
         <BasicType name="VisString255"
                 descID="IEC61850_7_2.BasicTypes::P_VisString255.cl.desc"/>
         <BasicType name="Unicode255"
                 descID="IEC61850_7_2.BasicTypes::P_Unicode255.cl.desc"/>
         <BasicType name="PhyComAddr"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_PhyComAddr.cl.desc"/>
         
         <BasicType name="ObjRef"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_ObjectReference.cl.desc"/>
         <BasicType name="EntryID"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_EntryID.cl.desc"/>
         <BasicType name="Currency"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_Currency.cl.desc"/>
         <BasicType name="Timestamp"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_Timestamp.cl.desc"/>
         
         <BasicType name="Quality"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_Quality.cl.desc"/>
         
         <BasicType name="EntryTime"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_EntryTime.cl.desc"/>
         <BasicType name="TrgOps"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_TriggerConditions.cl.desc"/>
         <BasicType name="OptFlds"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_RCBReportOptions.cl.desc"/>
         
         <BasicType name="SvOptFlds"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_SVMessageOptions.cl.desc"/>
         <BasicType name="Check"
                 descID="IEC61850_7_2.DomainTypesGeneral::P_CheckConditions.cl.desc"/>
         <BasicType name="Tcmd"
                 descID="IEC61850_7_2.DomainTypesCodedEnums::StepControlKind.cl.desc"/>
         <BasicType name="Dbpos"
                 descID="IEC61850_7_2.DomainTypesCodedEnums::DpStatusKind.cl.desc"/>
         
         
      </BasicTypes>
   <FunctionalConstraints>
         <FunctionalConstraint abbreviation="ST"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.ST.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="GoCB"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
               <DataSetMemberOf cb="SVCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="MX"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.MX.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="GoCB"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
               <DataSetMemberOf cb="SVCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="SP"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.SP.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="SetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="GoCB"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="SV"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.SV.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="SetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <Service name="SetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="CF"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.CF.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="SetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <Service name="SetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="DC"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.DC.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="SetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <Service name="SetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="SG"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.SG.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="SE"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.SE.title">
            <ApplicableServices>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetEditSGValue"/>
               <Service name="SetEditSGValue"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="SR"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.SR.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="OR"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.OR.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="GoCB"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="BL"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.BL.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="SetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <Service name="SetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
         <FunctionalConstraint abbreviation="EX"
                            titleID="IEC61850_7_2.FunctionalConstraints::FcKind.EX.title">
            <ApplicableServices>
               <Service name="GetDataValues"/>
               <Service name="GetDataDefinition"/>
               <Service name="GetDataDirectory"/>
               <Service name="GetDataSetValues"/>
               <DataSetMemberOf cb="RCB"/>
               <DataSetMemberOf cb="LCB"/>
            </ApplicableServices>
         </FunctionalConstraint>
      </FunctionalConstraints>
   <PresenceConditions>
         <PresenceCondition name="M"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.M.desc"/>
         <PresenceCondition name="O"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.O.desc"/>
         <PresenceCondition name="F"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.F.desc"/>
         <PresenceCondition name="na"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.na.desc"/>
         <PresenceCondition name="Mmulti"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.Mmulti.desc"/>
         <PresenceCondition name="Omulti"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.Omulti.desc"/>
         <PresenceCondition name="AtLeastOne"
                         argument="n"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.AtLeastOne(n).desc"/>
         <PresenceCondition name="AtMostOne"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.AtMostOne.desc"/>
         <PresenceCondition name="AllOrNonePerGroup"
                         argument="n"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.AllOrNonePerGroup(n).desc"/>
         <PresenceCondition name="AllOnlyOneGroup"
                         argument="n"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.AllOnlyOneGroup(n).desc"/>
         <PresenceCondition name="AllAtLeastOneGroup"
                         argument="n"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.AllAtLeastOneGroup(n).desc"/>
         <PresenceCondition name="MF"
                         argument="sibling"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MF(sibling).desc"/>
         <PresenceCondition name="MO"
                         argument="sibling"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MO(sibling).desc"/>
         <PresenceCondition name="OM"
                         argument="sibling"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.OM(sibling).desc"/>
         <PresenceCondition name="FM"
                         argument="sibling"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.FM(sibling).desc"/>
         <PresenceCondition name="MOcond"
                         argument="condID"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOcond(condID).desc"/>
         <PresenceCondition name="MFcond"
                         argument="condID"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MFcond(condID).desc"/>
         <PresenceCondition name="OFcond"
                         argument="condID"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.OFcond(condID).desc"/>
         <PresenceCondition name="MmultiRange"
                         argument="min, max"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MmultiRange(min,_max).desc"/>
         <PresenceCondition name="OmultiRange"
                         argument="min, max"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.OmultiRange(min,_max).desc"/>
         <PresenceCondition name="MFsubst"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MFsubst.desc"/>
         <PresenceCondition name="MOln0"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOln0.desc"/>
         <PresenceCondition name="MFln0"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MFln0.desc"/>
         <PresenceCondition name="MOlnNs"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOlnNs.desc"/>
         <PresenceCondition name="MOdataNs"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOdataNs.desc"/>
         <PresenceCondition name="MFscaledAV"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MFscaledAV.desc"/>
         <PresenceCondition name="MFscaledMagV"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MFscaledMagV.desc"/>
         <PresenceCondition name="MFscaledAngV"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MFscaledAngV.desc"/>
         <PresenceCondition name="MOrms"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOrms.desc"/>
         <PresenceCondition name="MOrootLD"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOrootLD.desc"/>
         <PresenceCondition name="MOoperTm"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOoperTm.desc"/>
         <PresenceCondition name="MmultiF"
                         argument="sibling"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MmultiF(sibling).desc"/>
         <PresenceCondition name="MOsbo"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOsbo.desc"/>
         <PresenceCondition name="MOenhanced"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MOenhanced.desc"/>
         <PresenceCondition name="MONamPlt"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MONamPlt.desc"/>
         <PresenceCondition name="OF"
                         argument="sibling"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.OF(sibling).desc"/>
         <PresenceCondition name="MORange"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MORange.desc"/>
         <PresenceCondition name="OMSynPh"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.OMSynPh.desc"/>
         <PresenceCondition name="MAllOrNonePerGroup"
                         argument="n"
                         descID="IEC61850_7_2.PresenceConditions::PresenceCondition.MAllOrNonePerGroup(n).desc"/>
      </PresenceConditions>
   <Enumerations>
         <Enumeration name="ServiceNameKind"
                   titleID="IEC61850_7_2.DomainTypesEnums::ServiceNameKind.cl.title">
            <Literal name="Unknown" literalVal="0"/>
            <Literal name="Associate" literalVal="1"/>
            <Literal name="Abort" literalVal="2"/>
            <Literal name="Release" literalVal="3"/>
            <Literal name="GetServerDirectory" literalVal="4"/>
            <Literal name="GetLogicalDeviceDirectory" literalVal="5"/>
            <Literal name="GetAllDataValues" literalVal="6"/>
            <Literal name="GetDataValues" literalVal="7"/>
            <Literal name="SetDataValues" literalVal="8"/>
            <Literal name="GetDataDirectory" literalVal="9"/>
            <Literal name="GetDataDefinition" literalVal="10"/>
            <Literal name="GetDataSetValues" literalVal="11"/>
            <Literal name="SetDataSetValues" literalVal="12"/>
            <Literal name="CreateDataSet" literalVal="13"/>
            <Literal name="DeleteDataSet" literalVal="14"/>
            <Literal name="GetDataSetDirectory" literalVal="15"/>
            <Literal name="SelectActiveSG" literalVal="16"/>
            <Literal name="SelectEditSG" literalVal="17"/>
            <Literal name="SetEditSGValue" literalVal="18"/>
            <Literal name="ConfirmEditSGValues" literalVal="19"/>
            <Literal name="GetEditSGValue" literalVal="20"/>
            <Literal name="GetSGCBValues" literalVal="21"/>
            <Literal name="Report" literalVal="22"/>
            <Literal name="GetBRCBValues" literalVal="23"/>
            <Literal name="SetBRCBValues" literalVal="24"/>
            <Literal name="GetURCBValues" literalVal="25"/>
            <Literal name="SetURCBValues" literalVal="26"/>
            <Literal name="GetLCBValues" literalVal="27"/>
            <Literal name="SetLCBValues" literalVal="28"/>
            <Literal name="QueryLogByTime" literalVal="29"/>
            <Literal name="QueryLogAfter" literalVal="30"/>
            <Literal name="GetLogStatusValues" literalVal="31"/>
            <Literal name="SendGOOSEMessage" literalVal="32"/>
            <Literal name="GetGoCBValues" literalVal="33"/>
            <Literal name="SetGoCBValues" literalVal="34"/>
            <Literal name="GetGoReference" literalVal="35"/>
            <Literal name="GetGOOSEElementNumber" literalVal="36"/>
            <Literal name="SendMSVMessage" literalVal="37"/>
            <Literal name="GetMSVCBValues" literalVal="38"/>
            <Literal name="SetMSVCBValues" literalVal="39"/>
            <Literal name="SendUSVMessage" literalVal="40" deprecated="true"/>
            <Literal name="GetUSVCBValues" literalVal="41" deprecated="true"/>
            <Literal name="SetUSVCBValues" literalVal="42" deprecated="true"/>
            <Literal name="Select" literalVal="43"/>
            <Literal name="SelectWithValue" literalVal="44"/>
            <Literal name="Cancel" literalVal="45"/>
            <Literal name="Operate" literalVal="46"/>
            <Literal name="CommandTermination" literalVal="47"/>
            <Literal name="TimeActivatedOperate" literalVal="48"/>
            <Literal name="GetFile" literalVal="49"/>
            <Literal name="SetFile" literalVal="50"/>
            <Literal name="DeleteFile" literalVal="51"/>
            <Literal name="GetFileAttributeValues" literalVal="52"/>
            <Literal name="TimeSynchronization" literalVal="53"/>
            <Literal name="InternalChange" literalVal="54"/>
            <Literal name="GetLogicalNodeDirectory" literalVal="55"/>
            <Literal name="GetMsvReference" literalVal="56"/>
            <Literal name="GetMSVElementNumber" literalVal="57"/>
         </Enumeration>
         <Enumeration name="ServiceStatusKind"
                   titleID="IEC61850_7_2.DomainTypesEnums::ServiceStatusKind.cl.title">
            <Literal name="no-error" literalVal="0"/>
            <Literal name="instance-not-available" literalVal="1"/>
            <Literal name="instance-in-use" literalVal="2"/>
            <Literal name="access-violation" literalVal="3"/>
            <Literal name="access-not-allowed-in-current-state" literalVal="4"/>
            <Literal name="parameter-value-inappropriate" literalVal="5"/>
            <Literal name="parameter-value-inconsistent" literalVal="6"/>
            <Literal name="class-not-supported" literalVal="7"/>
            <Literal name="instance-locked-by-other-client" literalVal="8"/>
            <Literal name="control-must-be-selected" literalVal="9" deprecated="true"/>
            <Literal name="type-conflict" literalVal="10"/>
            <Literal name="failed-due-to-communications-constraint" literalVal="11"/>
            <Literal name="failed-due-to-server-constraint" literalVal="12"/>
         </Enumeration>
         <Enumeration name="OriginatorCategoryKind"
                   titleID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.cl.title">
            <Literal name="not-supported"
                  literalVal="0"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.not-supported.desc"/>
            <Literal name="bay-control"
                  literalVal="1"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.bay-control.desc"/>
            <Literal name="station-control"
                  literalVal="2"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.station-control.desc"/>
            <Literal name="remote-control"
                  literalVal="3"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.remote-control.desc"/>
            <Literal name="automatic-bay"
                  literalVal="4"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.automatic-bay.desc"/>
            <Literal name="automatic-station"
                  literalVal="5"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.automatic-station.desc"/>
            <Literal name="automatic-remote"
                  literalVal="6"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.automatic-remote.desc"/>
            <Literal name="maintenance"
                  literalVal="7"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.maintenance.desc"/>
            <Literal name="process"
                  literalVal="8"
                  descID="IEC61850_7_2.DomainTypesEnums::OriginatorCategoryKind.process.desc"/>
         </Enumeration>
         <Enumeration name="ControlServiceStatusKind"
                   titleID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.cl.title">
            <Literal name="Unknown"
                  literalVal="0"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Unknown.desc"/>
            <Literal name="Not-supported"
                  literalVal="1"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Not-supported.desc"/>
            <Literal name="Blocked-by-switching-hierarchy"
                  literalVal="2"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-switching-hierarchy.desc"/>
            <Literal name="Select-failed"
                  literalVal="3"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Select-failed.desc"/>
            <Literal name="Invalid-position"
                  literalVal="4"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Invalid-position.desc"/>
            <Literal name="Position-reached"
                  literalVal="5"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Position-reached.desc"/>
            <Literal name="Parameter-change-in-execution"
                  literalVal="6"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Parameter-change-in-execution.desc"/>
            <Literal name="Step-limit"
                  literalVal="7"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Step-limit.desc"/>
            <Literal name="Blocked-by-Mode"
                  literalVal="8"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-Mode.desc"/>
            <Literal name="Blocked-by-process"
                  literalVal="9"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-process.desc"/>
            <Literal name="Blocked-by-interlocking"
                  literalVal="10"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-interlocking.desc"/>
            <Literal name="Blocked-by-synchrocheck"
                  literalVal="11"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-synchrocheck.desc"/>
            <Literal name="Command-already-in-execution"
                  literalVal="12"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Command-already-in-execution.desc"/>
            <Literal name="Blocked-by-health"
                  literalVal="13"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-health.desc"/>
            <Literal name="1-of-n-control"
                  literalVal="14"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.1-of-n-control.desc"/>
            <Literal name="Abortion-by-cancel"
                  literalVal="15"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Abortion-by-cancel.desc"/>
            <Literal name="Time-limit-over"
                  literalVal="16"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Time-limit-over.desc"/>
            <Literal name="Abortion-by-trip"
                  literalVal="17"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Abortion-by-trip.desc"/>
            <Literal name="Object-not-selected"
                  literalVal="18"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Object-not-selected.desc"/>
            <Literal name="Object-already-selected"
                  literalVal="19"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Object-already-selected.desc"/>
            <Literal name="No-access-authority"
                  literalVal="20"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.No-access-authority.desc"/>
            <Literal name="Ended-with-overshoot"
                  literalVal="21"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Ended-with-overshoot.desc"/>
            <Literal name="Abortion-due-to-deviation"
                  literalVal="22"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Abortion-due-to-deviation.desc"/>
            <Literal name="Abortion-by-communication-loss"
                  literalVal="23"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Abortion-by-communication-loss.desc"/>
            <Literal name="Blocked-by-command"
                  literalVal="24"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Blocked-by-command.desc"/>
            <Literal name="None"
                  literalVal="25"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.None.desc"/>
            <Literal name="Inconsistent-parameters"
                  literalVal="26"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Inconsistent-parameters.desc"/>
            <Literal name="Locked-by-other-client"
                  literalVal="27"
                  descID="IEC61850_7_2.DomainTypesEnums::ControlServiceStatusKind.Locked-by-other-client.desc"/>
         </Enumeration>
         <Enumeration name="SamplingModeKind"
                   titleID="IEC61850_7_2.DomainTypesEnums::SamplingModeKind.cl.title">
            <Literal name="SamplesPerPeriod" literalVal="0"/>
            <Literal name="SamplesPerSecond" literalVal="1"/>
            <Literal name="SecondsPerSample" literalVal="2"/>
         </Enumeration>
      </Enumerations>
   <ConstructedAttributes>
         <ConstructedAttribute name="Originator"
                            titleID="IEC61850_7_2.DomainTypesGeneral::S_Originator.cl.title">
            <SubDataAttribute name="orCat"
                           type="OriginatorCategoryKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_2.DomainTypesGeneral::S_Originator.orCat.desc"
                           presCond="M"/>
            <SubDataAttribute name="orIdent"
                           type="Octet64"
                           descID="IEC61850_7_2.DomainTypesGeneral::S_Originator.orIdent.desc"
                           presCond="M"/>
         </ConstructedAttribute>
      </ConstructedAttributes>
</NS>
`;
const nsd73 = `<?xml version="1.0" encoding="UTF-8"?>
<NS xmlns="http://www.iec.ch/61850/2016/NSD"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xsi:schemaLocation="http://www.iec.ch/61850/2016/NSD NSD.xsd"
    id="IEC 61850-7-3"
    version="2007"
    revision="B"
    release="5"
    umlVersion="WG10built12"
    umlDate="2024-02-12"
    publicationStage="IS"
    appVersion="j61850DocBuilder 02.03 based on jCleanCim noNS beta9.3 (derived from jCleanCim 02-02)"
    namespaceType="basic"
    nsdVersion="2017"
    nsdRevision="B"
    nsdRelease="5">
   <Copyright>
         <Notice>
			COPYRIGHT (c) IEC, www.iec.ch/tc57/supportdocuments. This version of this NSD is part of IEC_61850-7-3:2010 Edition 2.1; see the IEC_61850-7-3:2010 Edition 2.1 for full legal notices. In case of any differences between the here-below code and the IEC published content, the here-below definition supersedes the IEC publication; it may contain updates. See history files. The whole document has to be taken into account to have a full description of this code component.
			See www.iec.ch/CCv1 for copyright details.
			</Notice>
         <License uri="www.iec.ch/CCv1" kind="Standard"/>
      </Copyright>
   <Changes version="2007"
            revision="B"
            tissues="1716, 1730, 1783, 1785, 1807, 1829, 1840, 1851, 1852, 1889, 1900"/>
   <DependsOn id="IEC 61850-7-2"
              version="2007"
              revision="B"
              dependencyType="dependsOn"/>
   <Enumerations>
         <Enumeration name="AngleReferenceKind"
                   titleID="IEC61850_7_3.DAEnums::AngleReferenceKind.cl.title">
            <Literal name="V" literalVal="0"/>
            <Literal name="A" literalVal="1"/>
            <Literal name="other" literalVal="2"/>
            <Literal name="Synchrophasor"
                  literalVal="3"
                  descID="IEC61850_7_3.DAEnums::AngleReferenceKind.Synchrophasor.desc"/>
         </Enumeration>
         <Enumeration name="CtlModelKind"
                   titleID="IEC61850_7_3.DAEnums::CtlModelKind.cl.title">
            <Literal name="status-only"
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::CtlModelKind.status-only.desc"/>
            <Literal name="direct-with-normal-security"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::CtlModelKind.direct-with-normal-security.desc"/>
            <Literal name="sbo-with-normal-security"
                  literalVal="2"
                  descID="IEC61850_7_3.DAEnums::CtlModelKind.sbo-with-normal-security.desc"/>
            <Literal name="direct-with-enhanced-security"
                  literalVal="3"
                  descID="IEC61850_7_3.DAEnums::CtlModelKind.direct-with-enhanced-security.desc"/>
            <Literal name="sbo-with-enhanced-security"
                  literalVal="4"
                  descID="IEC61850_7_3.DAEnums::CtlModelKind.sbo-with-enhanced-security.desc"/>
         </Enumeration>
         <Enumeration name="CurveCharKind"
                   titleID="IEC61850_7_3.DAEnums::CurveCharKind.cl.title">
            <Literal name="None"
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.None.desc"/>
            <Literal name="ANSI Extremely Inverse"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.ANSI_Extremely_Inverse.desc"/>
            <Literal name="ANSI Very Inverse"
                  literalVal="2"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.ANSI_Very_Inverse.desc"/>
            <Literal name="ANSI Normal Inverse" literalVal="3" deprecated="true"/>
            <Literal name="ANSI Moderate Inverse"
                  literalVal="4"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.ANSI_Moderate_Inverse.desc"/>
            <Literal name="ANSI Definite Time"
                  literalVal="5"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.ANSI_Definite_Time.desc"/>
            <Literal name="Long-Time Extremely Inverse" literalVal="6" deprecated="true"/>
            <Literal name="Long-Time Very Inverse" literalVal="7" deprecated="true"/>
            <Literal name="Long-Time Inverse" literalVal="8" deprecated="true"/>
            <Literal name="IEC Normal Inverse" literalVal="9" deprecated="true"/>
            <Literal name="IEC Very Inverse"
                  literalVal="10"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.IEC_Very_Inverse.desc"/>
            <Literal name="IEC Inverse"
                  literalVal="11"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.IEC_Inverse.desc"/>
            <Literal name="IEC Extremely Inverse"
                  literalVal="12"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.IEC_Extremely_Inverse.desc"/>
            <Literal name="IEC Short-Time Inverse" literalVal="13" deprecated="true"/>
            <Literal name="IEC Long-Time Inverse" literalVal="14" deprecated="true"/>
            <Literal name="IEC Definite Time"
                  literalVal="15"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.IEC_Definite_Time.desc"/>
            <Literal name="Reserved" literalVal="16"/>
            <Literal name="Polynom 1"
                  literalVal="17"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_1.desc"/>
            <Literal name="Polynom 2"
                  literalVal="18"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_2.desc"/>
            <Literal name="Polynom 3"
                  literalVal="19"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_3.desc"/>
            <Literal name="Polynom 4"
                  literalVal="20"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_4.desc"/>
            <Literal name="Polynom 5"
                  literalVal="21"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_5.desc"/>
            <Literal name="Polynom 6"
                  literalVal="22"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_6.desc"/>
            <Literal name="Polynom 7"
                  literalVal="23"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_7.desc"/>
            <Literal name="Polynom 8"
                  literalVal="24"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_8.desc"/>
            <Literal name="Polynom 9"
                  literalVal="25"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_9.desc"/>
            <Literal name="Polynom 10"
                  literalVal="26"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_10.desc"/>
            <Literal name="Polynom 11"
                  literalVal="27"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_11.desc"/>
            <Literal name="Polynom 12"
                  literalVal="28"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_12.desc"/>
            <Literal name="Polynom 13"
                  literalVal="29"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_13.desc"/>
            <Literal name="Polynom 14"
                  literalVal="30"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_14.desc"/>
            <Literal name="Polynom 15"
                  literalVal="31"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_15.desc"/>
            <Literal name="Polynom 16"
                  literalVal="32"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Polynom_16.desc"/>
            <Literal name="Multiline 1"
                  literalVal="33"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_1.desc"/>
            <Literal name="Multiline 2"
                  literalVal="34"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_2.desc"/>
            <Literal name="Multiline 3"
                  literalVal="35"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_3.desc"/>
            <Literal name="Multiline 4"
                  literalVal="36"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_4.desc"/>
            <Literal name="Multiline 5"
                  literalVal="37"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_5.desc"/>
            <Literal name="Multiline 6"
                  literalVal="38"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_6.desc"/>
            <Literal name="Multiline 7"
                  literalVal="39"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_7.desc"/>
            <Literal name="Multiline 8"
                  literalVal="40"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_8.desc"/>
            <Literal name="Multiline 9"
                  literalVal="41"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_9.desc"/>
            <Literal name="Multiline 10"
                  literalVal="42"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_10.desc"/>
            <Literal name="Multiline 11"
                  literalVal="43"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_11.desc"/>
            <Literal name="Multiline 12"
                  literalVal="44"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_12.desc"/>
            <Literal name="Multiline 13"
                  literalVal="45"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_13.desc"/>
            <Literal name="Multiline 14"
                  literalVal="46"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_14.desc"/>
            <Literal name="Multiline 15"
                  literalVal="47"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_15.desc"/>
            <Literal name="Multiline 16"
                  literalVal="48"
                  descID="IEC61850_7_3.DAEnums::CurveCharKind.Multiline_16.desc"/>
         </Enumeration>
         <Enumeration name="FaultDirectionKind"
                   titleID="IEC61850_7_3.DAEnums::FaultDirectionKind.cl.title">
            <Literal name="unknown" literalVal="0"/>
            <Literal name="forward" literalVal="1"/>
            <Literal name="backward" literalVal="2"/>
            <Literal name="both" literalVal="3"/>
         </Enumeration>
         <Enumeration name="HvReferenceKind"
                   titleID="IEC61850_7_3.DAEnums::HvReferenceKind.cl.title">
            <Literal name="fundamental" literalVal="0"/>
            <Literal name="rms" literalVal="1"/>
            <Literal name="absolute" literalVal="2"/>
         </Enumeration>
         <Enumeration name="MonthKind" titleID="IEC61850_7_3.DAEnums::MonthKind.cl.title">
            <Literal name="reserved" literalVal="0"/>
            <Literal name="January" literalVal="1"/>
            <Literal name="February" literalVal="2"/>
            <Literal name="March" literalVal="3"/>
            <Literal name="April" literalVal="4"/>
            <Literal name="May" literalVal="5"/>
            <Literal name="June" literalVal="6"/>
            <Literal name="July" literalVal="7"/>
            <Literal name="August" literalVal="8"/>
            <Literal name="September" literalVal="9"/>
            <Literal name="October" literalVal="10"/>
            <Literal name="November" literalVal="11"/>
            <Literal name="December" literalVal="12"/>
         </Enumeration>
         <Enumeration name="MultiplierKind"
                   titleID="IEC61850_7_3.DAEnums::MultiplierKind.cl.title">
            <Literal name="y"
                  literalVal="-24"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.y.desc"/>
            <Literal name="z"
                  literalVal="-21"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.z.desc"/>
            <Literal name="a"
                  literalVal="-18"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.a.desc"/>
            <Literal name="f"
                  literalVal="-15"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.f.desc"/>
            <Literal name="p"
                  literalVal="-12"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.p.desc"/>
            <Literal name="n"
                  literalVal="-9"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.n.desc"/>
            <Literal name="µ"
                  literalVal="-6"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.µ.desc"/>
            <Literal name="m"
                  literalVal="-3"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.m.desc"/>
            <Literal name="c"
                  literalVal="-2"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.c.desc"/>
            <Literal name="d"
                  literalVal="-1"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.d.desc"/>
            <Literal name=""
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.none.desc"/>
            <Literal name="da"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.da.desc"/>
            <Literal name="h"
                  literalVal="2"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.h.desc"/>
            <Literal name="k"
                  literalVal="3"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.k.desc"/>
            <Literal name="M"
                  literalVal="6"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.M.desc"/>
            <Literal name="G"
                  literalVal="9"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.G.desc"/>
            <Literal name="T"
                  literalVal="12"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.T.desc"/>
            <Literal name="P"
                  literalVal="15"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.P.desc"/>
            <Literal name="E"
                  literalVal="18"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.E.desc"/>
            <Literal name="Z"
                  literalVal="21"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.Z.desc"/>
            <Literal name="Y"
                  literalVal="24"
                  descID="IEC61850_7_3.DAEnums::MultiplierKind.Y.desc"/>
         </Enumeration>
         <Enumeration name="OccurrenceKind"
                   titleID="IEC61850_7_3.DAEnums::OccurrenceKind.cl.title">
            <Literal name="Time" literalVal="0"/>
            <Literal name="WeekDay" literalVal="1"/>
            <Literal name="WeekOfYear" literalVal="2"/>
            <Literal name="DayOfMonth" literalVal="3"/>
            <Literal name="DayOfYear" literalVal="4"/>
            <Literal name="NONE"
                  literalVal="5"
                  descID="IEC61850_7_3.DAEnums::OccurrenceKind.NONE.desc"/>
         </Enumeration>
         <Enumeration name="OutputSignalKind"
                   titleID="IEC61850_7_3.DAEnums::OutputSignalKind.cl.title">
            <Literal name="pulse"
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::OutputSignalKind.pulse.desc"/>
            <Literal name="persistent"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::OutputSignalKind.persistent.desc"/>
            <Literal name="persistent-feedback"
                  literalVal="2"
                  descID="IEC61850_7_3.DAEnums::OutputSignalKind.persistent-feedback.desc"/>
         </Enumeration>
         <Enumeration name="PeriodKind" titleID="IEC61850_7_3.DAEnums::PeriodKind.cl.title">
            <Literal name="Hour" literalVal="0"/>
            <Literal name="Day" literalVal="1"/>
            <Literal name="Week" literalVal="2"/>
            <Literal name="Month" literalVal="3"/>
            <Literal name="Year" literalVal="4"/>
         </Enumeration>
         <Enumeration name="PhaseAngleReferenceKind"
                   titleID="IEC61850_7_3.DAEnums::PhaseAngleReferenceKind.cl.title">
            <Literal name="Va" literalVal="0"/>
            <Literal name="Vb" literalVal="1"/>
            <Literal name="Vc" literalVal="2"/>
            <Literal name="Aa" literalVal="3"/>
            <Literal name="Ab" literalVal="4"/>
            <Literal name="Ac" literalVal="5"/>
            <Literal name="Vab" literalVal="6"/>
            <Literal name="Vbc" literalVal="7"/>
            <Literal name="Vca" literalVal="8"/>
            <Literal name="Vother" literalVal="9"/>
            <Literal name="Aother" literalVal="10"/>
            <Literal name="Synchrophasor"
                  literalVal="11"
                  descID="IEC61850_7_3.DAEnums::PhaseAngleReferenceKind.Synchrophasor.desc"/>
         </Enumeration>
         <Enumeration name="PhaseFaultDirectionKind"
                   titleID="IEC61850_7_3.DAEnums::PhaseFaultDirectionKind.cl.title">
            <Literal name="unknown" literalVal="0"/>
            <Literal name="forward" literalVal="1"/>
            <Literal name="backward" literalVal="2"/>
         </Enumeration>
         <Enumeration name="PhaseReferenceKind"
                   titleID="IEC61850_7_3.DAEnums::PhaseReferenceKind.cl.title">
            <Literal name="A" literalVal="0"/>
            <Literal name="B" literalVal="1"/>
            <Literal name="C" literalVal="2"/>
            <Literal name="Synchrophasor" literalVal="3"/>
         </Enumeration>
         <Enumeration name="RangeKind" titleID="IEC61850_7_3.DAEnums::RangeKind.cl.title">
            <Literal name="normal" literalVal="0"/>
            <Literal name="high" literalVal="1"/>
            <Literal name="low" literalVal="2"/>
            <Literal name="high-high" literalVal="3"/>
            <Literal name="low-low" literalVal="4"/>
         </Enumeration>
         <Enumeration name="SIUnitKind" titleID="IEC61850_7_3.DAEnums::SIUnitKind.cl.title">
            <Literal name=""
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.none.desc"/>
            <Literal name="m"
                  literalVal="2"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m.desc"/>
            <Literal name="kg"
                  literalVal="3"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.kg.desc"/>
            <Literal name="s"
                  literalVal="4"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.s.desc"/>
            <Literal name="A"
                  literalVal="5"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.A.desc"/>
            <Literal name="K"
                  literalVal="6"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.K.desc"/>
            <Literal name="mol"
                  literalVal="7"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.mol.desc"/>
            <Literal name="cd"
                  literalVal="8"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.cd.desc"/>
            <Literal name="deg"
                  literalVal="9"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.deg.desc"/>
            <Literal name="rad"
                  literalVal="10"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.rad.desc"/>
            <Literal name="sr"
                  literalVal="11"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.sr.desc"/>
            <Literal name="Gy"
                  literalVal="21"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Gy.desc"/>
            <Literal name="Bq"
                  literalVal="22"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Bq.desc"/>
            <Literal name="°C"
                  literalVal="23"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.°C.desc"/>
            <Literal name="Sv"
                  literalVal="24"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Sv.desc"/>
            <Literal name="F"
                  literalVal="25"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.F.desc"/>
            <Literal name="C"
                  literalVal="26"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.C.desc"/>
            <Literal name="S"
                  literalVal="27"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.S.desc"/>
            <Literal name="H"
                  literalVal="28"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.H.desc"/>
            <Literal name="V"
                  literalVal="29"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.V.desc"/>
            <Literal name="ohm"
                  literalVal="30"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.ohm.desc"/>
            <Literal name="J"
                  literalVal="31"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.J.desc"/>
            <Literal name="N"
                  literalVal="32"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.N.desc"/>
            <Literal name="Hz"
                  literalVal="33"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Hz.desc"/>
            <Literal name="lx"
                  literalVal="34"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.lx.desc"/>
            <Literal name="Lm"
                  literalVal="35"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Lm.desc"/>
            <Literal name="Wb"
                  literalVal="36"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Wb.desc"/>
            <Literal name="T"
                  literalVal="37"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.T.desc"/>
            <Literal name="W"
                  literalVal="38"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.W.desc"/>
            <Literal name="Pa"
                  literalVal="39"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Pa.desc"/>
            <Literal name="m²"
                  literalVal="41"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m².desc"/>
            <Literal name="m³"
                  literalVal="42"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m³.desc"/>
            <Literal name="m/s"
                  literalVal="43"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m_per_s.desc"/>
            <Literal name="m/s²"
                  literalVal="44"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m_per_s².desc"/>
            <Literal name="m³/s"
                  literalVal="45"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m³_per_s.desc"/>
            <Literal name="m/m³"
                  literalVal="46"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m_per_m³.desc"/>
            <Literal name="M"
                  literalVal="47"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.M.desc"/>
            <Literal name="kg/m³"
                  literalVal="48"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.kg_per_m³.desc"/>
            <Literal name="m²/s"
                  literalVal="49"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.m²_per_s.desc"/>
            <Literal name="W/m K"
                  literalVal="50"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.W_per_m_K.desc"/>
            <Literal name="J/K"
                  literalVal="51"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.J_per_K.desc"/>
            <Literal name="ppm"
                  literalVal="52"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.ppm.desc"/>
            <Literal name="1/s"
                  literalVal="53"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.1_per_s.desc"/>
            <Literal name="rad/s"
                  literalVal="54"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.rad_per_s.desc"/>
            <Literal name="W/m²"
                  literalVal="55"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.W_per_m².desc"/>
            <Literal name="J/m²"
                  literalVal="56"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.J_per_m².desc"/>
            <Literal name="S/m"
                  literalVal="57"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.S_per_m.desc"/>
            <Literal name="K/s"
                  literalVal="58"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.K_per_s.desc"/>
            <Literal name="Pa/s"
                  literalVal="59"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Pa_per_s.desc"/>
            <Literal name="J/kg K"
                  literalVal="60"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.J_per_kg_K.desc"/>
            <Literal name="VA"
                  literalVal="61"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.VA.desc"/>
            <Literal name="Watts"
                  literalVal="62"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Watts.desc"
                  deprecated="true"/>
            <Literal name="VAr"
                  literalVal="63"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.VAr.desc"/>
            <Literal name="phi"
                  literalVal="64"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.phi.desc"
                  deprecated="true"/>
            <Literal name="cos(phi)"
                  literalVal="65"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.cos(phi).desc"/>
            <Literal name="Vs"
                  literalVal="66"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Vs.desc"/>
            <Literal name="V²"
                  literalVal="67"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.V².desc"/>
            <Literal name="As"
                  literalVal="68"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.As.desc"/>
            <Literal name="A²"
                  literalVal="69"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.A².desc"/>
            <Literal name="A²t"
                  literalVal="70"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.A²t.desc"/>
            <Literal name="VAh"
                  literalVal="71"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.VAh.desc"/>
            <Literal name="Wh"
                  literalVal="72"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Wh.desc"/>
            <Literal name="VArh"
                  literalVal="73"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.VArh.desc"/>
            <Literal name="V/Hz"
                  literalVal="74"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.V_per_Hz.desc"/>
            <Literal name="Hz/s"
                  literalVal="75"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Hz_per_s.desc"/>
            <Literal name="char"
                  literalVal="76"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.char.desc"/>
            <Literal name="char/s"
                  literalVal="77"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.char_per_s.desc"/>
            <Literal name="kgm²"
                  literalVal="78"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.kgm².desc"/>
            <Literal name="dB"
                  literalVal="79"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.dB.desc"/>
            <Literal name="J/Wh"
                  literalVal="80"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.J_per_Wh.desc"/>
            <Literal name="W/s"
                  literalVal="81"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.W_per_s.desc"/>
            <Literal name="l/s"
                  literalVal="82"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.l_per_s.desc"/>
            <Literal name="dBm"
                  literalVal="83"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.dBm.desc"/>
            <Literal name="h"
                  literalVal="84"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.h.desc"/>
            <Literal name="min"
                  literalVal="85"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.min.desc"/>
            <Literal name="Ohm/m"
                  literalVal="86"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.Ohm_per_m.desc"/>
            <Literal name="percent/s"
                  literalVal="87"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.percent_per_s.desc"/>
            <Literal name="A/V"
                  literalVal="88"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.A_per_V.desc"/>
            <Literal name="A/Vs"
                  literalVal="89"
                  descID="IEC61850_7_3.DAEnums::SIUnitKind.A_per_Vs.desc"/>
         </Enumeration>
         <Enumeration name="SboClassKind"
                   titleID="IEC61850_7_3.DAEnums::SboClassKind.cl.title">
            <Literal name="operate-once"
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::SboClassKind.operate-once.desc"/>
            <Literal name="operate-many"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::SboClassKind.operate-many.desc"/>
         </Enumeration>
         <Enumeration name="SequenceKind"
                   titleID="IEC61850_7_3.DAEnums::SequenceKind.cl.title">
            <Literal name="pos-neg-zero"
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::SequenceKind.pos-neg-zero.desc"/>
            <Literal name="dir-quad-zero"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::SequenceKind.dir-quad-zero.desc"/>
         </Enumeration>
         <Enumeration name="SeverityKind"
                   titleID="IEC61850_7_3.DAEnums::SeverityKind.cl.title">
            <Literal name="unknown"
                  literalVal="0"
                  descID="IEC61850_7_3.DAEnums::SeverityKind.unknown.desc"/>
            <Literal name="critical"
                  literalVal="1"
                  descID="IEC61850_7_3.DAEnums::SeverityKind.critical.desc"/>
            <Literal name="major"
                  literalVal="2"
                  descID="IEC61850_7_3.DAEnums::SeverityKind.major.desc"/>
            <Literal name="minor"
                  literalVal="3"
                  descID="IEC61850_7_3.DAEnums::SeverityKind.minor.desc"/>
            <Literal name="warning"
                  literalVal="4"
                  descID="IEC61850_7_3.DAEnums::SeverityKind.warning.desc"/>
         </Enumeration>
         <Enumeration name="WeekdayKind" titleID="IEC61850_7_3.DAEnums::WeekdayKind.cl.title">
            <Literal name="reserved" literalVal="0"/>
            <Literal name="Monday" literalVal="1"/>
            <Literal name="Tuesday" literalVal="2"/>
            <Literal name="Wednesday" literalVal="3"/>
            <Literal name="Thursday" literalVal="4"/>
            <Literal name="Friday" literalVal="5"/>
            <Literal name="Saturday" literalVal="6"/>
            <Literal name="Sunday" literalVal="7"/>
         </Enumeration>
      </Enumerations>
   <ConstructedAttributes>
         <ConstructedAttribute name="ScaledValueConfig"
                            titleID="IEC61850_7_3.ConstructedDAs::ScaledValueConfig.cl.title">
            <SubDataAttribute name="scaleFactor"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::ScaledValueConfig.scaleFactor.desc"
                           presCond="M"/>
            <SubDataAttribute name="offset"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::ScaledValueConfig.offset.desc"
                           presCond="M"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="RangeConfig"
                            titleID="IEC61850_7_3.ConstructedDAs::RangeConfig.cl.title">
            <SubDataAttribute name="hhLim"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.hhLim.desc"
                           presCond="MORange"/>
            <SubDataAttribute name="hLim"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.hLim.desc"
                           presCond="MORange"/>
            <SubDataAttribute name="lLim"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.lLim.desc"
                           presCond="MORange"/>
            <SubDataAttribute name="llLim"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.llLim.desc"
                           presCond="MORange"/>
            <SubDataAttribute name="min"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.min.desc"
                           presCond="M"/>
            <SubDataAttribute name="max"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.max.desc"
                           presCond="M"/>
            <SubDataAttribute name="limDb"
                           type="INT32U"
                           minValue="0"
                           maxValue="100000"
                           descID="IEC61850_7_3.ConstructedDAs::RangeConfig.limDb.desc"
                           presCond="O"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="ValWithTrans"
                            titleID="IEC61850_7_3.ConstructedDAs::ValWithTrans.cl.title">
            <SubDataAttribute name="posVal"
                           type="INT8"
                           minValue="-64"
                           maxValue="63"
                           descID="IEC61850_7_3.ConstructedDAs::ValWithTrans.posVal.desc"
                           presCond="M"/>
            <SubDataAttribute name="transInd"
                           type="BOOLEAN"
                           descID="IEC61850_7_3.ConstructedDAs::ValWithTrans.transInd.desc"
                           presCond="O"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="PulseConfig"
                            titleID="IEC61850_7_3.ConstructedDAs::PulseConfig.cl.title">
            <SubDataAttribute name="cmdQual"
                           type="OutputSignalKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.ConstructedDAs::PulseConfig.cmdQual.desc"
                           presCond="M"/>
            <SubDataAttribute name="onDur"
                           type="INT32U"
                           descID="IEC61850_7_3.ConstructedDAs::PulseConfig.onDur.desc"
                           presCond="M"/>
            <SubDataAttribute name="offDur"
                           type="INT32U"
                           descID="IEC61850_7_3.ConstructedDAs::PulseConfig.offDur.desc"
                           presCond="M"/>
            <SubDataAttribute name="numPls"
                           type="INT32U"
                           descID="IEC61850_7_3.ConstructedDAs::PulseConfig.numPls.desc"
                           presCond="M"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="Unit" titleID="IEC61850_7_3.ConstructedDAs::Unit.cl.title">
            <SubDataAttribute name="SIUnit"
                           type="SIUnitKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.ConstructedDAs::Unit.SIUnit.desc"
                           presCond="M"/>
            <SubDataAttribute name="multiplier"
                           type="MultiplierKind"
                           typeKind="ENUMERATED"
                           defaultValue="none"
                           descID="IEC61850_7_3.ConstructedDAs::Unit.multiplier.desc"
                           presCond="O"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="Vector" titleID="IEC61850_7_3.ConstructedDAs::Vector.cl.title">
            <SubDataAttribute name="mag"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.ConstructedDAs::Vector.mag.desc"
                           presCond="M"/>
            <SubDataAttribute name="ang"
                           type="AnalogueValue"
                           typeKind="CONSTRUCTED"
                           minValue="-180"
                           maxValue="180"
                           descID="IEC61850_7_3.ConstructedDAs::Vector.ang.desc"
                           presCond="O"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="Point" titleID="IEC61850_7_3.ConstructedDAs::Point.cl.title">
            <SubDataAttribute name="xVal"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Point.xVal.desc"
                           presCond="M"/>
            <SubDataAttribute name="yVal"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Point.yVal.desc"
                           presCond="M"/>
            <SubDataAttribute name="zVal"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Point.zVal.desc"
                           presCond="O"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="Cell" titleID="IEC61850_7_3.ConstructedDAs::Cell.cl.title">
            <SubDataAttribute name="xStart"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Cell.xStart.desc"
                           presCond="M"/>
            <SubDataAttribute name="xEnd"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Cell.xEnd.desc"
                           presCond="O"/>
            <SubDataAttribute name="yStart"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Cell.yStart.desc"
                           presCond="O"/>
            <SubDataAttribute name="yEnd"
                           type="FLOAT32"
                           descID="IEC61850_7_3.ConstructedDAs::Cell.yEnd.desc"
                           presCond="O"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="CalendarTime"
                            titleID="IEC61850_7_3.ConstructedDAs::CalendarTime.cl.title">
            <SubDataAttribute name="occ"
                           type="INT16U"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.occ.desc"
                           presCond="M"/>
            <SubDataAttribute name="occType"
                           type="OccurrenceKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.occType.desc"
                           presCond="M"/>
            <SubDataAttribute name="occPer"
                           type="PeriodKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.occPer.desc"
                           presCond="M"/>
            <SubDataAttribute name="weekDay"
                           type="WeekdayKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.weekDay.desc"
                           presCond="M"/>
            <SubDataAttribute name="month"
                           type="MonthKind"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.month.desc"
                           presCond="M"/>
            <SubDataAttribute name="day"
                           type="INT8U"
                           minValue="1"
                           maxValue="31"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.day.desc"
                           presCond="M"/>
            <SubDataAttribute name="hr"
                           type="INT8U"
                           minValue="0"
                           maxValue="23"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.hr.desc"
                           presCond="M"/>
            <SubDataAttribute name="mn"
                           type="INT8U"
                           minValue="0"
                           maxValue="59"
                           descID="IEC61850_7_3.ConstructedDAs::CalendarTime.mn.desc"
                           presCond="M"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="AnalogueValue"
                            titleID="IEC61850_7_3.AnalogueValue::AnalogueValue.cl.title">
            <SubDataAttribute name="i"
                           type="INT32"
                           descID="IEC61850_7_3.AnalogueValue::AnalogueValue.i.desc"
                           presCond="AtLeastOne"
                           presCondArgs="1"/>
            <SubDataAttribute name="f"
                           type="FLOAT32"
                           descID="IEC61850_7_3.AnalogueValue::AnalogueValue.f.desc"
                           presCond="AtLeastOne"
                           presCondArgs="1"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="AnalogueValueCtl"
                            titleID="IEC61850_7_3.AnalogueValue::AnalogueValueCtl.cl.title">
            <SubDataAttribute name="i"
                           type="INT32"
                           descID="IEC61850_7_3.AnalogueValue::AnalogueValueCtl.i.desc"
                           presCond="AllOnlyOneGroup"
                           presCondArgs="1"/>
            <SubDataAttribute name="f"
                           type="FLOAT32"
                           descID="IEC61850_7_3.AnalogueValue::AnalogueValueCtl.f.desc"
                           presCond="AllOnlyOneGroup"
                           presCondArgs="2"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="AnalogueValueCtlF"
                            titleID="IEC61850_7_3.AnalogueValue::AnalogueValueCtlF.cl.title">
            <SubDataAttribute name="f"
                           type="FLOAT32"
                           descID="IEC61850_7_3.AnalogueValue::AnalogueValueCtlF.f.desc"
                           presCond="M"/>
         </ConstructedAttribute>
         <ConstructedAttribute name="AnalogueValueCtlInt"
                            titleID="IEC61850_7_3.AnalogueValue::AnalogueValueCtlInt.cl.title">
            <SubDataAttribute name="i"
                           type="INT32"
                           descID="IEC61850_7_3.AnalogueValue::AnalogueValueCtlInt.i.desc"
                           presCond="M"/>
         </ConstructedAttribute>
      </ConstructedAttributes>
   <CDCs>
         <CDC name="SPS" titleID="IEC61850_7_3.CDCStatusInfo::SPS.cl.title">
            <DataAttribute name="stVal"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::SPS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::SPS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::SPS.t.desc"
                        presCond="M"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCStatusInfo::SPS.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="DPS" titleID="IEC61850_7_3.CDCStatusInfo::DPS.cl.title">
            <DataAttribute name="stVal"
                        fc="ST"
                        type="Dbpos"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::DPS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::DPS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::DPS.t.desc"
                        presCond="M"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="Dbpos"
                        descID="IEC61850_7_3.CDCStatusInfo::DPS.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="INS"
           titleID="IEC61850_7_3.CDCStatusInfo::INS.cl.title"
           statistics="true">
            <DataAttribute name="stVal"
                        fc="ST"
                        type="INT32"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCStatusInfo::INS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::INS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::INS.t.desc"
                        presCond="M"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="INT32"
                        descID="IEC61850_7_3.CDCStatusInfo::INS.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::INS.units.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ENS"
           titleID="IEC61850_7_3.CDCStatusInfo::ENS.cl.title"
           enumParameterized="true">
            <DataAttribute name="stVal"
                        fc="ST"
                        typeKind="ENUMERATED"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ENS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ENS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ENS.t.desc"
                        presCond="M"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCStatusInfo::ENS.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ACT" titleID="IEC61850_7_3.CDCStatusInfo::ACT.cl.title">
            <DataAttribute name="general"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.general.desc"
                        presCond="M"/>
            <DataAttribute name="phsA"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.phsA.desc"
                        presCond="O"/>
            <DataAttribute name="phsB"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.phsB.desc"
                        presCond="O"/>
            <DataAttribute name="phsC"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.phsC.desc"
                        presCond="O"/>
            <DataAttribute name="neut"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.neut.desc"
                        presCond="O"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.t.desc"
                        presCond="M"/>
            <DataAttribute name="originSrc"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.originSrc.desc"
                        presCond="O"/>
            <DataAttribute name="operTmPhsA"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.operTmPhsA.desc"
                        presCond="O"/>
            <DataAttribute name="operTmPhsB"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.operTmPhsB.desc"
                        presCond="O"/>
            <DataAttribute name="operTmPhsC"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ACT.operTmPhsC.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ACD" titleID="IEC61850_7_3.CDCStatusInfo::ACD.cl.title">
            <DataAttribute name="general"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.general.desc"
                        presCond="M"/>
            <DataAttribute name="dirGeneral"
                        fc="ST"
                        type="FaultDirectionKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.dirGeneral.desc"
                        presCond="M"/>
            <DataAttribute name="phsA"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.phsA.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="dirPhsA"
                        fc="ST"
                        type="PhaseFaultDirectionKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.dirPhsA.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="phsB"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.phsB.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="2"/>
            <DataAttribute name="dirPhsB"
                        fc="ST"
                        type="PhaseFaultDirectionKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.dirPhsB.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="2"/>
            <DataAttribute name="phsC"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.phsC.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="3"/>
            <DataAttribute name="dirPhsC"
                        fc="ST"
                        type="PhaseFaultDirectionKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.dirPhsC.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="3"/>
            <DataAttribute name="neut"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.neut.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="4"/>
            <DataAttribute name="dirNeut"
                        fc="ST"
                        type="PhaseFaultDirectionKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.dirNeut.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="4"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ACD.t.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="SEC" titleID="IEC61850_7_3.CDCStatusInfo::SEC.cl.title">
            <DataAttribute name="cnt"
                        fc="ST"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::SEC.cnt.desc"
                        presCond="M"/>
            <DataAttribute name="sev"
                        fc="ST"
                        type="SeverityKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCStatusInfo::SEC.sev.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::SEC.t.desc"
                        presCond="M"/>
            <DataAttribute name="addr"
                        fc="ST"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCStatusInfo::SEC.addr.desc"
                        presCond="O"/>
            <DataAttribute name="addInfo"
                        fc="ST"
                        type="VisString64"
                        descID="IEC61850_7_3.CDCStatusInfo::SEC.addInfo.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="BCR"
           titleID="IEC61850_7_3.CDCStatusInfo::BCR.cl.title"
           statistics="true">
            <DataAttribute name="actVal"
                        fc="ST"
                        type="INT64"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.actVal.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="2"/>
            <DataAttribute name="frVal"
                        fc="ST"
                        type="INT64"
                        dupd="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.frVal.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="1"/>
            <DataAttribute name="frTm"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.frTm.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="1"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.t.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="2"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.units.desc"
                        presCond="O"/>
            <DataAttribute name="pulsQty"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.pulsQty.desc"
                        presCond="M"/>
            <DataAttribute name="frEna"
                        fc="CF"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.frEna.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="1"/>
            <DataAttribute name="strTm"
                        fc="CF"
                        type="Timestamp"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.strTm.desc"
                        presCond="OF"
                        presCondArgs="frVal"/>
            <DataAttribute name="frPd"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.frPd.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="1"/>
            <DataAttribute name="frRs"
                        fc="CF"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::BCR.frRs.desc"
                        presCond="AllAtLeastOneGroup"
                        presCondArgs="1"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="HST" titleID="IEC61850_7_3.CDCStatusInfo::HST.cl.title">
            <DataAttribute name="hstVal"
                        fc="ST"
                        type="INT32"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.hstVal.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.t.desc"
                        presCond="M"/>
            <DataAttribute name="numPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.numPts.desc"
                        presCond="M"/>
            <DataAttribute name="hstRangeC"
                        fc="CF"
                        type="Cell"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.hstRangeC.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="xUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.xUnits.desc"
                        presCond="M"/>
            <DataAttribute name="yUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.yUnits.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.units.desc"
                        presCond="O"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="xD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.xD.desc"
                        presCond="M"/>
            <DataAttribute name="xDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.xDU.desc"
                        presCond="O"/>
            <DataAttribute name="yD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.yD.desc"
                        presCond="O"/>
            <DataAttribute name="yDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCStatusInfo::HST.yDU.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="VSS" titleID="IEC61850_7_3.CDCStatusInfo::VSS.cl.title">
            <DataAttribute name="stVal"
                        fc="ST"
                        type="VisString255"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::VSS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::VSS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::VSS.t.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ORS" titleID="IEC61850_7_3.CDCStatusInfo::ORS.cl.title">
            <DataAttribute name="stVal"
                        fc="ST"
                        type="ObjRef"
                        dchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ORS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::ORS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::ORS.t.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="TCS" titleID="IEC61850_7_3.CDCStatusInfo::TCS.cl.title">
            <DataAttribute name="stVal"
                        fc="ST"
                        type="Timestamp"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCStatusInfo::TCS.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCStatusInfo::TCS.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCStatusInfo::TCS.t.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="MV"
           titleID="IEC61850_7_3.CDCAnalogueInfo::MV.cl.title"
           statistics="true">
            <DataAttribute name="instMag"
                        fc="MX"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.instMag.desc"
                        presCond="O"/>
            <DataAttribute name="mag"
                        fc="MX"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.mag.desc"
                        presCond="M"/>
            <DataAttribute name="range"
                        fc="MX"
                        type="RangeKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.range.desc"
                        presCond="O"/>
            <DataAttribute name="q"
                        fc="MX"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="MX"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.t.desc"
                        presCond="M"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subMag"
                        fc="SV"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.subMag.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.units.desc"
                        presCond="O"/>
            <DataAttribute name="db"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.db.desc"
                        presCond="O"/>
            <DataAttribute name="zeroDb"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.zeroDb.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="rangeC"
                        fc="CF"
                        type="RangeConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.rangeC.desc"
                        presCond="MO"
                        presCondArgs="range"/>
            <DataAttribute name="smpRate"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.smpRate.desc"
                        presCond="O"/>
            <DataAttribute name="dbRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.dbRef.desc"
                        presCond="MO"
                        presCondArgs="db"/>
            <DataAttribute name="zeroDbRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::MV.zeroDbRef.desc"
                        presCond="MO"
                        presCondArgs="zeroDb"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CMV"
           titleID="IEC61850_7_3.CDCAnalogueInfo::CMV.cl.title"
           statistics="true">
            <DataAttribute name="instCVal"
                        fc="MX"
                        type="Vector"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.instCVal.desc"
                        presCond="O"/>
            <DataAttribute name="cVal"
                        fc="MX"
                        type="Vector"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.cVal.desc"
                        presCond="M"/>
            <DataAttribute name="range"
                        fc="MX"
                        type="RangeKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.range.desc"
                        presCond="O"/>
            <DataAttribute name="rangeAng"
                        fc="MX"
                        type="RangeKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.rangeAng.desc"
                        presCond="O"/>
            <DataAttribute name="q"
                        fc="MX"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="MX"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.t.desc"
                        presCond="M"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subCVal"
                        fc="SV"
                        type="Vector"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.subCVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.units.desc"
                        presCond="O"/>
            <DataAttribute name="db"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.db.desc"
                        presCond="O"/>
            <DataAttribute name="dbAng"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.dbAng.desc"
                        presCond="O"/>
            <DataAttribute name="zeroDb"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.zeroDb.desc"
                        presCond="O"/>
            <DataAttribute name="rangeC"
                        fc="CF"
                        type="RangeConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.rangeC.desc"
                        presCond="MO"
                        presCondArgs="range"/>
            <DataAttribute name="rangeAngC"
                        fc="CF"
                        type="RangeConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.rangeAngC.desc"
                        presCond="MO"
                        presCondArgs="rangeAng"/>
            <DataAttribute name="magSVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.magSVC.desc"
                        presCond="MFscaledMagV"/>
            <DataAttribute name="angSVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.angSVC.desc"
                        presCond="MFscaledAngV"/>
            <DataAttribute name="angRef"
                        fc="CF"
                        type="PhaseAngleReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.angRef.desc"
                        presCond="O"/>
            <DataAttribute name="smpRate"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.smpRate.desc"
                        presCond="O"/>
            <DataAttribute name="dbRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.dbRef.desc"
                        presCond="MO"
                        presCondArgs="db"/>
            <DataAttribute name="zeroDbRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.zeroDbRef.desc"
                        presCond="MO"
                        presCondArgs="zeroDb"/>
            <DataAttribute name="dbAngRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::CMV.dbAngRef.desc"
                        presCond="MO"
                        presCondArgs="dbAng"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="SAV"
           titleID="IEC61850_7_3.CDCAnalogueInfo::SAV.cl.title"
           statistics="true">
            <DataAttribute name="instMag"
                        fc="MX"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.instMag.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="MX"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="MX"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.t.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.units.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="min"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.min.desc"
                        presCond="O"/>
            <DataAttribute name="max"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SAV.max.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="WYE"
           titleID="IEC61850_7_3.CDCAnalogueInfo::WYE.cl.title"
           statistics="true">
            <SubDataObject name="phsA"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.phsA.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="phsB"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.phsB.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="phsC"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.phsC.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="neut"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.neut.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="net"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.net.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="res"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.res.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="angRef"
                        fc="CF"
                        type="PhaseAngleReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.angRef.desc"
                        presCond="O"/>
            <DataAttribute name="phsToNeut"
                        fc="CF"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::WYE.phsToNeut.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="DEL"
           titleID="IEC61850_7_3.CDCAnalogueInfo::DEL.cl.title"
           statistics="true">
            <SubDataObject name="phsAB"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::DEL.phsAB.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="phsBC"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::DEL.phsBC.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <SubDataObject name="phsCA"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::DEL.phsCA.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="angRef"
                        fc="CF"
                        type="PhaseAngleReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::DEL.angRef.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="SEQ"
           titleID="IEC61850_7_3.CDCAnalogueInfo::SEQ.cl.title"
           statistics="true">
            <SubDataObject name="c1"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SEQ.c1.desc"
                        presCond="M"/>
            <SubDataObject name="c2"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SEQ.c2.desc"
                        presCond="OMSynPh"/>
            <SubDataObject name="c3"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SEQ.c3.desc"
                        presCond="OMSynPh"/>
            <DataAttribute name="seqT"
                        fc="MX"
                        type="SequenceKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SEQ.seqT.desc"
                        presCond="M"/>
            <DataAttribute name="phsRef"
                        fc="CF"
                        type="PhaseReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::SEQ.phsRef.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="HMV"
           titleID="IEC61850_7_3.CDCAnalogueInfo::HMV.cl.title"
           statistics="true">
            <SubDataObject name="har"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HMV.har.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="numHar"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.numHar.desc"
                        presCond="M"/>
            <DataAttribute name="numCyc"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.numCyc.desc"
                        presCond="M"/>
            <DataAttribute name="evalTm"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.evalTm.desc"
                        presCond="M"/>
            <DataAttribute name="smpRate"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.smpRate.desc"
                        presCond="O"/>
            <DataAttribute name="frequency"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.frequency.desc"
                        presCond="M"/>
            <DataAttribute name="hvRef"
                        fc="CF"
                        type="HvReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.hvRef.desc"
                        presCond="O"/>
            <DataAttribute name="rmsCyc"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.rmsCyc.desc"
                        presCond="MOrms"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="HWYE"
           titleID="IEC61850_7_3.CDCAnalogueInfo::HWYE.cl.title"
           statistics="true">
            <SubDataObject name="phsAHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.phsAHar.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="phsBHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.phsBHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="phsCHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.phsCHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="neutHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.neutHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="netHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.netHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="resHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.resHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="numHar"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.numHar.desc"
                        presCond="M"/>
            <DataAttribute name="numCyc"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.numCyc.desc"
                        presCond="M"/>
            <DataAttribute name="evalTm"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.evalTm.desc"
                        presCond="M"/>
            <DataAttribute name="angRef"
                        fc="CF"
                        type="PhaseAngleReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HWYE.angRef.desc"
                        presCond="O"/>
            <DataAttribute name="smpRate"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.smpRate.desc"
                        presCond="O"/>
            <DataAttribute name="frequency"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.frequency.desc"
                        presCond="M"/>
            <DataAttribute name="hvRef"
                        fc="CF"
                        type="HvReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.hvRef.desc"
                        presCond="O"/>
            <DataAttribute name="rmsCyc"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.rmsCyc.desc"
                        presCond="MOrms"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="HDEL"
           titleID="IEC61850_7_3.CDCAnalogueInfo::HDEL.cl.title"
           statistics="true">
            <SubDataObject name="phsABHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HDEL.phsABHar.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="phsBCHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HDEL.phsBCHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <SubDataObject name="phsCAHar"
                        type="CMV"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HDEL.phsCAHar.desc"
                        presCond="O"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="numHar"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.numHar.desc"
                        presCond="M"/>
            <DataAttribute name="numCyc"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.numCyc.desc"
                        presCond="M"/>
            <DataAttribute name="evalTm"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.evalTm.desc"
                        presCond="M"/>
            <DataAttribute name="angRef"
                        fc="CF"
                        type="PhaseAngleReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HDEL.angRef.desc"
                        presCond="O"/>
            <DataAttribute name="smpRate"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.smpRate.desc"
                        presCond="O"/>
            <DataAttribute name="frequency"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.frequency.desc"
                        presCond="M"/>
            <DataAttribute name="hvRef"
                        fc="CF"
                        type="HvReferenceKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.hvRef.desc"
                        presCond="O"/>
            <DataAttribute name="rmsCyc"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.rmsCyc.desc"
                        presCond="MOrms"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCAnalogueInfo::HarmonicMeasurandCDC.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BaseComposedCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="SPC" titleID="IEC61850_7_3.CDCControl::SPC.cl.title">
            <DataAttribute name="origin"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::SPC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="ST"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::SPC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="stVal"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.stVal.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.q.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::SPC.t.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="stSeld"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCControl::SPC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="pulseConfig"
                        fc="CF"
                        type="PulseConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.pulseConfig.desc"
                        presCond="O"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::SPC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="BOOLEAN"
                           descID="IEC61850_7_3.CDCControl::SPC.ctlVal.desc"/>
         </CDC>
         <CDC name="DPC" titleID="IEC61850_7_3.CDCControl::DPC.cl.title">
            <DataAttribute name="origin"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::DPC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="ST"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::DPC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="stVal"
                        fc="ST"
                        type="Dbpos"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::DPC.t.desc"
                        presCond="M"/>
            <DataAttribute name="stSeld"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="Dbpos"
                        descID="IEC61850_7_3.CDCControl::DPC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="pulseConfig"
                        fc="CF"
                        type="PulseConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.pulseConfig.desc"
                        presCond="O"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::DPC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="BOOLEAN"
                           descID="IEC61850_7_3.CDCControl::DPC.ctlVal.desc"/>
         </CDC>
         <CDC name="INC"
           titleID="IEC61850_7_3.CDCControl::INC.cl.title"
           statistics="true">
            <DataAttribute name="origin"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::INC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="ST"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::INC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="stVal"
                        fc="ST"
                        type="INT32"
                        dchg="true"
                        dupd="true"
                        descID="IEC61850_7_3.CDCControl::INC.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::INC.t.desc"
                        presCond="M"/>
            <DataAttribute name="stSeld"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="INT32"
                        descID="IEC61850_7_3.CDCControl::INC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::INC.units.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="INT32"
                           descID="IEC61850_7_3.CDCControl::INC.ctlVal.desc"/>
         </CDC>
         <CDC name="ENC"
           titleID="IEC61850_7_3.CDCControl::ENC.cl.title"
           enumParameterized="true">
            <DataAttribute name="origin"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::ENC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="ST"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::ENC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="stVal"
                        fc="ST"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.stVal.desc"
                        presCond="M"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.q.desc"
                        presCond="M"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ENC.t.desc"
                        presCond="M"/>
            <DataAttribute name="stSeld"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCControl::ENC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ENC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           typeKind="ENUMERATED"
                           descID="IEC61850_7_3.CDCControl::ENC.ctlVal.desc"/>
         </CDC>
         <CDC name="BSC"
           titleID="IEC61850_7_3.CDCControl::BSC.cl.title"
           statistics="true">
            <DataAttribute name="origin"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::BSC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="ST"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::BSC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="valWTr"
                        fc="ST"
                        type="ValWithTrans"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.valWTr.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.q.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::BSC.t.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="stSeld"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="ValWithTrans"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::BSC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="persistent"
                        fc="CF"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.persistent.desc"
                        presCond="M"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="INT8"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="INT8"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BSC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="Tcmd"
                           descID="IEC61850_7_3.CDCControl::BSC.ctlVal.desc"/>
         </CDC>
         <CDC name="ISC"
           titleID="IEC61850_7_3.CDCControl::ISC.cl.title"
           statistics="true">
            <DataAttribute name="origin"
                        fc="ST"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::ISC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="ST"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::ISC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="valWTr"
                        fc="ST"
                        type="ValWithTrans"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.valWTr.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="q"
                        fc="ST"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.q.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="t"
                        fc="ST"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ISC.t.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="stSeld"
                        fc="ST"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="ValWithTrans"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::ISC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="INT8"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="INT8"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ISC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="INT8"
                           descID="IEC61850_7_3.CDCControl::ISC.ctlVal.desc"/>
         </CDC>
         <CDC name="APC"
           titleID="IEC61850_7_3.CDCControl::APC.cl.title"
           statistics="true">
            <DataAttribute name="origin"
                        fc="MX"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::APC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="MX"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::APC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="mxVal"
                        fc="MX"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.mxVal.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="q"
                        fc="MX"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.q.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="t"
                        fc="MX"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::APC.t.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="stSeld"
                        fc="MX"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::APC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.units.desc"
                        presCond="O"/>
            <DataAttribute name="db"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.db.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="dbRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::APC.dbRef.desc"
                        presCond="MO"
                        presCondArgs="db"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="AnalogueValueCtl"
                           typeKind="CONSTRUCTED"
                           descID="IEC61850_7_3.CDCControl::APC.ctlVal.desc"/>
         </CDC>
         <CDC name="BAC"
           titleID="IEC61850_7_3.CDCControl::BAC.cl.title"
           statistics="true">
            <DataAttribute name="origin"
                        fc="MX"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::BAC.origin.desc"
                        presCond="O"/>
            <DataAttribute name="ctlNum"
                        fc="MX"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCControl::BAC.ctlNum.desc"
                        presCond="O"/>
            <DataAttribute name="mxVal"
                        fc="MX"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.mxVal.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="q"
                        fc="MX"
                        type="Quality"
                        qchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.q.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="t"
                        fc="MX"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::BAC.t.desc"
                        presCond="MAllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="stSeld"
                        fc="MX"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.stSeld.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="opRcvd"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opRcvd.desc"
                        presCond="O"/>
            <DataAttribute name="opOk"
                        fc="OR"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.opOk.desc"
                        presCond="O"/>
            <DataAttribute name="tOpOk"
                        fc="OR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCControl::ControlTestingCDC.tOpOk.desc"
                        presCond="O"/>
            <DataAttribute name="subEna"
                        fc="SV"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subEna.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subVal"
                        fc="SV"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCControl::BAC.subVal.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subQ"
                        fc="SV"
                        type="Quality"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subQ.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="subID"
                        fc="SV"
                        type="VisString64"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.subID.desc"
                        presCond="MFsubst"/>
            <DataAttribute name="blkEna"
                        fc="BL"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CoreAbstractCDCs::SubstitutionCDC.blkEna.desc"
                        presCond="O"/>
            <DataAttribute name="persistent"
                        fc="CF"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.persistent.desc"
                        presCond="M"/>
            <DataAttribute name="ctlModel"
                        fc="CF"
                        type="CtlModelKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.ctlModel.desc"
                        presCond="M"/>
            <DataAttribute name="sboTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.sboTimeout.desc"
                        presCond="MOsbo"/>
            <DataAttribute name="sboClass"
                        fc="CF"
                        type="SboClassKind"
                        typeKind="ENUMERATED"
                        defaultValue="operate-once"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.sboClass.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.units.desc"
                        presCond="O"/>
            <DataAttribute name="db"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.db.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="operTimeout"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.operTimeout.desc"
                        presCond="MOenhanced"/>
            <DataAttribute name="dbRef"
                        fc="CF"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCControl::BAC.dbRef.desc"
                        presCond="MO"
                        presCondArgs="db"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
            <ServiceParameter name="ctlVal"
                           type="Tcmd"
                           descID="IEC61850_7_3.CDCControl::BAC.ctlVal.desc"/>
         </CDC>
         <CDC name="SPG" variant="SP" titleID="IEC61850_7_3.SPG::SPG_SP.cl.title">
            <DataAttribute name="setVal"
                        fc="SP"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.SPG::SPG_SP.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="SPG" variant="SG" titleID="IEC61850_7_3.SPG::SPG_SG.cl.title">
            <DataAttribute name="setVal"
                        fc="SG"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.SPG::SPG_SG.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="SPG" variant="SE" titleID="IEC61850_7_3.SPG::SPG_SE.cl.title">
            <DataAttribute name="setVal"
                        fc="SE"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.SPG::SPG_SE.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ING" variant="SP" titleID="IEC61850_7_3.ING::ING_SP.cl.title">
            <DataAttribute name="setVal"
                        fc="SP"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING_SP.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.units.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ING" variant="SG" titleID="IEC61850_7_3.ING::ING_SG.cl.title">
            <DataAttribute name="setVal"
                        fc="SG"
                        type="INT32"
                        descID="IEC61850_7_3.ING::ING_SG.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.units.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ING" variant="SE" titleID="IEC61850_7_3.ING::ING_SE.cl.title">
            <DataAttribute name="setVal"
                        fc="SE"
                        type="INT32"
                        descID="IEC61850_7_3.ING::ING_SE.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="INT32U"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ING::ING.units.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ENG"
           variant="SP"
           titleID="IEC61850_7_3.ENG::ENG_SP.cl.title"
           enumParameterized="true">
            <DataAttribute name="setVal"
                        fc="SP"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.ENG::ENG_SP.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ENG"
           variant="SG"
           titleID="IEC61850_7_3.ENG::ENG_SG.cl.title"
           enumParameterized="true">
            <DataAttribute name="setVal"
                        fc="SG"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.ENG::ENG_SG.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ENG"
           variant="SE"
           titleID="IEC61850_7_3.ENG::ENG_SE.cl.title"
           enumParameterized="true">
            <DataAttribute name="setVal"
                        fc="SE"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.ENG::ENG_SE.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ORG" titleID="IEC61850_7_3.ORG::ORG.cl.title">
            <DataAttribute name="setSrcRef"
                        fc="SP"
                        type="ObjRef"
                        dchg="true"
                        descID="IEC61850_7_3.ORG::ORG.setSrcRef.desc"
                        presCond="M"/>
            <DataAttribute name="setTstRef"
                        fc="SP"
                        type="ObjRef"
                        dchg="true"
                        descID="IEC61850_7_3.ORG::ORG.setTstRef.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="setSrcCB"
                        fc="SP"
                        type="ObjRef"
                        dchg="true"
                        descID="IEC61850_7_3.ORG::ORG.setSrcCB.desc"
                        presCond="O"/>
            <DataAttribute name="setTstCB"
                        fc="SP"
                        type="ObjRef"
                        dchg="true"
                        descID="IEC61850_7_3.ORG::ORG.setTstCB.desc"
                        presCond="OF"
                        presCondArgs="setTstRef"/>
            <DataAttribute name="intAddr"
                        fc="SP"
                        type="VisString255"
                        dchg="true"
                        descID="IEC61850_7_3.ORG::ORG.intAddr.desc"
                        presCond="O"/>
            <DataAttribute name="tstEna"
                        fc="SP"
                        type="BOOLEAN"
                        dchg="true"
                        descID="IEC61850_7_3.ORG::ORG.tstEna.desc"
                        presCond="AllOrNonePerGroup"
                        presCondArgs="1"/>
            <DataAttribute name="purpose"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.ORG::ORG.purpose.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="TSG" variant="SP" titleID="IEC61850_7_3.TSG::TSG_SP.cl.title">
            <DataAttribute name="setTm"
                        fc="SP"
                        type="Timestamp"
                        dchg="true"
                        descID="IEC61850_7_3.TSG::TSG_SP.setTm.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="setCal"
                        fc="SP"
                        type="CalendarTime"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.TSG::TSG_SP.setCal.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="TSG" variant="SG" titleID="IEC61850_7_3.TSG::TSG_SG.cl.title">
            <DataAttribute name="setTm"
                        fc="SG"
                        type="Timestamp"
                        descID="IEC61850_7_3.TSG::TSG_SG.setTm.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="setCal"
                        fc="SG"
                        type="CalendarTime"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.TSG::TSG_SG.setCal.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="TSG" variant="SE" titleID="IEC61850_7_3.TSG::TSG_SE.cl.title">
            <DataAttribute name="setTm"
                        fc="SE"
                        type="Timestamp"
                        descID="IEC61850_7_3.TSG::TSG_SE.setTm.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="setCal"
                        fc="SE"
                        type="CalendarTime"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.TSG::TSG_SE.setCal.desc"
                        presCond="AtLeastOne"
                        presCondArgs="1"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CUG" variant="SP" titleID="IEC61850_7_3.CUG::CUG_SP.cl.title">
            <DataAttribute name="cur"
                        fc="SP"
                        type="Currency"
                        dchg="true"
                        descID="IEC61850_7_3.CUG::CUG_SP.cur.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CUG" variant="SG" titleID="IEC61850_7_3.CUG::CUG_SG.cl.title">
            <DataAttribute name="cur"
                        fc="SG"
                        type="Currency"
                        descID="IEC61850_7_3.CUG::CUG_SG.cur.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CUG" variant="SE" titleID="IEC61850_7_3.CUG::CUG_SE.cl.title">
            <DataAttribute name="cur"
                        fc="SE"
                        type="Currency"
                        descID="IEC61850_7_3.CUG::CUG_SE.cur.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="VSG" variant="SP" titleID="IEC61850_7_3.VSG::VSG_SP.cl.title">
            <DataAttribute name="setVal"
                        fc="SP"
                        type="VisString255"
                        dchg="true"
                        descID="IEC61850_7_3.VSG::VSG_SP.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="VSG" variant="SG" titleID="IEC61850_7_3.VSG::VSG_SG.cl.title">
            <DataAttribute name="setVal"
                        fc="SG"
                        type="VisString255"
                        descID="IEC61850_7_3.VSG::VSG_SG.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="VSG" variant="SE" titleID="IEC61850_7_3.VSG::VSG_SE.cl.title">
            <DataAttribute name="setVal"
                        fc="SE"
                        type="VisString255"
                        descID="IEC61850_7_3.VSG::VSG_SE.setVal.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ASG" variant="SP" titleID="IEC61850_7_3.ASG::ASG_SP.cl.title">
            <DataAttribute name="setMag"
                        fc="SP"
                        type="AnalogueValueCtl"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG_SP.setMag.desc"
                        presCond="M"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.units.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ASG" variant="SG" titleID="IEC61850_7_3.ASG::ASG_SG.cl.title">
            <DataAttribute name="setMag"
                        fc="SG"
                        type="AnalogueValueCtl"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.ASG::ASG_SG.setMag.desc"
                        presCond="M"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.units.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="ASG" variant="SE" titleID="IEC61850_7_3.ASG::ASG_SE.cl.title">
            <DataAttribute name="setMag"
                        fc="SE"
                        type="AnalogueValueCtl"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.ASG::ASG_SE.setMag.desc"
                        presCond="M"/>
            <DataAttribute name="units"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.units.desc"
                        presCond="O"/>
            <DataAttribute name="sVC"
                        fc="CF"
                        type="ScaledValueConfig"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.sVC.desc"
                        presCond="MFscaledAV"/>
            <DataAttribute name="minVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.minVal.desc"
                        presCond="O"/>
            <DataAttribute name="maxVal"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.maxVal.desc"
                        presCond="O"/>
            <DataAttribute name="stepSize"
                        fc="CF"
                        type="AnalogueValue"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.ASG::ASG.stepSize.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CURVE"
           variant="SP"
           titleID="IEC61850_7_3.CURVE::CURVE_SP.cl.title">
            <DataAttribute name="setCharact"
                        fc="SP"
                        type="CurveCharKind"
                        typeKind="ENUMERATED"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setCharact.desc"
                        presCond="M"/>
            <DataAttribute name="setParA"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setParA.desc"
                        presCond="O"/>
            <DataAttribute name="setParB"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setParB.desc"
                        presCond="O"/>
            <DataAttribute name="setParC"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setParC.desc"
                        presCond="O"/>
            <DataAttribute name="setParD"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setParD.desc"
                        presCond="O"/>
            <DataAttribute name="setParE"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setParE.desc"
                        presCond="O"/>
            <DataAttribute name="setParF"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CURVE::CURVE_SP.setParF.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CURVE"
           variant="SG"
           titleID="IEC61850_7_3.CURVE::CURVE_SG.cl.title">
            <DataAttribute name="setCharact"
                        fc="SG"
                        type="CurveCharKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setCharact.desc"
                        presCond="M"/>
            <DataAttribute name="setParA"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setParA.desc"
                        presCond="O"/>
            <DataAttribute name="setParB"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setParB.desc"
                        presCond="O"/>
            <DataAttribute name="setParC"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setParC.desc"
                        presCond="O"/>
            <DataAttribute name="setParD"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setParD.desc"
                        presCond="O"/>
            <DataAttribute name="setParE"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setParE.desc"
                        presCond="O"/>
            <DataAttribute name="setParF"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SG.setParF.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CURVE"
           variant="SE"
           titleID="IEC61850_7_3.CURVE::CURVE_SE.cl.title">
            <DataAttribute name="setCharact"
                        fc="SE"
                        type="CurveCharKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setCharact.desc"
                        presCond="M"/>
            <DataAttribute name="setParA"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setParA.desc"
                        presCond="O"/>
            <DataAttribute name="setParB"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setParB.desc"
                        presCond="O"/>
            <DataAttribute name="setParC"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setParC.desc"
                        presCond="O"/>
            <DataAttribute name="setParD"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setParD.desc"
                        presCond="O"/>
            <DataAttribute name="setParE"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setParE.desc"
                        presCond="O"/>
            <DataAttribute name="setParF"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CURVE::CURVE_SE.setParF.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CSG" variant="SP" titleID="IEC61850_7_3.CSG::CSG_SP.cl.title">
            <DataAttribute name="pointZ"
                        fc="SP"
                        type="FLOAT32"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG_SP.pointZ.desc"
                        presCond="O"/>
            <DataAttribute name="numPts"
                        fc="SP"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG_SP.numPts.desc"
                        presCond="M"/>
            <DataAttribute name="crvPts"
                        fc="SP"
                        type="Point"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG_SP.crvPts.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="xUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.xUnits.desc"
                        presCond="M"/>
            <DataAttribute name="yUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.yUnits.desc"
                        presCond="M"/>
            <DataAttribute name="zUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.zUnits.desc"
                        presCond="O"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="xD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.xD.desc"
                        presCond="M"/>
            <DataAttribute name="xDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.xDU.desc"
                        presCond="O"/>
            <DataAttribute name="yD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.yD.desc"
                        presCond="M"/>
            <DataAttribute name="yDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.yDU.desc"
                        presCond="O"/>
            <DataAttribute name="zD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.zD.desc"
                        presCond="O"/>
            <DataAttribute name="zDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.zDU.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CSG" variant="SG" titleID="IEC61850_7_3.CSG::CSG_SG.cl.title">
            <DataAttribute name="pointZ"
                        fc="SG"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CSG::CSG_SG.pointZ.desc"
                        presCond="O"/>
            <DataAttribute name="numPts"
                        fc="SG"
                        type="INT16U"
                        descID="IEC61850_7_3.CSG::CSG_SG.numPts.desc"
                        presCond="M"/>
            <DataAttribute name="crvPts"
                        fc="SG"
                        type="Point"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CSG::CSG_SG.crvPts.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="xUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.xUnits.desc"
                        presCond="M"/>
            <DataAttribute name="yUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.yUnits.desc"
                        presCond="M"/>
            <DataAttribute name="zUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.zUnits.desc"
                        presCond="O"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="xD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.xD.desc"
                        presCond="M"/>
            <DataAttribute name="xDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.xDU.desc"
                        presCond="O"/>
            <DataAttribute name="yD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.yD.desc"
                        presCond="M"/>
            <DataAttribute name="yDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.yDU.desc"
                        presCond="O"/>
            <DataAttribute name="zD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.zD.desc"
                        presCond="O"/>
            <DataAttribute name="zDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.zDU.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CSG" variant="SE" titleID="IEC61850_7_3.CSG::CSG_SE.cl.title">
            <DataAttribute name="pointZ"
                        fc="SE"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CSG::CSG_SE.pointZ.desc"
                        presCond="O"/>
            <DataAttribute name="numPts"
                        fc="SE"
                        type="INT16U"
                        descID="IEC61850_7_3.CSG::CSG_SE.numPts.desc"
                        presCond="M"/>
            <DataAttribute name="crvPts"
                        fc="SE"
                        type="Point"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CSG::CSG_SE.crvPts.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="xUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.xUnits.desc"
                        presCond="M"/>
            <DataAttribute name="yUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.yUnits.desc"
                        presCond="M"/>
            <DataAttribute name="zUnits"
                        fc="CF"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.zUnits.desc"
                        presCond="O"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CSG::CSG.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="xD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.xD.desc"
                        presCond="M"/>
            <DataAttribute name="xDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.xDU.desc"
                        presCond="O"/>
            <DataAttribute name="yD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.yD.desc"
                        presCond="M"/>
            <DataAttribute name="yDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.yDU.desc"
                        presCond="O"/>
            <DataAttribute name="zD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CSG::CSG.zD.desc"
                        presCond="O"/>
            <DataAttribute name="zDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CSG::CSG.zDU.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="DPL" titleID="IEC61850_7_3.CDCDescription::DPL.cl.title">
            <DataAttribute name="vendor"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.vendor.desc"
                        presCond="M"/>
            <DataAttribute name="hwRev"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.hwRev.desc"
                        presCond="O"/>
            <DataAttribute name="swRev"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.swRev.desc"
                        presCond="O"/>
            <DataAttribute name="serNum"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.serNum.desc"
                        presCond="O"/>
            <DataAttribute name="model"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.model.desc"
                        presCond="O"/>
            <DataAttribute name="location"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.location.desc"
                        presCond="O"/>
            <DataAttribute name="name"
                        fc="DC"
                        type="VisString64"
                        descID="IEC61850_7_3.CDCDescription::DPL.name.desc"
                        presCond="O"/>
            <DataAttribute name="owner"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.owner.desc"
                        presCond="O"/>
            <DataAttribute name="ePSName"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.ePSName.desc"
                        presCond="O"/>
            <DataAttribute name="primeOper"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.primeOper.desc"
                        presCond="O"/>
            <DataAttribute name="secondOper"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.secondOper.desc"
                        presCond="O"/>
            <DataAttribute name="latitude"
                        fc="DC"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CDCDescription::DPL.latitude.desc"
                        presCond="O"/>
            <DataAttribute name="longitude"
                        fc="DC"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CDCDescription::DPL.longitude.desc"
                        presCond="O"/>
            <DataAttribute name="altitude"
                        fc="DC"
                        type="FLOAT32"
                        descID="IEC61850_7_3.CDCDescription::DPL.altitude.desc"
                        presCond="O"/>
            <DataAttribute name="mRID"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::DPL.mRID.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="LPL" titleID="IEC61850_7_3.CDCDescription::LPL.cl.title">
            <DataAttribute name="paramRev"
                        fc="ST"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCDescription::LPL.paramRev.desc"
                        presCond="O"/>
            <DataAttribute name="valRev"
                        fc="ST"
                        type="INT32"
                        dchg="true"
                        descID="IEC61850_7_3.CDCDescription::LPL.valRev.desc"
                        presCond="O"/>
            <DataAttribute name="vendor"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::LPL.vendor.desc"
                        presCond="M"/>
            <DataAttribute name="swRev"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::LPL.swRev.desc"
                        presCond="M"/>
            <DataAttribute name="ldNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::LPL.ldNs.desc"
                        presCond="MFln0"/>
            <DataAttribute name="lnNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::LPL.lnNs.desc"
                        presCond="MOlnNs"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="configRev"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::LPL.configRev.desc"
                        presCond="MOln0"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CSD" titleID="IEC61850_7_3.CDCDescription::CSD.cl.title">
            <DataAttribute name="xUnits"
                        fc="DC"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCDescription::CSD.xUnits.desc"
                        presCond="M"/>
            <DataAttribute name="xD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::CSD.xD.desc"
                        presCond="M"/>
            <DataAttribute name="xDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCDescription::CSD.xDU.desc"
                        presCond="O"/>
            <DataAttribute name="yUnits"
                        fc="DC"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCDescription::CSD.yUnits.desc"
                        presCond="M"/>
            <DataAttribute name="yD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::CSD.yD.desc"
                        presCond="M"/>
            <DataAttribute name="yDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCDescription::CSD.yDU.desc"
                        presCond="O"/>
            <DataAttribute name="zUnits"
                        fc="DC"
                        type="Unit"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCDescription::CSD.zUnits.desc"
                        presCond="O"/>
            <DataAttribute name="zD"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::CSD.zD.desc"
                        presCond="O"/>
            <DataAttribute name="zDU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCDescription::CSD.zDU.desc"
                        presCond="O"/>
            <DataAttribute name="numPts"
                        fc="DC"
                        type="INT16U"
                        descID="IEC61850_7_3.CDCDescription::CSD.numPts.desc"
                        presCond="M"/>
            <DataAttribute name="crvPts"
                        fc="DC"
                        type="Point"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCDescription::CSD.crvPts.desc"
                        presCond="M"
                        isArray="true"
                        sizeAttribute="maxPts"/>
            <DataAttribute name="maxPts"
                        fc="CF"
                        type="INT16U"
                        dchg="true"
                        descID="IEC61850_7_3.CDCDescription::CSD.maxPts.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="VSD" titleID="IEC61850_7_3.CDCDescription::VSD.cl.title">
            <DataAttribute name="val"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CDCDescription::VSD.val.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CST" titleID="IEC61850_7_3.CDCServiceTracking::CST.cl.title">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::CST.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::CST.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::CST.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::CST.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::CST.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::CST.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="BTS" titleID="IEC61850_7_3.CDCServiceTracking::BTS.cl.title">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="rptID"
                        fc="SR"
                        type="VisString129"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.rptID.desc"
                        presCond="M"/>
            <DataAttribute name="rptEna"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.rptEna.desc"
                        presCond="M"/>
            <DataAttribute name="datSet"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.datSet.desc"
                        presCond="M"/>
            <DataAttribute name="confRev"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.confRev.desc"
                        presCond="M"/>
            <DataAttribute name="optFlds"
                        fc="SR"
                        type="OptFlds"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.optFlds.desc"
                        presCond="M"/>
            <DataAttribute name="bufTm"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.bufTm.desc"
                        presCond="M"/>
            <DataAttribute name="sqNum"
                        fc="SR"
                        type="INT16U"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.sqNum.desc"
                        presCond="M"/>
            <DataAttribute name="trgOps"
                        fc="SR"
                        type="TrgOps"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.trgOps.desc"
                        presCond="M"/>
            <DataAttribute name="intgPd"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.intgPd.desc"
                        presCond="M"/>
            <DataAttribute name="gi"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.gi.desc"
                        presCond="M"/>
            <DataAttribute name="purgeBuf"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.purgeBuf.desc"
                        presCond="M"/>
            <DataAttribute name="entryID"
                        fc="SR"
                        type="EntryID"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.entryID.desc"
                        presCond="M"/>
            <DataAttribute name="timeOfEntry"
                        fc="SR"
                        type="EntryTime"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.timeOfEntry.desc"
                        presCond="M"/>
            <DataAttribute name="resvTms"
                        fc="SR"
                        type="INT16"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.resvTms.desc"
                        presCond="O"/>
            <DataAttribute name="owner"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::BTS.owner.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="UTS" titleID="IEC61850_7_3.CDCServiceTracking::UTS.cl.title">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="rptID"
                        fc="SR"
                        type="VisString129"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.rptID.desc"
                        presCond="M"/>
            <DataAttribute name="rptEna"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.rptEna.desc"
                        presCond="M"/>
            <DataAttribute name="resv"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.resv.desc"
                        presCond="M"/>
            <DataAttribute name="datSet"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.datSet.desc"
                        presCond="M"/>
            <DataAttribute name="confRev"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.confRev.desc"
                        presCond="M"/>
            <DataAttribute name="optFlds"
                        fc="SR"
                        type="OptFlds"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.optFlds.desc"
                        presCond="M"/>
            <DataAttribute name="bufTm"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.bufTm.desc"
                        presCond="M"/>
            <DataAttribute name="sqNum"
                        fc="SR"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.sqNum.desc"
                        presCond="M"/>
            <DataAttribute name="trgOps"
                        fc="SR"
                        type="TrgOps"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.trgOps.desc"
                        presCond="M"/>
            <DataAttribute name="intgPd"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.intgPd.desc"
                        presCond="M"/>
            <DataAttribute name="gi"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.gi.desc"
                        presCond="M"/>
            <DataAttribute name="owner"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::UTS.owner.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="LTS" titleID="IEC61850_7_3.CDCServiceTracking::LTS.cl.title">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="logEna"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.logEna.desc"
                        presCond="M"/>
            <DataAttribute name="logRef"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.logRef.desc"
                        presCond="M"/>
            <DataAttribute name="datSet"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.datSet.desc"
                        presCond="M"/>
            <DataAttribute name="oldEntrTm"
                        fc="SR"
                        type="EntryTime"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.oldEntrTm.desc"
                        presCond="M"/>
            <DataAttribute name="newEntrTm"
                        fc="SR"
                        type="EntryTime"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.newEntrTm.desc"
                        presCond="M"/>
            <DataAttribute name="oldEnt"
                        fc="SR"
                        type="EntryID"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.oldEnt.desc"
                        presCond="M"/>
            <DataAttribute name="newEnt"
                        fc="SR"
                        type="EntryID"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.newEnt.desc"
                        presCond="M"/>
            <DataAttribute name="trgOps"
                        fc="SR"
                        type="TrgOps"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.trgOps.desc"
                        presCond="M"/>
            <DataAttribute name="intgPd"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::LTS.intgPd.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="GTS"
           titleID="IEC61850_7_3.CDCServiceTracking::GTS.cl.title"
           typeKindParameterized="true">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="goEna"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.goEna.desc"
                        presCond="M"/>
            <DataAttribute name="goID"
                        fc="SR"
                        type="VisString129"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.goID.desc"
                        presCond="M"/>
            <DataAttribute name="datSet"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.datSet.desc"
                        presCond="M"/>
            <DataAttribute name="confRev"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.confRev.desc"
                        presCond="M"/>
            <DataAttribute name="ndsCom"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.ndsCom.desc"
                        presCond="M"/>
            <DataAttribute name="dstAddress"
                        fc="SR"
                        typeKind="SCSM"
                        descID="IEC61850_7_3.CDCServiceTracking::GTS.dstAddress.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="MTS"
           titleID="IEC61850_7_3.CDCServiceTracking::MTS.cl.title"
           typeKindParameterized="true">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="svEna"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.svEna.desc"
                        presCond="M"/>
            <DataAttribute name="msvID"
                        fc="SR"
                        type="VisString129"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.msvID.desc"
                        presCond="M"/>
            <DataAttribute name="datSet"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.datSet.desc"
                        presCond="M"/>
            <DataAttribute name="confRev"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.confRev.desc"
                        presCond="M"/>
            <DataAttribute name="smpRate"
                        fc="SR"
                        type="INT16U"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.smpRate.desc"
                        presCond="M"/>
            <DataAttribute name="optFlds"
                        fc="SR"
                        type="SvOptFlds"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.optFlds.desc"
                        presCond="M"/>
            <DataAttribute name="smpMod"
                        fc="SR"
                        type="SamplingModeKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.smpMod.desc"
                        presCond="M"/>
            <DataAttribute name="dstAddress"
                        fc="SR"
                        typeKind="SCSM"
                        descID="IEC61850_7_3.CDCServiceTracking::MTS.dstAddress.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="NTS"
           titleID="IEC61850_7_3.CDCServiceTracking::NTS.cl.title"
           deprecated="true">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="svEna"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.svEna.desc"
                        presCond="M"/>
            <DataAttribute name="resv"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.resv.desc"
                        presCond="M"/>
            <DataAttribute name="usvID"
                        fc="SR"
                        type="VisString129"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.usvID.desc"
                        presCond="M"/>
            <DataAttribute name="datSet"
                        fc="SR"
                        type="ObjRef"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.datSet.desc"
                        presCond="M"/>
            <DataAttribute name="confRev"
                        fc="SR"
                        type="INT32U"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.confRev.desc"
                        presCond="M"/>
            <DataAttribute name="smpMod"
                        fc="SR"
                        type="SamplingModeKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.smpMod.desc"
                        presCond="M"/>
            <DataAttribute name="smpRate"
                        fc="SR"
                        type="INT16U"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.smpRate.desc"
                        presCond="M"/>
            <DataAttribute name="optFlds"
                        fc="SR"
                        type="SvOptFlds"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.optFlds.desc"
                        presCond="M"/>
            <DataAttribute name="dstAddress"
                        fc="SR"
                        type="PhyComAddr"
                        descID="IEC61850_7_3.CDCServiceTracking::NTS.dstAddress.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="STS" titleID="IEC61850_7_3.CDCServiceTracking::STS.cl.title">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer"
                        fc="SR"
                        type="Unicode255"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.certIssuer.desc"
                        presCond="O"/>
            <DataAttribute name="numOfSG"
                        fc="SR"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.numOfSG.desc"
                        presCond="M"/>
            <DataAttribute name="actSG"
                        fc="SR"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.actSG.desc"
                        presCond="M"/>
            <DataAttribute name="editSG"
                        fc="SR"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.editSG.desc"
                        presCond="M"/>
            <DataAttribute name="cnfEdit"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.cnfEdit.desc"
                        presCond="M"/>
            <DataAttribute name="lActTm"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.lActTm.desc"
                        presCond="M"/>
            <DataAttribute name="resvTms"
                        fc="SR"
                        type="INT16U"
                        descID="IEC61850_7_3.CDCServiceTracking::STS.resvTms.desc"
                        presCond="O"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
         <CDC name="CTS"
           titleID="IEC61850_7_3.CDCServiceTracking::CTS.cl.title"
           typeKindParameterized="true">
            <DataAttribute name="objRef"
                        fc="SR"
                        type="ObjRef"
                        dupd="true"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.objRef.desc"
                        presCond="M"/>
            <DataAttribute name="serviceType"
                        fc="SR"
                        type="ServiceNameKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.serviceType.desc"
                        presCond="M"/>
            <DataAttribute name="errorCode"
                        fc="SR"
                        type="ServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.errorCode.desc"
                        presCond="M"/>
            <DataAttribute name="originatorID"
                        fc="SR"
                        type="Octet64"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.originatorID.desc"
                        presCond="O"/>
            <DataAttribute name="t"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.t.desc"
                        presCond="M"/>
            <DataAttribute name="certIssuer" fc="SR" type="Unicode255" presCond="O"/>
            <DataAttribute name="ctlVal"
                        fc="SR"
                        typeKind="undefined"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.ctlVal.desc"
                        presCond="M"/>
            <DataAttribute name="operTm"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.operTm.desc"
                        presCond="MOoperTm"/>
            <DataAttribute name="origin"
                        fc="SR"
                        type="Originator"
                        typeKind="CONSTRUCTED"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.origin.desc"
                        presCond="M"/>
            <DataAttribute name="ctlNum"
                        fc="SR"
                        type="INT8U"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.ctlNum.desc"
                        presCond="M"/>
            <DataAttribute name="T"
                        fc="SR"
                        type="Timestamp"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.T.desc"
                        presCond="M"/>
            <DataAttribute name="Test"
                        fc="SR"
                        type="BOOLEAN"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.Test.desc"
                        presCond="M"/>
            <DataAttribute name="Check"
                        fc="SR"
                        type="Check"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.Check.desc"
                        presCond="M"/>
            <DataAttribute name="respAddCause"
                        fc="SR"
                        type="ControlServiceStatusKind"
                        typeKind="ENUMERATED"
                        descID="IEC61850_7_3.CDCServiceTracking::CTS.respAddCause.desc"
                        presCond="M"/>
            <DataAttribute name="d"
                        fc="DC"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.d.desc"
                        presCond="O"/>
            <DataAttribute name="dU"
                        fc="DC"
                        type="Unicode255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dU.desc"
                        presCond="O"/>
            <DataAttribute name="cdcName"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.cdcName.desc"
                        presCond="O"/>
            <DataAttribute name="dataNs"
                        fc="EX"
                        type="VisString255"
                        descID="IEC61850_7_3.CoreAbstractCDCs::BasePrimitiveCDC.dataNs.desc"
                        presCond="MOdataNs"/>
         </CDC>
      </CDCs>
</NS>
`;
const nsd74 = `<?xml version="1.0" encoding="UTF-8"?>
<NS xmlns="http://www.iec.ch/61850/2016/NSD"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xsi:schemaLocation="http://www.iec.ch/61850/2016/NSD NSD.xsd"
    id="IEC 61850-7-4"
    version="2007"
    revision="B"
    release="5"
    umlVersion="WG10built12"
    umlDate="2024-02-14"
    publicationStage="IS"
    appVersion="j61850DocBuilder 02.03 based on jCleanCim noNS beta9.3 (derived from jCleanCim 02-02)"
    namespaceType="basic"
    nsdVersion="2017"
    nsdRevision="B"
    nsdRelease="5">
   <Copyright>
         <Notice>
			COPYRIGHT (c) IEC, www.iec.ch/tc57/supportdocuments. This version of this NSD is part of IEC_61850-7-4:2020 Edition 2.1; see the IEC_61850-7-4:2020 Edition 2.1 for full legal notices. In case of any differences between the here-below code and the IEC published content, the here-below definition supersedes the IEC publication; it may contain updates. See history files. The whole document has to be taken into account to have a full description of this code component.
			See www.iec.ch/CCv1 for copyright details.
			</Notice>
         <License uri="www.iec.ch/CCv1" kind="Standard"/>
      </Copyright>
   <Changes version="2007"
            revision="B"
            tissues="1701, 1766, 1775, 1819, 1821, 1836, 1846, 1856, 1859, 1866, 1883"/>
   <DependsOn id="IEC 61850-7-3"
              version="2007"
              revision="B"
              dependencyType="dependsOn"/>
   <Abbreviations>
         <Abbreviation name="A" descID="IEC61850_7_4.Abbreviations::AbbrTermA.A.desc"/>
         <Abbreviation name="AC" descID="IEC61850_7_4.Abbreviations::AbbrTermA.AC.desc"/>
         <Abbreviation name="AGC" descID="IEC61850_7_4.Abbreviations::AbbrTermA.AGC.desc"/>
         <Abbreviation name="ASG" descID="IEC61850_7_4.Abbreviations::AbbrTermA.ASG.desc"/>
         <Abbreviation name="AWatt" descID="IEC61850_7_4.Abbreviations::AbbrTermA.AWatt.desc"/>
         <Abbreviation name="Abr" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Abr.desc"/>
         <Abbreviation name="Abs" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Abs.desc"/>
         <Abbreviation name="Absb" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Absb.desc"/>
         <Abbreviation name="Acc" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Acc.desc"/>
         <Abbreviation name="Accl" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Accl.desc"/>
         <Abbreviation name="Accm" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Accm.desc"/>
         <Abbreviation name="Ack" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ack.desc"/>
         <Abbreviation name="Acs" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Acs.desc"/>
         <Abbreviation name="Act" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Act.desc"/>
         <Abbreviation name="Actr" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Actr.desc"/>
         <Abbreviation name="Acu" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Acu.desc"/>
         <Abbreviation name="Addr" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Addr.desc"/>
         <Abbreviation name="Adj" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Adj.desc"/>
         <Abbreviation name="Admin" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Admin.desc"/>
         <Abbreviation name="Adp" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Adp.desc"/>
         <Abbreviation name="Aff" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Aff.desc"/>
         <Abbreviation name="Age" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Age.desc"/>
         <Abbreviation name="Ahr" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ahr.desc"/>
         <Abbreviation name="Air" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Air.desc"/>
         <Abbreviation name="Alg" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Alg.desc"/>
         <Abbreviation name="Alm" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Alm.desc"/>
         <Abbreviation name="Als" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Als.desc"/>
         <Abbreviation name="Alt" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Alt.desc"/>
         <Abbreviation name="Altn" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Altn.desc"/>
         <Abbreviation name="Amnt" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Amnt.desc"/>
         <Abbreviation name="Amp" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Amp.desc"/>
         <Abbreviation name="An" descID="IEC61850_7_4.Abbreviations::AbbrTermA.An.desc"/>
         <Abbreviation name="Anc" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Anc.desc"/>
         <Abbreviation name="Ane" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ane.desc"/>
         <Abbreviation name="Ang" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ang.desc"/>
         <Abbreviation name="Ap" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ap.desc"/>
         <Abbreviation name="Apc" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Apc.desc"/>
         <Abbreviation name="App" descID="IEC61850_7_4.Abbreviations::AbbrTermA.App.desc"/>
         <Abbreviation name="Ar" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ar.desc"/>
         <Abbreviation name="Arc" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Arc.desc"/>
         <Abbreviation name="Area" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Area.desc"/>
         <Abbreviation name="Arr" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Arr.desc"/>
         <Abbreviation name="Asyn" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Asyn.desc"/>
         <Abbreviation name="At" descID="IEC61850_7_4.Abbreviations::AbbrTermA.At.desc"/>
         <Abbreviation name="Auth" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Auth.desc"/>
         <Abbreviation name="Auto" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Auto.desc"/>
         <Abbreviation name="Aux" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Aux.desc"/>
         <Abbreviation name="Av" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Av.desc"/>
         <Abbreviation name="Avl" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Avl.desc"/>
         <Abbreviation name="Ax" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Ax.desc"/>
         <Abbreviation name="Azi" descID="IEC61850_7_4.Abbreviations::AbbrTermA.Azi.desc"/>
         <Abbreviation name="B" descID="IEC61850_7_4.Abbreviations::AbbrTermB.B.desc"/>
         <Abbreviation name="BG" descID="IEC61850_7_4.Abbreviations::AbbrTermB.BG.desc"/>
         <Abbreviation name="Bac" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bac.desc"/>
         <Abbreviation name="Bar" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bar.desc"/>
         <Abbreviation name="Base" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Base.desc"/>
         <Abbreviation name="Bat" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bat.desc"/>
         <Abbreviation name="Bck" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bck.desc"/>
         <Abbreviation name="Bec" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bec.desc"/>
         <Abbreviation name="Beh" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Beh.desc"/>
         <Abbreviation name="Ber" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Ber.desc"/>
         <Abbreviation name="Bias" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bias.desc"/>
         <Abbreviation name="Bl" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bl.desc"/>
         <Abbreviation name="Blb" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Blb.desc"/>
         <Abbreviation name="Blk" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Blk.desc"/>
         <Abbreviation name="Blow" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Blow.desc"/>
         <Abbreviation name="Bnd" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bnd.desc"/>
         <Abbreviation name="Boil" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Boil.desc"/>
         <Abbreviation name="Bot" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bot.desc"/>
         <Abbreviation name="Brcb" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Brcb.desc"/>
         <Abbreviation name="Brg" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Brg.desc"/>
         <Abbreviation name="Brk" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Brk.desc"/>
         <Abbreviation name="Bsc" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bsc.desc"/>
         <Abbreviation name="Bst" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bst.desc"/>
         <Abbreviation name="Bt" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bt.desc"/>
         <Abbreviation name="Bub" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bub.desc"/>
         <Abbreviation name="Bus" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Bus.desc"/>
         <Abbreviation name="Byp" descID="IEC61850_7_4.Abbreviations::AbbrTermB.Byp.desc"/>
         <Abbreviation name="C" descID="IEC61850_7_4.Abbreviations::AbbrTermC.C.desc"/>
         <Abbreviation name="C2H2" descID="IEC61850_7_4.Abbreviations::AbbrTermC.C2H2.desc"/>
         <Abbreviation name="C2H4" descID="IEC61850_7_4.Abbreviations::AbbrTermC.C2H4.desc"/>
         <Abbreviation name="C2H6" descID="IEC61850_7_4.Abbreviations::AbbrTermC.C2H6.desc"/>
         <Abbreviation name="CB" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CB.desc"/>
         <Abbreviation name="CE" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CE.desc"/>
         <Abbreviation name="CG" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CG.desc"/>
         <Abbreviation name="CH4" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CH4.desc"/>
         <Abbreviation name="CHP" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CHP.desc"/>
         <Abbreviation name="CO" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CO.desc"/>
         <Abbreviation name="CO2" descID="IEC61850_7_4.Abbreviations::AbbrTermC.CO2.desc"/>
         <Abbreviation name="Cab" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cab.desc"/>
         <Abbreviation name="Cal" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cal.desc"/>
         <Abbreviation name="Cam" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cam.desc"/>
         <Abbreviation name="Can" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Can.desc"/>
         <Abbreviation name="Cap" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cap.desc"/>
         <Abbreviation name="Capac" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Capac.desc"/>
         <Abbreviation name="Car" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Car.desc"/>
         <Abbreviation name="Cbr" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cbr.desc"/>
         <Abbreviation name="Ccw" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Ccw.desc"/>
         <Abbreviation name="Ccy" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Ccy.desc"/>
         <Abbreviation name="Cds" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cds.desc"/>
         <Abbreviation name="Ceil" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Ceil.desc"/>
         <Abbreviation name="Cel" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cel.desc"/>
         <Abbreviation name="Cf" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cf.desc"/>
         <Abbreviation name="Cff" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cff.desc"/>
         <Abbreviation name="Cfg" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cfg.desc"/>
         <Abbreviation name="Cg" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cg.desc"/>
         <Abbreviation name="Ch" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Ch.desc"/>
         <Abbreviation name="Cha" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cha.desc"/>
         <Abbreviation name="Chg" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Chg.desc"/>
         <Abbreviation name="Chk" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Chk.desc"/>
         <Abbreviation name="Chr" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Chr.desc"/>
         <Abbreviation name="Chs" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Chs.desc"/>
         <Abbreviation name="Circ" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Circ.desc"/>
         <Abbreviation name="Cl" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cl.desc"/>
         <Abbreviation name="Clc" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Clc.desc"/>
         <Abbreviation name="Clip" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Clip.desc"/>
         <Abbreviation name="Clk" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Clk.desc"/>
         <Abbreviation name="Cloud" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cloud.desc"/>
         <Abbreviation name="Clr" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Clr.desc"/>
         <Abbreviation name="Cls" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cls.desc"/>
         <Abbreviation name="Cm" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cm.desc"/>
         <Abbreviation name="Cmbu" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cmbu.desc"/>
         <Abbreviation name="Cmd" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cmd.desc"/>
         <Abbreviation name="Cmpl" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cmpl.desc"/>
         <Abbreviation name="Cmut" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cmut.desc"/>
         <Abbreviation name="Cndct" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cndct.desc"/>
         <Abbreviation name="Cnt" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cnt.desc"/>
         <Abbreviation name="Cntt" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cntt.desc"/>
         <Abbreviation name="Cnv" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cnv.desc"/>
         <Abbreviation name="Col" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Col.desc"/>
         <Abbreviation name="Comm" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Comm.desc"/>
         <Abbreviation name="Comp" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Comp.desc"/>
         <Abbreviation name="Conf" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Conf.desc"/>
         <Abbreviation name="ConfRev"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermC.ConfRev.desc"/>
         <Abbreviation name="Conn" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Conn.desc"/>
         <Abbreviation name="Cons" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cons.desc"/>
         <Abbreviation name="Cor" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cor.desc"/>
         <Abbreviation name="Core" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Core.desc"/>
         <Abbreviation name="Cost" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cost.desc"/>
         <Abbreviation name="Crank" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Crank.desc"/>
         <Abbreviation name="Crd" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Crd.desc"/>
         <Abbreviation name="Crit" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Crit.desc"/>
         <Abbreviation name="Crl" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Crl.desc"/>
         <Abbreviation name="Crp" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Crp.desc"/>
         <Abbreviation name="Crv" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Crv.desc"/>
         <Abbreviation name="Csmp" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Csmp.desc"/>
         <Abbreviation name="Ctl" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Ctl.desc"/>
         <Abbreviation name="Ctr" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Ctr.desc"/>
         <Abbreviation name="Cum" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cum.desc"/>
         <Abbreviation name="Cur" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cur.desc"/>
         <Abbreviation name="Cut" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cut.desc"/>
         <Abbreviation name="Cvr" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cvr.desc"/>
         <Abbreviation name="Cw" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cw.desc"/>
         <Abbreviation name="Cwb" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cwb.desc"/>
         <Abbreviation name="Cyc" descID="IEC61850_7_4.Abbreviations::AbbrTermC.Cyc.desc"/>
         <Abbreviation name="D" descID="IEC61850_7_4.Abbreviations::AbbrTermD.D.desc"/>
         <Abbreviation name="DC" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DC.desc"/>
         <Abbreviation name="DER" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DER.desc"/>
         <Abbreviation name="DExt" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DExt.desc"/>
         <Abbreviation name="DPCSO" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DPCSO.desc"/>
         <Abbreviation name="DQ0" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DQ0.desc"/>
         <Abbreviation name="DS" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DS.desc"/>
         <Abbreviation name="DT" descID="IEC61850_7_4.Abbreviations::AbbrTermD.DT.desc"/>
         <Abbreviation name="Dam" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dam.desc"/>
         <Abbreviation name="Damp" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Damp.desc"/>
         <Abbreviation name="Date" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Date.desc"/>
         <Abbreviation name="Day" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Day.desc"/>
         <Abbreviation name="Db" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Db.desc"/>
         <Abbreviation name="Dcl" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dcl.desc"/>
         <Abbreviation name="Dct" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dct.desc"/>
         <Abbreviation name="De" descID="IEC61850_7_4.Abbreviations::AbbrTermD.De.desc"/>
         <Abbreviation name="Dea" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dea.desc"/>
         <Abbreviation name="Dec" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dec.desc"/>
         <Abbreviation name="Deg" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Deg.desc"/>
         <Abbreviation name="Dehum" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dehum.desc"/>
         <Abbreviation name="Del" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Del.desc"/>
         <Abbreviation name="Den" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Den.desc"/>
         <Abbreviation name="Dep" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dep.desc"/>
         <Abbreviation name="Desc" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Desc.desc"/>
         <Abbreviation name="Det" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Det.desc"/>
         <Abbreviation name="Detun" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Detun.desc"/>
         <Abbreviation name="Dev" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dev.desc"/>
         <Abbreviation name="Dew" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dew.desc"/>
         <Abbreviation name="Dff" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dff.desc"/>
         <Abbreviation name="Dfl" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dfl.desc"/>
         <Abbreviation name="Dft" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dft.desc"/>
         <Abbreviation name="Dia" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dia.desc"/>
         <Abbreviation name="Diag" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Diag.desc"/>
         <Abbreviation name="Dif" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dif.desc"/>
         <Abbreviation name="Dig" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dig.desc"/>
         <Abbreviation name="Dip" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dip.desc"/>
         <Abbreviation name="Dir" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dir.desc"/>
         <Abbreviation name="Dis" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dis.desc"/>
         <Abbreviation name="Dist" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dist.desc"/>
         <Abbreviation name="Dith" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dith.desc"/>
         <Abbreviation name="Dl" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dl.desc"/>
         <Abbreviation name="Dlt" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dlt.desc"/>
         <Abbreviation name="Dlv" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dlv.desc"/>
         <Abbreviation name="Dmd" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dmd.desc"/>
         <Abbreviation name="Dn" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dn.desc"/>
         <Abbreviation name="Dpc" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dpc.desc"/>
         <Abbreviation name="Dpt" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dpt.desc"/>
         <Abbreviation name="Drag" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Drag.desc"/>
         <Abbreviation name="Dropout"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dropout.desc"/>
         <Abbreviation name="Drp" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Drp.desc"/>
         <Abbreviation name="Drt" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Drt.desc"/>
         <Abbreviation name="Drtb" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Drtb.desc"/>
         <Abbreviation name="Drv" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Drv.desc"/>
         <Abbreviation name="Dsa" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dsa.desc"/>
         <Abbreviation name="Dsc" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dsc.desc"/>
         <Abbreviation name="Dsch" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dsch.desc"/>
         <Abbreviation name="Dscon" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dscon.desc"/>
         <Abbreviation name="Dsp" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dsp.desc"/>
         <Abbreviation name="Dtc" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dtc.desc"/>
         <Abbreviation name="Dur" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dur.desc"/>
         <Abbreviation name="Dust" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dust.desc"/>
         <Abbreviation name="Dv" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dv.desc"/>
         <Abbreviation name="Dw" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dw.desc"/>
         <Abbreviation name="Dyn" descID="IEC61850_7_4.Abbreviations::AbbrTermD.Dyn.desc"/>
         <Abbreviation name="EE" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EE.desc"/>
         <Abbreviation name="EF" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EF.desc"/>
         <Abbreviation name="EFN" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EFN.desc"/>
         <Abbreviation name="EMA" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EMA.desc"/>
         <Abbreviation name="ENG" descID="IEC61850_7_4.Abbreviations::AbbrTermE.ENG.desc"/>
         <Abbreviation name="ENS" descID="IEC61850_7_4.Abbreviations::AbbrTermE.ENS.desc"/>
         <Abbreviation name="EPC" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EPC.desc"/>
         <Abbreviation name="EV" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EV.desc"/>
         <Abbreviation name="EVSE" descID="IEC61850_7_4.Abbreviations::AbbrTermE.EVSE.desc"/>
         <Abbreviation name="Echo" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Echo.desc"/>
         <Abbreviation name="Ecp" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ecp.desc"/>
         <Abbreviation name="Edt" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Edt.desc"/>
         <Abbreviation name="Efc" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Efc.desc"/>
         <Abbreviation name="El" descID="IEC61850_7_4.Abbreviations::AbbrTermE.El.desc"/>
         <Abbreviation name="Ela" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ela.desc"/>
         <Abbreviation name="Em" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Em.desc"/>
         <Abbreviation name="Emg" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Emg.desc"/>
         <Abbreviation name="En" descID="IEC61850_7_4.Abbreviations::AbbrTermE.En.desc"/>
         <Abbreviation name="Ena" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ena.desc"/>
         <Abbreviation name="Enc" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Enc.desc"/>
         <Abbreviation name="Encl" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Encl.desc"/>
         <Abbreviation name="End" descID="IEC61850_7_4.Abbreviations::AbbrTermE.End.desc"/>
         <Abbreviation name="Eng" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Eng.desc"/>
         <Abbreviation name="Ent" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ent.desc"/>
         <Abbreviation name="Entr" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Entr.desc"/>
         <Abbreviation name="Env" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Env.desc"/>
         <Abbreviation name="Eq" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Eq.desc"/>
         <Abbreviation name="Err" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Err.desc"/>
         <Abbreviation name="Est" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Est.desc"/>
         <Abbreviation name="Ev" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ev.desc"/>
         <Abbreviation name="Evn" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Evn.desc"/>
         <Abbreviation name="Evt" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Evt.desc"/>
         <Abbreviation name="Ex" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ex.desc"/>
         <Abbreviation name="ExIm" descID="IEC61850_7_4.Abbreviations::AbbrTermE.ExIm.desc"/>
         <Abbreviation name="Exc" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Exc.desc"/>
         <Abbreviation name="Excl" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Excl.desc"/>
         <Abbreviation name="Exp" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Exp.desc"/>
         <Abbreviation name="Exps" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Exps.desc"/>
         <Abbreviation name="Expt" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Expt.desc"/>
         <Abbreviation name="Ext" descID="IEC61850_7_4.Abbreviations::AbbrTermE.Ext.desc"/>
         <Abbreviation name="F" descID="IEC61850_7_4.Abbreviations::AbbrTermF.F.desc"/>
         <Abbreviation name="FA" descID="IEC61850_7_4.Abbreviations::AbbrTermF.FA.desc"/>
         <Abbreviation name="FPM" descID="IEC61850_7_4.Abbreviations::AbbrTermF.FPM.desc"/>
         <Abbreviation name="Fa" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fa.desc"/>
         <Abbreviation name="Fact" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fact.desc"/>
         <Abbreviation name="Fail" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fail.desc"/>
         <Abbreviation name="Fan" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fan.desc"/>
         <Abbreviation name="Fbc" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fbc.desc"/>
         <Abbreviation name="Fer" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fer.desc"/>
         <Abbreviation name="Fil" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fil.desc"/>
         <Abbreviation name="Fire" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fire.desc"/>
         <Abbreviation name="Fish" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fish.desc"/>
         <Abbreviation name="Fix" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fix.desc"/>
         <Abbreviation name="Fld" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fld.desc"/>
         <Abbreviation name="Flk" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flk.desc"/>
         <Abbreviation name="Fll" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fll.desc"/>
         <Abbreviation name="Flm" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flm.desc"/>
         <Abbreviation name="Flood" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flood.desc"/>
         <Abbreviation name="Flsh" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flsh.desc"/>
         <Abbreviation name="Flt" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flt.desc"/>
         <Abbreviation name="Flush" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flush.desc"/>
         <Abbreviation name="Flw" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Flw.desc"/>
         <Abbreviation name="Fol" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fol.desc"/>
         <Abbreviation name="Forc" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Forc.desc"/>
         <Abbreviation name="Fu" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fu.desc"/>
         <Abbreviation name="Fuel" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fuel.desc"/>
         <Abbreviation name="Full" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Full.desc"/>
         <Abbreviation name="Fun" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fun.desc"/>
         <Abbreviation name="Fwd" descID="IEC61850_7_4.Abbreviations::AbbrTermF.Fwd.desc"/>
         <Abbreviation name="Gain" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gain.desc"/>
         <Abbreviation name="Gas" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gas.desc"/>
         <Abbreviation name="Gbx" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gbx.desc"/>
         <Abbreviation name="Gdv" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gdv.desc"/>
         <Abbreviation name="Gen" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gen.desc"/>
         <Abbreviation name="Glob" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Glob.desc"/>
         <Abbreviation name="Gm" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gm.desc"/>
         <Abbreviation name="Gn" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gn.desc"/>
         <Abbreviation name="Gnd" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gnd.desc"/>
         <Abbreviation name="GoCBRef"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermG.GoCBRef.desc"/>
         <Abbreviation name="Gocb" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gocb.desc"/>
         <Abbreviation name="Gr" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gr.desc"/>
         <Abbreviation name="Gra" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gra.desc"/>
         <Abbreviation name="Grd" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Grd.desc"/>
         <Abbreviation name="Gri" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gri.desc"/>
         <Abbreviation name="Gross" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gross.desc"/>
         <Abbreviation name="Gs" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gs.desc"/>
         <Abbreviation name="Gte" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gte.desc"/>
         <Abbreviation name="Gust" descID="IEC61850_7_4.Abbreviations::AbbrTermG.Gust.desc"/>
         <Abbreviation name="H" descID="IEC61850_7_4.Abbreviations::AbbrTermH.H.desc"/>
         <Abbreviation name="H2" descID="IEC61850_7_4.Abbreviations::AbbrTermH.H2.desc"/>
         <Abbreviation name="H2O" descID="IEC61850_7_4.Abbreviations::AbbrTermH.H2O.desc"/>
         <Abbreviation name="HP" descID="IEC61850_7_4.Abbreviations::AbbrTermH.HP.desc"/>
         <Abbreviation name="HPh" descID="IEC61850_7_4.Abbreviations::AbbrTermH.HPh.desc"/>
         <Abbreviation name="Ha" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Ha.desc"/>
         <Abbreviation name="Har" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Har.desc"/>
         <Abbreviation name="Hb" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hb.desc"/>
         <Abbreviation name="Hd" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hd.desc"/>
         <Abbreviation name="Health"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermH.Health.desc"/>
         <Abbreviation name="Heat" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Heat.desc"/>
         <Abbreviation name="Hello" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hello.desc"/>
         <Abbreviation name="Hi" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hi.desc"/>
         <Abbreviation name="Hlf" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hlf.desc"/>
         <Abbreviation name="Hold" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hold.desc"/>
         <Abbreviation name="Hor" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hor.desc"/>
         <Abbreviation name="Horn" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Horn.desc"/>
         <Abbreviation name="Ht" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Ht.desc"/>
         <Abbreviation name="Htex" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Htex.desc"/>
         <Abbreviation name="Hub" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hub.desc"/>
         <Abbreviation name="Hum" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hum.desc"/>
         <Abbreviation name="Hy" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hy.desc"/>
         <Abbreviation name="Hyd" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hyd.desc"/>
         <Abbreviation name="Hys" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hys.desc"/>
         <Abbreviation name="Hz" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hz.desc"/>
         <Abbreviation name="Hz1" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hz1.desc"/>
         <Abbreviation name="Hz2" descID="IEC61850_7_4.Abbreviations::AbbrTermH.Hz2.desc"/>
         <Abbreviation name="I" descID="IEC61850_7_4.Abbreviations::AbbrTermI.I.desc"/>
         <Abbreviation name="ING" descID="IEC61850_7_4.Abbreviations::AbbrTermI.ING.desc"/>
         <Abbreviation name="INS" descID="IEC61850_7_4.Abbreviations::AbbrTermI.INS.desc"/>
         <Abbreviation name="ISCSO" descID="IEC61850_7_4.Abbreviations::AbbrTermI.ISCSO.desc"/>
         <Abbreviation name="Ia" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ia.desc"/>
         <Abbreviation name="Iafm" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iafm.desc"/>
         <Abbreviation name="Iano" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iano.desc"/>
         <Abbreviation name="Ianofo"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ianofo.desc"/>
         <Abbreviation name="Ianopca"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ianopca.desc"/>
         <Abbreviation name="Ianos" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ianos.desc"/>
         <Abbreviation name="Ianosm"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ianosm.desc"/>
         <Abbreviation name="Iao" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iao.desc"/>
         <Abbreviation name="Iaog" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaog.desc"/>
         <Abbreviation name="Iaogfp"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaogfp.desc"/>
         <Abbreviation name="Iaogpp"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaogpp.desc"/>
         <Abbreviation name="Iaong" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaong.desc"/>
         <Abbreviation name="Iaongel"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaongel.desc"/>
         <Abbreviation name="Iaongen"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaongen.desc"/>
         <Abbreviation name="Iaongrs"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaongrs.desc"/>
         <Abbreviation name="Iaongts"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iaongts.desc"/>
         <Abbreviation name="Ice" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ice.desc"/>
         <Abbreviation name="Id" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Id.desc"/>
         <Abbreviation name="Ieee" descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.Ieee.desc"/>
         <Abbreviation name="IeeeKH"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKH.desc"/>
         <Abbreviation name="IeeeKH1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKH1.desc"/>
         <Abbreviation name="IeeeKH11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKH11.desc"/>
         <Abbreviation name="IeeeKH17"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKH17.desc"/>
         <Abbreviation name="IeeeKH2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKH2.desc"/>
         <Abbreviation name="IeeeKI"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKI.desc"/>
         <Abbreviation name="IeeeKI1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKI1.desc"/>
         <Abbreviation name="IeeeKI11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKI11.desc"/>
         <Abbreviation name="IeeeKI17"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKI17.desc"/>
         <Abbreviation name="IeeeKI2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKI2.desc"/>
         <Abbreviation name="IeeeKL"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKL.desc"/>
         <Abbreviation name="IeeeKL1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKL1.desc"/>
         <Abbreviation name="IeeeKL11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKL11.desc"/>
         <Abbreviation name="IeeeKL17"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKL17.desc"/>
         <Abbreviation name="IeeeKL2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKL2.desc"/>
         <Abbreviation name="IeeeKs1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKs1.desc"/>
         <Abbreviation name="IeeeKs2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKs2.desc"/>
         <Abbreviation name="IeeeKs3"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeKs3.desc"/>
         <Abbreviation name="IeeeM"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeM.desc"/>
         <Abbreviation name="IeeeN"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeN.desc"/>
         <Abbreviation name="IeeeT1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT1.desc"/>
         <Abbreviation name="IeeeT10"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT10.desc"/>
         <Abbreviation name="IeeeT11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT11.desc"/>
         <Abbreviation name="IeeeT2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT2.desc"/>
         <Abbreviation name="IeeeT3"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT3.desc"/>
         <Abbreviation name="IeeeT4"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT4.desc"/>
         <Abbreviation name="IeeeT7"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT7.desc"/>
         <Abbreviation name="IeeeT8"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT8.desc"/>
         <Abbreviation name="IeeeT9"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeT9.desc"/>
         <Abbreviation name="IeeeTH1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH1.desc"/>
         <Abbreviation name="IeeeTH10"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH10.desc"/>
         <Abbreviation name="IeeeTH11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH11.desc"/>
         <Abbreviation name="IeeeTH12"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH12.desc"/>
         <Abbreviation name="IeeeTH2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH2.desc"/>
         <Abbreviation name="IeeeTH3"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH3.desc"/>
         <Abbreviation name="IeeeTH4"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH4.desc"/>
         <Abbreviation name="IeeeTH5"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH5.desc"/>
         <Abbreviation name="IeeeTH6"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH6.desc"/>
         <Abbreviation name="IeeeTH7"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH7.desc"/>
         <Abbreviation name="IeeeTH8"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH8.desc"/>
         <Abbreviation name="IeeeTH9"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTH9.desc"/>
         <Abbreviation name="IeeeTI1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI1.desc"/>
         <Abbreviation name="IeeeTI10"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI10.desc"/>
         <Abbreviation name="IeeeTI11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI11.desc"/>
         <Abbreviation name="IeeeTI12"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI12.desc"/>
         <Abbreviation name="IeeeTI2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI2.desc"/>
         <Abbreviation name="IeeeTI3"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI3.desc"/>
         <Abbreviation name="IeeeTI4"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI4.desc"/>
         <Abbreviation name="IeeeTI5"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI5.desc"/>
         <Abbreviation name="IeeeTI6"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI6.desc"/>
         <Abbreviation name="IeeeTI7"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI7.desc"/>
         <Abbreviation name="IeeeTI8"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI8.desc"/>
         <Abbreviation name="IeeeTI9"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTI9.desc"/>
         <Abbreviation name="IeeeTL1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL1.desc"/>
         <Abbreviation name="IeeeTL10"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL10.desc"/>
         <Abbreviation name="IeeeTL11"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL11.desc"/>
         <Abbreviation name="IeeeTL12"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL12.desc"/>
         <Abbreviation name="IeeeTL2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL2.desc"/>
         <Abbreviation name="IeeeTL3"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL3.desc"/>
         <Abbreviation name="IeeeTL4"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL4.desc"/>
         <Abbreviation name="IeeeTL5"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL5.desc"/>
         <Abbreviation name="IeeeTL6"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL6.desc"/>
         <Abbreviation name="IeeeTL7"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL7.desc"/>
         <Abbreviation name="IeeeTL8"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL8.desc"/>
         <Abbreviation name="IeeeTL9"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTL9.desc"/>
         <Abbreviation name="IeeeTw1"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTw1.desc"/>
         <Abbreviation name="IeeeTw2"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTw2.desc"/>
         <Abbreviation name="IeeeTw3"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTw3.desc"/>
         <Abbreviation name="IeeeTw4"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeTw4.desc"/>
         <Abbreviation name="IeeeVHMax"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVHMax.desc"/>
         <Abbreviation name="IeeeVHMin"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVHMin.desc"/>
         <Abbreviation name="IeeeVIMax"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVIMax.desc"/>
         <Abbreviation name="IeeeVIMin"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVIMin.desc"/>
         <Abbreviation name="IeeeVLMax"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVLMax.desc"/>
         <Abbreviation name="IeeeVLMin"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVLMin.desc"/>
         <Abbreviation name="IeeeVsi1Max"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVsi1Max.desc"/>
         <Abbreviation name="IeeeVsi1Min"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVsi1Min.desc"/>
         <Abbreviation name="IeeeVsi2Max"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVsi2Max.desc"/>
         <Abbreviation name="IeeeVsi2Min"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVsi2Min.desc"/>
         <Abbreviation name="IeeeVstMax"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVstMax.desc"/>
         <Abbreviation name="IeeeVstMin"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermIeee.IeeeVstMin.desc"/>
         <Abbreviation name="Imb" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Imb.desc"/>
         <Abbreviation name="Imp" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Imp.desc"/>
         <Abbreviation name="Impact"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermI.Impact.desc"/>
         <Abbreviation name="Impt" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Impt.desc"/>
         <Abbreviation name="In" descID="IEC61850_7_4.Abbreviations::AbbrTermI.In.desc"/>
         <Abbreviation name="Ina" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ina.desc"/>
         <Abbreviation name="Inc" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inc.desc"/>
         <Abbreviation name="Incl" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Incl.desc"/>
         <Abbreviation name="Incr" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Incr.desc"/>
         <Abbreviation name="Ind" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ind.desc"/>
         <Abbreviation name="Indp" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Indp.desc"/>
         <Abbreviation name="Iner" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iner.desc"/>
         <Abbreviation name="Inh" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inh.desc"/>
         <Abbreviation name="Inl" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inl.desc"/>
         <Abbreviation name="Inlet" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inlet.desc"/>
         <Abbreviation name="Inn" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inn.desc"/>
         <Abbreviation name="Ins" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ins.desc"/>
         <Abbreviation name="Insol" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Insol.desc"/>
         <Abbreviation name="Inst" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inst.desc"/>
         <Abbreviation name="Int" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Int.desc"/>
         <Abbreviation name="Intm" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Intm.desc"/>
         <Abbreviation name="Intn" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Intn.desc"/>
         <Abbreviation name="Intr" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Intr.desc"/>
         <Abbreviation name="Intv" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Intv.desc"/>
         <Abbreviation name="Inv" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Inv.desc"/>
         <Abbreviation name="Isc" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Isc.desc"/>
         <Abbreviation name="Isld" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Isld.desc"/>
         <Abbreviation name="Iso" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iso.desc"/>
         <Abbreviation name="Iu" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Iu.desc"/>
         <Abbreviation name="Ix" descID="IEC61850_7_4.Abbreviations::AbbrTermI.Ix.desc"/>
         <Abbreviation name="Jmp" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.Jmp.desc"/>
         <Abbreviation name="Jnt" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.Jnt.desc"/>
         <Abbreviation name="K" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.K.desc"/>
         <Abbreviation name="K0Fact"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermJK.K0Fact.desc"/>
         <Abbreviation name="KFact" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.KFact.desc"/>
         <Abbreviation name="Kck" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.Kck.desc"/>
         <Abbreviation name="Key" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.Key.desc"/>
         <Abbreviation name="L" descID="IEC61850_7_4.Abbreviations::AbbrTermL.L.desc"/>
         <Abbreviation name="LDC" descID="IEC61850_7_4.Abbreviations::AbbrTermL.LDC.desc"/>
         <Abbreviation name="LDCR" descID="IEC61850_7_4.Abbreviations::AbbrTermL.LDCR.desc"/>
         <Abbreviation name="LDCX" descID="IEC61850_7_4.Abbreviations::AbbrTermL.LDCX.desc"/>
         <Abbreviation name="LDCZ" descID="IEC61850_7_4.Abbreviations::AbbrTermL.LDCZ.desc"/>
         <Abbreviation name="LED" descID="IEC61850_7_4.Abbreviations::AbbrTermL.LED.desc"/>
         <Abbreviation name="LTC" descID="IEC61850_7_4.Abbreviations::AbbrTermL.LTC.desc"/>
         <Abbreviation name="Last" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Last.desc"/>
         <Abbreviation name="Ld" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Ld.desc"/>
         <Abbreviation name="Ldp" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Ldp.desc"/>
         <Abbreviation name="Leap" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Leap.desc"/>
         <Abbreviation name="Len" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Len.desc"/>
         <Abbreviation name="Lev" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lev.desc"/>
         <Abbreviation name="Lft" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lft.desc"/>
         <Abbreviation name="Lg" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lg.desc"/>
         <Abbreviation name="Life" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Life.desc"/>
         <Abbreviation name="Lim" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lim.desc"/>
         <Abbreviation name="Lin" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lin.desc"/>
         <Abbreviation name="Liv" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Liv.desc"/>
         <Abbreviation name="Lkd" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lkd.desc"/>
         <Abbreviation name="Lkg" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lkg.desc"/>
         <Abbreviation name="Ll" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Ll.desc"/>
         <Abbreviation name="Lo" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lo.desc"/>
         <Abbreviation name="Loc" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Loc.desc"/>
         <Abbreviation name="Locb" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Locb.desc"/>
         <Abbreviation name="Lod" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lod.desc"/>
         <Abbreviation name="Log" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Log.desc"/>
         <Abbreviation name="Lok" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lok.desc"/>
         <Abbreviation name="Loop" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Loop.desc"/>
         <Abbreviation name="Los" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Los.desc"/>
         <Abbreviation name="Ls" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Ls.desc"/>
         <Abbreviation name="Lst" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lst.desc"/>
         <Abbreviation name="Lub" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lub.desc"/>
         <Abbreviation name="Lum" descID="IEC61850_7_4.Abbreviations::AbbrTermL.Lum.desc"/>
         <Abbreviation name="M" descID="IEC61850_7_4.Abbreviations::AbbrTermM.M.desc"/>
         <Abbreviation name="MV" descID="IEC61850_7_4.Abbreviations::AbbrTermM.MV.desc"/>
         <Abbreviation name="Mac" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mac.desc"/>
         <Abbreviation name="Made" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Made.desc"/>
         <Abbreviation name="Mag" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mag.desc"/>
         <Abbreviation name="Maint" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Maint.desc"/>
         <Abbreviation name="Man" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Man.desc"/>
         <Abbreviation name="Mat" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mat.desc"/>
         <Abbreviation name="Mau" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mau.desc"/>
         <Abbreviation name="Max" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Max.desc"/>
         <Abbreviation name="Mbr" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mbr.desc"/>
         <Abbreviation name="Md" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Md.desc"/>
         <Abbreviation name="Mdul" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mdul.desc"/>
         <Abbreviation name="Meas" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Meas.desc"/>
         <Abbreviation name="Mech" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mech.desc"/>
         <Abbreviation name="Media" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Media.desc"/>
         <Abbreviation name="Mem" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mem.desc"/>
         <Abbreviation name="Min" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Min.desc"/>
         <Abbreviation name="Mir" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mir.desc"/>
         <Abbreviation name="Mlt" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mlt.desc"/>
         <Abbreviation name="Mns" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mns.desc"/>
         <Abbreviation name="Mod" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mod.desc"/>
         <Abbreviation name="Mot" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mot.desc"/>
         <Abbreviation name="Mrg" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mrg.desc"/>
         <Abbreviation name="Mrk" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mrk.desc"/>
         <Abbreviation name="Mst" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mst.desc"/>
         <Abbreviation name="Msv" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Msv.desc"/>
         <Abbreviation name="Msvcb" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Msvcb.desc"/>
         <Abbreviation name="Mth" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mth.desc"/>
         <Abbreviation name="Mult" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mult.desc"/>
         <Abbreviation name="Mvm" descID="IEC61850_7_4.Abbreviations::AbbrTermM.Mvm.desc"/>
         <Abbreviation name="N2" descID="IEC61850_7_4.Abbreviations::AbbrTermN.N2.desc"/>
         <Abbreviation name="NOx" descID="IEC61850_7_4.Abbreviations::AbbrTermN.NOx.desc"/>
         <Abbreviation name="NQS" descID="IEC61850_7_4.Abbreviations::AbbrTermN.NQS.desc"/>
         <Abbreviation name="Nam" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Nam.desc"/>
         <Abbreviation name="Name" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Name.desc"/>
         <Abbreviation name="Ndl" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Ndl.desc"/>
         <Abbreviation name="NdsCom"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermN.NdsCom.desc"/>
         <Abbreviation name="Neut" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Neut.desc"/>
         <Abbreviation name="Ng" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Ng.desc"/>
         <Abbreviation name="Ngt" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Ngt.desc"/>
         <Abbreviation name="Nhd" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Nhd.desc"/>
         <Abbreviation name="Night" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Night.desc"/>
         <Abbreviation name="No" descID="IEC61850_7_4.Abbreviations::AbbrTermN.No.desc"/>
         <Abbreviation name="Nom" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Nom.desc"/>
         <Abbreviation name="Num" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Num.desc"/>
         <Abbreviation name="Nxt" descID="IEC61850_7_4.Abbreviations::AbbrTermN.Nxt.desc"/>
         <Abbreviation name="O2" descID="IEC61850_7_4.Abbreviations::AbbrTermO.O2.desc"/>
         <Abbreviation name="O3" descID="IEC61850_7_4.Abbreviations::AbbrTermO.O3.desc"/>
         <Abbreviation name="Obl" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Obl.desc"/>
         <Abbreviation name="Oc" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Oc.desc"/>
         <Abbreviation name="Odd" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Odd.desc"/>
         <Abbreviation name="Of" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Of.desc"/>
         <Abbreviation name="Off" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Off.desc"/>
         <Abbreviation name="Ofs" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Ofs.desc"/>
         <Abbreviation name="Oil" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Oil.desc"/>
         <Abbreviation name="On" descID="IEC61850_7_4.Abbreviations::AbbrTermO.On.desc"/>
         <Abbreviation name="Oo" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Oo.desc"/>
         <Abbreviation name="Op" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Op.desc"/>
         <Abbreviation name="Operate"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermO.Operate.desc"/>
         <Abbreviation name="Opn" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Opn.desc"/>
         <Abbreviation name="Ord" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Ord.desc"/>
         <Abbreviation name="Out" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Out.desc"/>
         <Abbreviation name="Ov" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Ov.desc"/>
         <Abbreviation name="Ovl" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Ovl.desc"/>
         <Abbreviation name="Ox" descID="IEC61850_7_4.Abbreviations::AbbrTermO.Ox.desc"/>
         <Abbreviation name="P" descID="IEC61850_7_4.Abbreviations::AbbrTermP.P.desc"/>
         <Abbreviation name="PF" descID="IEC61850_7_4.Abbreviations::AbbrTermP.PF.desc"/>
         <Abbreviation name="PH" descID="IEC61850_7_4.Abbreviations::AbbrTermP.PH.desc"/>
         <Abbreviation name="PNV" descID="IEC61850_7_4.Abbreviations::AbbrTermP.PNV.desc"/>
         <Abbreviation name="POW" descID="IEC61850_7_4.Abbreviations::AbbrTermP.POW.desc"/>
         <Abbreviation name="PP" descID="IEC61850_7_4.Abbreviations::AbbrTermP.PP.desc"/>
         <Abbreviation name="PPV" descID="IEC61850_7_4.Abbreviations::AbbrTermP.PPV.desc"/>
         <Abbreviation name="PT1" descID="IEC61850_7_4.Abbreviations::AbbrTermP.PT1.desc"/>
         <Abbreviation name="Pa" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pa.desc"/>
         <Abbreviation name="Pair" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pair.desc"/>
         <Abbreviation name="Pap" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pap.desc"/>
         <Abbreviation name="Par" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Par.desc"/>
         <Abbreviation name="Pas" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pas.desc"/>
         <Abbreviation name="Path" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Path.desc"/>
         <Abbreviation name="Pcb" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pcb.desc"/>
         <Abbreviation name="Pct" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pct.desc"/>
         <Abbreviation name="Pdm" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pdm.desc"/>
         <Abbreviation name="Pe" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pe.desc"/>
         <Abbreviation name="Per" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Per.desc"/>
         <Abbreviation name="Ph" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Ph.desc"/>
         <Abbreviation name="Phs" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Phs.desc"/>
         <Abbreviation name="Phy" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Phy.desc"/>
         <Abbreviation name="Pi" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pi.desc"/>
         <Abbreviation name="Pin" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pin.desc"/>
         <Abbreviation name="Pipe" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pipe.desc"/>
         <Abbreviation name="Pk" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pk.desc"/>
         <Abbreviation name="Pl" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pl.desc"/>
         <Abbreviation name="Plg" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Plg.desc"/>
         <Abbreviation name="Pls" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pls.desc"/>
         <Abbreviation name="Plt" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Plt.desc"/>
         <Abbreviation name="Pmp" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pmp.desc"/>
         <Abbreviation name="Po" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Po.desc"/>
         <Abbreviation name="Pol" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pol.desc"/>
         <Abbreviation name="Polytr"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermP.Polytr.desc"/>
         <Abbreviation name="Port" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Port.desc"/>
         <Abbreviation name="Pos" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pos.desc"/>
         <Abbreviation name="Pot" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pot.desc"/>
         <Abbreviation name="Prc" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prc.desc"/>
         <Abbreviation name="Pre" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pre.desc"/>
         <Abbreviation name="Prec" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prec.desc"/>
         <Abbreviation name="Pres" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pres.desc"/>
         <Abbreviation name="Prg" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prg.desc"/>
         <Abbreviation name="Prim" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prim.desc"/>
         <Abbreviation name="Prio" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prio.desc"/>
         <Abbreviation name="Prm" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prm.desc"/>
         <Abbreviation name="Pro" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pro.desc"/>
         <Abbreviation name="Proc" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Proc.desc"/>
         <Abbreviation name="Proxy" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Proxy.desc"/>
         <Abbreviation name="Prs" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prs.desc"/>
         <Abbreviation name="Prt" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Prt.desc"/>
         <Abbreviation name="Ps" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Ps.desc"/>
         <Abbreviation name="Psk" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Psk.desc"/>
         <Abbreviation name="Pss" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pss.desc"/>
         <Abbreviation name="Pst" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pst.desc"/>
         <Abbreviation name="Pt" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pt.desc"/>
         <Abbreviation name="Pth" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pth.desc"/>
         <Abbreviation name="Pwr" descID="IEC61850_7_4.Abbreviations::AbbrTermP.Pwr.desc"/>
         <Abbreviation name="Qty" descID="IEC61850_7_4.Abbreviations::AbbrTermQ.Qty.desc"/>
         <Abbreviation name="Qu" descID="IEC61850_7_4.Abbreviations::AbbrTermQ.Qu.desc"/>
         <Abbreviation name="Qud" descID="IEC61850_7_4.Abbreviations::AbbrTermQ.Qud.desc"/>
         <Abbreviation name="R" descID="IEC61850_7_4.Abbreviations::AbbrTermR.R.desc"/>
         <Abbreviation name="Rad" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rad.desc"/>
         <Abbreviation name="Ral" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Ral.desc"/>
         <Abbreviation name="Ramp" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Ramp.desc"/>
         <Abbreviation name="Rat" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rat.desc"/>
         <Abbreviation name="Rb" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rb.desc"/>
         <Abbreviation name="Rcd" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rcd.desc"/>
         <Abbreviation name="Rch" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rch.desc"/>
         <Abbreviation name="Rcl" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rcl.desc"/>
         <Abbreviation name="Rct" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rct.desc"/>
         <Abbreviation name="Rdy" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rdy.desc"/>
         <Abbreviation name="Re" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Re.desc"/>
         <Abbreviation name="React" descID="IEC61850_7_4.Abbreviations::AbbrTermR.React.desc"/>
         <Abbreviation name="Rec" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rec.desc"/>
         <Abbreviation name="Rec1" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rec1.desc"/>
         <Abbreviation name="Rec13" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rec13.desc"/>
         <Abbreviation name="Rec3" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rec3.desc"/>
         <Abbreviation name="Recha" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Recha.desc"/>
         <Abbreviation name="Rect" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rect.desc"/>
         <Abbreviation name="Red" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Red.desc"/>
         <Abbreviation name="Ref" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Ref.desc"/>
         <Abbreviation name="Reg" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Reg.desc"/>
         <Abbreviation name="Rel" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rel.desc"/>
         <Abbreviation name="Req" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Req.desc"/>
         <Abbreviation name="Res" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Res.desc"/>
         <Abbreviation name="Reso" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Reso.desc"/>
         <Abbreviation name="Reuse" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Reuse.desc"/>
         <Abbreviation name="Rev" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rev.desc"/>
         <Abbreviation name="Rf" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rf.desc"/>
         <Abbreviation name="Rin" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rin.desc"/>
         <Abbreviation name="Ris" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Ris.desc"/>
         <Abbreviation name="Rl" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rl.desc"/>
         <Abbreviation name="Rm" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rm.desc"/>
         <Abbreviation name="Rmp" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rmp.desc"/>
         <Abbreviation name="Rms" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rms.desc"/>
         <Abbreviation name="Rn" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rn.desc"/>
         <Abbreviation name="Rnbk" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rnbk.desc"/>
         <Abbreviation name="Rng" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rng.desc"/>
         <Abbreviation name="Rod" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rod.desc"/>
         <Abbreviation name="Root" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Root.desc"/>
         <Abbreviation name="Rot" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rot.desc"/>
         <Abbreviation name="Rpt" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rpt.desc"/>
         <Abbreviation name="Rs" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rs.desc"/>
         <Abbreviation name="Rsl" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rsl.desc"/>
         <Abbreviation name="Rst" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rst.desc"/>
         <Abbreviation name="Rsv" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rsv.desc"/>
         <Abbreviation name="Rt" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rt.desc"/>
         <Abbreviation name="Rte" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rte.desc"/>
         <Abbreviation name="Rtg" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rtg.desc"/>
         <Abbreviation name="Rub" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rub.desc"/>
         <Abbreviation name="Run" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Run.desc"/>
         <Abbreviation name="Rv" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rv.desc"/>
         <Abbreviation name="Rvc" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rvc.desc"/>
         <Abbreviation name="Rvrt" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rvrt.desc"/>
         <Abbreviation name="Rwy" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rwy.desc"/>
         <Abbreviation name="Rx" descID="IEC61850_7_4.Abbreviations::AbbrTermR.Rx.desc"/>
         <Abbreviation name="S10" descID="IEC61850_7_4.Abbreviations::AbbrTermS.S10.desc"/>
         <Abbreviation name="S12" descID="IEC61850_7_4.Abbreviations::AbbrTermS.S12.desc"/>
         <Abbreviation name="SM" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SM.desc"/>
         <Abbreviation name="SNL" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SNL.desc"/>
         <Abbreviation name="SOx" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SOx.desc"/>
         <Abbreviation name="SPCSO" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SPCSO.desc"/>
         <Abbreviation name="SPG" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SPG.desc"/>
         <Abbreviation name="SPS" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SPS.desc"/>
         <Abbreviation name="SPl" descID="IEC61850_7_4.Abbreviations::AbbrTermS.SPl.desc"/>
         <Abbreviation name="ST" descID="IEC61850_7_4.Abbreviations::AbbrTermS.ST.desc"/>
         <Abbreviation name="Saf" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Saf.desc"/>
         <Abbreviation name="Sag" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sag.desc"/>
         <Abbreviation name="Sar" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sar.desc"/>
         <Abbreviation name="Sat" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sat.desc"/>
         <Abbreviation name="Sc" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sc.desc"/>
         <Abbreviation name="Scale" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Scale.desc"/>
         <Abbreviation name="Schd" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Schd.desc"/>
         <Abbreviation name="Scnd" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Scnd.desc"/>
         <Abbreviation name="Sco" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sco.desc"/>
         <Abbreviation name="Sec" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sec.desc"/>
         <Abbreviation name="Sel" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sel.desc"/>
         <Abbreviation name="Self" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Self.desc"/>
         <Abbreviation name="Seq" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Seq.desc"/>
         <Abbreviation name="Ser" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Ser.desc"/>
         <Abbreviation name="Set" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Set.desc"/>
         <Abbreviation name="Sgcb" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sgcb.desc"/>
         <Abbreviation name="Sh" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sh.desc"/>
         <Abbreviation name="Shar" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Shar.desc"/>
         <Abbreviation name="Shft" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Shft.desc"/>
         <Abbreviation name="Shld" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Shld.desc"/>
         <Abbreviation name="Sig" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sig.desc"/>
         <Abbreviation name="Sign" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sign.desc"/>
         <Abbreviation name="Sim" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sim.desc"/>
         <Abbreviation name="Sld" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sld.desc"/>
         <Abbreviation name="Slnt" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Slnt.desc"/>
         <Abbreviation name="Slp" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Slp.desc"/>
         <Abbreviation name="Smok" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Smok.desc"/>
         <Abbreviation name="Smp" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Smp.desc"/>
         <Abbreviation name="Snd" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Snd.desc"/>
         <Abbreviation name="Snpt" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Snpt.desc"/>
         <Abbreviation name="Snr" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Snr.desc"/>
         <Abbreviation name="Snw" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Snw.desc"/>
         <Abbreviation name="Soc" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Soc.desc"/>
         <Abbreviation name="Sof" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sof.desc"/>
         <Abbreviation name="Spc" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Spc.desc"/>
         <Abbreviation name="Spcf" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Spcf.desc"/>
         <Abbreviation name="Spd" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Spd.desc"/>
         <Abbreviation name="Spec" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Spec.desc"/>
         <Abbreviation name="Spir" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Spir.desc"/>
         <Abbreviation name="Spt" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Spt.desc"/>
         <Abbreviation name="Sq" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sq.desc"/>
         <Abbreviation name="Src" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Src.desc"/>
         <Abbreviation name="Srfc" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Srfc.desc"/>
         <Abbreviation name="St" descID="IEC61850_7_4.Abbreviations::AbbrTermS.St.desc"/>
         <Abbreviation name="Sta" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sta.desc"/>
         <Abbreviation name="Stab" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stab.desc"/>
         <Abbreviation name="Stat" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stat.desc"/>
         <Abbreviation name="Stc" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stc.desc"/>
         <Abbreviation name="Std" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Std.desc"/>
         <Abbreviation name="Stdby" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stdby.desc"/>
         <Abbreviation name="Step" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Step.desc"/>
         <Abbreviation name="Stk" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stk.desc"/>
         <Abbreviation name="Stl" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stl.desc"/>
         <Abbreviation name="Stnd" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stnd.desc"/>
         <Abbreviation name="Sto" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sto.desc"/>
         <Abbreviation name="Stop" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stop.desc"/>
         <Abbreviation name="Storm" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Storm.desc"/>
         <Abbreviation name="Stow" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stow.desc"/>
         <Abbreviation name="Str" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Str.desc"/>
         <Abbreviation name="Strg" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Strg.desc"/>
         <Abbreviation name="Stt" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stt.desc"/>
         <Abbreviation name="Stuck" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Stuck.desc"/>
         <Abbreviation name="Sub" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sub.desc"/>
         <Abbreviation name="Sum" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sum.desc"/>
         <Abbreviation name="Sup" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sup.desc"/>
         <Abbreviation name="Sv" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sv.desc"/>
         <Abbreviation name="SvCBRef"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermS.SvCBRef.desc"/>
         <Abbreviation name="Svc" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Svc.desc"/>
         <Abbreviation name="Sw" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sw.desc"/>
         <Abbreviation name="Swg" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Swg.desc"/>
         <Abbreviation name="Swl" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Swl.desc"/>
         <Abbreviation name="Syn" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Syn.desc"/>
         <Abbreviation name="Sys" descID="IEC61850_7_4.Abbreviations::AbbrTermS.Sys.desc"/>
         <Abbreviation name="TP" descID="IEC61850_7_4.Abbreviations::AbbrTermT.TP.desc"/>
         <Abbreviation name="Ta" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Ta.desc"/>
         <Abbreviation name="Tag" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tag.desc"/>
         <Abbreviation name="Tap" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tap.desc"/>
         <Abbreviation name="Task" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Task.desc"/>
         <Abbreviation name="Td" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Td.desc"/>
         <Abbreviation name="Td0p" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Td0p.desc"/>
         <Abbreviation name="Td0s" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Td0s.desc"/>
         <Abbreviation name="Tdd" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tdd.desc"/>
         <Abbreviation name="Tdf" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tdf.desc"/>
         <Abbreviation name="Tdp" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tdp.desc"/>
         <Abbreviation name="Tds" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tds.desc"/>
         <Abbreviation name="Tech" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tech.desc"/>
         <Abbreviation name="Term" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Term.desc"/>
         <Abbreviation name="Test" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Test.desc"/>
         <Abbreviation name="Tgt" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tgt.desc"/>
         <Abbreviation name="Thd" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Thd.desc"/>
         <Abbreviation name="Thm" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Thm.desc"/>
         <Abbreviation name="Ti" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Ti.desc"/>
         <Abbreviation name="Tilt" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tilt.desc"/>
         <Abbreviation name="Tm" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tm.desc"/>
         <Abbreviation name="Tm1" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tm1.desc"/>
         <Abbreviation name="Tm2" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tm2.desc"/>
         <Abbreviation name="Tm3" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tm3.desc"/>
         <Abbreviation name="Tmh" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tmh.desc"/>
         <Abbreviation name="Tmm" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tmm.desc"/>
         <Abbreviation name="Tmms" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tmms.desc"/>
         <Abbreviation name="Tmp" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tmp.desc"/>
         <Abbreviation name="Tms" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tms.desc"/>
         <Abbreviation name="Tnk" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tnk.desc"/>
         <Abbreviation name="Tns" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tns.desc"/>
         <Abbreviation name="Top" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Top.desc"/>
         <Abbreviation name="Topo" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Topo.desc"/>
         <Abbreviation name="Torq" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Torq.desc"/>
         <Abbreviation name="Tot" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tot.desc"/>
         <Abbreviation name="Tow" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tow.desc"/>
         <Abbreviation name="Tp" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tp.desc"/>
         <Abbreviation name="Tpc" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tpc.desc"/>
         <Abbreviation name="Tpy" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tpy.desc"/>
         <Abbreviation name="Tq0p" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tq0p.desc"/>
         <Abbreviation name="Tq0s" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tq0s.desc"/>
         <Abbreviation name="Tqp" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tqp.desc"/>
         <Abbreviation name="Tqs" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tqs.desc"/>
         <Abbreviation name="Tr" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tr.desc"/>
         <Abbreviation name="Trf" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trf.desc"/>
         <Abbreviation name="Trg" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trg.desc"/>
         <Abbreviation name="Trip" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trip.desc"/>
         <Abbreviation name="Trk" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trk.desc"/>
         <Abbreviation name="Trp" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trp.desc"/>
         <Abbreviation name="Trs" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trs.desc"/>
         <Abbreviation name="Trunk" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Trunk.desc"/>
         <Abbreviation name="Ts" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Ts.desc"/>
         <Abbreviation name="Tu" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tu.desc"/>
         <Abbreviation name="Tun" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tun.desc"/>
         <Abbreviation name="Tur" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tur.desc"/>
         <Abbreviation name="Tx" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Tx.desc"/>
         <Abbreviation name="Typ" descID="IEC61850_7_4.Abbreviations::AbbrTermT.Typ.desc"/>
         <Abbreviation name="UPS" descID="IEC61850_7_4.Abbreviations::AbbrTermU.UPS.desc"/>
         <Abbreviation name="UTC" descID="IEC61850_7_4.Abbreviations::AbbrTermU.UTC.desc"/>
         <Abbreviation name="Udp" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Udp.desc"/>
         <Abbreviation name="Uhf" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Uhf.desc"/>
         <Abbreviation name="Un" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Un.desc"/>
         <Abbreviation name="Unav" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Unav.desc"/>
         <Abbreviation name="Unb" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Unb.desc"/>
         <Abbreviation name="Unld" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Unld.desc"/>
         <Abbreviation name="Unt" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Unt.desc"/>
         <Abbreviation name="Up" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Up.desc"/>
         <Abbreviation name="Ups" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Ups.desc"/>
         <Abbreviation name="Urcb" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Urcb.desc"/>
         <Abbreviation name="Use" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Use.desc"/>
         <Abbreviation name="Used" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Used.desc"/>
         <Abbreviation name="Usvcb" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Usvcb.desc"/>
         <Abbreviation name="Util" descID="IEC61850_7_4.Abbreviations::AbbrTermU.Util.desc"/>
         <Abbreviation name="V" descID="IEC61850_7_4.Abbreviations::AbbrTermV.V.desc"/>
         <Abbreviation name="V1" descID="IEC61850_7_4.Abbreviations::AbbrTermV.V1.desc"/>
         <Abbreviation name="V2" descID="IEC61850_7_4.Abbreviations::AbbrTermV.V2.desc"/>
         <Abbreviation name="VA" descID="IEC61850_7_4.Abbreviations::AbbrTermV.VA.desc"/>
         <Abbreviation name="VAh" descID="IEC61850_7_4.Abbreviations::AbbrTermV.VAh.desc"/>
         <Abbreviation name="VAr" descID="IEC61850_7_4.Abbreviations::AbbrTermV.VAr.desc"/>
         <Abbreviation name="VArh" descID="IEC61850_7_4.Abbreviations::AbbrTermV.VArh.desc"/>
         <Abbreviation name="Va" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Va.desc"/>
         <Abbreviation name="Vac" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vac.desc"/>
         <Abbreviation name="Val" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Val.desc"/>
         <Abbreviation name="Vbr" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vbr.desc"/>
         <Abbreviation name="Ver" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Ver.desc"/>
         <Abbreviation name="Viol" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Viol.desc"/>
         <Abbreviation name="Vis" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vis.desc"/>
         <Abbreviation name="Visc" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Visc.desc"/>
         <Abbreviation name="Vlan" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vlan.desc"/>
         <Abbreviation name="Vld" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vld.desc"/>
         <Abbreviation name="Vlm" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vlm.desc"/>
         <Abbreviation name="Vlv" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vlv.desc"/>
         <Abbreviation name="Vol" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vol.desc"/>
         <Abbreviation name="VolAmpr"
                    descID="IEC61850_7_4.Abbreviations::AbbrTermV.VolAmpr.desc"/>
         <Abbreviation name="Vss" descID="IEC61850_7_4.Abbreviations::AbbrTermV.Vss.desc"/>
         <Abbreviation name="W" descID="IEC61850_7_4.Abbreviations::AbbrTermW.W.desc"/>
         <Abbreviation name="W200" descID="IEC61850_7_4.Abbreviations::AbbrTermW.W200.desc"/>
         <Abbreviation name="Wac" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wac.desc"/>
         <Abbreviation name="Wash" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wash.desc"/>
         <Abbreviation name="Watt" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Watt.desc"/>
         <Abbreviation name="Wav" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wav.desc"/>
         <Abbreviation name="Wd" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wd.desc"/>
         <Abbreviation name="Week" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Week.desc"/>
         <Abbreviation name="Wei" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wei.desc"/>
         <Abbreviation name="Wet" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wet.desc"/>
         <Abbreviation name="Wgt" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wgt.desc"/>
         <Abbreviation name="Wh" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wh.desc"/>
         <Abbreviation name="Wid" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wid.desc"/>
         <Abbreviation name="Win" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Win.desc"/>
         <Abbreviation name="Wkup" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wkup.desc"/>
         <Abbreviation name="Wld" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wld.desc"/>
         <Abbreviation name="Wnd" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wnd.desc"/>
         <Abbreviation name="Wrm" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wrm.desc"/>
         <Abbreviation name="Wrn" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wrn.desc"/>
         <Abbreviation name="Wrs" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wrs.desc"/>
         <Abbreviation name="Wtr" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wtr.desc"/>
         <Abbreviation name="Wup" descID="IEC61850_7_4.Abbreviations::AbbrTermW.Wup.desc"/>
         <Abbreviation name="X" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.X.desc"/>
         <Abbreviation name="X0" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.X0.desc"/>
         <Abbreviation name="X1" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.X1.desc"/>
         <Abbreviation name="X2" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.X2.desc"/>
         <Abbreviation name="Xd" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xd.desc"/>
         <Abbreviation name="Xdir" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xdir.desc"/>
         <Abbreviation name="Xdp" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xdp.desc"/>
         <Abbreviation name="Xds" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xds.desc"/>
         <Abbreviation name="Xm" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xm.desc"/>
         <Abbreviation name="Xq" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xq.desc"/>
         <Abbreviation name="Xqp" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xqp.desc"/>
         <Abbreviation name="Xqs" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xqs.desc"/>
         <Abbreviation name="Xsec" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Xsec.desc"/>
         <Abbreviation name="Ydir" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Ydir.desc"/>
         <Abbreviation name="Yw" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Yw.desc"/>
         <Abbreviation name="Z" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Z.desc"/>
         <Abbreviation name="Zer" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Zer.desc"/>
         <Abbreviation name="Zero" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Zero.desc"/>
         <Abbreviation name="Zm" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Zm.desc"/>
         <Abbreviation name="Zn" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Zn.desc"/>
         <Abbreviation name="Zro" descID="IEC61850_7_4.Abbreviations::AbbrTermsXYZ.Zro.desc"/>
         <Abbreviation name="km" descID="IEC61850_7_4.Abbreviations::AbbrTermJK.km.desc"/>
         <Abbreviation name="ppm" descID="IEC61850_7_4.Abbreviations::AbbrTermP.ppm.desc"/>
      </Abbreviations>
   <Enumerations>
         <Enumeration name="AdjustmentKind"
                   titleID="IEC61850_7_4.DOEnums::AdjustmentKind.cl.title">
            <Literal name="Completed" literalVal="1"/>
            <Literal name="Cancelled" literalVal="2"/>
            <Literal name="New adjustments" literalVal="3"/>
            <Literal name="Under way" literalVal="4"/>
         </Enumeration>
         <Enumeration name="AffectedPhasesKind"
                   titleID="IEC61850_7_4.DOEnums::AffectedPhasesKind.cl.title">
            <Literal name="PhaseA" literalVal="1"/>
            <Literal name="PhaseB" literalVal="2"/>
            <Literal name="PhaseAB" literalVal="3"/>
            <Literal name="PhaseC" literalVal="4"/>
            <Literal name="PhaseAC" literalVal="5"/>
            <Literal name="PhaseBC" literalVal="6"/>
            <Literal name="PhaseABC" literalVal="7"/>
            <Literal name="None" literalVal="8"/>
         </Enumeration>
         <Enumeration name="AutoReclosingKind"
                   titleID="IEC61850_7_4.DOEnums::AutoReclosingKind.cl.title">
            <Literal name="Ready" literalVal="1"/>
            <Literal name="InProgress" literalVal="2" deprecated="true"/>
            <Literal name="Successful" literalVal="3"/>
            <Literal name="WaitingForTrip" literalVal="4"/>
            <Literal name="TripFromProtection" literalVal="5"/>
            <Literal name="FaultDisappeared" literalVal="6"/>
            <Literal name="WaitToComplete" literalVal="7"/>
            <Literal name="CBclosed" literalVal="8"/>
            <Literal name="CycleUnsuccessful" literalVal="9"/>
            <Literal name="Unsuccessful" literalVal="10"/>
            <Literal name="Aborted" literalVal="11"/>
            <Literal name="NotReady" literalVal="12"/>
         </Enumeration>
         <Enumeration name="BehaviourModeKind"
                   titleID="IEC61850_7_4.DOEnums::BehaviourModeKind.cl.title">
            <Literal name="on" literalVal="1"/>
            <Literal name="blocked" literalVal="2"/>
            <Literal name="test" literalVal="3"/>
            <Literal name="test/blocked" literalVal="4"/>
            <Literal name="off" literalVal="5"/>
         </Enumeration>
         <Enumeration name="BreakerOpCapabilityKind"
                   titleID="IEC61850_7_4.DOEnums::BreakerOpCapabilityKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Open" literalVal="2"/>
            <Literal name="Close-Open" literalVal="3"/>
            <Literal name="Open-Close-Open" literalVal="4"/>
            <Literal name="Close-Open-Close-Open" literalVal="5"/>
            <Literal name="Open-Close-Open-Close-Open" literalVal="6"/>
            <Literal name="more" literalVal="7"/>
         </Enumeration>
         <Enumeration name="CalcIntervalKind"
                   titleID="IEC61850_7_4.DOEnums::CalcIntervalKind.cl.title">
            <Literal name="MS" literalVal="1"/>
            <Literal name="PER_CYCLE" literalVal="2"/>
            <Literal name="CYCLE" literalVal="3"/>
            <Literal name="DAY" literalVal="4"/>
            <Literal name="WEEK" literalVal="5"/>
            <Literal name="MONTH" literalVal="6"/>
            <Literal name="YEAR" literalVal="7"/>
            <Literal name="EXTERNAL" literalVal="8"/>
         </Enumeration>
         <Enumeration name="CalcMethodKind"
                   titleID="IEC61850_7_4.DOEnums::CalcMethodKind.cl.title">
            <Literal name="UNSPECIFIED"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.UNSPECIFIED.desc"/>
            <Literal name="TRUE_RMS"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.TRUE_RMS.desc"/>
            <Literal name="PEAK_FUNDAMENTAL"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.PEAK_FUNDAMENTAL.desc"/>
            <Literal name="RMS_FUNDAMENTAL"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.RMS_FUNDAMENTAL.desc"/>
            <Literal name="MIN"
                  literalVal="5"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.MIN.desc"/>
            <Literal name="MAX"
                  literalVal="6"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.MAX.desc"/>
            <Literal name="AVG"
                  literalVal="7"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.AVG.desc"/>
            <Literal name="SDV"
                  literalVal="8"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.SDV.desc"/>
            <Literal name="PREDICTION"
                  literalVal="9"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.PREDICTION.desc"
                  deprecated="true"/>
            <Literal name="RATE"
                  literalVal="10"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.RATE.desc"
                  deprecated="true"/>
            <Literal name="P-CLASS"
                  literalVal="11"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.P-CLASS.desc"/>
            <Literal name="M-CLASS"
                  literalVal="12"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.M-CLASS.desc"/>
            <Literal name="DIFF"
                  literalVal="13"
                  descID="IEC61850_7_4.DOEnums::CalcMethodKind.DIFF.desc"/>
         </Enumeration>
         <Enumeration name="CalcModeKind"
                   titleID="IEC61850_7_4.DOEnums::CalcModeKind.cl.title">
            <Literal name="TOTAL"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::CalcModeKind.TOTAL.desc"/>
            <Literal name="PERIOD"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::CalcModeKind.PERIOD.desc"/>
            <Literal name="SLIDING"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::CalcModeKind.SLIDING.desc"/>
         </Enumeration>
         <Enumeration name="ClockSourceKind"
                   titleID="IEC61850_7_4.DOEnums::ClockSourceKind.cl.title">
            <Literal name="Unknown" literalVal="1"/>
            <Literal name="SNTP" literalVal="2"/>
            <Literal name="PTP" literalVal="3"/>
            <Literal name="IRIG-B" literalVal="4"/>
            <Literal name="Substation internal" literalVal="5"/>
         </Enumeration>
         <Enumeration name="ClockSyncKind"
                   titleID="IEC61850_7_4.DOEnums::ClockSyncKind.cl.title">
            <Literal name="InternalClock" literalVal="0"/>
            <Literal name="LocalAreaClock" literalVal="1"/>
            <Literal name="GlobalAreaClock" literalVal="2"/>
         </Enumeration>
         <Enumeration name="ClockSyncLockingKind"
                   titleID="IEC61850_7_4.DOEnums::ClockSyncLockingKind.cl.title">
            <Literal name="Locked"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::ClockSyncLockingKind.Locked.desc"/>
            <Literal name="Unlocked10s"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::ClockSyncLockingKind.Unlocked10s.desc"/>
            <Literal name="Unlocked100s"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::ClockSyncLockingKind.Unlocked100s.desc"/>
            <Literal name="Unlocked1000s"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::ClockSyncLockingKind.Unlocked1000s.desc"/>
            <Literal name="UnlockedMoreThan1000s"
                  literalVal="5"
                  descID="IEC61850_7_4.DOEnums::ClockSyncLockingKind.UnlockedMoreThan1000s.desc"/>
         </Enumeration>
         <Enumeration name="DirectionModeKind"
                   titleID="IEC61850_7_4.DOEnums::DirectionModeKind.cl.title">
            <Literal name="NonDirectional" literalVal="1"/>
            <Literal name="Forward" literalVal="2"/>
            <Literal name="Reverse" literalVal="3"/>
         </Enumeration>
         <Enumeration name="FailureDetectionKind"
                   titleID="IEC61850_7_4.DOEnums::FailureDetectionKind.cl.title">
            <Literal name="Current" literalVal="1"/>
            <Literal name="Breaker Status" literalVal="2"/>
            <Literal name="Both current and breaker status" literalVal="3"/>
            <Literal name="Other" literalVal="4"/>
         </Enumeration>
         <Enumeration name="FaultLoopKind"
                   titleID="IEC61850_7_4.DOEnums::FaultLoopKind.cl.title">
            <Literal name="PhaseAtoGround"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::FaultLoopKind.PhaseAtoGround.desc"/>
            <Literal name="PhaseBtoGround"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::FaultLoopKind.PhaseBtoGround.desc"/>
            <Literal name="PhaseCtoGround"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::FaultLoopKind.PhaseCtoGround.desc"/>
            <Literal name="PhaseAtoB"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::FaultLoopKind.PhaseAtoB.desc"/>
            <Literal name="PhaseBtoC"
                  literalVal="5"
                  descID="IEC61850_7_4.DOEnums::FaultLoopKind.PhaseBtoC.desc"/>
            <Literal name="PhaseCtoA"
                  literalVal="6"
                  descID="IEC61850_7_4.DOEnums::FaultLoopKind.PhaseCtoA.desc"/>
            <Literal name="Others" literalVal="7"/>
         </Enumeration>
         <Enumeration name="FaultMeasuredValueTypeKind"
                   titleID="IEC61850_7_4.DOEnums::FaultMeasuredValueTypeKind.cl.title">
            <Literal name="At Start Moment" literalVal="1"/>
            <Literal name="At Trip Moment" literalVal="2"/>
            <Literal name="Peak Fault Value" literalVal="3"/>
         </Enumeration>
         <Enumeration name="FilterFunctionKind"
                   titleID="IEC61850_7_4.DOEnums::FilterFunctionKind.cl.title">
            <Literal name="Low pass" literalVal="1"/>
            <Literal name="High pass" literalVal="2"/>
            <Literal name="Bandpass" literalVal="3"/>
            <Literal name="Bandstop" literalVal="4"/>
            <Literal name="Deadband" literalVal="5"/>
         </Enumeration>
         <Enumeration name="FuseFunctionKind"
                   titleID="IEC61850_7_4.DOEnums::FuseFunctionKind.cl.title">
            <Literal name="Slow time delay"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::FuseFunctionKind.Slow_time_delay.desc"/>
            <Literal name="Fast time delay"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::FuseFunctionKind.Fast_time_delay.desc"/>
            <Literal name="Fast acting"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::FuseFunctionKind.Fast_acting.desc"/>
            <Literal name="Very fast acting"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::FuseFunctionKind.Very_fast_acting.desc"/>
            <Literal name="Not applicable / Unknown" literalVal="98"/>
            <Literal name="Other" literalVal="99"/>
         </Enumeration>
         <Enumeration name="HealthKind" titleID="IEC61850_7_4.DOEnums::HealthKind.cl.title">
            <Literal name="Ok"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::HealthKind.Ok.desc"/>
            <Literal name="Warning"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::HealthKind.Warning.desc"/>
            <Literal name="Alarm"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::HealthKind.Alarm.desc"/>
         </Enumeration>
         <Enumeration name="InstrumentTransformerMeasurementRatingKind"
                   titleID="IEC61850_7_4.DOEnums::InstrumentTransformerMeasurementRatingKind.cl.title">
            <Literal name="0.05" literalVal="1"/>
            <Literal name="0.1" literalVal="2"/>
            <Literal name="0.2" literalVal="3"/>
            <Literal name="0.2S" literalVal="4"/>
            <Literal name="0.5" literalVal="5"/>
            <Literal name="0.5S" literalVal="6"/>
            <Literal name="1" literalVal="7"/>
            <Literal name="3" literalVal="8"/>
            <Literal name="5" literalVal="9"/>
         </Enumeration>
         <Enumeration name="InstrumentTransformerProtectionRatingKind"
                   titleID="IEC61850_7_4.DOEnums::InstrumentTransformerProtectionRatingKind.cl.title">
            <Literal name="1" literalVal="1"/>
            <Literal name="2" literalVal="2"/>
            <Literal name="3" literalVal="3"/>
            <Literal name="5" literalVal="4"/>
            <Literal name="6" literalVal="5"/>
            <Literal name="10" literalVal="6"/>
         </Enumeration>
         <Enumeration name="LeapSecondKind"
                   titleID="IEC61850_7_4.DOEnums::LeapSecondKind.cl.title">
            <Literal name="Unknown" literalVal="1"/>
            <Literal name="Normal Time" literalVal="2"/>
            <Literal name="Last minute of the day has 61 seconds" literalVal="3"/>
            <Literal name="Last minute of the day has 59 seconds" literalVal="4"/>
         </Enumeration>
         <Enumeration name="LevelTriggerModeKind"
                   titleID="IEC61850_7_4.DOEnums::LevelTriggerModeKind.cl.title">
            <Literal name="Positive or Rising" literalVal="1"/>
            <Literal name="Negative or Falling" literalVal="2"/>
            <Literal name="Both" literalVal="3"/>
            <Literal name="Other" literalVal="4"/>
         </Enumeration>
         <Enumeration name="LiveDeadModeKind"
                   titleID="IEC61850_7_4.DOEnums::LiveDeadModeKind.cl.title">
            <Literal name="Dead Line, Dead Bus" literalVal="1"/>
            <Literal name="Live Line, Dead Bus" literalVal="2"/>
            <Literal name="Dead Line, Live Bus" literalVal="3"/>
            <Literal name="Dead Line, Dead Bus OR Live Line, Dead Bus" literalVal="4"/>
            <Literal name="Dead Line, Dead Bus OR Dead Line, Live Bus" literalVal="5"/>
            <Literal name="Live Line, Dead Bus OR Dead Line, Live Bus" literalVal="6"/>
            <Literal name="Dead Line, Dead Bus OR Live Line, Dead Bus OR Dead Line, Live Bus"
                  literalVal="7"/>
         </Enumeration>
         <Enumeration name="MaterialKind"
                   titleID="IEC61850_7_4.DOEnums::MaterialKind.cl.title">
            <Literal name="Air" literalVal="1"/>
            <Literal name="Water" literalVal="2"/>
            <Literal name="Steam" literalVal="3"/>
            <Literal name="Oil" literalVal="4"/>
            <Literal name="Hydrogen" literalVal="5"/>
            <Literal name="Natural gas" literalVal="6"/>
            <Literal name="Butane" literalVal="7"/>
            <Literal name="Propane" literalVal="8"/>
            <Literal name="Waste gas" literalVal="9"/>
            <Literal name="Not applicable / Unknown" literalVal="98"/>
            <Literal name="Other" literalVal="99"/>
         </Enumeration>
         <Enumeration name="MaterialStateKind"
                   titleID="IEC61850_7_4.DOEnums::MaterialStateKind.cl.title">
            <Literal name="Gaseous"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::MaterialStateKind.Gaseous.desc"/>
            <Literal name="Liquid"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::MaterialStateKind.Liquid.desc"/>
            <Literal name="Solid"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::MaterialStateKind.Solid.desc"/>
            <Literal name="Not applicable / Unknown" literalVal="98"/>
            <Literal name="Other" literalVal="99"/>
         </Enumeration>
         <Enumeration name="PFSignKind" titleID="IEC61850_7_4.DOEnums::PFSignKind.cl.title">
            <Literal name="IEC"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::PFSignKind.IEC.desc"/>
            <Literal name="EEI"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::PFSignKind.EEI.desc"/>
         </Enumeration>
         <Enumeration name="PIDAlgorithmKind"
                   titleID="IEC61850_7_4.DOEnums::PIDAlgorithmKind.cl.title">
            <Literal name="P" literalVal="1"/>
            <Literal name="I" literalVal="2"/>
            <Literal name="D" literalVal="3"/>
            <Literal name="PI" literalVal="4"/>
            <Literal name="PD" literalVal="5"/>
            <Literal name="ID" literalVal="6"/>
            <Literal name="PID" literalVal="7"/>
         </Enumeration>
         <Enumeration name="POWSwitchingCapabilityKind"
                   titleID="IEC61850_7_4.DOEnums::POWSwitchingCapabilityKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Close" literalVal="2"/>
            <Literal name="Open" literalVal="3"/>
            <Literal name="Close and Open" literalVal="4"/>
         </Enumeration>
         <Enumeration name="ParallelCoilModeKind"
                   titleID="IEC61850_7_4.DOEnums::ParallelCoilModeKind.cl.title">
            <Literal name="Master/Slave" literalVal="1"/>
            <Literal name="Master/Slave with fixed slave position" literalVal="2"/>
            <Literal name="Master/Slave with variable slave position" literalVal="3"/>
            <Literal name="Parallel operation without communication" literalVal="4"/>
         </Enumeration>
         <Enumeration name="ParallelCtrlModeKind"
                   titleID="IEC61850_7_4.DOEnums::ParallelCtrlModeKind.cl.title">
            <Literal name="Master" literalVal="1"/>
            <Literal name="Slave" literalVal="2"/>
            <Literal name="Independent" literalVal="3"/>
         </Enumeration>
         <Enumeration name="ParallelTransfModeKind"
                   titleID="IEC61850_7_4.DOEnums::ParallelTransfModeKind.cl.title">
            <Literal name="No Mode predefined" literalVal="1"/>
            <Literal name="Master" literalVal="2"/>
            <Literal name="Follower" literalVal="3"/>
            <Literal name="Power Factor" literalVal="4"/>
            <Literal name="Negative Reactance" literalVal="5"/>
            <Literal name="Circulating Current" literalVal="6"/>
            <Literal name="Circulating Reactive Current (var balancing)" literalVal="7"/>
            <Literal name="Circulating Reactive Current by equalizing power factor"
                  literalVal="8"
                  descID="IEC61850_7_4.DOEnums::ParallelTransfModeKind.Circulating_Reactive_Current_by_equalizing_power_factor.desc"/>
         </Enumeration>
         <Enumeration name="PolarizingQuantityKind"
                   titleID="IEC61850_7_4.DOEnums::PolarizingQuantityKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Zero Sequence Current" literalVal="2"/>
            <Literal name="Zero Sequence Voltage" literalVal="3"/>
            <Literal name="Negative Sequence Voltage" literalVal="4"/>
            <Literal name="Phase to Phase Voltages"
                  literalVal="5"
                  descID="IEC61850_7_4.DOEnums::PolarizingQuantityKind.Phase_to_Phase_Voltages.desc"/>
            <Literal name="Phase to Ground Voltages" literalVal="6"/>
            <Literal name="Positive sequence voltage" literalVal="7"/>
         </Enumeration>
         <Enumeration name="RecordingModeKind"
                   titleID="IEC61850_7_4.DOEnums::RecordingModeKind.cl.title">
            <Literal name="Overwrite existing values" literalVal="1"/>
            <Literal name="Stop when full or saturated" literalVal="2"/>
         </Enumeration>
         <Enumeration name="RectifierControlModeKind"
                   titleID="IEC61850_7_4.DOEnums::RectifierControlModeKind.cl.title">
            <Literal name="Current" literalVal="1"/>
            <Literal name="Voltage" literalVal="2"/>
            <Literal name="Active Power" literalVal="3"/>
         </Enumeration>
         <Enumeration name="ResetCurveKind"
                   titleID="IEC61850_7_4.DOEnums::ResetCurveKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Definite Time Delayed Reset" literalVal="2"/>
            <Literal name="Inverse Reset" literalVal="3"/>
         </Enumeration>
         <Enumeration name="RestraintModeKind"
                   titleID="IEC61850_7_4.DOEnums::RestraintModeKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Harmonic2" literalVal="2"/>
            <Literal name="Harmonic5" literalVal="3"/>
            <Literal name="Harmonic2and5" literalVal="4"/>
            <Literal name="WaveformAnalysis" literalVal="5"/>
            <Literal name="WaveformAnalysisAndHarmonic2" literalVal="6"/>
            <Literal name="Other" literalVal="7"/>
            <Literal name="WaveformAnalysisAndHarmonic5" literalVal="8"/>
            <Literal name="WaveformAnalysisAndHarmonic2AndHarmonic5" literalVal="9"/>
         </Enumeration>
         <Enumeration name="RetripModeKind"
                   titleID="IEC61850_7_4.DOEnums::RetripModeKind.cl.title">
            <Literal name="Off" literalVal="1"/>
            <Literal name="Without Check" literalVal="2"/>
            <Literal name="With Current Check" literalVal="3"/>
            <Literal name="With Breaker Status Check" literalVal="4"/>
            <Literal name="With Current and Breaker Status Check" literalVal="5"/>
            <Literal name="Other Checks" literalVal="6"/>
         </Enumeration>
         <Enumeration name="RotatingMachineStateKind"
                   titleID="IEC61850_7_4.DOEnums::RotatingMachineStateKind.cl.title">
            <Literal name="Stopped"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::RotatingMachineStateKind.Stopped.desc"/>
            <Literal name="Stopping" literalVal="2"/>
            <Literal name="Started"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::RotatingMachineStateKind.Started.desc"/>
            <Literal name="Starting" literalVal="4"/>
            <Literal name="Disabled" literalVal="5"/>
         </Enumeration>
         <Enumeration name="RotationalDirectionKind"
                   titleID="IEC61850_7_4.DOEnums::RotationalDirectionKind.cl.title">
            <Literal name="Clockwise" literalVal="1"/>
            <Literal name="Counter-Clockwise" literalVal="2"/>
            <Literal name="Unknown" literalVal="3"/>
         </Enumeration>
         <Enumeration name="RotorThermalStateKind"
                   titleID="IEC61850_7_4.DOEnums::RotorThermalStateKind.cl.title">
            <Literal name="Cold" literalVal="1"/>
            <Literal name="Warm" literalVal="2"/>
            <Literal name="Overload" literalVal="3"/>
         </Enumeration>
         <Enumeration name="SOFEnablingModeKind"
                   titleID="IEC61850_7_4.DOEnums::SOFEnablingModeKind.cl.title">
            <Literal name="SwitchCommand"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::SOFEnablingModeKind.SwitchCommand.desc"/>
            <Literal name="BreakerClosed"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::SOFEnablingModeKind.BreakerClosed.desc"/>
            <Literal name="VoltageAndCurrentLevel"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::SOFEnablingModeKind.VoltageAndCurrentLevel.desc"/>
         </Enumeration>
         <Enumeration name="SOFOperationModeKind"
                   titleID="IEC61850_7_4.DOEnums::SOFOperationModeKind.cl.title">
            <Literal name="ExternalSignal"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::SOFOperationModeKind.ExternalSignal.desc"/>
            <Literal name="VoltageAndCurrent"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::SOFOperationModeKind.VoltageAndCurrent.desc"/>
            <Literal name="ExternalSignal or VoltageAndCurrent" literalVal="3"/>
         </Enumeration>
         <Enumeration name="STotalCalcMethodKind"
                   titleID="IEC61850_7_4.DOEnums::STotalCalcMethodKind.cl.title">
            <Literal name="Vector" literalVal="1"/>
            <Literal name="Arithmetic" literalVal="2"/>
         </Enumeration>
         <Enumeration name="ScheduleEnablingErrorKind"
                   titleID="IEC61850_7_4.DOEnums::ScheduleEnablingErrorKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Missing valid NumEntr" literalVal="2"/>
            <Literal name="Missing valid SchdIntv" literalVal="3"/>
            <Literal name="Missing valid schedule values" literalVal="4"/>
            <Literal name="Inconsistent values CDC"
                  literalVal="5"
                  descID="IEC61850_7_4.DOEnums::ScheduleEnablingErrorKind.Inconsistent_values_CDC.desc"/>
            <Literal name="Missing valid StrTm"
                  literalVal="6"
                  descID="IEC61850_7_4.DOEnums::ScheduleEnablingErrorKind.Missing_valid_StrTm.desc"/>
            <Literal name="Other" literalVal="99"/>
         </Enumeration>
         <Enumeration name="ScheduleStateKind"
                   titleID="IEC61850_7_4.DOEnums::ScheduleStateKind.cl.title">
            <Literal name="Not ready" literalVal="1"/>
            <Literal name="Start Time required" literalVal="2"/>
            <Literal name="Ready" literalVal="3"/>
            <Literal name="Running" literalVal="4"/>
         </Enumeration>
         <Enumeration name="SetpointEndKind"
                   titleID="IEC61850_7_4.DOEnums::SetpointEndKind.cl.title">
            <Literal name="Ended normally" literalVal="1"/>
            <Literal name="Ended with overshoot" literalVal="2"/>
            <Literal name="Cancelled: measurement was deviating" literalVal="3"/>
            <Literal name="Cancelled: loss of communication with dispatch centre"
                  literalVal="4"/>
            <Literal name="Cancelled: loss of communication with local area network"
                  literalVal="5"/>
            <Literal name="Cancelled: loss of communication with the local interface"
                  literalVal="6"/>
            <Literal name="Cancelled: timeout" literalVal="7"/>
            <Literal name="Cancelled: voluntarily" literalVal="8"/>
            <Literal name="Cancelled: noisy environments" literalVal="9"/>
            <Literal name="Cancelled: material failure" literalVal="10"/>
            <Literal name="Cancelled: new set-point request" literalVal="11"/>
            <Literal name="Cancelled: improper environment (blockage)" literalVal="12"/>
            <Literal name="Cancelled: stability time was reached" literalVal="13"/>
            <Literal name="Cancelled: immobilisation time was reached" literalVal="14"/>
            <Literal name="Cancelled: equipment was in the wrong mode" literalVal="15"/>
            <Literal name="Unknown causes" literalVal="16"/>
         </Enumeration>
         <Enumeration name="StageControlKind"
                   titleID="IEC61850_7_4.DOEnums::StageControlKind.cl.title">
            <Literal name="Inactive" literalVal="1"/>
            <Literal name="Stage1" literalVal="2"/>
            <Literal name="Stage2" literalVal="3"/>
            <Literal name="Stage3" literalVal="4"/>
         </Enumeration>
         <Enumeration name="StrWeekDayKind"
                   titleID="IEC61850_7_4.DOEnums::StrWeekDayKind.cl.title">
            <Literal name="Monday"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Monday.desc"/>
            <Literal name="Tuesday"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Tuesday.desc"/>
            <Literal name="Wednesday"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Wednesday.desc"/>
            <Literal name="Thursday"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Thursday.desc"/>
            <Literal name="Friday"
                  literalVal="5"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Friday.desc"/>
            <Literal name="Saturday"
                  literalVal="6"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Saturday.desc"/>
            <Literal name="Sunday"
                  literalVal="7"
                  descID="IEC61850_7_4.DOEnums::StrWeekDayKind.Sunday.desc"/>
         </Enumeration>
         <Enumeration name="SwitchFunctionKind"
                   titleID="IEC61850_7_4.DOEnums::SwitchFunctionKind.cl.title">
            <Literal name="Load Break" literalVal="1"/>
            <Literal name="Disconnector" literalVal="2"/>
            <Literal name="Earthing Switch" literalVal="3"/>
            <Literal name="High Speed Earthing Switch" literalVal="4"/>
         </Enumeration>
         <Enumeration name="SwitchingCapabilityKind"
                   titleID="IEC61850_7_4.DOEnums::SwitchingCapabilityKind.cl.title">
            <Literal name="None" literalVal="1"/>
            <Literal name="Open" literalVal="2"/>
            <Literal name="Close" literalVal="3"/>
            <Literal name="Open and Close" literalVal="4"/>
         </Enumeration>
         <Enumeration name="SynchOperationModeKind"
                   titleID="IEC61850_7_4.DOEnums::SynchOperationModeKind.cl.title">
            <Literal name="Automatic-synchronizing"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::SynchOperationModeKind.Automatic-synchronizing.desc"/>
            <Literal name="Automatic-paralleling"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::SynchOperationModeKind.Automatic-paralleling.desc"/>
            <Literal name="Manual"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::SynchOperationModeKind.Manual.desc"/>
            <Literal name="Test"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::SynchOperationModeKind.Test.desc"/>
         </Enumeration>
         <Enumeration name="TankFillKind"
                   titleID="IEC61850_7_4.DOEnums::TankFillKind.cl.title">
            <Literal name="pressure only" literalVal="1"/>
            <Literal name="level only" literalVal="2"/>
            <Literal name="both pressure and level" literalVal="3"/>
         </Enumeration>
         <Enumeration name="TransientPerformanceClassKind"
                   titleID="IEC61850_7_4.DOEnums::TransientPerformanceClassKind.cl.title">
            <Literal name="Unknown" literalVal="1"/>
            <Literal name="P" literalVal="2"/>
            <Literal name="PR" literalVal="3"/>
            <Literal name="PX" literalVal="4"/>
            <Literal name="PXR" literalVal="5"/>
            <Literal name="TPX" literalVal="6"/>
            <Literal name="TPY" literalVal="7"/>
            <Literal name="TPZ" literalVal="8"/>
            <Literal name="TPE" literalVal="9"/>
            <Literal name="TPS" literalVal="10" deprecated="true"/>
            <Literal name="TPM" literalVal="11"/>
         </Enumeration>
         <Enumeration name="TpcAppModeKind"
                   titleID="IEC61850_7_4.DOEnums::TpcAppModeKind.cl.title">
            <Literal name="Unused" literalVal="1"/>
            <Literal name="Blocking" literalVal="2"/>
            <Literal name="Permissive" literalVal="3"/>
            <Literal name="Direct" literalVal="4"/>
            <Literal name="Unblocking" literalVal="5"/>
            <Literal name="Status" literalVal="6"/>
         </Enumeration>
         <Enumeration name="TriggerSourceKind"
                   titleID="IEC61850_7_4.DOEnums::TriggerSourceKind.cl.title">
            <Literal name="Internal" literalVal="1"/>
            <Literal name="External" literalVal="2"/>
            <Literal name="Both" literalVal="3"/>
         </Enumeration>
         <Enumeration name="TripBehaviourKind"
                   titleID="IEC61850_7_4.DOEnums::TripBehaviourKind.cl.title">
            <Literal name="Single Pole Tripping" literalVal="1"/>
            <Literal name="Undefined" literalVal="2"/>
            <Literal name="Three Pole Tripping" literalVal="3"/>
         </Enumeration>
         <Enumeration name="TripModeKind"
                   titleID="IEC61850_7_4.DOEnums::TripModeKind.cl.title">
            <Literal name="3 phase tripping"
                  literalVal="1"
                  descID="IEC61850_7_4.DOEnums::TripModeKind.3_phase_tripping.desc"/>
            <Literal name="1 or 3 phase tripping"
                  literalVal="2"
                  descID="IEC61850_7_4.DOEnums::TripModeKind.1_or_3_phase_tripping.desc"/>
            <Literal name="specific"
                  literalVal="3"
                  descID="IEC61850_7_4.DOEnums::TripModeKind.specific.desc"/>
            <Literal name="1 phase tripping"
                  literalVal="4"
                  descID="IEC61850_7_4.DOEnums::TripModeKind.1_phase_tripping.desc"/>
         </Enumeration>
         <Enumeration name="TuningKind" titleID="IEC61850_7_4.DOEnums::TuningKind.cl.title">
            <Literal name="Not tuned" literalVal="1"/>
            <Literal name="Tuned" literalVal="2"/>
            <Literal name="Tuned but not compensated" literalVal="3"/>
            <Literal name="Umax" literalVal="4"/>
            <Literal name="Umax but not compensated" literalVal="5"/>
            <Literal name="Umax but not compensated due to U continous limitation"
                  literalVal="6"/>
         </Enumeration>
         <Enumeration name="UnbalanceDetectionKind"
                   titleID="IEC61850_7_4.DOEnums::UnbalanceDetectionKind.cl.title">
            <Literal name="Negative sequence" literalVal="1"/>
            <Literal name="Zero sequence" literalVal="2"/>
            <Literal name="Neg-pos sequence" literalVal="3"/>
            <Literal name="Zero-pos sequence" literalVal="4"/>
            <Literal name="Phase vector comparison" literalVal="5"/>
            <Literal name="Others" literalVal="6"/>
         </Enumeration>
         <Enumeration name="UnblockModeKind"
                   titleID="IEC61850_7_4.DOEnums::UnblockModeKind.cl.title">
            <Literal name="Off" literalVal="1"/>
            <Literal name="Permanent" literalVal="2"/>
            <Literal name="Time window" literalVal="3"/>
         </Enumeration>
         <Enumeration name="VoltInterruptDetectionKind"
                   titleID="IEC61850_7_4.DOEnums::VoltInterruptDetectionKind.cl.title">
            <Literal name="Voltage" literalVal="1"/>
            <Literal name="Voltage and Current" literalVal="2"/>
            <Literal name="Voltage and Normally Open breaker contact" literalVal="3"/>
            <Literal name="Voltage and Normally Closed breaker contact" literalVal="4"/>
            <Literal name="Voltage and Normally Open and Normally Closed breaker contacts"
                  literalVal="5"/>
            <Literal name="Normally Open breaker contact" literalVal="6"/>
            <Literal name="Normally Closed breaker contact" literalVal="7"/>
            <Literal name="Both Normally Open and Normally Closed breaker contacts"
                  literalVal="8"/>
         </Enumeration>
         <Enumeration name="WeakEndInfeedModeKind"
                   titleID="IEC61850_7_4.DOEnums::WeakEndInfeedModeKind.cl.title">
            <Literal name="Off" literalVal="1"/>
            <Literal name="Operate" literalVal="2"/>
            <Literal name="Echo" literalVal="3"/>
            <Literal name="Echo and Operate" literalVal="4"/>
         </Enumeration>
      </Enumerations>
   <LNClasses>
         <AbstractLNClass name="DomainLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::DomainLN.cl.title">
            <DataObject name="NamPlt"
                     type="LPL"
                     descID="IEC61850_7_4.AbstractLNsCommon::DomainLN.NamPlt.desc"
                     presCond="MONamPlt"
                     presCondArgsID="IEC61850_7_4.AbstractLNsCommon::DomainLN__(_MONamPlt_=__((_NamPlt_))__)_.cond.AbstractLNsCommon::DomainLN.NamPlt"
                     dsPresCond="MONamPlt"
                     dsPresCondArgsID="IEC61850_7_4.AbstractLNsCommon::DomainLN__(_MONamPlt_=__((_NamPlt_))__)_.dsCond.AbstractLNsCommon::DomainLN.NamPlt"/>
            <DataObject name="Beh"
                     type="ENS"
                     underlyingType="BehaviourModeKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::DomainLN.Beh.desc"
                     presCond="M"
                     dsPresCond="M"/>
            <DataObject name="Health"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::DomainLN.Health.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Mir"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::DomainLN.Mir.desc"
                     presCond="MOcond"
                     presCondArgs="1"
                     presCondArgsID="IEC61850_7_4.AbstractLNsCommon::DomainLN__(_MOcond(1)_=__((_Mir_))__)_.cond.AbstractLNsCommon::DomainLN.Mir"
                     dsPresCond="MOcond"
                     dsPresCondArgs="1"
                     dsPresCondArgsID="IEC61850_7_4.AbstractLNsCommon::DomainLN__(_MOcond(1)_=__((_Mir_))__)_.dsCond.AbstractLNsCommon::DomainLN.Mir"/>
            <DataObject name="Mod"
                     type="ENC"
                     underlyingType="BehaviourModeKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::DomainLN.Mod.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InRef"
                     type="ORG"
                     descID="IEC61850_7_4.AbstractLNsCommon::DomainLN.InRef.desc"
                     presCond="Omulti"
                     dsPresCond="Omulti"/>
         </AbstractLNClass>
         <AbstractLNClass name="StatisticsLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.cl.title"
                       base="DomainLN">
            <DataObject name="ClcExp"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcExp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcNxtTmms"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcNxtTmms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcStr"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcStr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcMth"
                     type="ENG"
                     underlyingType="CalcMethodKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcMth.desc"
                     presCond="O"
                     dsPresCond="M"/>
            <DataObject name="ClcMod"
                     type="ENG"
                     underlyingType="CalcModeKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcMod.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcIntvTyp"
                     type="ENG"
                     underlyingType="CalcIntervalKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcIntvTyp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcIntvPer"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcIntvPer.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="NumSubIntv"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.NumSubIntv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcRfTyp"
                     type="ENG"
                     underlyingType="CalcIntervalKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcRfTyp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcRfPer"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcRfPer.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcSrc"
                     type="ORG"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.ClcSrc.desc"
                     presCond="F"
                     dsPresCond="M"/>
            <DataObject name="InSyn"
                     type="ORG"
                     descID="IEC61850_7_4.AbstractLNsCommon::StatisticsLN.InSyn.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="NonProcessInterfaceLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::NonProcessInterfaceLN.cl.title"
                       base="StatisticsLN">
            <DataObject name="EEName"
                     type="DPL"
                     descID="IEC61850_7_4.AbstractLNsCommon::NonProcessInterfaceLN.EEName.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EEHealth"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::NonProcessInterfaceLN.EEHealth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmh"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsCommon::NonProcessInterfaceLN.OpTmh.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="NonProcessControllingEquipmentInterfaceLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::NonProcessControllingEquipmentInterfaceLN.cl.title"
                       base="NonProcessInterfaceLN">
            <DataObject name="Loc"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::NonProcessControllingEquipmentInterfaceLN.Loc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LocKey"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::NonProcessControllingEquipmentInterfaceLN.LocKey.desc"
                     presCond="OF"
                     presCondArgs="Loc"
                     dsPresCond="F"/>
            <DataObject name="LocSta"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::NonProcessControllingEquipmentInterfaceLN.LocSta.desc"
                     presCond="OF"
                     presCondArgs="Loc"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="FunctionLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::FunctionLN.cl.title"
                       base="StatisticsLN">
            <DataObject name="Blk"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::FunctionLN.Blk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkRef"
                     type="ORG"
                     descID="IEC61850_7_4.AbstractLNsCommon::FunctionLN.BlkRef.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="EquipmentInterfaceLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::EquipmentInterfaceLN.cl.title"
                       base="FunctionLN">
            <DataObject name="EEName"
                     type="DPL"
                     descID="IEC61850_7_4.AbstractLNsCommon::EquipmentInterfaceLN.EEName.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EEHealth"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::EquipmentInterfaceLN.EEHealth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmh"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsCommon::EquipmentInterfaceLN.OpTmh.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="CmdEquipmentInterfaceLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::CmdEquipmentInterfaceLN.cl.title"
                       base="EquipmentInterfaceLN">
            <DataObject name="CmdBlk"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::CmdEquipmentInterfaceLN.CmdBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ControllingLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::ControllingLN.cl.title"
                       base="FunctionLN">
            <DataObject name="Loc"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControllingLN.Loc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LocKey"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControllingLN.LocKey.desc"
                     presCond="OF"
                     presCondArgs="Loc"
                     dsPresCond="F"/>
            <DataObject name="LocSta"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControllingLN.LocSta.desc"
                     presCond="OF"
                     presCondArgs="Loc"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ControlledLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::ControlledLN.cl.title"
                       base="ControllingLN">
            <DataObject name="CmdBlk"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControlledLN.CmdBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControlledLN.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="ControlEquipmentInterfaceLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::ControlEquipmentInterfaceLN.cl.title"
                       base="ControlledLN">
            <DataObject name="EEName"
                     type="DPL"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControlEquipmentInterfaceLN.EEName.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EEHealth"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControlEquipmentInterfaceLN.EEHealth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmh"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsCommon::ControlEquipmentInterfaceLN.OpTmh.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="AutomaticControlLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::AutomaticControlLN.cl.title"
                       base="ControlledLN">
            <DataObject name="Auto"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::AutomaticControlLN.Auto.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="SynchronisationLN"
                       titleID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.cl.title"
                       base="ControlledLN">
            <DataObject name="VInd"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.VInd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AngInd"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.AngInd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzInd"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.HzInd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifVClc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifVClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DifHzClc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifHzClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DifAngClc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifAngClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="V1Clc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.V1Clc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="V2Clc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.V2Clc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Hz1Clc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.Hz1Clc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Hz2Clc"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.Hz2Clc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SynPrg"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.SynPrg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LivLivBlk"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.LivLivBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VAdpFact"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.VAdpFact.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AdpAngDeg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.AdpAngDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifVNg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifVNg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifVPs"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifVPs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifHzNg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifHzNg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifHzPs"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifHzPs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifAngNg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifAngNg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifAngPs"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DifAngPs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinVSyn"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.MinVSyn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxVSyn"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.MaxVSyn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DetSyn"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DetSyn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LivDeaMod"
                     type="ENG"
                     underlyingType="LiveDeadModeKind"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.LivDeaMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DeaLinVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DeaLinVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LivLinVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.LivLinVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DeaBusVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.DeaBusVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LivBusVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.LivBusVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TotTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsCommon::SynchronisationLN.TotTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="SubscriptionSupervisionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupL::SubscriptionSupervisionLN.cl.title"
                       base="DomainLN">
            <DataObject name="NdsCom"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupL::SubscriptionSupervisionLN.NdsCom.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="St"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupL::SubscriptionSupervisionLN.St.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="SimSt"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupL::SubscriptionSupervisionLN.SimSt.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="ConfRevNum"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsGroupL::SubscriptionSupervisionLN.ConfRevNum.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="RxConfRevNum"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsGroupL::SubscriptionSupervisionLN.RxConfRevNum.desc"
                     presCond="O"
                     dsPresCond="na"/>
         </AbstractLNClass>
         <AbstractLNClass name="FunctionOutputLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupF::FunctionOutputLN.cl.title"
                       base="FunctionLN">
            <DataObject name="Out"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupF::FunctionOutputLN.Out.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="ThresholdLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupF::ThresholdLN.cl.title"
                       base="FunctionLN">
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupF::ThresholdLN.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupF::ThresholdLN.StrVal.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupF::ThresholdLN.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrCrv"
                     type="CSG"
                     descID="IEC61850_7_4.AbstractLNsGroupF::ThresholdLN.StrCrv.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupF::ThresholdLN.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="EnergyLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.cl.title"
                       base="FunctionLN">
            <DataObject name="TotVAh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.TotVAh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TotWh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.TotWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TotVArh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.TotVArh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SupWh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.SupWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SupVArh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.SupVArh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DmdWh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.DmdWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DmdVArh"
                     type="BCR"
                     descID="IEC61850_7_4.AbstractLNsGroupM::EnergyLN.DmdVArh.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="HarmonicsLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.cl.title"
                       base="FunctionLN">
            <DataObject name="Hz"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.Hz.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="HzSet"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.HzSet.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="F"/>
            <DataObject name="EvTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.EvTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NumCyc"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.NumCyc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ThdAVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.ThdAVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ThdVVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.ThdVVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ThdATmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.ThdATmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ThdVTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.ThdVTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NomA"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupM::HarmonicsLN.NomA.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::ProtectionLN.cl.title"
                       base="FunctionLN">
            <DataObject name="FltPhV"
                     type="WYE"
                     descID="IEC61850_7_4.AbstractLNsGroupP::ProtectionLN.FltPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FltA"
                     type="WYE"
                     descID="IEC61850_7_4.AbstractLNsGroupP::ProtectionLN.FltA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.AbstractLNsGroupP::ProtectionLN.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FltValTyp"
                     type="ENG"
                     underlyingType="FaultMeasuredValueTypeKind"
                     descID="IEC61850_7_4.AbstractLNsGroupP::ProtectionLN.FltValTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="CurrentProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="TmASt"
                     type="CSD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.TmASt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="TmACrv"
                     type="CURVE"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.TmACrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmAChr"
                     type="CSG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.TmAChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
            <DataObject name="TmMult"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.TmMult.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.MinOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.MaxOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TypRsCrv"
                     type="ENG"
                     underlyingType="ResetCurveKind"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.TypRsCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::CurrentProtectionLN.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="EarthfaultProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::EarthfaultProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="FltIndRs"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsGroupP::EarthfaultProtectionLN.FltIndRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndStr"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::EarthfaultProtectionLN.GndStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DirMod"
                     type="ENG"
                     underlyingType="DirectionModeKind"
                     descID="IEC61850_7_4.AbstractLNsGroupP::EarthfaultProtectionLN.DirMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="FrequencyProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BlkV"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.BlkV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.BlkVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::FrequencyProtectionLN.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="GeneratorProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::GeneratorProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::GeneratorProtectionLN.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupP::GeneratorProtectionLN.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::GeneratorProtectionLN.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="MotorStartupProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::MotorStartupProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupP::MotorStartupProtectionLN.Op.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SetA"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::MotorStartupProtectionLN.SetA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SetTms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::MotorStartupProtectionLN.SetTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="PowerProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DirMod"
                     type="ENG"
                     underlyingType="DirectionModeKind"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.DirMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerProtectionLN.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="PowerFactorProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BlkA"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.BlkA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkV"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.BlkV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkValA"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.BlkValA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkValV"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::PowerFactorProtectionLN.BlkValV.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="VoltageProtectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.cl.title"
                       base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmMult"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.TmMult.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.MinOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.MaxOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupP::VoltageProtectionLN.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="PowerQualityLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupQ::PowerQualityLN.cl.title"
                       base="FunctionLN">
            <DataObject name="VaStr"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupQ::PowerQualityLN.VaStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VaEnd"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.AbstractLNsGroupQ::PowerQualityLN.VaEnd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EvtCnt"
                     type="HST"
                     descID="IEC61850_7_4.AbstractLNsGroupQ::PowerQualityLN.EvtCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.AbstractLNsGroupQ::PowerQualityLN.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="UnbalanceDetectionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupQ::UnbalanceDetectionLN.cl.title"
                       base="PowerQualityLN">
            <DataObject name="UnbDetMth"
                     type="ENG"
                     underlyingType="UnbalanceDetectionKind"
                     descID="IEC61850_7_4.AbstractLNsGroupQ::UnbalanceDetectionLN.UnbDetMth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupQ::UnbalanceDetectionLN.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="RecorderLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupR::RecorderLN.cl.title"
                       base="FunctionLN">
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.AbstractLNsGroupR::RecorderLN.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TrgMod"
                     type="ENG"
                     underlyingType="TriggerSourceKind"
                     descID="IEC61850_7_4.AbstractLNsGroupR::RecorderLN.TrgMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LevMod"
                     type="ENG"
                     underlyingType="LevelTriggerModeKind"
                     descID="IEC61850_7_4.AbstractLNsGroupR::RecorderLN.LevMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PreTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupR::RecorderLN.PreTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PstTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupR::RecorderLN.PstTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="DRChannelLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupR::DRChannelLN.cl.title"
                       base="RecorderLN">
            <DataObject name="ChTrg"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupR::DRChannelLN.ChTrg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChNum"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupR::DRChannelLN.ChNum.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="SrcRef"
                     type="ORG"
                     descID="IEC61850_7_4.AbstractLNsGroupR::DRChannelLN.SrcRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="SupervisionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupS::SupervisionLN.cl.title"
                       base="FunctionLN">
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SupervisionLN.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="LineSupervisionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.cl.title"
                       base="SupervisionLN">
            <DataObject name="InsAlm"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.InsAlm.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InsBlk"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.InsBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InsTr"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.InsTr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InsLevMax"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.InsLevMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InsLevMin"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.InsLevMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Pres"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.Pres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Tmp"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::LineSupervisionLN.Tmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="SwitchgearSupervisionLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.cl.title"
                       base="SupervisionLN">
            <DataObject name="OpCntAlm"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpCntAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpCntWrn"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpCntWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmAlm"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmWrn"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MechHealth"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.MechHealth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmOpnAlm"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmOpnAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmClsAlm"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmClsAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AccmAbr"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.AccmAbr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AuxSwTmOpn"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.AuxSwTmOpn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AuxSwTmCls"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.AuxSwTmCls.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RctTmOpn"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.RctTmOpn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RctTmCls"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.RctTmCls.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpSpdOpn"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpSpdOpn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpSpdCls"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpSpdCls.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpTmOpn"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmOpn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpTmCls"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmCls.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Stk"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.Stk.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OvStkOpn"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OvStkOpn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OvStkCls"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OvStkCls.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ColA"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.ColA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Tmp"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.Tmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpAlmTmh"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpAlmTmh.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpWrnTmh"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpWrnTmh.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpAlmNum"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpAlmNum.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpWrnNum"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpWrnNum.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmOpnSet"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmOpnSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpTmClsSet"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupS::SwitchgearSupervisionLN.OpTmClsSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="InstrumentTransformerLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.cl.title"
                       base="SensorLN">
            <DataObject name="HzRtg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.HzRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Rat"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.Rat.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Cor"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.Cor.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN__(_MFcond(3)_=__((_Cor,_AngCor_))__)_.cond.AbstractLNsGroupT::InstrumentTransformerLN.Cor"
                     dsPresCond="F"/>
            <DataObject name="AngCor"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.AngCor.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN__(_MFcond(3)_=__((_Cor,_AngCor_))__)_.cond.AbstractLNsGroupT::InstrumentTransformerLN.AngCor"
                     dsPresCond="F"/>
            <DataObject name="CorCrv"
                     type="CSG"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.CorCrv.desc"
                     presCond="MFcond"
                     presCondArgs="4"
                     presCondArgsID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN__(_MFcond(4)_=__((_CorCrv_))__)_.cond.AbstractLNsGroupT::InstrumentTransformerLN.CorCrv"
                     dsPresCond="F"/>
            <DataObject name="Clip"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.Clip.desc"
                     presCond="MOcond"
                     presCondArgs="5"
                     presCondArgsID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN__(_MOcond(5)_=__((_Clip_))__)_.cond.AbstractLNsGroupT::InstrumentTransformerLN.Clip"
                     dsPresCond="F"/>
            <DataObject name="AccMeas"
                     type="ENG"
                     underlyingType="InstrumentTransformerMeasurementRatingKind"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.AccMeas.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AccPro"
                     type="ENG"
                     underlyingType="InstrumentTransformerProtectionRatingKind"
                     descID="IEC61850_7_4.AbstractLNsGroupT::InstrumentTransformerLN.AccPro.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="SensorLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupT::SensorLN.cl.title"
                       base="EquipmentInterfaceLN">
            <DataObject name="SmpRte"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupT::SensorLN.SmpRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HoldTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupT::SensorLN.HoldTmms.desc"
                     presCond="MOcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.AbstractLNsGroupT::SensorLN__(_MOcond(2)_=__((_HoldTmms_))__)_.cond.AbstractLNsGroupT::SensorLN.HoldTmms"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="SwitchingEquipmentLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.cl.title"
                       base="EquipmentInterfaceLN">
            <DataObject name="Loc"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.Loc.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="LocKey"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.LocKey.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpCnt"
                     type="INS"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.OpCnt.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="Dsc"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.Dsc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LocSta"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.LocSta.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Pos"
                     type="DPC"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.Pos.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BlkOpn"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.BlkOpn.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BlkCls"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.BlkCls.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ChaMotEna"
                     type="SPC"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.ChaMotEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DscDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.AbstractLNsGroupX::SwitchingEquipmentLN.DscDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="BaseConverterLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupZ::BaseConverterLN.cl.title"
                       base="EquipmentInterfaceLN">
            <DataObject name="VArRtg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BaseConverterLN.VArRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BaseConverterLN.VRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="BatteryLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.cl.title"
                       base="EquipmentInterfaceLN">
            <DataObject name="BatHi"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.BatHi.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BatLo"
                     type="SPS"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.BatLo.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VolChgRte"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.VolChgRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Vol"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.Vol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Amp"
                     type="MV"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.Amp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HiBatVol"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.HiBatVol.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoBatVol"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::BatteryLN.LoBatVol.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ConductorLN"
                       titleID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.cl.title"
                       base="EquipmentInterfaceLN">
            <DataObject name="LinLenkm"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.LinLenkm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RPs"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.RPs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="XPs"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.XPs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZPsMag"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.ZPsMag.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZPsAng"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.ZPsAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RZer"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.RZer.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="XZer"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.XZer.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZZerMag"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.ZZerMag.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZZerAng"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.ZZerAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RmZer"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.RmZer.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="XmZer"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.XmZer.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZmZerMag"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.ZmZerMag.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZmZerAng"
                     type="ASG"
                     descID="IEC61850_7_4.AbstractLNsGroupZ::ConductorLN.ZmZerAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <LNClass name="LPHD" titleID="IEC61850_7_4.LNGroupL::LPHD.cl.title">
            <DataObject name="NamPlt"
                     type="LPL"
                     descID="IEC61850_7_4.LNGroupL::LPHD.NamPlt.desc"
                     presCond="MONamPlt"
                     presCondArgsID="IEC61850_7_4.LNGroupL::LPHD__(_MONamPlt_=__((_NamPlt_))__)_.cond.LNGroupL::LPHD.NamPlt"
                     dsPresCond="na"/>
            <DataObject name="PhyNam"
                     type="DPL"
                     descID="IEC61850_7_4.LNGroupL::LPHD.PhyNam.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="PhyHealth"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.LNGroupL::LPHD.PhyHealth.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="OutOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.OutOv.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="Proxy"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.Proxy.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="InOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.InOv.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="OpTmh"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.OpTmh.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="NumPwrUp"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.NumPwrUp.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="WrmStr"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.WrmStr.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="WacTrg"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.WacTrg.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="PwrUp"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupL::LPHD.PwrUp.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="PwrDn"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupL::LPHD.PwrDn.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="PwrSupAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LPHD.PwrSupAlm.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="RsStat"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupL::LPHD.RsStat.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="Sim"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupL::LPHD.Sim.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="MaxDl"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupL::LPHD.MaxDl.desc"
                     presCond="MOcond"
                     presCondArgs="1"
                     presCondArgsID="IEC61850_7_4.LNGroupL::LPHD__(_MOcond(1)_=__((_MaxDl_))__)_.cond.LNGroupL::LPHD.MaxDl"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LLN0"
               titleID="IEC61850_7_4.LNGroupL::LLN0.cl.title"
               canHaveLOG="true">
            <DataObject name="NamPlt"
                     type="LPL"
                     descID="IEC61850_7_4.LNGroupL::LLN0.NamPlt.desc"
                     presCond="MOrootLD"
                     dsPresCond="na"/>
            <DataObject name="Beh"
                     type="ENS"
                     underlyingType="BehaviourModeKind"
                     descID="IEC61850_7_4.LNGroupL::LLN0.Beh.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="Health"
                     type="ENS"
                     underlyingType="HealthKind"
                     descID="IEC61850_7_4.LNGroupL::LLN0.Health.desc"
                     presCond="MOrootLD"
                     dsPresCond="na"/>
            <DataObject name="LocKey"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LLN0.LocKey.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="Loc"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LLN0.Loc.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="Mod"
                     type="ENC"
                     underlyingType="BehaviourModeKind"
                     descID="IEC61850_7_4.LNGroupL::LLN0.Mod.desc"
                     presCond="MOrootLD"
                     dsPresCond="na"/>
            <DataObject name="LocSta"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupL::LLN0.LocSta.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="Diag"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupL::LLN0.Diag.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="LEDRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupL::LLN0.LEDRs.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="SwModKey"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupL::LLN0.SwModKey.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="InRef"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupL::LLN0.InRef.desc"
                     presCond="Omulti"
                     dsPresCond="na"/>
            <DataObject name="GrRef"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupL::LLN0.GrRef.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="MltLev"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupL::LLN0.MltLev.desc"
                     presCond="O"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LCCH"
               titleID="IEC61850_7_4.LNGroupL::LCCH.cl.title"
               base="DomainLN">
            <DataObject name="ChLiv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LCCH.ChLiv.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="RedChLiv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LCCH.RedChLiv.desc"
                     presCond="MFcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupL::LCCH__(_MFcond(2)_=__((_RedChLiv_))__)_.cond.LNGroupL::LCCH.RedChLiv"
                     dsPresCond="na"/>
            <DataObject name="OutOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LCCH.OutOv.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="InOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LCCH.InOv.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="FerCh"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LCCH.FerCh.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="RedFerCh"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LCCH.RedFerCh.desc"
                     presCond="OF"
                     presCondArgs="RedChLiv"
                     dsPresCond="na"/>
            <DataObject name="RxCnt"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupL::LCCH.RxCnt.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="RedRxCnt"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupL::LCCH.RedRxCnt.desc"
                     presCond="OF"
                     presCondArgs="RedChLiv"
                     dsPresCond="na"/>
            <DataObject name="TxCnt"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupL::LCCH.TxCnt.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="ApNam"
                     type="VSG"
                     descID="IEC61850_7_4.LNGroupL::LCCH.ApNam.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="ChLivTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupL::LCCH.ChLivTms.desc"
                     presCond="O"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LGOS"
               titleID="IEC61850_7_4.LNGroupL::LGOS.cl.title"
               base="SubscriptionSupervisionLN">
            <DataObject name="LastStNum"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LGOS.LastStNum.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="GoCBRef"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupL::LGOS.GoCBRef.desc"
                     presCond="M"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LSVS"
               titleID="IEC61850_7_4.LNGroupL::LSVS.cl.title"
               base="SubscriptionSupervisionLN">
            <DataObject name="SvCBRef"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupL::LSVS.SvCBRef.desc"
                     presCond="M"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LTIM"
               titleID="IEC61850_7_4.LNGroupL::LTIM.cl.title"
               base="DomainLN">
            <DataObject name="TmDT"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LTIM.TmDT.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="Leap"
                     type="ENS"
                     underlyingType="LeapSecondKind"
                     descID="IEC61850_7_4.LNGroupL::LTIM.Leap.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="TmOfsTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupL::LTIM.TmOfsTmm.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="TmUseDT"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupL::LTIM.TmUseDT.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="TmChgDT"
                     type="TSG"
                     descID="IEC61850_7_4.LNGroupL::LTIM.TmChgDT.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="TmChgST"
                     type="TSG"
                     descID="IEC61850_7_4.LNGroupL::LTIM.TmChgST.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="StrWeekDay"
                     type="ENG"
                     underlyingType="StrWeekDayKind"
                     descID="IEC61850_7_4.LNGroupL::LTIM.StrWeekDay.desc"
                     presCond="O"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LTMS"
               titleID="IEC61850_7_4.LNGroupL::LTMS.cl.title"
               base="DomainLN">
            <DataObject name="TmAcc"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmAcc.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="TmSrc"
                     type="VSS"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmSrc.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="TmSrcTyp"
                     type="ENS"
                     underlyingType="ClockSourceKind"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmSrcTyp.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="TmSyn"
                     type="ENS"
                     underlyingType="ClockSyncKind"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmSyn.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="TmChSt"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmChSt.desc"
                     presCond="Omulti"
                     dsPresCond="na"/>
            <DataObject name="TmSynLkd"
                     type="ENS"
                     underlyingType="ClockSyncLockingKind"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmSynLkd.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="TmSrcSet"
                     type="VSG"
                     descID="IEC61850_7_4.LNGroupL::LTMS.TmSrcSet.desc"
                     presCond="Omulti"
                     dsPresCond="na"/>
            <DataObject name="HoldTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupL::LTMS.HoldTms.desc"
                     presCond="O"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="LTRK"
               titleID="IEC61850_7_4.LNGroupL::LTRK.cl.title"
               base="DomainLN">
            <DataObject name="SpcTrk"
                     type="CTS"
                     underlyingTypeKind="BASIC"
                     underlyingType="BOOLEAN"
                     descID="IEC61850_7_4.LNGroupL::LTRK.SpcTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="DpcTrk"
                     type="CTS"
                     underlyingTypeKind="BASIC"
                     underlyingType="BOOLEAN"
                     descID="IEC61850_7_4.LNGroupL::LTRK.DpcTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="IncTrk"
                     type="CTS"
                     underlyingTypeKind="BASIC"
                     underlyingType="INT32"
                     descID="IEC61850_7_4.LNGroupL::LTRK.IncTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="EncTrk"
                     type="CTS"
                     underlyingTypeKind="ENUMERATED"
                     descID="IEC61850_7_4.LNGroupL::LTRK.EncTrk.desc"
                     presCond="Omulti"
                     dsPresCond="na"/>
            <DataObject name="ApcFTrk"
                     type="CTS"
                     underlyingTypeKind="CONSTRUCTED"
                     underlyingType="AnalogueValueCtlF"
                     descID="IEC61850_7_4.LNGroupL::LTRK.ApcFTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="ApcIntTrk"
                     type="CTS"
                     underlyingTypeKind="CONSTRUCTED"
                     underlyingType="AnalogueValueCtlInt"
                     descID="IEC61850_7_4.LNGroupL::LTRK.ApcIntTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="BscTrk"
                     type="CTS"
                     underlyingTypeKind="BASIC"
                     underlyingType="Tcmd"
                     descID="IEC61850_7_4.LNGroupL::LTRK.BscTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="IscTrk"
                     type="CTS"
                     underlyingTypeKind="BASIC"
                     underlyingType="INT8"
                     descID="IEC61850_7_4.LNGroupL::LTRK.IscTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="BacTrk"
                     type="CTS"
                     underlyingTypeKind="BASIC"
                     underlyingType="Tcmd"
                     descID="IEC61850_7_4.LNGroupL::LTRK.BacTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="GenTrk"
                     type="CST"
                     descID="IEC61850_7_4.LNGroupL::LTRK.GenTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="UrcbTrk"
                     type="UTS"
                     descID="IEC61850_7_4.LNGroupL::LTRK.UrcbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="BrcbTrk"
                     type="BTS"
                     descID="IEC61850_7_4.LNGroupL::LTRK.BrcbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="LocbTrk"
                     type="LTS"
                     descID="IEC61850_7_4.LNGroupL::LTRK.LocbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="GocbTrk"
                     type="GTS"
                     underlyingTypeKind="SCSM"
                     underlyingType="PhyComAddrL2"
                     descID="IEC61850_7_4.LNGroupL::LTRK.GocbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="MsvcbTrk"
                     type="MTS"
                     underlyingTypeKind="SCSM"
                     underlyingType="PhyComAddrL2"
                     descID="IEC61850_7_4.LNGroupL::LTRK.MsvcbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="UsvcbTrk"
                     type="NTS"
                     descID="IEC61850_7_4.LNGroupL::LTRK.UsvcbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="SgcbTrk"
                     type="STS"
                     descID="IEC61850_7_4.LNGroupL::LTRK.SgcbTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="GocbUdpTrk"
                     type="GTS"
                     underlyingTypeKind="SCSM"
                     underlyingType="PhyComAddrUDP"
                     descID="IEC61850_7_4.LNGroupL::LTRK.GocbUdpTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="MsvcbUdpTrk"
                     type="MTS"
                     underlyingTypeKind="SCSM"
                     underlyingType="PhyComAddrUDP"
                     descID="IEC61850_7_4.LNGroupL::LTRK.MsvcbUdpTrk.desc"
                     presCond="O"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="ANCR"
               titleID="IEC61850_7_4.LNGroupA::ANCR.cl.title"
               base="AutomaticControlLN">
            <DataObject name="HiColPos"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.HiColPos.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LoColPos"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.LoColPos.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ColChgOp"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ColChgOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StFixCol"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.StFixCol.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StClcTun"
                     type="ENS"
                     underlyingType="TuningKind"
                     descID="IEC61850_7_4.LNGroupA::ANCR.StClcTun.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PotAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.PotAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.MotAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotWrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.MotWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ClcSeqWrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ClcSeqWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ColPosA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ColPosA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AResoPt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.AResoPt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AWatt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.AWatt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ADetun"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ADetun.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Damp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.Damp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CapacImb"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.CapacImb.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolResoPt"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.VolResoPt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="NeutVol"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupA::ANCR.NeutVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TapChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupA::ANCR.TapChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ColTapPos"
                     type="ISC"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ColTapPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ColPos"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ColPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ColChg"
                     type="BAC"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ColChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="StrClc"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupA::ANCR.StrClc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ParOp"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ParOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FixCol"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ANCR.FixCol.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ParColMod"
                     type="ENG"
                     underlyingType="ParallelCoilModeKind"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ParColMod.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ParMod"
                     type="ENG"
                     underlyingType="ParallelCtrlModeKind"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ParMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ADetunSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ANCR.ADetunSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BndWid"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ANCR.BndWid.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ARCO"
               titleID="IEC61850_7_4.LNGroupA::ARCO.cl.title"
               base="AutomaticControlLN">
            <DataObject name="VOvSt"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ARCO.VOvSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NeutAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ARCO.NeutAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschBlk"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ARCO.DschBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupA::ARCO.TapChg.desc"
                     presCond="M"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="ARIS"
               titleID="IEC61850_7_4.LNGroupA::ARIS.cl.title"
               base="AutomaticControlLN">
            <DataObject name="ZBlk"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ARIS.ZBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmpAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ARIS.TmpAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NeutVol"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupA::ARIS.NeutVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RisTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ARIS.RisTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RisTmpClc"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ARIS.RisTmpClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StrSeq"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupA::ARIS.StrSeq.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ATCC"
               titleID="IEC61850_7_4.LNGroupA::ATCC.cl.title"
               base="AutomaticControlLN">
            <DataObject name="HiTapPos"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.HiTapPos.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LoTapPos"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LoTapPos.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TapOpR"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapOpR.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapOpL"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapOpL.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapOpStop"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapOpStop.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapOpErr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapOpErr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LTCBlkVLo"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LTCBlkVLo.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LTCBlkVHi"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LTCBlkVHi.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LTCBlkAHi"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LTCBlkAHi.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EndPosR"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.EndPosR.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EndPosL"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.EndPosL.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ErrPar"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::ATCC.ErrPar.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtlV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.CtlV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LodA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LodA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CircA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.CircA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhAng"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.PhAng.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HiCtlV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.HiCtlV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LoCtlV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LoCtlV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HiDmdA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupA::ATCC.HiDmdA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TapChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="TapPos"
                     type="ISC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="VolSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.VolSpt.desc"
                     presCond="AtLeastOne"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="BndCtrChg"
                     type="BAC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BndCtrChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="ParOp"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.ParOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LTCBlk"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LTCBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LTCDragRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LTCDragRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRed"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupA::ATCC.VRed.desc"
                     deprecated="true"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="BndCtr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BndCtr.desc"
                     presCond="AtLeastOne"
                     presCondArgs="2"
                     dsPresCond="F"/>
            <DataObject name="BndWid"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BndWid.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtlDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupA::ATCC.CtlDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LDCR"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LDCR.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LDCX"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LDCX.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkLV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BlkLV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkRV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BlkRV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkVLo"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BlkVLo.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkVHi"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.BlkVHi.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RnbkRV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.RnbkRV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LimLodA"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LimLodA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LDC"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LDC.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ParTrfMod"
                     type="ENG"
                     underlyingType="ParallelTransfModeKind"
                     descID="IEC61850_7_4.LNGroupA::ATCC.ParTrfMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmDlChr"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TmDlChr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LDCZ"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.LDCZ.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRedVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::ATCC.VRedVal.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapBlkR"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapBlkR.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapBlkL"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupA::ATCC.TapBlkL.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="AVCO"
               titleID="IEC61850_7_4.LNGroupA::AVCO.cl.title"
               base="AutomaticControlLN">
            <DataObject name="BlkEF"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::AVCO.BlkEF.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkAOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::AVCO.BlkAOv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkVOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupA::AVCO.BlkVOv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupA::AVCO.TapChg.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupA::AVCO.VolSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LimAOv"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::AVCO.LimAOv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LimVOv"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupA::AVCO.LimVOv.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="CALH"
               titleID="IEC61850_7_4.LNGroupC::CALH.cl.title"
               base="FunctionLN">
            <DataObject name="GrAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CALH.GrAlm.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="GrWrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CALH.GrWrn.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="GrInd"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CALH.GrInd.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="AlmLstOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CALH.AlmLstOv.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="CCGR"
               titleID="IEC61850_7_4.LNGroupC::CCGR.cl.title"
               base="AutomaticControlLN">
            <DataObject name="OpTmh"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupC::CCGR.OpTmh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FanOvCur"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CCGR.FanOvCur.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PmpOvCur"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CCGR.PmpOvCur.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PmpAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CCGR.PmpAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnvTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.EnvTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OilTmpIn"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.OilTmpIn.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="OilTmpOut"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.OilTmpOut.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="OilMotA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.OilMotA.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ClTmpIn"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.ClTmpIn.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="ClTmpOut"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.ClTmpOut.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="ClMotA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.ClMotA.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="FanFlw"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.FanFlw.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CETmpIn"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.CETmpIn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CETmpOut"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.CETmpOut.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CEPres"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.CEPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CEFlw"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.CEFlw.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FanA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CCGR.FanA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CEBlk"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupC::CCGR.CEBlk.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CECtl"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupC::CCGR.CECtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PmpCtlGen"
                     type="ENC"
                     underlyingType="StageControlKind"
                     descID="IEC61850_7_4.LNGroupC::CCGR.PmpCtlGen.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PmpCtl"
                     type="ENC"
                     underlyingType="StageControlKind"
                     descID="IEC61850_7_4.LNGroupC::CCGR.PmpCtl.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="FanCtlGen"
                     type="ENC"
                     underlyingType="StageControlKind"
                     descID="IEC61850_7_4.LNGroupC::CCGR.FanCtlGen.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FanCtl"
                     type="ENC"
                     underlyingType="StageControlKind"
                     descID="IEC61850_7_4.LNGroupC::CCGR.FanCtl.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="OilTmpSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CCGR.OilTmpSet.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="ClTmpSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CCGR.ClTmpSet.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="CILO"
               titleID="IEC61850_7_4.LNGroupC::CILO.cl.title"
               base="FunctionLN">
            <DataObject name="EnaOpn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CILO.EnaOpn.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EnaCls"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CILO.EnaCls.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="CPOW"
               titleID="IEC61850_7_4.LNGroupC::CPOW.cl.title"
               base="FunctionLN">
            <DataObject name="TmExc"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CPOW.TmExc.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrPOW"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CPOW.StrPOW.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpOpn"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupC::CPOW.OpOpn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpCls"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupC::CPOW.OpCls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Pos"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CPOW.Pos.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosA"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CPOW.PosA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosB"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CPOW.PosB.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosC"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CPOW.PosC.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CPOW.MaxDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="CSWI"
               titleID="IEC61850_7_4.LNGroupC::CSWI.cl.title"
               base="ControlledLN">
            <DataObject name="OpOpn"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupC::CSWI.OpOpn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelOpn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSWI.SelOpn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpCls"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupC::CSWI.OpCls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelCls"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSWI.SelCls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Pos"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CSWI.Pos.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="PosA"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CSWI.PosA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosB"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CSWI.PosB.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosC"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupC::CSWI.PosC.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwModKey"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupC::CSWI.SwModKey.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DscDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSWI.DscDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="CSYN"
               titleID="IEC61850_7_4.LNGroupC::CSYN.cl.title"
               base="SynchronisationLN">
            <DataObject name="Cmd"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSYN.Cmd.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="LHz"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSYN.LHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LV"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSYN.LV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Rel"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSYN.Rel.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="RHz"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSYN.RHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RotDir"
                     type="ENS"
                     underlyingType="RotationalDirectionKind"
                     descID="IEC61850_7_4.LNGroupC::CSYN.RotDir.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RV"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupC::CSYN.RV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AccClc"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CSYN.AccClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AccClcDev"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupC::CSYN.AccClcDev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpModSyn"
                     type="ENC"
                     underlyingType="SynchOperationModeKind"
                     descID="IEC61850_7_4.LNGroupC::CSYN.OpModSyn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RelDeaBus"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupC::CSYN.RelDeaBus.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DlSynTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.DlSynTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.DlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzNom"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.HzNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MltCmd"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.MltCmd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VAdj"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.VAdj.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VChr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.VChr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VIntvTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.VIntvTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VNom"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.VNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinVTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.MinVTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxVTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.MaxVTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzAdj"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.HzAdj.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzChr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.HzChr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzIntvTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.HzIntvTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinHzTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.MinHzTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxHzTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupC::CSYN.MaxHzTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzTgtVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.HzTgtVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="KckPls"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupC::CSYN.KckPls.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FCNT"
               titleID="IEC61850_7_4.LNGroupF::FCNT.cl.title"
               base="FunctionLN">
            <DataObject name="Up"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FCNT.Up.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Dn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FCNT.Dn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CntVal"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupF::FCNT.CntVal.desc"
                     presCond="M"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="FCSD"
               titleID="IEC61850_7_4.LNGroupF::FCSD.cl.title"
               base="FunctionOutputLN">
            <DataObject name="Crv"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupF::FCSD.Crv.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FFIL"
               titleID="IEC61850_7_4.LNGroupF::FFIL.cl.title"
               base="FunctionOutputLN">
            <DataObject name="ErrTerm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FFIL.ErrTerm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FilTyp"
                     type="ENG"
                     underlyingType="FilterFunctionKind"
                     descID="IEC61850_7_4.LNGroupF::FFIL.FilTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="KP"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FFIL.KP.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="KLd"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FFIL.KLd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="KLg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FFIL.KLg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tm1Tmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FFIL.Tm1Tmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tm1LdTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FFIL.Tm1LdTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tm2Tmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FFIL.Tm2Tmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tm2LdTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FFIL.Tm2LdTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tm3Tmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FFIL.Tm3Tmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Db"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FFIL.Db.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FLIM"
               titleID="IEC61850_7_4.LNGroupF::FLIM.cl.title"
               base="FunctionOutputLN">
            <DataObject name="HiLim"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FLIM.HiLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoLim"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FLIM.LoLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HiLimSpt"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FLIM.HiLimSpt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoLimSpt"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FLIM.LoLimSpt.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FPID"
               titleID="IEC61850_7_4.LNGroupF::FPID.cl.title"
               base="FunctionOutputLN">
            <DataObject name="PAct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FPID.PAct.desc"
                     presCond="OFcond"
                     presCondArgs="1"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_OFcond(1)_=__((_PAct_))__)_.cond.LNGroupF::FPID.PAct"
                     dsPresCond="O"/>
            <DataObject name="IAct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FPID.IAct.desc"
                     presCond="OFcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_OFcond(2)_=__((_IAct_))__)_.cond.LNGroupF::FPID.IAct"
                     dsPresCond="O"/>
            <DataObject name="DAct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FPID.DAct.desc"
                     presCond="OFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_OFcond(3)_=__((_DAct_))__)_.cond.LNGroupF::FPID.DAct"
                     dsPresCond="O"/>
            <DataObject name="ErrTerm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FPID.ErrTerm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PIDAlg"
                     type="ENG"
                     underlyingType="PIDAlgorithmKind"
                     descID="IEC61850_7_4.LNGroupF::FPID.PIDAlg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="KP"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FPID.KP.desc"
                     presCond="MFcond"
                     presCondArgs="1"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_MFcond(1)_=__((_KP_))__)_.cond.LNGroupF::FPID.KP"
                     dsPresCond="F"/>
            <DataObject name="KI"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FPID.KI.desc"
                     presCond="MFcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_MFcond(2)_=__((_KI,_ITmms_))__)_.cond.LNGroupF::FPID.KI"
                     dsPresCond="F"/>
            <DataObject name="ITmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FPID.ITmms.desc"
                     presCond="MFcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_MFcond(2)_=__((_KI,_ITmms_))__)_.cond.LNGroupF::FPID.ITmms"
                     dsPresCond="F"/>
            <DataObject name="KD"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FPID.KD.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_MFcond(3)_=__((_KD,_DTmms,_DFilTmms_))__)_.cond.LNGroupF::FPID.KD"
                     dsPresCond="F"/>
            <DataObject name="DTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FPID.DTmms.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_MFcond(3)_=__((_KD,_DTmms,_DFilTmms_))__)_.cond.LNGroupF::FPID.DTmms"
                     dsPresCond="F"/>
            <DataObject name="DFilTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FPID.DFilTmms.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupF::FPID__(_MFcond(3)_=__((_KD,_DTmms,_DFilTmms_))__)_.cond.LNGroupF::FPID.DFilTmms"
                     dsPresCond="F"/>
            <DataObject name="Bias"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FPID.Bias.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ILim"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FPID.ILim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Drp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FPID.Drp.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FRMP"
               titleID="IEC61850_7_4.LNGroupF::FRMP.cl.title"
               base="FunctionOutputLN">
            <DataObject name="AdjSt"
                     type="ENS"
                     underlyingType="AdjustmentKind"
                     descID="IEC61850_7_4.LNGroupF::FRMP.AdjSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ErrTerm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FRMP.ErrTerm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RmpUp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FRMP.RmpUp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RmpDn"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FRMP.RmpDn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StepPs"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FRMP.StepPs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StepNg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FRMP.StepNg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FSCC"
               titleID="IEC61850_7_4.LNGroupF::FSCC.cl.title"
               base="DomainLN">
            <DataObject name="ActSchdRef"
                     type="ORS"
                     descID="IEC61850_7_4.LNGroupF::FSCC.ActSchdRef.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="ValINS"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupF::FSCC.ValINS.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="ValSPS"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FSCC.ValSPS.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="ValENS"
                     type="ENS"
                     underlyingType="EnumDA"
                     descID="IEC61850_7_4.LNGroupF::FSCC.ValENS.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="ValMV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FSCC.ValMV.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="CtlEnt"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupF::FSCC.CtlEnt.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="Schd"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupF::FSCC.Schd.desc"
                     presCond="Mmulti"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="FSCH"
               titleID="IEC61850_7_4.LNGroupF::FSCH.cl.title"
               base="DomainLN">
            <DataObject name="SchdSt"
                     type="ENS"
                     underlyingType="ScheduleStateKind"
                     descID="IEC61850_7_4.LNGroupF::FSCH.SchdSt.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="SchdEntr"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupF::FSCH.SchdEntr.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="ValINS"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValINS.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="ValSPS"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValSPS.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="ValENS"
                     type="ENS"
                     underlyingType="EnumDA"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValENS.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="ActStrTm"
                     type="TCS"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ActStrTm.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="NxtStrTm"
                     type="TCS"
                     descID="IEC61850_7_4.LNGroupF::FSCH.NxtStrTm.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="SchdEnaErr"
                     type="ENS"
                     underlyingType="ScheduleEnablingErrorKind"
                     descID="IEC61850_7_4.LNGroupF::FSCH.SchdEnaErr.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="ValMV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValMV.desc"
                     presCond="AtMostOne"
                     dsPresCond="na"/>
            <DataObject name="EnaReq"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupF::FSCH.EnaReq.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="DsaReq"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupF::FSCH.DsaReq.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="SchdPrio"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FSCH.SchdPrio.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="NumEntr"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FSCH.NumEntr.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="SchdIntv"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FSCH.SchdIntv.desc"
                     presCond="M"
                     dsPresCond="na"/>
            <DataObject name="ValASG"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValASG.desc"
                     presCond="MmultiF"
                     presCondArgs="ValMV"
                     dsPresCond="na"/>
            <DataObject name="ValING"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValING.desc"
                     presCond="MmultiF"
                     presCondArgs="ValINS"
                     dsPresCond="na"/>
            <DataObject name="ValSPG"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValSPG.desc"
                     presCond="MmultiF"
                     presCondArgs="ValSPS"
                     dsPresCond="na"/>
            <DataObject name="ValENG"
                     type="ENG"
                     underlyingType="EnumDA"
                     descID="IEC61850_7_4.LNGroupF::FSCH.ValENG.desc"
                     presCond="MmultiF"
                     presCondArgs="ValENS"
                     dsPresCond="na"/>
            <DataObject name="StrTm"
                     type="TSG"
                     descID="IEC61850_7_4.LNGroupF::FSCH.StrTm.desc"
                     presCond="Omulti"
                     dsPresCond="na"/>
            <DataObject name="EvtTrg"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupF::FSCH.EvtTrg.desc"
                     presCond="O"
                     dsPresCond="na"/>
            <DataObject name="InSyn"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupF::FSCH.InSyn.desc"
                     presCond="MF"
                     presCondArgs="EvtTrg"
                     dsPresCond="na"/>
            <DataObject name="SchdReuse"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupF::FSCH.SchdReuse.desc"
                     presCond="M"
                     dsPresCond="na"/>
         </LNClass>
         <LNClass name="FSPT"
               titleID="IEC61850_7_4.LNGroupF::FSPT.cl.title"
               base="AutomaticControlLN">
            <DataObject name="SptDvAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptDvAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SptUp"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptUp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SptDn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptDn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SptDir"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptDir.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SptEndSt"
                     type="ENS"
                     underlyingType="SetpointEndKind"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptEndSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AdjSt"
                     type="ENS"
                     underlyingType="AdjustmentKind"
                     descID="IEC61850_7_4.LNGroupF::FSPT.AdjSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Out"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FSPT.Out.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SptMem"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptMem.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ErrTerm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupF::FSPT.ErrTerm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SptChg"
                     type="BAC"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptChg.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SptVal"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupF::FSPT.SptVal.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxRst"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FSPT.MaxRst.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinRst"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FSPT.MinRst.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DvAlm"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupF::FSPT.DvAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="FXOT"
               titleID="IEC61850_7_4.LNGroupF::FXOT.cl.title"
               base="ThresholdLN"/>
         <LNClass name="FXUT"
               titleID="IEC61850_7_4.LNGroupF::FXUT.cl.title"
               base="ThresholdLN"/>
         <LNClass name="GAPC"
               titleID="IEC61850_7_4.LNGroupG::GAPC.cl.title"
               base="AutomaticControlLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupG::GAPC.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupG::GAPC.Op.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupG::GAPC.Alm.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Wrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupG::GAPC.Wrn.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Ind"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupG::GAPC.Ind.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="SPCSO"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupG::GAPC.SPCSO.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="DPCSO"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupG::GAPC.DPCSO.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="ISCSO"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupG::GAPC.ISCSO.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupG::GAPC.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="GGIO"
               titleID="IEC61850_7_4.LNGroupG::GGIO.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="IntIn"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupG::GGIO.IntIn.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupG::GGIO.Alm.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Wrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupG::GGIO.Wrn.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Ind"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupG::GGIO.Ind.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="CntVal"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupG::GGIO.CntVal.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="AnIn"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupG::GGIO.AnIn.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="AnOut"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupG::GGIO.AnOut.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="SPCSO"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupG::GGIO.SPCSO.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="DPCSO"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupG::GGIO.DPCSO.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="ISCSO"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupG::GGIO.ISCSO.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="GLOG"
               titleID="IEC61850_7_4.LNGroupG::GLOG.cl.title"
               base="FunctionLN">
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupG::GLOG.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LogTrg"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupG::GLOG.LogTrg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LogRef"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupG::GLOG.LogRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrgRef"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupG::GLOG.TrgRef.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="GSAL"
               titleID="IEC61850_7_4.LNGroupG::GSAL.cl.title"
               base="FunctionLN">
            <DataObject name="AuthFail"
                     type="SEC"
                     descID="IEC61850_7_4.LNGroupG::GSAL.AuthFail.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AcsCtlFail"
                     type="SEC"
                     descID="IEC61850_7_4.LNGroupG::GSAL.AcsCtlFail.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="SvcViol"
                     type="SEC"
                     descID="IEC61850_7_4.LNGroupG::GSAL.SvcViol.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Ina"
                     type="SEC"
                     descID="IEC61850_7_4.LNGroupG::GSAL.Ina.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="NumCntRs"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupG::GSAL.NumCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupG::GSAL.OpCntRs.desc"
                     presCond="M"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="IARC"
               titleID="IEC61850_7_4.LNGroupI::IARC.cl.title"
               base="NonProcessInterfaceLN">
            <DataObject name="MemOv"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupI::IARC.MemOv.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="MemUsed"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupI::IARC.MemUsed.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="NumRcd"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupI::IARC.NumRcd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InTrg"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupI::IARC.InTrg.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="InLog"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupI::IARC.InLog.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="MaxNumRcd"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupI::IARC.MaxNumRcd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RcdMod"
                     type="ENG"
                     underlyingType="RecordingModeKind"
                     descID="IEC61850_7_4.LNGroupI::IARC.RcdMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MemFull"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupI::IARC.MemFull.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="IHMI"
               titleID="IEC61850_7_4.LNGroupI::IHMI.cl.title"
               base="NonProcessControllingEquipmentInterfaceLN"/>
         <LNClass name="ISAF"
               titleID="IEC61850_7_4.LNGroupI::ISAF.cl.title"
               base="NonProcessInterfaceLN">
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupI::ISAF.Alm.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupI::ISAF.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AlmRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupI::ISAF.AlmRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ITCI"
               titleID="IEC61850_7_4.LNGroupI::ITCI.cl.title"
               base="NonProcessControllingEquipmentInterfaceLN">
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupI::ITCI.Alm.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ITMI"
               titleID="IEC61850_7_4.LNGroupI::ITMI.cl.title"
               base="NonProcessInterfaceLN"/>
         <LNClass name="ITPC"
               titleID="IEC61850_7_4.LNGroupI::ITPC.cl.title"
               base="NonProcessInterfaceLN">
            <DataObject name="GrdRxCmd"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupI::ITPC.GrdRxCmd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LosSig"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupI::ITPC.LosSig.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TxCmdCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupI::ITPC.TxCmdCnt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="RxCmdCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupI::ITPC.RxCmdCnt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="LosSyn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupI::ITPC.LosSyn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Ber"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupI::ITPC.Ber.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Fer"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupI::ITPC.Fer.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CarLev"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupI::ITPC.CarLev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Snr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupI::ITPC.Snr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LoopTestTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupI::ITPC.LoopTestTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="NumTxCmd"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupI::ITPC.NumTxCmd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NumRxCmd"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupI::ITPC.NumRxCmd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TpcTxMod"
                     type="ENG"
                     underlyingType="TpcAppModeKind"
                     descID="IEC61850_7_4.LNGroupI::ITPC.TpcTxMod.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="TpcRxMod"
                     type="ENG"
                     underlyingType="TpcAppModeKind"
                     descID="IEC61850_7_4.LNGroupI::ITPC.TpcRxMod.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="SecTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupI::ITPC.SecTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BstRat"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupI::ITPC.BstRat.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TxPwr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupI::ITPC.TxPwr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TxCtrHz"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupI::ITPC.TxCtrHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RxCtrHz"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupI::ITPC.RxCtrHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TxBndWid"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupI::ITPC.TxBndWid.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RxBndWid"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupI::ITPC.RxBndWid.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KFAN"
               titleID="IEC61850_7_4.LNGroupK::KFAN.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="Spd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KFAN.Spd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpCtl"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupK::KFAN.OpCtl.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="SpdSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupK::KFAN.SpdSpt.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="MinOpTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupK::KFAN.MinOpTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupK::KFAN.MaxOpTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KFIL"
               titleID="IEC61850_7_4.LNGroupK::KFIL.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="ACAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KFIL.ACAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotPro"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KFIL.MotPro.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Flush"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KFIL.Flush.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FilAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KFIL.FilAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifPresHi"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KFIL.DifPresHi.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FlushCnt"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupK::KFIL.FlushCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpCtl"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupK::KFIL.OpCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AlmSpt"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupK::KFIL.AlmSpt.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KPMP"
               titleID="IEC61850_7_4.LNGroupK::KPMP.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="Spd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KPMP.Spd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpCtl"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupK::KPMP.OpCtl.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="SpdSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupK::KPMP.SpdSpt.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="MinOpTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupK::KPMP.MinOpTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupK::KPMP.MaxOpTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KTNK"
               titleID="IEC61850_7_4.LNGroupK::KTNK.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="LevPct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KTNK.LevPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Vlm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KTNK.Vlm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VlmCap"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupK::KTNK.VlmCap.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TnkTyp"
                     type="ENG"
                     underlyingType="TankFillKind"
                     descID="IEC61850_7_4.LNGroupK::KTNK.TnkTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KVLV"
               titleID="IEC61850_7_4.LNGroupK::KVLV.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="OpCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupK::KVLV.OpCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClsPos"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KVLV.ClsPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="OpnPos"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KVLV.OpnPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="Mvm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KVLV.Mvm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Stuck"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupK::KVLV.Stuck.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosVlv"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KVLV.PosVlv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Flw"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupK::KVLV.Flw.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PosSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupK::KVLV.PosSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Pos"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupK::KVLV.Pos.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupK::KVLV.PosChg.desc"
                     presCond="AtMostOne"
                     dsPresCond="O"/>
            <DataObject name="PosChgIncr"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupK::KVLV.PosChgIncr.desc"
                     presCond="AtMostOne"
                     dsPresCond="O"/>
            <DataObject name="BlkOpn"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupK::KVLV.BlkOpn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkCls"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupK::KVLV.BlkCls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpnLim"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupK::KVLV.OpnLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ClsLim"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupK::KVLV.ClsLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Incr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupK::KVLV.Incr.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="MENV"
               titleID="IEC61850_7_4.LNGroupM::MENV.cl.title"
               base="FunctionLN">
            <DataObject name="SmokAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupM::MENV.SmokAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FloodAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupM::MENV.FloodAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CO2Em"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.CO2Em.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="COEm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.COEm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="NOxEm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.NOxEm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SOxEm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.SOxEm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Dust"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.Dust.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Snd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.Snd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="O2CmbuGas"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.O2CmbuGas.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="O3Air"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MENV.O3Air.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SmokLev"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MENV.SmokLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FloodLev"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MENV.FloodLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="MFLK"
               titleID="IEC61850_7_4.LNGroupM::MFLK.cl.title"
               base="FunctionLN">
            <DataObject name="PPPcbLs"
                     type="HST"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPcbLs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhPcbLs"
                     type="HST"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPcbLs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PPPcbLl"
                     type="HST"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPcbLl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhPcbLl"
                     type="HST"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPcbLl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PPPst"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPst.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPst"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPst.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPPlt"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPlt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPlt"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPlt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPPiMax"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPiMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPiMax"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPiMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPPiLoFil"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPiLoFil.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPiLoFil"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPiLoFil.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPPiRoot"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPiRoot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPiRoot"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPiRoot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPPdmWav"
                     type="HDEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPdmWav.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPdmWav"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPdmWav.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPPdmSpec"
                     type="HDEL"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PPPdmSpec.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhPdmSpec"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MFLK.PhPdmSpec.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MFLW"
               titleID="IEC61850_7_4.LNGroupM::MFLW.cl.title"
               base="FunctionLN">
            <DataObject name="VlmCnt"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupM::MFLW.VlmCnt.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="FlwRte"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FlwRte.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="FanSpd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FanSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FlwHorDir"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FlwHorDir.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FlwVerDir"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FlwVerDir.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MatDen"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.MatDen.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MatCndct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.MatCndct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MatLev"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.MatLev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FlwVlvPct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FlwVlvPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MatTyp"
                     type="ENG"
                     underlyingType="MaterialKind"
                     descID="IEC61850_7_4.LNGroupM::MFLW.MatTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="MatSt"
                     type="ENG"
                     underlyingType="MaterialStateKind"
                     descID="IEC61850_7_4.LNGroupM::MFLW.MatSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="FlwRteSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FlwRteSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinXsecArea"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MFLW.MinXsecArea.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FlwVlvTgt"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FlwVlvTgt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FanSpdSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MFLW.FanSpdSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="MHAI"
               titleID="IEC61850_7_4.LNGroupM::MHAI.cl.title"
               base="HarmonicsLN">
            <DataObject name="HA"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HPhV"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HPPV"
                     type="HDEL"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HW"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HVAr"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HVAr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HVA"
                     type="HWYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HVA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HRmsA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HRmsA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HRmsPhV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HRmsPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HRmsPPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HRmsPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HTuW"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HTuW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HTsW"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HTsW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HATm"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HATm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HKFact"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HKFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HTdf"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HTdf.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdOddA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdOddA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdEvnA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdEvnA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TddA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.TddA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TddOddA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.TddOddA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TddEvnA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.TddEvnA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdPhV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdOddPhV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdOddPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdEvnPhV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdEvnPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdPPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdOddPPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdOddPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdEvnPPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MHAI.ThdEvnPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HCfPhV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HCfPhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HCfPPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HCfPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HCfA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HCfA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HTiFact"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MHAI.HTiFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MHAN"
               titleID="IEC61850_7_4.LNGroupM::MHAN.cl.title"
               base="HarmonicsLN">
            <DataObject name="HaAmp"
                     type="HMV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaVol"
                     type="HMV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaWatt"
                     type="HMV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaWatt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaVolAmpr"
                     type="HMV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaVolAmpr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaVolAmp"
                     type="HMV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaVolAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaRmsAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaRmsAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaRmsVol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaRmsVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaTuWatt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaTuWatt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaTsWatt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaTsWatt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaAmpTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaAmpTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaKFact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaKFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaTdFact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaTdFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.ThdAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdOddAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.ThdOddAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdEvnAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.ThdEvnAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TddAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.TddAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TddOddAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.TddOddAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TddEvnAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.TddEvnAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdVol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.ThdVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdOddVol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.ThdOddVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThdEvnVol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.ThdEvnVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaCfAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaCfAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaCfVol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaCfVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HaTiFact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHAN.HaTiFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MHET"
               titleID="IEC61850_7_4.LNGroupM::MHET.cl.title"
               base="FunctionLN">
            <DataObject name="MatVlm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHET.MatVlm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MatPct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHET.MatPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MatCal"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHET.MatCal.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HeatOut"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHET.HeatOut.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AccmHeatOut"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHET.AccmHeatOut.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AccmHeatRs"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupM::MHET.AccmHeatRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MatTyp"
                     type="ENG"
                     underlyingType="MaterialKind"
                     descID="IEC61850_7_4.LNGroupM::MHET.MatTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="HeatSpcf"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MHET.HeatSpcf.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxMatCal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MHET.MaxMatCal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxHeatOut"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupM::MHET.MaxHeatOut.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="MHYD"
               titleID="IEC61850_7_4.LNGroupM::MHYD.cl.title"
               base="FunctionLN">
            <DataObject name="FishCnt"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupM::MHYD.FishCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Lev"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.Lev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Flw"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.Flw.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SpdSrfc"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.SpdSrfc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Tmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.Tmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Cndct"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.Cndct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HydPH"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.HydPH.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Slnt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MHYD.Slnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MMDC"
               titleID="IEC61850_7_4.LNGroupM::MMDC.cl.title"
               base="FunctionLN">
            <DataObject name="Watt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.Watt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Amp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.Amp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Vol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.Vol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolPsGnd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.VolPsGnd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolNgGnd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.VolNgGnd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Ris"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.Ris.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RisPsGnd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.RisPsGnd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RisNgGnd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMDC.RisNgGnd.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MMET"
               titleID="IEC61850_7_4.LNGroupM::MMET.cl.title"
               base="FunctionLN">
            <DataObject name="EnvTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.EnvTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WetBlbTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.WetBlbTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CloudCvr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.CloudCvr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EnvHum"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.EnvHum.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DewPt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.DewPt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DffInsol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.DffInsol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DctInsol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.DctInsol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DlDur"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.DlDur.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HorInsol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.HorInsol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HorWdDir"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.HorWdDir.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HorWdSpd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.HorWdSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VerWdDir"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.VerWdDir.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VerWdSpd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.VerWdSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WdGustSpd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.WdGustSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EnvPres"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.EnvPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RnFll"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.RnFll.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SnwDen"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.SnwDen.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SnwTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.SnwTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SnwCvr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.SnwCvr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SnwFll"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.SnwFll.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SnwEq"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMET.SnwEq.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MMTN"
               titleID="IEC61850_7_4.LNGroupM::MMTN.cl.title"
               base="EnergyLN"/>
         <LNClass name="MMTR"
               titleID="IEC61850_7_4.LNGroupM::MMTR.cl.title"
               base="EnergyLN"/>
         <LNClass name="MMXN"
               titleID="IEC61850_7_4.LNGroupM::MMXN.cl.title"
               base="FunctionLN">
            <DataObject name="Amp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.Amp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Vol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.Vol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Watt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.Watt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolAmpr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.VolAmpr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolAmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.VolAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PwrFact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.PwrFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Imp"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.Imp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Hz"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXN.Hz.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MMXU"
               titleID="IEC61850_7_4.LNGroupM::MMXU.cl.title"
               base="FunctionLN">
            <DataObject name="TotW"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.TotW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TotVAr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.TotVAr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TotVA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.TotVA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TotPF"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.TotPF.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Hz"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.Hz.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MMXU.PPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PNV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.PNV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PhV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.PhV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="A"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.A.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="W"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.W.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VAr"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.VAr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.VA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PF"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.PF.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Z"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MMXU.Z.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvAPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvAPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvPPVPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvPPVPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvPhVPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvPhVPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvWPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvWPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvVAPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvVAPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvVArPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvVArPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvPFPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvPFPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvZPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.AvZPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxAPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxAPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxPPVPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxPPVPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxPhVPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxPhVPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxWPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxWPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxVAPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxVAPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxVArPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxVArPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxPFPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxPFPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxZPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MaxZPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinAPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinAPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinPPVPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinPPVPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinPhVPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinPhVPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinWPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinWPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinVAPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinVAPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinVArPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinVArPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinPFPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinPFPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MinZPhs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.MinZPhs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HzRte"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MMXU.HzRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClcTotVA"
                     type="ENG"
                     underlyingType="STotalCalcMethodKind"
                     descID="IEC61850_7_4.LNGroupM::MMXU.ClcTotVA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PFSign"
                     type="ENG"
                     underlyingType="PFSignKind"
                     descID="IEC61850_7_4.LNGroupM::MMXU.PFSign.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="MSQI"
               titleID="IEC61850_7_4.LNGroupM::MSQI.cl.title"
               base="FunctionLN">
            <DataObject name="SeqA"
                     type="SEQ"
                     descID="IEC61850_7_4.LNGroupM::MSQI.SeqA.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="SeqV"
                     type="SEQ"
                     descID="IEC61850_7_4.LNGroupM::MSQI.SeqV.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="DQ0Seq"
                     type="SEQ"
                     descID="IEC61850_7_4.LNGroupM::MSQI.DQ0Seq.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbNgA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbNgA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbNgV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbNgV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbPPV"
                     type="DEL"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbV"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbZroA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbZroA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbZroV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.ImbZroV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxImbA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.MaxImbA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxImbPPV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.MaxImbPPV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxImbV"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupM::MSQI.MaxImbV.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="PDIF"
               titleID="IEC61850_7_4.LNGroupP::PDIF.cl.title"
               base="ProtectionLN">
            <DataObject name="TmASt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PDIF.TmASt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PDIF.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PDIF.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DifAClc"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupP::PDIF.DifAClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RstA"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupP::PDIF.RstA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TmACrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PDIF.TmACrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmAChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PDIF.TmAChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
            <DataObject name="LinCapac"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIF.LinCapac.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIF.LoSet.desc"
                     presCond="AtMostOne"
                     dsPresCond="F"/>
            <DataObject name="HiSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIF.HiSet.desc"
                     presCond="AtMostOne"
                     dsPresCond="F"/>
            <DataObject name="MinOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIF.MinOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIF.MaxOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RstMod"
                     type="ENG"
                     underlyingType="RestraintModeKind"
                     descID="IEC61850_7_4.LNGroupP::PDIF.RstMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIF.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PDIR"
               titleID="IEC61850_7_4.LNGroupP::PDIR.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PDIR.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PDIR.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIR.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PDIS"
               titleID="IEC61850_7_4.LNGroupP::PDIS.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PDIS.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PDIS.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="PoRch"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.PoRch.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.PhStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.GndStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DirMod"
                     type="ENG"
                     underlyingType="DirectionModeKind"
                     descID="IEC61850_7_4.LNGroupP::PDIS.DirMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PctRch"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.PctRch.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Ofs"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.Ofs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PctOfs"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.PctOfs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RisLod"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.RisLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AngLod"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.AngLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmDlMod"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.TmDlMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIS.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhDlMod"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.PhDlMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIS.PhDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndDlMod"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.GndDlMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIS.GndDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="X1"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.X1.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LinAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.LinAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RisGndRch"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.RisGndRch.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RisPhRch"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.RisPhRch.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="K0Fact"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.K0Fact.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="K0FactAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PDIS.K0FactAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PDIS.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PDOP"
               titleID="IEC61850_7_4.LNGroupP::PDOP.cl.title"
               base="PowerProtectionLN"/>
         <LNClass name="PDUP"
               titleID="IEC61850_7_4.LNGroupP::PDUP.cl.title"
               base="PowerProtectionLN"/>
         <LNClass name="PFRC"
               titleID="IEC61850_7_4.LNGroupP::PFRC.cl.title"
               base="FrequencyProtectionLN"/>
         <LNClass name="PHAR"
               titleID="IEC61850_7_4.LNGroupP::PHAR.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PHAR.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="HaRst"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PHAR.HaRst.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PHAR.PhStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhStop"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PHAR.PhStop.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PHAR.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PHAR.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PHIZ"
               titleID="IEC61850_7_4.LNGroupP::PHIZ.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.AStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.VStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HVStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.HVStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PHIZ.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PIOC"
               titleID="IEC61850_7_4.LNGroupP::PIOC.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PIOC.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PIOC.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PIOC.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PMRI"
               titleID="IEC61850_7_4.LNGroupP::PMRI.cl.title"
               base="MotorStartupProtectionLN">
            <DataObject name="StrInh"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupP::PMRI.StrInh.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrInhTmm"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupP::PMRI.StrInhTmm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxNumStr"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PMRI.MaxNumStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxWrmStr"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PMRI.MaxWrmStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxStrTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PMRI.MaxStrTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PMRI.EqTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InhTmm"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PMRI.InhTmm.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PMSS"
               titleID="IEC61850_7_4.LNGroupP::PMSS.cl.title"
               base="MotorStartupProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PMSS.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotStr"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PMSS.MotStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LokRotTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PMSS.LokRotTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="POPF"
               titleID="IEC61850_7_4.LNGroupP::POPF.cl.title"
               base="PowerFactorProtectionLN"/>
         <LNClass name="PPAM"
               titleID="IEC61850_7_4.LNGroupP::PPAM.cl.title"
               base="GeneratorProtectionLN"/>
         <LNClass name="PRTR"
               titleID="IEC61850_7_4.LNGroupP::PRTR.cl.title"
               base="GeneratorProtectionLN"/>
         <LNClass name="PSCH"
               titleID="IEC61850_7_4.LNGroupP::PSCH.cl.title"
               base="ProtectionLN">
            <DataObject name="TxPrm"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.TxPrm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TxBlk"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.TxBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TxTr"
                     type="ACT"
                     descID="IEC61850_7_4.LNGroupP::PSCH.TxTr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RxPrm"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.RxPrm.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="RxBlk"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.RxBlk.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="RxTr"
                     type="ACT"
                     descID="IEC61850_7_4.LNGroupP::PSCH.RxTr.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EchoWei"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.EchoWei.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EchoWeiOp"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSCH.EchoWeiOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RxSrc"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupP::PSCH.RxSrc.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="RxSrcTr"
                     type="ORG"
                     descID="IEC61850_7_4.LNGroupP::PSCH.RxSrcTr.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSCH.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CrdTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSCH.CrdTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DurTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSCH.DurTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnBlkMod"
                     type="ENG"
                     underlyingType="UnblockModeKind"
                     descID="IEC61850_7_4.LNGroupP::PSCH.UnBlkMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnBlkTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSCH.UnBlkTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WeiMod"
                     type="ENG"
                     underlyingType="WeakEndInfeedModeKind"
                     descID="IEC61850_7_4.LNGroupP::PSCH.WeiMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WeiTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSCH.WeiTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PSDE"
               titleID="IEC61850_7_4.LNGroupP::PSDE.cl.title"
               base="EarthfaultProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PSDE.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSDE.Op.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Ang"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PSDE.Ang.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndOp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PSDE.GndOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSDE.StrDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSDE.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PSOF"
               titleID="IEC61850_7_4.LNGroupP::PSOF.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PSOF.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PSOF.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpAccEx"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupP::PSOF.OpAccEx.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkRec"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupP::PSOF.BlkRec.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnaTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSOF.EnaTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnaMod"
                     type="ENG"
                     underlyingType="SOFEnablingModeKind"
                     descID="IEC61850_7_4.LNGroupP::PSOF.EnaMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpModSof"
                     type="ENG"
                     underlyingType="SOFOperationModeKind"
                     descID="IEC61850_7_4.LNGroupP::PSOF.OpModSof.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SetPhV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PSOF.SetPhV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PSOF.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkValV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PSOF.BlkValV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkValA"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PSOF.BlkValA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PSOF.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTDV"
               titleID="IEC61850_7_4.LNGroupP::PTDV.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PTDV.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PTDV.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTDV.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTDV.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTEF"
               titleID="IEC61850_7_4.LNGroupP::PTEF.cl.title"
               base="EarthfaultProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PTEF.Str.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PTEF.Op.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTHF"
               titleID="IEC61850_7_4.LNGroupP::PTHF.cl.title"
               base="GeneratorProtectionLN"/>
         <LNClass name="PTOC"
               titleID="IEC61850_7_4.LNGroupP::PTOC.cl.title"
               base="CurrentProtectionLN">
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTOC.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DirMod"
                     type="ENG"
                     underlyingType="DirectionModeKind"
                     descID="IEC61850_7_4.LNGroupP::PTOC.DirMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTOF"
               titleID="IEC61850_7_4.LNGroupP::PTOF.cl.title"
               base="FrequencyProtectionLN"/>
         <LNClass name="PTOV"
               titleID="IEC61850_7_4.LNGroupP::PTOV.cl.title"
               base="VoltageProtectionLN">
            <DataObject name="TmVSt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PTOV.TmVSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PTOV.Op.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmVCrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PTOV.TmVCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmVChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PTOV.TmVChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTRC"
               titleID="IEC61850_7_4.LNGroupP::PTRC.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PTRC.Str.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PTRC.Op.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="Tr"
                     type="ACT"
                     descID="IEC61850_7_4.LNGroupP::PTRC.Tr.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="TrMod"
                     type="ENG"
                     underlyingType="TripModeKind"
                     descID="IEC61850_7_4.LNGroupP::PTRC.TrMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrPlsTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTRC.TrPlsTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTTR"
               titleID="IEC61850_7_4.LNGroupP::PTTR.cl.title"
               base="ProtectionLN">
            <DataObject name="TmTmpSt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmTmpSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmASt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmASt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PTTR.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PTTR.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AlmThm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupP::PTTR.AlmThm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkThm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupP::PTTR.BlkThm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Amp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupP::PTTR.Amp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Tmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupP::PTTR.Tmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TmpRl"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmpRl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LodRsvAlm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupP::PTTR.LodRsvAlm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LodRsvTr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupP::PTTR.LodRsvTr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TmTmpCrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmTmpCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTmpChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmTmpChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
            <DataObject name="TmACrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmACrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmAChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmAChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
            <DataObject name="TmpMax"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTTR.TmpMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTTR.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTTR.MinOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTTR.MaxOpTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTTR.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTTR.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ConsTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PTTR.ConsTms.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="AlmVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTTR.AlmVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DropoutVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTTR.DropoutVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTUC"
               titleID="IEC61850_7_4.LNGroupP::PTUC.cl.title"
               base="CurrentProtectionLN">
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PTUC.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DirMod"
                     type="ENG"
                     underlyingType="DirectionModeKind"
                     descID="IEC61850_7_4.LNGroupP::PTUC.DirMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PTUF"
               titleID="IEC61850_7_4.LNGroupP::PTUF.cl.title"
               base="FrequencyProtectionLN"/>
         <LNClass name="PTUV"
               titleID="IEC61850_7_4.LNGroupP::PTUV.cl.title"
               base="VoltageProtectionLN">
            <DataObject name="TmVSt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PTUV.TmVSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PTUV.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="TmVCrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PTUV.TmVCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmVChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PTUV.TmVChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PUPF"
               titleID="IEC61850_7_4.LNGroupP::PUPF.cl.title"
               base="PowerFactorProtectionLN"/>
         <LNClass name="PVOC"
               titleID="IEC61850_7_4.LNGroupP::PVOC.cl.title"
               base="CurrentProtectionLN">
            <DataObject name="AVSt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PVOC.AVSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AVCrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PVOC.AVCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AVChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PVOC.AVChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PVPH"
               titleID="IEC61850_7_4.LNGroupP::PVPH.cl.title"
               base="VoltageProtectionLN">
            <DataObject name="VHzSt"
                     type="CSD"
                     descID="IEC61850_7_4.LNGroupP::PVPH.VHzSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PVPH.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VHzCrv"
                     type="CURVE"
                     descID="IEC61850_7_4.LNGroupP::PVPH.VHzCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VHzChr"
                     type="CSG"
                     descID="IEC61850_7_4.LNGroupP::PVPH.VHzChr.desc"
                     presCond="OmultiRange"
                     presCondArgs="33, 48"
                     dsPresCond="F"/>
            <DataObject name="TypRsCrv"
                     type="ENG"
                     underlyingType="ResetCurveKind"
                     descID="IEC61850_7_4.LNGroupP::PVPH.TypRsCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="PZSU"
               titleID="IEC61850_7_4.LNGroupP::PZSU.cl.title"
               base="ProtectionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupP::PZSU.Str.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupP::PZSU.Op.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupP::PZSU.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PZSU.OpDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RsDlTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupP::PZSU.RsDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="QFVR"
               titleID="IEC61850_7_4.LNGroupQ::QFVR.cl.title"
               base="PowerQualityLN">
            <DataObject name="UnHzStr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupQ::QFVR.UnHzStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OvHzStr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupQ::QFVR.OvHzStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzVaTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QFVR.HzVaTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HzVaMag"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QFVR.HzVaMag.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="UnHzStrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QFVR.UnHzStrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OvHzStrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QFVR.OvHzStrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="QITR"
               titleID="IEC61850_7_4.LNGroupQ::QITR.cl.title"
               base="PowerQualityLN">
            <DataObject name="ATrsTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QITR.ATrsTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxATrs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QITR.MaxATrs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QITR.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="QIUB"
               titleID="IEC61850_7_4.LNGroupQ::QIUB.cl.title"
               base="UnbalanceDetectionLN">
            <DataObject name="AVaTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QIUB.AVaTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxAVa"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QIUB.MaxAVa.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="QVTR"
               titleID="IEC61850_7_4.LNGroupQ::QVTR.cl.title"
               base="PowerQualityLN">
            <DataObject name="VTrsTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QVTR.VTrsTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxVTrs"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QVTR.MaxVTrs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QVTR.StrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="QVUB"
               titleID="IEC61850_7_4.LNGroupQ::QVUB.cl.title"
               base="UnbalanceDetectionLN">
            <DataObject name="VVaTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QVUB.VVaTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxVVa"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QVUB.MaxVVa.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="QVVR"
               titleID="IEC61850_7_4.LNGroupQ::QVVR.cl.title"
               base="PowerQualityLN">
            <DataObject name="DipStr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.DipStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwlStr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.SwlStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntrStr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.IntrStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AffPhs"
                     type="ENS"
                     underlyingType="AffectedPhasesKind"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.AffPhs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VVa"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.VVa.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VVaTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.VVaTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DipStrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.DipStrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwlStrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.SwlStrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntrStrVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.IntrStrVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntrDetMth"
                     type="ENG"
                     underlyingType="VoltInterruptDetectionKind"
                     descID="IEC61850_7_4.LNGroupQ::QVVR.IntrDetMth.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RADR"
               titleID="IEC61850_7_4.LNGroupR::RADR.cl.title"
               base="DRChannelLN">
            <DataObject name="HiTrgLev"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RADR.HiTrgLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoTrgLev"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RADR.LoTrgLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RBDR"
               titleID="IEC61850_7_4.LNGroupR::RBDR.cl.title"
               base="DRChannelLN"/>
         <LNClass name="RBRF"
               titleID="IEC61850_7_4.LNGroupR::RBRF.cl.title"
               base="FunctionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupR::RBRF.Str.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpEx"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RBRF.OpEx.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="OpIn"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RBRF.OpIn.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupR::RBRF.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FailMod"
                     type="ENG"
                     underlyingType="FailureDetectionKind"
                     descID="IEC61850_7_4.LNGroupR::RBRF.FailMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FailTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RBRF.FailTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SPlTrTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RBRF.SPlTrTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TPTrTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RBRF.TPTrTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DetValA"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RBRF.DetValA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ReTrMod"
                     type="ENG"
                     underlyingType="RetripModeKind"
                     descID="IEC61850_7_4.LNGroupR::RBRF.ReTrMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RDIR"
               titleID="IEC61850_7_4.LNGroupR::RDIR.cl.title"
               base="FunctionLN">
            <DataObject name="Dir"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupR::RDIR.Dir.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ChrAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.ChrAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinFwdAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.MinFwdAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinRvAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.MinRvAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxFwdAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.MaxFwdAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxRvAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.MaxRvAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkValA"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.BlkValA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkValV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.BlkValV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PolQty"
                     type="ENG"
                     underlyingType="PolarizingQuantityKind"
                     descID="IEC61850_7_4.LNGroupR::RDIR.PolQty.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MinPPV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RDIR.MinPPV.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RDRE"
               titleID="IEC61850_7_4.LNGroupR::RDRE.cl.title"
               base="RecorderLN">
            <DataObject name="RcdMade"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RDRE.RcdMade.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="FltNum"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupR::RDRE.FltNum.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="GriFltNum"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupR::RDRE.GriFltNum.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RcdStr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupR::RDRE.RcdStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MemUsed"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupR::RDRE.MemUsed.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RcdTrg"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RDRE.RcdTrg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MemRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RDRE.MemRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MemClr"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RDRE.MemClr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MemFull"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RDRE.MemFull.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxNumRcd"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RDRE.MaxNumRcd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ReTrgMod"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupR::RDRE.ReTrgMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PerTrgTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RDRE.PerTrgTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExclTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RDRE.ExclTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RcdMod"
                     type="ENG"
                     underlyingType="RecordingModeKind"
                     descID="IEC61850_7_4.LNGroupR::RDRE.RcdMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StoRte"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RDRE.StoRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RDRS"
               titleID="IEC61850_7_4.LNGroupR::RDRS.cl.title"
               base="FunctionLN">
            <DataObject name="AutoUpLod"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupR::RDRS.AutoUpLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DltRcd"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RDRS.DltRcd.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RFLO"
               titleID="IEC61850_7_4.LNGroupR::RFLO.cl.title"
               base="FunctionLN">
            <DataObject name="FltLoop"
                     type="ENS"
                     underlyingType="FaultLoopKind"
                     descID="IEC61850_7_4.LNGroupR::RFLO.FltLoop.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FltZ"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupR::RFLO.FltZ.desc"
                     presCond="MOcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupR::RFLO__(_MOcond(2)_=__((_FltZ,_FltX,_FltR_))__)_.cond.LNGroupR::RFLO.FltZ"
                     dsPresCond="O"/>
            <DataObject name="FltDiskm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupR::RFLO.FltDiskm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FltR"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupR::RFLO.FltR.desc"
                     presCond="MOcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupR::RFLO__(_MOcond(2)_=__((_FltZ,_FltX,_FltR_))__)_.cond.LNGroupR::RFLO.FltR"
                     dsPresCond="O"/>
            <DataObject name="FltX"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupR::RFLO.FltX.desc"
                     presCond="MOcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupR::RFLO__(_MOcond(2)_=__((_FltZ,_FltX,_FltR_))__)_.cond.LNGroupR::RFLO.FltX"
                     dsPresCond="O"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupR::RFLO.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="RMXU"
               titleID="IEC61850_7_4.LNGroupR::RMXU.cl.title"
               base="FunctionLN">
            <DataObject name="ALoc"
                     type="WYE"
                     descID="IEC61850_7_4.LNGroupR::RMXU.ALoc.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="AmpLocPhsA"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupR::RMXU.AmpLocPhsA.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="AmpLocPhsB"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupR::RMXU.AmpLocPhsB.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="AmpLocPhsC"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupR::RMXU.AmpLocPhsC.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="AmpLocRes"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupR::RMXU.AmpLocRes.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="RPSB"
               titleID="IEC61850_7_4.LNGroupR::RPSB.cl.title"
               base="FunctionLN">
            <DataObject name="Str"
                     type="ACD"
                     descID="IEC61850_7_4.LNGroupR::RPSB.Str.desc"
                     presCond="MOcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupR::RPSB__(_MOcond(2)_=__((_Str,_BlkZn_))__)_.cond.LNGroupR::RPSB.Str"
                     dsPresCond="F"/>
            <DataObject name="Op"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RPSB.Op.desc"
                     presCond="MOcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupR::RPSB__(_MOcond(3)_=__((_Op_))__)_.cond.LNGroupR::RPSB.Op"
                     dsPresCond="F"/>
            <DataObject name="BlkZn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupR::RPSB.BlkZn.desc"
                     presCond="MOcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupR::RPSB__(_MOcond(2)_=__((_Str,_BlkZn_))__)_.cond.LNGroupR::RPSB.BlkZn"
                     dsPresCond="F"/>
            <DataObject name="OpCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupR::RPSB.OpCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ZeroEna"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupR::RPSB.ZeroEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NgEna"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupR::RPSB.NgEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxEna"
                     type="SPG"
                     descID="IEC61850_7_4.LNGroupR::RPSB.MaxEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwgVal"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RPSB.SwgVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwgRis"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RPSB.SwgRis.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwgReact"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RPSB.SwgReact.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwgTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RPSB.SwgTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnBlkTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RPSB.UnBlkTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxNumSlp"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RPSB.MaxNumSlp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EvTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RPSB.EvTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RREC"
               titleID="IEC61850_7_4.LNGroupR::RREC.cl.title"
               base="FunctionLN">
            <DataObject name="TrBeh"
                     type="ENS"
                     underlyingType="TripBehaviourKind"
                     descID="IEC61850_7_4.LNGroupR::RREC.TrBeh.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RecCyc"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupR::RREC.RecCyc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpCls"
                     type="ACT"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupR::RREC.OpCls.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AutoRecSt"
                     type="ENS"
                     underlyingType="AutoReclosingKind"
                     descID="IEC61850_7_4.LNGroupR::RREC.AutoRecSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Rec1PhCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupR::RREC.Rec1PhCnt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="Rec3PhCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupR::RREC.Rec3PhCnt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="CycTrMod"
                     type="ENG"
                     underlyingType="TripModeKind"
                     descID="IEC61850_7_4.LNGroupR::RREC.CycTrMod.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="MaxCyc"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.MaxCyc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UseCyc"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.UseCyc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.MaxTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Rec1Tmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.Rec1Tmms.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Rec13Tmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.Rec13Tmms.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="Rec3Tmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.Rec3Tmms.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="RclTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.RclTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RdyTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupR::RREC.RdyTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="RSYN"
               titleID="IEC61850_7_4.LNGroupR::RSYN.cl.title"
               base="SynchronisationLN">
            <DataObject name="Rel"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupR::RSYN.Rel.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DifV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RSYN.DifV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifHz"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RSYN.DifHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifAng"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupR::RSYN.DifAng.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SARC"
               titleID="IEC61850_7_4.LNGroupS::SARC.cl.title"
               base="SupervisionLN">
            <DataObject name="FADet"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SARC.FADet.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="SwArcDet"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SARC.SwArcDet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FACntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupS::SARC.FACntRs.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="ArcCntRs"
                     type="INC"
                     descID="IEC61850_7_4.LNGroupS::SARC.ArcCntRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="SCBR"
               titleID="IEC61850_7_4.LNGroupS::SCBR.cl.title"
               base="SwitchgearSupervisionLN">
            <DataObject name="ColOpn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SCBR.ColOpn.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ColAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SCBR.ColAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AbrAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SCBR.AbrAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AbrWrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SCBR.AbrWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SCBR.SwA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ActAbr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SCBR.ActAbr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AbrAlmLev"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SCBR.AbrAlmLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AbrWrnLev"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SCBR.AbrWrnLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SIMG"
               titleID="IEC61850_7_4.LNGroupS::SIMG.cl.title"
               base="LineSupervisionLN">
            <DataObject name="PresAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIMG.PresAlm.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="DenAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIMG.DenAlm.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="TmpAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIMG.TmpAlm.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="InsBlkTmh"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupS::SIMG.InsBlkTmh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Den"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIMG.Den.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="SIML"
               titleID="IEC61850_7_4.LNGroupS::SIML.cl.title"
               base="LineSupervisionLN">
            <DataObject name="TmpAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.TmpAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GasInsAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.GasInsAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GasInsTr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.GasInsTr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GasFlwTr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.GasFlwTr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="H2Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2Alm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="H2Wrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2Wrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MstAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.MstAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MstWrn"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SIML.MstWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Lev"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.Lev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="H2O"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2O.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="H2OPap"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2OPap.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="H2OAir"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2OAir.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="H2OTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2OTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="H2ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.H2ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="N2ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.N2ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="COppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.COppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CO2ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.CO2ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CH4ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.CH4ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="C2H2ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.C2H2ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="C2H4ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.C2H4ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="C2H6ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.C2H6ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="O2ppm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.O2ppm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CmbuGas"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.CmbuGas.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FltGas"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SIML.FltGas.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="SLTC"
               titleID="IEC61850_7_4.LNGroupS::SLTC.cl.title"
               base="SupervisionLN">
            <DataObject name="OilFil"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SLTC.OilFil.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotDrvBlk"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SLTC.MotDrvBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VacCelAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SLTC.VacCelAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OilFilTr"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SLTC.OilFilTr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Torq"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SLTC.Torq.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MotDrvA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SLTC.MotDrvA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AbrPrt"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SLTC.AbrPrt.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="SOPM"
               titleID="IEC61850_7_4.LNGroupS::SOPM.cl.title"
               base="SupervisionLN">
            <DataObject name="MotOp"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotStrAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotStrAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HyAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.HyAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HyBlk"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.HyBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnBlk"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.EnBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.EnAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HeatAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.HeatAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaIntvTms"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.ChaIntvTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MotStrNum"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotStrNum.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="En"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SOPM.En.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HyPres"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SOPM.HyPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HyTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SOPM.HyTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MotTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MotA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Tmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SOPM.Tmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MotAlmTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotAlmTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotAlmNum"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotAlmNum.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotStrTms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupS::SOPM.MotStrTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SPDC"
               titleID="IEC61850_7_4.LNGroupS::SPDC.cl.title"
               base="SupervisionLN">
            <DataObject name="PaDschAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPDC.PaDschAlm.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="OpCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupS::SPDC.OpCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AcuPaDsch"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPDC.AcuPaDsch.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="AppPaDsch"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPDC.AppPaDsch.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="NQS"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPDC.NQS.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="UhfPaDsch"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPDC.UhfPaDsch.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="CtrHz"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SPDC.CtrHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BndWid"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SPDC.BndWid.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SPRS"
               titleID="IEC61850_7_4.LNGroupS::SPRS.cl.title"
               base="SupervisionLN">
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPRS.Alm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPRS.RteAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Trip"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPRS.Trip.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteTrip"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPRS.RteTrip.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Pres"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPRS.Pres.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="PresRte"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPRS.PresRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AlmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SPRS.AlmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteAlmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SPRS.RteAlmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TripSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SPRS.TripSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteTripSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SPRS.RteTripSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SPTR"
               titleID="IEC61850_7_4.LNGroupS::SPTR.cl.title"
               base="SupervisionLN">
            <DataObject name="HPTmpAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPTR.HPTmpAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HPTmpOp"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPTR.HPTmpOp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HPTmpTr"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupS::SPTR.HPTmpTr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MbrAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPTR.MbrAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CGAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPTR.CGAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HeatAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SPTR.HeatAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AgeRte"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPTR.AgeRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="BotTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPTR.BotTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CoreTmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPTR.CoreTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HPTmpClc"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SPTR.HPTmpClc.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="SSWI"
               titleID="IEC61850_7_4.LNGroupS::SSWI.cl.title"
               base="SwitchgearSupervisionLN"/>
         <LNClass name="STMP"
               titleID="IEC61850_7_4.LNGroupS::STMP.cl.title"
               base="SupervisionLN">
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::STMP.Alm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::STMP.RteAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Trip"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::STMP.Trip.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteTrip"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::STMP.RteTrip.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tmp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::STMP.Tmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TmpRte"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::STMP.TmpRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AlmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::STMP.AlmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteAlmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::STMP.RteAlmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TripSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::STMP.TripSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RteTripSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::STMP.RteTripSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SVBR"
               titleID="IEC61850_7_4.LNGroupS::SVBR.cl.title"
               base="SupervisionLN">
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SVBR.Alm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AxDspAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SVBR.AxDspAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Trip"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SVBR.Trip.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AxDspTrip"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupS::SVBR.AxDspTrip.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Vbr"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SVBR.Vbr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VbrPer"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SVBR.VbrPer.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AxDsp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupS::SVBR.AxDsp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VbrAlmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SVBR.VbrAlmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AxDspAlmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SVBR.AxDspAlmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VbrTripSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SVBR.VbrTripSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AxDspTripSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupS::SVBR.AxDspTripSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="TANG"
               titleID="IEC61850_7_4.LNGroupT::TANG.cl.title"
               base="SensorLN">
            <DataObject name="AngSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TANG.AngSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TAXD"
               titleID="IEC61850_7_4.LNGroupT::TAXD.cl.title"
               base="SensorLN">
            <DataObject name="AxDspSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TAXD.AxDspSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TCTR"
               titleID="IEC61850_7_4.LNGroupT::TCTR.cl.title"
               base="InstrumentTransformerLN">
            <DataObject name="AmpSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TCTR.AmpSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupT::TCTR.ARtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Trp"
                     type="ENG"
                     underlyingType="TransientPerformanceClassKind"
                     descID="IEC61850_7_4.LNGroupT::TCTR.Trp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ScndTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupT::TCTR.ScndTmms.desc"
                     presCond="MOcond"
                     presCondArgs="6"
                     presCondArgsID="IEC61850_7_4.LNGroupT::TCTR__(_MOcond(6)_=__((_ScndTmms_))__)_.cond.LNGroupT::TCTR.ScndTmms"
                     dsPresCond="F"/>
            <DataObject name="DynRngMin"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupT::TCTR.DynRngMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DynRngMax"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupT::TCTR.DynRngMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="TDST"
               titleID="IEC61850_7_4.LNGroupT::TDST.cl.title"
               base="SensorLN">
            <DataObject name="DisSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TDST.DisSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TFLW"
               titleID="IEC61850_7_4.LNGroupT::TFLW.cl.title"
               base="SensorLN">
            <DataObject name="FlwSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TFLW.FlwSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TFRQ"
               titleID="IEC61850_7_4.LNGroupT::TFRQ.cl.title"
               base="SensorLN">
            <DataObject name="HzSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TFRQ.HzSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TGSN"
               titleID="IEC61850_7_4.LNGroupT::TGSN.cl.title"
               base="SensorLN">
            <DataObject name="GenSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TGSN.GenSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="THUM"
               titleID="IEC61850_7_4.LNGroupT::THUM.cl.title"
               base="SensorLN">
            <DataObject name="HumSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::THUM.HumSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TLVL"
               titleID="IEC61850_7_4.LNGroupT::TLVL.cl.title"
               base="SensorLN">
            <DataObject name="LevPctSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TLVL.LevPctSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TMGF"
               titleID="IEC61850_7_4.LNGroupT::TMGF.cl.title"
               base="SensorLN">
            <DataObject name="MagFldSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TMGF.MagFldSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TMVM"
               titleID="IEC61850_7_4.LNGroupT::TMVM.cl.title"
               base="SensorLN">
            <DataObject name="MvmRteSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TMVM.MvmRteSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TPOS"
               titleID="IEC61850_7_4.LNGroupT::TPOS.cl.title"
               base="SensorLN">
            <DataObject name="PosPctSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TPOS.PosPctSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TPRS"
               titleID="IEC61850_7_4.LNGroupT::TPRS.cl.title"
               base="SensorLN">
            <DataObject name="PresSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TPRS.PresSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TRTN"
               titleID="IEC61850_7_4.LNGroupT::TRTN.cl.title"
               base="SensorLN">
            <DataObject name="RotSpdSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TRTN.RotSpdSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TSND"
               titleID="IEC61850_7_4.LNGroupT::TSND.cl.title"
               base="SensorLN">
            <DataObject name="SndSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TSND.SndSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TTMP"
               titleID="IEC61850_7_4.LNGroupT::TTMP.cl.title"
               base="SensorLN">
            <DataObject name="TmpSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TTMP.TmpSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TTNS"
               titleID="IEC61850_7_4.LNGroupT::TTNS.cl.title"
               base="SensorLN">
            <DataObject name="TnsSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TTNS.TnsSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TVBR"
               titleID="IEC61850_7_4.LNGroupT::TVBR.cl.title"
               base="SensorLN">
            <DataObject name="VbrSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TVBR.VbrSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="TVTR"
               titleID="IEC61850_7_4.LNGroupT::TVTR.cl.title"
               base="InstrumentTransformerLN">
            <DataObject name="FuFail"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupT::TVTR.FuFail.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VolSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TVTR.VolSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupT::TVTR.VRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="TWPH"
               titleID="IEC61850_7_4.LNGroupT::TWPH.cl.title"
               base="SensorLN">
            <DataObject name="H2OPHSv"
                     type="SAV"
                     descID="IEC61850_7_4.LNGroupT::TWPH.H2OPHSv.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="XCBR"
               titleID="IEC61850_7_4.LNGroupX::XCBR.cl.title"
               base="SwitchingEquipmentLN">
            <DataObject name="CBOpCap"
                     type="ENS"
                     underlyingType="BreakerOpCapabilityKind"
                     descID="IEC61850_7_4.LNGroupX::XCBR.CBOpCap.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="POWCap"
                     type="ENS"
                     underlyingType="POWSwitchingCapabilityKind"
                     descID="IEC61850_7_4.LNGroupX::XCBR.POWCap.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxOpCap"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupX::XCBR.MaxOpCap.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SumSwARs"
                     type="BCR"
                     descID="IEC61850_7_4.LNGroupX::XCBR.SumSwARs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CBTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupX::XCBR.CBTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="POWOpnTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupX::XCBR.POWOpnTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="POWClsTmms"
                     type="ING"
                     descID="IEC61850_7_4.LNGroupX::XCBR.POWClsTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="XFUS"
               titleID="IEC61850_7_4.LNGroupX::XFUS.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="FuSt"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupX::XFUS.FuSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuTyp"
                     type="ENG"
                     underlyingType="FuseFunctionKind"
                     descID="IEC61850_7_4.LNGroupX::XFUS.FuTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupX::XFUS.ARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupX::XFUS.VRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="XSWI"
               titleID="IEC61850_7_4.LNGroupX::XSWI.cl.title"
               base="SwitchingEquipmentLN">
            <DataObject name="SwTyp"
                     type="ENS"
                     underlyingType="SwitchFunctionKind"
                     descID="IEC61850_7_4.LNGroupX::XSWI.SwTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="SwOpCap"
                     type="ENS"
                     underlyingType="SwitchingCapabilityKind"
                     descID="IEC61850_7_4.LNGroupX::XSWI.SwOpCap.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="YEFN"
               titleID="IEC61850_7_4.LNGroupY::YEFN.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="EndPosR"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YEFN.EndPosR.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EndPosL"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YEFN.EndPosL.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PotAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YEFN.PotAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MotAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YEFN.MotAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ColPosA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupY::YEFN.ColPosA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ColAEFN"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupY::YEFN.ColAEFN.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="NeutVol"
                     type="CMV"
                     descID="IEC61850_7_4.LNGroupY::YEFN.NeutVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TapChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupY::YEFN.TapChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ColTapPos"
                     type="ISC"
                     descID="IEC61850_7_4.LNGroupY::YEFN.ColTapPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ColPos"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupY::YEFN.ColPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ColChg"
                     type="BAC"
                     descID="IEC61850_7_4.LNGroupY::YEFN.ColChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="YLTC"
               titleID="IEC61850_7_4.LNGroupY::YLTC.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="OpCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupY::YLTC.OpCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EndPosR"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YLTC.EndPosR.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EndPosL"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YLTC.EndPosL.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OoStep"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YLTC.OoStep.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LTCCycAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YLTC.LTCCycAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkLoVisc"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YLTC.BlkLoVisc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TapPos"
                     type="ISC"
                     descID="IEC61850_7_4.LNGroupY::YLTC.TapPos.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="TapChg"
                     type="BSC"
                     descID="IEC61850_7_4.LNGroupY::YLTC.TapChg.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="YPSH"
               titleID="IEC61850_7_4.LNGroupY::YPSH.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="ShOpCap"
                     type="ENS"
                     underlyingType="SwitchingCapabilityKind"
                     descID="IEC61850_7_4.LNGroupY::YPSH.ShOpCap.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Pos"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupY::YPSH.Pos.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BlkOpn"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupY::YPSH.BlkOpn.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BlkCls"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupY::YPSH.BlkCls.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ChaMotEna"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupY::YPSH.ChaMotEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="YPTR"
               titleID="IEC61850_7_4.LNGroupY::YPTR.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="OpNoLod"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OpNoLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpOvA"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OpOvA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpOvV"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OpOvV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpUnV"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OpUnV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LodFact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupY::YPTR.LodFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaxVA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupY::YPTR.MaxVA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OvlTm"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OvlTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OvlTmEmg"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OvlTmEmg.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HiVRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupY::YPTR.HiVRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoVRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupY::YPTR.LoVRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupY::YPTR.VARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxVASet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupY::YPTR.MaxVASet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OvlTmSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OvlTmSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OvlTmEmgSet"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupY::YPTR.OvlTmEmgSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZAXN"
               titleID="IEC61850_7_4.LNGroupZ::ZAXN.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="Vol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZAXN.Vol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Amp"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZAXN.Amp.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="ZBAT"
               titleID="IEC61850_7_4.LNGroupZ::ZBAT.cl.title"
               base="BatteryLN">
            <DataObject name="TestRsl"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZBAT.TestRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BatTest"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupZ::ZBAT.BatTest.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZBSH"
               titleID="IEC61850_7_4.LNGroupZ::ZBSH.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="React"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.React.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AbsReact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.AbsReact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LosFact"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.LosFact.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Vol"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.Vol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DspA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.DspA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LkgA"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.LkgA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RefReact"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.RefReact.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RefPF"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.RefPF.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RefV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZBSH.RefV.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZCAB"
               titleID="IEC61850_7_4.LNGroupZ::ZCAB.cl.title"
               base="ConductorLN"/>
         <LNClass name="ZCAP"
               titleID="IEC61850_7_4.LNGroupZ::ZCAP.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="DschBlk"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZCAP.DschBlk.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="CapDS"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZCAP.CapDS.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZCON"
               titleID="IEC61850_7_4.LNGroupZ::ZCON.cl.title"
               base="BaseConverterLN"/>
         <LNClass name="ZGEN"
               titleID="IEC61850_7_4.LNGroupZ::ZGEN.cl.title"
               base="CmdEquipmentInterfaceLN">
            <DataObject name="GnSt"
                     type="ENS"
                     underlyingType="RotatingMachineStateKind"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.GnSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpNoLod"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.OpNoLod.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="RotDir"
                     type="ENS"
                     underlyingType="RotationalDirectionKind"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.RotDir.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpUnExt"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.OpUnExt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpOvExt"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.OpOvExt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="LosOil"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.LosOil.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LosVac"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.LosVac.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PresAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.PresAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GnSpd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.GnSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnCtl"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.GnCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DExt"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.DExt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AuxSco"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.AuxSco.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArR"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.VArR.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArL"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.VArL.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DmdW"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.DmdW.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.WRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.VARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZGEN.VRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZGIL"
               titleID="IEC61850_7_4.LNGroupZ::ZGIL.cl.title"
               base="EquipmentInterfaceLN"/>
         <LNClass name="ZLIN"
               titleID="IEC61850_7_4.LNGroupZ::ZLIN.cl.title"
               base="ConductorLN"/>
         <LNClass name="ZMOT"
               titleID="IEC61850_7_4.LNGroupZ::ZMOT.cl.title"
               base="CmdEquipmentInterfaceLN">
            <DataObject name="MotSt"
                     type="ENS"
                     underlyingType="RotatingMachineStateKind"
                     descID="IEC61850_7_4.LNGroupZ::ZMOT.MotSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RotThmSt"
                     type="ENS"
                     underlyingType="RotorThermalStateKind"
                     descID="IEC61850_7_4.LNGroupZ::ZMOT.RotThmSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LosOil"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZMOT.LosOil.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LosVac"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZMOT.LosVac.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PresAlm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZMOT.PresAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DExt"
                     type="SPC"
                     descID="IEC61850_7_4.LNGroupZ::ZMOT.DExt.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZREA"
               titleID="IEC61850_7_4.LNGroupZ::ZREA.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZREA.VRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZREA.ARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZREA.VARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZREA.VArRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZRES"
               titleID="IEC61850_7_4.LNGroupZ::ZRES.cl.title"
               base="EquipmentInterfaceLN"/>
         <LNClass name="ZRRC"
               titleID="IEC61850_7_4.LNGroupZ::ZRRC.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="GnSt"
                     type="ENS"
                     underlyingType="RotatingMachineStateKind"
                     descID="IEC61850_7_4.LNGroupZ::ZRRC.GnSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GnSpd"
                     type="MV"
                     descID="IEC61850_7_4.LNGroupZ::ZRRC.GnSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnCtl"
                     type="DPC"
                     descID="IEC61850_7_4.LNGroupZ::ZRRC.GnCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZSAR"
               titleID="IEC61850_7_4.LNGroupZ::ZSAR.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="OpCnt"
                     type="INS"
                     descID="IEC61850_7_4.LNGroupZ::ZSAR.OpCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpSar"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_4.LNGroupZ::ZSAR.OpSar.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZSCR"
               titleID="IEC61850_7_4.LNGroupZ::ZSCR.cl.title"
               base="CmdEquipmentInterfaceLN">
            <DataObject name="Alm"
                     type="SPS"
                     descID="IEC61850_7_4.LNGroupZ::ZSCR.Alm.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AmpSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupZ::ZSCR.AmpSpt.desc"
                     presCond="MFcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupZ::ZSCR__(_MFcond(2)_=__((_SetV,_AmpSpt_))__)_.cond.LNGroupZ::ZSCR.AmpSpt"
                     dsPresCond="O"/>
            <DataObject name="VolSpt"
                     type="APC"
                     descID="IEC61850_7_4.LNGroupZ::ZSCR.VolSpt.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupZ::ZSCR__(_MFcond(3)_=__((_SetA,_VolSpt_))__)_.cond.LNGroupZ::ZSCR.VolSpt"
                     dsPresCond="O"/>
            <DataObject name="OpModRect"
                     type="ENG"
                     underlyingType="RectifierControlModeKind"
                     descID="IEC61850_7_4.LNGroupZ::ZSCR.OpModRect.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="SetA"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSCR.SetA.desc"
                     presCond="MFcond"
                     presCondArgs="3"
                     presCondArgsID="IEC61850_7_4.LNGroupZ::ZSCR__(_MFcond(3)_=__((_SetA,_VolSpt_))__)_.cond.LNGroupZ::ZSCR.SetA"
                     dsPresCond="F"/>
            <DataObject name="SetV"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSCR.SetV.desc"
                     presCond="MFcond"
                     presCondArgs="2"
                     presCondArgsID="IEC61850_7_4.LNGroupZ::ZSCR__(_MFcond(2)_=__((_SetV,_AmpSpt_))__)_.cond.LNGroupZ::ZSCR.SetV"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZSMC"
               titleID="IEC61850_7_4.LNGroupZ::ZSMC.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="RotDir"
                     type="ENS"
                     underlyingType="RotationalDirectionKind"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.RotDir.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.VRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.ARtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.WRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VARtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.VARtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="SpdRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SpdRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="SpdCrit"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SpdCrit.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FldRisTmp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.FldRisTmp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SttRisTmp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SttRisTmp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SttRis"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SttRis.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PFRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.PFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Iner"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Iner.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FldAmpRtg"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.FldAmpRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FldAmpRtgZer"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.FldAmpRtgZer.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FldRis"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.FldRis.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BaseImp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.BaseImp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SttLkgX"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SttLkgX.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xd"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Xd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xdp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Xdp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xds"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Xds.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xq"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Xq.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xqp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Xqp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xqs"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.Xqs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="X0"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.X0.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="X2"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.X2.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTdp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTdp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTds"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTds.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTd0p"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTd0p.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTd0s"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTd0s.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTqp"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTqp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTqs"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTqs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTq0p"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTq0p.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTq0s"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTq0s.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmTa"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.TmTa.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SatCffS10"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SatCffS10.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SatCffS12"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZSMC.SatCffS12.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZTCF"
               titleID="IEC61850_7_4.LNGroupZ::ZTCF.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="PwrHz"
                     type="ASG"
                     descID="IEC61850_7_4.LNGroupZ::ZTCF.PwrHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="ZTCR"
               titleID="IEC61850_7_4.LNGroupZ::ZTCR.cl.title"
               base="EquipmentInterfaceLN"/>
      </LNClasses>
</NS>
`;
const nsd7420 = `<?xml version="1.0" encoding="UTF-8"?>
<NS xmlns="http://www.iec.ch/61850/2016/NSD"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xsi:schemaLocation="http://www.iec.ch/61850/2016/NSD NSD.xsd"
    id="IEC 61850-7-420"
    version="2019"
    revision="A"
    release="4"
    umlVersion="WG17build8"
    umlDate="2021-09-09T00:00:00Z"
    publicationStage="IS">
   <Copyright>
         <Notice>
			COPYRIGHT (c) IEC, www.iec.ch/tc57/supportdocuments. This version of this NSD is part of IEC_61850-7-420:2020 Edition 2.0; see the IEC_61850-7-420:2020 Edition 2.0 for full legal notices. In case of any differences between the here-below code and the IEC published content, the here-below definition supersedes the IEC publication; it may contain updates. See history files. The whole document has to be taken into account to have a full description of this code component.
			See www.iec.ch/CCv1 for copyright details.
			</Notice>
         <License uri="www.iec.ch/CCv1" kind="Standard"/>
      </Copyright>
   <Changes version="2009"
            revision="A"
            tissues="642-646, 648, 651, 654, 666, 701, 703, 704, 888-889, 903-907, 916, 917, 921-923, 945-947, 955-960, 975-976, 978-989, 992-995, 999-1001, 1003-1006, 1008-1024, 1027-1028, 1031-1033, 1035, 1073-1074, 1087-1090, 1094-1115, 1124, 1126, 1132, 1134, 1153, 1158, 1182, 1183, 1206, 1210, 1215-1219, 1225, 1314, 1320, 1323, 1366, 1392-1394, 1414"/>
   <DependsOn id="IEC 61850-7-4" version="2007" revision="B"/>
   <Abbreviations>
         <Abbreviation name="Add"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Add.desc"/>
         <Abbreviation name="Ava"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Ava.desc"/>
         <Abbreviation name="Avar"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Avar.desc"/>
         <Abbreviation name="Cea"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Cea.desc"/>
         <Abbreviation name="Cnst"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Cnst.desc"/>
         <Abbreviation name="Ctb"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Ctb.desc"/>
         <Abbreviation name="Eff"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Eff.desc"/>
         <Abbreviation name="Egz"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Egz.desc"/>
         <Abbreviation name="Elc"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Elc.desc"/>
         <Abbreviation name="Eps"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Eps.desc"/>
         <Abbreviation name="Esp"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Esp.desc"/>
         <Abbreviation name="Expc"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Expc.desc"/>
         <Abbreviation name="Fct"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Fct.desc"/>
         <Abbreviation name="Frm"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Frm.desc"/>
         <Abbreviation name="Iva"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Iva.desc"/>
         <Abbreviation name="Ivar"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Ivar.desc"/>
         <Abbreviation name="Mn"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Mn.desc"/>
         <Abbreviation name="Ms"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Ms.desc"/>
         <Abbreviation name="Mx"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Mx.desc"/>
         <Abbreviation name="Opl"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Opl.desc"/>
         <Abbreviation name="Ple"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Ple.desc"/>
         <Abbreviation name="Poa"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Poa.desc"/>
         <Abbreviation name="Ren"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Ren.desc"/>
         <Abbreviation name="Rnt"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Rnt.desc"/>
         <Abbreviation name="Rpd"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Rpd.desc"/>
         <Abbreviation name="Rpu"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Rpu.desc"/>
         <Abbreviation name="Rsp"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Rsp.desc"/>
         <Abbreviation name="Rtn"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Rtn.desc"/>
         <Abbreviation name="Sink"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Sink.desc"/>
         <Abbreviation name="Snpt"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Snpt.desc"/>
         <Abbreviation name="Soe"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Soe.desc"/>
         <Abbreviation name="Soh"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Soh.desc"/>
         <Abbreviation name="Susc"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Susc.desc"/>
         <Abbreviation name="Thr"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Thr.desc"/>
         <Abbreviation name="Unit"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Unit.desc"/>
         <Abbreviation name="Wst"
                    descID="IEC61850_7_420.Abbreviations_7_420::Abbr_7_420Term.Wst.desc"/>
      </Abbreviations>
   <Enumerations>
         <Enumeration name="ACSystemKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ACSystemKind.cl.title">
            <Literal name="Single phase" literalVal="1"/>
            <Literal name="Two phases" literalVal="2"/>
            <Literal name="Three phases" literalVal="3"/>
         </Enumeration>
         <Enumeration name="ACToDCConversionKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ACToDCConversionKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="AC to DC" literalVal="1"/>
            <Literal name="AC to AC to DC" literalVal="2"/>
            <Literal name="AC to DC to DC" literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="BatteryTypeKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Lead-acid"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Lead-acid.desc"/>
            <Literal name="Nickel-metal hydrate (NiMH)"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Nickel-metal_hydrate_(NiMH).desc"/>
            <Literal name="Nickel-cadmium (NiCd)"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Nickel-cadmium_(NiCd).desc"/>
            <Literal name="Carbon zinc"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Carbon_zinc.desc"/>
            <Literal name="Lithium ion"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Lithium_ion.desc"/>
            <Literal name="Zinc chloride"
                  literalVal="6"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Zinc_chloride.desc"/>
            <Literal name="Alkaline"
                  literalVal="7"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Alkaline.desc"/>
            <Literal name="Rechargeable alkaline"
                  literalVal="8"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Rechargeable_alkaline.desc"/>
            <Literal name="Sodium sulphur (NaS)" literalVal="9"/>
            <Literal name="Flow" literalVal="10"/>
            <Literal name="Not applicable or not known"
                  literalVal="98"
                  descID="IEC61850_7_420.DOEnums_7_420::BatteryTypeKind.Not_applicable_or_not_known.desc"/>
            <Literal name="Unknown" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="BoilerKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::BoilerKind.cl.title">
            <Literal name="Regular boiler" literalVal="1"/>
            <Literal name="Condensing boiler" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="CeasetoEnergizeStateKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.cl.title">
            <Literal name="CTE not authorized"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.CTE_not_authorized.desc"/>
            <Literal name="CTE authorized but not requested"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.CTE_authorized_but_not_requested.desc"/>
            <Literal name="CTE auth and requested but DER not in CTE mode"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.CTE_auth_and_requested_but_DER_not_in_CTE_mode.desc"/>
            <Literal name="DER in CTE mode but RTS not authorized"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.DER_in_CTE_mode_but_RTS_not_authorized.desc"/>
            <Literal name="DER in CTE, RTS auth and not requested"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.DER_in_CTE,_RTS_auth_and_not_requested.desc"/>
            <Literal name="RTS authorized and requested"
                  literalVal="6"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateKind.RTS_authorized_and_requested.desc"/>
         </Enumeration>
         <Enumeration name="CeasetoEnergizeStateTransitionKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateTransitionKind.cl.title">
            <Literal name="Cease to energize"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateTransitionKind.Cease_to_energize.desc"/>
            <Literal name="Return to service"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::CeasetoEnergizeStateTransitionKind.Return_to_service.desc"/>
         </Enumeration>
         <Enumeration name="ChargeSourceKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ChargeSourceKind.cl.title">
            <Literal name="Mode A"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::ChargeSourceKind.Mode_A.desc"/>
            <Literal name="Mode B"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::ChargeSourceKind.Mode_B.desc"/>
            <Literal name="Mode C"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::ChargeSourceKind.Mode_C.desc"/>
         </Enumeration>
         <Enumeration name="CHPEnergyConverterKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::CHPEnergyConverterKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Gas turbine" literalVal="1"/>
            <Literal name="Fuel cell" literalVal="2"/>
            <Literal name="Reciprocating engine" literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Unknown" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="CHPGeneratorKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::CHPGeneratorKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Rotating" literalVal="1"/>
            <Literal name="Inverter" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Unknown" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="CHPOperatingModeKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::CHPOperatingModeKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Heat-production driven" literalVal="1"/>
            <Literal name="Electrical generation driven" literalVal="2"/>
            <Literal name="Combined heat and generation driven" literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Unknown" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="CoolingMethodKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::CoolingMethodKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Passive air cooling (heatsink)" literalVal="1"/>
            <Literal name="Forced air cooling (fan + heatsink)" literalVal="2"/>
            <Literal name="Fluid cooling (water)" literalVal="3"/>
            <Literal name="Heat pipe" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="DERStateKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::DERStateKind.cl.title">
            <Literal name="on but disconnected and not ready" literalVal="1"/>
            <Literal name="starting up" literalVal="2"/>
            <Literal name="disconnected and available" literalVal="3"/>
            <Literal name="disconnected and authorized" literalVal="4"/>
            <Literal name="synchronizing" literalVal="5"/>
            <Literal name="running" literalVal="6"/>
            <Literal name="stopping and disconnecting under emergency conditions"
                  literalVal="7"/>
            <Literal name="stopping" literalVal="8"/>
            <Literal name="disconnected and blocked"
                  literalVal="9"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateKind.disconnected_and_blocked.desc"/>
            <Literal name="disconnected and in maintenance"
                  literalVal="10"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateKind.disconnected_and_in_maintenance.desc"/>
            <Literal name="failed" literalVal="11"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="DERStateTransitionKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.cl.title">
            <Literal name="Start"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Start.desc"/>
            <Literal name="Connect"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Connect.desc"/>
            <Literal name="Disconnect"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Disconnect.desc"/>
            <Literal name="Disconnect under emergency conditions"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Disconnect_under_emergency_conditions.desc"/>
            <Literal name="Get blocked"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Get_blocked.desc"/>
            <Literal name="Get unblocked"
                  literalVal="6"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Get_unblocked.desc"/>
            <Literal name="Go to maintenance"
                  literalVal="7"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Go_to_maintenance.desc"/>
            <Literal name="Go out of maintenance"
                  literalVal="8"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Go_out_of_maintenance.desc"/>
            <Literal name="Stop"
                  literalVal="9"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Stop.desc"/>
            <Literal name="Turn off controller"
                  literalVal="10"
                  descID="IEC61850_7_420.DOEnums_7_420::DERStateTransitionKind.Turn_off_controller.desc"/>
         </Enumeration>
         <Enumeration name="DERSynchronizationKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::DERSynchronizationKind.cl.title">
            <Literal name="Unavailable to connect" literalVal="1"/>
            <Literal name="Not synchronized, available to connect" literalVal="2"/>
            <Literal name="In synchronization process" literalVal="3"/>
            <Literal name="Synchronized and not connected" literalVal="4"/>
            <Literal name="Synchronized and connected" literalVal="5"/>
            <Literal name="Synchronization failure" literalVal="6"/>
            <Literal name="Disconnecting from grid" literalVal="7"/>
            <Literal name="Not applicable or Unknown" literalVal="98"/>
         </Enumeration>
         <Enumeration name="DERUnitKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::DERUnitKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Diesel / gas engine" literalVal="1"/>
            <Literal name="Gas Turbine engine" literalVal="2"/>
            <Literal name="PV" literalVal="3"/>
            <Literal name="PV plus Storage" literalVal="4"/>
            <Literal name="Lithium Ion Battery Storage" literalVal="5"/>
            <Literal name="Fuel cell" literalVal="6"/>
            <Literal name="Hydro generator" literalVal="7"/>
            <Literal name="Wind turbine" literalVal="8"/>
            <Literal name="Flow battery storage" literalVal="9"/>
            <Literal name="Air compression storage" literalVal="10"/>
            <Literal name="Flywheel storage" literalVal="11"/>
            <Literal name="Capacitor storage" literalVal="12"/>
            <Literal name="Vehicle-to-Grid (V2G)" literalVal="13"/>
            <Literal name="Mixed, hybrid DER" literalVal="50"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="ECPConnKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ECPConnKind.cl.title">
            <Literal name="PoC: Electric point positioned at the connection of the DER to its local EPS"
                  literalVal="1"/>
            <Literal name="IntDER: Electric point positioned internally to the DER"
                  literalVal="2"/>
            <Literal name="PCC: Electric point positioned at the connection of local EPS to area EPS - the EPS contains DERs including local loads"
                  literalVal="3"/>
            <Literal name="PCCD: specific PCC when the EPS contains only DERs with no loads"
                  literalVal="4"/>
            <Literal name="PoCoL: Electric point positioned at the connection of load within the DER local EPS"
                  literalVal="5"/>
            <Literal name="ExtPCC: Electric point positioned at the connection to a PCC external to the area EPS"
                  literalVal="6"/>
            <Literal name="ExtPoC: Electric point positioned at the connection of DER within local EPS outside of the DER local EPS"
                  literalVal="7"/>
            <Literal name="AuxLoad: Connection of auxilliary load to DER" literalVal="8"/>
            <Literal name="PoCG: Connection of group of possibly different types of DERs to local EPS"
                  literalVal="9"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="ECPIslandStateKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ECPIslandStateKind.cl.title">
            <Literal name="Factory configuration (from vendor)" literalVal="1"/>
            <Literal name="Default configuration (after installation)" literalVal="2"/>
            <Literal name="Normal grid-connected configuration" literalVal="3"/>
            <Literal name="Islanded condition 1 (local island behind the PCC)"
                  literalVal="4"/>
            <Literal name="Islanded condition 2 (islanded at PCC)" literalVal="5"/>
            <Literal name="Islanded condition 3 (multiple PCC regional island)"
                  literalVal="6"/>
            <Literal name="1st Alternate grid-connected configuration" literalVal="7"/>
            <Literal name="2nd Alternate grid-connected configuration" literalVal="8"/>
            <Literal name="3rd Alternate grid-connected configuration" literalVal="9"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="EquipmentTestResultKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::EquipmentTestResultKind.cl.title">
            <Literal name="unavailable"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::EquipmentTestResultKind.unavailable.desc"/>
            <Literal name="success"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::EquipmentTestResultKind.success.desc"/>
            <Literal name="fault (bad)"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::EquipmentTestResultKind.fault_(bad).desc"/>
            <Literal name="test running"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::EquipmentTestResultKind.test_running.desc"/>
            <Literal name="test aborted" literalVal="5"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="ExciterKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ExciterKind.cl.title">
            <Literal name="DC"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::ExciterKind.DC.desc"/>
            <Literal name="AC"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::ExciterKind.AC.desc"/>
         </Enumeration>
         <Enumeration name="FrequencyActivePowerRefParamKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::FrequencyActivePowerRefParamKind.cl.title">
            <Literal name="Active power as absolute value" literalVal="1"/>
            <Literal name="Active power as percent of maximum active power"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::FrequencyActivePowerRefParamKind.Active_power_as_percent_of_maximum_active_power.desc"/>
            <Literal name="Active power as percent of snapshot active power reference"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::FrequencyActivePowerRefParamKind.Active_power_as_percent_of_snapshot_active_power_reference.desc"/>
            <Literal name="Active power as percent of the available range active power"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::FrequencyActivePowerRefParamKind.Active_power_as_percent_of_the_available_range_active_power.desc"/>
            <Literal name="Active power as percent of the full range active power"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::FrequencyActivePowerRefParamKind.Active_power_as_percent_of_the_full_range_active_power.desc"/>
         </Enumeration>
         <Enumeration name="FuelDeliveryKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::FuelDeliveryKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Passive" literalVal="1"/>
            <Literal name="Pump" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="FuelKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::FuelKind.cl.title">
            <Literal name="BIT"
                  literalVal="0"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.BIT.desc"/>
            <Literal name="LIG"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.LIG.desc"/>
            <Literal name="SUB"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.SUB.desc"/>
            <Literal name="WC"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WC.desc"/>
            <Literal name="SC"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.SC.desc"/>
            <Literal name="DFO"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.DFO.desc"/>
            <Literal name="JF"
                  literalVal="6"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.JF.desc"/>
            <Literal name="KER"
                  literalVal="7"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.KER.desc"/>
            <Literal name="PC"
                  literalVal="8"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.PC.desc"/>
            <Literal name="RFO"
                  literalVal="9"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.RFO.desc"/>
            <Literal name="WO"
                  literalVal="10"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WO.desc"/>
            <Literal name="NG"
                  literalVal="11"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.NG.desc"/>
            <Literal name="BFG"
                  literalVal="12"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.BFG.desc"/>
            <Literal name="OG"
                  literalVal="13"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.OG.desc"/>
            <Literal name="PG"
                  literalVal="14"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.PG.desc"/>
            <Literal name="NUC"
                  literalVal="15"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.NUC.desc"/>
            <Literal name="AB"
                  literalVal="16"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.AB.desc"/>
            <Literal name="MSW"
                  literalVal="17"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.MSW.desc"/>
            <Literal name="OBS"
                  literalVal="18"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.OBS.desc"/>
            <Literal name="TDF"
                  literalVal="19"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.TDF.desc"/>
            <Literal name="WDS"
                  literalVal="20"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WDS.desc"/>
            <Literal name="OBL"
                  literalVal="21"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.OBL.desc"/>
            <Literal name="BLQ"
                  literalVal="22"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.BLQ.desc"/>
            <Literal name="SLW"
                  literalVal="23"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.SLW.desc"/>
            <Literal name="WDL"
                  literalVal="24"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WDL.desc"/>
            <Literal name="LFG"
                  literalVal="25"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.LFG.desc"/>
            <Literal name="OBG"
                  literalVal="26"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.OBG.desc"/>
            <Literal name="GEO"
                  literalVal="27"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.GEO.desc"/>
            <Literal name="WAT"
                  literalVal="28"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WAT.desc"/>
            <Literal name="SUN"
                  literalVal="29"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.SUN.desc"/>
            <Literal name="WND"
                  literalVal="30"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WND.desc"/>
            <Literal name="HPS" literalVal="31"/>
            <Literal name="PUR"
                  literalVal="32"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.PUR.desc"/>
            <Literal name="WH"
                  literalVal="33"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.WH.desc"/>
            <Literal name="OTH"
                  literalVal="34"
                  descID="IEC61850_7_420.DOEnums_7_420::FuelKind.OTH.desc"
                  deprecated="true"/>
         </Enumeration>
         <Enumeration name="FuelProcessingInFuelKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::FuelProcessingInFuelKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Hydrogen plus pure oxygen" literalVal="1"/>
            <Literal name="Hydrogen" literalVal="2"/>
            <Literal name="Methanol" literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="FuelProcessingKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::FuelProcessingKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Steam reforming" literalVal="1"/>
            <Literal name="Partial oxidation" literalVal="2"/>
            <Literal name="Autothermal reforming" literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="FuelProcessingOutFuelKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::FuelProcessingOutFuelKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Hydrogen" literalVal="1"/>
            <Literal name="Reformate" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="GroundingSystemKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::GroundingSystemKind.cl.title">
            <Literal name="IT"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::GroundingSystemKind.IT.desc"/>
            <Literal name="TN-S"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::GroundingSystemKind.TN-S.desc"/>
            <Literal name="TN-C"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::GroundingSystemKind.TN-C.desc"/>
            <Literal name="TN-C-S"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::GroundingSystemKind.TN-C-S.desc"/>
            <Literal name="TT"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::GroundingSystemKind.TT.desc"/>
         </Enumeration>
         <Enumeration name="InverterControlSourceKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::InverterControlSourceKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Current-source inverter (CSI)" literalVal="1"/>
            <Literal name="Voltage-controlled voltage-source inverter (VC-VSI)"
                  literalVal="2"/>
            <Literal name="Current-controlled voltage-source inverter (CC-VSI)"
                  literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="InverterSwitchKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::InverterSwitchKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Field effect transistor" literalVal="1"/>
            <Literal name="Insulated gate bipolar transistor" literalVal="2"/>
            <Literal name="Thyristor" literalVal="3"/>
            <Literal name="Gate turn off thyristor" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="IsolationKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::IsolationKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Low frequency transformer isolated" literalVal="1"/>
            <Literal name="Hi frequency transformer isolated" literalVal="2"/>
            <Literal name="Non-isolated, grounded" literalVal="3"/>
            <Literal name="Non-isolated, isolated DC source" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="OutputFilterKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::OutputFilterKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="None" literalVal="1"/>
            <Literal name="Series filter (L)" literalVal="2"/>
            <Literal name="Parallel filter (LC)" literalVal="3"/>
            <Literal name="Series-Parallel (LCL)" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PhaseFeedKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PhaseFeedKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Feeding from N to A" literalVal="1"/>
            <Literal name="Feeding from N to B" literalVal="2"/>
            <Literal name="Feeding from N to C" literalVal="3"/>
            <Literal name="Feeding from A to B" literalVal="4"/>
            <Literal name="Feeding from A to C" literalVal="5"/>
            <Literal name="Feeding from B to A" literalVal="6"/>
            <Literal name="Feeding from B to C" literalVal="7"/>
            <Literal name="Feeding from C to A" literalVal="8"/>
            <Literal name="Feeding from C to B" literalVal="9"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PhaseKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PhaseKind.cl.title">
            <Literal name="Single phase to neutral" literalVal="1"/>
            <Literal name="Split phase" literalVal="2"/>
            <Literal name="2-phase" literalVal="3"/>
            <Literal name="3-phase delta" literalVal="4"/>
            <Literal name="3-phase wye / 4-wires" literalVal="5"/>
            <Literal name="3-phase wye / 5-wires"
                  literalVal="6"
                  descID="IEC61850_7_420.DOEnums_7_420::PhaseKind.3-phase_wye__per__5-wires.desc"/>
            <Literal name="DC" literalVal="9"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="PVArrayControlModeKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVArrayControlModeKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Maximum power point tracking (MPPT)" literalVal="1"/>
            <Literal name="Power limiter controller" literalVal="2"/>
            <Literal name="DC current limit" literalVal="3"/>
            <Literal name="Array voltage control" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PVAssemblyKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVAssemblyKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Array" literalVal="1"/>
            <Literal name="Sub-array" literalVal="2"/>
            <Literal name="String" literalVal="3"/>
            <Literal name="Module" literalVal="4"/>
            <Literal name="Plant" literalVal="5"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PVConfigKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVConfigKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Flat plate" literalVal="1"/>
            <Literal name="Concentrating" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PVControlStateKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVControlStateKind.cl.title">
            <Literal name="Not ready" literalVal="1"/>
            <Literal name="Asleep" literalVal="2"/>
            <Literal name="Awaking up" literalVal="3"/>
            <Literal name="Awake" literalVal="4"/>
            <Literal name="Shutdown / Sleep test" literalVal="5"/>
            <Literal name="Under test" literalVal="6"/>
         </Enumeration>
         <Enumeration name="PVGroundingKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVGroundingKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Positive ground" literalVal="1"/>
            <Literal name="Negative ground" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Not grounded" literalVal="3"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PVTrackingControlKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVTrackingControlKind.cl.title">
            <Literal name="Stop" literalVal="1"/>
            <Literal name="Start tracking" literalVal="2"/>
            <Literal name="Start reference run" literalVal="3"/>
            <Literal name="Go to manual mode" literalVal="4"/>
            <Literal name="Go to stow position" literalVal="5"/>
            <Literal name="Go to storm position" literalVal="6"/>
            <Literal name="Go to snow position" literalVal="7"/>
            <Literal name="Go to night position" literalVal="8"/>
            <Literal name="Go to maintenance position" literalVal="9"/>
         </Enumeration>
         <Enumeration name="PVTrackingKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Fixed"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Fixed.desc"/>
            <Literal name="Vertical"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Vertical.desc"/>
            <Literal name="Inclined"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Inclined.desc"/>
            <Literal name="Hor Ver"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Hor_Ver.desc"/>
            <Literal name="Horizontal"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Horizontal.desc"/>
            <Literal name="Hor Hor NS"
                  literalVal="6"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Hor_Hor_NS.desc"/>
            <Literal name="Hor Hor ES"
                  literalVal="7"
                  descID="IEC61850_7_420.DOEnums_7_420::PVTrackingKind.Hor_Hor_ES.desc"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PVTrackingStatusKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVTrackingStatusKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Stopped" literalVal="1"/>
            <Literal name="Automatic tracking in progress" literalVal="2"/>
            <Literal name="Reference run completed" literalVal="4"/>
            <Literal name="Manual mode" literalVal="5"/>
            <Literal name="Reference run in progress" literalVal="3"/>
            <Literal name="Going to position" literalVal="6"/>
            <Literal name="In target position" literalVal="7"/>
            <Literal name="In stow position" literalVal="8"/>
            <Literal name="In storm position" literalVal="9"/>
            <Literal name="In snow position" literalVal="10"/>
            <Literal name="In night position" literalVal="11"/>
            <Literal name="In maintenance position" literalVal="12"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="PVTrackingTechnologyKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::PVTrackingTechnologyKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Sensory tracking" literalVal="1"/>
            <Literal name="Astronomical tracking" literalVal="2"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="QuadrantRunningStateKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::QuadrantRunningStateKind.cl.title">
            <Literal name="P greater than zero, Q greater than zero" literalVal="1"/>
            <Literal name="P less than zero, Q greater than zero" literalVal="2"/>
            <Literal name="P less than zero, Q less than zero" literalVal="3"/>
            <Literal name="P greater than zero, Q less than zero" literalVal="4"/>
            <Literal name="P equals zero, Q greater than zero" literalVal="5"/>
            <Literal name="P equals zero, Q less than zero" literalVal="6"/>
            <Literal name="P greater than zero, Q equals zero" literalVal="7"/>
            <Literal name="P less than zero, Q equals zero" literalVal="8"/>
            <Literal name="P equals zero, Q equals zero"
                  literalVal="9"
                  descID="IEC61850_7_420.DOEnums_7_420::QuadrantRunningStateKind.P_equals_zero,_Q_equals_zero.desc"/>
         </Enumeration>
         <Enumeration name="ReactivePowerRefParamKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ReactivePowerRefParamKind.cl.title">
            <Literal name="Reactive power in percent of WMax"
                  literalVal="1"
                  descID="IEC61850_7_420.DOEnums_7_420::ReactivePowerRefParamKind.Reactive_power_in_percent_of_WMax.desc"/>
            <Literal name="Reactive power in percent of VArMax"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::ReactivePowerRefParamKind.Reactive_power_in_percent_of_VArMax.desc"/>
            <Literal name="Reactive power in percent of VArAvl"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::ReactivePowerRefParamKind.Reactive_power_in_percent_of_VArAvl.desc"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
         </Enumeration>
         <Enumeration name="ThermalEnergyMediumKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ThermalEnergyMediumKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Water" literalVal="1"/>
            <Literal name="Steam" literalVal="2"/>
            <Literal name="Air" literalVal="3"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="ThermalEnergyStorageKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::ThermalEnergyStorageKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="For heating with storage" literalVal="1"/>
            <Literal name="For heating without storage" literalVal="2"/>
            <Literal name="For cooling with storage" literalVal="3"/>
            <Literal name="For cooling without storage" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="VoltageActivePowerRefParamKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::VoltageActivePowerRefParamKind.cl.title">
            <Literal name="Active power as absolute value" literalVal="1"/>
            <Literal name="Active power as percent of maximum active power"
                  literalVal="2"
                  descID="IEC61850_7_420.DOEnums_7_420::VoltageActivePowerRefParamKind.Active_power_as_percent_of_maximum_active_power.desc"/>
            <Literal name="Active power as percent of snapshot active power reference"
                  literalVal="3"
                  descID="IEC61850_7_420.DOEnums_7_420::VoltageActivePowerRefParamKind.Active_power_as_percent_of_snapshot_active_power_reference.desc"/>
            <Literal name="Active power as percent of the available range active power"
                  literalVal="4"
                  descID="IEC61850_7_420.DOEnums_7_420::VoltageActivePowerRefParamKind.Active_power_as_percent_of_the_available_range_active_power.desc"/>
            <Literal name="Active power as percent of the full range active power"
                  literalVal="5"
                  descID="IEC61850_7_420.DOEnums_7_420::VoltageActivePowerRefParamKind.Active_power_as_percent_of_the_full_range_active_power.desc"/>
         </Enumeration>
         <Enumeration name="VoltageRegulationKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::VoltageRegulationKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="Regulated output: fixed voltage" literalVal="1"/>
            <Literal name="Regulated output: variable voltage" literalVal="2"/>
            <Literal name="Filtered output: load dependent" literalVal="3"/>
            <Literal name="Unregulated and unfiltered" literalVal="4"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
         <Enumeration name="WaveformConditioningKind"
                   titleID="IEC61850_7_420.DOEnums_7_420::WaveformConditioningKind.cl.title">
            <Literal name="Not applicable or Unknown" literalVal="0" deprecated="true"/>
            <Literal name="None" literalVal="1"/>
            <Literal name="EMI filter" literalVal="2"/>
            <Literal name="Line filter" literalVal="3"/>
            <Literal name="EMI/Line filter" literalVal="4"/>
            <Literal name="Unified power factor" literalVal="5"/>
            <Literal name="Not applicable or not known" literalVal="98"/>
            <Literal name="Other" literalVal="99" deprecated="true"/>
         </Enumeration>
      </Enumerations>
   <LNClasses>
         <AbstractLNClass name="DEResourceLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::DEResourceLN.cl.title"
                       base="AllEnergyDEResourceLN"/>
         <AbstractLNClass name="AllEnergyDEResourceLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::AllEnergyDEResourceLN.cl.title"
                       base="ControlEquipmentInterfaceLN">
            <DataObject name="DERId"
                     type="VSG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::AllEnergyDEResourceLN.DERId.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="DER_NameplateRatingsLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.cl.title"
                       base="DEResourceLN">
            <DataObject name="OutEcpRef"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.OutEcpRef.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EcpConnTyp"
                     type="ENG"
                     underlyingType="ECPConnKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.EcpConnTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhsConnTyp"
                     type="ENG"
                     underlyingType="PhaseKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.PhsConnTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DERTyp"
                     type="ENG"
                     underlyingType="DERUnitKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.DERTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OvPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.OvPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.UnPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TmpMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.TmpMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FltRtgPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.FltRtgPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndReactRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.GndReactRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FltAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.FltAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelfVRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.SelfVRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FltDurMaxTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.FltDurMaxTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelfWRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.SelfWRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelfPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.SelfPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RvSeq"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.RvSeq.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelfVRngRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.SelfVRngRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EfcRtgPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.EfcRtgPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndRisRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.GndRisRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SuscRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.SuscRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RegClas"
                     type="VSG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.RegClas.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="HzNomRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.HzNomRtg.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="HzMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.HzMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_NameplateRatingsLN.HzMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="DER_StateAbstractLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.cl.title"
                       base="DER_ActualPowerInformationLN">
            <DataObject name="DEROpSt"
                     type="ENS"
                     underlyingType="DERStateKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.DEROpSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="TestRsl"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.TestRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TestAddRsl"
                     type="ENS"
                     underlyingType="EquipmentTestResultKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.TestAddRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AuthConn"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.AuthConn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DEROpStCtl"
                     type="ENC"
                     underlyingType="DERStateTransitionKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.DEROpStCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CeaEgzCtl"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.CeaEgzCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WSpt"
                     type="APC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.WSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VArSpt"
                     type="APC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.VArSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EmgMod"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.EmgMod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AuthDscon"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.AuthDscon.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TestEna"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.TestEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Test"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.Test.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrMaxTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.StrMaxTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OffMinTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.OffMinTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OnMinTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.OnMinTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StopDlMinTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.StopDlMinTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StopMaxTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.StopMaxTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrDlMinTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.StrDlMinTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AutoStr"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.AutoStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AutoConn"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_StateAbstractLN.AutoConn.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="DER_ActualPowerInformationLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::DER_ActualPowerInformationLN.cl.title"
                       base="DER_OperationalSettingsLN">
            <DataObject name="SelfSvcWh"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_ActualPowerInformationLN.SelfSvcWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VAPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_ActualPowerInformationLN.VAPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlUpW"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_ActualPowerInformationLN.AvlUpW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlDnW"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_ActualPowerInformationLN.AvlDnW.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="DER_OperationalSettingsLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.cl.title"
                       base="DER_NameplateRatingsLN">
            <DataObject name="PFSign"
                     type="ENG"
                     underlyingType="PFSignKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.PFSign.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OplPct"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.OplPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OvPF"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.OvPF.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PFExtSet"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.PFExtSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IsldCtlFol"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.IsldCtlFol.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ClcTotVA"
                     type="ENG"
                     underlyingType="STotalCalcMethodKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.ClcTotVA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FllBckTmExp"
                     type="ING"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.FllBckTmExp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AvarZerWMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.AvarZerWMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IvarZerWMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::DER_OperationalSettingsLN.IvarZerWMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="NonStorageOperationalSettingsLN"
                       titleID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.cl.title"
                       base="DER_StateAbstractLN">
            <DataObject name="VArTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VArTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvarTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.AvarTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="IvarTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.IvarTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VArAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VArAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvarAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.AvarAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="IvarAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.IvarAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.WMax.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WOvPFMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.WOvPFMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WUnPFMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.WUnPFMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRmp"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.WRmp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VArMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VArMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AvarMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.AvarMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IvarMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.IvarMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VMax.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.AMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VAMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VAMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AvaMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.AvaMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IvaMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.IvaMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArSptRef"
                     type="ENG"
                     underlyingType="ReactivePowerRefParamKind"
                     descID="IEC61850_7_420.AbstractDerLNs_7_420::NonStorageOperationalSettingsLN.VArSptRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ElectricalReferenceLN"
                       titleID="IEC61850_7_420.AbstractEcpLNs_7_420::ElectricalReferenceLN.cl.title"
                       base="FunctionLN">
            <DataObject name="ElcStCtlRef"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::ElectricalReferenceLN.ElcStCtlRef.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="ElcRefId"
                     type="VSG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::ElectricalReferenceLN.ElcRefId.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ElcMsRef"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::ElectricalReferenceLN.ElcMsRef.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="PhysicalElectricalConnectionPointLN"
                       titleID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.cl.title"
                       base="ElectricalReferenceLN">
            <DataObject name="EcpIsldSt"
                     type="ENS"
                     underlyingType="ECPIslandStateKind"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.EcpIsldSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhsConnTyp"
                     type="ENG"
                     underlyingType="PhaseKind"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.PhsConnTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GndSys"
                     type="ENG"
                     underlyingType="GroundingSystemKind"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.GndSys.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRef"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VRef.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VRefPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VRefPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VArRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VARtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.WRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzNom"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.HzNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.VMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DERMsIncl"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.DERMsIncl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RefFrm"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.RefFrm.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EcpIsldAuto"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::PhysicalElectricalConnectionPointLN.EcpIsldAuto.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="VirtualElectricalReferenceLN"
                       titleID="IEC61850_7_420.AbstractEcpLNs_7_420::VirtualElectricalReferenceLN.cl.title"
                       base="ElectricalReferenceLN">
            <DataObject name="InclElcRef"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractEcpLNs_7_420::VirtualElectricalReferenceLN.InclElcRef.desc"
                     presCond="Mmulti"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="DER_GeneratorLN"
                       titleID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.cl.title"
                       base="GeneratorNameplateRatingsLN">
            <DataObject name="GnSynSt"
                     type="ENS"
                     underlyingType="DERSynchronizationKind"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnSynSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RmpLodSw"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.RmpLodSw.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TotStrCnt"
                     type="INS"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.TotStrCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RemExpcOpTms"
                     type="INS"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.RemExpcOpTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CnstWMax"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.CnstWMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnOpTm"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnOpTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnStabTm"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnStabTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnClDnTm"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnClDnTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AutoVRegPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.AutoVRegPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnEnTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnEnTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnEnPer"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnEnPer.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RenWPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.RenWPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="RenVArPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.RenVArPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnOnCnt"
                     type="INC"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnOnCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PerStrCnt"
                     type="INC"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.PerStrCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OpTms"
                     type="INC"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.OpTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnEnPerRs"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::DER_GeneratorLN.GnEnPerRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="GeneratorUnitLN"
                       titleID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorUnitLN.cl.title"
                       base="ControlEquipmentInterfaceLN"/>
         <AbstractLNClass name="GeneratorNameplateRatingsLN"
                       titleID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.cl.title"
                       base="NonStorageOperationalSettingsLN">
            <DataObject name="WMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.WMaxRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WOvPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.WOvPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WUnPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.WUnPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.VAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.VArMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AvarMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.AvarMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IvarMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.IvarMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.AMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.VMaxRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.VMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ConsWMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.ConsWMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ConsWMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.ConsWMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EmgWMinRtg"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.EmgWMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EmgWMaxRtg"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.EmgWMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DsconWMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.DsconWMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRpuMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.WRpuMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRpdMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.WRpdMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtbWMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.CtbWMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtbVArMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.CtbVArMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WCtb"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.WCtb.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArCtb"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.VArCtb.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RenWMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.RenWMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RenVArMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractGenLNs_7_420::GeneratorNameplateRatingsLN.RenVArMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="StorageOperationalSettingsLN"
                       titleID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.cl.title"
                       base="DER_StateAbstractLN">
            <DataObject name="ChaAvarTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaAvarTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschAvarTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschAvarTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaIvarTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaIvarTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschIvarTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschIvarTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaAvarAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaAvarAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschAvarAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschAvarAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaIvarAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaIvarAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschIvarAvl"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschIvarAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EffWh"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.EffWh.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="EffWhPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.EffWhPct.desc"
                     presCond="AtLeastOne"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="ChaWMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaWMax.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DschWMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschWMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWRmp"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaWRmp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWRmp"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschWRmp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVArMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaVArMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVArMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschVArMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVAMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaVAMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVAMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschVAMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAvarMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaAvarMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAvarMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschAvarMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaIvarMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaIvarMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschIvarMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschIvarMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaVMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschVMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaVMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschVMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaAMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschAMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaEfc"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaEfc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschEfc"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschEfc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UseWhMaxPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.UseWhMaxPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UseWhMinPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.UseWhMinPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UseWh"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.UseWh.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaSrc"
                     type="ENG"
                     underlyingType="ChargeSourceKind"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaSrc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWOvPFMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaWOvPFMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWOvPFMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschWOvPFMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWUnPFMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.ChaWUnPFMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWUnPFMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.DschWUnPFMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RenChaEna"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageOperationalSettingsLN.RenChaEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="StorageNameplateRatingsLN"
                       titleID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.cl.title"
                       base="StorageOperationalSettingsLN">
            <DataObject name="ChaWMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaWMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschWMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWRmpRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaWRmpRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWRmpRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschWRmpRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWOvPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaWOvPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWOvPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschWOvPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWUnPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaWUnPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWUnPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschWUnPFRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaVAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschVAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAvarRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaAvarRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAvarRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschAvarRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaIvarRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaIvarRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschIvarRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschIvarRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaVMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschVMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaVMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschVMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschVMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WhRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.WhRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WhMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.WhMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WhMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.WhMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaEfcRtg"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaEfcRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschEfcRtg"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.DschEfcRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaSrcRtg"
                     type="ENG"
                     underlyingType="ChargeSourceKind"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::StorageNameplateRatingsLN.ChaSrcRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="DER_StorageLN"
                       titleID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.cl.title"
                       base="StorageNameplateRatingsLN">
            <DataObject name="SocHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocHiWrn"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocHiWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocLoWrn"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocLoWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SohLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SohLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaCycCnt"
                     type="INS"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.ChaCycCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InWh"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.InWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutWh"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.OutWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SocWh"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="UseSocPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.UseSocPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SocEffWhPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocEffWhPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaWhTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.ChaWhTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschWhTot"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.DschWhTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlDschW"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.AvlDschW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlChaW"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.AvlChaW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaVAPct"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.ChaVAPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlChaWTm"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.AvlChaWTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlDschWTm"
                     type="MV"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.AvlDschWTm.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaWhTotRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.ChaWhTotRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWhTotRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.DschWhTotRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqGn"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.EqGn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqLod"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.EqLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocHiAlsPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocHiAlsPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocHiWrsPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocHiWrsPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocLoAlsPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocLoAlsPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocLoWrsPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SocLoWrsPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SohLoAlsPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.SohLoAlsPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RntEffPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractStoLNs_7_420::DER_StorageLN.RntEffPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="StorageUnitLN"
                       titleID="IEC61850_7_420.AbstractStoLNs_7_420::StorageUnitLN.cl.title"
                       base="ControlEquipmentInterfaceLN"/>
         <AbstractLNClass name="DER_LoadLN"
                       titleID="IEC61850_7_420.AbstractLodLNs_7_420::DER_LoadLN.cl.title"
                       base="LoadNameplateRatingsLN"/>
         <AbstractLNClass name="LoadNameplateRatingsLN"
                       titleID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.cl.title"
                       base="NonStorageOperationalSettingsLN">
            <DataObject name="WMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.WMaxRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WOvPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.WOvPFRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WUnPFRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.WUnPFRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.VMaxRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.VMinRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.AMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VAMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.VAMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRpuMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.WRpuMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRpdMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLodLNs_7_420::LoadNameplateRatingsLN.WRpdMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="LoadUnitLN"
                       titleID="IEC61850_7_420.AbstractLodLNs_7_420::LoadUnitLN.cl.title"
                       base="ControlEquipmentInterfaceLN"/>
         <AbstractLNClass name="DERConverterLN"
                       titleID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.cl.title"
                       base="BaseConverterLN">
            <DataObject name="DCPwrSt"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.DCPwrSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TestRsl"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.TestRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TestAddRsl"
                     type="ENS"
                     underlyingType="EquipmentTestResultKind"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.TestAddRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DCPwrBlk"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.DCPwrBlk.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Test"
                     type="SPC"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.Test.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WSpt"
                     type="APC"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.WSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VArSpt"
                     type="APC"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.VArSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CmutSelf"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.CmutSelf.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ClMthTyp"
                     type="ENG"
                     underlyingType="CoolingMethodKind"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.ClMthTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IsoTyp"
                     type="ENG"
                     underlyingType="IsolationKind"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.IsoTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ACTyp"
                     type="ENG"
                     underlyingType="ACSystemKind"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.ACTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InAMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.InAMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InVMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.InVMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutWSet"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractOtherLNs_7_420::DERConverterLN.OutWSet.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="LowPassFilterOnFunctionInputLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionInputLN.cl.title"
                       base="OperationalFunctionLN">
            <DataObject name="InFilByp"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionInputLN.InFilByp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RspTmms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionInputLN.RspTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="LowPassFilterOnFunctionOutputLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionOutputLN.cl.title"
                       base="LowPassFilterOnFunctionInputLN">
            <DataObject name="OutFilByp"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionOutputLN.OutFilByp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OplTmsMax"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionOutputLN.OplTmsMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OplTmsMin"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::LowPassFilterOnFunctionOutputLN.OplTmsMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ElectricalContextReferenceLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ElectricalContextReferenceLN.cl.title"
                       base="ControlledLN">
            <DataObject name="InEcpRef"
                     type="ORG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ElectricalContextReferenceLN.InEcpRef.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EcpConnTyp"
                     type="ENG"
                     underlyingType="ECPConnKind"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ElectricalContextReferenceLN.EcpConnTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="OperationalFunctionLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.cl.title"
                       base="ElectricalContextReferenceLN">
            <DataObject name="RvrtTmExp"
                     type="SPS"
                     transient="true"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.RvrtTmExp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ModPrio"
                     type="INC"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.ModPrio.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ActDlTmms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.ActDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WinTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.WinTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RvrtTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.RvrtTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RmpTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.RmpTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ModPsAcc"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.ModPsAcc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ModNgAcc"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.ModNgAcc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocUseMaxPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.SocUseMaxPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SocUseMinPct"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::OperationalFunctionLN.SocUseMinPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="RampRatesLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.cl.title"
                       base="LowPassFilterOnFunctionOutputLN">
            <DataObject name="RmpRteUse"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.RmpRteUse.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="RpuMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.RpuMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RpdMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.RpdMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaRpuMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.ChaRpuMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaRpdMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.ChaRpdMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EmgRpuMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.EmgRpuMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EmgRpdMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.EmgRpdMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaEmgRpuMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.ChaEmgRpuMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaEmgRpdMax"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.ChaEmgRpdMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RpuMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.RpuMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RpdMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::RampRatesLN.RpdMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ActivePowerLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.cl.title"
                       base="RampRatesLN">
            <DataObject name="SocExpcTms"
                     type="INS"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.SocExpcTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqW"
                     type="MV"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.ReqW.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="SocExpc"
                     type="MV"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.SocExpc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SocWhExpc"
                     type="MV"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.SocWhExpc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WSpt"
                     type="APC"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.WSpt.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="WSptPct"
                     type="APC"
                     descID="IEC61850_7_420.AbstractLNs7_420_Op_Functions::ActivePowerLN.WSptPct.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
         </AbstractLNClass>
         <AbstractLNClass name="HysteresisSnapshotLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.cl.title"
                       base="RampRatesLN">
            <DataObject name="WRef"
                     type="MV"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.WRef.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqW"
                     type="MV"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.ReqW.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="HysEna"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.HysEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SnptBarEna"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.SnptBarEna.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrDlTmms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.StrDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StopDlTmms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.StopDlTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WMaxRefEna"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.WMaxRefEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FilTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.FilTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RtnRmpRte"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::HysteresisSnapshotLN.RtnRmpRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="FrequencyActivePowerLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.cl.title"
                       base="HysteresisSnapshotLN">
            <DataObject name="HzWCrv"
                     type="CSG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.HzWCrv.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="HzWCrvRef"
                     type="ENG"
                     underlyingType="FrequencyActivePowerRefParamKind"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.HzWCrvRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WGra"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.WGra.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="F"/>
            <DataObject name="HzRef"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.HzRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzStr"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.HzStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzStop"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.HzStop.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaWGra"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.ChaWGra.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="F"/>
            <DataObject name="HzChgRteTms"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::FrequencyActivePowerLN.HzChgRteTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="RideThroughLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.cl.title"
                       base="OperationalFunctionLN">
            <DataObject name="ModRtSt"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.ModRtSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="TrZnSt"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.TrZnSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CeaZnSt"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.CeaZnSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PrmZnSt"
                     type="SPS"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.PrmZnSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RtRs"
                     type="INC"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.RtRs.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EvtStopTm"
                     type="ING"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.EvtStopTm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PreScCapMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.PreScCapMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PstScCapMin"
                     type="ASG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::RideThroughLN.PstScCapMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ReactivePowerLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ReactivePowerLN.cl.title"
                       base="RampRatesLN">
            <DataObject name="ReqVAr"
                     type="MV"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ReactivePowerLN.ReqVAr.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="VArTgtSpt"
                     type="APC"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ReactivePowerLN.VArTgtSpt.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="VArTgtSptPct"
                     type="APC"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ReactivePowerLN.VArTgtSptPct.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
            <DataObject name="VArSptRef"
                     type="ENG"
                     underlyingType="ReactivePowerRefParamKind"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ReactivePowerLN.VArSptRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArAct"
                     type="SPG"
                     descID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ReactivePowerLN.VArAct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </AbstractLNClass>
         <AbstractLNClass name="ActivePowerLimitLN"
                       titleID="IEC61850_7_420.AbstractLNs7_420GridCodeModes::ActivePowerLimitLN.cl.title"
                       base="RampRatesLN"/>
         <LNClass name="DECP"
               titleID="IEC61850_7_420.ECP_LNs::DECP.cl.title"
               base="PhysicalElectricalConnectionPointLN"/>
         <LNClass name="DPCC"
               titleID="IEC61850_7_420.ECP_LNs::DPCC.cl.title"
               base="PhysicalElectricalConnectionPointLN">
            <DataObject name="AreaEpsEcpId"
                     type="VSG"
                     descID="IEC61850_7_420.ECP_LNs::DPCC.AreaEpsEcpId.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="AreaEpsWMax"
                     type="ASG"
                     descID="IEC61850_7_420.ECP_LNs::DPCC.AreaEpsWMax.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DVER"
               titleID="IEC61850_7_420.ECP_LNs::DVER.cl.title"
               base="VirtualElectricalReferenceLN"/>
         <LNClass name="DPMC"
               titleID="IEC61850_7_420.DERPowerManagementLN::DPMC.cl.title"
               base="ControllingLN">
            <DataObject name="PFExtQudEsp"
                     type="SPS"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.PFExtQudEsp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ReqPFExtQud"
                     type="SPS"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqPFExtQud.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="WTopFct"
                     type="ORS"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.WTopFct.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="VArTopFct"
                     type="ORS"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.VArTopFct.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="PQSt"
                     type="ENS"
                     underlyingType="QuadrantRunningStateKind"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.PQSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DifWEsp"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.DifWEsp.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="DifVArEsp"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.DifVArEsp.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="PFEsp"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.PFEsp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqPF"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqPF.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqW"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqW.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqTotW"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqTotW.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqWMin"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqWMin.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqWMax"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqWMax.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqTotWMin"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqTotWMin.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqTotWMax"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqTotWMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqVAr"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqVAr.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqTotVAr"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqTotVAr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqVArMin"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqVArMin.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqVArMax"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqVArMax.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ReqTotVArMin"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqTotVArMin.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ReqTotVArMax"
                     type="MV"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.ReqTotVArMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.WSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="DifWSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.DifWSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="WMinSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.WMinSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="WMaxSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.WMaxSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="VArSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.VArSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="DifVArSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.DifVArSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="VArMaxSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.VArMaxSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="VArMinSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.VArMinSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="PFSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.PFSpt.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="PFExtQudSpt"
                     type="SPC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.PFExtQudSpt.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="CeaEgzCtl"
                     type="SPC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.CeaEgzCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RenChaEna"
                     type="SPC"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.RenChaEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DERRef"
                     type="ORG"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.DERRef.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OutEcpRef"
                     type="ORG"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.OutEcpRef.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="FctRef"
                     type="ORG"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.FctRef.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="StrWRpuPct"
                     type="ASG"
                     descID="IEC61850_7_420.DERPowerManagementLN::DPMC.StrWRpuPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DMDR"
               titleID="IEC61850_7_420.DERMixedLNs::DMDR.cl.title"
               base="DER_StateAbstractLN">
            <DataObject name="InclDER"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.InclDER.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="InclGn"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.InclGn.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="InclSto"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.InclSto.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="InclLod"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.InclLod.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="EqGn"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.EqGn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqSto"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.EqSto.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqLod"
                     type="ORG"
                     descID="IEC61850_7_420.DERMixedLNs::DMDR.EqLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DGEN"
               titleID="IEC61850_7_420.DERGeneratorLNs::DGEN.cl.title"
               base="DER_GeneratorLN">
            <DataObject name="GnOpSt"
                     type="ENS"
                     underlyingType="DERGeneratorStateKind"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.GnOpSt.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpTmsRs"
                     type="INS"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.OpTmsRs.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="GnH"
                     type="HMV"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.GnH.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="GnCtl"
                     type="DPC"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.GnCtl.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GnRL"
                     type="DPC"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.GnRL.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GnBlk"
                     type="SPC"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.GnBlk.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GnOnCntRs"
                     type="SPC"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.GnOnCntRs.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PerStrCntRs"
                     type="SPC"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.PerStrCntRs.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InclGn"
                     type="ORG"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.InclGn.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="DERUnit"
                     type="ORG"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.DERUnit.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqGn"
                     type="ORG"
                     descID="IEC61850_7_420.DERGeneratorLNs::DGEN.EqGn.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DSTO"
               titleID="IEC61850_7_420.DERStorageLNs::DSTO.cl.title"
               base="DER_StorageLN">
            <DataObject name="EqSto"
                     type="ORG"
                     descID="IEC61850_7_420.DERStorageLNs::DSTO.EqSto.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InclSto"
                     type="ORG"
                     descID="IEC61850_7_420.DERStorageLNs::DSTO.InclSto.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="DERUnit"
                     type="ORG"
                     descID="IEC61850_7_420.DERStorageLNs::DSTO.DERUnit.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DLOD"
               titleID="IEC61850_7_420.DERLoadLNs::DLOD.cl.title"
               base="DER_LoadLN">
            <DataObject name="InclLod"
                     type="ORG"
                     descID="IEC61850_7_420.DERLoadLNs::DLOD.InclLod.desc"
                     presCond="Omulti"
                     dsPresCond="F"/>
            <DataObject name="DERUnit"
                     type="ORG"
                     descID="IEC61850_7_420.DERLoadLNs::DLOD.DERUnit.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EqLod"
                     type="ORG"
                     descID="IEC61850_7_420.DERLoadLNs::DLOD.EqLod.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SBAT"
               titleID="IEC61850_7_420.Battery_LNs::SBAT.cl.title"
               base="SupervisionLN">
            <DataObject name="BatEF"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.BatEF.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelVolLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelVolHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAmpHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.DschAmpHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAmpHiWrn"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.DschAmpHiWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAmpHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ChaAmpHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAmpHiWrn"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ChaAmpHiWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpHiWrn"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpHiWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpLoWrn"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpLoWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbTmpAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbTmpAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbTmpWrn"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbTmpWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbVolAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbVolAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbVolWrn"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbVolWrn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtTmpHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtTmpHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtTmpLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtTmpLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVolHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtVolHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVolLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtVolLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVolHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolLoAlm"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVolLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnA"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="IntnV"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CelVolLo"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolLo.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CelVolHi"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolHi.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CelTmpMax"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelTmpMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CelTmpMin"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelTmpMin.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="IntnAmp"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnAmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="IntnTmp"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmp.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="ExtTmp"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ExtVol"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="IntnVol"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVol.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CelVolRs"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelVolLoAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolLoAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelVolHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.CelVolHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAmpHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.DschAmpHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAmpHiWrs"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.DschAmpHiWrs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAmpHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ChaAmpHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaAmpHiWrs"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ChaAmpHiWrs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpHiWrs"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpHiWrs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpLoAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpLoAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnTmpLoWrs"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnTmpLoWrs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbTmpAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbTmpAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbTmpWrs"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbTmpWrs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbVolAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbVolAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UnbVolWrs"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.UnbVolWrs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtTmpHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtTmpHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtTmpLoAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtTmpLoAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVolHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtVolHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVolLoAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.ExtVolLoAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolMxLim"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVolMxLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolMnLim"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVolMnLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolHiAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVolHiAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolLoAls"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::SBAT.IntnVolLoAls.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DBAT"
               titleID="IEC61850_7_420.Battery_LNs::DBAT.cl.title"
               base="StorageUnitLN">
            <DataObject name="SocPro"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.SocPro.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaSt"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ChaSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschSt"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TestRsl"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.TestRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TestAddRsl"
                     type="ENS"
                     underlyingType="EquipmentTestResultKind"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.TestAddRsl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DCSwCls"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DCSwCls.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BatSt"
                     type="SPS"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.BatSt.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Amp"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.Amp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="Watt"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.Watt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaAmpLim"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ChaAmpLim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EffAhr"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.EffAhr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaVolLim"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ChaVolLim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschAmpLim"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschAmpLim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CelStrgCnt"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.CelStrgCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlChaAhr"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.AvlChaAhr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AvlDschAhr"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.AvlDschAhr.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChaAhrTot"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ChaAhrTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschAhrTot"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschAhrTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SocEffAhrPct"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.SocEffAhrPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SocDvPct"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.SocDvPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VolChgRte"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.VolChgRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DschVolLim"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschVolLim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CycSocRngPct"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.CycSocRngPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CycAmpAv"
                     type="MV"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.CycAmpAv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="BatTest"
                     type="SPC"
                     transient="true"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.BatTest.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BatOn"
                     type="SPC"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.BatOn.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BatTyp"
                     type="ENG"
                     underlyingType="BatteryTypeKind"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.BatTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ChaAmpMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ChaAmpMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AhrRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.AhrRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EffAhrRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.EffAhrRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AhrMinRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.AhrMinRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ChaVolMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ChaVolMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschAmpMxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschAmpMxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVolMaxRtg"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ExtVolMaxRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVolNom"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.ExtVolNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVolNom"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.IntnVolNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntnVNom"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.IntnVNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SelfDschWRte"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.SelfDschWRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelParCnt"
                     type="ING"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.CelParCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelSerCnt"
                     type="ING"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.CelSerCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWattCrv"
                     type="CSG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschWattCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschWattTm"
                     type="CSG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.DschWattTm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BatVNom"
                     type="ASG"
                     descID="IEC61850_7_420.Battery_LNs::DBAT.BatVNom.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DPVA"
               titleID="IEC61850_7_420.PhotovoltaicLNs::DPVA.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="Typ"
                     type="ENG"
                     underlyingType="PVAssemblyKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.Typ.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="GndConn"
                     type="ENG"
                     underlyingType="PVGroundingKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.GndConn.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulCnt"
                     type="ING"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.MdulCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrgCnt"
                     type="ING"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.StrgCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SubArrCnt"
                     type="ING"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.SubArrCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ArrArea"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.ArrArea.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ArrWRtg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.ArrWRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Tilt"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.Tilt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Azi"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVA.Azi.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DPVM"
               titleID="IEC61850_7_420.PhotovoltaicLNs::DPVM.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="AVCrvIx"
                     type="INS"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.AVCrvIx.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MdulCfgTyp"
                     type="ENG"
                     underlyingType="PVConfigKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulCfgTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulAVCrv"
                     type="CSG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulAVCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulWRtg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulWRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulW200Rtg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulW200Rtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxMdulV"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MaxMdulV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxMdulA"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MaxMdulA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulOcV"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulOcV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulScA"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulScA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulWTmpDrt"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulWTmpDrt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulATmpDrt"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulATmpDrt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulVTmpDrt"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulVTmpDrt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MdulDrtPct"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVM.MdulDrtPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DPVC"
               titleID="IEC61850_7_420.PhotovoltaicLNs::DPVC.cl.title"
               base="GeneratorUnitLN">
            <DataObject name="CtlModSt"
                     type="INS"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.CtlModSt.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PVCtlSt"
                     type="ENS"
                     underlyingType="PVControlStateKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.PVCtlSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ArrModCtl"
                     type="ENC"
                     underlyingType="PVArrayControlModeKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.ArrModCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkRefV"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkRefV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkWkupV"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkWkupV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkDlWkupTms"
                     type="ING"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkDlWkupTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkDlSlpTms"
                     type="ING"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkDlSlpTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkSlpW"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkSlpW.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkRte"
                     type="ING"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkVStep"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DPVC.TrkVStep.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DTRC"
               titleID="IEC61850_7_420.PhotovoltaicLNs::DTRC.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="TrkAlm"
                     type="SPS"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.TrkAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="TrkSt"
                     type="ENS"
                     underlyingType="PVTrackingStatusKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.TrkSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AziDeg"
                     type="MV"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.AziDeg.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ElDeg"
                     type="MV"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.ElDeg.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TrkCtl"
                     type="ENC"
                     underlyingType="PVTrackingControlKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.TrkCtl.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="TrkTyp"
                     type="ENG"
                     underlyingType="PVTrackingKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.TrkTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="TrkTech"
                     type="ENG"
                     underlyingType="PVTrackingTechnologyKind"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.TrkTech.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StowAziDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.StowAziDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StowElDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.StowElDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StormAziDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.StormAziDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StormElDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.StormElDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SnwAziDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.SnwAziDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SnwElDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.SnwElDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NightAziDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.NightAziDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NightElDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.NightElDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaintAziDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.MaintAziDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaintElDeg"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.MaintElDeg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntvAzi"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.IntvAzi.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntvEl"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.IntvEl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="IntvTm"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.IntvTm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AziDegTgt"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.AziDegTgt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ElDegTgt"
                     type="ASG"
                     descID="IEC61850_7_420.PhotovoltaicLNs::DTRC.ElDegTgt.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DCIP"
               titleID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.cl.title"
               base="GeneratorUnitLN">
            <DataObject name="EngOnOff"
                     type="SPS"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EngOnOff.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="EngSpd"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EngSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EngTorq"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EngTorq.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EngTmDeg"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EngTmDeg.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImpactHzPct"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ImpactHzPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="BlowFlw"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.BlowFlw.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InOxFlwRte"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.InOxFlwRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WstGasFlwRte"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.WstGasFlwRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LubCsmp"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.LubCsmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TrsVLim"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.TrsVLim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbALim"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ImbALim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ImbVLim"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ImbVLim.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HACrvPct"
                     type="HMV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.HACrvPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HVCrvPct"
                     type="HMV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.HVCrvPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChgLimVPct"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ChgLimVPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChgLimAng"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ChgLimAng.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ChgLimRatAng"
                     type="MV"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ChgLimRatAng.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CrankCtl"
                     type="SPC"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.CrankCtl.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DiagEna"
                     type="DPC"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.DiagEna.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EmgCtl"
                     type="DPC"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EmgCtl.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EngCtl"
                     type="DPC"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EngCtl.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HeatRteCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.HeatRteCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NumPle"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.NumPle.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SpdMin"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.SpdMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SpdMax"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.SpdMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SpdNom"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.SpdNom.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SpdTgt"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.SpdTgt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EngTorqTgt"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.EngTorqTgt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WMaxVArCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.WMaxVArCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WMinVArCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.WMinVArCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WVArVLimCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.WVArVLimCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OcDirTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.OcDirTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OcSubDirTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.OcSubDirTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OcSubQudTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.OcSubQudTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ScDirTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ScDirTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ScSubDirTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ScSubDirTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ScSubQudTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ScSubQudTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InerTms"
                     type="ING"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.InerTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InOxFlwTgt"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.InOxFlwTgt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LubCsmpTgt"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.LubCsmpTgt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SttLkgX"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.SttLkgX.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="X0"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.X0.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="X2"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.X2.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xd"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.Xd.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xdp"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.Xdp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xds"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.Xds.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xqs"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.Xqs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xqp"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.Xqp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Xq"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.Xq.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ZerSeqRis"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.ZerSeqRis.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PosSeqRis"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.PosSeqRis.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NgSeqRis"
                     type="ASG"
                     descID="IEC61850_7_420.ReciprocatingEngineLNs::DCIP.NgSeqRis.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DFCL"
               titleID="IEC61850_7_420.FuelCellLNs::DFCL.cl.title"
               base="GeneratorUnitLN">
            <DataObject name="ConnGriCnt"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.ConnGriCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LifeEfcPct"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.LifeEfcPct.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="InstEfcPct"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.InstEfcPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaintTms"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.MaintTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StrCnt"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.StrCnt.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="LifeTms"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.LifeTms.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="FuelCsmp"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.FuelCsmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WtrCsmp"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.WtrCsmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InOxFlwRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.InOxFlwRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WtrLev"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.WtrLev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutH2Rte"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.OutH2Rte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutH2Lev"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.OutH2Lev.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WtrCndct"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.WtrCndct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="LifeWh"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.LifeWh.desc"
                     deprecated="true"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="FuelStop"
                     type="SPC"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.FuelStop.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="StrCntRs"
                     type="SPC"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.StrCntRs.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EmgCtl"
                     type="SPC"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.EmgCtl.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GriIndpWRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.GriIndpWRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GriDepRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.GriDepRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HzRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.HzRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelTyp"
                     type="ENG"
                     underlyingType="FuelKind"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.FuelTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EfcPct"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.EfcPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ALim"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.ALim.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VLim"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.VLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFCL.VRtg.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DSTK"
               titleID="IEC61850_7_420.FuelCellLNs::DSTK.cl.title"
               base="FunctionLN">
            <DataObject name="StcSt"
                     type="SPS"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="CelVTrCnt"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.CelVTrCnt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StcLodTms"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcLodTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="MaintTms"
                     type="INS"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.MaintTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StcWh"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StcEfcPct"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcEfcPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutDCV"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.OutDCV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutDCA"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.OutDCA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InClTmp"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.InClTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutClTmp"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.OutClTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClFlwRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.ClFlwRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ClPres"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.ClPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="H2FlwRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.H2FlwRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InH2Pres"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.InH2Pres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InOxFlwRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.InOxFlwRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InOxPres"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.InOxPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="StcWRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcWRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StcVRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcVRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StcARtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcARtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StcFuelTyp"
                     type="ENG"
                     underlyingType="FuelKind"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.StcFuelTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CelCnt"
                     type="ING"
                     descID="IEC61850_7_420.FuelCellLNs::DSTK.CelCnt.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DFPM"
               titleID="IEC61850_7_420.FuelCellLNs::DFPM.cl.title"
               base="FunctionLN">
            <DataObject name="FPMSt"
                     type="SPS"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.FPMSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InAccmWh"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.InAccmWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutAccmWh"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.OutAccmWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="CnvEfc"
                     type="MV"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.CnvEfc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ProcTyp"
                     type="ENG"
                     underlyingType="FuelProcessingKind"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.ProcTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ThmRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.ThmRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InFuelTyp"
                     type="ENG"
                     underlyingType="FuelProcessingInFuelKind"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.InFuelTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutFuelTyp"
                     type="ENG"
                     underlyingType="FuelProcessingOutFuelKind"
                     descID="IEC61850_7_420.FuelCellLNs::DFPM.OutFuelTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KFUL"
               titleID="IEC61850_7_420.FuelSystemLNs::KFUL.cl.title"
               base="SupervisionLN">
            <DataObject name="AccmOpTms"
                     type="INS"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.AccmOpTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelCostAv"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelCostAv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelEfcPct"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelEfcPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AccmTotFuel"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.AccmTotFuel.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AccmFuel"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.AccmFuel.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelCalAv"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelCalAv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="AccmFuelRs"
                     type="SPC"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.AccmFuelRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="AccmOpTmRs"
                     type="SPC"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.AccmOpTmRs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelTyp"
                     type="ENG"
                     underlyingType="FuelKind"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="Ccy"
                     type="CUG"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.Ccy.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelCost"
                     type="ASG"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GrossCalVal"
                     type="ASG"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.GrossCalVal.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelEfcRtg"
                     type="ASG"
                     descID="IEC61850_7_420.FuelSystemLNs::KFUL.FuelEfcRtg.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="KFLV"
               titleID="IEC61850_7_420.FuelSystemLNs::KFLV.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="FuelSt"
                     type="SPS"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.FuelSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InFuelRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.InFuelRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutFuelRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.OutFuelRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InFuelTmp"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.InFuelTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="OutFuelTmp"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.OutFuelTmp.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelRalA"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.FuelRalA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelRalPres"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.FuelRalPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="EngFuelRte"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.EngFuelRte.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TmPres"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.TmPres.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="TmRalActrA"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.TmRalActrA.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="PmpActrA"
                     type="MV"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.PmpActrA.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FuelStr"
                     type="SPC"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.FuelStr.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelStop"
                     type="SPC"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.FuelStop.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelDlvTyp"
                     type="ENG"
                     underlyingType="FuelDeliveryKind"
                     descID="IEC61850_7_420.FuelSystemLNs::KFLV.FuelDlvTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DCHC"
               titleID="IEC61850_7_420.CHP_LNs::DCHC.cl.title"
               base="GeneratorUnitLN">
            <DataObject name="MaintTms"
                     type="INS"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.MaintTms.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HtPwrEfc"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.HtPwrEfc.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="HtTyp"
                     type="ENG"
                     underlyingType="ThermalEnergyMediumKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.HtTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="MaxHtCap"
                     type="ASG"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.MaxHtCap.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HtEfcPct"
                     type="ASG"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.HtEfcPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ClTyp"
                     type="ENG"
                     underlyingType="ThermalEnergyMediumKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.ClTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnCnvTyp"
                     type="ENG"
                     underlyingType="CHPEnergyConverterKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.EnCnvTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="GnTyp"
                     type="ENG"
                     underlyingType="CHPGeneratorKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.GnTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FuelTyp"
                     type="ENG"
                     underlyingType="FuelKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.FuelTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OpModCHP"
                     type="ENG"
                     underlyingType="CHPOperatingModeKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHC.OpModCHP.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DCTS"
               titleID="IEC61850_7_420.CHP_LNs::DCTS.cl.title"
               base="FunctionLN">
            <DataObject name="ThmCapTot"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmCapTot.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThmCapPct"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmCapPct.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThmIn"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmIn.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThmOut"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmOut.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThmLos"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmLos.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ThmStoTyp"
                     type="ENG"
                     underlyingType="ThermalEnergyStorageKind"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmStoTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ThmOutEst"
                     type="ORG"
                     descID="IEC61850_7_420.CHP_LNs::DCTS.ThmOutEst.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DCHB"
               titleID="IEC61850_7_420.CHP_LNs::DCHB.cl.title"
               base="ControlEquipmentInterfaceLN">
            <DataObject name="BoilRdy"
                     type="SPS"
                     descID="IEC61850_7_420.CHP_LNs::DCHB.BoilRdy.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BoilDnReg"
                     type="SPS"
                     descID="IEC61850_7_420.CHP_LNs::DCHB.BoilDnReg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BoilWh"
                     type="MV"
                     descID="IEC61850_7_420.CHP_LNs::DCHB.BoilWh.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="BoilCtl"
                     type="SPC"
                     descID="IEC61850_7_420.CHP_LNs::DCHB.BoilCtl.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="BoilTyp"
                     type="ENG"
                     underlyingType="BoilerKind"
                     descID="IEC61850_7_420.CHP_LNs::DCHB.BoilTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DEXC"
               titleID="IEC61850_7_420.DERExcitationLNs::DEXC.cl.title"
               base="EquipmentInterfaceLN">
            <DataObject name="ExtSt"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DrpV"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.DrpV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PwrStab"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.PwrStab.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxHiVLim"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.MaxHiVLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="MaxLoVLim"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.MaxLoVLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FlshAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.FlshAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PwrSupAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.PwrSupAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DCAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.DCAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ACAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ACAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="UPSAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.UPSAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkA"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.BlkA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkV"
                     type="SPS"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.BlkV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtTyp"
                     type="ENG"
                     underlyingType="ExciterKind"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="NoLodExtV"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.NoLodExtV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="NoLodExtA"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.NoLodExtA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PFExtV"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.PFExtV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PFExtA"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.PFExtA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtForc"
                     type="SPG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtForc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtInerTms"
                     type="ING"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtInerTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtGain"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtGain.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhLdComp"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.PhLdComp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VSpt"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.VSpt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtlHzHiLim"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.CtlHzHiLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtlHzLoLim"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.CtlHzLoLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StabSigWash"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.StabSigWash.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StabGain"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.StabGain.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtlHzHiAlm"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.CtlHzHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtCeilV"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtCeilV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CtlHzLoAlm"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.CtlHzLoAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtCeilA"
                     type="ASG"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtCeilA.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVTms"
                     type="ING"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtVTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ExtVDurTms"
                     type="ING"
                     descID="IEC61850_7_420.DERExcitationLNs::DEXC.ExtVDurTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DINV"
               titleID="IEC61850_7_420.DERInverterLNs::DINV.cl.title"
               base="DERConverterLN">
            <DataObject name="InvACLosAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvACLosAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InvDCLosAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvDCLosAlm.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InvGriLosAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvGriLosAlm.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="InvSwAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvSwAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="Stdby"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.Stdby.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CurLev"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.CurLev.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InvManStopSt"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvManStopSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GriModSt"
                     type="ENS"
                     underlyingType="GridConnectStateKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.GriModSt.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArAvl"
                     type="MV"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.VArAvl.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DCVSpt"
                     type="APC"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.DCVSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="InvSwTyp"
                     type="ENG"
                     underlyingType="InverterSwitchKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvSwTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InvCtlSrc"
                     type="ENG"
                     underlyingType="InverterControlSourceKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.InvCtlSrc.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WRtg"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.WRtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VARtg"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.VARtg.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WVArVLim"
                     type="CSG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.WVArVLim.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WVArVLimSet"
                     type="CSG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.WVArVLimSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="SwHz"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.SwHz.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhsACfg"
                     type="ENG"
                     underlyingType="PhaseFeedKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.PhsACfg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhsBCfg"
                     type="ENG"
                     underlyingType="PhaseFeedKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.PhsBCfg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PhsCCfg"
                     type="ENG"
                     underlyingType="PhaseFeedKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.PhsCCfg.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="GriMod"
                     type="ENG"
                     underlyingType="GridConnectModeKind"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.GriMod.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutHzSet"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.OutHzSet.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutPFSet"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.OutPFSet.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutVArSet"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DINV.OutVArSet.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DRTF"
               titleID="IEC61850_7_420.DERInverterLNs::DRTF.cl.title"
               base="DERConverterLN">
            <DataObject name="VRegTyp"
                     type="ENG"
                     underlyingType="VoltageRegulationKind"
                     descID="IEC61850_7_420.DERInverterLNs::DRTF.VRegTyp.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="CnvTyp"
                     type="ENG"
                     underlyingType="ACToDCConversionKind"
                     descID="IEC61850_7_420.DERInverterLNs::DRTF.CnvTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutFilTyp"
                     type="ENG"
                     underlyingType="OutputFilterKind"
                     descID="IEC61850_7_420.DERInverterLNs::DRTF.OutFilTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="InWavTyp"
                     type="ENG"
                     underlyingType="WaveformConditioningKind"
                     descID="IEC61850_7_420.DERInverterLNs::DRTF.InWavTyp.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutVSet"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DRTF.OutVSet.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="OutALim"
                     type="ASG"
                     descID="IEC61850_7_420.DERInverterLNs::DRTF.OutALim.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="SINV"
               titleID="IEC61850_7_420.DERInverterLNs::SINV.cl.title"
               base="SupervisionLN">
            <DataObject name="TmpHiAlm"
                     type="SPS"
                     descID="IEC61850_7_420.DERInverterLNs::SINV.TmpHiAlm.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="EnclTmp"
                     type="MV"
                     descID="IEC61850_7_420.DERInverterLNs::SINV.EnclTmp.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="HeatSinkTmp"
                     type="MV"
                     descID="IEC61850_7_420.DERInverterLNs::SINV.HeatSinkTmp.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="TrfTmp"
                     type="MV"
                     descID="IEC61850_7_420.DERInverterLNs::SINV.TrfTmp.desc"
                     presCond="Omulti"
                     dsPresCond="O"/>
            <DataObject name="FanSpd"
                     type="MV"
                     descID="IEC61850_7_420.DERInverterLNs::SINV.FanSpd.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="DCCT"
               titleID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.cl.title"
               base="FunctionLN">
            <DataObject name="Ccy"
                     type="CUG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.Ccy.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.OpCost.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="OpWhCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.OpWhCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.StrCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StopCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.StopCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RampCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.RampCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HeatRteCost"
                     type="CSG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.HeatRteCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CRteCost"
                     type="CSG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CRteCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CnttExptWLim"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CnttExptWLim.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CnttImptWLim"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CnttImptWLim.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CnttPF"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CnttPF.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CnttHiV"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CnttHiV.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CnttLoV"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CnttLoV.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CnttAnc"
                     type="ENG"
                     underlyingType="AncillaryServiceKind"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CnttAnc.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HeatRtePrc"
                     type="SCR"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.HeatRtePrc.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CRtePrc"
                     type="SCR"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCCT.CRtePrc.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DCST"
               titleID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.cl.title"
               base="FunctionLN">
            <DataObject name="Ccy"
                     type="CUG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.Ccy.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HeatRteAct"
                     type="CSG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.HeatRteAct.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="HeatRteCost"
                     type="CSG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.HeatRteCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RampCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.RampCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StrCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.StrCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="StopCost"
                     type="ASG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.StopCost.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CostRamp"
                     type="CSG"
                     descID="IEC61850_7_420.DERFinancialLNs_7_420::DCST.CostRamp.desc"
                     deprecated="true"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="MMET"
               titleID="IEC61850_7_420.MeasurementExtLN::MMETExt.cl.title"
               isExtension="true">
            <DataObject name="PoaInsol"
                     type="MV"
                     descID="IEC61850_7_420.MeasurementExtLN::MMETExt.PoaInsol.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="MMXU"
               titleID="IEC61850_7_420.MeasurementExtLN::MMXUExt.cl.title"
               isExtension="true">
            <DataObject name="PFExtQud"
                     type="SPS"
                     descID="IEC61850_7_420.MeasurementExtLN::MMXUExt.PFExtQud.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PQSt"
                     type="ENS"
                     underlyingType="QuadrantRunningStateKind"
                     descID="IEC61850_7_420.MeasurementExtLN::MMXUExt.PQSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DCTE"
               titleID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.cl.title"
               base="OperationalFunctionLN">
            <DataObject name="CeaEgzReqSt"
                     type="ENS"
                     underlyingType="CeasetoEnergizeStateKind"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.CeaEgzReqSt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="CeaEgzReq"
                     type="SPS"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.CeaEgzReq.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="CeaEgzAuth"
                     type="SPC"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.CeaEgzAuth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="CeaEgzReqCtl"
                     type="ENC"
                     underlyingType="CeasetoEnergizeStateTransitionKind"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.CeaEgzReqCtl.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="RtnSvcAuth"
                     type="SPC"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.RtnSvcAuth.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="RtnSvcAuto"
                     type="SPG"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.RtnSvcAuto.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="RtnRmpTmms"
                     type="ING"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.RtnRmpTmms.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="RtnDlTmms"
                     type="ING"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.RtnDlTmms.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VArLimPct"
                     type="ASG"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.VArLimPct.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VHiLim"
                     type="ASG"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.VHiLim.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="VLoLim"
                     type="ASG"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.VLoLim.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="HzHiLim"
                     type="ASG"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.HzHiLim.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="HzLoLim"
                     type="ASG"
                     descID="IEC61850_7_420.CeasetoEnergizeLN::DCTE.HzLoLim.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DHVT"
               titleID="IEC61850_7_420.Voltage_Ride-ThroughLNs::DHVT.cl.title"
               base="RideThroughLN"/>
         <LNClass name="DLVT"
               titleID="IEC61850_7_420.Voltage_Ride-ThroughLNs::DLVT.cl.title"
               base="RideThroughLN"/>
         <LNClass name="DHFT"
               titleID="IEC61850_7_420.Frequency_Ride-ThroughLNs::DHFT.cl.title"
               base="RideThroughLN">
            <DataObject name="HzChgMaxRte"
                     type="ING"
                     descID="IEC61850_7_420.Frequency_Ride-ThroughLNs::DHFT.HzChgMaxRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DLFT"
               titleID="IEC61850_7_420.Frequency_Ride-ThroughLNs::DLFT.cl.title"
               base="RideThroughLN">
            <DataObject name="HzChgMaxRte"
                     type="ING"
                     descID="IEC61850_7_420.Frequency_Ride-ThroughLNs::DLFT.HzChgMaxRte.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DHFW"
               titleID="IEC61850_7_420.Frequency-ActivePowerLNs::DHFW.cl.title"
               base="FrequencyActivePowerLN"/>
         <LNClass name="DLFW"
               titleID="IEC61850_7_420.Frequency-ActivePowerLNs::DLFW.cl.title"
               base="FrequencyActivePowerLN"/>
         <LNClass name="DAGC"
               titleID="IEC61850_7_420.ActivePowerLNs::DAGC.cl.title"
               base="ActivePowerLN">
            <DataObject name="WMinAvl"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DAGC.WMinAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WMaxAvl"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DAGC.WMaxAvl.desc"
                     presCond="O"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="DTCD"
               titleID="IEC61850_7_420.ActivePowerLNs::DTCD.cl.title"
               base="ActivePowerLN">
            <DataObject name="SocDate"
                     type="TCS"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.SocDate.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="WhReq"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.WhReq.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="DurMin"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.DurMin.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="SocUseTgtPct"
                     type="ING"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.SocUseTgtPct.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="DateTgt"
                     type="TSG"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.DateTgt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ChaDurMax"
                     type="ING"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.ChaDurMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DschDurMax"
                     type="ING"
                     descID="IEC61850_7_420.ActivePowerLNs::DTCD.DschDurMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DVWC"
               titleID="IEC61850_7_420.ActivePowerLNs::DVWC.cl.title"
               base="HysteresisSnapshotLN">
            <DataObject name="ReqWMax"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DVWC.ReqWMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VRefEsp"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DVWC.VRefEsp.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="VWCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ActivePowerLNs::DVWC.VWCrv.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VWCrvRef"
                     type="ENG"
                     underlyingType="VoltageActivePowerRefParamKind"
                     descID="IEC61850_7_420.ActivePowerLNs::DVWC.VWCrvRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRefOfs"
                     type="ASG"
                     descID="IEC61850_7_420.ActivePowerLNs::DVWC.VRefOfs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRefPct"
                     type="ASG"
                     descID="IEC61850_7_420.ActivePowerLNs::DVWC.VRefPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DWFL"
               titleID="IEC61850_7_420.ActivePowerLNs::DWFL.cl.title"
               base="ActivePowerLN">
            <DataObject name="FolWRef"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DWFL.FolWRef.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="FolWThr"
                     type="ASG"
                     descID="IEC61850_7_420.ActivePowerLNs::DWFL.FolWThr.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="FolWPct"
                     type="ASG"
                     descID="IEC61850_7_420.ActivePowerLNs::DWFL.FolWPct.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="FolWTgt"
                     type="ASG"
                     descID="IEC61850_7_420.ActivePowerLNs::DWFL.FolWTgt.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DWGC"
               titleID="IEC61850_7_420.ActivePowerLNs::DWGC.cl.title"
               base="ActivePowerLN"/>
         <LNClass name="DWMN"
               titleID="IEC61850_7_420.ActivePowerLNs::DWMN.cl.title"
               base="ActivePowerLimitLN">
            <DataObject name="ReqWMin"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DWMN.ReqWMin.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WMinSptPct"
                     type="APC"
                     descID="IEC61850_7_420.ActivePowerLNs::DWMN.WMinSptPct.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="WMinSpt"
                     type="APC"
                     descID="IEC61850_7_420.ActivePowerLNs::DWMN.WMinSpt.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="DWMX"
               titleID="IEC61850_7_420.ActivePowerLNs::DWMX.cl.title"
               base="ActivePowerLimitLN">
            <DataObject name="ReqWMax"
                     type="MV"
                     descID="IEC61850_7_420.ActivePowerLNs::DWMX.ReqWMax.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="WMaxSptPct"
                     type="APC"
                     descID="IEC61850_7_420.ActivePowerLNs::DWMX.WMaxSptPct.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="O"/>
            <DataObject name="WMaxSpt"
                     type="APC"
                     descID="IEC61850_7_420.ActivePowerLNs::DWMX.WMaxSpt.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="O"/>
         </LNClass>
         <LNClass name="DFPF"
               titleID="IEC61850_7_420.PowerFactorLNs::DFPF.cl.title"
               base="RampRatesLN">
            <DataObject name="ReqPFExt"
                     type="SPS"
                     descID="IEC61850_7_420.PowerFactorLNs::DFPF.ReqPFExt.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ReqPF"
                     type="MV"
                     descID="IEC61850_7_420.PowerFactorLNs::DFPF.ReqPF.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="PFGnTgtSpt"
                     type="APC"
                     descID="IEC61850_7_420.PowerFactorLNs::DFPF.PFGnTgtSpt.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="PFGnExtQud"
                     type="SPC"
                     descID="IEC61850_7_420.PowerFactorLNs::DFPF.PFGnExtQud.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="PFLodTgtSpt"
                     type="APC"
                     descID="IEC61850_7_420.PowerFactorLNs::DFPF.PFLodTgtSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="PFLodExtQud"
                     type="SPC"
                     descID="IEC61850_7_420.PowerFactorLNs::DFPF.PFLodExtQud.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DVVR"
               titleID="IEC61850_7_420.ReactivePowerLNs::DVVR.cl.title"
               base="ReactivePowerLN">
            <DataObject name="VRefEsp"
                     type="MV"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VRefEsp.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="VRefSpt"
                     type="APC"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VRefSpt.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VVArCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VVArCrv.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="1"
                     dsPresCond="F"/>
            <DataObject name="VRefAdjEna"
                     type="SPG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VRefAdjEna.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRefTmms"
                     type="ING"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VRefTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VRefOfs"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VRefOfs.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VVArCrvDel"
                     type="CSG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VVArCrvDel.desc"
                     presCond="AllOnlyOneGroup"
                     presCondArgs="2"
                     dsPresCond="F"/>
            <DataObject name="VRefPct"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DVVR.VRefPct.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DVAR"
               titleID="IEC61850_7_420.ReactivePowerLNs::DVAR.cl.title"
               base="ReactivePowerLN"/>
         <LNClass name="DWVR"
               titleID="IEC61850_7_420.ReactivePowerLNs::DWVR.cl.title"
               base="ReactivePowerLN">
            <DataObject name="WVArCrv"
                     type="CSG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DWVR.WVArCrv.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="WBarEna"
                     type="SPG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DWVR.WBarEna.desc"
                     presCond="M"
                     dsPresCond="F"/>
         </LNClass>
         <LNClass name="DRGS"
               titleID="IEC61850_7_420.ReactivePowerLNs::DRGS.cl.title"
               base="ReactivePowerLN">
            <DataObject name="HiVRtSt"
                     type="SPS"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.HiVRtSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="LoVRtSt"
                     type="SPS"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.LoVRtSt.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="ReqA"
                     type="MV"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.ReqA.desc"
                     presCond="M"
                     dsPresCond="O"/>
            <DataObject name="DelV"
                     type="MV"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.DelV.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="VAv"
                     type="MV"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.VAv.desc"
                     presCond="O"
                     dsPresCond="O"/>
            <DataObject name="ArGraMod"
                     type="SPG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.ArGraMod.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ArGraSag"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.ArGraSag.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="ArGraSwl"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.ArGraSwl.desc"
                     presCond="M"
                     dsPresCond="F"/>
            <DataObject name="HysBlkZnV"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.HysBlkZnV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkZnV"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.BlkZnV.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="BlkZnTmms"
                     type="ING"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.BlkZnTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="FilTms"
                     type="ING"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.FilTms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="HoldTmms"
                     type="ING"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.HoldTmms.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DbVMin"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.DbVMin.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="DbVMax"
                     type="ASG"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.DbVMax.desc"
                     presCond="O"
                     dsPresCond="F"/>
            <DataObject name="VArSptRef"
                     type="ENG"
                     underlyingType="ReactivePowerRefParamKind"
                     descID="IEC61850_7_420.ReactivePowerLNs::DRGS.VArSptRef.desc"
                     presCond="O"
                     dsPresCond="F"/>
         </LNClass>
      </LNClasses>
</NS>
`;
const nsd81 = `<?xml version="1.0" encoding="UTF-8"?>
<!--
COPYRIGHT (c) IEC, 2016. All rights reserved. Disclaimer: The IEC disclaims liability for any personal injury, property or other damages of any nature whatsoever, whether special, indirect, consequential or compensatory, directly or indirectly resulting from this software and the document upon which its methods are based, use of, or reliance upon.
-->
<!--
History:
- 2016-01-11: first version
- 2016-02-18: corrections according to TF meeting in Cathedral City
	+ MFctrl -> MOctrl
	+ MFsboNormal -> MOsboNormal
	+ MFsboEnhanced -> MOsboEnhanced
- 2016-04-29:
    + updated file according to NSD.xsd changes (removal of AppliesTo element; usage of "abstract" type DAReference instead of VisString129; 8-1 introduced FCs and their applicable services)
    + added umlDate attribute for versioning
- 2016-05-18: [updates according to today's TF telco]
	+ removed FCs for control blocks.
- 2019-04-10: Add UDP IP PhyComAddr
  + add MOsbo
  + change IGMPSrc to iGMPSrc
  + change SBO basic type from DAReference to VisString129
-->
<!--
Notes on presence conditions:
From 7-3:
- MOoperTm: Element is mandatory if at least one controlled object on the IED supports time activation service; otherwise it is optional.
New presence conditions:
- MOctrl: Element is mandatory if declared control model supports anything else besides (optionally) status-only, otherwise optional.
- MOsboNormal: Element is mandatory if declared control model supports 'sbo-with-normal-security', otherwise optional.
- MOsboEnhanced: Element is mandatory if declared control model supports 'sbo-with-enhanced-security', otherwise optional.
-->
<ServiceNS xmlns="http://www.iec.ch/61850/2016/NSD" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" id="IEC 61850-8-1" version="2003" revision="A" release="2" xsi:schemaLocation="http://www.iec.ch/61850/2016/NSD NSD.xsd" umlDate="2019-04-10T12:00:00Z">
	<Copyright>
		<Notice>
		COPYRIGHT (c) IEC, 2018. This version of this NSD is part of IEC 61850-8-1:2018; see the IEC 61850-8-1:2018 for full legal notices. In case of any differences between the here-below code and the IEC published content, the here-below code is the valid one; it may contain updates. See history files. The whole document has to be taken into account to have a full description of this code component.
See www.iec.ch/CCv1 for copyright details
		</Notice>
		<License uri="www.iec.ch/CCv1" kind="Standard">IEC License</License>
	</Copyright>
	<FunctionalConstraints>
		<FunctionalConstraint abbreviation="CO" descID="IEC 61850-8-1:2003.CO">
			<ApplicableServices>
				<Service name="Cancel"/>
				<Service name="CommandTermination"/>
				<Service name="Operate"/>
				<Service name="Select"/>
				<Service name="SelectWithValue"/>
				<Service name="TimeActivatedOperate"/>
			</ApplicableServices>
		</FunctionalConstraint>
	</FunctionalConstraints>
	<PresenceConditions>
		<PresenceCondition name="MOctrl" descID="IEC 61850-8-1:2003.MOctrl"/>
		<PresenceCondition name="MOsboNormal" descID="IEC 61850-8-1:2003.MOsboNormal"/>
		<PresenceCondition name="MOsboEnhanced" descID="IEC 61850-8-1:2003.MOsboEnhanced"/>
		<PresenceCondition name="MOsbo" descID="IEC 61850-8-1:2003.MOsbo"/>
	</PresenceConditions>
	<ServiceTypeRealizations>
		<ServiceTypeRealization titleID="IEC 61850-8-1:2003.PhyComAddr" name="PhyComAddr">
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddr.Addr" name="Addr" typeKind="BASIC" type="Octet6" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddr.PRIORITY" name="PRIORITY" typeKind="BASIC" type="INT8U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddr.VID" name="VID" typeKind="BASIC" type="INT16U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddr.APPID" name="APPID" typeKind="BASIC" type="INT16U" presCond="M"/>
		</ServiceTypeRealization>
		<ServiceTypeRealization titleID="IEC 61850-8-1:2003.PhyComAddrIP" name="PhyComAddr">
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.Addr" name="Addr" typeKind="BASIC" type="Octet16" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.isIPv6" name="isIPv6" typeKind="BASIC" type="BOOLEAN" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.PRIORITY" name="PRIORITY" typeKind="BASIC" type="INT8U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.VID" name="VID" typeKind="BASIC" type="INT16U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.APPID" name="APPID" typeKind="BASIC" type="INT16U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.gwAddr" name="gwAddr" typeKind="BASIC" type="Octet16" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.tOS" name="tOS" typeKind="BASIC" type="INT8U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.PhyComAddrIP.iGMPSrc" name="iGMPSrc" typeKind="BASIC" type="Octet16" presCond="M"/>
		</ServiceTypeRealization>
	</ServiceTypeRealizations>
	<ServiceConstructedAttributes>
		<ServiceConstructedAttribute titleID="IEC 61850-8-1:2003.SBOw" name="SBOw" typeKindParameterized="true">
			<SubDataAttribute descID="IEC 61850-8-1:2003.ctlVal" name="ctlVal" typeKind="undefined" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.operTm" name="operTm" typeKind="BASIC" type="Timestamp" presCond="MOoperTm"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.origin" name="origin" typeKind="CONSTRUCTED" type="Originator" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.ctlNum" name="ctlNum" typeKind="BASIC" type="INT8U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.T" name="T" typeKind="BASIC" type="Timestamp" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.Test" name="Test" typeKind="BASIC" type="BOOLEAN" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.Check" name="Check" typeKind="BASIC" type="Check" presCond="M"/>
		</ServiceConstructedAttribute>
		<ServiceConstructedAttribute titleID="IEC 61850-8-1:2003.Oper" name="Oper" typeKindParameterized="true">
			<SubDataAttribute descID="IEC 61850-8-1:2003.ctlVal" name="ctlVal" typeKind="undefined" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.operTm" name="operTm" typeKind="BASIC" type="Timestamp" presCond="MOoperTm"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.origin" name="origin" typeKind="CONSTRUCTED" type="Originator" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.ctlNum" name="ctlNum" typeKind="BASIC" type="INT8U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.T" name="T" typeKind="BASIC" type="Timestamp" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.Test" name="Test" typeKind="BASIC" type="BOOLEAN" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.Check" name="Check" typeKind="BASIC" type="Check" presCond="M"/>
		</ServiceConstructedAttribute>
		<ServiceConstructedAttribute titleID="IEC 61850-8-1:2003.Cancel" name="Cancel" typeKindParameterized="true">
			<SubDataAttribute descID="IEC 61850-8-1:2003.ctlVal" name="ctlVal" typeKind="undefined" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.operTm" name="operTm" typeKind="BASIC" type="Timestamp" presCond="MOoperTm"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.origin" name="origin" typeKind="CONSTRUCTED" type="Originator" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.ctlNum" name="ctlNum" typeKind="BASIC" type="INT8U" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.T" name="T" typeKind="BASIC" type="Timestamp" presCond="M"/>
			<SubDataAttribute descID="IEC 61850-8-1:2003.Test" name="Test" typeKind="BASIC" type="BOOLEAN" presCond="M"/>
		</ServiceConstructedAttribute>
	</ServiceConstructedAttributes>
	<ServiceCDCs>
		<ServiceCDC cdc="SPC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="BASIC" underlyingType="BOOLEAN" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="BASIC" underlyingType="BOOLEAN" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="BASIC" underlyingType="BOOLEAN" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="DPC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="BASIC" underlyingType="BOOLEAN" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="BASIC" underlyingType="BOOLEAN" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="BASIC" underlyingType="BOOLEAN" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="INC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="BASIC" underlyingType="INT32" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="BASIC" underlyingType="INT32" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="BASIC" underlyingType="INT32" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="ENC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="ENUMERATED" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="ENUMERATED" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="ENUMERATED" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="BSC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="BASIC" underlyingType="Tcmd" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="BASIC" underlyingType="Tcmd" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="BASIC" underlyingType="Tcmd" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="ISC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="BASIC" underlyingType="INT8" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="BASIC" underlyingType="INT8" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="BASIC" underlyingType="INT8" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="APC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="CONSTRUCTED" underlyingType="AnalogueValueCtl" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="CONSTRUCTED" underlyingType="AnalogueValueCtl" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="CONSTRUCTED" underlyingType="AnalogueValueCtl" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
		<ServiceCDC cdc="BAC">
			<ServiceDataAttribute name="SBO" typeKind="BASIC" type="VisString129" fc="CO" presCond="MOsboNormal" descID="IEC 61850-8-1:2003.SBO"/>
			<ServiceDataAttribute name="SBOw" typeKind="CONSTRUCTED" type="SBOw" underlyingTypeKind="BASIC" underlyingType="Tcmd" fc="CO" presCond="MOsboEnhanced"/>
			<ServiceDataAttribute name="Oper" typeKind="CONSTRUCTED" type="Oper" underlyingTypeKind="BASIC" underlyingType="Tcmd" fc="CO" presCond="MOctrl"/>
			<ServiceDataAttribute name="Cancel" typeKind="CONSTRUCTED" type="Cancel" underlyingTypeKind="BASIC" underlyingType="Tcmd" fc="CO" presCond="MOsbo"/>
		</ServiceCDC>
	</ServiceCDCs>
</ServiceNS>
`;

const supportedCdc = [
    "ACD",
    "ACT",
    "APC",
    "ASG",
    "BAC",
    "BCR",
    "BSC",
    "CMV",
    "DEL",
    "DPC",
    "DPL",
    "HDEL",
    "HMV",
    "HST",
    "HWYE",
    "INC",
    "INS",
    "ISC",
    "LPL",
    "MV",
    "ORG",
    "ORS",
    "SAV",
    "SEC",
    "SEQ",
    "SPC",
    "SPG",
    "SPS",
    "TCS",
    "TSG",
    "VSG",
    "VSS",
    "WYE",
];
new Set(supportedCdc);
new DOMParser().parseFromString(nsd72, "application/xml");
new DOMParser().parseFromString(nsd73, "application/xml");
new DOMParser().parseFromString(nsd74, "application/xml");
new DOMParser().parseFromString(nsd7420, "application/xml");
new DOMParser().parseFromString(nsd81, "application/xml");

const indexedSCLTags = ["ExtRef", "IEDName", "P", "ProtNs", "Val"];
new Set(indexedSCLTags);

/* eslint-disable no-use-before-define */
function hitemIdentity(e) {
    return `${e.getAttribute("version")}\t${e.getAttribute("revision")}`;
}
function terminalIdentity(e) {
    return `${identity(e.parentElement)}>${e.getAttribute("connectivityNode")}`;
}
function lNodeIdentity(e) {
    const [iedName, ldInst, prefix, lnClass, lnInst, lnType] = [
        "iedName",
        "ldInst",
        "prefix",
        "lnClass",
        "lnInst",
        "lnType",
    ].map((name) => e.getAttribute(name));
    if (iedName === "None")
        return `${identity(e.parentElement)}>(${lnClass} ${lnInst ?? ""} ${lnType})`;
    return `${iedName} ${ldInst || "(Client)"}/${prefix ?? ""} ${lnClass} ${lnInst ?? ""}`;
}
function kDCIdentity(e) {
    return `${identity(e.parentElement)}>${e.getAttribute("iedName")} ${e.getAttribute("apName")}`;
}
function associationIdentity(e) {
    const [iedName, ldInst, prefix, lnClass, lnInst] = [
        "iedName",
        "ldInst",
        "prefix",
        "lnClass",
        "lnInst",
        "lnType",
    ].map((name) => e.getAttribute(name));
    return `${identity(e.parentElement)}>${iedName} ${ldInst}/${prefix ?? ""} ${lnClass} ${lnInst ?? ""}`;
}
function lDeviceIdentity(e) {
    return `${identity(e.closest("IED"))}>>${e.getAttribute("inst")}`;
}
function iEDNameIdentity(e) {
    const iedName = e.textContent;
    const [apRef, ldInst, prefix, lnClass, lnInst] = [
        "apRef",
        "ldInst",
        "prefix",
        "lnClass",
        "lnInst",
    ].map((name) => e.getAttribute(name));
    return `${identity(e.parentElement)}>${iedName} ${apRef || ""} ${ldInst || ""}/${prefix ?? ""} ${lnClass ?? ""} ${lnInst ?? ""}`;
}
function fCDAIdentity(e) {
    const [ldInst, prefix, lnClass, lnInst, doName, daName, fc, ix] = [
        "ldInst",
        "prefix",
        "lnClass",
        "lnInst",
        "doName",
        "daName",
        "fc",
        "ix",
    ].map((name) => e.getAttribute(name));
    const dataPath = `${ldInst}/${prefix ?? ""} ${lnClass} ${lnInst ?? ""}.${doName} ${daName || ""}`;
    return `${identity(e.parentElement)}>${dataPath} (${fc}${ix ? ` [${ix}]` : ""})`;
}
function extRefIdentity(e) {
    if (!e.parentElement)
        return NaN;
    const parentIdentity = identity(e.parentElement);
    const iedName = e.getAttribute("iedName");
    const intAddr = e.getAttribute("intAddr");
    const intAddrIndex = Array.from(e.parentElement.querySelectorAll(`ExtRef[intAddr="${intAddr}"]`)).indexOf(e);
    if (intAddr)
        return `${parentIdentity}>${intAddr}[${intAddrIndex}]`;
    const [ldInst, prefix, lnClass, lnInst, doName, daName, serviceType, srcLDInst, srcPrefix, srcLNClass, srcLNInst, srcCBName,] = [
        "ldInst",
        "prefix",
        "lnClass",
        "lnInst",
        "doName",
        "daName",
        "serviceType",
        "srcLDInst",
        "srcPrefix",
        "srcLNClass",
        "srcLNInst",
        "srcCBName",
    ].map((name) => e.getAttribute(name));
    const defaultSrcPrefix = "";
    const finalSrcPrefix = srcPrefix ?? defaultSrcPrefix;
    const defaultSrcLNInst = "";
    const finalSrcLNInst = srcLNInst ?? defaultSrcLNInst;
    const cbPath = srcCBName
        ? `${serviceType}:${srcCBName} ${srcLDInst}/${finalSrcPrefix} ${srcLNClass} ${finalSrcLNInst}`
        : "";
    const defaultPrefix = "";
    const finalPrefix = prefix ?? defaultPrefix;
    const defaultLnInst = "";
    const finalLnInst = lnInst ?? defaultLnInst;
    const defaultDaName = "";
    const finalDaName = daName || defaultDaName;
    const dataPath = `${iedName} ${ldInst}/${finalPrefix} ${lnClass} ${finalLnInst} ${doName} ${finalDaName}`;
    return `${parentIdentity}>${cbPath ? `${cbPath} ` : ""}${dataPath}`;
}
function lNIdentity(e) {
    const [prefix, lnClass, inst] = ["prefix", "lnClass", "inst"].map((name) => e.getAttribute(name));
    return `${identity(e.parentElement)}>${prefix ?? ""} ${lnClass} ${inst}`;
}
function clientLNIdentity(e) {
    const [apRef, iedName, ldInst, prefix, lnClass, lnInst] = [
        "apRef",
        "iedName",
        "ldInst",
        "prefix",
        "lnClass",
        "lnInst",
    ].map((name) => e.getAttribute(name));
    return `${identity(e.parentElement)}>${iedName} ${apRef || ""} ${ldInst}/${prefix ?? ""} ${lnClass} ${lnInst}`;
}
function ixNamingIdentity(e) {
    const [name, ix] = ["name", "ix"].map((naming) => e.getAttribute(naming));
    return `${identity(e.parentElement)}>${name}${ix ? `[${ix}]` : ""}`;
}
function valIdentity(e) {
    if (!e.parentElement)
        return NaN;
    const sGroup = e.getAttribute("sGroup");
    const index = Array.from(e.parentElement.children)
        .filter((child) => child.getAttribute("sGroup") === sGroup)
        .findIndex((child) => child.isSameNode(e));
    return `${identity(e.parentElement)}>${sGroup ? `${sGroup}` : ""} ${index}`;
}
function connectedAPIdentity(e) {
    const [iedName, apName] = ["iedName", "apName"].map((name) => e.getAttribute(name));
    return `${iedName} ${apName}`;
}
function controlBlockIdentity(e) {
    const [ldInst, cbName] = ["ldInst", "cbName"].map((name) => e.getAttribute(name));
    return `${ldInst} ${cbName}`;
}
function physConnIdentity(e) {
    if (!e.parentElement)
        return NaN;
    const pcType = e.getAttribute("type");
    if (e.parentElement.children.length > 1 &&
        pcType !== "Connection" &&
        pcType !== "RedConn")
        return NaN;
    return `${identity(e.parentElement)}>${pcType}`;
}
function pIdentity(e) {
    if (!e.parentElement)
        return NaN;
    const eParent = e.parentElement;
    const eType = e.getAttribute("type");
    if (eParent.tagName === "PhysConn")
        return `${identity(e.parentElement)}>${eType}`;
    const index = Array.from(e.parentElement.children)
        .filter((child) => child.getAttribute("type") === eType)
        .findIndex((child) => child.isSameNode(e));
    return `${identity(e.parentElement)}>${eType} [${index}]`;
}
function enumValIdentity(e) {
    return `${identity(e.parentElement)}>${e.getAttribute("ord")}`;
}
function protNsIdentity(e) {
    if (!e.parentElement)
        return NaN;
    const type = e.getAttribute("type");
    return `${identity(e.parentElement)}>${type || "8-MMS"}\t${e.textContent}`;
}
function sCLIdentity() {
    return "";
}
function namingIdentity(e) {
    return e.parentElement.tagName === "SCL"
        ? e.getAttribute("name")
        : `${identity(e.parentElement)}>${e.getAttribute("name")}`;
}
function singletonIdentity(e) {
    return identity(e.parentElement).toString();
}
function idNamingIdentity(e) {
    return `#${e.id}`;
}
const tags = {
    AccessControl: {
        identity: singletonIdentity,
    },
    AccessPoint: {
        identity: namingIdentity,
    },
    Address: {
        identity: singletonIdentity,
    },
    Association: {
        identity: associationIdentity,
    },
    Authentication: {
        identity: singletonIdentity,
    },
    BDA: {
        identity: namingIdentity,
    },
    BitRate: {
        identity: singletonIdentity,
    },
    Bay: {
        identity: namingIdentity,
    },
    ClientLN: {
        identity: clientLNIdentity,
    },
    ClientServices: {
        identity: singletonIdentity,
    },
    CommProt: {
        identity: singletonIdentity,
    },
    Communication: {
        identity: singletonIdentity,
    },
    ConductingEquipment: {
        identity: namingIdentity,
    },
    ConfDataSet: {
        identity: singletonIdentity,
    },
    ConfLdName: {
        identity: singletonIdentity,
    },
    ConfLNs: {
        identity: singletonIdentity,
    },
    ConfLogControl: {
        identity: singletonIdentity,
    },
    ConfReportControl: {
        identity: singletonIdentity,
    },
    ConfSG: {
        identity: singletonIdentity,
    },
    ConfSigRef: {
        identity: singletonIdentity,
    },
    ConnectedAP: {
        identity: connectedAPIdentity,
    },
    ConnectivityNode: {
        identity: namingIdentity,
    },
    DA: {
        identity: namingIdentity,
    },
    DAI: {
        identity: ixNamingIdentity,
    },
    DAType: {
        identity: idNamingIdentity,
    },
    DO: {
        identity: namingIdentity,
    },
    DOI: {
        identity: namingIdentity,
    },
    DOType: {
        identity: idNamingIdentity,
    },
    DataObjectDirectory: {
        identity: singletonIdentity,
    },
    DataSet: {
        identity: namingIdentity,
    },
    DataSetDirectory: {
        identity: singletonIdentity,
    },
    DataTypeTemplates: {
        identity: singletonIdentity,
    },
    DynAssociation: {
        identity: singletonIdentity,
    },
    DynDataSet: {
        identity: singletonIdentity,
    },
    EnumType: {
        identity: idNamingIdentity,
    },
    EnumVal: {
        identity: enumValIdentity,
    },
    EqFunction: {
        identity: namingIdentity,
    },
    EqSubFunction: {
        identity: namingIdentity,
    },
    ExtRef: {
        identity: extRefIdentity,
    },
    FCDA: {
        identity: fCDAIdentity,
    },
    FileHandling: {
        identity: singletonIdentity,
    },
    Function: {
        identity: namingIdentity,
    },
    GeneralEquipment: {
        identity: namingIdentity,
    },
    GetCBValues: {
        identity: singletonIdentity,
    },
    GetDataObjectDefinition: {
        identity: singletonIdentity,
    },
    GetDataSetValue: {
        identity: singletonIdentity,
    },
    GetDirectory: {
        identity: singletonIdentity,
    },
    GOOSE: {
        identity: singletonIdentity,
    },
    GOOSESecurity: {
        identity: namingIdentity,
    },
    GSE: {
        identity: controlBlockIdentity,
    },
    GSEDir: {
        identity: singletonIdentity,
    },
    GSEControl: {
        identity: namingIdentity,
    },
    GSESettings: {
        identity: singletonIdentity,
    },
    GSSE: {
        identity: singletonIdentity,
    },
    Header: {
        identity: singletonIdentity,
    },
    History: {
        identity: singletonIdentity,
    },
    Hitem: {
        identity: hitemIdentity,
    },
    IED: {
        identity: namingIdentity,
    },
    IEDName: {
        identity: iEDNameIdentity,
    },
    Inputs: {
        identity: singletonIdentity,
    },
    IssuerName: {
        identity: singletonIdentity,
    },
    KDC: {
        identity: kDCIdentity,
    },
    LDevice: {
        identity: lDeviceIdentity,
    },
    LN: {
        identity: lNIdentity,
    },
    LN0: {
        identity: singletonIdentity,
    },
    LNode: {
        identity: lNodeIdentity,
    },
    LNodeType: {
        identity: idNamingIdentity,
    },
    Line: {
        identity: namingIdentity,
    },
    Log: {
        identity: namingIdentity,
    },
    LogControl: {
        identity: namingIdentity,
    },
    LogSettings: {
        identity: singletonIdentity,
    },
    MaxTime: {
        identity: singletonIdentity,
    },
    McSecurity: {
        identity: singletonIdentity,
    },
    MinTime: {
        identity: singletonIdentity,
    },
    NeutralPoint: {
        identity: terminalIdentity,
    },
    OptFields: {
        identity: singletonIdentity,
    },
    P: {
        identity: pIdentity,
    },
    PhysConn: {
        identity: physConnIdentity,
    },
    PowerTransformer: {
        identity: namingIdentity,
    },
    Process: {
        identity: namingIdentity,
    },
    ProtNs: {
        identity: protNsIdentity,
    },
    Protocol: {
        identity: singletonIdentity,
    },
    ReadWrite: {
        identity: singletonIdentity,
    },
    RedProt: {
        identity: singletonIdentity,
    },
    ReportControl: {
        identity: namingIdentity,
    },
    ReportSettings: {
        identity: singletonIdentity,
    },
    RptEnabled: {
        identity: singletonIdentity,
    },
    SamplesPerSec: {
        identity: singletonIdentity,
    },
    SampledValueControl: {
        identity: namingIdentity,
    },
    SecPerSamples: {
        identity: singletonIdentity,
    },
    SCL: {
        identity: sCLIdentity,
    },
    SDI: {
        identity: ixNamingIdentity,
    },
    SDO: {
        identity: namingIdentity,
    },
    Server: {
        identity: singletonIdentity,
    },
    ServerAt: {
        identity: singletonIdentity,
    },
    Services: {
        identity: singletonIdentity,
    },
    SetDataSetValue: {
        identity: singletonIdentity,
    },
    SettingControl: {
        identity: singletonIdentity,
    },
    SettingGroups: {
        identity: singletonIdentity,
    },
    SGEdit: {
        identity: singletonIdentity,
    },
    SmpRate: {
        identity: singletonIdentity,
    },
    SMV: {
        identity: controlBlockIdentity,
    },
    SmvOpts: {
        identity: singletonIdentity,
    },
    SMVsc: {
        identity: singletonIdentity,
    },
    SMVSecurity: {
        identity: namingIdentity,
    },
    SMVSettings: {
        identity: singletonIdentity,
    },
    SubEquipment: {
        identity: namingIdentity,
    },
    SubFunction: {
        identity: namingIdentity,
    },
    SubNetwork: {
        identity: namingIdentity,
    },
    Subject: {
        identity: singletonIdentity,
    },
    Substation: {
        identity: namingIdentity,
    },
    SupSubscription: {
        identity: singletonIdentity,
    },
    TapChanger: {
        identity: namingIdentity,
    },
    Terminal: {
        identity: terminalIdentity,
    },
    Text: {
        identity: singletonIdentity,
    },
    TimerActivatedControl: {
        identity: singletonIdentity,
    },
    TimeSyncProt: {
        identity: singletonIdentity,
    },
    TransformerWinding: {
        identity: namingIdentity,
    },
    TrgOps: {
        identity: singletonIdentity,
    },
    Val: {
        identity: valIdentity,
    },
    ValueHandling: {
        identity: singletonIdentity,
    },
    Voltage: {
        identity: singletonIdentity,
    },
    VoltageLevel: {
        identity: namingIdentity,
    },
};
/** @returns Identity string for a valid SCL element or NaN */
function identity(e) {
    if (e === null)
        return NaN;
    if (e.closest("Private"))
        return NaN;
    const tag = e.tagName;
    if (isSCLTag(tag))
        return tags[tag].identity(e);
    return NaN;
}

/**
 * Pure rectangle and point math.
 *
 * All functions here operate on numeric tuples (Rect, Point) with no
 * knowledge of DOM Elements or SCL structure.
 */
function contains([x1, y1, w1, h1], [x2, y2, w2, h2]) {
    return x1 <= x2 && y1 <= y2 && x1 + w1 >= x2 + w2 && y1 + h1 >= y2 + h2;
}
function overlaps([x1, y1, w1, h1], [x2, y2, w2, h2]) {
    if (x1 >= x2 + w2 || x2 >= x1 + w1) {
        return false;
    }
    if (y1 >= y2 + h2 || y2 >= y1 + h1) {
        return false;
    }
    return true;
}
function between(a, x, b) {
    return (a <= x && x <= b) || (b <= x && x <= a);
}
function liesOn([x, y], [x1, y1], [x2, y2]) {
    return ((x === x1 && x === x2 && between(y1, y, y2)) ||
        (y === y1 && y === y2 && between(x1, x, x2)));
}
function pointsOnLine(p1, p2) {
    const points = [];
    const coord = p1[0] === p2[0] ? 1 : 0;
    let p = p1[coord] < p2[coord] ? p1 : p2;
    const q = p === p1 ? p2 : p1;
    p = p.slice();
    p[coord] = Math.floor(p[coord] * 2) / 2;
    while (p[coord] <= q[coord]) {
        points.push(p);
        p = p.slice();
        p[coord] += 0.5;
    }
    return points;
}
function distance$1([x1, y1], [x2, y2]) {
    return Math.abs(x1 - x2) + Math.abs(y1 - y2);
}
function closestPointOnLine(p, p1, p2) {
    let point = p1;
    const points = pointsOnLine(p1, p2);
    points.forEach((candidate) => {
        if (distance$1(candidate, p) < distance$1(point, p)) {
            point = candidate;
        }
    });
    return point;
}
function findIntersection(p1, p2, lp1, lp2) {
    if (liesOn(p1, lp1, lp2)) {
        return p1;
    }
    if (liesOn(lp1, p1, p2)) {
        return lp1;
    }
    if (liesOn(lp2, p1, p2)) {
        return lp2;
    }
    return closestPointOnLine(p2, lp1, lp2);
}
/**
 * Extend a connection path with a newly committed waypoint while the user is
 * drawing a connection.
 *
 * A connection path is the list of orthogonal waypoints running from the source
 * terminal to the cursor. Its *final* point is provisional: it tracks the live
 * cursor so the in-progress segment can be previewed as the user moves the
 * mouse. Committing a waypoint is therefore not a plain append — the provisional
 * last point must first be **replaced** by `corner` (the now-fixed bend where
 * the previewed segment turns), and only then are the new live endpoints
 * (`rest`) appended so the path keeps tracking the cursor from the new bend.
 *
 * The result is normalised with {@link cleanPath}, which drops any duplicate or
 * collinear points the new bend may have introduced.
 *
 * @param path - the current connection path
 * @param corner - the fixed bend that replaces the provisional last waypoint
 * @param rest - the new live endpoint(s) extending the path past the bend
 * @returns the extended, normalised path
 */
function extendConnectPointPaths(path, corner, ...rest) {
    const next = [...path.slice(0, -1), corner, ...rest];
    cleanPath(next);
    return next;
}
/**
 * The single 90° bend that keeps an orthogonal connection path going from its
 * last committed waypoint toward a `target` point.
 *
 * A connection path's last two points play two distinct roles. `lastFixed`
 * (second-to-last) is the **anchor** the bend is drawn from — the returned
 * `corner` reuses one of its coordinates. The final, `provisional` point is used
 * **only** to reveal the orientation of the segment that arrived at `lastFixed`
 * (by comparing their x's); its coordinates are never used directly. A single
 * point could not tell us that orientation, hence both are needed.
 *
 * The path leaves `lastFixed` continuing in that **same** orientation, then
 * bends once at `corner` to line up with the `target`:
 *
 * ```text
 *   last segment horizontal          last segment vertical
 *   ───▶ lastFixed                    lastFixed
 *              │ (turn down)               └────▶ corner ─▶ target
 *              ▼                        (keep going, then turn across)
 *         corner ──▶ target
 * ```
 *
 * @param path - the current connection path (needs at least its last two points)
 * @param target - the point the bent path should line up with
 * @returns the bend `corner`
 */
function elbowCorner(path, target) {
    // Only the orientation of the last committed segment matters: it ran
    // vertically when its two endpoints share an x-coordinate.
    const [lastFixed, provisional] = path.slice(-2);
    const lastSegmentWasVertical = lastFixed[0] === provisional[0];
    // Leave `lastFixed` in the same orientation, then bend once toward the target:
    //  - vertical last segment  -> keep lastFixed's x, travel to the target's y
    //  - horizontal last segment -> keep lastFixed's y, travel to the target's x
    return lastSegmentWasVertical
        ? [lastFixed[0], target[1]]
        : [target[0], lastFixed[1]];
}
/**
 * Compute the live "elbow" that previews the in-progress segment of a
 * connection as it follows the cursor.
 *
 * The bend is {@link elbowCorner} toward the target. The target is the bare
 * `cursor`, unless it hovers a snap target that supplies its own `far` approach
 * point and `near` terminal endpoint (the preview then runs
 * `corner → far → near`; without a snap target `far` and `near` are both the
 * cursor, i.e. the `far → near` stub has zero length).
 *
 * The returned `corner`, `far`, `near` are exactly the points
 * {@link extendConnectPointPaths} commits on click, so the preview and the
 * committed geometry cannot drift apart.
 *
 * @param path - the current connection path (needs at least its last two points)
 * @param cursor - the live cursor position
 * @param snap - optional snap-target endpoints (`far` approach, then `near` terminal)
 * @returns the bend `corner` and the `far`/`near` endpoints of the preview
 */
function connectPreviewElbow(path, cursor, snap) {
    // Where the preview ends: the bare cursor, or a snap target's own endpoints.
    const far = snap ? snap.far : cursor;
    const near = snap ? snap.near : cursor;
    return { corner: elbowCorner(path, far), far, near };
}
function cleanPath(path) {
    let i = path.length - 2;
    while (i > 0) {
        const [x, y] = path[i];
        const [nx, ny] = path[i + 1];
        const [px, py] = path[i - 1];
        if ((x === nx && y === ny) ||
            (x === nx && x === px) ||
            (y === ny && y === py)) {
            path.splice(i, 1);
        }
        i -= 1;
    }
}

function sections(element) {
    const privates = element.querySelectorAll(`:scope Private[type="${privType}"]`);
    return Array.from(privates).flatMap(priv => Array.from(priv.children).filter(child => child.localName === 'Section' && child.namespaceURI === sldNs));
}
/** Returns the SLD sections in an element that are marked as busbar geometry. */
function busSections(element) {
    return sections(element).filter(section => getSLDAttributes(section, 'bus') === 'true');
}
/** Checks whether a Bay element is represented as an SLD busbar. */
function isBusBar(element) {
    return element.tagName === 'Bay' && busSections(element).length > 0;
}
/** Calculates rendered anchor points for starting T1 and T2 connections from equipment. */
function connectionStartPoints(equipment) {
    const { pos: [x, y], rot, } = attributes(equipment);
    const T1 = [
        [
            [x + 0.5, y + 0.16],
            [x + 0.84, y + 0.5],
            [x + 0.5, y + 0.84],
            [x + 0.16, y + 0.5],
        ][rot],
        [
            [x + 0.5, y],
            [x + 1, y + 0.5],
            [x + 0.5, y + 1],
            [x, y + 0.5],
        ][rot],
    ];
    const T2 = [
        [
            [x + 0.5, y + 0.84],
            [x + 0.16, y + 0.5],
            [x + 0.5, y + 0.16],
            [x + 0.84, y + 0.5],
        ][rot],
        [
            [x + 0.5, y + 1],
            [x, y + 0.5],
            [x + 0.5, y],
            [x + 1, y + 0.5],
        ][rot],
    ];
    return { T1, T2 };
}

function newResizeEvent(detail) {
    return new CustomEvent('oscd-sld-resize', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newResizeTLEvent(detail) {
    return new CustomEvent('oscd-sld-resize-tl', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newPlaceEvent(detail) {
    return new CustomEvent('oscd-sld-place', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newPlaceLabelEvent(detail) {
    return new CustomEvent('oscd-sld-place-label', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newConnectEvent(detail) {
    return new CustomEvent('oscd-sld-connect', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newExtendConnectPointEvent(path) {
    return new CustomEvent('oscd-sld-extend-connect-point', {
        bubbles: true,
        composed: true,
        detail: { path },
    });
}
function newRotateEvent(detail) {
    return new CustomEvent('oscd-sld-rotate', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newStartInteractionEvent(detail) {
    return new CustomEvent('oscd-sld-start-interaction', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newSelectEvent(element) {
    return new CustomEvent('oscd-sld-selected', {
        bubbles: true,
        composed: true,
        detail: { element },
    });
}
function newSclEditDialogEvent(element) {
    return new CustomEvent('oscd-sld-edit-scl', {
        bubbles: true,
        composed: true,
        detail: { element },
    });
}
function newGroundTerminalEvent(equipment, terminal) {
    return new CustomEvent('oscd-sld-ground-terminal', {
        bubbles: true,
        composed: true,
        detail: { equipment, terminal },
    });
}
function newOpenContextMenuEvent(detail) {
    return new CustomEvent('oscd-sld-open-context-menu', {
        bubbles: true,
        composed: true,
        detail,
    });
}
function newEditIedEvent(element) {
    return new CustomEvent('oscd-sld-edit-ied', {
        bubbles: true,
        composed: true,
        detail: { element },
    });
}

const privType = 'OpenSCD-SLD-Layout';
const sldNs = 'https://openscd.org/SCL/SSD/SLD/v0';
/**
 * Fallback prefix for the SLD-layout namespace ({@link sldNs}), used only when a
 * document does not already declare one. Components detect the document's actual
 * prefix at runtime (`lookupPrefix(sldNs)`) and fall back to this shared default,
 * so every component stamps the *same* prefix and view-built edits stay
 * consistent with controller-built ones.
 */
const defaultSldNsPrefix = 'eosld';
const svgNs$1 = 'http://www.w3.org/2000/svg';
const xlinkNs = 'http://www.w3.org/1999/xlink';
/**
 * Reads the prefix a document uses for the SLD-layout namespace ({@link sldNs}),
 * falling back to {@link defaultSldNsPrefix} when the document declares none.
 *
 * `nsp` has no independent existence: it is a pure projection of the document.
 * Deriving it on demand (rather than storing and threading a copy) guarantees
 * every component stamps the *same* prefix, so view-built edits stay consistent
 * with controller-built ones. `lookupPrefix` only inspects the root element's
 * `xmlns:*` declarations, so this is O(1) in document size.
 */
function sldPrefix(doc) {
    return doc?.documentElement.lookupPrefix(sldNs) ?? defaultSldNsPrefix;
}

function isIedReferenceElement(element) {
    return (element.localName === 'Reference' &&
        element.namespaceURI === sldNs &&
        element.getAttributeNS(sldNs, 'type') === 'IED');
}
function iedReferences(root) {
    const refs = Array.from(root.getElementsByTagNameNS(sldNs, 'Reference')).filter(isIedReferenceElement);
    return refs;
}
function iedIdentity(referencedIed) {
    if (isIedReferenceElement(referencedIed)) {
        return referencedIed.getAttributeNS(sldNs, 'id');
    }
    return null;
}
function resolveIed(referencedIed) {
    const doc = referencedIed.ownerDocument;
    if (isIedReferenceElement(referencedIed)) {
        const referenceIdentity = iedIdentity(referencedIed);
        if (!referenceIdentity) {
            return null;
        }
        return (Array.from(doc.querySelectorAll(':root > IED')).find(ied => identity(ied) === referenceIdentity) ?? null);
    }
    return null;
}

const transformerKinds = ['default', 'auto', 'earthing'];
/**
 * Fallback colour for a label with no persisted `color` SLDAttribute. This is a
 * document-data default (the value a label is treated as having when unset), not
 * a themable render token — kept a concrete literal so it round-trips through the
 * SCL unchanged. Shared with the context menu's "Reset Color" no-op check.
 */
const DEFAULT_LABEL_COLOR = '#000';
function isTransformerKind(kind) {
    return transformerKinds.includes(kind);
}
function xmlBoolean(value) {
    return ['true', '1'].includes(value?.trim() ?? 'false');
}
function sldAttributes(element, nsPrefix) {
    if (isIedReferenceElement(element)) {
        const referenceSldAttrs = Array.from(element.children).find(child => child.localName === 'SLDAttributes' && child.namespaceURI === sldNs);
        if (referenceSldAttrs) {
            return referenceSldAttrs;
        }
        {
            return null;
        }
    }
    const priv = Array.from(element.children).find(child => child.localName === 'Private' &&
        child.getAttribute('type') === privType);
    const sldAttrs = priv
        ? Array.from(priv.children).find(child => child.localName === 'SLDAttributes' && child.namespaceURI === sldNs) ?? null
        : null;
    if (sldAttrs) {
        return sldAttrs;
    }
    {
        return null;
    }
}
function getSLDAttributes(element, key) {
    const isSectionOrVertex = ['Section', 'Vertex'].includes(element.localName);
    if (isSectionOrVertex) {
        return element.getAttributeNS(sldNs, key);
    }
    return sldAttributes(element)?.getAttributeNS(sldNs, key) ?? null;
}
function attributes(element) {
    // Resolve the SLD-attribute source node once. `getSLDAttributes` would
    // otherwise re-run the (children-scanning) `sldAttributes` lookup for each of
    // the ~12 keys read below — a measurable cost when rendering thousands of
    // elements. Semantics match `getSLDAttributes`: Section/Vertex carry the
    // attributes directly, every other element via its SLDAttributes private.
    const isSectionOrVertex = ['Section', 'Vertex'].includes(element.localName);
    const source = isSectionOrVertex ? element : sldAttributes(element);
    const read = (key) => source?.getAttributeNS(sldNs, key) ?? null;
    const [x, y, w, h, rotVal, labelX, labelY] = [
        'x',
        'y',
        'w',
        'h',
        'rot',
        'lx',
        'ly',
    ].map(name => parseFloat(read(name) ?? '0'));
    const weight = parseInt(read('weight') ?? '300', 10);
    const pos = [x, y].map(d => Math.max(0, d));
    const dim = [w, h].map(d => Math.max(1, d));
    const label = [labelX, labelY].map(d => Math.max(0, d));
    const bus = xmlBoolean(read('bus'));
    const flip = xmlBoolean(read('flip'));
    const kindVal = read('kind');
    const kind = isTransformerKind(kindVal) ? kindVal : 'default';
    const color = read('color') || DEFAULT_LABEL_COLOR;
    const rot = (((rotVal % 4) + 4) % 4);
    return { pos, dim, label, flip, rot, bus, weight, color, kind };
}

/**
 * Element-aware geometry helpers.
 *
 * These bridge SCL Elements to the pure rectangle math in geometry.ts by
 * reading spatial attributes from elements and delegating to contains/overlaps.
 */
function containsRect(element, x0, y0, w0, h0) {
    const { pos: [x, y], dim: [w, h], } = attributes(element);
    return contains([x, y, w, h], [x0, y0, w0, h0]);
}
function overlapsRect(element, x0, y0, w0, h0) {
    const { pos: [x, y], dim: [w, h], } = attributes(element);
    return overlaps([x, y, w, h], [x0, y0, w0, h0]);
}

/**
 * SLD placement and resize validation rules.
 *
 * These encode the domain-specific logic for whether an SCL element can
 * legally occupy a given position or size on the SLD grid. They know about
 * the SLD topology (parent/child containment hierarchy, bus bar exemptions,
 * IED references occupying grid space, etc.).
 */
const parentTags = {
    ConductingEquipment: ['Bay'],
    Bay: ['VoltageLevel'],
    VoltageLevel: ['Substation'],
    PowerTransformer: ['Bay', 'VoltageLevel', 'Substation'],
    Reference: ['Bay', 'VoltageLevel', 'Substation'],
};
function canPlaceAt(root, element, x, y, w, h) {
    if (element.tagName === 'Substation') {
        return true;
    }
    const overlappingSibling = Array.from(root.querySelectorAll(`${element.localName}, PowerTransformer`))
        .concat(iedReferences(root))
        .find(sibling => sibling.closest(element.localName) !== element &&
        overlapsRect(sibling, x, y, w, h) &&
        !isBusBar(sibling));
    if (overlappingSibling && !isBusBar(element)) {
        return false;
    }
    const containingParent = element.tagName === 'VoltageLevel' ||
        element.tagName === 'PowerTransformer' ||
        isIedReferenceElement(element)
        ? containsRect(root, x, y, w, h)
        : Array.from(root.querySelectorAll(parentTags[element.localName].join(','))).find(parent => !isBusBar(parent) && containsRect(parent, x, y, w, h));
    if (containingParent) {
        return true;
    }
    return false;
}
function canResizeTo(root, element, w, h) {
    const { pos: [x, y], dim: [oldW, oldH], } = attributes(element);
    if (!canPlaceAt(root, element, x, y, w, h) &&
        canPlaceAt(root, element, x, y, oldW, oldH)) {
        return false;
    }
    const lostChild = Array.from(element.children)
        .concat(iedReferences(element))
        .find((child) => {
        if (!parentTags[child.localName]?.includes(element.localName)) {
            return false;
        }
        const { pos: [cx, cy], dim: [cw, ch], } = attributes(child);
        return !contains([x, y, w, h], [cx, cy, cw, ch]);
    });
    if (lostChild) {
        return false;
    }
    return true;
}
function canResizeToTL(root, element, x, y, w, h) {
    if (!canPlaceAt(root, element, x, y, w, h)) {
        return false;
    }
    const lostChild = Array.from(element.children)
        .concat(iedReferences(element))
        .find((child) => {
        if (!parentTags[child.localName]?.includes(element.localName)) {
            return false;
        }
        const { pos: [cx, cy], dim: [cw, ch], } = attributes(child);
        return !contains([x, y, w, h], [cx, cy, cw, ch]);
    });
    if (lostChild) {
        return false;
    }
    return true;
}

function isSelectable(element, selectable) {
    return selectable.some(sel => identity(element) === sel);
}
function isToBeHighlighted(element, highlight) {
    return highlight.some(h => identity(element) === h.id);
}
function getHighlightStyle(element, highlight) {
    const style = highlight.find(h => identity(element) === h.id)?.style;
    if (!style) {
        return '';
    }
    let styleStr = '';
    if (style?.fill) {
        styleStr += `fill: ${style.fill}; `;
    }
    if (style?.fillOpacity) {
        styleStr += `fill-opacity: ${style.fillOpacity}; `;
    }
    if (style?.stroke) {
        styleStr += `stroke: ${style.stroke}; `;
    }
    if (style?.strokeWidth) {
        styleStr += `stroke-width: ${style.strokeWidth}; `;
    }
    if (style?.strokeOpacity) {
        styleStr += `stroke-opacity: ${style.strokeOpacity}; `;
    }
    if (style?.rx) {
        styleStr += `rx: ${style.rx}; `;
    }
    return styleStr;
}

/**
 * Pure constructors for each {@link InteractionState} variant. They compute the next
 * interaction *value* only — no DOM, no events, no promises. Side-effecting
 * orchestration (event dispatch, placement promises, `disabled` guards) stays
 * on the host component, which simply assigns the result.
 *
 * Reserved as a possible future step: if transition guards accumulate (e.g.
 * "only append a point while connecting"), these could be folded into a single
 * `transition(state, action)` reducer. Avoided for now (YAGNI) — the union plus
 * these one-line constructors already give free exclusivity and call-site
 * narrowing without the extra machinery.
 */
/**
 * Pure selectors that read an {@link InteractionState} without re-fanning it out
 * into independent fields. They keep the union the single source of truth: the
 * viewer and the drawing artifacts ask these questions of the one `interaction`
 * value, so illegal combinations stay unrepresentable all the way down.
 *
 * - {@link isMode} answers "which gesture is active?" (mode-only).
 * - {@link targetInMode} answers "is *this* element the subject of gesture X?"
 *   (identity checks are mode-specific, hence the mode argument).
 * - {@link connectDetail} exposes the connect-from payload while connecting.
 */
function isMode(state, ...modes) {
    return modes.includes(state.mode);
}
function targetInMode(state, ...modes) {
    return 'element' in state && modes.includes(state.mode)
        ? state.element
        : undefined;
}
function connectDetail(state) {
    return state.mode === 'connectingFrom'
        ? { from: state.element, path: state.path, fromTerminal: state.terminal }
        : undefined;
}

function preventDefault$5(e) {
    if (e.button === 1) {
        e.preventDefault();
    }
}
function labelText(element, ied, x) {
    if (element.tagName !== 'Text') {
        return (element.getAttribute('name') ||
            ied?.getAttribute('name') ||
            element.getAttributeNS(sldNs, 'name'));
    }
    return element.textContent?.split(/\r?\n/).map((line, i) => w `<tspan
      alignment-baseline="central"
      x="${x + 0.1}"
      dy="${i === 0 ? A : '1.19em'}"
      visibility="${line ? A : 'hidden'}"
    >
      ${line || '.'}
    </tspan>`);
}
function renderLabel(element, context, { preview = false } = {}) {
    if (!context.view.showLabels) {
        return A;
    }
    if (context.view.showIeds === false && isIedReferenceElement(element)) {
        return A;
    }
    let deg = 0;
    let weight = 400;
    let color = 'var(--md-sys-color-on-surface, var(--oscd-base00))';
    const [x, y] = context.renderedLabelPosition(element, { preview });
    const ied = context.resolveIed(element);
    let text = labelText(element, ied, x);
    if (element.tagName === 'Text') {
        const { weight: textWeight, color: textColor, rot } = attributes(element);
        weight = textWeight;
        color = textColor;
        deg = rot * 90;
        if (!element.textContent) {
            text = '<Middle click to edit>';
            color = 'var(--oscd-sld-label-placeholder-color)';
            weight = 500;
        }
    }
    if (isIedReferenceElement(element) &&
        !isMode(context.interaction, 'placing', 'placingLabel')) {
        color = ied ? color : 'var(--oscd-sld-unresolved-reference-color)';
    }
    const fontSize = element.tagName === 'ConductingEquipment' ? 0.45 : 0.6;
    let events = 'none';
    let handleClick = A;
    if (isMode(context.interaction, 'idle') && !context.disabled) {
        events = 'all';
        handleClick = (event) => {
            const [mouseX2, mouseY2] = context.halfGridPosition(event);
            const offset = [mouseX2 - x - 0.5, mouseY2 - y + 0.5];
            context.dispatch(newStartInteractionEvent({ mode: 'placingLabel', element, offset }));
        };
    }
    else if (context.disabled && isSelectable(element, context.selectable)) {
        events = 'all';
        handleClick = () => context.dispatch(newSelectEvent(element));
    }
    let auxclick = A;
    if (!context.disabled) {
        auxclick = (e) => {
            if (e.button === 1) {
                if (!isIedReferenceElement(element)) {
                    context.dispatch(newSclEditDialogEvent(element));
                }
                else if (ied) {
                    context.dispatch(newEditIedEvent(ied));
                }
                e.preventDefault();
            }
        };
    }
    let contextmenu = A;
    if (!context.disabled) {
        contextmenu = (e) => {
            e.preventDefault();
            if (!isMode(context.interaction, 'idle')) {
                return;
            }
            context.requestContextMenu(element, e);
        };
    }
    let id = A;
    if (element.closest('Substation') === context.substation) {
        if (element.localName !== 'Text' && !isIedReferenceElement(element)) {
            id = `${identity(element)}`;
        }
        if (isIedReferenceElement(element)) {
            id = `${ied?.getAttribute('name') ?? ''}`;
        }
    }
    const classes = e({
        label: true,
        container: (element.tagName === 'Bay' && !isBusBar(element)) ||
            element.tagName === 'VoltageLevel',
        disabled: context.disabled,
        selectable: isSelectable(element, context.selectable),
    });
    return w `<g
    class="${classes}"
    id="label:${id}"
    transform="rotate(${deg} ${x + 0.5} ${y - 0.5})"
  >
    <text
      x="${x + 0.1}"
      y="${y - 0.5}"
      alignment-baseline="central"
      @mousedown=${preventDefault$5}
      @auxclick=${auxclick}
      @click=${handleClick}
      @contextmenu=${contextmenu}
      pointer-events="${events}"
      font-weight="${weight}"
      font-size="${fontSize}px"
      font-family="Roboto, sans-serif"
      style="fill: ${color}; cursor: default;"
    >
      ${text}
    </text>
  </g>`;
}

function preventDefault$4(e) {
    if (e.button === 1) {
        e.preventDefault();
    }
}
function equipmentRenderState(equipment, context, { preview = false, connect = false } = {}) {
    if (targetInMode(context.interaction, 'placing') === equipment && !preview) {
        return undefined;
    }
    if (connectDetail(context.interaction)?.from.closest('Substation') ===
        context.substation &&
        !connect) {
        return undefined;
    }
    const [x, y] = context.renderedPosition(equipment);
    const eqType = equipment.getAttribute('type');
    const terminals = Array.from(equipment.children).filter(c => c.tagName === 'Terminal');
    const topTerminal = terminals.find(t => t.getAttribute('name') === 'T1');
    const bottomTerminal = terminals.find(t => t.getAttribute('name') !== 'T1');
    const placingTarget = targetInMode(context.interaction, 'placing');
    const placingOtherElement = !!placingTarget && placingTarget !== equipment;
    const connectingFromSelf = targetInMode(context.interaction, 'connectingFrom') === equipment;
    const selectable = isSelectable(equipment, context.selectable);
    const highlightedStyle = isToBeHighlighted(equipment, context.highlight)
        ? getHighlightStyle(equipment, context.highlight)
        : undefined;
    return {
        bottomGrounded: bottomTerminal?.getAttribute('cNodeName') === 'grounded',
        canShowBottomPort: !(bottomTerminal ||
            isMode(context.interaction, 'locked', 'resizingBR', 'resizingTL', 'connectingFrom', 'placingLabel') ||
            placingOtherElement ||
            singleTerminal.has(eqType) ||
            context.disabled),
        canShowTopPort: !(topTerminal ||
            isMode(context.interaction, 'locked', 'resizingBR', 'resizingTL', 'connectingFrom', 'placingLabel') ||
            placingOtherElement ||
            context.disabled),
        clickthrough: connect ||
            (!isMode(context.interaction, 'idle') && placingTarget !== equipment) ||
            (context.disabled && !selectable),
        diagramElementId: equipment.closest('Substation') === context.substation
            ? `${identity(equipment)}`
            : undefined,
        disabled: context.disabled,
        highlightedStyle,
        placingSelf: placingTarget === equipment,
        portPointerEventsDisabled: isMode(context.interaction, 'placing'),
        position: [x, y],
        selectable,
        showBottomConnectIndicator: isMode(context.interaction, 'connectingFrom') &&
            !connectingFromSelf &&
            !(context.mouseX === x &&
                context.mouseY === y &&
                context.nearestOpenTerminal(equipment) === 'T2') &&
            !bottomTerminal &&
            !singleTerminal.has(eqType) &&
            !context.disabled,
        showTopConnectIndicator: isMode(context.interaction, 'connectingFrom') &&
            !connectingFromSelf &&
            !(context.mouseX === x &&
                context.mouseY === y &&
                context.nearestOpenTerminal(equipment) === 'T1') &&
            !topTerminal &&
            !context.disabled,
        topGrounded: topTerminal?.getAttribute('cNodeName') === 'grounded',
    };
}
function equipmentRenderActions(equipment, context, state) {
    let handleClick = (e) => {
        context.dispatch(newStartInteractionEvent({
            mode: 'placing',
            element: equipment,
            copy: e.shiftKey,
        }));
    };
    if (targetInMode(context.interaction, 'placing') === equipment) {
        const [x, y] = state.position;
        const parent = Array.from(context.substation.querySelectorAll(':root > Substation > VoltageLevel > Bay')).find(bay => !isBusBar(bay) && containsRect(bay, x, y, 1, 1));
        if (parent && canPlaceAt(context.substation, equipment, x, y, 1, 1)) {
            handleClick = () => {
                context.dispatch(newPlaceEvent({
                    x,
                    y,
                    element: equipment,
                    parent,
                }));
            };
        }
    }
    if (context.disabled && !state.selectable) {
        handleClick = () => { };
    }
    if (context.disabled && state.selectable) {
        handleClick = () => {
            context.dispatch(newSelectEvent(equipment));
        };
    }
    return {
        onAuxClick: (e) => {
            if (context.disabled) {
                return;
            }
            if (e.button === 1) {
                // middle mouse button
                context.dispatch(newRotateEvent(equipment));
                e.preventDefault();
            }
        },
        onClick: handleClick,
        onContextMenu: (e) => {
            e.preventDefault();
            if (!isMode(context.interaction, 'idle') || context.disabled) {
                return;
            }
            context.requestContextMenu(equipment, e);
        },
        onGroundBottom: (e) => {
            e.preventDefault();
            context.groundTerminal(equipment, 'T2');
        },
        onGroundTop: (e) => {
            e.preventDefault();
            context.groundTerminal(equipment, 'T1');
        },
        onMouseDown: preventDefault$4,
        onStartBottomConnect: () => {
            context.dispatch(newStartInteractionEvent({
                mode: 'connecting',
                from: equipment,
                fromTerminal: 'T2',
                path: connectionStartPoints(equipment).T2,
            }));
        },
        onStartTopConnect: () => {
            context.dispatch(newStartInteractionEvent({
                mode: 'connecting',
                from: equipment,
                fromTerminal: 'T1',
                path: connectionStartPoints(equipment).T1,
            }));
        },
    };
}
function renderEquipmentPreviewLabels(equipment, context, { preview = false } = {}) {
    return preview
        ? w `<g class="preview">
        ${[
            renderLabel(equipment, context, { preview }),
            ...Array.from(equipment.querySelectorAll('Text')).map(text => renderLabel(text, context, { preview })),
        ]}
      </g>`
        : A;
}
function renderEquipment(equipment, state, actions) {
    const [x, y] = state.position;
    const { flip, rot } = attributes(equipment);
    const deg = 90 * rot;
    const eqType = equipment.getAttribute('type');
    const ringed = ringedEqTypes.has(eqType);
    const symbol = isEqType(eqType) ? eqType : 'ConductingEquipment';
    const icon = ringed
        ? w `<svg
        viewBox="0 0 25 25"
        width="1"
        height="1"
      >
        ${eqRingPath}
      </svg>`
        : w `<use
        href="#${symbol}"
        xlink:href="#${symbol}"
        pointer-events="none"
      />`;
    const topConnector = state.canShowTopPort
        ? w `<circle
        class="port"
        cx="0.5"
        cy="0"
        r="0.2"
        opacity="0.4"
        style="fill: var(--oscd-sld-terminal-color); stroke: var(--oscd-sld-terminal-outline-color)"
        pointer-events="${state.portPointerEventsDisabled ? 'none' : A}"
        @click=${actions.onStartTopConnect}
        @contextmenu=${actions.onGroundTop}
      />`
        : A;
    const topIndicator = state.showTopConnectIndicator
        ? w `<polygon
        points="0.3,0 0.7,0 0.5,0.4"
        style="fill: var(--oscd-sld-terminal-color)"
        opacity="0.4"
      />`
        : A;
    const topGrounded = state.topGrounded
        ? w `<line
        x1="0.5"
        y1="-0.1"
        x2="0.5"
        y2="0.16"
        stroke="currentColor"
        stroke-width="0.06"
        marker-start="url(#grounded)"
      />`
        : A;
    const bottomConnector = state.canShowBottomPort
        ? w `<circle
        class="port"
        cx="0.5"
        cy="1"
        r="0.2"
        opacity="0.4"
        style="fill: var(--oscd-sld-terminal-color); stroke: var(--oscd-sld-terminal-outline-color)"
        pointer-events="${state.portPointerEventsDisabled ? 'none' : A}"
        @click=${actions.onStartBottomConnect}
        @contextmenu=${actions.onGroundBottom}
      />`
        : A;
    const bottomIndicator = state.showBottomConnectIndicator
        ? w `<polygon
        points="0.3,1 0.7,1 0.5,0.6"
        style="fill: var(--oscd-sld-terminal-color)"
        opacity="0.4"
      />`
        : A;
    const bottomGrounded = state.bottomGrounded
        ? w `<line
        x1="0.5"
        y1="1.1"
        x2="0.5"
        y2="0.84"
        stroke="currentColor"
        stroke-width="0.06"
        marker-start="url(#grounded)"
      />`
        : A;
    const highlight = state.highlightedStyle
        ? w `<rect
        x="${x}"
        y="${y}"
        width="1"
        height="1"
        style="${state.highlightedStyle}"
        pointer-events="none"
      />`
        : A;
    return w `${highlight}<g
    class="${e({
        equipment: true,
        preview: state.placingSelf,
        disabled: state.disabled,
        selectable: state.selectable,
    })}"
    id="${state.diagramElementId ?? A}"
    transform="translate(${x} ${y}) rotate(${deg} 0.5 0.5)${flip ? ' scale(-1,1) translate(-1 0)' : ''}"
  >
    <title>${equipment.getAttribute('name')}</title>
    ${icon}
    ${ringed
        ? w `<use
            transform="rotate(${-deg} 0.5 0.5)"
            pointer-events="none"
            href="#${symbol}"
            xlink:href="#${symbol}"
          />`
        : A}
    <rect
      width="1"
      height="1"
      fill="none"
      pointer-events="${state.clickthrough ? 'none' : 'all'}"
      @mousedown=${actions.onMouseDown}
      @click=${actions.onClick}
      @auxclick=${actions.onAuxClick}
      @contextmenu=${actions.onContextMenu}
    />
    ${topConnector}
    ${topIndicator}
    ${topGrounded}
    ${bottomConnector}
    ${bottomIndicator}
    ${bottomGrounded}
  </g>`;
}
const conductingEquipmentArtifact = {
    actions: equipmentRenderActions,
    matches: element => element.tagName === 'ConductingEquipment',
    render: (element, state, actions, context, options) => w `
    ${renderEquipment(element, state, actions)}
    ${renderEquipmentPreviewLabels(element, context, options)}
  `,
    state: equipmentRenderState,
};

function preventDefault$3(e) {
    if (e.button === 1) {
        e.preventDefault();
    }
}
function renderConnectivityNode(cNode, context) {
    const priv = cNode.querySelector(`Private[type="${privType}"]`);
    if (!priv) {
        return A;
    }
    const circles = [];
    const intersections = Object.entries(Array.from(priv.querySelectorAll('Vertex')).reduce((record, vertex) => {
        const ret = record;
        const key = JSON.stringify(context.renderedPosition(vertex));
        if (ret[key]) {
            ret[key].push(vertex);
        }
        else {
            ret[key] = [vertex];
        }
        return ret;
    }, {}))
        .filter(([_, vertices]) => vertices.length > 2 ||
        (vertices.length === 2 &&
            vertices.find(v => v.hasAttributeNS(sldNs, 'uuid'))))
        .map(([_, [vertex]]) => context.renderedPosition(vertex));
    intersections.forEach(([x, y]) => circles.push(w `<circle fill="currentColor" cx="${x}" cy="${y}" r="0.15" />`));
    const lines = [];
    const sections = Array.from(priv.getElementsByTagNameNS(sldNs, 'Section'));
    const bay = cNode.closest('Bay');
    const targetSize = 0.5;
    const pointerEvents = !isMode(context.interaction, 'placing', 'locked') &&
        (!isMode(context.interaction, 'resizingBR') ||
            (targetInMode(context.interaction, 'resizingBR') === bay &&
                isBusBar(bay)))
        ? 'all'
        : 'none';
    sections.forEach((section) => {
        const busBar = xmlBoolean(section.getAttributeNS(sldNs, 'bus'));
        const vertices = Array.from(section.getElementsByTagNameNS(sldNs, 'Vertex'));
        let i = 0;
        while (i < vertices.length - 1) {
            const [x1, y1] = context.renderedPosition(vertices[i]);
            let [x2, y2] = context.renderedPosition(vertices[i + 1]);
            let handleClick = A;
            let handleAuxClick = A;
            let handleContextMenu = A;
            if (busBar && bay && !context.disabled) {
                const { pos: [x, y], } = attributes(bay);
                handleClick = (e) => {
                    const [mouseX, mouseY] = context.gridPosition(e);
                    context.dispatch(newStartInteractionEvent({
                        mode: 'placing',
                        element: bay,
                        offset: [mouseX - x, mouseY - y],
                    }));
                };
                handleAuxClick = ({ button }) => {
                    if (button === 1) {
                        context.dispatch(newStartInteractionEvent({ mode: 'resizingBR', element: bay }));
                    }
                };
                handleContextMenu = (e) => {
                    e.preventDefault();
                    if (!isMode(context.interaction, 'idle')) {
                        return;
                    }
                    context.requestContextMenu(bay, e);
                };
            }
            if (busBar && targetInMode(context.interaction, 'resizingBR') === bay && !context.disabled) {
                if (section !==
                    sections.find(s => xmlBoolean(s.getAttributeNS(sldNs, 'bus')))) {
                    return;
                }
                circles.length = 0;
                const { pos: [vX, vY], dim: [vW, vH], } = attributes(bay.parentElement);
                const maxX = vX + vW - 0.5;
                const maxY = vY + vH - 0.5;
                if (i === 0) {
                    const dx = Math.max(context.mouseX - x1, 0);
                    const dy = Math.max(context.mouseY - y1, 0);
                    if (dx > dy) {
                        x2 = Math.max(x1, Math.min(maxX, context.mouseX + 0.5));
                        y2 = y1;
                    }
                    else {
                        y2 = Math.max(y1, Math.min(maxY, context.mouseY + 0.5));
                        x2 = x1;
                    }
                    if (x1 === x2 && y1 === y2) {
                        if (x2 >= maxX) {
                            y2 += 1;
                        }
                        else {
                            x2 += 1;
                        }
                    }
                }
                handleClick = () => {
                    context.dispatch(newPlaceEvent({
                        parent: section,
                        element: vertices[vertices.length - 1],
                        x: x2,
                        y: y2,
                    }));
                };
                lines.push(w `<rect x="${context.mouseX}" y="${context.mouseY}"
            width="1" height="1" fill="none" pointer-events="${pointerEvents}"
            @click=${handleClick} />`);
            }
            if (isMode(context.interaction, 'connectingFrom') && !context.disabled) {
                handleClick = () => {
                    const { from, path, fromTerminal } = connectDetail(context.interaction);
                    if (from
                        .closest('ConductingEquipment, PowerTransformer')
                        .querySelector(`[connectivityNode="${cNode.getAttribute('pathName')}"]`)) {
                        return;
                    }
                    const cursor = [context.mouseX2, context.mouseY2];
                    // The final drawn segment approaches the busbar from the elbow bend,
                    // unless the elbow is degenerate (no bend, i.e. the bend coincides
                    // with the cursor) — then it approaches straight from the last fixed
                    // waypoint.
                    const approach = elbowCorner(path, cursor);
                    const lastFixed = path[path.length - 2];
                    const start = approach[0] === cursor[0] && approach[1] === cursor[1]
                        ? lastFixed
                        : approach;
                    // Clamp the endpoint onto the busbar line segment [x1,y1]-[x2,y2],
                    // then re-bend the elbow to reach that clamped point.
                    const endpoint = findIntersection(start, cursor, [x1, y1], [x2, y2]);
                    const corner = elbowCorner(path, endpoint);
                    const newPath = extendConnectPointPaths(path, corner, endpoint);
                    context.dispatch(newConnectEvent({
                        from,
                        fromTerminal,
                        path: newPath,
                        to: cNode,
                    }));
                };
            }
            lines.push(w `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
              pointer-events="${pointerEvents}"
              stroke-width="${busBar ? 0.12 : A}" stroke="currentColor"
              stroke-linecap="${busBar ? 'round' : 'square'}" />`);
            lines.push(w `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
              pointer-events="${pointerEvents}" stroke-width="${targetSize}"
              @contextmenu=${handleContextMenu} @mousedown=${preventDefault$3}
              @click=${handleClick} @auxclick=${handleAuxClick} />`);
            if (busBar ||
                (isMode(context.interaction, 'connectingFrom') && !vertices[i].hasAttributeNS(sldNs, 'uuid'))) {
                lines.push(w `<rect x="${x1 - targetSize / 2}" y="${y1 - targetSize / 2}"
                width="${targetSize}" height="${targetSize}"
                @click=${handleClick} @auxclick=${handleAuxClick}
                @contextmenu=${handleContextMenu} @mousedown=${preventDefault$3}
                pointer-events="${pointerEvents}" fill="none" />`);
            }
            if (busBar ||
                (isMode(context.interaction, 'connectingFrom') && !vertices[i + 1].hasAttributeNS(sldNs, 'uuid'))) {
                lines.push(w `<rect x="${x2 - targetSize / 2}" y="${y2 - targetSize / 2}"
                width="${targetSize}" height="${targetSize}"
                @click=${handleClick} @auxclick=${handleAuxClick}
                @contextmenu=${handleContextMenu} @mousedown=${preventDefault$3}
                pointer-events="${pointerEvents}" fill="none" />`);
            }
            i += 1;
        }
    });
    const id = cNode.closest('Substation') === context.substation
        ? identity(cNode)
        : A;
    return w `<g class="${e({
        node: true,
        disabled: context.disabled,
    })}" id="${id}" >
      <title>${cNode.getAttribute('pathName')}</title>
      ${circles}
      ${lines}
    </g>`;
}

function busBarState(busBar, context) {
    const [x, y] = context.renderedPosition(busBar);
    const { dim: [w, h], } = attributes(busBar);
    return {
        diagramElementId: busBar.closest('Substation') === context.substation
            ? String(identity(busBar))
            : undefined,
        dimensions: [w, h],
        position: [x, y],
    };
}
function busBarActions(busBar, context, state) {
    const [x, y] = state.position;
    const [w, h] = state.dimensions;
    if (context.disabled || isMode(context.interaction, 'locked')) {
        return { onClick: () => { } };
    }
    return {
        onClick: () => {
            const parent = Array.from(context.substation.querySelectorAll(':root > Substation > VoltageLevel')).find(vl => containsRect(vl, x, y, w, h));
            if (parent) {
                context.dispatch(newPlaceEvent({
                    x,
                    y,
                    element: busBar,
                    parent,
                }));
            }
        },
    };
}
function renderBusBar(busBar, state, actions, context) {
    const [x, y] = state.position;
    const [w$1, h] = state.dimensions;
    return w `<g class="bus preview" id="${state.diagramElementId ?? A}">
    <title>${busBar.getAttribute('name')}</title>
    ${renderLabel(busBar, context)}
    ${Array.from(busBar.querySelectorAll('Text')).map(text => renderLabel(text, context))}
    ${renderConnectivityNode(busBar.querySelector('ConnectivityNode'), context)}
    <rect
      x="${x}"
      y="${y}"
      width="${w$1}"
      height="${h}"
      pointer-events="all"
      fill="none"
      @click=${actions.onClick}
    />
  </g>`;
}
const busBarArtifact = {
    actions: busBarActions,
    matches: isBusBar,
    render: renderBusBar,
    state: busBarState,
};

function preventDefault$2(e) {
    if (e.button === 1) {
        e.preventDefault();
    }
}
function iedReferenceState(referencedIed, context, { preview = false } = {}) {
    if (context.view.showIeds === false ||
        (targetInMode(context.interaction, 'placing') === referencedIed && !preview)) {
        return undefined;
    }
    const [x, y] = context.renderedPosition(referencedIed);
    const iedName = context.resolveIed(referencedIed)?.getAttribute('name') ?? null;
    return {
        clickthrough: !isMode(context.interaction, 'idle') && targetInMode(context.interaction, 'placing') !== referencedIed,
        diagramElementId: referencedIed.closest('Substation') === context.substation && iedName
            ? `IEDRef-${iedName}`
            : undefined,
        disabled: context.disabled,
        iedName,
        placingSelf: targetInMode(context.interaction, 'placing') === referencedIed,
        position: [x, y],
        selectable: isSelectable(referencedIed, context.selectable),
    };
}
function iedReferenceActions(referencedIed, context, state) {
    let handleClick = () => { };
    const [x, y] = state.position;
    if (targetInMode(context.interaction, 'placing') === referencedIed &&
        canPlaceAt(context.substation, referencedIed, x, y, 1, 1)) {
        handleClick = () => {
            const parent = Array.from(context.substation.querySelectorAll(':scope > VoltageLevel > Bay'))
                .concat(Array.from(context.substation.querySelectorAll(':scope > VoltageLevel')))
                .find(vlOrBay => containsRect(vlOrBay, x, y, 1, 1)) ||
                context.substation;
            context.dispatch(newPlaceEvent({
                x,
                y,
                element: referencedIed,
                parent,
            }));
        };
    }
    else if (context.disabled && state.selectable) {
        handleClick = () => context.dispatch(newSelectEvent(referencedIed));
    }
    else if (!isMode(context.interaction, 'idle') || context.disabled) {
        handleClick = () => { };
    }
    else {
        handleClick = () => context.dispatch(newStartInteractionEvent({ mode: 'placing', element: referencedIed }));
    }
    return {
        onClick: handleClick,
        onContextMenu: (e) => {
            e.preventDefault();
            if (!isMode(context.interaction, 'idle') || context.disabled) {
                return;
            }
            context.requestContextMenu(referencedIed, e);
        },
        onMouseDown: preventDefault$2,
    };
}
function renderIedReference(_referencedIed, state, actions) {
    const [x, y] = state.position;
    return w `<g
    class="${e({
        ied: true,
        preview: state.placingSelf,
        disabled: state.disabled,
        selectable: state.selectable,
    })}"
    id="${state.diagramElementId ?? A}"
    transform="translate(${x} ${y})"
  >
    <title>${state.iedName}</title>
    <use href="#IED" xlink:href="#IED" pointer-events="none" />
    <rect
      width="1"
      height="1"
      fill="none"
      pointer-events="${state.clickthrough ? 'none' : 'all'}"
      @mousedown=${actions.onMouseDown}
      @click=${actions.onClick}
      @contextmenu=${actions.onContextMenu}
    />
  </g>`;
}
function renderIedReferencePreviewLabels(referencedIed, context, { preview = false } = {}) {
    return preview
        ? w `<g class="preview">
        ${renderLabel(referencedIed, context, { preview })}
      </g>`
        : A;
}
const iedReferenceArtifact = {
    actions: iedReferenceActions,
    matches: isIedReferenceElement,
    render: (element, state, actions, context, options) => w `
    ${renderIedReference(element, state, actions)}
    ${renderIedReferencePreviewLabels(element, context, options)}
  `,
    state: iedReferenceState,
};

function shiftPoint(point, rot, coord, amount) {
    const shifted = point.slice();
    if (coord === 0) {
        shifted[rot % 2] += rot < 2 ? amount : -amount;
    }
    else {
        shifted[(rot + 1) % 2] += rot > 0 && rot < 3 ? -amount : amount;
    }
    return shifted;
}
function transformerWindingMeasures(winding, transformerPosition, { rot, kind, flip }, twoWindingEarthingZigZagTransform) {
    const transformer = winding.parentElement;
    const windings = Array.from(transformer.children).filter(c => c.tagName === 'TransformerWinding');
    const [x, y] = transformerPosition.map(c => c + 0.5);
    let center = [x, y];
    const size = 0.7;
    const grounded = {};
    const terminals = {};
    let arc;
    let zigZagTransform;
    const terminalElements = Array.from(winding.children).filter(c => c.tagName === 'Terminal');
    const terminal1 = terminalElements.find(t => t.getAttribute('name') === 'T1');
    const terminal2 = terminalElements.find(t => t.getAttribute('name') !== 'T1');
    const neutral = Array.from(winding.children).find(c => c.tagName === 'NeutralPoint');
    const windingIndex = windings.indexOf(winding);
    if (windings.length === 1) {
        if (kind === 'earthing') {
            zigZagTransform = '';
            const n1 = shiftPoint(center, rot, 1, size);
            if (!neutral) {
                terminals.N1 = n1;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                const n1p = shiftPoint(n1, rot, 1, 0.2);
                grounded.N1 = [n1p, n1];
            }
            if (!terminal1 && !terminal2) {
                terminals.T1 = shiftPoint(center, rot, 1, -size);
            }
        }
        else {
            const sgn = flip ? -1 : 1;
            const n1 = shiftPoint(center, rot, 0, -size);
            const n2 = shiftPoint(center, rot, 0, size);
            const t1 = shiftPoint(center, rot, 1, (-size - 0.5) * sgn);
            const t2 = shiftPoint(center, rot, 1, size * sgn);
            if (!neutral) {
                terminals.N1 = n1;
                terminals.N2 = n2;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                if (neutral.getAttribute('name') === 'N1') {
                    const n1p = shiftPoint(n1, rot, 0, -0.2);
                    grounded.N1 = [n1p, n1];
                }
                else {
                    const n2p = shiftPoint(n2, rot, 0, 0.2);
                    grounded.N2 = [n2p, n2];
                }
            }
            arc = {
                from: n2,
                fromCtl: shiftPoint(n2, rot, 1, -sgn),
                to: t1,
                toCtl: shiftPoint(shiftPoint(t1, rot, 0, 0.2), rot, 1, 0.1 * sgn),
            };
            if (!terminal1) {
                terminals.T1 = t1;
            }
            if (!terminal2) {
                terminals.T2 = t2;
            }
        }
    }
    else if (windings.length === 2) {
        if (windingIndex === 1) {
            center = shiftPoint(center, rot, 1, 1);
        }
        if (kind === 'auto') {
            if (windingIndex === 1) {
                const n1 = shiftPoint(center, rot, 0, -size);
                const n2 = shiftPoint(center, rot, 0, size);
                if (!neutral) {
                    terminals.N1 = n1;
                    terminals.N2 = n2;
                }
                else if (neutral.getAttribute('cNodeName') === 'grounded') {
                    if (neutral.getAttribute('name') === 'N1') {
                        const n1p = shiftPoint(n1, rot, 0, -0.2);
                        grounded.N1 = [n1p, n1];
                    }
                    else {
                        const n2p = shiftPoint(n2, rot, 0, 0.2);
                        grounded.N2 = [n2p, n2];
                    }
                }
                if (!terminal1 && !terminal2) {
                    terminals.T1 = shiftPoint(center, rot, 1, size);
                }
            }
            else {
                const sgn = flip ? -1 : 1;
                const t1 = shiftPoint(center, rot, 0, size * sgn);
                const t2 = shiftPoint(center, rot, 0, (-size - 0.5) * sgn);
                const n1 = shiftPoint(center, rot, 1, -size);
                arc = {
                    from: n1,
                    fromCtl: shiftPoint(n1, rot, 0, -sgn),
                    to: t2,
                    toCtl: shiftPoint(shiftPoint(t2, rot, 1, -0.2), rot, 0, 0.1 * sgn),
                };
                if (!terminal1) {
                    terminals.T1 = t1;
                }
                if (!terminal2) {
                    terminals.T2 = t2;
                }
                if (!neutral) {
                    terminals.N1 = n1;
                }
                else if (neutral.getAttribute('cNodeName') === 'grounded') {
                    const n1p = shiftPoint(n1, rot, 1, -0.2);
                    grounded.N1 = [n1p, n1];
                }
            }
        }
        else if (kind === 'earthing') {
            if (windingIndex === 1) {
                if (!terminal1 && !terminal2) {
                    terminals.T1 = shiftPoint(center, rot, 1, size);
                }
            }
            else {
                zigZagTransform = twoWindingEarthingZigZagTransform;
                const sgn = flip ? -1 : 1;
                if (!terminal1 && !terminal2) {
                    terminals.T1 = shiftPoint(center, rot, 0, -size * sgn);
                }
                const n1 = shiftPoint(center, rot, 0, size * sgn);
                if (!neutral) {
                    terminals.N1 = n1;
                }
                else if (neutral.getAttribute('cNodeName') === 'grounded') {
                    const n1p = shiftPoint(n1, rot, 0, 0.2 * sgn);
                    grounded.N1 = [n1p, n1];
                }
            }
        }
        else if (windingIndex === 1) {
            const n1 = shiftPoint(center, rot, 0, -size);
            const n2 = shiftPoint(center, rot, 0, +size);
            if (!neutral) {
                terminals.N1 = n1;
                terminals.N2 = n2;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                if (neutral.getAttribute('name') === 'N1') {
                    const n1p = shiftPoint(n1, rot, 0, -0.2);
                    grounded.N1 = [n1p, n1];
                }
                else {
                    const n2p = shiftPoint(n2, rot, 0, 0.2);
                    grounded.N2 = [n2p, n2];
                }
            }
            if (!terminal1 && !terminal2) {
                terminals.T1 = shiftPoint(center, rot, 1, +size);
            }
        }
        else {
            const n1 = shiftPoint(center, rot, 0, -size);
            const n2 = shiftPoint(center, rot, 0, +size);
            if (!neutral) {
                terminals.N1 = n1;
                terminals.N2 = n2;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                if (neutral.getAttribute('name') === 'N1') {
                    const n1p = shiftPoint(n1, rot, 0, -0.2);
                    grounded.N1 = [n1p, n1];
                }
                else {
                    const n2p = shiftPoint(n2, rot, 0, 0.2);
                    grounded.N2 = [n2p, n2];
                }
            }
            if (!terminal1 && !terminal2) {
                terminals.T1 = shiftPoint(center, rot, 1, -size);
            }
        }
    }
    else if (windings.length === 3) {
        if (windingIndex === 0) {
            if (!terminal1 && !terminal2) {
                terminals.T1 = shiftPoint(center, rot, 1, -size);
            }
            const n1 = shiftPoint(center, rot, 0, -size);
            const n2 = shiftPoint(center, rot, 0, +size);
            if (!neutral) {
                terminals.N1 = n1;
                terminals.N2 = n2;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                if (neutral.getAttribute('name') === 'N1') {
                    const n1p = shiftPoint(n1, rot, 0, -0.2);
                    grounded.N1 = [n1p, n1];
                }
                else {
                    const n2p = shiftPoint(n2, rot, 0, 0.2);
                    grounded.N2 = [n2p, n2];
                }
            }
        }
        else if (windingIndex === 1) {
            center = shiftPoint(shiftPoint(center, rot, 0, 0.5), rot, 1, 1);
            if (!terminal1 && !terminal2) {
                terminals.T1 = shiftPoint(center, rot, 0, size);
            }
            const n1 = shiftPoint(center, rot, 1, size);
            if (!neutral) {
                terminals.N1 = n1;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                const n1p = shiftPoint(n1, rot, 1, 0.2);
                grounded.N1 = [n1p, n1];
            }
        }
        else if (windingIndex === 2) {
            center = shiftPoint(shiftPoint(center, rot, 0, -0.5), rot, 1, 1);
            if (!terminal1 && !terminal2) {
                terminals.T1 = shiftPoint(center, rot, 0, -size);
            }
            const n1 = shiftPoint(center, rot, 1, size);
            if (!neutral) {
                terminals.N1 = n1;
            }
            else if (neutral.getAttribute('cNodeName') === 'grounded') {
                const n1p = shiftPoint(n1, rot, 1, 0.2);
                grounded.N1 = [n1p, n1];
            }
        }
    }
    return { center, size, terminals, grounded, arc, zigZagTransform };
}

function preventDefault$1(e) {
    if (e.button === 1) {
        e.preventDefault();
    }
}
function transformerHighlight(transformer, highlight) {
    const style = getHighlightStyle(transformer, highlight);
    const { pos: [x, y], } = attributes(transformer);
    const nmWindings = transformer.querySelectorAll('TransformerWinding').length;
    if (nmWindings === 3) {
        return w `<rect x="${x - 0.8}" y="${y - 0.3}" width="2.6" height="2.6" style="${style}" pointer-events="none" />`;
    }
    if (nmWindings === 2) {
        return w `<rect x="${x - 0.3}" y="${y - 0.3}" width="1.6" height="2.6" style="${style}" pointer-events="none" />`;
    }
    return w `<rect x="${x - 0.3}" y="${y - 0.3}" width="1.6" height="1.6" style="${style}" pointer-events="none" />`;
}
function renderTransformerWinding(winding, context) {
    const { size, center: [cx, cy], terminals, grounded, arc, zigZagTransform, } = transformerWindingMeasures(winding, context.renderedPosition(winding.parentElement), attributes(winding.parentElement), zigZag2WTransform);
    const ports = [];
    Object.entries(grounded).forEach(([_, [[x1, y1], [x2, y2]]]) => {
        ports.push(w `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="currentColor" stroke-width="0.06" marker-start="url(#grounded)" />`);
    });
    const groundable = winding.closest('Bay');
    const placingTarget = targetInMode(context.interaction, 'placing');
    if (!(isMode(context.interaction, 'connectingFrom', 'resizingBR', 'resizingTL', 'placingLabel') ||
        (placingTarget &&
            placingTarget !== winding.closest('PowerTransformer')) ||
        context.disabled)) {
        Object.entries(terminals).forEach(([name, point]) => {
            if (!point) {
                return;
            }
            const [x, y] = point;
            const x1 = Number.isInteger(x * 2) ? x : x + 1;
            const y1 = Number.isInteger(y * 2) ? y : y + 1;
            const terminal = name.startsWith('T');
            const fill = terminal
                ? 'var(--oscd-sld-terminal-color)'
                : 'var(--oscd-sld-neutral-terminal-color)';
            ports.push(w `<circle class="port" cx="${x}" cy="${y}" r="0.2" opacity="0.4"
            @contextmenu=${(e) => {
                if (terminal) {
                    return;
                }
                e.preventDefault();
                e.stopImmediatePropagation();
                if (!isMode(context.interaction, 'idle')) {
                    return;
                }
                context.groundTerminal(winding, name);
            }}
            @click=${(e) => {
                e.stopImmediatePropagation();
                if (!isMode(context.interaction, 'idle')) {
                    return;
                }
                context.dispatch(newStartInteractionEvent({
                    mode: 'connecting',
                    from: winding,
                    fromTerminal: name,
                    path: [
                        [x, y],
                        [x1, y1],
                    ],
                }));
            }}
            style="fill: ${fill}; stroke: ${groundable && !terminal ? 'var(--oscd-sld-groundable-terminal-color)' : 'none'}" />`);
        });
    }
    let longArrow = false;
    let arcPath = w ``;
    const { flip, rot } = attributes(winding.parentElement);
    if (arc) {
        const { from: [xf, yf], fromCtl: [xfc, yfc], to: [xt, yt], toCtl: [xtc, ytc], } = arc;
        if (!flip && yfc < yf) {
            longArrow = true;
        }
        if (flip && xfc > xf) {
            longArrow = true;
        }
        arcPath = w `<path d="M ${xf} ${yf} C ${xfc} ${yfc}, ${xtc} ${ytc}, ${xt} ${yt}" stroke="currentColor" stroke-width="0.06" />`;
    }
    const tapChanger = winding.querySelector('TapChanger');
    const ltcArrow = tapChanger
        ? w `<line x1="${cx - 0.8}" y1="${cy + 0.8}" x2="${cx + 0.8}" y2="${cy - (longArrow ? 1 : 0.8)}"
            stroke="currentColor" stroke-width="0.06" marker-end="url(#arrow)" />`
        : A;
    const zigZag = zigZagTransform === undefined
        ? A
        : w `<g stroke="currentColor" stroke-linecap="round"
              transform="rotate(${rot * 90} ${cx} ${cy})
              translate(${cx - 1.5} ${cy - 1.5})
              ${zigZagTransform}">${zigZagPath}</g>`;
    return w `<g class="winding"
      @contextmenu=${(e) => {
        e.preventDefault();
        if (!isMode(context.interaction, 'idle')) {
            return;
        }
        context.requestContextMenu(winding, e);
    }}
  ><circle cx="${cx}" cy="${cy}" r="${size}" stroke="currentColor" stroke-width="0.06" />${arcPath}${zigZag}${ltcArrow}${ports}</g>`;
}
function powerTransformerState(transformer, context, { preview = false } = {}) {
    if (targetInMode(context.interaction, 'placing') === transformer && !preview) {
        return undefined;
    }
    return {
        disabled: context.disabled,
        highlight: isToBeHighlighted(transformer, context.highlight)
            ? transformerHighlight(transformer, context.highlight)
            : '',
        placingSelf: targetInMode(context.interaction, 'placing') === transformer,
        position: context.renderedPosition(transformer),
        selectable: isSelectable(transformer, context.selectable),
        windings: Array.from(transformer.children).filter(c => c.tagName === 'TransformerWinding'),
    };
}
function powerTransformerActions(transformer, context, state) {
    const [x, y] = state.position;
    let handleClick = A;
    if (targetInMode(context.interaction, 'placing') === transformer) {
        handleClick = (e) => {
            if (targetInMode(context.interaction, 'placing') === transformer) {
                const parent = Array.from(context.substation.querySelectorAll(':scope > VoltageLevel > Bay'))
                    .concat(Array.from(context.substation.querySelectorAll(':scope > VoltageLevel')))
                    .find(vl => containsRect(vl, x, y, 1, 1)) || context.substation;
                context.dispatch(newPlaceEvent({
                    element: transformer,
                    parent,
                    x,
                    y,
                }));
            }
            if (!isMode(context.interaction, 'idle')) {
                return;
            }
            const [mouseX, mouseY] = context.gridPosition(e);
            const offset = [mouseX - x, mouseY - y];
            context.dispatch(newStartInteractionEvent({
                mode: 'placing',
                element: transformer,
                copy: e.shiftKey,
                offset,
            }));
        };
    }
    else if (context.disabled && state.selectable) {
        handleClick = () => context.dispatch(newSelectEvent(transformer));
    }
    else if (context.disabled || !isMode(context.interaction, 'idle')) {
        handleClick = () => { };
    }
    else {
        handleClick = (e) => {
            const [mouseX, mouseY] = context.gridPosition(e);
            const offset = [mouseX - x, mouseY - y];
            context.dispatch(newStartInteractionEvent({
                mode: 'placing',
                element: transformer,
                copy: e.shiftKey,
                offset,
            }));
        };
    }
    return {
        onAuxClick: (e) => {
            if (e.button === 1) {
                context.dispatch(newRotateEvent(transformer));
                e.preventDefault();
            }
        },
        onClick: handleClick,
    };
}
function renderPowerTransformer(transformer, state, actions, context, { preview = false } = {}) {
    const clickTarget = state.placingSelf
        ? w `<rect width="1" height="1" fill="none"
          x="${context.mouseX}" y="${context.mouseY}" />`
        : A;
    return w `${state.highlight}<g class="${e({
        transformer: true,
        preview,
        disabled: state.disabled,
        selectable: state.selectable,
    })}"
      pointer-events="all"
      @mousedown=${preventDefault$1}
      @auxclick=${actions.onAuxClick}
      @click=${actions.onClick}>
      ${state.windings.map(w => renderTransformerWinding(w, context))}
      ${clickTarget}
    </g>
    <g class="preview">${preview
        ? [
            renderLabel(transformer, context, { preview }),
            ...Array.from(transformer.querySelectorAll('Text')).map(text => renderLabel(text, context, { preview })),
        ]
        : A}</g>`;
}
const powerTransformerArtifact = {
    actions: powerTransformerActions,
    matches: element => element.tagName === 'PowerTransformer',
    render: renderPowerTransformer,
    state: powerTransformerState,
};

function isBay$1(element) {
    return element.tagName === 'Bay' && !isBusBar(element);
}
function preventDefault(e) {
    if (e.button === 1) {
        e.preventDefault();
    }
}
const voltageLevelKind = {
    className: 'voltagelevel',
    stroke: 'var(--oscd-sld-voltage-level-color)',
    strokeDasharray: A,
    placingChildTag: 'Bay',
    resolvePlacementParent: (_element, context) => context.substation,
};
const bayKind = {
    className: 'bay',
    stroke: 'var(--oscd-sld-bay-color)',
    strokeDasharray: '0.18',
    placingChildTag: 'ConductingEquipment',
    resolvePlacementParent: (_element, context, x, y, w, h) => Array.from(context.substation.querySelectorAll(':root > Substation > VoltageLevel')).find(vl => containsRect(vl, x, y, w, h)),
};
function renderHighlightLayer(element, context, x, y, w$1, h) {
    if (!isToBeHighlighted(element, context.highlight)) {
        return A;
    }
    return w `<rect x="${x}" y="${y}" width="${w$1}" height="${h}" style="${getHighlightStyle(element, context.highlight)}" pointer-events="none" />`;
}
function renderEquipmentLayer(element, context) {
    return Array.from(element.children)
        .filter(child => child.tagName === 'ConductingEquipment')
        .map(equipment => context.renderEquipment(equipment));
}
function renderPowerTransformerLayer(element, context) {
    return Array.from(element.children)
        .filter(child => child.tagName === 'PowerTransformer')
        .map(powerTransformer => context.renderPowerTransformer(powerTransformer));
}
function renderIedLayer(element, context, preview) {
    return iedReferences(element)
        .filter(referencedIed => referencedIed.parentElement?.tagName === 'Private' &&
        referencedIed.parentElement.parentElement === element)
        .map(referencedIed => context.renderIed(referencedIed, { preview }));
}
function renderPreviewConnectivityLayer(element, context, preview) {
    if (!preview) {
        return A;
    }
    return Array.from(element.querySelectorAll('ConnectivityNode'))
        .filter(child => child.getAttribute('name') !== 'grounded')
        .map(cNode => context.renderConnectivityNode(cNode));
}
function renderPreviewLabelLayer(element, context, preview) {
    if (!preview) {
        return A;
    }
    return Array.from(element.querySelectorAll('Bay, ConductingEquipment, PowerTransformer, Text'))
        .concat(Array.from(element.querySelector(':scope > Private[type="OpenSCD-SLD-Layout"]')
        ? iedReferences(element.querySelector(':scope > Private[type="OpenSCD-SLD-Layout"]'))
        : []))
        .concat(element)
        .map(labelled => renderLabel(labelled, context, { preview }));
}
function renderResizeHandlesLayer(element, context, x, y, w$1, h) {
    if (!isMode(context.interaction, 'idle') || context.disabled) {
        return A;
    }
    return w `
    <svg xmlns="${svgNs$1}" height="1" width="1" fill="black"
      opacity="0.83" class="handle"
      @click=${() => context.dispatch(newStartInteractionEvent({ mode: 'resizingTL', element }))}
      viewBox="0 96 960 960" x="${x}" y="${y}">
      <rect fill="white" x="28.8" y="124.8" width="902.4" height="902.4" />
      ${resizeTLPath}
    </svg>
    <svg xmlns="${svgNs$1}" height="1" width="1" fill="black"
      opacity="0.83" class="handle"
      @click=${() => context.dispatch(newStartInteractionEvent({ mode: 'resizingBR', element }))}
      viewBox="0 96 960 960" x="${w$1 + x - 1}" y="${h + y - 1}">
      <rect fill="white" x="28.8" y="124.8" width="902.4" height="902.4" />
      ${resizeBRPath}
    </svg>
  `;
}
function renderPlacingTargetLayer(context, kind, handleClick, x, y, w$1, h) {
    if (targetInMode(context.interaction, 'placing')?.tagName !== kind.placingChildTag) {
        return A;
    }
    return w `<rect x="${x}" y="${y}" width="${w$1}" height="${h}"
    @click=${handleClick} fill="url(#grid)" />`;
}
function renderResizingTargetLayer(element, context, handleClick, x, y, w$1, h) {
    const resizingBRTarget = targetInMode(context.interaction, 'resizingBR');
    if (resizingBRTarget !== element &&
        targetInMode(context.interaction, 'resizingTL') !== element &&
        !(resizingBRTarget?.parentElement === element && isBusBar(resizingBRTarget))) {
        return A;
    }
    return w `<rect x="${x}" y="${y}" width="${w$1}" height="${h}"
    @click=${handleClick} fill="url(#grid)" />`;
}
/**
 * Renders a single SLD equipment container (`VoltageLevel` or `Bay`): its
 * resizable rectangle, drag-to-place and resize interactions, resize handles,
 * highlight, and child contents. The `kind` supplies the few VoltageLevel/Bay
 * differences; `childContainers` are the nested containers to render inside
 * (the bays of a voltage level, or `nothing` for a bay).
 */
function render(element, context, preview, kind, childContainers) {
    if (targetInMode(context.interaction, 'placing') === element && !preview) {
        return w ``;
    }
    let [x, y] = context.renderedPosition(element);
    let { dim: [w$1, h], } = attributes(element);
    const right = x + w$1 - 1;
    const bottom = y + h - 1;
    let handleClick = (e) => {
        if (isMode(context.interaction, 'idle')) {
            const [mouseX, mouseY] = context.gridPosition(e);
            context.dispatch(newStartInteractionEvent({
                mode: 'placing',
                element,
                copy: e.shiftKey,
                offset: [mouseX - x, mouseY - y],
            }));
        }
    };
    let invalid = false;
    let contextmenu = (e) => {
        e.preventDefault();
        if (!isMode(context.interaction, 'idle')) {
            return;
        }
        context.requestContextMenu(element, e);
    };
    if (context.disabled) {
        contextmenu = () => { };
    }
    let auxclick = ({ clientX, clientY, button }) => {
        if (button !== 1) {
            return;
        }
        const mouse = context.svgCoordinates(clientX, clientY);
        if (distance$1(mouse, [x, y]) < distance$1(mouse, [right, bottom])) {
            context.dispatch(newStartInteractionEvent({ mode: 'resizingTL', element }));
        }
        else {
            context.dispatch(newStartInteractionEvent({ mode: 'resizingBR', element }));
        }
    };
    if (context.disabled) {
        auxclick = () => { };
    }
    if (targetInMode(context.interaction, 'resizingBR') === element) {
        w$1 = Math.max(1, context.mouseX - x + 1);
        h = Math.max(1, context.mouseY - y + 1);
        if (canResizeTo(context.substation, element, w$1, h)) {
            handleClick = () => context.dispatch(newResizeEvent({
                w: w$1,
                h,
                element,
            }));
        }
        else {
            invalid = true;
        }
    }
    if (targetInMode(context.interaction, 'resizingTL') === element) {
        w$1 = Math.max(1, x + w$1 - context.mouseX);
        h = Math.max(1, y + h - context.mouseY);
        x = Math.min(context.mouseX, right);
        y = Math.min(context.mouseY, bottom);
        if (canResizeToTL(context.substation, element, x, y, w$1, h)) {
            handleClick = () => context.dispatch(newResizeTLEvent({
                x,
                y,
                w: w$1,
                h,
                element,
            }));
        }
        else {
            invalid = true;
        }
    }
    if (targetInMode(context.interaction, 'placing') === element) {
        const parent = kind.resolvePlacementParent(element, context, x, y, w$1, h);
        if (parent && canPlaceAt(context.substation, element, x, y, w$1, h)) {
            handleClick = () => context.dispatch(newPlaceEvent({
                x,
                y,
                element,
                parent,
            }));
        }
        else {
            invalid = true;
        }
    }
    const clickthrough = context.disabled ||
        (!isMode(context.interaction, 'idle') &&
            targetInMode(context.interaction, 'placing') !== element &&
            targetInMode(context.interaction, 'resizingBR') !== element &&
            targetInMode(context.interaction, 'resizingTL') !== element);
    const strokeColor = invalid
        ? 'var(--oscd-sld-invalid-placement-color)'
        : kind.stroke;
    const highlighted = isToBeHighlighted(element, context.highlight);
    const safeHandleClick = handleClick || A;
    return w `${renderHighlightLayer(element, context, x, y, w$1, h)}<g id="${element.closest('Substation') === context.substation
        ? identity(element)
        : A}" class=${e({
        [kind.className]: true,
        preview,
    })} tabindex="0" pointer-events="${clickthrough ? 'none' : 'all'}" style="outline: none;">
    <rect x="${x}" y="${y}" width="${w$1}" height="${h}"
      @contextmenu=${contextmenu}
      @click=${safeHandleClick} @mousedown=${preventDefault}
      @auxclick=${auxclick}
      stroke-dasharray="${kind.strokeDasharray}"
      style="stroke: ${strokeColor}; fill: ${highlighted ? 'none' : 'var(--md-sys-color-surface, var(--oscd-base3))'}" />
    ${childContainers}
    ${renderEquipmentLayer(element, context)}
    ${renderPowerTransformerLayer(element, context)}
    ${renderIedLayer(element, context, preview)}
    ${renderPreviewConnectivityLayer(element, context, preview)}
    ${renderPreviewLabelLayer(element, context, preview)}
    ${renderResizeHandlesLayer(element, context, x, y, w$1, h)}
    ${renderPlacingTargetLayer(context, kind, handleClick, x, y, w$1, h)}
    ${renderResizingTargetLayer(element, context, safeHandleClick, x, y, w$1, h)}
  </g>`;
}
/** Renders a `VoltageLevel` and, nested inside it, each of its (non-busbar) bays. */
function renderVoltageLevel(voltageLevel, context, preview = false) {
    const bays = Array.from(voltageLevel.children)
        .filter(isBay$1)
        .map(bay => renderBay(bay, context, preview));
    return render(voltageLevel, context, preview, voltageLevelKind, bays);
}
/** Renders a `Bay` and its equipment. Bays do not nest, so they hold no child containers. */
function renderBay(bay, context, preview = false) {
    return render(bay, context, preview, bayKind, A);
}

/**
 * Themeable colour tokens for the SLD editor.
 *
 * The model mirrors `@omicronenergy/oscd-shell` (see its THEMING.md):
 *
 * 1. **Foundation palette** — our internal `--oscd-base03 … --oscd-base3`,
 *    `--oscd-primary`, `--oscd-secondary`, `--oscd-error`/`--oscd-warning` are
 *    initialised from the host's public `--oscd-theme-*` tokens, falling back
 *    to the documented oscd-shell defaults. This makes the plugin pick up a
 *    distro's theme when embedded in the shell, yet still render sensibly when
 *    used standalone (where the shell's tokens are absent).
 *
 * 2. **SLD brand palette** — `--oscd-sld-red|yellow|blue`, the diagram's own
 *    identity colours, overridable via the public `--oscd-editor-sld-*` hooks.
 *
 * 3. **SLD semantic tokens** — what the components actually consume, named for
 *    their role and each resolving (public hook → brand/foundation token) so
 *    they can be retuned individually or swept via the palette.
 *
 * Generic surfaces and text are *not* given bespoke SLD tokens: components
 * reference the standard `--md-sys-color-*` variables directly, with a
 * foundation-token fallback for standalone use.
 *
 * Included in each top-level component's `static styles` so the tokens resolve
 * the same whether a component is used inside the editor or on its own; custom
 * properties inherit through shadow DOM, so an override set above any of them
 * still wins.
 */
/**
 * Every colour token declared by {@link sldThemeStyles}. The export serialiser
 * pins each one's runtime-resolved value onto the exported SVG root so the
 * standalone file's `var()` references keep their (possibly distro-themed)
 * values. Kept here as the single source of truth next to the declarations —
 * an all-or-nothing dump; a few unused tokens cost nothing and beat curating.
 */
const sldThemeTokens = [
    '--oscd-primary',
    '--oscd-secondary',
    '--oscd-base03',
    '--oscd-base02',
    '--oscd-base01',
    '--oscd-base00',
    '--oscd-base0',
    '--oscd-base1',
    '--oscd-base2',
    '--oscd-base3',
    '--oscd-error',
    '--oscd-warning',
    '--oscd-sld-red',
    '--oscd-sld-yellow',
    '--oscd-sld-blue',
    '--oscd-sld-icon-substation-background-color',
    '--oscd-sld-icon-substation-foreground-color',
    '--oscd-sld-icon-voltage-level-background-color',
    '--oscd-sld-icon-voltage-level-foreground-color',
    '--oscd-sld-icon-bay-background-color',
    '--oscd-sld-icon-bay-foreground-color',
    '--oscd-sld-voltage-level-color',
    '--oscd-sld-bay-color',
    '--oscd-sld-invalid-placement-color',
    '--oscd-sld-unresolved-reference-color',
    '--oscd-sld-terminal-color',
    '--oscd-sld-neutral-terminal-color',
    '--oscd-sld-terminal-outline-color',
    '--oscd-sld-groundable-terminal-color',
    '--oscd-sld-grid-color',
    '--oscd-sld-label-placeholder-color',
];
const sldThemeStyles = i$7 `
  :host {
    /* foundation palette — initialised from the host oscd-theme tokens */
    --oscd-primary: var(--oscd-theme-primary, #0b335b);
    --oscd-secondary: var(--oscd-theme-secondary, #2485e5);
    --oscd-base03: var(--oscd-theme-base03, #121417);
    --oscd-base02: var(--oscd-theme-base02, #1a1e23);
    --oscd-base01: var(--oscd-theme-base01, #3d4651);
    --oscd-base00: var(--oscd-theme-base00, #46505d);
    --oscd-base0: var(--oscd-theme-base0, #8b97a7);
    --oscd-base1: var(--oscd-theme-base1, #96a1b0);
    --oscd-base2: var(--oscd-theme-base2, #f3f5f6);
    --oscd-base3: var(--oscd-theme-base3, white);
    --oscd-error: var(--oscd-theme-error, #dc322f);
    --oscd-warning: var(--oscd-theme-warning, #b58900);

    /* SLD brand palette (diagram identity) */
    --oscd-sld-red: var(--oscd-editor-sld-red, #bb1326);
    --oscd-sld-yellow: var(--oscd-editor-sld-yellow, #f5e214);
    --oscd-sld-blue: var(--oscd-editor-sld-blue, #12579b);

    /* SLD semantic tokens */
    --oscd-sld-toolbar-background-color: var(
      --oscd-editor-sld-toolbar-background-color,
      color-mix(in srgb, var(--md-sys-color-surface, var(--oscd-base3)) 87%, transparent)
    );
    --oscd-sld-tooltip-background-color: var(
      --oscd-editor-sld-tooltip-background-color,
      color-mix(in srgb, var(--md-sys-color-surface, var(--oscd-base3)) 87%, transparent)
    );

    --oscd-sld-icon-substation-background-color: var(
      --oscd-editor-sld-icon-substation-background-color,
      var(--oscd-sld-red)
    );
    --oscd-sld-icon-substation-foreground-color: var(
      --oscd-editor-sld-icon-substation-foreground-color,
      var(--oscd-base3)
    );
    --oscd-sld-icon-voltage-level-background-color: var(
      --oscd-editor-sld-icon-voltage-level-background-color,
      var(--oscd-sld-yellow)
    );
    --oscd-sld-icon-voltage-level-foreground-color: var(
      --oscd-editor-sld-icon-voltage-level-foreground-color,
      var(--md-sys-color-on-surface, var(--oscd-base00))
    );
    --oscd-sld-icon-bay-background-color: var(
      --oscd-editor-sld-icon-bay-background-color,
      var(--oscd-sld-blue)
    );
    --oscd-sld-icon-bay-foreground-color: var(
      --oscd-editor-sld-icon-bay-foreground-color,
      var(--oscd-base3)
    );

    --oscd-sld-voltage-level-color: var(
      --oscd-editor-sld-voltage-level-color,
      var(--oscd-sld-yellow)
    );
    --oscd-sld-bay-color: var(
      --oscd-editor-sld-bay-color,
      var(--oscd-sld-blue)
    );

    --oscd-sld-invalid-placement-color: var(
      --oscd-editor-sld-invalid-placement-color,
      var(--oscd-sld-red)
    );
    --oscd-sld-unresolved-reference-color: var(
      --oscd-editor-sld-unresolved-reference-color,
      var(--oscd-sld-red)
    );

    --oscd-sld-terminal-color: var(
      --oscd-editor-sld-terminal-color,
      var(--oscd-sld-red)
    );
    --oscd-sld-neutral-terminal-color: var(
      --oscd-editor-sld-neutral-terminal-color,
      var(--oscd-sld-blue)
    );
    --oscd-sld-terminal-outline-color: var(
      --oscd-editor-sld-terminal-outline-color,
      var(--oscd-sld-yellow)
    );
    --oscd-sld-groundable-terminal-color: var(
      --oscd-editor-sld-groundable-terminal-color,
      var(--oscd-sld-yellow)
    );

    --oscd-sld-grid-color: var(
      --oscd-editor-sld-grid-color,
      var(--oscd-base0)
    );
    --oscd-sld-label-placeholder-color: var(
      --oscd-editor-sld-label-placeholder-color,
      var(--oscd-base1)
    );
  }
`;

const prettifyXSLT = new DOMParser().parseFromString([
    // Describes how we want to modify the XML: indent everything.
    '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
    '  <xsl:strip-space elements="*"/>',
    '  <xsl:template match="para[content-style][not(text())]">',
    '    <xsl:value-of select="normalize-space(.)"/>',
    '  </xsl:template>',
    '  <xsl:template match="node()|@*">',
    '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
    '  </xsl:template>',
    '  <xsl:output indent="yes"/>',
    '</xsl:stylesheet>',
].join('\n'), 'application/xml');
let xsltProcessor;
if (!navigator.userAgent.toLowerCase().includes('firefox')) {
    xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(prettifyXSLT);
}
function prettyPrint(xmlDoc) {
    const doc = xsltProcessor
        ? xsltProcessor.transformToDocument(xmlDoc)
        : xmlDoc;
    return new XMLSerializer().serializeToString(doc);
}
// SLD theme tokens the artifacts consume via `style="…: var(--oscd-sld-…)"`.
// The export is monochrome by spec, so every token is pinned to black ink on a
// white surface (overriding the live theme) — the diagram markup keeps its
// var() references and just resolves to black/white once serialised.
/**
 * Pins the SLD tokens to a fixed black-on-white palette on the exported root so
 * the SVG is self-contained and monochrome regardless of the live theme. The
 * diagram markup keeps its `var()` references unchanged; surface resolves to
 * white, ink (`color` → `currentColor` symbols) and every other token to black.
 */
function forceMonochromeTokens(clone) {
    const declarations = [
        'color: black;',
        '--md-sys-color-surface: white;',
        '--md-sys-color-on-surface: black;',
    ];
    sldThemeTokens.forEach(token => declarations.push(`${token}: black;`));
    const style = clone.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'style');
    style.textContent = `:root { ${declarations.join(' ')} }`;
    clone.insertBefore(style, clone.firstChild);
}
function cleanXML(element) {
    const cl = element.classList;
    if (cl.contains('handle') ||
        cl.contains('preview') ||
        cl.contains('port') ||
        (cl.contains('label') && cl.contains('container'))) {
        element.remove();
        return;
    }
    if (cl.contains('voltagelevel') || cl.contains('bay')) {
        element.querySelector('rect')?.remove();
    }
    Array.from(element.childNodes).forEach((child) => {
        if (child.nodeType === 8) {
            element.removeChild(child);
        }
        if (child.nodeType === 1) {
            cleanXML(child);
        }
    });
}
/**
 * Produces the export-ready serialization of a rendered SLD SVG: clones the
 * source (never mutating it), pins a monochrome black-on-white palette, strips
 * the editor-only interaction chrome, and pretty-prints the result to a string.
 *
 * This is the SLD "SVG out" capability — it encodes intimate knowledge of how
 * the viewer builds its SVG (which nodes are editing chrome, how colour is
 * themed), so it is owned by the viewer (its sole caller via `exportableSvg()`).
 * It performs no I/O; deciding to package the string as a file is a separate,
 * higher-level concern (see `downloadSvg`).
 */
function serializeForExport(svg) {
    const exportedSvg = svg.cloneNode(true);
    forceMonochromeTokens(exportedSvg);
    cleanXML(exportedSvg);
    return prettyPrint(exportedSvg);
}

function isBay(element) {
    return element.tagName === 'Bay' && !isBusBar(element);
}
const mouseCoordinateProperties = [
    'mouseX',
    'mouseY',
    'mouseX2',
    'mouseY2',
    'mouseX2f',
    'mouseY2f',
];
/** An editor [[`plugin`]] for editing the `Substation` section. */
class SldSubstationViewer extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        this.docVersion = -1;
        this.gridSize = 32;
        this.interaction = { mode: 'locked' };
        this.disabled = false;
        this.selectable = [];
        this.highlight = [];
        this.mouseX = 0;
        this.mouseY = 0;
        this.iedResolutionCache = new Map();
        this.mouseX2 = 0;
        this.mouseY2 = 0;
        this.mouseX2f = 0;
        this.mouseY2f = 0;
    }
    get nsp() {
        return sldPrefix(this.doc);
    }
    /**
     * The following read-only getters project the single {@link interaction}
     * value into the per-gesture shapes the render layers and drawing artifacts
     * consume. The view stores no interaction state of its own — it derives these
     * from the one `interaction` property supplied by the controller.
     */
    get placing() {
        return this.interaction.mode === 'placing'
            ? this.interaction.element
            : undefined;
    }
    get placingOffset() {
        return this.interaction.mode === 'placing' ||
            this.interaction.mode === 'placingLabel'
            ? this.interaction.offset
            : [0, 0];
    }
    get placingLabel() {
        return this.interaction.mode === 'placingLabel'
            ? this.interaction.element
            : undefined;
    }
    get resizingTL() {
        return this.interaction.mode === 'resizingTL'
            ? this.interaction.element
            : undefined;
    }
    get connecting() {
        return connectDetail(this.interaction);
    }
    get idle() {
        return this.interaction.mode === 'idle';
    }
    /**
     * True when `element` is, or is contained by, the element currently being
     * placed. Such an element moves with the cursor as the placing-preview ghost,
     * so the base layers suppress it (the preview paints it instead) and the
     * position helpers apply the live mouse offset to it. This is the one way a
     * base layer's appearance is parameterised by the placing mode.
     */
    isPartOfPlacingElement(element) {
        return (!!this.placing && element.closest(this.placing.localName) === this.placing);
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('doc') ||
            changedProperties.has('docVersion') ||
            changedProperties.has('substation')) {
            this.iedResolutionCache.clear();
        }
    }
    shouldUpdate(changedProperties) {
        if (!isMode(this.interaction, 'idle', 'locked')) {
            return true;
        }
        return !Array.from(changedProperties.keys()).every(property => mouseCoordinateProperties.includes(property));
    }
    resolveIed(referencedIed) {
        if (!this.iedResolutionCache.has(referencedIed)) {
            this.iedResolutionCache.set(referencedIed, resolveIed(referencedIed));
        }
        return this.iedResolutionCache.get(referencedIed) ?? null;
    }
    svgCoordinates(clientX, clientY) {
        const p = new DOMPoint(clientX, clientY);
        const { x, y } = p.matrixTransform(this.sld.getScreenCTM().inverse());
        const result = [x, y].map(coord => Math.max(0, coord));
        return result;
    }
    gridPosition(event) {
        if (!event.isTrusted && !event.clientX && !event.clientY) {
            return [this.mouseX, this.mouseY];
        }
        const [clientX, clientY] = [event.clientX, event.clientY];
        const [x, y] = this.svgCoordinates(clientX, clientY);
        return [Math.floor(x), Math.floor(y)];
    }
    halfGridPosition(event) {
        if (!event.isTrusted && !event.clientX && !event.clientY) {
            return [this.mouseX2, this.mouseY2];
        }
        const [clientX, clientY] = [event.clientX, event.clientY];
        const [x, y] = this.svgCoordinates(clientX, clientY);
        return [Math.round(x * 2) / 2, Math.round(y * 2) / 2];
    }
    renderedLabelPosition(element, { preview = false } = {}) {
        let { label: [x, y], } = attributes(element);
        const [offsetX, offsetY] = isIedReferenceElement(element) &&
            !getSLDAttributes(element, 'x') &&
            preview
            ? [-1, -1]
            : this.placingOffset;
        if (this.isPartOfPlacingElement(element)) {
            const { pos: [parentX, parentY], } = attributes(this.placing);
            x += this.mouseX - parentX - offsetX;
            y += this.mouseY - parentY - offsetY;
        }
        if (this.placingLabel === element) {
            x = this.mouseX2 - 0.5 - offsetX;
            y = this.mouseY2 + 0.5 - offsetY;
        }
        if (this.resizingTL === element) {
            const { pos: [resX, resY], dim: [resW, resH], } = attributes(element);
            if (resX === x && resY === y) {
                x += Math.min(this.mouseX, resX + resW - 1) - resX;
                y += Math.min(this.mouseY, resY + resH - 1) - resY;
            }
        }
        return [x, y];
    }
    renderedPosition(element) {
        let { pos: [x, y], } = attributes(element);
        if (this.isPartOfPlacingElement(element)) {
            const { pos: [parentX, parentY], } = attributes(this.placing);
            const [offsetX, offsetY] = this.placingOffset;
            x += this.mouseX - parentX - offsetX;
            y += this.mouseY - parentY - offsetY;
        }
        return [x, y];
    }
    /**
     * Returns the substation's diagram as an export-ready SVG string.
     * The viewer alone knows how it constructs the SVG and which nodes are
     * editing chrome, so it owns normalization/serialization; the editor decides
     * what to do with the result (e.g. trigger a file download).
     */
    exportableSvg() {
        return serializeForExport(this.sld);
    }
    nearestOpenTerminal(equipment) {
        if (!equipment) {
            return undefined;
        }
        const topTerminal = equipment.querySelector('Terminal[name="T1"]');
        const bottomTerminal = equipment.querySelector('Terminal:not([name="T1"])');
        const oneSided = singleTerminal.has(equipment.getAttribute('type'));
        if (topTerminal && bottomTerminal) {
            return undefined;
        }
        if (oneSided && (topTerminal || bottomTerminal)) {
            return undefined;
        }
        if (oneSided) {
            return 'T1';
        }
        if (topTerminal) {
            return 'T2';
        }
        if (bottomTerminal) {
            return 'T1';
        }
        const [mx, my] = [this.mouseX2f, this.mouseY2f];
        const { rot, pos: [x, y], } = attributes(equipment);
        if (rot === 0 && my >= y + 0.5) {
            return 'T2';
        }
        if (rot === 1 && mx < x + 0.5) {
            return 'T2';
        }
        if (rot === 2 && my < y + 0.5) {
            return 'T2';
        }
        if (rot === 3 && mx >= x + 0.5) {
            return 'T2';
        }
        return 'T1';
    }
    groundTerminal(equipment, name) {
        this.dispatchEvent(newGroundTerminalEvent(equipment, name));
    }
    requestContextMenu(element, event) {
        const [gridX, gridY] = this.gridPosition(event);
        this.dispatchEvent(newOpenContextMenuEvent({
            element,
            x: event.clientX,
            y: event.clientY,
            gridX,
            gridY,
        }));
    }
    /**
     * Composes the substation SVG as one z-ordered stack of layers (paint order =
     * z-order; last drawn wins). Each layer is one of two kinds by *presence*:
     *
     * - **base layers** — always in the stack: `renderVoltageLevelLayer`,
     *   `renderConnectivityLayer`, `renderPowerTransformerLayer`, `renderIedLayer`,
     *   `renderLabelLayer`.
     * - **mode layers** — present only during one interaction mode, each gated on
     *   the relevant field/payload: `renderVoltageLevelPlacingTarget` (placing a
     *   VoltageLevel), `renderConnectionPreviewLayer` +
     *   `renderConnectModeEquipmentLayer` (connecting), `renderPlacingTargetsLayer`
     *   + `renderPlacingPreview` (placing).
     *
     * Mode layers are NOT a top tier — they are interleaved at fixed z-positions
     * (the VL placing target paints at the back; the connection preview in the
     * middle), so the call order here must not change. Base-layer *appearance* may
     * still vary by mode via `isPartOfPlacingElement` (the placed element is
     * suppressed here and re-painted as the preview ghost).
     */
    render() {
        const { dim: [w, h], } = attributes(this.substation);
        // The five base layers (voltage levels, connectivity, power transformers,
        // IEDs, labels) are position-independent: their geometry derives from the
        // document and interaction, never from the live cursor — except in the four
        // modes where a base artifact tracks the mouse (resize preview, connect
        // target highlight/snap, and the label-repositioning preview, which is
        // painted inside the guarded label layer). Memoizing them with `guard` lets
        // the per-move re-renders that keep the placing/connect preview under the
        // cursor skip re-evaluating the whole (potentially thousands of `<g>`) base
        // stack.
        const baseLayerTracksMouse = this.interaction.mode === 'resizingBR' ||
            this.interaction.mode === 'resizingTL' ||
            this.interaction.mode === 'connectingFrom' ||
            this.interaction.mode === 'placingLabel';
        const baseLayerKey = [
            this.substation,
            this.docVersion,
            this.interaction,
            this.showLabels,
            this.showIeds,
            this.gridSize,
            this.highlight,
            this.selectable,
            this.disabled,
            // Mouse coordinates only invalidate the base layers in the modes that
            // paint them from the cursor; elsewhere a constant keeps the key stable so
            // guard reuses the memoized layers across cursor moves.
            baseLayerTracksMouse ? this.mouseX : 0,
            baseLayerTracksMouse ? this.mouseY : 0,
            baseLayerTracksMouse ? this.mouseX2 : 0,
            baseLayerTracksMouse ? this.mouseY2 : 0,
            baseLayerTracksMouse ? this.mouseX2f : 0,
            baseLayerTracksMouse ? this.mouseY2f : 0,
        ];
        return b `<section>
      <slot name="header"></slot>
      <svg
        xmlns="${svgNs$1}"
        xmlns:xlink="${xlinkNs}"
        id="sld"
        viewBox="0 0 ${w} ${h}"
        width="${w * this.gridSize}"
        height="${h * this.gridSize}"
        stroke-width="0.06"
        fill="none"
        @mousemove=${(e) => {
            if (this.disabled) {
                return;
            }
            const [x, y] = this.svgCoordinates(e.clientX, e.clientY);
            this.mouseX = Math.floor(x);
            this.mouseY = Math.floor(y);
            this.mouseX2 = Math.round(x * 2) / 2;
            this.mouseY2 = Math.round(y * 2) / 2;
            this.mouseX2f = Math.floor(x * 2) / 2;
            this.mouseY2f = Math.floor(y * 2) / 2;
        }}
      >
        <style>
          .handle {
            visibility: hidden;
          }
          :focus {
            outline: none;
          }
          g:hover > .handle {
            opacity: 0.2;
            visibility: visible;
          }
          g:hover > .handle:hover {
            visibility: visible;
            opacity: 0.83;
          }
          g.voltagelevel > rect,
          g.bay > rect {
            shape-rendering: crispEdges;
          }
          svg:not(:hover) .preview {
            visibility: hidden;
          }
          .preview {
            opacity: 0.75;
          }
        </style>
        ${symbols}
        <rect width="100%" height="100%" style="fill: var(--md-sys-color-surface, var(--oscd-base3))" />
        ${this.renderVoltageLevelPlacingTarget()}
        ${i$2(baseLayerKey, () => this.renderVoltageLevelLayer())}
        ${this.renderConnectionPreviewLayer()}
        ${this.renderConnectModeEquipmentLayer()}
        ${i$2(baseLayerKey, () => [
            this.renderConnectivityLayer(),
            this.renderPowerTransformerLayer(),
            this.renderIedLayer(),
            this.renderLabelLayer(),
        ])}
        ${this.renderPlacingTargetsLayer()}
        ${this.renderPlacingPreview()}
      </svg>
    </section>`;
    }
    renderLabel(element, { preview = false } = {}) {
        return renderLabel(element, this.sharedContext(), { preview });
    }
    /**
     * The VoltageLevel drop-zone, painted near the BACK of the stack (behind
     * existing voltage levels) — a VL is dropped *behind* the diagram. Mutually
     * exclusive with `renderPlacingTargetsLayer` (only one placing mode at a time).
     */
    renderVoltageLevelPlacingTarget() {
        if (this.placing?.tagName !== 'VoltageLevel') {
            return A;
        }
        return w `<rect width="100%" height="100%" fill="url(#grid)" />`;
    }
    /**
     * The full-canvas drop-targets for elements that may land anywhere in the
     * substation (PowerTransformer / IED / Label), painted near the FRONT of the
     * stack so they catch clicks over existing elements. All three are mutually
     * exclusive (gated on the active placing mode), so at most one is live.
     */
    renderPlacingTargetsLayer() {
        const transformerPlacingTarget = this.placing?.tagName === 'PowerTransformer'
            ? w `<rect width="100%" height="100%" fill="url(#grid)" />`
            : A;
        const iedPlacingTarget = !!this.placing && isIedReferenceElement(this.placing)
            ? w `<rect
            width="100%"
            height="100%"
            fill="url(#grid)"
            @click=${() => {
                const element = this.placing;
                const [x, y] = this.renderedPosition(element);
                if (!canPlaceAt(this.substation, element, x, y, 1, 1)) {
                    return;
                }
                const parent = Array.from(this.substation.querySelectorAll(':scope > VoltageLevel > Bay'))
                    .concat(Array.from(this.substation.querySelectorAll(':scope > VoltageLevel')))
                    .find(vlOrBay => containsRect(vlOrBay, x, y, 1, 1)) ||
                    this.substation;
                this.dispatchEvent(newPlaceEvent({ x, y, element, parent }));
            }}
          />`
            : A;
        const placingLabelTarget = this.placingLabel
            ? w `<rect width="100%" height="100%" fill="url(#halfgrid)"
      @click=${() => {
                const element = this.placingLabel;
                const [x, y] = this.renderedLabelPosition(element, { preview: true });
                this.dispatchEvent(newPlaceLabelEvent({ element, x, y }));
            }}
      />`
            : A;
        return [transformerPlacingTarget, iedPlacingTarget, placingLabelTarget];
    }
    renderPlacingPreview() {
        if (!this.placing) {
            return w ``;
        }
        if (this.placing.tagName === 'VoltageLevel') {
            return renderVoltageLevel(this.placing, this.containerContext(), true);
        }
        if (isBay(this.placing)) {
            return renderBay(this.placing, this.containerContext(), true);
        }
        if (this.placing.tagName === 'ConductingEquipment') {
            return this.renderEquipment(this.placing, { preview: true });
        }
        if (isIedReferenceElement(this.placing)) {
            return this.renderIed(this.placing, { preview: true });
        }
        if (this.placing.tagName === 'PowerTransformer') {
            return this.renderPowerTransformer(this.placing, true);
        }
        if (isBusBar(this.placing)) {
            return this.renderBusBar(this.placing);
        }
        return w ``;
    }
    renderVoltageLevelLayer() {
        return Array.from(this.substation.children)
            .filter(child => child.tagName === 'VoltageLevel')
            .map(vl => w `${renderVoltageLevel(vl, this.containerContext())}`);
    }
    renderConnectionPreviewLayer() {
        if (this.connecting?.from.closest('Substation') !== this.substation) {
            return [];
        }
        const { from, path, fromTerminal } = this.connecting;
        const targetEq = Array.from(this.substation.querySelectorAll('ConductingEquipment'))
            .filter(eq => eq !== from)
            .find((eq) => {
            const { pos: [x, y], } = attributes(eq);
            return x === this.mouseX && y === this.mouseY;
        });
        const toTerminal = this.nearestOpenTerminal(targetEq);
        let snap;
        if (targetEq && toTerminal) {
            const [close, far] = connectionStartPoints(targetEq)[toTerminal];
            snap = { near: close, far };
        }
        const { corner, far, near } = connectPreviewElbow(path, [this.mouseX2, this.mouseY2], snap);
        // The whole preview is one orthogonal polyline: the already-committed
        // waypoints (every point but the provisional last one) continuing through
        // the live elbow lastFixed -> corner -> far -> near.
        const previewPoints = [...path.slice(0, -1), corner, far, near];
        const segment = (start, end) => w `<line x1="${start[0]}" y1="${start[1]}" x2="${end[0]}" y2="${end[1]}"
                stroke-linecap="square" stroke="currentColor" />`;
        // draw a line between each consecutive pair of points
        const lines = previewPoints
            .slice(1)
            .map((point, index) => segment(previewPoints[index], point));
        const dropTarget = w `<rect width="100%" height="100%" fill="url(#grid)"
      @click=${() => {
            const newPath = extendConnectPointPaths(path, corner, far, near);
            this.dispatchEvent(newExtendConnectPointEvent(newPath));
            if (targetEq && toTerminal) {
                this.dispatchEvent(newConnectEvent({
                    from,
                    fromTerminal,
                    path: newPath,
                    to: targetEq,
                    toTerminal,
                }));
            }
        }} />`;
        return [...lines, dropTarget];
    }
    /**
     * While a connection is being drawn in this substation, every
     * `ConductingEquipment` is suppressed in its container layer (see
     * conducting-equipment.ts) and re-painted here as a flat top overlay in
     * connect mode: terminal connect-indicators on, and click-through enabled so
     * clicks fall through to the connection drop-target beneath.
     */
    renderConnectModeEquipmentLayer() {
        if (this.connecting?.from.closest('Substation') !== this.substation) {
            return A;
        }
        return Array.from(this.substation.querySelectorAll('ConductingEquipment')).map(eq => this.renderEquipment(eq, { connect: true }));
    }
    renderConnectivityLayer() {
        return Array.from(this.substation.querySelectorAll('ConnectivityNode'))
            .filter(node => node.getAttribute('name') !== 'grounded' &&
            !this.isPartOfPlacingElement(node))
            .sort((a, b) => Number(isBusBar(a.parentElement)) -
            Number(isBusBar(b.parentElement)))
            .map(cNode => this.renderConnectivityNode(cNode));
    }
    renderPowerTransformerLayer() {
        return Array.from(this.substation.querySelectorAll(':scope > PowerTransformer')).map(transformer => this.renderPowerTransformer(transformer));
    }
    renderIedLayer() {
        return iedReferences(this.substation)
            .filter(referencedIed => referencedIed.parentElement?.tagName === 'Private' &&
            !['Bay', 'VoltageLevel'].includes(referencedIed.parentElement.parentElement.tagName) &&
            !this.isPartOfPlacingElement(referencedIed))
            .map(ied => this.renderIed(ied));
    }
    renderLabelLayer() {
        return Array.from(this.substation.querySelectorAll('VoltageLevel, Bay, ConductingEquipment, PowerTransformer, Text'))
            .concat(Array.from(this.substation.querySelectorAll('Private[type="OpenSCD-SLD-Layout"]') ?? []).flatMap(privateLayout => iedReferences(privateLayout)))
            .filter(e => !this.isPartOfPlacingElement(e))
            .map(element => this.renderLabel(element));
    }
    containerContext() {
        return {
            ...this.sharedContext(),
            highlight: this.highlight,
            mouseX: this.mouseX,
            mouseY: this.mouseY,
            svgCoordinates: (clientX, clientY) => this.svgCoordinates(clientX, clientY),
            renderEquipment: equipment => this.renderEquipment(equipment),
            renderPowerTransformer: equipment => this.renderPowerTransformer(equipment),
            renderIed: (referencedIed, options) => this.renderIed(referencedIed, options),
            renderConnectivityNode: cNode => this.renderConnectivityNode(cNode),
        };
    }
    renderPowerTransformer(transformer, preview = false) {
        return this.renderArtifact(powerTransformerArtifact, transformer, this.powerTransformerContext(), { preview });
    }
    sharedContext() {
        return {
            disabled: this.disabled,
            dispatch: event => this.dispatchEvent(event),
            gridPosition: event => this.gridPosition(event),
            halfGridPosition: event => this.halfGridPosition(event),
            interaction: this.interaction,
            requestContextMenu: (element, event) => this.requestContextMenu(element, event),
            resolveIed: referencedIed => this.resolveIed(referencedIed),
            renderedLabelPosition: (element, options) => this.renderedLabelPosition(element, options),
            renderedPosition: element => this.renderedPosition(element),
            selectable: this.selectable,
            substation: this.substation,
            view: {
                showLabels: this.showLabels,
                showIeds: this.showIeds,
            },
        };
    }
    equipmentContext() {
        return {
            ...this.sharedContext(),
            groundTerminal: (element, terminal) => this.groundTerminal(element, terminal),
            highlight: this.highlight,
            mouseX: this.mouseX,
            mouseY: this.mouseY,
            nearestOpenTerminal: equipment => this.nearestOpenTerminal(equipment),
        };
    }
    busBarContext() {
        return this.connectivityNodeContext();
    }
    powerTransformerContext() {
        return {
            ...this.sharedContext(),
            groundTerminal: (element, terminal) => this.groundTerminal(element, terminal),
            highlight: this.highlight,
            mouseX: this.mouseX,
            mouseY: this.mouseY,
        };
    }
    renderArtifact(descriptor, element, context, options = {}) {
        const state = descriptor.state(element, context, options);
        if (!state) {
            return w ``;
        }
        return descriptor.render(element, state, descriptor.actions(element, context, state), context, options);
    }
    renderEquipment(equipment, options = {}) {
        return this.renderArtifact(conductingEquipmentArtifact, equipment, this.equipmentContext(), options);
    }
    renderIed(referencedIed, { preview = false } = {}) {
        return this.renderArtifact(iedReferenceArtifact, referencedIed, this.sharedContext(), { preview });
    }
    renderBusBar(busBar) {
        return this.renderArtifact(busBarArtifact, busBar, this.busBarContext());
    }
    connectivityNodeContext() {
        return {
            ...this.sharedContext(),
            mouseX: this.mouseX,
            mouseY: this.mouseY,
            mouseX2: this.mouseX2,
            mouseY2: this.mouseY2,
        };
    }
    renderConnectivityNode(cNode) {
        return renderConnectivityNode(cNode, this.connectivityNodeContext());
    }
}
SldSubstationViewer.scopedElements = {};
SldSubstationViewer.styles = [
    sldThemeStyles,
    i$7 `
    :host {
      display: block;
    }

    /*
     * Contain the intrinsically-sized svg (width = w × gridSize) within this
     * host. This is dormant in the plugin — nothing there constrains the
     * viewer's width (the host lays out at 'width: fit-content'), so the section
     * grows to the svg's native size and never scrolls; the shell owns the
     * scroll/zoom viewport. It only activates for a *constrained* standalone
     * consumer (e.g. a fixed-width card), where it scrolls instead of spilling.
     * See the fit-to-container workstream for scale-to-fit (vs. scroll).
     */
    section {
      overflow: auto;
    }

    #sld {
      color: var(--md-sys-color-on-surface, var(--oscd-base03));
    }

    .disabled:not(.selectable) {
      pointer-events: none;
      opacity: 0.2;
    }

    .disabled.selectable > text {
      pointer-events: all;
    }

    * {
      user-select: none;
    }
  `,
];
__decorate([
    n$3()
], SldSubstationViewer.prototype, "doc", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "substation", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "docVersion", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "gridSize", void 0);
__decorate([
    n$3({ attribute: false })
], SldSubstationViewer.prototype, "interaction", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "showLabels", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "showIeds", void 0);
__decorate([
    n$3({ type: Boolean })
], SldSubstationViewer.prototype, "disabled", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "selectable", void 0);
__decorate([
    n$3()
], SldSubstationViewer.prototype, "highlight", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "idle", null);
__decorate([
    e$4('svg#sld')
], SldSubstationViewer.prototype, "sld", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "mouseX", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "mouseY", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "mouseX2", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "mouseY2", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "mouseX2f", void 0);
__decorate([
    r$2()
], SldSubstationViewer.prototype, "mouseY2f", void 0);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A key to retrieve an `Attachable` element's `AttachableController` from a
 * global `MutationObserver`.
 */
const ATTACHABLE_CONTROLLER = Symbol('attachableController');
let FOR_ATTRIBUTE_OBSERVER;
{
    /**
     * A global `MutationObserver` that reacts to `for` attribute changes on
     * `Attachable` elements. If the `for` attribute changes, the controller will
     * re-attach to the new referenced element.
     */
    FOR_ATTRIBUTE_OBSERVER = new MutationObserver((records) => {
        for (const record of records) {
            // When a control's `for` attribute changes, inform its
            // `AttachableController` to update to a new control.
            record.target[ATTACHABLE_CONTROLLER]?.hostConnected();
        }
    });
}
/**
 * A controller that provides an implementation for `Attachable` elements.
 *
 * @example
 * ```ts
 * class MyElement extends LitElement implements Attachable {
 *   get control() { return this.attachableController.control; }
 *
 *   private readonly attachableController = new AttachableController(
 *     this,
 *     (previousControl, newControl) => {
 *       previousControl?.removeEventListener('click', this.handleClick);
 *       newControl?.addEventListener('click', this.handleClick);
 *     }
 *   );
 *
 *   // Implement remaining `Attachable` properties/methods that call the
 *   // controller's properties/methods.
 * }
 * ```
 */
class AttachableController {
    get htmlFor() {
        return this.host.getAttribute('for');
    }
    set htmlFor(htmlFor) {
        if (htmlFor === null) {
            this.host.removeAttribute('for');
        }
        else {
            this.host.setAttribute('for', htmlFor);
        }
    }
    get control() {
        if (this.host.hasAttribute('for')) {
            if (!this.htmlFor || !this.host.isConnected) {
                return null;
            }
            return this.host.getRootNode().querySelector(`#${this.htmlFor}`);
        }
        return this.currentControl || this.host.parentElement;
    }
    set control(control) {
        if (control) {
            this.attach(control);
        }
        else {
            this.detach();
        }
    }
    /**
     * Creates a new controller for an `Attachable` element.
     *
     * @param host The `Attachable` element.
     * @param onControlChange A callback with two parameters for the previous and
     *     next control. An `Attachable` element may perform setup or teardown
     *     logic whenever the control changes.
     */
    constructor(host, onControlChange) {
        this.host = host;
        this.onControlChange = onControlChange;
        this.currentControl = null;
        host.addController(this);
        host[ATTACHABLE_CONTROLLER] = this;
        FOR_ATTRIBUTE_OBSERVER?.observe(host, { attributeFilter: ['for'] });
    }
    attach(control) {
        if (control === this.currentControl) {
            return;
        }
        this.setCurrentControl(control);
        // When imperatively attaching, remove the `for` attribute so
        // that the attached control is used instead of a referenced one.
        this.host.removeAttribute('for');
    }
    detach() {
        this.setCurrentControl(null);
        // When imperatively detaching, add an empty `for=""` attribute. This will
        // ensure the control is `null` rather than the `parentElement`.
        this.host.setAttribute('for', '');
    }
    /** @private */
    hostConnected() {
        this.setCurrentControl(this.control);
    }
    /** @private */
    hostDisconnected() {
        this.setCurrentControl(null);
    }
    setCurrentControl(control) {
        this.onControlChange(this.currentControl, control);
        this.currentControl = control;
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Events that the focus ring listens to.
 */
const EVENTS$1 = ['focusin', 'focusout', 'pointerdown'];
/**
 * A focus ring component.
 *
 * @fires visibility-changed {Event} Fired whenever `visible` changes.
 */
class FocusRing extends i$4 {
    constructor() {
        super(...arguments);
        /**
         * Makes the focus ring visible.
         */
        this.visible = false;
        /**
         * Makes the focus ring animate inwards instead of outwards.
         */
        this.inward = false;
        this.attachableController = new AttachableController(this, this.onControlChange.bind(this));
    }
    get htmlFor() {
        return this.attachableController.htmlFor;
    }
    set htmlFor(htmlFor) {
        this.attachableController.htmlFor = htmlFor;
    }
    get control() {
        return this.attachableController.control;
    }
    set control(control) {
        this.attachableController.control = control;
    }
    attach(control) {
        this.attachableController.attach(control);
    }
    detach() {
        this.attachableController.detach();
    }
    connectedCallback() {
        super.connectedCallback();
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute('aria-hidden', 'true');
    }
    /** @private */
    handleEvent(event) {
        if (event[HANDLED_BY_FOCUS_RING]) {
            // This ensures the focus ring does not activate when multiple focus rings
            // are used within a single component.
            return;
        }
        switch (event.type) {
            default:
                return;
            case 'focusin':
                this.visible = this.control?.matches(':focus-visible') ?? false;
                break;
            case 'focusout':
            case 'pointerdown':
                this.visible = false;
                break;
        }
        event[HANDLED_BY_FOCUS_RING] = true;
    }
    onControlChange(prev, next) {
        for (const event of EVENTS$1) {
            prev?.removeEventListener(event, this);
            next?.addEventListener(event, this);
        }
    }
    update(changed) {
        if (changed.has('visible')) {
            // This logic can be removed once the `:has` selector has been introduced
            // to Firefox. This is necessary to allow correct submenu styles.
            this.dispatchEvent(new Event('visibility-changed'));
        }
        super.update(changed);
    }
}
__decorate([
    n$3({ type: Boolean, reflect: true })
], FocusRing.prototype, "visible", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], FocusRing.prototype, "inward", void 0);
const HANDLED_BY_FOCUS_RING = Symbol('handledByFocusRing');

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./focus/internal/focus-ring-styles.css.
const styles$u = i$7 `:host{animation-delay:0s,calc(var(--md-focus-ring-duration, 600ms)*.25);animation-duration:calc(var(--md-focus-ring-duration, 600ms)*.25),calc(var(--md-focus-ring-duration, 600ms)*.75);animation-timing-function:cubic-bezier(0.2, 0, 0, 1);box-sizing:border-box;color:var(--md-focus-ring-color, var(--md-sys-color-secondary, #625b71));display:none;pointer-events:none;position:absolute}:host([visible]){display:flex}:host(:not([inward])){animation-name:outward-grow,outward-shrink;border-end-end-radius:calc(var(--md-focus-ring-shape-end-end, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) + var(--md-focus-ring-outward-offset, 2px));border-end-start-radius:calc(var(--md-focus-ring-shape-end-start, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) + var(--md-focus-ring-outward-offset, 2px));border-start-end-radius:calc(var(--md-focus-ring-shape-start-end, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) + var(--md-focus-ring-outward-offset, 2px));border-start-start-radius:calc(var(--md-focus-ring-shape-start-start, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) + var(--md-focus-ring-outward-offset, 2px));inset:calc(-1*var(--md-focus-ring-outward-offset, 2px));outline:var(--md-focus-ring-width, 3px) solid currentColor}:host([inward]){animation-name:inward-grow,inward-shrink;border-end-end-radius:calc(var(--md-focus-ring-shape-end-end, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) - var(--md-focus-ring-inward-offset, 0px));border-end-start-radius:calc(var(--md-focus-ring-shape-end-start, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) - var(--md-focus-ring-inward-offset, 0px));border-start-end-radius:calc(var(--md-focus-ring-shape-start-end, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) - var(--md-focus-ring-inward-offset, 0px));border-start-start-radius:calc(var(--md-focus-ring-shape-start-start, var(--md-focus-ring-shape, var(--md-sys-shape-corner-full, 9999px))) - var(--md-focus-ring-inward-offset, 0px));border:var(--md-focus-ring-width, 3px) solid currentColor;inset:var(--md-focus-ring-inward-offset, 0px)}@keyframes outward-grow{from{outline-width:0}to{outline-width:var(--md-focus-ring-active-width, 8px)}}@keyframes outward-shrink{from{outline-width:var(--md-focus-ring-active-width, 8px)}}@keyframes inward-grow{from{border-width:0}to{border-width:var(--md-focus-ring-active-width, 8px)}}@keyframes inward-shrink{from{border-width:var(--md-focus-ring-active-width, 8px)}}@media(prefers-reduced-motion){:host{animation:none}}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-focus-ring
 * TODO(b/267336424): add docs
 *
 * @final
 * @suppress {visibility}
 */
class OscdFocusRing extends FocusRing {
}
OscdFocusRing.styles = [styles$u];

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A component for elevation.
 */
class Elevation extends i$4 {
    connectedCallback() {
        super.connectedCallback();
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        return b `<span class="shadow"></span>`;
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./elevation/internal/elevation-styles.css.
const styles$t = i$7 `:host,.shadow,.shadow::before,.shadow::after{border-radius:inherit;inset:0;position:absolute;transition-duration:inherit;transition-property:inherit;transition-timing-function:inherit}:host{display:flex;pointer-events:none;transition-property:box-shadow,opacity}.shadow::before,.shadow::after{content:"";transition-property:box-shadow,opacity;--_level: var(--md-elevation-level, 0);--_shadow-color: var(--md-elevation-shadow-color, var(--md-sys-color-shadow, #000))}.shadow::before{box-shadow:0px calc(1px*(clamp(0,var(--_level),1) + clamp(0,var(--_level) - 3,1) + 2*clamp(0,var(--_level) - 4,1))) calc(1px*(2*clamp(0,var(--_level),1) + clamp(0,var(--_level) - 2,1) + clamp(0,var(--_level) - 4,1))) 0px var(--_shadow-color);opacity:.3}.shadow::after{box-shadow:0px calc(1px*(clamp(0,var(--_level),1) + clamp(0,var(--_level) - 1,1) + 2*clamp(0,var(--_level) - 2,3))) calc(1px*(3*clamp(0,var(--_level),2) + 2*clamp(0,var(--_level) - 2,3))) calc(1px*(clamp(0,var(--_level),4) + 2*clamp(0,var(--_level) - 4,1))) var(--_shadow-color);opacity:.15}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-elevation
 * The `<oscd-elevation>` custom element with default styles.
 *
 * Elevation is the relative distance between two surfaces along the z-axis.
 *
 * @final
 * @suppress {visibility}
 */
class OscdElevation extends Elevation {
}
OscdElevation.styles = [styles$t];

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const n$1="important",i$1=" !"+n$1,o$1=e$2(class extends i$3{constructor(t$1){if(super(t$1),t$1.type!==t.ATTRIBUTE||"style"!==t$1.name||t$1.strings?.length>2)throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.")}render(t){return Object.keys(t).reduce((e,r)=>{const s=t[r];return null==s?e:e+`${r=r.includes("-")?r:r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g,"-$&").toLowerCase()}:${s};`},"")}update(e,[r]){const{style:s}=e.element;if(void 0===this.ft)return this.ft=new Set(Object.keys(r)),this.render(r);for(const t of this.ft)null==r[t]&&(this.ft.delete(t),t.includes("-")?s.removeProperty(t):s[t]=null);for(const t in r){const e=r[t];if(null!=e){this.ft.add(t);const r="string"==typeof e&&e.endsWith(i$1);t.includes("-")||r?s.setProperty(t,r?e.slice(0,-11):e,r?n$1:""):s[t]=e;}}return E}});

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Easing functions to use for web animations.
 *
 * **NOTE:** `EASING.EMPHASIZED` is approximated with unknown accuracy.
 *
 * TODO(b/241113345): replace with tokens
 */
const EASING = {
    STANDARD: 'cubic-bezier(0.2, 0, 0, 1)',
    EMPHASIZED: 'cubic-bezier(.3,0,0,1)',
    EMPHASIZED_ACCELERATE: 'cubic-bezier(.3,0,.8,.15)'};
/**
 * Creates an `AnimationSignal` that can be used to cancel a previous task.
 *
 * @example
 * class MyClass {
 *   private labelAnimationSignal = createAnimationSignal();
 *
 *   private async animateLabel() {
 *     // Start of the task. Previous tasks will be canceled.
 *     const signal = this.labelAnimationSignal.start();
 *
 *     // Do async work...
 *     if (signal.aborted) {
 *       // Use AbortSignal to check if a request was made to abort after some
 *       // asynchronous work.
 *       return;
 *     }
 *
 *     const animation = this.animate(...);
 *     // Add event listeners to be notified when the task should be canceled.
 *     signal.addEventListener('abort', () => {
 *       animation.cancel();
 *     });
 *
 *     animation.addEventListener('finish', () => {
 *       // Tell the signal that the current task is finished.
 *       this.labelAnimationSignal.finish();
 *     });
 *   }
 * }
 *
 * @return An `AnimationSignal`.
 */
function createAnimationSignal() {
    // The current animation's AbortController
    let animationAbortController = null;
    return {
        start() {
            // Tell the previous animation to cancel.
            animationAbortController?.abort();
            // Set up a new AbortController for the current animation.
            animationAbortController = new AbortController();
            // Provide the AbortSignal so that the caller can check aborted status
            // and add listeners.
            return animationAbortController.signal;
        },
        finish() {
            animationAbortController = null;
        },
    };
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Activates the first non-disabled item of a given array of items.
 *
 * @param items {Array<ListItem>} The items from which to activate the
 *     first item.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 */
function activateFirstItem(items, isActivatable = (isItemNotDisabled)) {
    // NOTE: These selector functions are static and not on the instance such
    // that multiple operations can be chained and we do not have to re-query
    // the DOM
    const firstItem = getFirstActivatableItem(items, isActivatable);
    if (firstItem) {
        firstItem.tabIndex = 0;
        firstItem.focus();
    }
    return firstItem;
}
/**
 * Activates the last non-disabled item of a given array of items.
 *
 * @param items {Array<ListItem>} The items from which to activate the
 *     last item.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 * @nocollapse
 */
function activateLastItem(items, isActivatable = (isItemNotDisabled)) {
    const lastItem = getLastActivatableItem(items, isActivatable);
    if (lastItem) {
        lastItem.tabIndex = 0;
        lastItem.focus();
    }
    return lastItem;
}
/**
 * Retrieves the first activated item of a given array of items.
 *
 * @param items {Array<ListItem>} The items to search.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 * @return A record of the first activated item including the item and the
 *     index of the item or `null` if none are activated.
 * @nocollapse
 */
function getActiveItem(items, isActivatable = (isItemNotDisabled)) {
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.tabIndex === 0 && isActivatable(item)) {
            return {
                item,
                index: i,
            };
        }
    }
    return null;
}
/**
 * Retrieves the first non-disabled item of a given array of items. This
 * the first item that is not disabled.
 *
 * @param items {Array<ListItem>} The items to search.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 * @return The first activatable item or `null` if none are activatable.
 * @nocollapse
 */
function getFirstActivatableItem(items, isActivatable = (isItemNotDisabled)) {
    for (const item of items) {
        if (isActivatable(item)) {
            return item;
        }
    }
    return null;
}
/**
 * Retrieves the last non-disabled item of a given array of items.
 *
 * @param items {Array<ListItem>} The items to search.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 * @return The last activatable item or `null` if none are activatable.
 * @nocollapse
 */
function getLastActivatableItem(items, isActivatable = (isItemNotDisabled)) {
    for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i];
        if (isActivatable(item)) {
            return item;
        }
    }
    return null;
}
/**
 * Retrieves the next non-disabled item of a given array of items.
 *
 * @param items {Array<ListItem>} The items to search.
 * @param index {{index: number}} The index to search from.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 * @param wrap If true, then the next item at the end of the list is the first
 *     item. Defaults to true.
 * @return The next activatable item or `null` if none are activatable.
 */
function getNextItem(items, index, isActivatable = (isItemNotDisabled), wrap = true) {
    for (let i = 1; i < items.length; i++) {
        const nextIndex = (i + index) % items.length;
        if (nextIndex < index && !wrap) {
            // Return if the index loops back to the beginning and not wrapping.
            return null;
        }
        const item = items[nextIndex];
        if (isActivatable(item)) {
            return item;
        }
    }
    return items[index] ? items[index] : null;
}
/**
 * Retrieves the previous non-disabled item of a given array of items.
 *
 * @param items {Array<ListItem>} The items to search.
 * @param index {{index: number}} The index to search from.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 * @param wrap If true, then the previous item at the beginning of the list is
 *     the last item. Defaults to true.
 * @return The previous activatable item or `null` if none are activatable.
 */
function getPrevItem(items, index, isActivatable = (isItemNotDisabled), wrap = true) {
    for (let i = 1; i < items.length; i++) {
        const prevIndex = (index - i + items.length) % items.length;
        if (prevIndex > index && !wrap) {
            // Return if the index loops back to the end and not wrapping.
            return null;
        }
        const item = items[prevIndex];
        if (isActivatable(item)) {
            return item;
        }
    }
    return items[index] ? items[index] : null;
}
/**
 * Activates the next item and focuses it. If nothing is currently activated,
 * activates the first item.
 */
function activateNextItem(items, activeItemRecord, isActivatable = (isItemNotDisabled), wrap = true) {
    if (activeItemRecord) {
        const next = getNextItem(items, activeItemRecord.index, isActivatable, wrap);
        if (next) {
            next.tabIndex = 0;
            next.focus();
        }
        return next;
    }
    else {
        return activateFirstItem(items, isActivatable);
    }
}
/**
 * Activates the previous item and focuses it. If nothing is currently
 * activated, activates the last item.
 */
function activatePreviousItem(items, activeItemRecord, isActivatable = (isItemNotDisabled), wrap = true) {
    if (activeItemRecord) {
        const prev = getPrevItem(items, activeItemRecord.index, isActivatable, wrap);
        if (prev) {
            prev.tabIndex = 0;
            prev.focus();
        }
        return prev;
    }
    else {
        return activateLastItem(items, isActivatable);
    }
}
/**
 * Creates an event that requests the menu to set `tabindex=0` on the item and
 * focus it. We use this pattern because List keeps track of what element is
 * active in the List by maintaining tabindex. We do not want list items
 * to set tabindex on themselves or focus themselves so that we can organize all
 * that logic in the parent List and Menus, and list item stays as dumb as
 * possible.
 */
function createRequestActivationEvent() {
    return new Event('request-activation', { bubbles: true, composed: true });
}
/**
 * The default `isActivatable` function, which checks if an item is not
 * disabled.
 *
 * @param item The item to check.
 * @return true if `item.disabled` is `false.
 */
function isItemNotDisabled(item) {
    return !item.disabled;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: move this file to List and make List use this
/**
 * Default keys that trigger navigation.
 */
// tslint:disable:enforce-name-casing Following Enum style
const NavigableKeys = {
    ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft',
    ArrowUp: 'ArrowUp',
    ArrowRight: 'ArrowRight',
    Home: 'Home',
    End: 'End',
};
/**
 * A controller that handles list keyboard navigation and item management.
 */
class ListController {
    constructor(config) {
        /**
         * Handles keyboard navigation. Should be bound to the node that will act as
         * the List.
         */
        this.handleKeydown = (event) => {
            const key = event.key;
            if (event.defaultPrevented || !this.isNavigableKey(key)) {
                return;
            }
            // do not use this.items directly in upcoming calculations so we don't
            // re-query the DOM unnecessarily
            const items = this.items;
            if (!items.length) {
                return;
            }
            const activeItemRecord = getActiveItem(items, this.isActivatable);
            event.preventDefault();
            const isRtl = this.isRtl();
            const inlinePrevious = isRtl
                ? NavigableKeys.ArrowRight
                : NavigableKeys.ArrowLeft;
            const inlineNext = isRtl
                ? NavigableKeys.ArrowLeft
                : NavigableKeys.ArrowRight;
            let nextActiveItem = null;
            switch (key) {
                // Activate the next item
                case NavigableKeys.ArrowDown:
                case inlineNext:
                    nextActiveItem = activateNextItem(items, activeItemRecord, this.isActivatable, this.wrapNavigation());
                    break;
                // Activate the previous item
                case NavigableKeys.ArrowUp:
                case inlinePrevious:
                    nextActiveItem = activatePreviousItem(items, activeItemRecord, this.isActivatable, this.wrapNavigation());
                    break;
                // Activate the first item
                case NavigableKeys.Home:
                    nextActiveItem = activateFirstItem(items, this.isActivatable);
                    break;
                // Activate the last item
                case NavigableKeys.End:
                    nextActiveItem = activateLastItem(items, this.isActivatable);
                    break;
            }
            if (nextActiveItem &&
                activeItemRecord &&
                activeItemRecord.item !== nextActiveItem) {
                // If a new item was activated, remove the tabindex of the previous
                // activated item.
                activeItemRecord.item.tabIndex = -1;
            }
        };
        /**
         * Listener to be bound to the `deactivate-items` item event.
         */
        this.onDeactivateItems = () => {
            const items = this.items;
            for (const item of items) {
                this.deactivateItem(item);
            }
        };
        /**
         * Listener to be bound to the `request-activation` item event..
         */
        this.onRequestActivation = (event) => {
            this.onDeactivateItems();
            const target = event.target;
            this.activateItem(target);
            target.focus();
        };
        /**
         * Listener to be bound to the `slotchange` event for the slot that renders
         * the items.
         */
        this.onSlotchange = () => {
            const items = this.items;
            // Whether we have encountered an item that has been activated
            let encounteredActivated = false;
            for (const item of items) {
                const isActivated = !item.disabled && item.tabIndex > -1;
                if (isActivated && !encounteredActivated) {
                    encounteredActivated = true;
                    item.tabIndex = 0;
                    continue;
                }
                // Deactivate the rest including disabled
                item.tabIndex = -1;
            }
            if (encounteredActivated) {
                return;
            }
            const firstActivatableItem = getFirstActivatableItem(items, this.isActivatable);
            if (!firstActivatableItem) {
                return;
            }
            firstActivatableItem.tabIndex = 0;
        };
        const { isItem, getPossibleItems, isRtl, deactivateItem, activateItem, isNavigableKey, isActivatable, wrapNavigation, } = config;
        this.isItem = isItem;
        this.getPossibleItems = getPossibleItems;
        this.isRtl = isRtl;
        this.deactivateItem = deactivateItem;
        this.activateItem = activateItem;
        this.isNavigableKey = isNavigableKey;
        this.isActivatable = isActivatable;
        this.wrapNavigation = wrapNavigation ?? (() => true);
    }
    /**
     * The items being managed by the list. Additionally, attempts to see if the
     * object has a sub-item in the `.item` property.
     */
    get items() {
        const maybeItems = this.getPossibleItems();
        const items = [];
        for (const itemOrParent of maybeItems) {
            const isItem = this.isItem(itemOrParent);
            // if the item is a list item, add it to the list of items
            if (isItem) {
                items.push(itemOrParent);
                continue;
            }
            // If the item exposes an `item` property check if it is a list item.
            const subItem = itemOrParent.item;
            if (subItem && this.isItem(subItem)) {
                items.push(subItem);
            }
        }
        return items;
    }
    /**
     * Activates the next item in the list. If at the end of the list, the first
     * item will be activated.
     *
     * @return The activated list item or `null` if there are no items.
     */
    activateNextItem() {
        const items = this.items;
        const activeItemRecord = getActiveItem(items, this.isActivatable);
        if (activeItemRecord) {
            activeItemRecord.item.tabIndex = -1;
        }
        return activateNextItem(items, activeItemRecord, this.isActivatable, this.wrapNavigation());
    }
    /**
     * Activates the previous item in the list. If at the start of the list, the
     * last item will be activated.
     *
     * @return The activated list item or `null` if there are no items.
     */
    activatePreviousItem() {
        const items = this.items;
        const activeItemRecord = getActiveItem(items, this.isActivatable);
        if (activeItemRecord) {
            activeItemRecord.item.tabIndex = -1;
        }
        return activatePreviousItem(items, activeItemRecord, this.isActivatable, this.wrapNavigation());
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Creates an event that closes any parent menus.
 */
function createCloseMenuEvent(initiator, reason) {
    return new CustomEvent('close-menu', {
        bubbles: true,
        composed: true,
        detail: { initiator, reason, itemPath: [initiator] },
    });
}
/**
 * Creates a default close menu event used by md-menu.
 */
const createDefaultCloseMenuEvent = (createCloseMenuEvent);
/**
 * Keys that are used for selection in menus.
 */
// tslint:disable-next-line:enforce-name-casing We are mimicking enum style
const SelectionKey = {
    SPACE: 'Space',
    ENTER: 'Enter',
};
/**
 * Default close `Reason` kind values.
 */
// tslint:disable-next-line:enforce-name-casing We are mimicking enum style
const CloseReason = {
    CLICK_SELECTION: 'click-selection',
    KEYDOWN: 'keydown',
};
/**
 * Keys that can close menus.
 */
// tslint:disable-next-line:enforce-name-casing We are mimicking enum style
const KeydownCloseKey = {
    ESCAPE: 'Escape',
    SPACE: SelectionKey.SPACE,
    ENTER: SelectionKey.ENTER,
};
/**
 * Determines whether the given key code is a key code that should close the
 * menu.
 *
 * @param code The KeyboardEvent code to check.
 * @return Whether or not the key code is in the predetermined list to close the
 * menu.
 */
function isClosableKey(code) {
    return Object.values(KeydownCloseKey).some((value) => value === code);
}
/**
 * Determines whether the given key code is a key code that should select a menu
 * item.
 *
 * @param code They KeyboardEvent code to check.
 * @return Whether or not the key code is in the predetermined list to select a
 * menu item.
 */
function isSelectableKey(code) {
    return Object.values(SelectionKey).some((value) => value === code);
}
/**
 * Determines whether a target element is contained inside another element's
 * composed tree.
 *
 * @param target The potential contained element.
 * @param container The potential containing element of the target.
 * @returns Whether the target element is contained inside the container's
 * composed subtree
 */
function isElementInSubtree(target, container) {
    // Dispatch a composed, bubbling event to check its path to see if the
    // newly-focused element is contained in container's subtree
    const focusEv = new Event('md-contains', { bubbles: true, composed: true });
    let composedPath = [];
    const listener = (ev) => {
        composedPath = ev.composedPath();
    };
    container.addEventListener('md-contains', listener);
    target.dispatchEvent(focusEv);
    container.removeEventListener('md-contains', listener);
    const isContained = composedPath.length > 0;
    return isContained;
}
/**
 * Element to focus on when menu is first opened.
 */
// tslint:disable-next-line:enforce-name-casing We are mimicking enum style
const FocusState = {
    NONE: 'none',
    LIST_ROOT: 'list-root',
    FIRST_ITEM: 'first-item',
    LAST_ITEM: 'last-item',
};

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * An enum of supported Menu corners
 */
// tslint:disable-next-line:enforce-name-casing We are mimicking enum style
const Corner = {
    END_START: 'end-start',
    START_START: 'start-start'};
/**
 * Given a surface, an anchor, corners, and some options, this surface will
 * calculate the position of a surface to align the two given corners and keep
 * the surface inside the window viewport. It also provides a StyleInfo map that
 * can be applied to the surface to handle visiblility and position.
 */
class SurfacePositionController {
    /**
     * @param host The host to connect the controller to.
     * @param getProperties A function that returns the properties for the
     * controller.
     */
    constructor(host, getProperties) {
        this.host = host;
        this.getProperties = getProperties;
        // The current styles to apply to the surface.
        this.surfaceStylesInternal = {
            'display': 'none',
        };
        // Previous values stored for change detection. Open change detection is
        // calculated separately so initialize it here.
        this.lastValues = {
            isOpen: false,
        };
        this.host.addController(this);
    }
    /**
     * The StyleInfo map to apply to the surface via Lit's stylemap
     */
    get surfaceStyles() {
        return this.surfaceStylesInternal;
    }
    /**
     * Calculates the surface's new position required so that the surface's
     * `surfaceCorner` aligns to the anchor's `anchorCorner` while keeping the
     * surface inside the window viewport. This positioning also respects RTL by
     * checking `getComputedStyle()` on the surface element.
     */
    async position() {
        const { surfaceEl, anchorEl, anchorCorner: anchorCornerRaw, surfaceCorner: surfaceCornerRaw, positioning, xOffset, yOffset, disableBlockFlip, disableInlineFlip, repositionStrategy, } = this.getProperties();
        const anchorCorner = anchorCornerRaw.toLowerCase().trim();
        const surfaceCorner = surfaceCornerRaw.toLowerCase().trim();
        if (!surfaceEl || !anchorEl) {
            return;
        }
        // Store these before we potentially resize the window with the next set of
        // lines
        const windowInnerWidth = window.innerWidth;
        const windowInnerHeight = window.innerHeight;
        const div = document.createElement('div');
        div.style.opacity = '0';
        div.style.position = 'fixed';
        div.style.display = 'block';
        div.style.inset = '0';
        document.body.appendChild(div);
        const scrollbarTestRect = div.getBoundingClientRect();
        div.remove();
        // Calculate the widths of the scrollbars in the inline and block directions
        // to account for window-relative calculations.
        const blockScrollbarHeight = window.innerHeight - scrollbarTestRect.bottom;
        const inlineScrollbarWidth = window.innerWidth - scrollbarTestRect.right;
        // Paint the surface transparently so that we can get the position and the
        // rect info of the surface.
        this.surfaceStylesInternal = {
            'display': 'block',
            'opacity': '0',
        };
        // Wait for it to be visible.
        this.host.requestUpdate();
        await this.host.updateComplete;
        // Safari has a bug that makes popovers render incorrectly if the node is
        // made visible + Animation Frame before calling showPopover().
        // https://bugs.webkit.org/show_bug.cgi?id=264069
        // also the cast is required due to differing TS types in Google and OSS.
        if (surfaceEl.popover &&
            surfaceEl.isConnected) {
            surfaceEl.showPopover();
        }
        const surfaceRect = surfaceEl.getSurfacePositionClientRect
            ? surfaceEl.getSurfacePositionClientRect()
            : surfaceEl.getBoundingClientRect();
        const anchorRect = anchorEl.getSurfacePositionClientRect
            ? anchorEl.getSurfacePositionClientRect()
            : anchorEl.getBoundingClientRect();
        const [surfaceBlock, surfaceInline] = surfaceCorner.split('-');
        const [anchorBlock, anchorInline] = anchorCorner.split('-');
        // LTR depends on the direction of the SURFACE not the anchor.
        const isLTR = getComputedStyle(surfaceEl).direction === 'ltr';
        /*
         * For more on inline and block dimensions, see MDN article:
         * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_logical_properties_and_values
         *
         * ┌───── inline/blockDocumentOffset  inlineScrollbarWidth
         * │       │                                    │
         * │     ┌─▼─────┐                              │Document
         * │    ┌┼───────┴──────────────────────────────┼────────┐
         * │    ││                                      │        │
         * └──► ││ ┌───── inline/blockWindowOffset      │        │
         *      ││ │       │                            ▼        │
         *      ││ │     ┌─▼───┐                 Window┌┐        │
         *      └┤ │    ┌┼─────┴───────────────────────┼│        │
         *       │ │    ││                             ││        │
         *       │ └──► ││  ┌──inline/blockAnchorOffset││        │
         *       │      ││  │     │                    ││        │
         *       │      └┤  │  ┌──▼───┐                ││        │
         *       │       │  │ ┌┼──────┤                ││        │
         *       │       │  └─►│Anchor│                ││        │
         *       │       │    └┴──────┘                ││        │
         *       │       │                             ││        │
         *       │       │     ┌───────────────────────┼┼────┐   │
         *       │       │     │ Surface               ││    │   │
         *       │       │     │                       ││    │   │
         *       │       │     │                       ││    │   │
         *       │       │     │                       ││    │   │
         *       │       │     │                       ││    │   │
         *       │      ┌┼─────┼───────────────────────┼│    │   │
         *       │   ┌─►┴──────┼────────────────────────┘    ├┐  │
         *       │   │         │ inline/blockOOBCorrection   ││  │
         *       │   │         │                         │   ││  │
         *       │   │         │                         ├──►├│  │
         *       │   │         │                         │   ││  │
         *       │   │         └────────────────────────┐▼───┼┘  │
         *       │  blockScrollbarHeight                └────┘   │
         *       │                                               │
         *       └───────────────────────────────────────────────┘
         */
        // Calculate the block positioning properties
        let { blockInset, blockOutOfBoundsCorrection, surfaceBlockProperty } = this.calculateBlock({
            surfaceRect,
            anchorRect,
            anchorBlock,
            surfaceBlock,
            yOffset,
            positioning,
            windowInnerHeight,
            blockScrollbarHeight,
        });
        // If the surface should be out of bounds in the block direction, flip the
        // surface and anchor corner block values and recalculate
        if (blockOutOfBoundsCorrection && !disableBlockFlip) {
            const flippedSurfaceBlock = surfaceBlock === 'start' ? 'end' : 'start';
            const flippedAnchorBlock = anchorBlock === 'start' ? 'end' : 'start';
            const flippedBlock = this.calculateBlock({
                surfaceRect,
                anchorRect,
                anchorBlock: flippedAnchorBlock,
                surfaceBlock: flippedSurfaceBlock,
                yOffset,
                positioning,
                windowInnerHeight,
                blockScrollbarHeight,
            });
            // In the case that the flipped verion would require less out of bounds
            // correcting, use the flipped corner block values
            if (blockOutOfBoundsCorrection > flippedBlock.blockOutOfBoundsCorrection) {
                blockInset = flippedBlock.blockInset;
                blockOutOfBoundsCorrection = flippedBlock.blockOutOfBoundsCorrection;
                surfaceBlockProperty = flippedBlock.surfaceBlockProperty;
            }
        }
        // Calculate the inline positioning properties
        let { inlineInset, inlineOutOfBoundsCorrection, surfaceInlineProperty } = this.calculateInline({
            surfaceRect,
            anchorRect,
            anchorInline,
            surfaceInline,
            xOffset,
            positioning,
            isLTR,
            windowInnerWidth,
            inlineScrollbarWidth,
        });
        // If the surface should be out of bounds in the inline direction, flip the
        // surface and anchor corner inline values and recalculate
        if (inlineOutOfBoundsCorrection && !disableInlineFlip) {
            const flippedSurfaceInline = surfaceInline === 'start' ? 'end' : 'start';
            const flippedAnchorInline = anchorInline === 'start' ? 'end' : 'start';
            const flippedInline = this.calculateInline({
                surfaceRect,
                anchorRect,
                anchorInline: flippedAnchorInline,
                surfaceInline: flippedSurfaceInline,
                xOffset,
                positioning,
                isLTR,
                windowInnerWidth,
                inlineScrollbarWidth,
            });
            // In the case that the flipped verion would require less out of bounds
            // correcting, use the flipped corner inline values
            if (Math.abs(inlineOutOfBoundsCorrection) >
                Math.abs(flippedInline.inlineOutOfBoundsCorrection)) {
                inlineInset = flippedInline.inlineInset;
                inlineOutOfBoundsCorrection = flippedInline.inlineOutOfBoundsCorrection;
                surfaceInlineProperty = flippedInline.surfaceInlineProperty;
            }
        }
        // If we are simply repositioning the surface back inside the viewport,
        // subtract the out of bounds correction values from the positioning.
        if (repositionStrategy === 'move') {
            blockInset = blockInset - blockOutOfBoundsCorrection;
            inlineInset = inlineInset - inlineOutOfBoundsCorrection;
        }
        this.surfaceStylesInternal = {
            'display': 'block',
            'opacity': '1',
            [surfaceBlockProperty]: `${blockInset}px`,
            [surfaceInlineProperty]: `${inlineInset}px`,
        };
        // In the case that we are resizing the surface to stay inside the viewport
        // we need to set height and width on the surface.
        if (repositionStrategy === 'resize') {
            // Add a height property to the styles if there is block height correction
            if (blockOutOfBoundsCorrection) {
                this.surfaceStylesInternal['height'] = `${surfaceRect.height - blockOutOfBoundsCorrection}px`;
            }
            // Add a width property to the styles if there is block height correction
            if (inlineOutOfBoundsCorrection) {
                this.surfaceStylesInternal['width'] = `${surfaceRect.width - inlineOutOfBoundsCorrection}px`;
            }
        }
        this.host.requestUpdate();
    }
    /**
     * Calculates the css property, the inset, and the out of bounds correction
     * for the surface in the block direction.
     */
    calculateBlock(config) {
        const { surfaceRect, anchorRect, anchorBlock, surfaceBlock, yOffset, positioning, windowInnerHeight, blockScrollbarHeight, } = config;
        // We use number booleans to multiply values rather than `if` / ternary
        // statements because it _heavily_ cuts down on nesting and readability
        const relativeToWindow = positioning === 'fixed' || positioning === 'document' ? 1 : 0;
        const relativeToDocument = positioning === 'document' ? 1 : 0;
        const isSurfaceBlockStart = surfaceBlock === 'start' ? 1 : 0;
        const isSurfaceBlockEnd = surfaceBlock === 'end' ? 1 : 0;
        const isOneBlockEnd = anchorBlock !== surfaceBlock ? 1 : 0;
        // Whether or not to apply the height of the anchor
        const blockAnchorOffset = isOneBlockEnd * anchorRect.height + yOffset;
        // The absolute block position of the anchor relative to window
        const blockTopLayerOffset = isSurfaceBlockStart * anchorRect.top +
            isSurfaceBlockEnd *
                (windowInnerHeight - anchorRect.bottom - blockScrollbarHeight);
        const blockDocumentOffset = isSurfaceBlockStart * window.scrollY - isSurfaceBlockEnd * window.scrollY;
        // If the surface's block would be out of bounds of the window, move it back
        // in
        const blockOutOfBoundsCorrection = Math.abs(Math.min(0, windowInnerHeight -
            blockTopLayerOffset -
            blockAnchorOffset -
            surfaceRect.height));
        // The block logical value of the surface
        const blockInset = relativeToWindow * blockTopLayerOffset +
            relativeToDocument * blockDocumentOffset +
            blockAnchorOffset;
        const surfaceBlockProperty = surfaceBlock === 'start' ? 'inset-block-start' : 'inset-block-end';
        return { blockInset, blockOutOfBoundsCorrection, surfaceBlockProperty };
    }
    /**
     * Calculates the css property, the inset, and the out of bounds correction
     * for the surface in the inline direction.
     */
    calculateInline(config) {
        const { isLTR: isLTRBool, surfaceInline, anchorInline, anchorRect, surfaceRect, xOffset, positioning, windowInnerWidth, inlineScrollbarWidth, } = config;
        // We use number booleans to multiply values rather than `if` / ternary
        // statements because it _heavily_ cuts down on nesting and readability
        const relativeToWindow = positioning === 'fixed' || positioning === 'document' ? 1 : 0;
        const relativeToDocument = positioning === 'document' ? 1 : 0;
        const isLTR = isLTRBool ? 1 : 0;
        const isRTL = isLTRBool ? 0 : 1;
        const isSurfaceInlineStart = surfaceInline === 'start' ? 1 : 0;
        const isSurfaceInlineEnd = surfaceInline === 'end' ? 1 : 0;
        const isOneInlineEnd = anchorInline !== surfaceInline ? 1 : 0;
        // Whether or not to apply the width of the anchor
        const inlineAnchorOffset = isOneInlineEnd * anchorRect.width + xOffset;
        // The inline position of the anchor relative to window in LTR
        const inlineTopLayerOffsetLTR = isSurfaceInlineStart * anchorRect.left +
            isSurfaceInlineEnd *
                (windowInnerWidth - anchorRect.right - inlineScrollbarWidth);
        // The inline position of the anchor relative to window in RTL
        const inlineTopLayerOffsetRTL = isSurfaceInlineStart *
            (windowInnerWidth - anchorRect.right - inlineScrollbarWidth) +
            isSurfaceInlineEnd * anchorRect.left;
        // The inline position of the anchor relative to window
        const inlineTopLayerOffset = isLTR * inlineTopLayerOffsetLTR + isRTL * inlineTopLayerOffsetRTL;
        // The inline position of the anchor relative to window in LTR
        const inlineDocumentOffsetLTR = isSurfaceInlineStart * window.scrollX -
            isSurfaceInlineEnd * window.scrollX;
        // The inline position of the anchor relative to window in RTL
        const inlineDocumentOffsetRTL = isSurfaceInlineEnd * window.scrollX -
            isSurfaceInlineStart * window.scrollX;
        // The inline position of the anchor relative to window
        const inlineDocumentOffset = isLTR * inlineDocumentOffsetLTR + isRTL * inlineDocumentOffsetRTL;
        // If the surface's inline would be out of bounds of the window, move it
        // back in
        const inlineOutOfBoundsCorrection = Math.abs(Math.min(0, windowInnerWidth -
            inlineTopLayerOffset -
            inlineAnchorOffset -
            surfaceRect.width));
        // The inline logical value of the surface
        const inlineInset = relativeToWindow * inlineTopLayerOffset +
            inlineAnchorOffset +
            relativeToDocument * inlineDocumentOffset;
        let surfaceInlineProperty = surfaceInline === 'start' ? 'inset-inline-start' : 'inset-inline-end';
        // There are cases where the element is RTL but the root of the page is not.
        // In these cases we want to not use logical properties.
        if (positioning === 'document' || positioning === 'fixed') {
            if ((surfaceInline === 'start' && isLTRBool) ||
                (surfaceInline === 'end' && !isLTRBool)) {
                surfaceInlineProperty = 'left';
            }
            else {
                surfaceInlineProperty = 'right';
            }
        }
        return {
            inlineInset,
            inlineOutOfBoundsCorrection,
            surfaceInlineProperty,
        };
    }
    hostUpdate() {
        this.onUpdate();
    }
    hostUpdated() {
        this.onUpdate();
    }
    /**
     * Checks whether the properties passed into the controller have changed since
     * the last positioning. If so, it will reposition if the surface is open or
     * close it if the surface should close.
     */
    async onUpdate() {
        const props = this.getProperties();
        let hasChanged = false;
        for (const [key, value] of Object.entries(props)) {
            // tslint:disable-next-line
            hasChanged = hasChanged || value !== this.lastValues[key];
            if (hasChanged)
                break;
        }
        const openChanged = this.lastValues.isOpen !== props.isOpen;
        const hasAnchor = !!props.anchorEl;
        const hasSurface = !!props.surfaceEl;
        if (hasChanged && hasAnchor && hasSurface) {
            // Only update isOpen, because if it's closed, we do not want to waste
            // time on a useless reposition calculation. So save the other "dirty"
            // values until next time it opens.
            this.lastValues.isOpen = props.isOpen;
            if (props.isOpen) {
                // We are going to do a reposition, so save the prop values for future
                // dirty checking.
                this.lastValues = props;
                await this.position();
                props.onOpen();
            }
            else if (openChanged) {
                await props.beforeClose();
                this.close();
                props.onClose();
            }
        }
    }
    /**
     * Hides the surface.
     */
    close() {
        this.surfaceStylesInternal = {
            'display': 'none',
        };
        this.host.requestUpdate();
        const surfaceEl = this.getProperties().surfaceEl;
        // The following type casts are required due to differing TS types in Google
        // and open source.
        if (surfaceEl?.popover &&
            surfaceEl?.isConnected) {
            surfaceEl.hidePopover();
        }
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicies to access the TypeaheadRecord tuple type.
 */
const TYPEAHEAD_RECORD = {
    INDEX: 0,
    ITEM: 1,
    TEXT: 2,
};
/**
 * This controller listens to `keydown` events and searches the header text of
 * an array of `MenuItem`s with the corresponding entered keys within the buffer
 * time and activates the item.
 *
 * @example
 * ```ts
 * const typeaheadController = new TypeaheadController(() => ({
 *   typeaheadBufferTime: 50,
 *   getItems: () => Array.from(document.querySelectorAll('md-menu-item'))
 * }));
 * html`
 *   <div
 *       @keydown=${typeaheadController.onKeydown}
 *       tabindex="0"
 *       class="activeItemText">
 *     <!-- focusable element that will receive keydown events -->
 *     Apple
 *   </div>
 *   <div>
 *     <md-menu-item active header="Apple"></md-menu-item>
 *     <md-menu-item header="Apricot"></md-menu-item>
 *     <md-menu-item header="Banana"></md-menu-item>
 *     <md-menu-item header="Olive"></md-menu-item>
 *     <md-menu-item header="Orange"></md-menu-item>
 *   </div>
 * `;
 * ```
 */
class TypeaheadController {
    /**
     * @param getProperties A function that returns the options of the typeahead
     * controller:
     *
     * {
     *   getItems: A function that returns an array of menu items to be searched.
     *   typeaheadBufferTime: The maximum time between each keystroke to keep the
     *       current type buffer alive.
     * }
     */
    constructor(getProperties) {
        this.getProperties = getProperties;
        /**
         * Array of tuples that helps with indexing.
         */
        this.typeaheadRecords = [];
        /**
         * Currently-typed text since last buffer timeout
         */
        this.typaheadBuffer = '';
        /**
         * The timeout id from the current buffer's setTimeout
         */
        this.cancelTypeaheadTimeout = 0;
        /**
         * If we are currently "typing"
         */
        this.isTypingAhead = false;
        /**
         * The record of the last active item.
         */
        this.lastActiveRecord = null;
        /**
         * Apply this listener to the element that will receive `keydown` events that
         * should trigger this controller.
         *
         * @param event The native browser `KeyboardEvent` from the `keydown` event.
         */
        this.onKeydown = (event) => {
            if (this.isTypingAhead) {
                this.typeahead(event);
            }
            else {
                this.beginTypeahead(event);
            }
        };
        /**
         * Ends the current typeahead and clears the buffer.
         */
        this.endTypeahead = () => {
            this.isTypingAhead = false;
            this.typaheadBuffer = '';
            this.typeaheadRecords = [];
        };
    }
    get items() {
        return this.getProperties().getItems();
    }
    get active() {
        return this.getProperties().active;
    }
    /**
     * Sets up typingahead
     */
    beginTypeahead(event) {
        if (!this.active) {
            return;
        }
        // We don't want to typeahead if the _beginning_ of the typeahead is a menu
        // navigation, or a selection. We will handle "Space" only if it's in the
        // middle of a typeahead
        if (event.code === 'Space' ||
            event.code === 'Enter' ||
            event.code.startsWith('Arrow') ||
            event.code === 'Escape') {
            return;
        }
        this.isTypingAhead = true;
        // Generates the record array data structure which is the index, the element
        // and a normalized header.
        this.typeaheadRecords = this.items.map((el, index) => [
            index,
            el,
            el.typeaheadText.trim().toLowerCase(),
        ]);
        this.lastActiveRecord =
            this.typeaheadRecords.find((record) => record[TYPEAHEAD_RECORD.ITEM].tabIndex === 0) ?? null;
        if (this.lastActiveRecord) {
            this.lastActiveRecord[TYPEAHEAD_RECORD.ITEM].tabIndex = -1;
        }
        this.typeahead(event);
    }
    /**
     * Performs the typeahead. Based on the normalized items and the current text
     * buffer, finds the _next_ item with matching text and activates it.
     *
     * @example
     *
     * items: Apple, Banana, Olive, Orange, Cucumber
     * buffer: ''
     * user types: o
     *
     * activates Olive
     *
     * @example
     *
     * items: Apple, Banana, Olive (active), Orange, Cucumber
     * buffer: 'o'
     * user types: l
     *
     * activates Olive
     *
     * @example
     *
     * items: Apple, Banana, Olive (active), Orange, Cucumber
     * buffer: ''
     * user types: o
     *
     * activates Orange
     *
     * @example
     *
     * items: Apple, Banana, Olive, Orange (active), Cucumber
     * buffer: ''
     * user types: o
     *
     * activates Olive
     */
    typeahead(event) {
        if (event.defaultPrevented)
            return;
        clearTimeout(this.cancelTypeaheadTimeout);
        // Stop typingahead if one of the navigation or selection keys (except for
        // Space) are pressed
        if (event.code === 'Enter' ||
            event.code.startsWith('Arrow') ||
            event.code === 'Escape') {
            this.endTypeahead();
            if (this.lastActiveRecord) {
                this.lastActiveRecord[TYPEAHEAD_RECORD.ITEM].tabIndex = -1;
            }
            return;
        }
        // If Space is pressed, prevent it from selecting and closing the menu
        if (event.code === 'Space') {
            event.preventDefault();
        }
        // Start up a new keystroke buffer timeout
        this.cancelTypeaheadTimeout = setTimeout(this.endTypeahead, this.getProperties().typeaheadBufferTime);
        this.typaheadBuffer += event.key.toLowerCase();
        const lastActiveIndex = this.lastActiveRecord
            ? this.lastActiveRecord[TYPEAHEAD_RECORD.INDEX]
            : -1;
        const numRecords = this.typeaheadRecords.length;
        /**
         * Sorting function that will resort the items starting with the given index
         *
         * @example
         *
         * this.typeaheadRecords =
         * 0: [0, <reference>, 'apple']
         * 1: [1, <reference>, 'apricot']
         * 2: [2, <reference>, 'banana']
         * 3: [3, <reference>, 'olive'] <-- lastActiveIndex
         * 4: [4, <reference>, 'orange']
         * 5: [5, <reference>, 'strawberry']
         *
         * this.typeaheadRecords.sort((a,b) => rebaseIndexOnActive(a)
         *                                       - rebaseIndexOnActive(b)) ===
         * 0: [3, <reference>, 'olive'] <-- lastActiveIndex
         * 1: [4, <reference>, 'orange']
         * 2: [5, <reference>, 'strawberry']
         * 3: [0, <reference>, 'apple']
         * 4: [1, <reference>, 'apricot']
         * 5: [2, <reference>, 'banana']
         */
        const rebaseIndexOnActive = (record) => {
            return ((record[TYPEAHEAD_RECORD.INDEX] + numRecords - lastActiveIndex) %
                numRecords);
        };
        // records filtered and sorted / rebased around the last active index
        const matchingRecords = this.typeaheadRecords
            .filter((record) => !record[TYPEAHEAD_RECORD.ITEM].disabled &&
            record[TYPEAHEAD_RECORD.TEXT].startsWith(this.typaheadBuffer))
            .sort((a, b) => rebaseIndexOnActive(a) - rebaseIndexOnActive(b));
        // Just leave if there's nothing that matches. Native select will just
        // choose the first thing that starts with the next letter in the alphabet
        // but that's out of scope and hard to localize
        if (matchingRecords.length === 0) {
            clearTimeout(this.cancelTypeaheadTimeout);
            if (this.lastActiveRecord) {
                this.lastActiveRecord[TYPEAHEAD_RECORD.ITEM].tabIndex = -1;
            }
            this.endTypeahead();
            return;
        }
        const isNewQuery = this.typaheadBuffer.length === 1;
        let nextRecord;
        // This is likely the case that someone is trying to "tab" through different
        // entries that start with the same letter
        if (this.lastActiveRecord === matchingRecords[0] && isNewQuery) {
            nextRecord = matchingRecords[1] ?? matchingRecords[0];
        }
        else {
            nextRecord = matchingRecords[0];
        }
        if (this.lastActiveRecord) {
            this.lastActiveRecord[TYPEAHEAD_RECORD.ITEM].tabIndex = -1;
        }
        this.lastActiveRecord = nextRecord;
        nextRecord[TYPEAHEAD_RECORD.ITEM].tabIndex = 0;
        nextRecord[TYPEAHEAD_RECORD.ITEM].focus();
        return;
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The default value for the typeahead buffer time in Milliseconds.
 */
const DEFAULT_TYPEAHEAD_BUFFER_TIME = 200;
const submenuNavKeys = new Set([
    NavigableKeys.ArrowDown,
    NavigableKeys.ArrowUp,
    NavigableKeys.Home,
    NavigableKeys.End,
]);
const menuNavKeys = new Set([
    NavigableKeys.ArrowLeft,
    NavigableKeys.ArrowRight,
    ...submenuNavKeys,
]);
/**
 * Gets the currently focused element on the page.
 *
 * @param activeDoc The document or shadowroot from which to start the search.
 *    Defaults to `window.document`
 * @return Returns the currently deeply focused element or `null` if none.
 */
function getFocusedElement(activeDoc = document) {
    let activeEl = activeDoc.activeElement;
    // Check for activeElement in the case that an element with a shadow root host
    // is currently focused.
    while (activeEl && activeEl?.shadowRoot?.activeElement) {
        activeEl = activeEl.shadowRoot.activeElement;
    }
    return activeEl;
}
/**
 * @fires opening {Event} Fired before the opening animation begins
 * @fires opened {Event} Fired once the menu is open, after any animations
 * @fires closing {Event} Fired before the closing animation begins
 * @fires closed {Event} Fired once the menu is closed, after any animations
 */
class Menu extends i$4 {
    /**
     * Whether the menu is animating upwards or downwards when opening. This is
     * helpful for calculating some animation calculations.
     */
    get openDirection() {
        const menuCornerBlock = this.menuCorner.split('-')[0];
        return menuCornerBlock === 'start' ? 'DOWN' : 'UP';
    }
    /**
     * The element which the menu should align to. If `anchor` is set to a
     * non-empty idref string, then `anchorEl` will resolve to the element with
     * the given id in the same root node. Otherwise, `null`.
     */
    get anchorElement() {
        if (this.anchor) {
            return this.getRootNode().querySelector(`#${this.anchor}`);
        }
        return this.currentAnchorElement;
    }
    set anchorElement(element) {
        this.currentAnchorElement = element;
        this.requestUpdate('anchorElement');
    }
    constructor() {
        super();
        /**
         * The ID of the element in the same root node in which the menu should align
         * to. Overrides setting `anchorElement = elementReference`.
         *
         * __NOTE__: anchor or anchorElement must either be an HTMLElement or resolve
         * to an HTMLElement in order for menu to open.
         */
        this.anchor = '';
        /**
         * Whether the positioning algorithm should calculate relative to the parent
         * of the anchor element (`absolute`), relative to the window (`fixed`), or
         * relative to the document (`document`). `popover` will use the popover API
         * to render the menu in the top-layer. If your browser does not support the
         * popover API, it will fall back to `fixed`.
         *
         * __Examples for `position = 'fixed'`:__
         *
         * - If there is no `position:relative` in the given parent tree and the
         *   surface is `position:absolute`
         * - If the surface is `position:fixed`
         * - If the surface is in the "top layer"
         * - The anchor and the surface do not share a common `position:relative`
         *   ancestor
         *
         * When using `positioning=fixed`, in most cases, the menu should position
         * itself above most other `position:absolute` or `position:fixed` elements
         * when placed inside of them. e.g. using a menu inside of an `md-dialog`.
         *
         * __NOTE__: Fixed menus will not scroll with the page and will be fixed to
         * the window instead.
         *
         * __Examples for `position = 'document'`:__
         *
         * - There is no parent that creates a relative positioning context e.g.
         *   `position: relative`, `position: absolute`, `transform: translate(x, y)`,
         *   etc.
         * - You put the effort into hoisting the menu to the top of the DOM like the
         *   end of the `<body>` to render over everything or in a top-layer.
         * - You are reusing a single `md-menu` element that dynamically renders
         *   content.
         *
         * __Examples for `position = 'popover'`:__
         *
         * - Your browser supports `popover`.
         * - Most cases. Once popover is in browsers, this will become the default.
         */
        this.positioning = 'absolute';
        /**
         * Skips the opening and closing animations.
         */
        this.quick = false;
        /**
         * Displays overflow content like a submenu. Not required in most cases when
         * using `positioning="popover"`.
         *
         * __NOTE__: This may cause adverse effects if you set
         * `md-menu {max-height:...}`
         * and have items overflowing items in the "y" direction.
         */
        this.hasOverflow = false;
        /**
         * Opens the menu and makes it visible. Alternative to the `.show()` and
         * `.close()` methods
         */
        this.open = false;
        /**
         * Offsets the menu's inline alignment from the anchor by the given number in
         * pixels. This value is direction aware and will follow the LTR / RTL
         * direction.
         *
         * e.g. LTR: positive -> right, negative -> left
         *      RTL: positive -> left, negative -> right
         */
        this.xOffset = 0;
        /**
         * Offsets the menu's block alignment from the anchor by the given number in
         * pixels.
         *
         * e.g. positive -> down, negative -> up
         */
        this.yOffset = 0;
        /**
         * Disable the `flip` behavior that usually happens on the horizontal axis
         * when the surface would render outside the viewport.
         */
        this.noHorizontalFlip = false;
        /**
         * Disable the `flip` behavior that usually happens on the vertical axis when
         * the surface would render outside the viewport.
         */
        this.noVerticalFlip = false;
        /**
         * The max time between the keystrokes of the typeahead menu behavior before
         * it clears the typeahead buffer.
         */
        this.typeaheadDelay = DEFAULT_TYPEAHEAD_BUFFER_TIME;
        /**
         * The corner of the anchor which to align the menu in the standard logical
         * property style of <block>-<inline> e.g. `'end-start'`.
         *
         * NOTE: This value may not be respected by the menu positioning algorithm
         * if the menu would render outisde the viewport.
         * Use `no-horizontal-flip` or `no-vertical-flip` to force the usage of the value
         */
        this.anchorCorner = Corner.END_START;
        /**
         * The corner of the menu which to align the anchor in the standard logical
         * property style of <block>-<inline> e.g. `'start-start'`.
         *
         * NOTE: This value may not be respected by the menu positioning algorithm
         * if the menu would render outisde the viewport.
         * Use `no-horizontal-flip` or `no-vertical-flip` to force the usage of the value
         */
        this.menuCorner = Corner.START_START;
        /**
         * Keeps the user clicks outside the menu.
         *
         * NOTE: clicking outside may still cause focusout to close the menu so see
         * `stayOpenOnFocusout`.
         */
        this.stayOpenOnOutsideClick = false;
        /**
         * Keeps the menu open when focus leaves the menu's composed subtree.
         *
         * NOTE: Focusout behavior will stop propagation of the focusout event. Set
         * this property to true to opt-out of menu's focusout handling altogether.
         */
        this.stayOpenOnFocusout = false;
        /**
         * After closing, does not restore focus to the last focused element before
         * the menu was opened.
         */
        this.skipRestoreFocus = false;
        /**
         * The element that should be focused by default once opened.
         *
         * NOTE: When setting default focus to 'LIST_ROOT', remember to change
         * `tabindex` to `0` and change md-menu's display to something other than
         * `display: contents` when necessary.
         */
        this.defaultFocus = FocusState.FIRST_ITEM;
        /**
         * Turns off navigation wrapping. By default, navigating past the end of the
         * menu items will wrap focus back to the beginning and vice versa. Use this
         * for ARIA patterns that do not wrap focus, like combobox.
         */
        this.noNavigationWrap = false;
        this.typeaheadActive = true;
        /**
         * Whether or not the current menu is a submenu and should not handle specific
         * navigation keys.
         *
         * @export
         */
        this.isSubmenu = false;
        /**
         * The event path of the last window pointerdown event.
         */
        this.pointerPath = [];
        /**
         * Whether or not the menu is repositoining due to window / document resize
         */
        this.isRepositioning = false;
        this.openCloseAnimationSignal = createAnimationSignal();
        this.listController = new ListController({
            isItem: (maybeItem) => {
                return maybeItem.hasAttribute('md-menu-item');
            },
            getPossibleItems: () => this.slotItems,
            isRtl: () => getComputedStyle(this).direction === 'rtl',
            deactivateItem: (item) => {
                item.selected = false;
                item.tabIndex = -1;
            },
            activateItem: (item) => {
                item.selected = true;
                item.tabIndex = 0;
            },
            isNavigableKey: (key) => {
                if (!this.isSubmenu) {
                    return menuNavKeys.has(key);
                }
                const isRtl = getComputedStyle(this).direction === 'rtl';
                // we want md-submenu to handle the submenu's left/right arrow exit
                // key so it can close the menu instead of navigate the list.
                // Therefore we need to include all keys but left/right arrow close
                // key
                const arrowOpen = isRtl
                    ? NavigableKeys.ArrowLeft
                    : NavigableKeys.ArrowRight;
                if (key === arrowOpen) {
                    return true;
                }
                return submenuNavKeys.has(key);
            },
            wrapNavigation: () => !this.noNavigationWrap,
        });
        /**
         * The element that was focused before the menu opened.
         */
        this.lastFocusedElement = null;
        /**
         * Handles typeahead navigation through the menu.
         */
        this.typeaheadController = new TypeaheadController(() => {
            return {
                getItems: () => this.items,
                typeaheadBufferTime: this.typeaheadDelay,
                active: this.typeaheadActive,
            };
        });
        this.currentAnchorElement = null;
        this.internals = 
        // Cast needed for closure
        this.attachInternals();
        /**
         * Handles positioning the surface and aligning it to the anchor as well as
         * keeping it in the viewport.
         */
        this.menuPositionController = new SurfacePositionController(this, () => {
            return {
                anchorCorner: this.anchorCorner,
                surfaceCorner: this.menuCorner,
                surfaceEl: this.surfaceEl,
                anchorEl: this.anchorElement,
                positioning: this.positioning === 'popover' ? 'document' : this.positioning,
                isOpen: this.open,
                xOffset: this.xOffset,
                yOffset: this.yOffset,
                disableBlockFlip: this.noVerticalFlip,
                disableInlineFlip: this.noHorizontalFlip,
                onOpen: this.onOpened,
                beforeClose: this.beforeClose,
                onClose: this.onClosed,
                // We can't resize components that have overflow like menus with
                // submenus because the overflow-y will show menu items / content
                // outside the bounds of the menu. Popover API fixes this because each
                // submenu is hoisted to the top-layer and are not considered overflow
                // content.
                repositionStrategy: this.hasOverflow && this.positioning !== 'popover'
                    ? 'move'
                    : 'resize',
            };
        });
        this.onWindowResize = () => {
            if (this.isRepositioning ||
                (this.positioning !== 'document' &&
                    this.positioning !== 'fixed' &&
                    this.positioning !== 'popover')) {
                return;
            }
            this.isRepositioning = true;
            this.reposition();
            this.isRepositioning = false;
        };
        this.handleFocusout = async (event) => {
            const anchorEl = this.anchorElement;
            // Do not close if we focused out by clicking on the anchor element. We
            // can't assume anchor buttons can be the related target because of iOS does
            // not focus buttons.
            if (this.stayOpenOnFocusout ||
                !this.open ||
                this.pointerPath.includes(anchorEl)) {
                return;
            }
            if (event.relatedTarget) {
                // Don't close the menu if we are switching focus between menu,
                // md-menu-item, and md-list or if the anchor was click focused, but check
                // if length of pointerPath is 0 because that means something was at least
                // clicked (shift+tab case).
                if (isElementInSubtree(event.relatedTarget, this) ||
                    (this.pointerPath.length !== 0 &&
                        isElementInSubtree(event.relatedTarget, anchorEl))) {
                    return;
                }
            }
            else if (this.pointerPath.includes(this)) {
                // If menu tabindex == -1 and the user clicks on the menu or a divider, we
                // want to keep the menu open.
                return;
            }
            const oldRestoreFocus = this.skipRestoreFocus;
            // allow focus to continue to the next focused object rather than returning
            this.skipRestoreFocus = true;
            this.close();
            // await for close
            await this.updateComplete;
            // return to previous behavior
            this.skipRestoreFocus = oldRestoreFocus;
        };
        /**
         * Saves the last focused element focuses the new element based on
         * `defaultFocus`, and animates open.
         */
        this.onOpened = async () => {
            this.lastFocusedElement = getFocusedElement();
            const items = this.items;
            const activeItemRecord = getActiveItem(items);
            if (activeItemRecord && this.defaultFocus !== FocusState.NONE) {
                activeItemRecord.item.tabIndex = -1;
            }
            let animationAborted = !this.quick;
            if (this.quick) {
                this.dispatchEvent(new Event('opening'));
            }
            else {
                animationAborted = !!(await this.animateOpen());
            }
            // This must come after the opening animation or else it may focus one of
            // the items before the animation has begun and causes the list to slide
            // (block-padding-of-the-menu)px at the end of the animation
            switch (this.defaultFocus) {
                case FocusState.FIRST_ITEM:
                    const first = getFirstActivatableItem(items);
                    if (first) {
                        first.tabIndex = 0;
                        first.focus();
                        await first.updateComplete;
                    }
                    break;
                case FocusState.LAST_ITEM:
                    const last = getLastActivatableItem(items);
                    if (last) {
                        last.tabIndex = 0;
                        last.focus();
                        await last.updateComplete;
                    }
                    break;
                case FocusState.LIST_ROOT:
                    this.focus();
                    break;
                default:
                case FocusState.NONE:
                    // Do nothing.
                    break;
            }
            if (!animationAborted) {
                this.dispatchEvent(new Event('opened'));
            }
        };
        /**
         * Animates closed.
         */
        this.beforeClose = async () => {
            this.open = false;
            if (!this.skipRestoreFocus) {
                this.lastFocusedElement?.focus?.();
            }
            if (!this.quick) {
                await this.animateClose();
            }
        };
        /**
         * Focuses the last focused element.
         */
        this.onClosed = () => {
            if (this.quick) {
                this.dispatchEvent(new Event('closing'));
                this.dispatchEvent(new Event('closed'));
            }
        };
        this.onWindowPointerdown = (event) => {
            this.pointerPath = event.composedPath();
        };
        /**
         * We cannot listen to window click because Safari on iOS will not bubble a
         * click event on window if the item clicked is not a "clickable" item such as
         * <body>
         */
        this.onDocumentClick = (event) => {
            if (!this.open) {
                return;
            }
            const path = event.composedPath();
            if (!this.stayOpenOnOutsideClick &&
                !path.includes(this) &&
                !path.includes(this.anchorElement)) {
                this.open = false;
            }
        };
        {
            this.internals.role = 'menu';
            this.addEventListener('keydown', this.handleKeydown);
            // Capture so that we can grab the event before it reaches the menu item
            // istelf. Specifically useful for the case where typeahead encounters a
            // space and we don't want the menu item to close the menu.
            this.addEventListener('keydown', this.captureKeydown, { capture: true });
            this.addEventListener('focusout', this.handleFocusout);
        }
    }
    /**
     * The menu items associated with this menu. The items must be `MenuItem`s and
     * have both the `md-menu-item` and `md-list-item` attributes.
     */
    get items() {
        return this.listController.items;
    }
    willUpdate(changed) {
        if (!changed.has('open')) {
            return;
        }
        if (this.open) {
            this.removeAttribute('aria-hidden');
            return;
        }
        this.setAttribute('aria-hidden', 'true');
    }
    update(changed) {
        if (changed.has('open')) {
            if (this.open) {
                this.setUpGlobalEventListeners();
            }
            else {
                this.cleanUpGlobalEventListeners();
            }
        }
        // Firefox does not support popover. Fall-back to using fixed.
        if (changed.has('positioning') &&
            this.positioning === 'popover' &&
            // type required for Google JS conformance
            !this.showPopover) {
            this.positioning = 'fixed';
        }
        super.update(changed);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.open) {
            this.setUpGlobalEventListeners();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.cleanUpGlobalEventListeners();
    }
    getBoundingClientRect() {
        if (!this.surfaceEl) {
            return super.getBoundingClientRect();
        }
        return this.surfaceEl.getBoundingClientRect();
    }
    getClientRects() {
        if (!this.surfaceEl) {
            return super.getClientRects();
        }
        return this.surfaceEl.getClientRects();
    }
    render() {
        return this.renderSurface();
    }
    /**
     * Renders the positionable surface element and its contents.
     */
    renderSurface() {
        return b `
      <div
        class="menu ${e(this.getSurfaceClasses())}"
        style=${o$1(this.menuPositionController.surfaceStyles)}
        popover=${this.positioning === 'popover' ? 'manual' : A}>
        ${this.renderElevation()}
        <div class="items">
          <div class="item-padding"> ${this.renderMenuItems()} </div>
        </div>
      </div>
    `;
    }
    /**
     * Renders the menu items' slot
     */
    renderMenuItems() {
        return b `<slot
      @close-menu=${this.onCloseMenu}
      @deactivate-items=${this.onDeactivateItems}
      @request-activation=${this.onRequestActivation}
      @deactivate-typeahead=${this.handleDeactivateTypeahead}
      @activate-typeahead=${this.handleActivateTypeahead}
      @stay-open-on-focusout=${this.handleStayOpenOnFocusout}
      @close-on-focusout=${this.handleCloseOnFocusout}
      @slotchange=${this.listController.onSlotchange}></slot>`;
    }
    /**
     * Renders the elevation component.
     */
    renderElevation() {
        return b `<md-elevation part="elevation"></md-elevation>`;
    }
    getSurfaceClasses() {
        return {
            open: this.open,
            fixed: this.positioning === 'fixed',
            'has-overflow': this.hasOverflow,
        };
    }
    captureKeydown(event) {
        if (event.target === this &&
            !event.defaultPrevented &&
            isClosableKey(event.code)) {
            event.preventDefault();
            this.close();
        }
        this.typeaheadController.onKeydown(event);
    }
    /**
     * Performs the opening animation:
     *
     * https://direct.googleplex.com/#/spec/295000003+271060003
     *
     * @return A promise that resolve to `true` if the animation was aborted,
     *     `false` if it was not aborted.
     */
    async animateOpen() {
        const surfaceEl = this.surfaceEl;
        const slotEl = this.slotEl;
        if (!surfaceEl || !slotEl)
            return true;
        const openDirection = this.openDirection;
        this.dispatchEvent(new Event('opening'));
        // needs to be imperative because we don't want to mix animation and Lit
        // render timing
        surfaceEl.classList.toggle('animating', true);
        const signal = this.openCloseAnimationSignal.start();
        const height = surfaceEl.offsetHeight;
        const openingUpwards = openDirection === 'UP';
        const children = this.items;
        const FULL_DURATION = 500;
        const SURFACE_OPACITY_DURATION = 50;
        const ITEM_OPACITY_DURATION = 250;
        // We want to fit every child fade-in animation within the full duration of
        // the animation.
        const DELAY_BETWEEN_ITEMS = (FULL_DURATION - ITEM_OPACITY_DURATION) / children.length;
        const surfaceHeightAnimation = surfaceEl.animate([{ height: '0px' }, { height: `${height}px` }], {
            duration: FULL_DURATION,
            easing: EASING.EMPHASIZED,
        });
        // When we are opening upwards, we want to make sure the last item is always
        // in view, so we need to translate it upwards the opposite direction of the
        // height animation
        const upPositionCorrectionAnimation = slotEl.animate([
            { transform: openingUpwards ? `translateY(-${height}px)` : '' },
            { transform: '' },
        ], { duration: FULL_DURATION, easing: EASING.EMPHASIZED });
        const surfaceOpacityAnimation = surfaceEl.animate([{ opacity: 0 }, { opacity: 1 }], SURFACE_OPACITY_DURATION);
        const childrenAnimations = [];
        for (let i = 0; i < children.length; i++) {
            // If we are animating upwards, then reverse the children list.
            const directionalIndex = openingUpwards ? children.length - 1 - i : i;
            const child = children[directionalIndex];
            const animation = child.animate([{ opacity: 0 }, { opacity: 1 }], {
                duration: ITEM_OPACITY_DURATION,
                delay: DELAY_BETWEEN_ITEMS * i,
            });
            // Make them all initially hidden and then clean up at the end of each
            // animation.
            child.classList.toggle('md-menu-hidden', true);
            animation.addEventListener('finish', () => {
                child.classList.toggle('md-menu-hidden', false);
            });
            childrenAnimations.push([child, animation]);
        }
        let resolveAnimation = (value) => { };
        const animationFinished = new Promise((resolve) => {
            resolveAnimation = resolve;
        });
        signal.addEventListener('abort', () => {
            surfaceHeightAnimation.cancel();
            upPositionCorrectionAnimation.cancel();
            surfaceOpacityAnimation.cancel();
            childrenAnimations.forEach(([child, animation]) => {
                child.classList.toggle('md-menu-hidden', false);
                animation.cancel();
            });
            resolveAnimation(true);
        });
        surfaceHeightAnimation.addEventListener('finish', () => {
            surfaceEl.classList.toggle('animating', false);
            this.openCloseAnimationSignal.finish();
            resolveAnimation(false);
        });
        return await animationFinished;
    }
    /**
     * Performs the closing animation:
     *
     * https://direct.googleplex.com/#/spec/295000003+271060003
     */
    animateClose() {
        let resolve;
        // This promise blocks the surface position controller from setting
        // display: none on the surface which will interfere with this animation.
        const animationEnded = new Promise((res) => {
            resolve = res;
        });
        const surfaceEl = this.surfaceEl;
        const slotEl = this.slotEl;
        if (!surfaceEl || !slotEl) {
            resolve(false);
            return animationEnded;
        }
        const openDirection = this.openDirection;
        const closingDownwards = openDirection === 'UP';
        this.dispatchEvent(new Event('closing'));
        // needs to be imperative because we don't want to mix animation and Lit
        // render timing
        surfaceEl.classList.toggle('animating', true);
        const signal = this.openCloseAnimationSignal.start();
        const height = surfaceEl.offsetHeight;
        const children = this.items;
        const FULL_DURATION = 150;
        const SURFACE_OPACITY_DURATION = 50;
        // The surface fades away at the very end
        const SURFACE_OPACITY_DELAY = FULL_DURATION - SURFACE_OPACITY_DURATION;
        const ITEM_OPACITY_DURATION = 50;
        const ITEM_OPACITY_INITIAL_DELAY = 50;
        const END_HEIGHT_PERCENTAGE = 0.35;
        // We want to fit every child fade-out animation within the full duration of
        // the animation.
        const DELAY_BETWEEN_ITEMS = (FULL_DURATION - ITEM_OPACITY_INITIAL_DELAY - ITEM_OPACITY_DURATION) /
            children.length;
        // The mock has the animation shrink to 35%
        const surfaceHeightAnimation = surfaceEl.animate([
            { height: `${height}px` },
            { height: `${height * END_HEIGHT_PERCENTAGE}px` },
        ], {
            duration: FULL_DURATION,
            easing: EASING.EMPHASIZED_ACCELERATE,
        });
        // When we are closing downwards, we want to make sure the last item is
        // always in view, so we need to translate it upwards the opposite direction
        // of the height animation
        const downPositionCorrectionAnimation = slotEl.animate([
            { transform: '' },
            {
                transform: closingDownwards
                    ? `translateY(-${height * (1 - END_HEIGHT_PERCENTAGE)}px)`
                    : '',
            },
        ], { duration: FULL_DURATION, easing: EASING.EMPHASIZED_ACCELERATE });
        const surfaceOpacityAnimation = surfaceEl.animate([{ opacity: 1 }, { opacity: 0 }], { duration: SURFACE_OPACITY_DURATION, delay: SURFACE_OPACITY_DELAY });
        const childrenAnimations = [];
        for (let i = 0; i < children.length; i++) {
            // If the animation is closing upwards, then reverse the list of
            // children so that we animate in the opposite direction.
            const directionalIndex = closingDownwards ? i : children.length - 1 - i;
            const child = children[directionalIndex];
            const animation = child.animate([{ opacity: 1 }, { opacity: 0 }], {
                duration: ITEM_OPACITY_DURATION,
                delay: ITEM_OPACITY_INITIAL_DELAY + DELAY_BETWEEN_ITEMS * i,
            });
            // Make sure the items stay hidden at the end of each child animation.
            // We clean this up at the end of the overall animation.
            animation.addEventListener('finish', () => {
                child.classList.toggle('md-menu-hidden', true);
            });
            childrenAnimations.push([child, animation]);
        }
        signal.addEventListener('abort', () => {
            surfaceHeightAnimation.cancel();
            downPositionCorrectionAnimation.cancel();
            surfaceOpacityAnimation.cancel();
            childrenAnimations.forEach(([child, animation]) => {
                animation.cancel();
                child.classList.toggle('md-menu-hidden', false);
            });
            resolve(false);
        });
        surfaceHeightAnimation.addEventListener('finish', () => {
            surfaceEl.classList.toggle('animating', false);
            childrenAnimations.forEach(([child]) => {
                child.classList.toggle('md-menu-hidden', false);
            });
            this.openCloseAnimationSignal.finish();
            this.dispatchEvent(new Event('closed'));
            resolve(true);
        });
        return animationEnded;
    }
    handleKeydown(event) {
        // At any key event, the pointer interaction is done so we need to clear our
        // cached pointerpath. This handles the case where the user clicks on the
        // anchor, and then hits shift+tab
        this.pointerPath = [];
        this.listController.handleKeydown(event);
    }
    setUpGlobalEventListeners() {
        document.addEventListener('click', this.onDocumentClick, { capture: true });
        window.addEventListener('pointerdown', this.onWindowPointerdown);
        document.addEventListener('resize', this.onWindowResize, { passive: true });
        window.addEventListener('resize', this.onWindowResize, { passive: true });
    }
    cleanUpGlobalEventListeners() {
        document.removeEventListener('click', this.onDocumentClick, {
            capture: true,
        });
        window.removeEventListener('pointerdown', this.onWindowPointerdown);
        document.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('resize', this.onWindowResize);
    }
    onCloseMenu() {
        this.close();
    }
    onDeactivateItems(event) {
        event.stopPropagation();
        this.listController.onDeactivateItems();
    }
    onRequestActivation(event) {
        event.stopPropagation();
        this.listController.onRequestActivation(event);
    }
    handleDeactivateTypeahead(event) {
        // stopPropagation so that this does not deactivate any typeaheads in menus
        // nested above it e.g. md-sub-menu
        event.stopPropagation();
        this.typeaheadActive = false;
    }
    handleActivateTypeahead(event) {
        // stopPropagation so that this does not activate any typeaheads in menus
        // nested above it e.g. md-sub-menu
        event.stopPropagation();
        this.typeaheadActive = true;
    }
    handleStayOpenOnFocusout(event) {
        event.stopPropagation();
        this.stayOpenOnFocusout = true;
    }
    handleCloseOnFocusout(event) {
        event.stopPropagation();
        this.stayOpenOnFocusout = false;
    }
    close() {
        this.open = false;
        const maybeSubmenu = this.slotItems;
        maybeSubmenu.forEach((item) => {
            item.close?.();
        });
    }
    show() {
        this.open = true;
    }
    /**
     * Activates the next item in the menu. If at the end of the menu, the first
     * item will be activated.
     *
     * @return The activated menu item or `null` if there are no items.
     */
    activateNextItem() {
        return this.listController.activateNextItem() ?? null;
    }
    /**
     * Activates the previous item in the menu. If at the start of the menu, the
     * last item will be activated.
     *
     * @return The activated menu item or `null` if there are no items.
     */
    activatePreviousItem() {
        return this.listController.activatePreviousItem() ?? null;
    }
    /**
     * Repositions the menu if it is open.
     *
     * Useful for the case where document or window-positioned menus have their
     * anchors moved while open.
     */
    reposition() {
        if (this.open) {
            this.menuPositionController.position();
        }
    }
}
__decorate([
    e$4('.menu')
], Menu.prototype, "surfaceEl", void 0);
__decorate([
    e$4('slot')
], Menu.prototype, "slotEl", void 0);
__decorate([
    n$3()
], Menu.prototype, "anchor", void 0);
__decorate([
    n$3()
], Menu.prototype, "positioning", void 0);
__decorate([
    n$3({ type: Boolean })
], Menu.prototype, "quick", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-overflow' })
], Menu.prototype, "hasOverflow", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], Menu.prototype, "open", void 0);
__decorate([
    n$3({ type: Number, attribute: 'x-offset' })
], Menu.prototype, "xOffset", void 0);
__decorate([
    n$3({ type: Number, attribute: 'y-offset' })
], Menu.prototype, "yOffset", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-horizontal-flip' })
], Menu.prototype, "noHorizontalFlip", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-vertical-flip' })
], Menu.prototype, "noVerticalFlip", void 0);
__decorate([
    n$3({ type: Number, attribute: 'typeahead-delay' })
], Menu.prototype, "typeaheadDelay", void 0);
__decorate([
    n$3({ attribute: 'anchor-corner' })
], Menu.prototype, "anchorCorner", void 0);
__decorate([
    n$3({ attribute: 'menu-corner' })
], Menu.prototype, "menuCorner", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'stay-open-on-outside-click' })
], Menu.prototype, "stayOpenOnOutsideClick", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'stay-open-on-focusout' })
], Menu.prototype, "stayOpenOnFocusout", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'skip-restore-focus' })
], Menu.prototype, "skipRestoreFocus", void 0);
__decorate([
    n$3({ attribute: 'default-focus' })
], Menu.prototype, "defaultFocus", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-navigation-wrap' })
], Menu.prototype, "noNavigationWrap", void 0);
__decorate([
    o$2({ flatten: true })
], Menu.prototype, "slotItems", void 0);
__decorate([
    r$2()
], Menu.prototype, "typeaheadActive", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./menu/internal/menu-styles.css.
const styles$s = i$7 `:host{--md-elevation-level: var(--md-menu-container-elevation, 2);--md-elevation-shadow-color: var(--md-menu-container-shadow-color, var(--md-sys-color-shadow, #000));min-width:112px;color:unset;display:contents}md-focus-ring{--md-focus-ring-shape: var(--md-menu-container-shape, var(--md-sys-shape-corner-extra-small, 4px))}.menu{border-radius:var(--md-menu-container-shape, var(--md-sys-shape-corner-extra-small, 4px));display:none;inset:auto;border:none;padding:0px;overflow:visible;background-color:rgba(0,0,0,0);color:inherit;opacity:0;z-index:20;position:absolute;user-select:none;max-height:inherit;height:inherit;min-width:inherit;max-width:inherit;scrollbar-width:inherit}.menu::backdrop{display:none}.fixed{position:fixed}.items{display:block;list-style-type:none;margin:0;outline:none;box-sizing:border-box;background-color:var(--md-menu-container-color, var(--md-sys-color-surface-container, #f3edf7));height:inherit;max-height:inherit;overflow:auto;min-width:inherit;max-width:inherit;border-radius:inherit;scrollbar-width:inherit}.item-padding{padding-block:var(--md-menu-top-space, 8px) var(--md-menu-bottom-space, 8px)}.has-overflow:not([popover]) .items{overflow:visible}.has-overflow.animating .items,.animating .items{overflow:hidden}.has-overflow.animating .items{pointer-events:none}.animating ::slotted(.md-menu-hidden){opacity:0}slot{display:block;height:inherit;max-height:inherit}::slotted(:is(md-divider,[role=separator])){margin:8px 0}@media(forced-colors: active){.menu{border-style:solid;border-color:CanvasText;border-width:1px}}
`;

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
class InternalMenu extends Menu {
}
InternalMenu.styles = [styles$s];
/**
 * @tagname oscd-menu
 * @summary Menus display a list of choices on a temporary surface.
 *
 * Menus appear when users interact with a button, action, or other control.
 *
 * They can be opened from a variety of elements, most commonly icon buttons,
 * buttons, and text fields.
 *
 * oscd-menu listens for the `close-menu` and `deselect-items` events.
 *
 * - `close-menu` closes the menu when dispatched from a child element.
 * - `deselect-items` deselects all of its immediate menu-item children.
 *
 * @example
 * ```html
 * <div style="position:relative;">
 *   <button
 *       id="anchor"
 *       @click=${() => this.menuRef.value.show()}>
 *     Click to open menu
 *   </button>
 *   <!--
 *     `has-overflow` is required when using a submenu which overflows the
 *     menu's contents.
 *
 *     Additionally, `anchor` ingests an idref which do not pass through shadow
 *     roots. You can also set `.anchorElement` to an element reference if
 *     necessary.
 *   -->
 *   <oscd-menu anchor="anchor" has-overflow ${ref(menuRef)}>
 *     <oscd-menu-item headline="This is a headline"></oscd-menu-item>
 *     <md-sub-menu>
 *       <oscd-menu-item
 *           slot="item"
 *           headline="this is a submenu item">
 *       </oscd-menu-item>
 *       <oscd-menu slot="menu">
 *         <oscd-menu-item headline="This is an item inside a submenu">
 *         </oscd-menu-item>
 *       </oscd-menu>
 *     </md-sub-menu>
 *   </oscd-menu>
 * </div>
 * ```
 *
 * @final
 * @suppress {visibility}
 */
class OscdMenu extends ScopedElementsMixin(InternalMenu) {
}
OscdMenu.scopedElements = {
    'md-focus-ring': OscdFocusRing,
    'md-elevation': OscdElevation,
};
OscdMenu.styles = [styles$s];

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const PRESS_GROW_MS = 450;
const MINIMUM_PRESS_MS = 225;
const INITIAL_ORIGIN_SCALE = 0.2;
const PADDING = 10;
const SOFT_EDGE_MINIMUM_SIZE = 75;
const SOFT_EDGE_CONTAINER_RATIO = 0.35;
const PRESS_PSEUDO = '::after';
const ANIMATION_FILL = 'forwards';
/**
 * Interaction states for the ripple.
 *
 * On Touch:
 *  - `INACTIVE -> TOUCH_DELAY -> WAITING_FOR_CLICK -> INACTIVE`
 *  - `INACTIVE -> TOUCH_DELAY -> HOLDING -> WAITING_FOR_CLICK -> INACTIVE`
 *
 * On Mouse or Pen:
 *   - `INACTIVE -> WAITING_FOR_CLICK -> INACTIVE`
 */
var State;
(function (State) {
    /**
     * Initial state of the control, no touch in progress.
     *
     * Transitions:
     *   - on touch down: transition to `TOUCH_DELAY`.
     *   - on mouse down: transition to `WAITING_FOR_CLICK`.
     */
    State[State["INACTIVE"] = 0] = "INACTIVE";
    /**
     * Touch down has been received, waiting to determine if it's a swipe or
     * scroll.
     *
     * Transitions:
     *   - on touch up: begin press; transition to `WAITING_FOR_CLICK`.
     *   - on cancel: transition to `INACTIVE`.
     *   - after `TOUCH_DELAY_MS`: begin press; transition to `HOLDING`.
     */
    State[State["TOUCH_DELAY"] = 1] = "TOUCH_DELAY";
    /**
     * A touch has been deemed to be a press
     *
     * Transitions:
     *  - on up: transition to `WAITING_FOR_CLICK`.
     */
    State[State["HOLDING"] = 2] = "HOLDING";
    /**
     * The user touch has finished, transition into rest state.
     *
     * Transitions:
     *   - on click end press; transition to `INACTIVE`.
     */
    State[State["WAITING_FOR_CLICK"] = 3] = "WAITING_FOR_CLICK";
})(State || (State = {}));
/**
 * Events that the ripple listens to.
 */
const EVENTS = [
    'click',
    'contextmenu',
    'pointercancel',
    'pointerdown',
    'pointerenter',
    'pointerleave',
    'pointerup',
];
/**
 * Delay reacting to touch so that we do not show the ripple for a swipe or
 * scroll interaction.
 */
const TOUCH_DELAY_MS = 150;
/**
 * Used to detect if HCM is active. Events do not process during HCM when the
 * ripple is not displayed.
 */
const FORCED_COLORS = window.matchMedia('(forced-colors: active)');
/**
 * A ripple component.
 */
class Ripple extends i$4 {
    constructor() {
        super(...arguments);
        /**
         * Disables the ripple.
         */
        this.disabled = false;
        this.hovered = false;
        this.pressed = false;
        this.rippleSize = '';
        this.rippleScale = '';
        this.initialSize = 0;
        this.state = State.INACTIVE;
        this.attachableController = new AttachableController(this, this.onControlChange.bind(this));
    }
    get htmlFor() {
        return this.attachableController.htmlFor;
    }
    set htmlFor(htmlFor) {
        this.attachableController.htmlFor = htmlFor;
    }
    get control() {
        return this.attachableController.control;
    }
    set control(control) {
        this.attachableController.control = control;
    }
    attach(control) {
        this.attachableController.attach(control);
    }
    detach() {
        this.attachableController.detach();
    }
    connectedCallback() {
        super.connectedCallback();
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        const classes = {
            'hovered': this.hovered,
            'pressed': this.pressed,
        };
        return b `<div class="surface ${e(classes)}"></div>`;
    }
    update(changedProps) {
        if (changedProps.has('disabled') && this.disabled) {
            this.hovered = false;
            this.pressed = false;
        }
        super.update(changedProps);
    }
    /**
     * TODO(b/269799771): make private
     * @private only public for slider
     */
    handlePointerenter(event) {
        if (!this.shouldReactToEvent(event)) {
            return;
        }
        this.hovered = true;
    }
    /**
     * TODO(b/269799771): make private
     * @private only public for slider
     */
    handlePointerleave(event) {
        if (!this.shouldReactToEvent(event)) {
            return;
        }
        this.hovered = false;
        // release a held mouse or pen press that moves outside the element
        if (this.state !== State.INACTIVE) {
            this.endPressAnimation();
        }
    }
    handlePointerup(event) {
        if (!this.shouldReactToEvent(event)) {
            return;
        }
        if (this.state === State.HOLDING) {
            this.state = State.WAITING_FOR_CLICK;
            return;
        }
        if (this.state === State.TOUCH_DELAY) {
            this.state = State.WAITING_FOR_CLICK;
            this.startPressAnimation(this.rippleStartEvent);
            return;
        }
    }
    async handlePointerdown(event) {
        if (!this.shouldReactToEvent(event)) {
            return;
        }
        this.rippleStartEvent = event;
        if (!this.isTouch(event)) {
            this.state = State.WAITING_FOR_CLICK;
            this.startPressAnimation(event);
            return;
        }
        // Wait for a hold after touch delay
        this.state = State.TOUCH_DELAY;
        await new Promise((resolve) => {
            setTimeout(resolve, TOUCH_DELAY_MS);
        });
        if (this.state !== State.TOUCH_DELAY) {
            return;
        }
        this.state = State.HOLDING;
        this.startPressAnimation(event);
    }
    handleClick() {
        // Click is a MouseEvent in Firefox and Safari, so we cannot use
        // `shouldReactToEvent`
        if (this.disabled) {
            return;
        }
        if (this.state === State.WAITING_FOR_CLICK) {
            this.endPressAnimation();
            return;
        }
        if (this.state === State.INACTIVE) {
            // keyboard synthesized click event
            this.startPressAnimation();
            this.endPressAnimation();
        }
    }
    handlePointercancel(event) {
        if (!this.shouldReactToEvent(event)) {
            return;
        }
        this.endPressAnimation();
    }
    handleContextmenu() {
        if (this.disabled) {
            return;
        }
        this.endPressAnimation();
    }
    determineRippleSize() {
        const { height, width } = this.getBoundingClientRect();
        const maxDim = Math.max(height, width);
        const softEdgeSize = Math.max(SOFT_EDGE_CONTAINER_RATIO * maxDim, SOFT_EDGE_MINIMUM_SIZE);
        // `?? 1` may be removed once `currentCSSZoom` is widely available.
        const zoom = this.currentCSSZoom ?? 1;
        const initialSize = Math.floor((maxDim * INITIAL_ORIGIN_SCALE) / zoom);
        const hypotenuse = Math.sqrt(width ** 2 + height ** 2);
        const maxRadius = hypotenuse + PADDING;
        this.initialSize = initialSize;
        // The dimensions may be altered by CSS `zoom`, which needs to be
        // compensated for in the final scale() value.
        const maybeZoomedScale = (maxRadius + softEdgeSize) / initialSize;
        this.rippleScale = `${maybeZoomedScale / zoom}`;
        this.rippleSize = `${initialSize}px`;
    }
    getNormalizedPointerEventCoords(pointerEvent) {
        const { scrollX, scrollY } = window;
        const { left, top } = this.getBoundingClientRect();
        const documentX = scrollX + left;
        const documentY = scrollY + top;
        const { pageX, pageY } = pointerEvent;
        // `?? 1` may be removed once `currentCSSZoom` is widely available.
        const zoom = this.currentCSSZoom ?? 1;
        return {
            x: (pageX - documentX) / zoom,
            y: (pageY - documentY) / zoom,
        };
    }
    getTranslationCoordinates(positionEvent) {
        const { height, width } = this.getBoundingClientRect();
        // `?? 1` may be removed once `currentCSSZoom` is widely available.
        const zoom = this.currentCSSZoom ?? 1;
        // end in the center
        const endPoint = {
            x: (width / zoom - this.initialSize) / 2,
            y: (height / zoom - this.initialSize) / 2,
        };
        let startPoint;
        if (positionEvent instanceof PointerEvent) {
            startPoint = this.getNormalizedPointerEventCoords(positionEvent);
        }
        else {
            startPoint = {
                x: width / zoom / 2,
                y: height / zoom / 2,
            };
        }
        // center around start point
        startPoint = {
            x: startPoint.x - this.initialSize / 2,
            y: startPoint.y - this.initialSize / 2,
        };
        return { startPoint, endPoint };
    }
    startPressAnimation(positionEvent) {
        if (!this.mdRoot) {
            return;
        }
        this.pressed = true;
        this.growAnimation?.cancel();
        this.determineRippleSize();
        const { startPoint, endPoint } = this.getTranslationCoordinates(positionEvent);
        const translateStart = `${startPoint.x}px, ${startPoint.y}px`;
        const translateEnd = `${endPoint.x}px, ${endPoint.y}px`;
        this.growAnimation = this.mdRoot.animate({
            top: [0, 0],
            left: [0, 0],
            height: [this.rippleSize, this.rippleSize],
            width: [this.rippleSize, this.rippleSize],
            transform: [
                `translate(${translateStart}) scale(1)`,
                `translate(${translateEnd}) scale(${this.rippleScale})`,
            ],
        }, {
            pseudoElement: PRESS_PSEUDO,
            duration: PRESS_GROW_MS,
            easing: EASING.STANDARD,
            fill: ANIMATION_FILL,
        });
    }
    async endPressAnimation() {
        this.rippleStartEvent = undefined;
        this.state = State.INACTIVE;
        const animation = this.growAnimation;
        let pressAnimationPlayState = Infinity;
        if (typeof animation?.currentTime === 'number') {
            pressAnimationPlayState = animation.currentTime;
        }
        else if (animation?.currentTime) {
            pressAnimationPlayState = animation.currentTime.to('ms').value;
        }
        if (pressAnimationPlayState >= MINIMUM_PRESS_MS) {
            this.pressed = false;
            return;
        }
        await new Promise((resolve) => {
            setTimeout(resolve, MINIMUM_PRESS_MS - pressAnimationPlayState);
        });
        if (this.growAnimation !== animation) {
            // A new press animation was started. The old animation was canceled and
            // should not finish the pressed state.
            return;
        }
        this.pressed = false;
    }
    /**
     * Returns `true` if
     *  - the ripple element is enabled
     *  - the pointer is primary for the input type
     *  - the pointer is the pointer that started the interaction, or will start
     * the interaction
     *  - the pointer is a touch, or the pointer state has the primary button
     * held, or the pointer is hovering
     */
    shouldReactToEvent(event) {
        if (this.disabled || !event.isPrimary) {
            return false;
        }
        if (this.rippleStartEvent &&
            this.rippleStartEvent.pointerId !== event.pointerId) {
            return false;
        }
        if (event.type === 'pointerenter' || event.type === 'pointerleave') {
            return !this.isTouch(event);
        }
        const isPrimaryButton = event.buttons === 1;
        return this.isTouch(event) || isPrimaryButton;
    }
    isTouch({ pointerType }) {
        return pointerType === 'touch';
    }
    /** @private */
    async handleEvent(event) {
        if (FORCED_COLORS?.matches) {
            // Skip event logic since the ripple is `display: none`.
            return;
        }
        switch (event.type) {
            case 'click':
                this.handleClick();
                break;
            case 'contextmenu':
                this.handleContextmenu();
                break;
            case 'pointercancel':
                this.handlePointercancel(event);
                break;
            case 'pointerdown':
                await this.handlePointerdown(event);
                break;
            case 'pointerenter':
                this.handlePointerenter(event);
                break;
            case 'pointerleave':
                this.handlePointerleave(event);
                break;
            case 'pointerup':
                this.handlePointerup(event);
                break;
        }
    }
    onControlChange(prev, next) {
        for (const event of EVENTS) {
            prev?.removeEventListener(event, this);
            next?.addEventListener(event, this);
        }
    }
}
__decorate([
    n$3({ type: Boolean, reflect: true })
], Ripple.prototype, "disabled", void 0);
__decorate([
    r$2()
], Ripple.prototype, "hovered", void 0);
__decorate([
    r$2()
], Ripple.prototype, "pressed", void 0);
__decorate([
    e$4('.surface')
], Ripple.prototype, "mdRoot", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./ripple/internal/ripple-styles.css.
const styles$r = i$7 `:host{display:flex;margin:auto;pointer-events:none}:host([disabled]){display:none}@media(forced-colors: active){:host{display:none}}:host,.surface{border-radius:inherit;position:absolute;inset:0;overflow:hidden}.surface{-webkit-tap-highlight-color:rgba(0,0,0,0)}.surface::before,.surface::after{content:"";opacity:0;position:absolute}.surface::before{background-color:var(--md-ripple-hover-color, var(--md-sys-color-on-surface, #1d1b20));inset:0;transition:opacity 15ms linear,background-color 15ms linear}.surface::after{background:radial-gradient(closest-side, var(--md-ripple-pressed-color, var(--md-sys-color-on-surface, #1d1b20)) max(100% - 70px, 65%), transparent 100%);transform-origin:center center;transition:opacity 375ms linear}.hovered::before{background-color:var(--md-ripple-hover-color, var(--md-sys-color-on-surface, #1d1b20));opacity:var(--md-ripple-hover-opacity, 0.08)}.pressed::after{opacity:var(--md-ripple-pressed-opacity, 0.12);transition-duration:105ms}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-ripple
 * @summary Ripples, also known as state layers, are visual indicators used to
 * communicate the status of a component or interactive element.
 *
 * indicates its state. State layers provide a systematic approach to
 * visualizing states by using opacity. A layer can be applied to an entire
 * element or in a circular shape and only one state layer can be applied at a
 * given time.
 *
 * @final
 * @suppress {visibility}
 */
class OscdRipple extends Ripple {
}
OscdRipple.styles = [styles$r];

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * An item layout component.
 */
class Item extends i$4 {
    constructor() {
        super(...arguments);
        /**
         * Only needed for SSR.
         *
         * Add this attribute when an item has two lines to avoid a Flash Of Unstyled
         * Content. This attribute is not needed for single line items or items with
         * three or more lines.
         */
        this.multiline = false;
    }
    render() {
        return b `
      <slot name="container"></slot>
      <slot class="non-text" name="start"></slot>
      <div class="text">
        <slot name="overline" @slotchange=${this.handleTextSlotChange}></slot>
        <slot
          class="default-slot"
          @slotchange=${this.handleTextSlotChange}></slot>
        <slot name="headline" @slotchange=${this.handleTextSlotChange}></slot>
        <slot
          name="supporting-text"
          @slotchange=${this.handleTextSlotChange}></slot>
      </div>
      <slot class="non-text" name="trailing-supporting-text"></slot>
      <slot class="non-text" name="end"></slot>
    `;
    }
    handleTextSlotChange() {
        // Check if there's more than one text slot with content. If so, the item is
        // multiline, which has a different min-height than single line items.
        let isMultiline = false;
        let slotsWithContent = 0;
        for (const slot of this.textSlots) {
            if (slotHasContent(slot)) {
                slotsWithContent += 1;
            }
            if (slotsWithContent > 1) {
                isMultiline = true;
                break;
            }
        }
        this.multiline = isMultiline;
    }
}
__decorate([
    n$3({ type: Boolean, reflect: true })
], Item.prototype, "multiline", void 0);
__decorate([
    r$1('.text slot')
], Item.prototype, "textSlots", void 0);
function slotHasContent(slot) {
    for (const node of slot.assignedNodes({ flatten: true })) {
        // Assume there's content if there's an element slotted in
        const isElement = node.nodeType === Node.ELEMENT_NODE;
        // If there's only text nodes for the default slot, check if there's
        // non-whitespace.
        const isTextWithContent = node.nodeType === Node.TEXT_NODE && node.textContent?.match(/\S/);
        if (isElement || isTextWithContent) {
            return true;
        }
    }
    return false;
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./labs/item/internal/item-styles.css.
const styles$q = i$7 `:host{color:var(--md-sys-color-on-surface, #1d1b20);font-family:var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-body-large-size, 1rem);font-weight:var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400));line-height:var(--md-sys-typescale-body-large-line-height, 1.5rem);align-items:center;box-sizing:border-box;display:flex;gap:16px;min-height:56px;overflow:hidden;padding:12px 16px;position:relative;text-overflow:ellipsis}:host([multiline]){min-height:72px}[name=overline]{color:var(--md-sys-color-on-surface-variant, #49454f);font-family:var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-label-small-size, 0.6875rem);font-weight:var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500));line-height:var(--md-sys-typescale-label-small-line-height, 1rem)}[name=supporting-text]{color:var(--md-sys-color-on-surface-variant, #49454f);font-family:var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-body-medium-size, 0.875rem);font-weight:var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400));line-height:var(--md-sys-typescale-body-medium-line-height, 1.25rem)}[name=trailing-supporting-text]{color:var(--md-sys-color-on-surface-variant, #49454f);font-family:var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-label-small-size, 0.6875rem);font-weight:var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500));line-height:var(--md-sys-typescale-label-small-line-height, 1rem)}[name=container]::slotted(*){inset:0;position:absolute}.default-slot{display:inline}.default-slot,.text ::slotted(*){overflow:hidden;text-overflow:ellipsis}.text{display:flex;flex:1;flex-direction:column;overflow:hidden}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-item
 * An item layout component that can be used inside list items to give them
 * their customizable structure.
 *
 * `<oscd-item>` does not have any functionality, which must be added by the
 * component using it.
 *
 * All text will wrap unless `white-space: nowrap` is set on the item or any of
 * its children.
 *
 * Slots available:
 * - `<default>`: The headline, or custom content.
 * - `headline`: The first line.
 * - `supporting-text`: Supporting text lines underneath the headline.
 * - `trailing-supporting-text`: A small text snippet at the end of the item.
 * - `start`: Any leading content, such as icons, avatars, or checkboxes.
 * - `end`: Any trailing content, such as icons and buttons.
 * - `container`: Background container content, intended for adding additional
 *     styles, such as ripples or focus rings.
 *
 * @example
 * ```html
 * <oscd-item>Single line</oscd-item>
 *
 * <oscd-item>
 *   <div class="custom-content">...</div>
 * </oscd-item>
 *
 * <!-- Classic 1 to 3+ line list items -->
 * <oscd-item>
 *   <md-icon slot="start">image</md-icon>
 *   <div slot="overline">Overline</div>
 *   <div slot="headline">Headline</div>
 *   <div="supporting-text">Supporting text</div>
 *   <div="trailing-supporting-text">Trailing</div>
 *   <md-icon slot="end">image</md-icon>
 * </oscd-item>
 * ```
 *
 * When wrapping `<oscd-item>`, forward the available slots to use the same slot
 * structure for the wrapping component (this is what `<md-list-item>` does).
 *
 * @example
 * ```html
 * <oscd-item>
 *   <slot></slot>
 *   <slot name="overline" slot="overline"></slot>
 *   <slot name="headline" slot="headline"></slot>
 *   <slot name="supporting-text" slot="supporting-text"></slot>
 *   <slot name="trailing-supporting-text"
 *       slot="trailing-supporting-text"></slot>
 *   <slot name="start" slot="start"></slot>
 *   <slot name="end" slot="end"></slot>
 * </oscd-item>
 * ```
 *
 * @final
 * @suppress {visibility}
 */
class OscdItem extends Item {
}
OscdItem.styles = [styles$q];

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const a=Symbol.for(""),o=t=>{if(t?.r===a)return t?._$litStatic$},i=(t,...r)=>({_$litStatic$:r.reduce((r,e,a)=>r+(t=>{if(void 0!==t._$litStatic$)return t._$litStatic$;throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`)})(e)+t[a+1],t[0]),r:a}),l$1=new Map,n=t=>(r,...e)=>{const a=e.length;let s,i;const n=[],u=[];let c,$=0,f=false;for(;$<a;){for(c=r[$];$<a&&void 0!==(i=e[$],s=o(i));)c+=s+r[++$],f=true;$!==a&&u.push(i),n.push(c),$++;}if($===a&&n.push(r[a]),f){const t=n.join("$$lit$$");void 0===(r=l$1.get(t))&&(n.raw=n,l$1.set(t,r=n)),e=u;}return t(r,...e)},u=n(b);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Accessibility Object Model reflective aria properties.
 */
const ARIA_PROPERTIES = [
    'role',
    'ariaAtomic',
    'ariaAutoComplete',
    'ariaBusy',
    'ariaChecked',
    'ariaColCount',
    'ariaColIndex',
    'ariaColSpan',
    'ariaCurrent',
    'ariaDisabled',
    'ariaExpanded',
    'ariaHasPopup',
    'ariaHidden',
    'ariaInvalid',
    'ariaKeyShortcuts',
    'ariaLabel',
    'ariaLevel',
    'ariaLive',
    'ariaModal',
    'ariaMultiLine',
    'ariaMultiSelectable',
    'ariaOrientation',
    'ariaPlaceholder',
    'ariaPosInSet',
    'ariaPressed',
    'ariaReadOnly',
    'ariaRequired',
    'ariaRoleDescription',
    'ariaRowCount',
    'ariaRowIndex',
    'ariaRowSpan',
    'ariaSelected',
    'ariaSetSize',
    'ariaSort',
    'ariaValueMax',
    'ariaValueMin',
    'ariaValueNow',
    'ariaValueText',
];
/**
 * Accessibility Object Model aria attributes.
 */
const ARIA_ATTRIBUTES = ARIA_PROPERTIES.map(ariaPropertyToAttribute);
/**
 * Checks if an attribute is one of the AOM aria attributes.
 *
 * @example
 * isAriaAttribute('aria-label'); // true
 *
 * @param attribute The attribute to check.
 * @return True if the attribute is an aria attribute, or false if not.
 */
function isAriaAttribute(attribute) {
    return ARIA_ATTRIBUTES.includes(attribute);
}
/**
 * Converts an AOM aria property into its corresponding attribute.
 *
 * @example
 * ariaPropertyToAttribute('ariaLabel'); // 'aria-label'
 *
 * @param property The aria property.
 * @return The aria attribute.
 */
function ariaPropertyToAttribute(property) {
    return property
        .replace('aria', 'aria-')
        // IDREF attributes also include an "Element" or "Elements" suffix
        .replace(/Elements?/g, '')
        .toLowerCase();
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Private symbols
const privateIgnoreAttributeChangesFor = Symbol('privateIgnoreAttributeChangesFor');
/**
 * Mixes in aria delegation for elements that delegate focus and aria to inner
 * shadow root elements.
 *
 * This mixin fixes invalid aria announcements with shadow roots, caused by
 * duplicate aria attributes on both the host and the inner shadow root element.
 *
 * Note: this mixin **does not yet support** ID reference attributes, such as
 * `aria-labelledby` or `aria-controls`.
 *
 * @example
 * ```ts
 * class MyButton extends mixinDelegatesAria(LitElement) {
 *   static shadowRootOptions = {mode: 'open', delegatesFocus: true};
 *
 *   render() {
 *     return html`
 *       <button aria-label=${this.ariaLabel || nothing}>
 *         <slot></slot>
 *       </button>
 *     `;
 *   }
 * }
 * ```
 * ```html
 * <my-button aria-label="Plus one">+1</my-button>
 * ```
 *
 * Use `ARIAMixinStrict` for lit analyzer strict types, such as the "role"
 * attribute.
 *
 * @example
 * ```ts
 * return html`
 *   <button role=${(this as ARIAMixinStrict).role || nothing}>
 *     <slot></slot>
 *   </button>
 * `;
 * ```
 *
 * In the future, updates to the Accessibility Object Model (AOM) will provide
 * built-in aria delegation features that will replace this mixin.
 *
 * @param base The class to mix functionality into.
 * @return The provided class with aria delegation mixed in.
 */
function mixinDelegatesAria(base) {
    var _a;
    class WithDelegatesAriaElement extends base {
        constructor() {
            super(...arguments);
            this[_a] = new Set();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (!isAriaAttribute(name)) {
                super.attributeChangedCallback(name, oldValue, newValue);
                return;
            }
            if (this[privateIgnoreAttributeChangesFor].has(name)) {
                return;
            }
            // Don't trigger another `attributeChangedCallback` once we remove the
            // aria attribute from the host. We check the explicit name of the
            // attribute to ignore since `attributeChangedCallback` can be called
            // multiple times out of an expected order when hydrating an element with
            // multiple attributes.
            this[privateIgnoreAttributeChangesFor].add(name);
            this.removeAttribute(name);
            this[privateIgnoreAttributeChangesFor].delete(name);
            const dataProperty = ariaAttributeToDataProperty(name);
            if (newValue === null) {
                delete this.dataset[dataProperty];
            }
            else {
                this.dataset[dataProperty] = newValue;
            }
            this.requestUpdate(ariaAttributeToDataProperty(name), oldValue);
        }
        getAttribute(name) {
            if (isAriaAttribute(name)) {
                return super.getAttribute(ariaAttributeToDataAttribute(name));
            }
            return super.getAttribute(name);
        }
        removeAttribute(name) {
            super.removeAttribute(name);
            if (isAriaAttribute(name)) {
                super.removeAttribute(ariaAttributeToDataAttribute(name));
                // Since `aria-*` attributes are already removed`, we need to request
                // an update because `attributeChangedCallback` will not be called.
                this.requestUpdate();
            }
        }
    }
    _a = privateIgnoreAttributeChangesFor;
    setupDelegatesAriaProperties(WithDelegatesAriaElement);
    return WithDelegatesAriaElement;
}
/**
 * Overrides the constructor's native `ARIAMixin` properties to ensure that
 * aria properties reflect the values that were shifted to a data attribute.
 *
 * @param ctor The `ReactiveElement` constructor to patch.
 */
function setupDelegatesAriaProperties(ctor) {
    for (const ariaProperty of ARIA_PROPERTIES) {
        // The casing between ariaProperty and the dataProperty may be different.
        // ex: aria-haspopup -> ariaHasPopup
        const ariaAttribute = ariaPropertyToAttribute(ariaProperty);
        // ex: aria-haspopup -> data-aria-haspopup
        const dataAttribute = ariaAttributeToDataAttribute(ariaAttribute);
        // ex: aria-haspopup -> dataset.ariaHaspopup
        const dataProperty = ariaAttributeToDataProperty(ariaAttribute);
        // Call `ReactiveElement.createProperty()` so that the `aria-*` and `data-*`
        // attributes are added to the `static observedAttributes` array. This
        // triggers `attributeChangedCallback` for the delegates aria mixin to
        // handle.
        ctor.createProperty(ariaProperty, {
            attribute: ariaAttribute,
            noAccessor: true,
        });
        ctor.createProperty(Symbol(dataAttribute), {
            attribute: dataAttribute,
            noAccessor: true,
        });
        // Re-define the `ARIAMixin` properties to handle data attribute shifting.
        // It is safe to use `Object.defineProperty` here because the properties
        // are native and not renamed.
        // tslint:disable-next-line:ban-unsafe-reflection
        Object.defineProperty(ctor.prototype, ariaProperty, {
            configurable: true,
            enumerable: true,
            get() {
                return this.dataset[dataProperty] ?? null;
            },
            set(value) {
                const prevValue = this.dataset[dataProperty] ?? null;
                if (value === prevValue) {
                    return;
                }
                if (value === null) {
                    delete this.dataset[dataProperty];
                }
                else {
                    this.dataset[dataProperty] = value;
                }
                this.requestUpdate(ariaProperty, prevValue);
            },
        });
    }
}
function ariaAttributeToDataAttribute(ariaAttribute) {
    // aria-haspopup -> data-aria-haspopup
    return `data-${ariaAttribute}`;
}
function ariaAttributeToDataProperty(ariaAttribute) {
    // aria-haspopup -> dataset.ariaHaspopup
    return ariaAttribute.replace(/-\w/, (dashLetter) => dashLetter[1].toUpperCase());
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A controller that provides most functionality of an element that implements
 * the MenuItem interface.
 */
class MenuItemController {
    /**
     * @param host The MenuItem in which to attach this controller to.
     * @param config The object that configures this controller's behavior.
     */
    constructor(host, config) {
        this.host = host;
        this.internalTypeaheadText = null;
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */
        this.onClick = () => {
            if (this.host.keepOpen)
                return;
            this.host.dispatchEvent(createDefaultCloseMenuEvent(this.host, {
                kind: CloseReason.CLICK_SELECTION,
            }));
        };
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */
        this.onKeydown = (event) => {
            // Check if the interactive element is an anchor tag. If so, click it.
            if (this.host.href && event.code === 'Enter') {
                const interactiveElement = this.getInteractiveElement();
                if (interactiveElement instanceof HTMLAnchorElement) {
                    interactiveElement.click();
                }
            }
            if (event.defaultPrevented)
                return;
            // If the host has keepOpen = true we should ignore clicks & Space/Enter,
            // however we always maintain the ability to close a menu with a explicit
            // `escape` keypress.
            const keyCode = event.code;
            if (this.host.keepOpen && keyCode !== 'Escape')
                return;
            if (isClosableKey(keyCode)) {
                event.preventDefault();
                this.host.dispatchEvent(createDefaultCloseMenuEvent(this.host, {
                    kind: CloseReason.KEYDOWN,
                    key: keyCode,
                }));
            }
        };
        this.getHeadlineElements = config.getHeadlineElements;
        this.getSupportingTextElements = config.getSupportingTextElements;
        this.getDefaultElements = config.getDefaultElements;
        this.getInteractiveElement = config.getInteractiveElement;
        this.host.addController(this);
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot, and if there are
     * no slotted elements into headline, then it checks the _default_ slot, and
     * then the `"supporting-text"` slot if nothing is in _default_.
     */
    get typeaheadText() {
        if (this.internalTypeaheadText !== null) {
            return this.internalTypeaheadText;
        }
        const headlineElements = this.getHeadlineElements();
        const textParts = [];
        headlineElements.forEach((headlineElement) => {
            if (headlineElement.textContent && headlineElement.textContent.trim()) {
                textParts.push(headlineElement.textContent.trim());
            }
        });
        // If there are no headline elements, check the default slot's text content
        if (textParts.length === 0) {
            this.getDefaultElements().forEach((defaultElement) => {
                if (defaultElement.textContent && defaultElement.textContent.trim()) {
                    textParts.push(defaultElement.textContent.trim());
                }
            });
        }
        // If there are no headline nor default slot elements, check the
        //supporting-text slot's text content
        if (textParts.length === 0) {
            this.getSupportingTextElements().forEach((supportingTextElement) => {
                if (supportingTextElement.textContent &&
                    supportingTextElement.textContent.trim()) {
                    textParts.push(supportingTextElement.textContent.trim());
                }
            });
        }
        return textParts.join(' ');
    }
    /**
     * The recommended tag name to render as the list item.
     */
    get tagName() {
        const type = this.host.type;
        switch (type) {
            case 'link':
                return 'a';
            case 'button':
                return 'button';
            default:
            case 'menuitem':
            case 'option':
                return 'li';
        }
    }
    /**
     * The recommended role of the menu item.
     */
    get role() {
        return this.host.type === 'option' ? 'option' : 'menuitem';
    }
    hostConnected() {
        this.host.toggleAttribute('md-menu-item', true);
    }
    hostUpdate() {
        if (this.host.href) {
            this.host.type = 'link';
        }
    }
    /**
     * Use to set the typeaheadText when it changes.
     */
    setTypeaheadText(text) {
        this.internalTypeaheadText = text;
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const menuItemBaseClass = mixinDelegatesAria(i$4);
/**
 * @fires close-menu {CustomEvent<{initiator: SelectOption, reason: Reason, itemPath: SelectOption[]}>}
 * Closes the encapsulating menu on closable interaction. --bubbles --composed
 */
class MenuItemEl extends menuItemBaseClass {
    constructor() {
        super(...arguments);
        /**
         * Disables the item and makes it non-selectable and non-interactive.
         */
        this.disabled = false;
        /**
         * Sets the behavior and role of the menu item, defaults to "menuitem".
         */
        this.type = 'menuitem';
        /**
         * Sets the underlying `HTMLAnchorElement`'s `href` resource attribute.
         */
        this.href = '';
        /**
         * Sets the underlying `HTMLAnchorElement`'s `target` attribute when `href` is
         * set.
         */
        this.target = '';
        /**
         * Keeps the menu open if clicked or keyboard selected.
         */
        this.keepOpen = false;
        /**
         * Sets the item in the selected visual state when a submenu is opened.
         */
        this.selected = false;
        this.menuItemController = new MenuItemController(this, {
            getHeadlineElements: () => {
                return this.headlineElements;
            },
            getSupportingTextElements: () => {
                return this.supportingTextElements;
            },
            getDefaultElements: () => {
                return this.defaultElements;
            },
            getInteractiveElement: () => this.listItemRoot,
        });
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot.
     */
    get typeaheadText() {
        return this.menuItemController.typeaheadText;
    }
    set typeaheadText(text) {
        this.menuItemController.setTypeaheadText(text);
    }
    render() {
        return this.renderListItem(b `
      <md-item>
        <div slot="container">
          ${this.renderRipple()} ${this.renderFocusRing()}
        </div>
        <slot name="start" slot="start"></slot>
        <slot name="end" slot="end"></slot>
        ${this.renderBody()}
      </md-item>
    `);
    }
    /**
     * Renders the root list item.
     *
     * @param content the child content of the list item.
     */
    renderListItem(content) {
        const isAnchor = this.type === 'link';
        let tag;
        switch (this.menuItemController.tagName) {
            case 'a':
                tag = i `a`;
                break;
            case 'button':
                tag = i `button`;
                break;
            default:
            case 'li':
                tag = i `li`;
                break;
        }
        // TODO(b/265339866): announce "button"/"link" inside of a list item. Until
        // then all are "menuitem" roles for correct announcement.
        const target = isAnchor && !!this.target ? this.target : A;
        return u `
      <${tag}
        id="item"
        tabindex=${this.disabled && !isAnchor ? -1 : 0}
        role=${this.menuItemController.role}
        aria-label=${this.ariaLabel || A}
        aria-selected=${this.ariaSelected || A}
        aria-checked=${this.ariaChecked || A}
        aria-expanded=${this.ariaExpanded || A}
        aria-haspopup=${this.ariaHasPopup || A}
        class="list-item ${e(this.getRenderClasses())}"
        href=${this.href || A}
        target=${target}
        @click=${this.menuItemController.onClick}
        @keydown=${this.menuItemController.onKeydown}
      >${content}</${tag}>
    `;
    }
    /**
     * Handles rendering of the ripple element.
     */
    renderRipple() {
        return b ` <md-ripple
      part="ripple"
      for="item"
      ?disabled=${this.disabled}></md-ripple>`;
    }
    /**
     * Handles rendering of the focus ring.
     */
    renderFocusRing() {
        return b ` <md-focus-ring
      part="focus-ring"
      for="item"
      inward></md-focus-ring>`;
    }
    /**
     * Classes applied to the list item root.
     */
    getRenderClasses() {
        return {
            'disabled': this.disabled,
            'selected': this.selected,
        };
    }
    /**
     * Handles rendering the headline and supporting text.
     */
    renderBody() {
        return b `
      <slot></slot>
      <slot name="overline" slot="overline"></slot>
      <slot name="headline" slot="headline"></slot>
      <slot name="supporting-text" slot="supporting-text"></slot>
      <slot
        name="trailing-supporting-text"
        slot="trailing-supporting-text"></slot>
    `;
    }
    focus() {
        // TODO(b/300334509): needed for some cases where delegatesFocus doesn't
        // work programmatically like in FF and select-option
        this.listItemRoot?.focus();
    }
}
/** @nocollapse */
MenuItemEl.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, reflect: true })
], MenuItemEl.prototype, "disabled", void 0);
__decorate([
    n$3()
], MenuItemEl.prototype, "type", void 0);
__decorate([
    n$3()
], MenuItemEl.prototype, "href", void 0);
__decorate([
    n$3()
], MenuItemEl.prototype, "target", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'keep-open' })
], MenuItemEl.prototype, "keepOpen", void 0);
__decorate([
    n$3({ type: Boolean })
], MenuItemEl.prototype, "selected", void 0);
__decorate([
    e$4('.list-item')
], MenuItemEl.prototype, "listItemRoot", void 0);
__decorate([
    o$2({ slot: 'headline' })
], MenuItemEl.prototype, "headlineElements", void 0);
__decorate([
    o$2({ slot: 'supporting-text' })
], MenuItemEl.prototype, "supportingTextElements", void 0);
__decorate([
    n$2({ slot: '' })
], MenuItemEl.prototype, "defaultElements", void 0);
__decorate([
    n$3({ attribute: 'typeahead-text' })
], MenuItemEl.prototype, "typeaheadText", null);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./menu/internal/menuitem/menu-item-styles.css.
const styles$p = i$7 `:host{display:flex;--md-ripple-hover-color: var(--md-menu-item-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-hover-opacity: var(--md-menu-item-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-menu-item-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-pressed-opacity: var(--md-menu-item-pressed-state-layer-opacity, 0.12)}:host([disabled]){opacity:var(--md-menu-item-disabled-opacity, 0.3);pointer-events:none}md-focus-ring{z-index:1;--md-focus-ring-shape: 8px}a,button,li{background:none;border:none;padding:0;margin:0;text-align:unset;text-decoration:none}.list-item{border-radius:inherit;display:flex;flex:1;max-width:inherit;min-width:inherit;outline:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.list-item:not(.disabled){cursor:pointer}[slot=container]{pointer-events:none}md-ripple{border-radius:inherit}md-item{border-radius:inherit;flex:1;color:var(--md-menu-item-label-text-color, var(--md-sys-color-on-surface, #1d1b20));font-family:var(--md-menu-item-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-menu-item-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));line-height:var(--md-menu-item-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));font-weight:var(--md-menu-item-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));min-height:var(--md-menu-item-one-line-container-height, 56px);padding-top:var(--md-menu-item-top-space, 12px);padding-bottom:var(--md-menu-item-bottom-space, 12px);padding-inline-start:var(--md-menu-item-leading-space, 16px);padding-inline-end:var(--md-menu-item-trailing-space, 16px)}md-item[multiline]{min-height:var(--md-menu-item-two-line-container-height, 72px)}[slot=supporting-text]{color:var(--md-menu-item-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-menu-item-supporting-text-font, var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-menu-item-supporting-text-size, var(--md-sys-typescale-body-medium-size, 0.875rem));line-height:var(--md-menu-item-supporting-text-line-height, var(--md-sys-typescale-body-medium-line-height, 1.25rem));font-weight:var(--md-menu-item-supporting-text-weight, var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400)))}[slot=trailing-supporting-text]{color:var(--md-menu-item-trailing-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-menu-item-trailing-supporting-text-font, var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-menu-item-trailing-supporting-text-size, var(--md-sys-typescale-label-small-size, 0.6875rem));line-height:var(--md-menu-item-trailing-supporting-text-line-height, var(--md-sys-typescale-label-small-line-height, 1rem));font-weight:var(--md-menu-item-trailing-supporting-text-weight, var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500)))}:is([slot=start],[slot=end])::slotted(*){fill:currentColor}[slot=start]{color:var(--md-menu-item-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f))}[slot=end]{color:var(--md-menu-item-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f))}.list-item{background-color:var(--md-menu-item-container-color, transparent)}.list-item.selected{background-color:var(--md-menu-item-selected-container-color, var(--md-sys-color-secondary-container, #e8def8))}.selected:not(.disabled) ::slotted(*){color:var(--md-menu-item-selected-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b))}@media(forced-colors: active){:host([disabled]),:host([disabled]) slot{color:GrayText;opacity:1}.list-item{position:relative}.list-item.selected::before{content:"";position:absolute;inset:0;box-sizing:border-box;border-radius:inherit;pointer-events:none;border:3px double CanvasText}}
`;

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-menu-item
 * @summary Menus display a list of choices on a temporary surface.
 *
 * Menu items are the selectable choices within the menu. Menu items must
 * implement the `MenuItem` interface and also have the `oscd-menu-item`
 * attribute. Additionally menu items are list items so they must also have the
 * `md-list-item` attribute.
 *
 * Menu items can control a menu by selectively firing the `close-menu` and
 * `deselect-items` events.
 *
 * @final
 * @suppress {visibility}
 */
class OscdMenuItem extends ScopedElementsMixin(MenuItemEl) {
}
OscdMenuItem.scopedElements = {
    'md-ripple': OscdRipple,
    'md-item': OscdItem,
    'md-focus-ring': OscdFocusRing,
};
OscdMenuItem.styles = [styles$p];

/** Distance from a point to a polyline. */
function distanceToPolyline([px, py], points) {
    if (points.length === 0) {
        return Infinity;
    }
    let best = Infinity;
    for (let i = 0; i < Math.max(1, points.length - 1); i += 1) {
        const [ax, ay] = points[i];
        const [bx, by] = points[Math.min(i + 1, points.length - 1)];
        const dx = bx - ax;
        const dy = by - ay;
        const length = dx * dx + dy * dy;
        const t = length === 0
            ? 0
            : Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / length));
        best = Math.min(best, Math.hypot(px - (ax + t * dx), py - (ay + t * dy)));
    }
    return best;
}
/**
 * Ids of the routes passing within `tolerance` of a point, nearest first.
 * Used to pick lines drawn close together, where the pointer may be over
 * several of them at once.
 */
function pickRoutes(routes, point, tolerance) {
    return routes
        .map(({ id, points }) => ({ id, distance: distanceToPolyline(point, points) }))
        .filter(({ distance }) => distance <= tolerance)
        .sort((a, b) => a.distance - b.distance)
        .map(({ id }) => id);
}

const serviceClass = {
    GOOSE: 'goose',
    SV: 'sv',
    Report: 'report',
};
/** Space (px) between an IED symbol and its selection box. */
const iedPadding = 2.5;
/** How close (px) the pointer must be to a line to pick it. */
const pickTolerance = 6;
/**
 * SVG overlay drawn on top of an `sld-substation-viewer`, sharing its
 * coordinate system: one user unit per grid cell, `gridSize` pixels each.
 *
 * Draws the routed connections and a focusable hit target for every placed
 * IED. Only connection lines and IED targets take pointer events, so the
 * diagram underneath stays visible.
 *
 * Lines are picked by distance: the line nearest the pointer is drawn
 * thicker in the highlight colour, and a click hitting several lines drawn
 * close together opens a menu listing them.
 *
 * @fires map-ied-select - an IED was activated (click, Enter or Space)
 * @fires map-connection-select - a connection was picked
 */
class MapConnectionLayer extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        /** Diagram size in grid cells. */
        this.dimensions = [0, 0];
        this.gridSize = 32;
        this.connections = [];
        this.ieds = [];
        /** Time (ms) a line stays highlighted after the pointer left it. */
        this.hoverDelay = 250;
    }
    serviceOf(id) {
        return this.connections.find(shape => shape.id === id)?.service ?? 'GOOSE';
    }
    handleIedKeydown(event, name) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.selectIed(name);
        }
    }
    selectIed(name) {
        this.dispatchEvent(new CustomEvent('map-ied-select', {
            detail: { name },
            bubbles: true,
            composed: true,
        }));
    }
    selectConnection(id) {
        this.choices = undefined;
        this.preview = undefined;
        this.dispatchEvent(new CustomEvent('map-connection-select', {
            detail: { id },
            bubbles: true,
            composed: true,
        }));
    }
    /** Pointer position in grid units and in px within the layer. */
    locate(event) {
        const bounds = this.renderRoot.querySelector('svg').getBoundingClientRect();
        const x = event.clientX - bounds.left;
        const y = event.clientY - bounds.top;
        return { at: [x / this.gridSize, y / this.gridSize], px: [x, y] };
    }
    /** Shapes within reach of the pointer, nearest first. */
    pick(event) {
        const { at, px } = this.locate(event);
        return {
            ids: pickRoutes(this.connections, at, pickTolerance / this.gridSize),
            px,
        };
    }
    /**
     * Highlights a line at once; un-highlights only after `hoverDelay`, so
     * moving the pointer across the gaps between lines does not make the
     * other lines flash back in.
     */
    hover(id) {
        clearTimeout(this.unhoverTimer);
        this.unhoverTimer = undefined;
        if (id !== undefined || this.hoverDelay <= 0) {
            this.hovered = id;
            return;
        }
        this.unhoverTimer = setTimeout(() => {
            this.unhoverTimer = undefined;
            this.hovered = undefined;
        }, this.hoverDelay);
    }
    disconnectedCallback() {
        clearTimeout(this.unhoverTimer);
        super.disconnectedCallback();
    }
    handlePointerMove(event) {
        const line = event.target.closest?.('.connection');
        if (!line) {
            this.hover(undefined);
            return;
        }
        const [nearest] = this.pick(event).ids;
        this.hover(nearest ?? line.getAttribute('data-id') ?? undefined);
    }
    handleClick(event) {
        if (!event.target.closest?.('.connection')) {
            return;
        }
        const { ids, px } = this.pick(event);
        const fallback = event.target
            .closest('.connection')
            .getAttribute('data-id');
        const connections = ids.length > 0 ? ids : [fallback];
        if (connections.length === 1) {
            this.selectConnection(connections[0]);
            return;
        }
        this.choices = { x: px[0], y: px[1], ids: connections };
    }
    closeChoices() {
        this.choices = undefined;
        this.preview = undefined;
    }
    handleEscape(event) {
        if (event.key === 'Escape' && this.choices) {
            event.stopPropagation();
            this.closeChoices();
        }
    }
    /** A connection was picked in the chooser, by click or keyboard. */
    handleChoice(event) {
        const id = event.detail.initiator?.dataset.id;
        if (id) {
            this.selectConnection(id);
        }
    }
    renderConnection(connection) {
        const { id, service, path, arrow } = connection;
        const hovered = this.hovered === id && !this.choices;
        const title = hovered && this.describe
            ? w `<title>${this.describe(id)}</title>`
            : A;
        const previewed = this.preview === id;
        return w `<g
      class=${e({
            connection: true,
            [serviceClass[service]]: true,
            hovered,
            selected: this.selectedConnection === id,
            previewed,
        })}
      data-id=${id}
    >
      ${title}
      <path class="hit" d=${path} />
      <path class="casing" d=${path} />
      <path class="line" d=${path} />
      <path class="arrow" d=${arrow} />
    </g>`;
    }
    renderIed({ name, position: [x, y] }) {
        const selected = this.selectedIed === name;
        // A little room around the symbol, the same on screen at any zoom.
        const pad = iedPadding / this.gridSize;
        return w `<rect
      class=${e({ ied: true, selected, flash: this.flashIed === name })}
      data-name=${name}
      x=${x - pad}
      y=${y - pad}
      width=${1 + 2 * pad}
      height=${1 + 2 * pad}
      rx=${0.1 + pad}
      tabindex="0"
      role="button"
      aria-label=${msg(str `IED ${name}`)}
      aria-pressed=${selected ? 'true' : 'false'}
      @click=${() => this.selectIed(name)}
      @keydown=${(event) => this.handleIedKeydown(event, name)}
    />`;
    }
    renderChooser() {
        const { choices } = this;
        if (!choices) {
            return A;
        }
        return b `<span
        id="chooser-anchor"
        style="left: ${choices.x}px; top: ${choices.y}px"
      ></span>
      <oscd-menu
        class="chooser"
        anchor="chooser-anchor"
        positioning="popover"
        default-focus="first-item"
        skip-restore-focus
        aria-label=${msg('Connections here')}
        .open=${true}
        @close-menu=${this.handleChoice}
        @closed=${this.closeChoices}
        @pointerdown=${(event) => event.stopPropagation()}
        @wheel=${(event) => event.stopPropagation()}
      >
        <div class="chooser-title">
          ${msg(str `${choices.ids.length} connections here`)}
        </div>
        ${choices.ids.map(id => b `<oscd-menu-item
            class="choice ${serviceClass[this.serviceOf(id)]}"
            data-id=${id}
            @pointerenter=${() => {
            this.preview = id;
        }}
            @focusin=${() => {
            this.preview = id;
        }}
          >
            <span slot="start" class="swatch"></span>
            <div slot="headline">${this.label?.(id) ?? id}</div>
          </oscd-menu-item>`)}
      </oscd-menu>`;
    }
    render() {
        const [w, h] = this.dimensions;
        return b `<svg
        viewBox="0 0 ${w} ${h}"
        width=${w * this.gridSize}
        height=${h * this.gridSize}
        fill="none"
        @pointermove=${this.handlePointerMove}
        @pointerleave=${() => this.hover(undefined)}
        @click=${this.handleClick}
        @keydown=${this.handleEscape}
      >
        ${this.ieds.map(ied => this.renderIed(ied))}
        ${this.connections.map(connection => this.renderConnection(connection))}
      </svg>
      ${this.renderChooser()}`;
    }
}
MapConnectionLayer.scopedElements = {
    'oscd-menu': OscdMenu,
    'oscd-menu-item': OscdMenuItem,
};
MapConnectionLayer.styles = i$7 `
    :host {
      display: block;
      pointer-events: none;
    }

    svg {
      display: block;
    }

    .ied {
      fill: transparent;
      pointer-events: all;
      cursor: pointer;
      outline: none;
    }

    .ied:focus-visible {
      stroke: var(--oscd-primary);
      stroke-width: 0.06;
    }

    .ied.selected {
      fill: var(--oscd-map-highlight-color);
      fill-opacity: 0.25;
      stroke: var(--oscd-map-highlight-color);
      stroke-width: 0.08;
    }

    /* A located IED pulses a few times. */
    .ied.flash {
      stroke: var(--oscd-map-highlight-color);
      animation: pulse 0.8s ease-in-out 3;
    }

    @keyframes pulse {
      0%,
      100% {
        stroke-width: 0.04;
        stroke-opacity: 0.3;
      }
      50% {
        stroke-width: 0.25;
        stroke-opacity: 1;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .ied.flash {
        animation: none;
        stroke-width: 0.12;
      }
    }

    .connection {
      cursor: pointer;
    }

    .goose {
      --oscd-map-connection-color: var(--oscd-map-goose-color);
    }

    .sv {
      --oscd-map-connection-color: var(--oscd-map-sv-color);
    }

    .report {
      --oscd-map-connection-color: var(--oscd-map-report-color);
    }

    .hit {
      stroke: transparent;
      stroke-width: 0.3;
      pointer-events: stroke;
    }

    /*
     * A background coloured band under each line: where lines cross, the
     * line drawn later interrupts the earlier one, so both stay readable.
     */
    .casing {
      stroke: var(--oscd-base3);
      stroke-width: 0.14;
      stroke-opacity: 0.9;
      pointer-events: none;
    }

    .line {
      stroke: var(--oscd-map-connection-color);
      stroke-width: 0.06;
      pointer-events: none;
    }

    .arrow {
      fill: var(--oscd-map-connection-color);
      stroke: var(--oscd-map-connection-color);
      stroke-width: 0.04;
      pointer-events: none;
    }

    .connection.hovered .line,
    .connection.selected .line,
    .connection.previewed .line {
      stroke: var(--oscd-map-highlight-color);
      stroke-width: 0.14;
    }

    .connection.hovered .arrow,
    .connection.selected .arrow,
    .connection.previewed .arrow {
      fill: var(--oscd-map-highlight-color);
      stroke: var(--oscd-map-highlight-color);
    }

    /*
     * The layer lets pointer events through to the diagram; the menu must
     * take them again to be clicked (and must not start a pan).
     */
    .chooser {
      pointer-events: auto;
      cursor: default;
    }

    #chooser-anchor {
      position: absolute;
      width: 1px;
      height: 1px;
      pointer-events: none;
    }

    .chooser-title {
      padding: 6px 16px;
      color: var(--oscd-base01);
      font-size: 0.85em;
    }

    .swatch {
      flex: none;
      width: 16px;
      height: 4px;
      border-radius: 2px;
      background: var(--oscd-map-connection-color);
    }
  `;
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "dimensions", void 0);
__decorate([
    n$3({ type: Number })
], MapConnectionLayer.prototype, "gridSize", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "connections", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "ieds", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "selectedIed", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "selectedConnection", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "flashIed", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "describe", void 0);
__decorate([
    n$3({ type: Number })
], MapConnectionLayer.prototype, "hoverDelay", void 0);
__decorate([
    n$3({ attribute: false })
], MapConnectionLayer.prototype, "label", void 0);
__decorate([
    r$2()
], MapConnectionLayer.prototype, "hovered", void 0);
__decorate([
    r$2()
], MapConnectionLayer.prototype, "choices", void 0);
__decorate([
    r$2()
], MapConnectionLayer.prototype, "preview", void 0);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const chipBaseClass = mixinDelegatesAria(i$4);
/**
 * A chip component.
 *
 * @fires update-focus {Event} Dispatched when `disabled` is toggled. --bubbles
 */
class Chip extends chipBaseClass {
    /**
     * Whether or not the primary ripple is disabled (defaults to `disabled`).
     * Some chip actions such as links cannot be disabled.
     */
    get rippleDisabled() {
        return this.disabled || this.softDisabled;
    }
    constructor() {
        super();
        /**
         * Whether or not the chip is disabled.
         *
         * Disabled chips are not focusable, unless `always-focusable` is set.
         */
        this.disabled = false;
        /**
         * Whether or not the chip is "soft-disabled" (disabled but still
         * focusable).
         *
         * Use this when a chip needs increased visibility when disabled. See
         * https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_disabled_controls
         * for more guidance on when this is needed.
         */
        this.softDisabled = false;
        /**
         * When true, allow disabled chips to be focused with arrow keys.
         *
         * Add this when a chip needs increased visibility when disabled. See
         * https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_disabled_controls
         * for more guidance on when this is needed.
         *
         * @deprecated Use `softDisabled` instead of `alwaysFocusable` + `disabled`.
         */
        this.alwaysFocusable = false;
        // TODO(b/350810013): remove the label property.
        /**
         * The label of the chip.
         *
         * @deprecated Set text as content of the chip instead.
         */
        this.label = '';
        /**
         * Only needed for SSR.
         *
         * Add this attribute when a chip has a `slot="icon"` to avoid a Flash Of
         * Unstyled Content.
         */
        this.hasIcon = false;
        {
            this.addEventListener('click', this.handleClick.bind(this));
        }
    }
    focus(options) {
        if (this.disabled && !this.alwaysFocusable) {
            return;
        }
        super.focus(options);
    }
    render() {
        return b `
      <div class="container ${e(this.getContainerClasses())}">
        ${this.renderContainerContent()}
      </div>
    `;
    }
    updated(changed) {
        if (changed.has('disabled') && changed.get('disabled') !== undefined) {
            this.dispatchEvent(new Event('update-focus', { bubbles: true }));
        }
    }
    getContainerClasses() {
        return {
            'disabled': this.disabled || this.softDisabled,
            'has-icon': this.hasIcon,
        };
    }
    renderContainerContent() {
        return b `
      ${this.renderOutline()}
      <md-focus-ring part="focus-ring" for=${this.primaryId}></md-focus-ring>
      <md-ripple
        for=${this.primaryId}
        ?disabled=${this.rippleDisabled}></md-ripple>
      ${this.renderPrimaryAction(this.renderPrimaryContent())}
    `;
    }
    renderOutline() {
        return b `<span class="outline"></span>`;
    }
    renderLeadingIcon() {
        return b `<slot name="icon" @slotchange=${this.handleIconChange}></slot>`;
    }
    renderPrimaryContent() {
        return b `
      <span class="leading icon" aria-hidden="true">
        ${this.renderLeadingIcon()}
      </span>
      <span class="label">
        <span class="label-text" id="label">
          ${this.label ? this.label : b `<slot></slot>`}
        </span>
      </span>
      <span class="touch"></span>
    `;
    }
    handleIconChange(event) {
        const slot = event.target;
        this.hasIcon = slot.assignedElements({ flatten: true }).length > 0;
    }
    handleClick(event) {
        // If the chip is soft-disabled or disabled + always-focusable, we need to
        // explicitly prevent the click from propagating to other event listeners
        // as well as prevent the default action.
        if (this.softDisabled || (this.disabled && this.alwaysFocusable)) {
            event.stopImmediatePropagation();
            event.preventDefault();
            return;
        }
    }
}
/** @nocollapse */
Chip.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, reflect: true })
], Chip.prototype, "disabled", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'soft-disabled', reflect: true })
], Chip.prototype, "softDisabled", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'always-focusable' })
], Chip.prototype, "alwaysFocusable", void 0);
__decorate([
    n$3()
], Chip.prototype, "label", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true, attribute: 'has-icon' })
], Chip.prototype, "hasIcon", void 0);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A chip set component.
 */
class ChipSet extends i$4 {
    get chips() {
        return this.childElements.filter((child) => child instanceof Chip);
    }
    constructor() {
        super();
        this.internals = 
        // Cast needed for closure
        this.attachInternals();
        {
            this.addEventListener('focusin', this.updateTabIndices.bind(this));
            this.addEventListener('update-focus', this.updateTabIndices.bind(this));
            this.addEventListener('keydown', this.handleKeyDown.bind(this));
            this.internals.role = 'toolbar';
        }
    }
    render() {
        return b `<slot @slotchange=${this.updateTabIndices}></slot>`;
    }
    handleKeyDown(event) {
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        const isHome = event.key === 'Home';
        const isEnd = event.key === 'End';
        // Ignore non-navigation keys
        if (!isLeft && !isRight && !isHome && !isEnd) {
            return;
        }
        const { chips } = this;
        // Don't try to select another chip if there aren't any.
        if (chips.length < 2) {
            return;
        }
        // Prevent default interactions, such as scrolling.
        event.preventDefault();
        if (isHome || isEnd) {
            const index = isHome ? 0 : chips.length - 1;
            chips[index].focus({ trailing: isEnd });
            this.updateTabIndices();
            return;
        }
        // Check if moving forwards or backwards
        const isRtl = getComputedStyle(this).direction === 'rtl';
        const forwards = isRtl ? isLeft : isRight;
        const focusedChip = chips.find((chip) => chip.matches(':focus-within'));
        if (!focusedChip) {
            // If there is not already a chip focused, select the first or last chip
            // based on the direction we're traveling.
            const nextChip = forwards ? chips[0] : chips[chips.length - 1];
            nextChip.focus({ trailing: !forwards });
            this.updateTabIndices();
            return;
        }
        const currentIndex = chips.indexOf(focusedChip);
        let nextIndex = forwards ? currentIndex + 1 : currentIndex - 1;
        // Search for the next sibling that is not disabled to select.
        // If we return to the host index, there is nothing to select.
        while (nextIndex !== currentIndex) {
            if (nextIndex >= chips.length) {
                // Return to start if moving past the last item.
                nextIndex = 0;
            }
            else if (nextIndex < 0) {
                // Go to end if moving before the first item.
                nextIndex = chips.length - 1;
            }
            // Check if the next sibling is disabled. If so,
            // move the index and continue searching.
            //
            // Some toolbar items may be focusable when disabled for increased
            // visibility.
            const nextChip = chips[nextIndex];
            if (nextChip.disabled && !nextChip.alwaysFocusable) {
                if (forwards) {
                    nextIndex++;
                }
                else {
                    nextIndex--;
                }
                continue;
            }
            nextChip.focus({ trailing: !forwards });
            this.updateTabIndices();
            break;
        }
    }
    updateTabIndices() {
        // The chip that should be focusable is either the chip that currently has
        // focus or the first chip that can be focused.
        const { chips } = this;
        let chipToFocus;
        for (const chip of chips) {
            const isChipFocusable = chip.alwaysFocusable || !chip.disabled;
            const chipIsFocused = chip.matches(':focus-within');
            if (chipIsFocused && isChipFocusable) {
                // Found the first chip that is actively focused. This overrides the
                // first focusable chip found.
                chipToFocus = chip;
                continue;
            }
            if (isChipFocusable && !chipToFocus) {
                chipToFocus = chip;
            }
            // Disable non-focused chips. If we disable all of them, we'll grant focus
            // to the first focusable child that was found.
            chip.tabIndex = -1;
        }
        if (chipToFocus) {
            chipToFocus.tabIndex = 0;
        }
    }
}
__decorate([
    o$2()
], ChipSet.prototype, "childElements", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/chip-set-styles.css.
const styles$o = i$7 `:host{display:flex;flex-wrap:wrap;gap:8px}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-chip-set
 * TODO(b/243982145): add docs
 *
 * @final
 * @suppress {visibility}
 */
class OscdChipSet extends ChipSet {
}
OscdChipSet.styles = [styles$o];

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/elevated-styles.css.
const styles$n = i$7 `.elevated{--md-elevation-level: var(--_elevated-container-elevation);--md-elevation-shadow-color: var(--_elevated-container-shadow-color)}.elevated::before{background:var(--_elevated-container-color)}.elevated:hover{--md-elevation-level: var(--_elevated-hover-container-elevation)}.elevated:focus-within{--md-elevation-level: var(--_elevated-focus-container-elevation)}.elevated:active{--md-elevation-level: var(--_elevated-pressed-container-elevation)}.elevated.disabled{--md-elevation-level: var(--_elevated-disabled-container-elevation)}.elevated.disabled::before{background:var(--_elevated-disabled-container-color);opacity:var(--_elevated-disabled-container-opacity)}@media(forced-colors: active){.elevated md-elevation{border:1px solid CanvasText}.elevated.disabled md-elevation{border-color:GrayText}}
`;

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Re-dispatches an event from the provided element.
 *
 * This function is useful for forwarding non-composed events, such as `change`
 * events.
 *
 * @example
 * class MyInput extends LitElement {
 *   render() {
 *     return html`<input @change=${this.redispatchEvent}>`;
 *   }
 *
 *   protected redispatchEvent(event: Event) {
 *     redispatchEvent(this, event);
 *   }
 * }
 *
 * @param element The element to dispatch the event from.
 * @param event The event to re-dispatch.
 * @return Whether or not the event was dispatched (if cancelable).
 */
function redispatchEvent(element, event) {
    // For bubbling events in SSR light DOM (or composed), stop their propagation
    // and dispatch the copy.
    if (event.bubbles && (!element.shadowRoot || event.composed)) {
        event.stopPropagation();
    }
    const copy = Reflect.construct(event.constructor, [event.type, event]);
    const dispatched = element.dispatchEvent(copy);
    if (!dispatched) {
        event.preventDefault();
    }
    return dispatched;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const ARIA_LABEL_REMOVE = 'aria-label-remove';
/**
 * A chip component with multiple actions.
 */
class MultiActionChip extends Chip {
    get ariaLabelRemove() {
        if (this.hasAttribute(ARIA_LABEL_REMOVE)) {
            return this.getAttribute(ARIA_LABEL_REMOVE);
        }
        const { ariaLabel } = this;
        // TODO(b/350810013): remove `this.label` when label property is removed.
        if (ariaLabel || this.label) {
            return `Remove ${ariaLabel || this.label}`;
        }
        return null;
    }
    set ariaLabelRemove(ariaLabel) {
        const prev = this.ariaLabelRemove;
        if (ariaLabel === prev) {
            return;
        }
        if (ariaLabel === null) {
            this.removeAttribute(ARIA_LABEL_REMOVE);
        }
        else {
            this.setAttribute(ARIA_LABEL_REMOVE, ariaLabel);
        }
        this.requestUpdate();
    }
    constructor() {
        super();
        this.handleTrailingActionFocus = this.handleTrailingActionFocus.bind(this);
        {
            this.addEventListener('keydown', this.handleKeyDown.bind(this));
        }
    }
    focus(options) {
        const isFocusable = this.alwaysFocusable || !this.disabled;
        if (isFocusable && options?.trailing && this.trailingAction) {
            this.trailingAction.focus(options);
            return;
        }
        super.focus(options);
    }
    renderContainerContent() {
        return b `
      ${super.renderContainerContent()}
      ${this.renderTrailingAction(this.handleTrailingActionFocus)}
    `;
    }
    handleKeyDown(event) {
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        // Ignore non-navigation keys.
        if (!isLeft && !isRight) {
            return;
        }
        if (!this.primaryAction || !this.trailingAction) {
            // Does not have multiple actions.
            return;
        }
        // Check if moving forwards or backwards
        const isRtl = getComputedStyle(this).direction === 'rtl';
        const forwards = isRtl ? isLeft : isRight;
        const isPrimaryFocused = this.primaryAction?.matches(':focus-within');
        const isTrailingFocused = this.trailingAction?.matches(':focus-within');
        if ((forwards && isTrailingFocused) || (!forwards && isPrimaryFocused)) {
            // Moving outside of the chip, it will be handled by the chip set.
            return;
        }
        // Prevent default interactions, such as scrolling.
        event.preventDefault();
        // Don't let the chip set handle this navigation event.
        event.stopPropagation();
        const actionToFocus = forwards ? this.trailingAction : this.primaryAction;
        actionToFocus.focus();
    }
    handleTrailingActionFocus() {
        const { primaryAction, trailingAction } = this;
        if (!primaryAction || !trailingAction) {
            return;
        }
        // Temporarily turn off the primary action's focusability. This allows
        // shift+tab from the trailing action to move to the previous chip rather
        // than the primary action in the same chip.
        primaryAction.tabIndex = -1;
        trailingAction.addEventListener('focusout', () => {
            primaryAction.tabIndex = 0;
        }, { once: true });
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/** @protected */
function renderRemoveButton({ ariaLabel, disabled, focusListener, tabbable = false, }) {
    // When an aria-label is not provided, we use two spans with aria-labelledby
    // to create the "Remove <textContent>" label for the remove button. The first
    // is this #remove-label span, the second is the chip's #label slot span.
    return b `
    <span id="remove-label" hidden aria-hidden="true">Remove</span>
    <button
      class="trailing action"
      aria-label=${ariaLabel || A}
      aria-labelledby=${!ariaLabel ? 'remove-label label' : A}
      tabindex=${!tabbable ? -1 : A}
      @click=${handleRemoveClick}
      @focus=${focusListener}>
      <md-focus-ring part="trailing-focus-ring"></md-focus-ring>
      <md-ripple ?disabled=${disabled}></md-ripple>
      <span class="trailing icon" aria-hidden="true">
        <slot name="remove-trailing-icon">
          <svg viewBox="0 96 960 960">
            <path
              d="m249 849-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z" />
          </svg>
        </slot>
      </span>
      <span class="touch"></span>
    </button>
  `;
}
function handleRemoveClick(event) {
    if (this.disabled || this.softDisabled) {
        return;
    }
    event.stopPropagation();
    const preventDefault = !this.dispatchEvent(new Event('remove', { cancelable: true }));
    if (preventDefault) {
        return;
    }
    this.remove();
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A filter chip component.
 *
 * @fires remove {Event} Dispatched when the remove button is clicked.
 */
class FilterChip extends MultiActionChip {
    constructor() {
        super(...arguments);
        this.elevated = false;
        this.removable = false;
        this.selected = false;
        /**
         * Only needed for SSR.
         *
         * Add this attribute when a filter chip has a `slot="selected-icon"` to avoid
         * a Flash Of Unstyled Content.
         */
        this.hasSelectedIcon = false;
    }
    get primaryId() {
        return 'button';
    }
    getContainerClasses() {
        return {
            ...super.getContainerClasses(),
            elevated: this.elevated,
            selected: this.selected,
            'has-trailing': this.removable,
            'has-icon': this.hasIcon || this.selected,
        };
    }
    renderPrimaryAction(content) {
        const { ariaLabel } = this;
        return b `
      <button
        class="primary action"
        id="button"
        aria-label=${ariaLabel || A}
        aria-pressed=${this.selected}
        aria-disabled=${this.softDisabled || A}
        ?disabled=${this.disabled && !this.alwaysFocusable}
        @click=${this.handleClickOnChild}
        >${content}</button
      >
    `;
    }
    renderLeadingIcon() {
        if (!this.selected) {
            return super.renderLeadingIcon();
        }
        return b `
      <slot name="selected-icon">
        <svg class="checkmark" viewBox="0 0 18 18" aria-hidden="true">
          <path
            d="M6.75012 12.1274L3.62262 8.99988L2.55762 10.0574L6.75012 14.2499L15.7501 5.24988L14.6926 4.19238L6.75012 12.1274Z" />
        </svg>
      </slot>
    `;
    }
    renderTrailingAction(focusListener) {
        if (this.removable) {
            return renderRemoveButton({
                focusListener,
                ariaLabel: this.ariaLabelRemove,
                disabled: this.disabled || this.softDisabled,
            });
        }
        return A;
    }
    renderOutline() {
        if (this.elevated) {
            return b `<md-elevation part="elevation"></md-elevation>`;
        }
        return super.renderOutline();
    }
    handleClickOnChild(event) {
        if (this.disabled || this.softDisabled) {
            return;
        }
        // Store prevValue to revert in case `chip.selected` is changed during an
        // event listener.
        const prevValue = this.selected;
        this.selected = !this.selected;
        const preventDefault = !redispatchEvent(this, event);
        if (preventDefault) {
            // We should not do `this.selected = !this.selected`, since a client
            // click listener could change its value. Instead, always revert to the
            // original value.
            this.selected = prevValue;
            return;
        }
    }
}
__decorate([
    n$3({ type: Boolean })
], FilterChip.prototype, "elevated", void 0);
__decorate([
    n$3({ type: Boolean })
], FilterChip.prototype, "removable", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], FilterChip.prototype, "selected", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true, attribute: 'has-selected-icon' })
], FilterChip.prototype, "hasSelectedIcon", void 0);
__decorate([
    e$4('.primary.action')
], FilterChip.prototype, "primaryAction", void 0);
__decorate([
    e$4('.trailing.action')
], FilterChip.prototype, "trailingAction", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/filter-styles.css.
const styles$m = i$7 `:host{--_container-height: var(--md-filter-chip-container-height, 32px);--_disabled-label-text-color: var(--md-filter-chip-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-filter-chip-disabled-label-text-opacity, 0.38);--_elevated-container-elevation: var(--md-filter-chip-elevated-container-elevation, 1);--_elevated-container-shadow-color: var(--md-filter-chip-elevated-container-shadow-color, var(--md-sys-color-shadow, #000));--_elevated-disabled-container-color: var(--md-filter-chip-elevated-disabled-container-color, var(--md-sys-color-on-surface, #1d1b20));--_elevated-disabled-container-elevation: var(--md-filter-chip-elevated-disabled-container-elevation, 0);--_elevated-disabled-container-opacity: var(--md-filter-chip-elevated-disabled-container-opacity, 0.12);--_elevated-focus-container-elevation: var(--md-filter-chip-elevated-focus-container-elevation, 1);--_elevated-hover-container-elevation: var(--md-filter-chip-elevated-hover-container-elevation, 2);--_elevated-pressed-container-elevation: var(--md-filter-chip-elevated-pressed-container-elevation, 1);--_elevated-selected-container-color: var(--md-filter-chip-elevated-selected-container-color, var(--md-sys-color-secondary-container, #e8def8));--_label-text-font: var(--md-filter-chip-label-text-font, var(--md-sys-typescale-label-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-filter-chip-label-text-line-height, var(--md-sys-typescale-label-large-line-height, 1.25rem));--_label-text-size: var(--md-filter-chip-label-text-size, var(--md-sys-typescale-label-large-size, 0.875rem));--_label-text-weight: var(--md-filter-chip-label-text-weight, var(--md-sys-typescale-label-large-weight, var(--md-ref-typeface-weight-medium, 500)));--_selected-focus-label-text-color: var(--md-filter-chip-selected-focus-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-label-text-color: var(--md-filter-chip-selected-hover-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-state-layer-color: var(--md-filter-chip-selected-hover-state-layer-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-state-layer-opacity: var(--md-filter-chip-selected-hover-state-layer-opacity, 0.08);--_selected-label-text-color: var(--md-filter-chip-selected-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-label-text-color: var(--md-filter-chip-selected-pressed-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-state-layer-color: var(--md-filter-chip-selected-pressed-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_selected-pressed-state-layer-opacity: var(--md-filter-chip-selected-pressed-state-layer-opacity, 0.12);--_elevated-container-color: var(--md-filter-chip-elevated-container-color, var(--md-sys-color-surface-container-low, #f7f2fa));--_disabled-outline-color: var(--md-filter-chip-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-opacity: var(--md-filter-chip-disabled-outline-opacity, 0.12);--_disabled-selected-container-color: var(--md-filter-chip-disabled-selected-container-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-selected-container-opacity: var(--md-filter-chip-disabled-selected-container-opacity, 0.12);--_focus-outline-color: var(--md-filter-chip-focus-outline-color, var(--md-sys-color-on-surface-variant, #49454f));--_outline-color: var(--md-filter-chip-outline-color, var(--md-sys-color-outline, #79747e));--_outline-width: var(--md-filter-chip-outline-width, 1px);--_selected-container-color: var(--md-filter-chip-selected-container-color, var(--md-sys-color-secondary-container, #e8def8));--_selected-outline-width: var(--md-filter-chip-selected-outline-width, 0px);--_focus-label-text-color: var(--md-filter-chip-focus-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-label-text-color: var(--md-filter-chip-hover-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-color: var(--md-filter-chip-hover-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-opacity: var(--md-filter-chip-hover-state-layer-opacity, 0.08);--_label-text-color: var(--md-filter-chip-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-label-text-color: var(--md-filter-chip-pressed-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-color: var(--md-filter-chip-pressed-state-layer-color, var(--md-sys-color-on-secondary-container, #1d192b));--_pressed-state-layer-opacity: var(--md-filter-chip-pressed-state-layer-opacity, 0.12);--_icon-size: var(--md-filter-chip-icon-size, 18px);--_disabled-leading-icon-color: var(--md-filter-chip-disabled-leading-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-leading-icon-opacity: var(--md-filter-chip-disabled-leading-icon-opacity, 0.38);--_selected-focus-leading-icon-color: var(--md-filter-chip-selected-focus-leading-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-leading-icon-color: var(--md-filter-chip-selected-hover-leading-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-leading-icon-color: var(--md-filter-chip-selected-leading-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-leading-icon-color: var(--md-filter-chip-selected-pressed-leading-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_focus-leading-icon-color: var(--md-filter-chip-focus-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_hover-leading-icon-color: var(--md-filter-chip-hover-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_leading-icon-color: var(--md-filter-chip-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_pressed-leading-icon-color: var(--md-filter-chip-pressed-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_disabled-trailing-icon-color: var(--md-filter-chip-disabled-trailing-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-trailing-icon-opacity: var(--md-filter-chip-disabled-trailing-icon-opacity, 0.38);--_selected-focus-trailing-icon-color: var(--md-filter-chip-selected-focus-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-trailing-icon-color: var(--md-filter-chip-selected-hover-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-trailing-icon-color: var(--md-filter-chip-selected-pressed-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-trailing-icon-color: var(--md-filter-chip-selected-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_focus-trailing-icon-color: var(--md-filter-chip-focus-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-trailing-icon-color: var(--md-filter-chip-hover-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-trailing-icon-color: var(--md-filter-chip-pressed-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_trailing-icon-color: var(--md-filter-chip-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_container-shape-start-start: var(--md-filter-chip-container-shape-start-start, var(--md-filter-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_container-shape-start-end: var(--md-filter-chip-container-shape-start-end, var(--md-filter-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_container-shape-end-end: var(--md-filter-chip-container-shape-end-end, var(--md-filter-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_container-shape-end-start: var(--md-filter-chip-container-shape-end-start, var(--md-filter-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_leading-space: var(--md-filter-chip-leading-space, 16px);--_trailing-space: var(--md-filter-chip-trailing-space, 16px);--_icon-label-space: var(--md-filter-chip-icon-label-space, 8px);--_with-leading-icon-leading-space: var(--md-filter-chip-with-leading-icon-leading-space, 8px);--_with-trailing-icon-trailing-space: var(--md-filter-chip-with-trailing-icon-trailing-space, 8px)}.selected.elevated::before{background:var(--_elevated-selected-container-color)}.checkmark{height:var(--_icon-size);width:var(--_icon-size)}.disabled .checkmark{opacity:var(--_disabled-leading-icon-opacity)}@media(forced-colors: active){.disabled .checkmark{opacity:1}}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/selectable-styles.css.
const styles$l = i$7 `.selected{--md-ripple-hover-color: var(--_selected-hover-state-layer-color);--md-ripple-hover-opacity: var(--_selected-hover-state-layer-opacity);--md-ripple-pressed-color: var(--_selected-pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_selected-pressed-state-layer-opacity)}:where(.selected)::before{background:var(--_selected-container-color)}:where(.selected) .outline{border-width:var(--_selected-outline-width)}:where(.selected.disabled)::before{background:var(--_disabled-selected-container-color);opacity:var(--_disabled-selected-container-opacity)}:where(.selected) .label{color:var(--_selected-label-text-color)}:where(.selected:hover) .label{color:var(--_selected-hover-label-text-color)}:where(.selected:focus) .label{color:var(--_selected-focus-label-text-color)}:where(.selected:active) .label{color:var(--_selected-pressed-label-text-color)}:where(.selected) .leading.icon{color:var(--_selected-leading-icon-color)}:where(.selected:hover) .leading.icon{color:var(--_selected-hover-leading-icon-color)}:where(.selected:focus) .leading.icon{color:var(--_selected-focus-leading-icon-color)}:where(.selected:active) .leading.icon{color:var(--_selected-pressed-leading-icon-color)}@media(forced-colors: active){:where(.selected:not(.elevated))::before{border:1px solid CanvasText}:where(.selected) .outline{border-width:1px}}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/shared-styles.css.
const styles$k = i$7 `:host{border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-start-radius:var(--_container-shape-end-start);border-end-end-radius:var(--_container-shape-end-end);display:inline-flex;height:var(--_container-height);cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0);--md-ripple-hover-color: var(--_hover-state-layer-color);--md-ripple-hover-opacity: var(--_hover-state-layer-opacity);--md-ripple-pressed-color: var(--_pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_pressed-state-layer-opacity)}:host(:is([disabled],[soft-disabled])){pointer-events:none}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_container-height))/2) 0}md-focus-ring{--md-focus-ring-shape-start-start: var(--_container-shape-start-start);--md-focus-ring-shape-start-end: var(--_container-shape-start-end);--md-focus-ring-shape-end-end: var(--_container-shape-end-end);--md-focus-ring-shape-end-start: var(--_container-shape-end-start)}.container{border-radius:inherit;box-sizing:border-box;display:flex;height:100%;position:relative;width:100%}.container::before{border-radius:inherit;content:"";inset:0;pointer-events:none;position:absolute}.container:not(.disabled){cursor:pointer}.container.disabled{pointer-events:none}.cell{display:flex}.action{align-items:baseline;appearance:none;background:none;border:none;border-radius:inherit;display:flex;outline:none;padding:0;position:relative;text-decoration:none}.primary.action{min-width:0;padding-inline-start:var(--_leading-space);padding-inline-end:var(--_trailing-space)}.has-icon .primary.action{padding-inline-start:var(--_with-leading-icon-leading-space)}.touch{height:48px;inset:50% 0 0;position:absolute;transform:translateY(-50%);width:100%}:host([touch-target=none]) .touch{display:none}.outline{border:var(--_outline-width) solid var(--_outline-color);border-radius:inherit;inset:0;pointer-events:none;position:absolute}:where(:focus) .outline{border-color:var(--_focus-outline-color)}:where(.disabled) .outline{border-color:var(--_disabled-outline-color);opacity:var(--_disabled-outline-opacity)}md-ripple{border-radius:inherit}.label,.icon,.touch{z-index:1}.label{align-items:center;color:var(--_label-text-color);display:flex;font-family:var(--_label-text-font);font-size:var(--_label-text-size);font-weight:var(--_label-text-weight);height:100%;line-height:var(--_label-text-line-height);overflow:hidden;user-select:none}.label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(:hover) .label{color:var(--_hover-label-text-color)}:where(:focus) .label{color:var(--_focus-label-text-color)}:where(:active) .label{color:var(--_pressed-label-text-color)}:where(.disabled) .label{color:var(--_disabled-label-text-color);opacity:var(--_disabled-label-text-opacity)}.icon{align-self:center;display:flex;fill:currentColor;position:relative}.icon ::slotted(:first-child){font-size:var(--_icon-size);height:var(--_icon-size);width:var(--_icon-size)}.leading.icon{color:var(--_leading-icon-color)}.leading.icon ::slotted(*),.leading.icon svg{margin-inline-end:var(--_icon-label-space)}:where(:hover) .leading.icon{color:var(--_hover-leading-icon-color)}:where(:focus) .leading.icon{color:var(--_focus-leading-icon-color)}:where(:active) .leading.icon{color:var(--_pressed-leading-icon-color)}:where(.disabled) .leading.icon{color:var(--_disabled-leading-icon-color);opacity:var(--_disabled-leading-icon-opacity)}@media(forced-colors: active){:where(.disabled) :is(.label,.outline,.leading.icon){color:GrayText;opacity:1}}a,button{text-transform:inherit}a,button:not(:disabled,[aria-disabled=true]){cursor:inherit}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/trailing-icon-styles.css.
const styles$j = i$7 `.trailing.action{align-items:center;justify-content:center;padding-inline-start:var(--_icon-label-space);padding-inline-end:var(--_with-trailing-icon-trailing-space)}.trailing.action :is(md-ripple,md-focus-ring){border-radius:50%;height:calc(1.3333333333*var(--_icon-size));width:calc(1.3333333333*var(--_icon-size))}.trailing.action md-focus-ring{inset:unset}.has-trailing .primary.action{padding-inline-end:0}.trailing.icon{color:var(--_trailing-icon-color);height:var(--_icon-size);width:var(--_icon-size)}:where(:hover) .trailing.icon{color:var(--_hover-trailing-icon-color)}:where(:focus) .trailing.icon{color:var(--_focus-trailing-icon-color)}:where(:active) .trailing.icon{color:var(--_pressed-trailing-icon-color)}:where(.disabled) .trailing.icon{color:var(--_disabled-trailing-icon-color);opacity:var(--_disabled-trailing-icon-opacity)}:where(.selected) .trailing.icon{color:var(--_selected-trailing-icon-color)}:where(.selected:hover) .trailing.icon{color:var(--_selected-hover-trailing-icon-color)}:where(.selected:focus) .trailing.icon{color:var(--_selected-focus-trailing-icon-color)}:where(.selected:active) .trailing.icon{color:var(--_selected-pressed-trailing-icon-color)}@media(forced-colors: active){.trailing.icon{color:ButtonText}:where(.disabled) .trailing.icon{color:GrayText;opacity:1}}
`;

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-filter-chip
 * TODO(b/243982145): add docs
 *
 * @final
 * @suppress {visibility}
 */
class OscdFilterChip extends ScopedElementsMixin(FilterChip) {
}
OscdFilterChip.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
    'md-elevation': OscdElevation,
};
OscdFilterChip.styles = [
    styles$k,
    styles$n,
    styles$j,
    styles$l,
    styles$m,
];

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * An input chip component.
 *
 * @fires remove {Event} Dispatched when the remove button is clicked.
 */
class InputChip extends MultiActionChip {
    constructor() {
        super(...arguments);
        this.avatar = false;
        this.href = '';
        this.target = '';
        this.removeOnly = false;
        this.selected = false;
    }
    get primaryId() {
        if (this.href) {
            return 'link';
        }
        if (this.removeOnly) {
            return '';
        }
        return 'button';
    }
    get rippleDisabled() {
        // Link chips cannot be disabled
        return !this.href && (this.disabled || this.softDisabled);
    }
    get primaryAction() {
        // Don't use @query() since a remove-only input chip still has a span that
        // has "primary action" classes.
        if (this.removeOnly) {
            return null;
        }
        return this.renderRoot.querySelector('.primary.action');
    }
    getContainerClasses() {
        return {
            ...super.getContainerClasses(),
            avatar: this.avatar,
            // Link chips cannot be disabled
            disabled: !this.href && (this.disabled || this.softDisabled),
            link: !!this.href,
            selected: this.selected,
            'has-trailing': true,
        };
    }
    renderPrimaryAction(content) {
        const { ariaLabel } = this;
        if (this.href) {
            return b `
        <a
          class="primary action"
          id="link"
          aria-label=${ariaLabel || A}
          href=${this.href}
          target=${this.target || A}
          >${content}</a
        >
      `;
        }
        if (this.removeOnly) {
            return b `
        <span class="primary action" aria-label=${ariaLabel || A}>
          ${content}
        </span>
      `;
        }
        return b `
      <button
        class="primary action"
        id="button"
        aria-label=${ariaLabel || A}
        aria-disabled=${this.softDisabled || A}
        ?disabled=${this.disabled && !this.alwaysFocusable}
        type="button"
        >${content}</button
      >
    `;
    }
    renderTrailingAction(focusListener) {
        return renderRemoveButton({
            focusListener,
            ariaLabel: this.ariaLabelRemove,
            disabled: !this.href && (this.disabled || this.softDisabled),
            tabbable: this.removeOnly,
        });
    }
}
__decorate([
    n$3({ type: Boolean })
], InputChip.prototype, "avatar", void 0);
__decorate([
    n$3()
], InputChip.prototype, "href", void 0);
__decorate([
    n$3()
], InputChip.prototype, "target", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'remove-only' })
], InputChip.prototype, "removeOnly", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], InputChip.prototype, "selected", void 0);
__decorate([
    e$4('.trailing.action')
], InputChip.prototype, "trailingAction", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/input-styles.css.
const styles$i = i$7 `:host{--_container-height: var(--md-input-chip-container-height, 32px);--_disabled-label-text-color: var(--md-input-chip-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-input-chip-disabled-label-text-opacity, 0.38);--_disabled-selected-container-color: var(--md-input-chip-disabled-selected-container-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-selected-container-opacity: var(--md-input-chip-disabled-selected-container-opacity, 0.12);--_label-text-font: var(--md-input-chip-label-text-font, var(--md-sys-typescale-label-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-input-chip-label-text-line-height, var(--md-sys-typescale-label-large-line-height, 1.25rem));--_label-text-size: var(--md-input-chip-label-text-size, var(--md-sys-typescale-label-large-size, 0.875rem));--_label-text-weight: var(--md-input-chip-label-text-weight, var(--md-sys-typescale-label-large-weight, var(--md-ref-typeface-weight-medium, 500)));--_selected-container-color: var(--md-input-chip-selected-container-color, var(--md-sys-color-secondary-container, #e8def8));--_selected-focus-label-text-color: var(--md-input-chip-selected-focus-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-label-text-color: var(--md-input-chip-selected-hover-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-state-layer-color: var(--md-input-chip-selected-hover-state-layer-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-state-layer-opacity: var(--md-input-chip-selected-hover-state-layer-opacity, 0.08);--_selected-label-text-color: var(--md-input-chip-selected-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-outline-width: var(--md-input-chip-selected-outline-width, 0px);--_selected-pressed-label-text-color: var(--md-input-chip-selected-pressed-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-state-layer-color: var(--md-input-chip-selected-pressed-state-layer-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-state-layer-opacity: var(--md-input-chip-selected-pressed-state-layer-opacity, 0.12);--_disabled-outline-color: var(--md-input-chip-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-opacity: var(--md-input-chip-disabled-outline-opacity, 0.12);--_focus-label-text-color: var(--md-input-chip-focus-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-outline-color: var(--md-input-chip-focus-outline-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-label-text-color: var(--md-input-chip-hover-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-color: var(--md-input-chip-hover-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-opacity: var(--md-input-chip-hover-state-layer-opacity, 0.08);--_label-text-color: var(--md-input-chip-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_outline-color: var(--md-input-chip-outline-color, var(--md-sys-color-outline, #79747e));--_outline-width: var(--md-input-chip-outline-width, 1px);--_pressed-label-text-color: var(--md-input-chip-pressed-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-color: var(--md-input-chip-pressed-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-opacity: var(--md-input-chip-pressed-state-layer-opacity, 0.12);--_avatar-shape: var(--md-input-chip-avatar-shape, var(--md-sys-shape-corner-full, 9999px));--_avatar-size: var(--md-input-chip-avatar-size, 24px);--_disabled-avatar-opacity: var(--md-input-chip-disabled-avatar-opacity, 0.38);--_disabled-leading-icon-color: var(--md-input-chip-disabled-leading-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-leading-icon-opacity: var(--md-input-chip-disabled-leading-icon-opacity, 0.38);--_icon-size: var(--md-input-chip-icon-size, 18px);--_selected-focus-leading-icon-color: var(--md-input-chip-selected-focus-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-leading-icon-color: var(--md-input-chip-selected-hover-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-leading-icon-color: var(--md-input-chip-selected-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-leading-icon-color: var(--md-input-chip-selected-pressed-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_focus-leading-icon-color: var(--md-input-chip-focus-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_hover-leading-icon-color: var(--md-input-chip-hover-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_leading-icon-color: var(--md-input-chip-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_pressed-leading-icon-color: var(--md-input-chip-pressed-leading-icon-color, var(--md-sys-color-primary, #6750a4));--_disabled-trailing-icon-color: var(--md-input-chip-disabled-trailing-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-trailing-icon-opacity: var(--md-input-chip-disabled-trailing-icon-opacity, 0.38);--_selected-focus-trailing-icon-color: var(--md-input-chip-selected-focus-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-hover-trailing-icon-color: var(--md-input-chip-selected-hover-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-pressed-trailing-icon-color: var(--md-input-chip-selected-pressed-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_selected-trailing-icon-color: var(--md-input-chip-selected-trailing-icon-color, var(--md-sys-color-on-secondary-container, #1d192b));--_focus-trailing-icon-color: var(--md-input-chip-focus-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-trailing-icon-color: var(--md-input-chip-hover-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-trailing-icon-color: var(--md-input-chip-pressed-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_trailing-icon-color: var(--md-input-chip-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_container-shape-start-start: var(--md-input-chip-container-shape-start-start, var(--md-input-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_container-shape-start-end: var(--md-input-chip-container-shape-start-end, var(--md-input-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_container-shape-end-end: var(--md-input-chip-container-shape-end-end, var(--md-input-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_container-shape-end-start: var(--md-input-chip-container-shape-end-start, var(--md-input-chip-container-shape, var(--md-sys-shape-corner-small, 8px)));--_leading-space: var(--md-input-chip-leading-space, 16px);--_trailing-space: var(--md-input-chip-trailing-space, 16px);--_icon-label-space: var(--md-input-chip-icon-label-space, 8px);--_with-leading-icon-leading-space: var(--md-input-chip-with-leading-icon-leading-space, 8px);--_with-trailing-icon-trailing-space: var(--md-input-chip-with-trailing-icon-trailing-space, 8px)}:host([avatar]){--_container-shape-start-start: var( --md-input-chip-container-shape-start-start, var(--md-input-chip-container-shape, calc(var(--_container-height) / 2)) );--_container-shape-start-end: var( --md-input-chip-container-shape-start-end, var(--md-input-chip-container-shape, calc(var(--_container-height) / 2)) );--_container-shape-end-end: var( --md-input-chip-container-shape-end-end, var(--md-input-chip-container-shape, calc(var(--_container-height) / 2)) );--_container-shape-end-start: var( --md-input-chip-container-shape-end-start, var(--md-input-chip-container-shape, calc(var(--_container-height) / 2)) )}.avatar .primary.action{padding-inline-start:4px}.avatar .leading.icon ::slotted(:first-child){border-radius:var(--_avatar-shape);height:var(--_avatar-size);width:var(--_avatar-size)}.disabled.avatar .leading.icon{opacity:var(--_disabled-avatar-opacity)}@media(forced-colors: active){.link .outline{border-color:ActiveText}.disabled.avatar .leading.icon{opacity:1}}
`;

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-input-chip
 * TODO(b/243982145): add docs
 *
 * @final
 * @suppress {visibility}
 */
class OscdInputChip extends ScopedElementsMixin(InputChip) {
}
OscdInputChip.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
};
OscdInputChip.styles = [
    styles$k,
    styles$j,
    styles$l,
    styles$i,
];

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * An icon element.
 */
let Icon$1 = class Icon extends i$4 {
    render() {
        return b `<slot></slot>`;
    }
    connectedCallback() {
        super.connectedCallback();
        const ariaHidden = this.getAttribute('aria-hidden');
        if (ariaHidden === 'false') {
            // Allow the user to set `aria-hidden="false"` to create an icon that is
            // announced by screenreaders.
            this.removeAttribute('aria-hidden');
            return;
        }
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute('aria-hidden', 'true');
    }
};

const elementIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M9,7H15V9H11V11H15V13H11V15H15V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const attributeIcon = w `<svg viewBox="0 0 24 24">
<path fill="currentColor" d="M11,7H13A2,2 0 0,1 15,9V17H13V13H11V17H9V9A2,2 0 0,1 11,7M11,9V11H13V9H11M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z" />
</svg>`;
const contentIcon = w `<svg viewBox="0 0 24 24">
<path fill="currentColor" d="M11,7H13A2,2 0 0,1 15,9V10H13V9H11V15H13V14H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;

const editIcon = w `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 25 25"
>
  <path
    d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
    stroke="currentColor"
    fill="transparent"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;
const pathsSVG = {
    action: w `<path d="M0 0h24v24H0z" fill="none"></path><path d="M13 3c-4.97 0-9
  4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7
  7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0
  9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" fill="currentColor"></path>`,
    dAIcon: w `<path fill="currentColor" d="m4.2 0c-2.31 0-4.2 1.89-4.2 4.2v11.6c0 2.31 1.89 4.2 4.2 4.2h18.1c2.31 0 4.2-1.89 4.2-4.2v-11.6c0-2.31-1.89-4.2-4.2-4.2zm0 1.89h18.1c1.29 0 2.3 1.01 2.3 2.3v11.6c0 1.29-1.01 2.31-2.3 2.31h-18.1c-1.29 0-2.3-1.01-2.3-2.31v-11.6c0-1.29 1.01-2.3 2.3-2.3z"/><path stroke="none" fill="currentColor" d="m12.5 9.94q0 1.55-0.509 2.71-0.503 1.15-1.43 1.76-0.923 0.611-2.12 0.611h-3.37v-10h3.02q2.11 0 3.26 1.28 1.15 1.27 1.15 3.65zm-1.76 0q0-1.61-0.698-2.46-0.698-0.852-1.99-0.852h-1.24v6.77h1.48q1.12 0 1.79-0.931 0.663-0.931 0.663-2.53z"/><path stroke="none" fill="currentColor" d="m19.7 15-0.74-2.56h-3.18l-0.74 2.56h-1.75l3.04-10h2.06l3.03 10zm-1.13-4.13-0.823-2.88-0.379-1.46q-0.0947 0.412-0.178 0.739-0.0829 0.327-1.02 3.59z"/>`,
    dOIcon: w `<path fill="none" stroke="currentColor" stroke-width="1.89" d="m4.2 0.945h18.1c1.8 0 3.25 1.45 3.25 3.25v11.6c0 1.8-1.45 3.25-3.25 3.25h-18.1c-1.8 0-3.25-1.45-3.25-3.25v-11.6c0-1.8 1.45-3.25 3.25-3.25z"/><path stroke="none" fill="currentColor" d="m12.1 9.94q0 1.55-0.509 2.71-0.503 1.15-1.43 1.76-0.923 0.611-2.12 0.611h-3.37v-10h3.02q2.11 0 3.26 1.28 1.15 1.27 1.15 3.65zm-1.76 0q0-1.61-0.698-2.46-0.698-0.852-1.99-0.852h-1.24v6.77h1.48q1.12 0 1.79-0.931 0.663-0.931 0.663-2.53z"/><path stroke="none" fill="currentColor" d="m21.6 9.97q0 1.56-0.515 2.75-0.515 1.19-1.47 1.82-0.959 0.625-2.24 0.625-1.97 0-3.08-1.39-1.11-1.39-1.11-3.81 0-2.41 1.11-3.76t3.1-1.35 3.1 1.36q1.12 1.36 1.12 3.74zm-1.78 0q0-1.62-0.639-2.54-0.639-0.923-1.79-0.923-1.17 0-1.81 0.916-0.639 0.909-0.639 2.54 0 1.65 0.651 2.6 0.657 0.945 1.79 0.945 1.17 0 1.81-0.923 0.639-0.923 0.639-2.62z"/>`,
    enumIcon: w `<path fill="none" stroke="currentColor" stroke-width="1.89" d="m4.2 0.945h18.1c1.8 0 3.25 1.45 3.25 3.25v11.6c0 1.8-1.45 3.25-3.25 3.25h-18.1c-1.8 0-3.25-1.45-3.25-3.25v-11.6c0-1.8 1.45-3.25 3.25-3.25z"/><path d="m5.37 15v-10h6.56v1.62h-4.81v2.51h4.45v1.62h-4.45v2.64h5.06v1.62z"/><path d="m18.5 15-3.63-7.71q0.107 1.12 0.107 1.8v5.9h-1.55v-10h1.99l3.69 7.77q-0.107-1.07-0.107-1.95v-5.82h1.55v10z"/>`,
    info: w `<path d="M0 0h24v24H0z" fill="none"></path><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor"></path>`,
    warning: w `<path d="M0 0h24v24H0z" fill="none"></path><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor"></path>`,
    error: w `<path d="M0 0h24v24H0V0z" fill="none"></path><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z" fill="currentColor"></path><path d="M11 7h2v7h-2z" fill="currentColor"></path><circle cx="12" cy="16" r="1" fill="currentColor"></circle>`,
    gooseIcon: w `<path fill="currentColor" d="M11,7H15V9H11V15H13V11H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />`,
    lNIcon: w `<path stroke="currentColor" stroke-width="1.89" fill="none" d="m4.2 0.945h18.1c1.8 0 3.25 1.45 3.25 3.25v11.6c0 1.8-1.45 3.25-3.25 3.25h-18.1c-1.8 0-3.25-1.45-3.25-3.25v-11.6c0-1.8 1.45-3.25 3.25-3.25z"/><path fill="currentColor" d="m5.71 15v-10h1.75v8.39h4.47v1.62z"/><path fill="currentColor" d="m18.2 15-3.63-7.71q0.107 1.12 0.107 1.8v5.9h-1.55v-10h1.99l3.69 7.77q-0.107-1.07-0.107-1.95v-5.82h1.55v10z"/>`,
    logIcon: w `<path fill="currentColor" d="M9,7H11V15H15V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />`,
    reportIcon: w `<path fill="currentColor" d="M9,7H13A2,2 0 0,1 15,9V11C15,11.84 14.5,12.55 13.76,12.85L15,17H13L11.8,13H11V17H9V7M11,9V11H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,16.41 7.58,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />`,
    dataSetIcon: w `<path fill="currentColor" d="M9,7H12.5A3.5,3.5 0 0,1 16,10.5V13.5A3.5,3.5 0 0,1 12.5,17H9V7M11,9V15H12.5A1.5,1.5 0 0,0 14,13.5V10.5A1.5,1.5 0 0,0 12.5,9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,16.41 7.58,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />`,
    smvIcon: w `<path fill="currentColor" d="M11,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H9V15H13V13H11A2,2 0 0,1 9,11V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />`,
    reset: w ``,
};
const gooseIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">${pathsSVG['gooseIcon']}</svg>`;
const reportIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">${pathsSVG['reportIcon']}</svg>`;
const smvIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">${pathsSVG['smvIcon']}</svg>`;
const dataSetIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">${pathsSVG['dataSetIcon']}</svg>`;
const logIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">${pathsSVG['logIcon']}</svg>`;
const inputIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M14,12L10,8V11H2V13H10V16M20,18V6C20,4.89 19.1,4 18,4H6A2,2 0 0,0 4,6V9H6V6H18V18H6V15H4V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18Z" />
</svg>`;
const clientIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M21,14V4H3V14H21M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H14L16,21V22H8V21L10,18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M4,5H15V10H4V5M16,5H20V7H16V5M20,8V13H16V8H20M4,11H9V13H4V11M10,11H15V13H10V11Z" />
</svg>`;
const disconnect = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3.88,13.46L2.46,14.88L4.59,17L2.46,19.12L3.88,20.54L6,18.41L8.12,20.54L9.54,19.12L7.41,17L9.54,14.88L8.12,13.46L6,15.59L3.88,13.46M14,15H20V19H14V15Z" />
</svg>`;
const networkConfigIcon = w `<svg
  xmlns="http://www.w3.org/2000/svg"
  slot="icon"
  width="25px"
  height="25px"
  style="margin-bottom:0px;"
>
  <rect
    width="8"
    height="8"
    x="8.5"
    y="2"
    rx="1"
    ry="1"
    fill="transparent"
    stroke="currentColor"
    stroke-width="1.5"
  />
  <rect
    width="8"
    height="8"
    x="2.5"
    y="15"
    rx="1"
    ry="1"
    fill="transparent"
    stroke="currentColor"
    stroke-width="1.5"
  />
  <rect
    width="8"
    height="8"
    x="15"
    y="15"
    rx="1"
    ry="1"
    fill="transparent"
    stroke="currentColor"
    stroke-width="1.5"
  />

  <line
    x1="2"
    y1="12.5"
    x2="23"
    y2="12.5"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-width="1.5"
  />
  <line
    x1="12.5"
    y1="10"
    x2="12.5"
    y2="12.5"
    stroke="currentColor"
    stroke-width="1.5"
  />
  <line
    x1="6.5"
    y1="12.5"
    x2="6.5"
    y2="15"
    stroke="currentColor"
    stroke-width="1.5"
  />
  <line
    x1="19"
    y1="12.5"
    x2="19"
    y2="15"
    stroke="currentColor"
    stroke-width="1.5"
  />
</svg>`;
const zeroLineIcon = w `<svg
  xmlns="http://www.w3.org/2000/svg"
  slot="icon"
  viewBox="0 0 25 25"
>
  <path
    d="M 2 9 L 12.5 2 L 23 9 L 21 9 L 21 21 L 4 21 L 4 9 Z"
    fill="transparent"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
  />
  <path
    d="M 11 7 L 17.5 7 L 13.5 11 L 16.5 11 L 10 19 L 11.5 13 L 8.5 13 Z "
    fill="currentColor"
  />
</svg>`;
const voltageLevelIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
      }

      .cls-1,
      .cls-2 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: currentColor;
        opacity: 0;
      }
    </style>
  </defs>
  <path
    class="cls-1"
    d="M11.13,20.06L3.63,6.93c-.27-.48-.11-1.09.37-1.36h0c.48-.27,1.09-.11,1.36.37l6.64,11.61,6.64-11.61c.27-.48.88-.65,1.36-.37h0c.48.27.65.88.37,1.36l-7.5,13.13c-.38.67-1.35.67-1.74,0Z"
  />
  <rect class="cls-2" width="24" height="24" />
</svg>`;
const bayIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path
    class="cls-1"
    d="M7.75,8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5h-1.25c0,.84.52,1.55,1.25,1.85v8.65h1.5v-8.65c.73-.3,1.25-1.01,1.25-1.85h-1.25v-1.5Z"
  />
  <path
    class="cls-1"
    d="M12.75,8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5h-1.25c0,.84.52,1.55,1.25,1.85v8.65h1.5v-8.65c.73-.3,1.25-1.01,1.25-1.85h-1.25v-1.5Z"
  />
  <path
    class="cls-1"
    d="M17.75,8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5h-1.25c0,.84.52,1.55,1.25,1.85v8.65h1.5v-8.65c.73-.3,1.25-1.01,1.25-1.85h-1.25v-1.5Z"
  />
  <path
    class="cls-1"
    d="M20,4H4c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2v-6h16v6c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  />
</svg>`;
const disconnectorIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
      }

      .cls-1,
      .cls-2 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #fff;
        opacity: 0;
      }
    </style>
  </defs>
  <g>
    <path
      class="cls-1"
      d="M12.71,15.29l-6.79-6.79c-.39-.39-1.02-.39-1.41,0-.39.39-.39,1.02,0,1.41l6.5,6.5v4.59c0,.55.45,1,1,1s1-.45,1-1v-5c0-.13-.03-.26-.08-.38-.05-.12-.12-.23-.22-.33Z"
    />
    <path
      class="cls-1"
      d="M14,6h-1v-3c0-.55-.45-1-1-1s-1,.45-1,1v3h-1c-.55,0-1,.45-1,1s.45,1,1,1h4c.55,0,1-.45,1-1s-.45-1-1-1Z"
    />
  </g>
  <rect class="cls-2" width="24" height="24" />
</svg>`;
const circuitBreakerIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
      }

      .cls-1,
      .cls-2 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #fff;
        opacity: 0;
      }
    </style>
  </defs>
  <g>
    <path
      class="cls-1"
      d="M12.71,15.29l-6.79-6.79c-.39-.39-1.02-.39-1.41,0-.39.39-.39,1.02,0,1.41l6.5,6.5v4.59c0,.55.45,1,1,1s1-.45,1-1v-5c0-.13-.03-.26-.08-.38-.05-.12-.12-.23-.22-.33Z"
    />
    <path
      class="cls-1"
      d="M13.41,7l1.29-1.29c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-1.29,1.29-1.29-1.29c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l1.29,1.29-1.29,1.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l1.29-1.29,1.29,1.29c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-1.29-1.29Z"
    />
  </g>
  <rect class="cls-2" width="24" height="24" />
</svg>`;
const currentTransformerIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
      }

      .cls-1,
      .cls-2 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #fff;
        opacity: 0;
      }
    </style>
  </defs>
  <path
    class="cls-1"
    d="M19,12c0-3.53-2.61-6.43-6-6.92v-2.08c0-.55-.45-1-1-1s-1,.45-1,1v2.08c-3.39.49-6,3.39-6,6.92s2.61,6.43,6,6.92v2.08c0,.55.45,1,1,1s1-.45,1-1v-2.08c3.39-.49,6-3.39,6-6.92ZM7,12c0-2.42,1.72-4.44,4-4.9v9.8c-2.28-.46-4-2.48-4-4.9ZM13,16.9V7.1c2.28.46,4,2.48,4,4.9s-1.72,4.44-4,4.9Z"
  />
  <rect class="cls-2" width="24" height="24" />
</svg>`;
const voltageTransformerIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
      }

      .cls-1,
      .cls-2 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #fff;
        opacity: 0;
      }
    </style>
  </defs>
  <path
    class="cls-1"
    d="M17,10c0-2.42-1.72-4.44-4-4.9v-2.1s0-1-1-1-1,1-1,1v2.1c-2.28.46-4,2.48-4,4.9,0,.71.15,1.39.42,2-.27.61-.42,1.29-.42,2,0,2.42,1.72,4.44,4,4.9v1.1h-1c-.55,0-1,.45-1,1s.45,1,1,1h4c.55,0,1-.45,1-1s-.45-1-1-1h-1v-1.1c2.28-.46,4-2.48,4-4.9,0-.71-.15-1.39-.42-2,.27-.61.42-1.29.42-2ZM12,7c1.66,0,3,1.34,3,3,0,0,0,.01,0,.02-.84-.63-1.87-1.02-3-1.02s-2.16.39-3,1.02c0,0,0-.01,0-.02,0-1.66,1.34-3,3-3ZM14.22,12c-.55.61-1.34,1-2.22,1s-1.67-.39-2.22-1c.55-.61,1.34-1,2.22-1s1.67.39,2.22,1ZM12,17c-1.66,0-3-1.34-3-3,0,0,0-.01,0-.02.84.63,1.87,1.02,3,1.02s2.16-.39,3-1.02c0,0,0,.01,0,.02,0,1.66-1.34,3-3,3Z"
  />
  <rect class="cls-2" width="24" height="24" />
</svg>`;
const earthSwitchIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
      }

      .cls-1,
      .cls-2 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #fff;
        opacity: 0;
      }
    </style>
  </defs>
  <g>
    <path
      class="cls-1"
      d="M13,20h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1Z"
    />
    <path
      class="cls-1"
      d="M15,16h-2v-5c0-.13-.03-.26-.08-.38-.05-.12-.12-.23-.22-.33L5.91,3.5c-.39-.39-1.02-.39-1.41,0-.39.39-.39,1.02,0,1.41l6.5,6.5v4.59h-2c-.55,0-1,.45-1,1s.45,1,1,1h6c.55,0,1-.45,1-1s-.45-1-1-1Z"
    />
    <path
      class="cls-1"
      d="M10,4h4c.55,0,1-.45,1-1s-.45-1-1-1h-4c-.55,0-1,.45-1,1s.45,1,1,1Z"
    />
  </g>
  <rect class="cls-2" width="24" height="24" />
</svg>`;
const generalConductingEquipmentIcon = w `<svg
  id="Laag_1"
  data-name="Laag 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <defs>
    <style>
      .cls-1 {
        fill: currentColor;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path
    class="cls-1"
    d="M20.41,3.59c-.78-.78-2.05-.78-2.83,0-.59.59-.73,1.47-.43,2.19l-1.49,1.49c-1.02-.79-2.29-1.27-3.67-1.27-3.31,0-6,2.69-6,6,0,1.38.48,2.66,1.27,3.67l-1.49,1.49c-.73-.31-1.6-.17-2.19.43-.78.78-.78,2.05,0,2.83.78.78,2.05.78,2.83,0,.59-.59.73-1.47.43-2.19l1.49-1.49c1.02.79,2.29,1.27,3.67,1.27,3.31,0,6-2.69,6-6,0-1.38-.48-2.66-1.27-3.67l1.49-1.49c.73.31,1.6.17,2.19-.43.78-.78.78-2.05,0-2.83ZM12,16c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4Z"
  />
</svg>`;
const connectivityNodeIcon = w `<svg
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    stroke="currentColor"
    fill="currentColor"
    stroke-width="1"
    cx="12.5"
    cy="12.5"
    r="5"
  />
</svg>`;
const powerTransformerTwoWindingIcon = w `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 25 25"
>
  <line
    x1="12.5"
    y1="2"
    x2="12.5"
    y2="5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <circle
    cx="12.5"
    cy="10"
    r="5"
    stroke="currentColor"
    fill="transparent"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <circle
    cx="12.5"
    cy="15"
    r="5"
    stroke="currentColor"
    fill="transparent"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <line
    x1="12.5"
    y1="20"
    x2="12.5"
    y2="23"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;
const openSCDIcon = w ` <svg
  xmlns="http://www.w3.org/2000/svg"
  style="width:100px;height:100px"
  viewBox="0 0 25 25"
>
  <path
    d="M 2 9 L 12.5 2 L 23 9 L 21 9 L 21 21 L 4 21 L 4 9 Z"
    fill="#eee8d5"
    stroke="#6c71c4"
    stroke-width="2"
    stroke-linejoin="round"
  />
  <path
    d="M 11 7 L 17.5 7 L 13.5 11 L 16.5 11 L 10 19 L 11.5 13 L 8.5 13 Z "
    fill="#2aa198"
  />
</svg>`;
const sizableSmvIcon = w `
  <svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M11,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H9V15H13V13H11A2,2 0 0,1 9,11V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
  </svg>`;
const sizableGooseIcon = w `<svg viewBox="0 0 24 24">
<path fill="currentColor" d="M11,7H15V9H11V15H13V11H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const substationIcon = w `<svg id="Laag_1" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<defs>
  <style>
    .cls-1 {
      fill: currentColor;
    }

    .cls-1, .cls-2 {
      stroke-width: 0px;
    }

    .cls-2 {
      fill: currentColor;
      opacity: 0;
    }
  </style>
</defs>
<g>
  <path class="cls-1" d="M19.3,7.94l-6-5.14c-.75-.64-1.85-.65-2.6,0l-6,5.14c-.44.38-.7.93-.7,1.52v9.54c0,1.1.9,2,2,2h12c1.1,0,2-.9,2-2v-9.54c0-.58-.25-1.14-.7-1.52ZM18,19H6v-9.54l6-5.14,6,5.14v9.54Z"/>
  <path class="cls-1" d="M11.57,7.74l-3,5c-.09.15-.09.35,0,.5.09.16.26.25.44.25h2v3.5c0,.22.15.42.37.48.04.01.09.02.13.02.17,0,.34-.09.43-.24l3-5c.09-.15.09-.35,0-.5-.09-.16-.26-.25-.44-.25h-2v-3.5c0-.22-.15-.42-.37-.48-.22-.06-.45.03-.56.22Z"/>
</g>
<rect class="cls-2" y="0" width="24" height="24"/>
</svg>`;
const lineIcon = w `<svg id="Laag_1" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<defs>
  <style>
    .cls-1 {
      fill: currentColor;
    }

    .cls-1, .cls-2 {
      stroke-width: 0px;
    }

    .cls-2 {
      fill: currentColor;
      opacity: 0;
    }
  </style>
</defs>
<path class="cls-1" d="M14.39,11.93l-1.39.58v-1.84l2.15-.89c.51-.21.75-.8.54-1.31-.21-.51-.8-.75-1.31-.54l-1.39.58V3c0-.55-.45-1-1-1s-1,.45-1,1v6.33l-2.15.89c-.51.21-.75.8-.54,1.31.21.51.8.75,1.31.54l1.39-.58v1.84l-2.15.89c-.51.21-.75.8-.54,1.31.21.51.8.75,1.31.54l1.39-.58v5.5c0,.55.45,1,1,1s1-.45,1-1v-6.33l2.15-.89c.51-.21.75-.8.54-1.31-.21-.51-.8-.75-1.31-.54Z"/>
<rect class="cls-2" width="24" height="24"/>
</svg>`;
const processIcon = w `<svg id="Laag_1" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<defs>
  <style>
    .cls-1 {
      fill: currentColor;
    }

    .cls-1, .cls-2 {
      stroke-width: 0px;
    }

    .cls-2 {
      fill: currentColor;
      opacity: 0;
    }
  </style>
</defs>
<path class="cls-1" d="M18.71,15.29c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l.29.29h-5.59c0-1.1-.9-2-2-2h-2c-1.01,0-1.84.76-1.97,1.74-.61-.34-1.03-.99-1.03-1.74,0-1.1.9-2,2-2h5c0,1.1.9,2,2,2h2c1.1,0,2-.9,2-2v-.14c1.72-.45,3-2,3-3.86,0-2.21-1.79-4-4-4h-5c0-1.1-.9-2-2-2h-2c-1.1,0-2,.9-2,2h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c0,1.1.9,2,2,2h2c1.1,0,2-.9,2-2h5c1.1,0,2,.9,2,2,0,.75-.42,1.39-1.03,1.74-.13-.98-.96-1.74-1.97-1.74h-2c-1.1,0-2,.9-2,2h-5c-2.21,0-4,1.79-4,4,0,1.86,1.28,3.41,3,3.86v.14c0,1.1.9,2,2,2h2c1.1,0,2-.9,2-2h5.59l-.29.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l2-2c.39-.39.39-1.02,0-1.41l-2-2ZM8,7v-2h2v2s-2,0-2,0ZM14,11h2v2s-2,0-2,0v-2ZM8,19v-2h2v2s-2,0-2,0Z"/>
<rect class="cls-2" y="0" width="24" height="24"/>
</svg>`;
const transformerWindingIcon = w `<svg id="Laag_1" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<defs>
  <style>
    .cls-1 {
      fill: currentColor;
    }

    .cls-1, .cls-2 {
      stroke-width: 0px;
    }

    .cls-2 {
      fill: currentColor;
      opacity: 0;
    }
  </style>
</defs>
<g>
  <path class="cls-1" d="M19,20h-2c-1.21,0-2.18-1.09-1.97-2.34.16-.98,1.09-1.66,2.08-1.66h-.11c.55,0,1-.45,1-1s-.42-.96-.95-.99c.04,0,.08-.01.12-.01h-.17c-1.21,0-2.18-1.09-1.97-2.34.16-.98,1.09-1.66,2.08-1.66h-.11c.55,0,1-.45,1-1s-.42-.96-.95-.99c.04,0,.08-.01.12-.01h-.17c-1.21,0-2.18-1.09-1.97-2.34.16-.98,1.09-1.66,2.08-1.66h1.89c.55,0,1-.45,1-1s-.45-1-1-1h-1.83c-2.09,0-3.95,1.53-4.15,3.61-.13,1.37.44,2.59,1.38,3.41-.76.64-1.28,1.55-1.38,2.59-.13,1.37.44,2.59,1.38,3.41-.76.64-1.28,1.55-1.38,2.59-.23,2.39,1.64,4.39,3.98,4.39h2c.55,0,1-.45,1-1s-.45-1-1-1Z"/>
  <path class="cls-1" d="M10.98,6.39c.23-2.39-1.64-4.39-3.98-4.39h-2c-.55,0-1,.45-1,1s.45,1,1,1h2c1.21,0,2.18,1.09,1.97,2.34-.16.98-1.09,1.66-2.08,1.66h.11c-.55,0-1,.45-1,1s.42.96.95.99c-.04,0-.08.01-.12.01h.17c1.21,0,2.18,1.09,1.97,2.34-.16.98-1.09,1.66-2.08,1.66h.11c-.55,0-1,.45-1,1,0,.28.11.53.29.71.17.17.4.27.65.28h0s.03.01.05.01c1.21,0,2.18,1.09,1.97,2.34-.16.98-1.09,1.66-2.08,1.66h-1.89c-.55,0-1,.45-1,1s.45,1,1,1h1.83c2.09,0,3.95-1.53,4.15-3.61.13-1.37-.44-2.59-1.38-3.41.76-.64,1.28-1.55,1.38-2.59.13-1.37-.44-2.59-1.38-3.41.76-.64,1.28-1.55,1.38-2.59Z"/>
  <path class="cls-1" d="M6.83,16h.17s-.03,0-.05-.01c-.04,0-.08.01-.12.01Z"/>
</g>
<rect class="cls-2" width="24" height="24"/>
</svg>`;

const accessPointIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M4.93,4.93C3.12,6.74 2,9.24 2,12C2,14.76 3.12,17.26 4.93,19.07L6.34,17.66C4.89,16.22 4,14.22 4,12C4,9.79 4.89,7.78 6.34,6.34L4.93,4.93M19.07,4.93L17.66,6.34C19.11,7.78 20,9.79 20,12C20,14.22 19.11,16.22 17.66,17.66L19.07,19.07C20.88,17.26 22,14.76 22,12C22,9.24 20.88,6.74 19.07,4.93M7.76,7.76C6.67,8.85 6,10.35 6,12C6,13.65 6.67,15.15 7.76,16.24L9.17,14.83C8.45,14.11 8,13.11 8,12C8,10.89 8.45,9.89 9.17,9.17L7.76,7.76M16.24,7.76L14.83,9.17C15.55,9.89 16,10.89 16,12C16,13.11 15.55,14.11 14.83,14.83L16.24,16.24C17.33,15.15 18,13.65 18,12C18,10.35 17.33,8.85 16.24,7.76M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z" />
</svg>`;
const serverIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z" />
</svg>`;
const logicalDeviceIcon = w `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
<path fill="currentColor" d="M13,13H18V15H13M13,9H18V11H13M6.91,7.41L11.5,12L6.91,16.6L5.5,15.18L8.68,12L5.5,8.82M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z" />
</svg>`;

const systemLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H11V15H15V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const automationLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M11,7H13A2,2 0 0,1 15,9V17H13V13H11V17H9V9A2,2 0 0,1 11,7M11,9V11H13V9H11M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z" />
</svg>`;
const controlLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M11,7H13A2,2 0 0,1 15,9V10H13V9H11V15H13V14H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const functionalLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H15V9H11V11H14V13H11V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const generalLogicalNode = w `<svg  viewBox="0 0 24 24">
    <path fill="currentColor" d="M11,7H15V9H11V15H13V11H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const interfacingLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,7V9H13V15H14V17H10V15H11V9H10V7H14M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const nonElectricalLogicalNode = w `<svg viewBox="0 0 24 24">
<path fill="currentColor" d="M9,7H11V10.33L13,7H15L12,12L15,17H13L11,13.67V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const measurementLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H15A2,2 0 0,1 17,9V17H15V9H13V16H11V9H9V17H7V9A2,2 0 0,1 9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const protectionLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H13A2,2 0 0,1 15,9V11A2,2 0 0,1 13,13H11V17H9V7M11,9V11H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const qualityLogicalNode = w `<svg  viewBox="0 0 24 24">
    <path fill="currentColor" d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17V19H11V17A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11Z" />
</svg>`;
const protectionRelatedLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H13A2,2 0 0,1 15,9V11C15,11.84 14.5,12.55 13.76,12.85L15,17H13L11.8,13H11V17H9V7M11,9V11H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,16.41 7.58,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const supervisionLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M11,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H9V15H13V13H11A2,2 0 0,1 9,11V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const transformerLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H15V9H13V17H11V9H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const switchgearLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H11L12,9.5L13,7H15L13,12L15,17H13L12,14.5L11,17H9L11,12L9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const powerTransformerLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H11L12,10L13,7H15L13,13V17H11V13L9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;
const furtherPowerSystemEquipmentLogicalNode = w `<svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M9,7H15V9L11,15H15V17H9V15L13,9H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>`;

/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
function pathToSvg(type) {
    return w `<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 26.5 24"
    width="24"
  >
    ${pathsSVG[type]}
  </svg> `;
}
const SCL_ICONS = {
    elementIcon: elementIcon,
    attributeIcon: attributeIcon,
    contentIcon: contentIcon,
    editIcon: editIcon,
    gooseIcon: gooseIcon,
    reportIcon: reportIcon,
    smvIcon: smvIcon,
    dataSetIcon: dataSetIcon,
    logIcon: logIcon,
    inputIcon: inputIcon,
    clientIcon: clientIcon,
    disconnect: disconnect,
    networkConfigIcon: networkConfigIcon,
    zeroLineIcon: zeroLineIcon,
    voltageLevelIcon: voltageLevelIcon,
    bayIcon: bayIcon,
    disconnectorIcon: disconnectorIcon,
    circuitBreakerIcon: circuitBreakerIcon,
    currentTransformerIcon: currentTransformerIcon,
    voltageTransformerIcon: voltageTransformerIcon,
    earthSwitchIcon: earthSwitchIcon,
    generalConductingEquipmentIcon: generalConductingEquipmentIcon,
    connectivityNodeIcon: connectivityNodeIcon,
    powerTransformerTwoWindingIcon: powerTransformerTwoWindingIcon,
    openSCDIcon: openSCDIcon,
    sizableSmvIcon: sizableSmvIcon,
    sizableGooseIcon: sizableGooseIcon,
    substationIcon: substationIcon,
    lineIcon: lineIcon,
    processIcon: processIcon,
    transformerWindingIcon: transformerWindingIcon,
    accessPointIcon: accessPointIcon,
    serverIcon: serverIcon,
    logicalDeviceIcon: logicalDeviceIcon,
    systemLogicalNode: systemLogicalNode,
    automationLogicalNode: automationLogicalNode,
    controlLogicalNode: controlLogicalNode,
    functionalLogicalNode: functionalLogicalNode,
    generalLogicalNode: generalLogicalNode,
    interfacingLogicalNode: interfacingLogicalNode,
    nonElectricalLogicalNode: nonElectricalLogicalNode,
    measurementLogicalNode: measurementLogicalNode,
    protectionLogicalNode: protectionLogicalNode,
    qualityLogicalNode: qualityLogicalNode,
    protectionRelatedLogicalNode: protectionRelatedLogicalNode,
    supervisionLogicalNode: supervisionLogicalNode,
    transformerLogicalNode: transformerLogicalNode,
    switchgearLogicalNode: switchgearLogicalNode,
    powerTransformerLogicalNode: powerTransformerLogicalNode,
    furtherPowerSystemEquipmentLogicalNode: furtherPowerSystemEquipmentLogicalNode,
    ...Object.keys(pathsSVG).reduce((acc, key) => {
        acc[key] = pathToSvg(key);
        return acc;
    }, {}),
};
({
    DAType: pathToSvg('dAIcon'),
    DOType: pathToSvg('dOIcon'),
    EnumType: pathToSvg('enumIcon'),
    LNodeType: pathToSvg('lNIcon'),
});

/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Internal Icon base class that extends the Material Design Icon with
 * automatic SCL icon resolution.
 *
 * When the text content of the element matches a key in {@link SCL_ICONS},
 * the corresponding SVG is rendered instead of the default Material Symbols
 * font ligature. If no match is found the element falls through to the
 * standard `<slot></slot>` rendering from the Material base class so that
 * Material Symbols font ligatures continue to work as before.
 */
class Icon extends Icon$1 {
    constructor() {
        super(...arguments);
        this._sclName = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this._updateSclName();
        this._observer = new MutationObserver(() => {
            this._updateSclName();
        });
        this._observer.observe(this, {
            characterData: true,
            subtree: true,
            childList: true,
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._observer?.disconnect();
        this._observer = undefined;
    }
    _updateSclName() {
        const name = (this.textContent ?? '').trim();
        if (name !== this._sclName) {
            this._sclName = name;
            this.requestUpdate();
        }
    }
    render() {
        const sclSvg = SCL_ICONS[this._sclName];
        if (sclSvg) {
            return b `${sclSvg}`;
        }
        return super.render();
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./icon/internal/icon-styles.css.
const styles$h = i$7 `:host{font-size:var(--md-icon-size, 24px);width:var(--md-icon-size, 24px);height:var(--md-icon-size, 24px);color:inherit;font-variation-settings:inherit;font-weight:400;font-family:var(--md-icon-font, Material Symbols Outlined);display:inline-flex;font-style:normal;place-items:center;place-content:center;line-height:1;overflow:hidden;letter-spacing:normal;text-transform:none;user-select:none;white-space:nowrap;word-wrap:normal;flex-shrink:0;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale}::slotted(svg){fill:currentColor}::slotted(*){height:100%;width:100%}
`;

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Icon component that renders SCL domain icons by name or falls back to
 * Material Symbols font ligatures.
 *
 * @example
 * ```html
 * <!-- SCL icon by name -->
 * <oscd-icon>gooseIcon</oscd-icon>
 *
 * <!-- Material Symbols ligature (unchanged) -->
 * <oscd-icon>edit</oscd-icon>
 * ```
 *
 * @tagname oscd-icon
 * @final
 * @suppress {visibility}
 */
class OscdIcon extends Icon {
}
/** @nocollapse */
OscdIcon.styles = [styles$h];

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Returns `true` if the given element is in a right-to-left direction.
 *
 * @param el Element to determine direction from
 * @param shouldCheck Optional. If `false`, return `false` without checking
 *     direction. Determining the direction of `el` is somewhat expensive, so
 *     this parameter can be used as a conditional guard. Defaults to `true`.
 */
function isRtl(el, shouldCheck = true) {
    return (shouldCheck &&
        getComputedStyle(el).getPropertyValue('direction').trim() === 'rtl');
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A symbol used to access dispatch hooks on an event.
 */
const dispatchHooks = Symbol('dispatchHooks');
/**
 * Add a hook for an event that is called after the event is dispatched and
 * propagates to other event listeners.
 *
 * This is useful for behaviors that need to check if an event is canceled.
 *
 * The callback is invoked synchronously, which allows for better integration
 * with synchronous platform APIs (like `<form>` or `<label>` clicking).
 *
 * Note: `setupDispatchHooks()` must be called on the element before adding any
 * other event listeners. Call it in the constructor of an element or
 * controller.
 *
 * @example
 * ```ts
 * class MyControl extends LitElement {
 *   constructor() {
 *     super();
 *     setupDispatchHooks(this, 'click');
 *     this.addEventListener('click', event => {
 *       afterDispatch(event, () => {
 *         if (event.defaultPrevented) {
 *           return
 *         }
 *
 *         // ... perform logic
 *       });
 *     });
 *   }
 * }
 * ```
 *
 * @example
 * ```ts
 * class MyController implements ReactiveController {
 *   constructor(host: ReactiveElement) {
 *     // setupDispatchHooks() may be called multiple times for the same
 *     // element and events, making it safe for multiple controllers to use it.
 *     setupDispatchHooks(host, 'click');
 *     host.addEventListener('click', event => {
 *       afterDispatch(event, () => {
 *         if (event.defaultPrevented) {
 *           return;
 *         }
 *
 *         // ... perform logic
 *       });
 *     });
 *   }
 * }
 * ```
 *
 * @param event The event to add a hook to.
 * @param callback A hook that is called after the event finishes dispatching.
 */
function afterDispatch(event, callback) {
    const hooks = event[dispatchHooks];
    if (!hooks) {
        throw new Error(`'${event.type}' event needs setupDispatchHooks().`);
    }
    hooks.addEventListener('after', callback, { once: true });
}
/**
 * A lookup map of elements and event types that have a dispatch hook listener
 * set up. Used to ensure we don't set up multiple hook listeners on the same
 * element for the same event.
 */
const ELEMENT_DISPATCH_HOOK_TYPES = new WeakMap();
/**
 * Sets up an element to add dispatch hooks to given event types. This must be
 * called before adding any event listeners that need to use dispatch hooks
 * like `afterDispatch()`.
 *
 * This function is safe to call multiple times with the same element or event
 * types. Call it in the constructor of elements, mixins, and controllers to
 * ensure it is set up before external listeners.
 *
 * @example
 * ```ts
 * class MyControl extends LitElement {
 *   constructor() {
 *     super();
 *     setupDispatchHooks(this, 'click');
 *     this.addEventListener('click', this.listenerUsingAfterDispatch);
 *   }
 * }
 * ```
 *
 * @param element The element to set up event dispatch hooks for.
 * @param eventTypes The event types to add dispatch hooks to.
 */
function setupDispatchHooks(element, ...eventTypes) {
    let typesAlreadySetUp = ELEMENT_DISPATCH_HOOK_TYPES.get(element);
    if (!typesAlreadySetUp) {
        typesAlreadySetUp = new Set();
        ELEMENT_DISPATCH_HOOK_TYPES.set(element, typesAlreadySetUp);
    }
    for (const eventType of eventTypes) {
        // Don't register multiple dispatch hook listeners. A second registration
        // would lead to the second listener calling `afterDispatch()` hooks twice.
        if (typesAlreadySetUp.has(eventType)) {
            continue;
        }
        element.addEventListener(eventType, (event) => {
            // Add hooks onto the event.
            const hooks = new EventTarget();
            event[dispatchHooks] = hooks;
            const cleanupLastNodeListener = new AbortController();
            const callAfterDispatch = () => {
                cleanupLastNodeListener.abort();
                hooks.dispatchEvent(new Event('after'));
            };
            const patchStopPropagation = (superMethod) => {
                return function () {
                    superMethod.call(this);
                    // Synchronously call afterDispatch() hooks when interrupted.
                    callAfterDispatch();
                };
            };
            event.stopPropagation = patchStopPropagation(event.stopPropagation);
            event.stopImmediatePropagation = patchStopPropagation(event.stopImmediatePropagation);
            // Add an event listener to detect the end of the event's propagation.
            const composedPath = event.composedPath();
            let lastNodeForEvent;
            if (event.composed && event.bubbles) {
                lastNodeForEvent = composedPath[composedPath.length - 1];
            }
            else if (!event.bubbles) {
                lastNodeForEvent = composedPath[0];
            }
            else {
                lastNodeForEvent = composedPath[0].getRootNode();
            }
            lastNodeForEvent.addEventListener(eventType, () => {
                // Synchronously call afterDispatch() hooks.
                callAfterDispatch();
            }, { once: true, signal: cleanupLastNodeListener.signal });
        }, {
            // Ensure this listener runs before other listeners.
            // `setupDispatchHooks()` should be called in constructors to also
            // ensure they run before any other externally-added capture listeners.
            capture: true,
        });
        typesAlreadySetUp.add(eventType);
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A unique symbol used for protected access to an instance's
 * `ElementInternals`.
 *
 * @example
 * ```ts
 * class MyElement extends mixinElementInternals(LitElement) {
 *   constructor() {
 *     super();
 *     this[internals].role = 'button';
 *   }
 * }
 * ```
 */
const internals = Symbol('internals');
// Private symbols
const privateInternals = Symbol('privateInternals');
/**
 * Mixes in an attached `ElementInternals` instance.
 *
 * This mixin is only needed when other shared code needs access to a
 * component's `ElementInternals`, such as form-associated mixins.
 *
 * @param base The class to mix functionality into.
 * @return The provided class with `WithElementInternals` mixed in.
 */
function mixinElementInternals(base) {
    class WithElementInternalsElement extends base {
        get [internals]() {
            // Create internals in getter so that it can be used in methods called on
            // construction in `ReactiveElement`, such as `requestUpdate()`.
            if (!this[privateInternals]) {
                // Cast needed for closure
                this[privateInternals] = this.attachInternals();
            }
            return this[privateInternals];
        }
    }
    return WithElementInternalsElement;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A symbol property to retrieve the form value for an element.
 */
const getFormValue = Symbol('getFormValue');
/**
 * A symbol property to retrieve the form state for an element.
 */
const getFormState = Symbol('getFormState');
/**
 * Mixes in form-associated behavior for a class. This allows an element to add
 * values to `<form>` elements.
 *
 * Implementing classes should provide a `[formValue]` to return the current
 * value of the element, as well as reset and restore callbacks.
 *
 * @example
 * ```ts
 * const base = mixinFormAssociated(mixinElementInternals(LitElement));
 *
 * class MyControl extends base {
 *   \@property()
 *   value = '';
 *
 *   override [getFormValue]() {
 *     return this.value;
 *   }
 *
 *   override formResetCallback() {
 *     const defaultValue = this.getAttribute('value');
 *     this.value = defaultValue;
 *   }
 *
 *   override formStateRestoreCallback(state: string) {
 *     this.value = state;
 *   }
 * }
 * ```
 *
 * Elements may optionally provide a `[formState]` if their values do not
 * represent the state of the component.
 *
 * @example
 * ```ts
 * const base = mixinFormAssociated(mixinElementInternals(LitElement));
 *
 * class MyCheckbox extends base {
 *   \@property()
 *   value = 'on';
 *
 *   \@property({type: Boolean})
 *   checked = false;
 *
 *   override [getFormValue]() {
 *     return this.checked ? this.value : null;
 *   }
 *
 *   override [getFormState]() {
 *     return String(this.checked);
 *   }
 *
 *   override formResetCallback() {
 *     const defaultValue = this.hasAttribute('checked');
 *     this.checked = defaultValue;
 *   }
 *
 *   override formStateRestoreCallback(state: string) {
 *     this.checked = Boolean(state);
 *   }
 * }
 * ```
 *
 * @param base The class to mix functionality into. The base class must use
 *     `mixinElementInternals()`.
 * @return The provided class with `FormAssociated` mixed in.
 */
function mixinFormAssociated(base) {
    class FormAssociatedElement extends base {
        get form() {
            return this[internals].form;
        }
        get labels() {
            return this[internals].labels;
        }
        // Use @property for the `name` and `disabled` properties to add them to the
        // `observedAttributes` array and trigger `attributeChangedCallback()`.
        //
        // We don't use Lit's default getter/setter (`noAccessor: true`) because
        // the attributes need to be updated synchronously to work with synchronous
        // form APIs, and Lit updates attributes async by default.
        get name() {
            return this.getAttribute('name') ?? '';
        }
        set name(name) {
            // Note: setting name to null or empty does not remove the attribute.
            this.setAttribute('name', name);
            // We don't need to call `requestUpdate()` since it's called synchronously
            // in `attributeChangedCallback()`.
        }
        get disabled() {
            return this.hasAttribute('disabled');
        }
        set disabled(disabled) {
            // Coerce `disabled` in `Boolean()` to ensure that setting to `null` or
            // `undefined` sets the attribute to `false`.
            this.toggleAttribute('disabled', Boolean(disabled));
            // We don't need to call `requestUpdate()` since it's called synchronously
            // in `attributeChangedCallback()`.
        }
        attributeChangedCallback(name, old, value) {
            // Manually `requestUpdate()` for `name` and `disabled` when their
            // attribute or property changes.
            // The properties update their attributes, so this callback is invoked
            // immediately when the properties are set. We call `requestUpdate()` here
            // instead of letting Lit set the properties from the attribute change.
            // That would cause the properties to re-set the attribute and invoke this
            // callback again in a loop. This leads to stale state when Lit tries to
            // determine if a property changed or not.
            if (name === 'name' || name === 'disabled') {
                // Disabled's value is only false if the attribute is missing and null.
                const oldValue = name === 'disabled' ? old !== null : old;
                // Trigger a lit update when the attribute changes.
                this.requestUpdate(name, oldValue);
                return;
            }
            super.attributeChangedCallback(name, old, value);
        }
        requestUpdate(name, oldValue, options) {
            super.requestUpdate(name, oldValue, options);
            // If any properties change, update the form value, which may have changed
            // as well.
            // Update the form value synchronously in `requestUpdate()` rather than
            // `update()` or `updated()`, which are async. This is necessary to ensure
            // that form data is updated in time for synchronous event listeners.
            this[internals].setFormValue(this[getFormValue](), this[getFormState]());
        }
        [getFormValue]() {
            return this.getAttribute('value');
        }
        [getFormState]() {
            return this[getFormValue]();
        }
        formDisabledCallback(disabled) {
            this.disabled = disabled;
        }
    }
    /** @nocollapse */
    FormAssociatedElement.formAssociated = true;
    __decorate([
        n$3({ noAccessor: true })
    ], FormAssociatedElement.prototype, "name", null);
    __decorate([
        n$3({ type: Boolean, noAccessor: true })
    ], FormAssociatedElement.prototype, "disabled", null);
    return FormAssociatedElement;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Mixes in form submitter behavior for a class.
 *
 * A click listener is added to each element instance. If the click is not
 * default prevented, it will submit the element's form, if any.
 *
 * @example
 * ```ts
 * const base = mixinFormSubmitter(mixinElementInternals(LitElement));
 * class MyButton extends base {
 *   static formAssociated = true;
 * }
 * ```
 *
 * @param base The class to mix functionality into.
 * @return The provided class with `FormSubmitter` mixed in.
 */
function mixinFormSubmitter(base) {
    class FormSubmitterElement extends base {
        // Name attribute must reflect synchronously for form integration.
        get name() {
            return this.getAttribute('name') ?? '';
        }
        set name(name) {
            this.setAttribute('name', name);
        }
        // Mixins must have a constructor with `...args: any[]`
        // tslint:disable-next-line:no-any
        constructor(...args) {
            super(...args);
            this.type = 'submit';
            this.value = '';
            setupDispatchHooks(this, 'click');
            this.addEventListener('click', async (event) => {
                const isReset = this.type === 'reset';
                const isSubmit = this.type === 'submit';
                const elementInternals = this[internals];
                const { form } = elementInternals;
                if (!form || !(isSubmit || isReset)) {
                    return;
                }
                afterDispatch(event, () => {
                    if (event.defaultPrevented) {
                        return;
                    }
                    if (isReset) {
                        form.reset();
                        return;
                    }
                    // form.requestSubmit(submitter) does not work with form associated custom
                    // elements. This patches the dispatched submit event to add the correct
                    // `submitter`.
                    // See https://github.com/WICG/webcomponents/issues/814
                    form.addEventListener('submit', (submitEvent) => {
                        Object.defineProperty(submitEvent, 'submitter', {
                            configurable: true,
                            enumerable: true,
                            get: () => this,
                        });
                    }, { capture: true, once: true });
                    elementInternals.setFormValue(this.value);
                    form.requestSubmit();
                });
            });
        }
    }
    __decorate([
        n$3()
    ], FormSubmitterElement.prototype, "type", void 0);
    __decorate([
        n$3({ reflect: true })
    ], FormSubmitterElement.prototype, "value", void 0);
    return FormSubmitterElement;
}

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const iconButtonBaseClass = mixinDelegatesAria(mixinFormSubmitter(mixinFormAssociated(mixinElementInternals(i$4))));
/**
 * A button for rendering icons.
 *
 * @fires input {InputEvent} Dispatched when a toggle button toggles --bubbles
 * --composed
 * @fires change {Event} Dispatched when a toggle button toggles --bubbles
 */
class IconButton extends iconButtonBaseClass {
    constructor() {
        super();
        /**
         * "Soft-disables" the icon button (disabled but still focusable).
         *
         * Use this when an icon button needs increased visibility when disabled. See
         * https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_disabled_controls
         * for more guidance on when this is needed.
         */
        this.softDisabled = false;
        /**
         * Flips the icon if it is in an RTL context at startup.
         */
        this.flipIconInRtl = false;
        /**
         * Sets the underlying `HTMLAnchorElement`'s `href` resource attribute.
         */
        this.href = '';
        /**
         * The filename to use when downloading the linked resource.
         * If not specified, the browser will determine a filename.
         * This is only applicable when the icon button is used as a link (`href` is set).
         */
        this.download = '';
        /**
         * Sets the underlying `HTMLAnchorElement`'s `target` attribute.
         */
        this.target = '';
        /**
         * The `aria-label` of the button when the button is toggleable and selected.
         */
        this.ariaLabelSelected = '';
        /**
         * When true, the button will toggle between selected and unselected
         * states
         */
        this.toggle = false;
        /**
         * Sets the selected state. When false, displays the default icon. When true,
         * displays the selected icon, or the default icon If no `slot="selected"`
         * icon is provided.
         */
        this.selected = false;
        this.flipIcon = isRtl(this, this.flipIconInRtl);
        setupDispatchHooks(this, 'click');
        this.addEventListener('click', (event) => {
            // If the button is soft-disabled or a disabled link, we need to
            // explicitly prevent the click from propagating to other event listeners
            // as well as prevent the default action. This is because the underlying
            // `<button>` or `<a>` element is not actually `:disabled`.
            if (this.softDisabled || (this.disabled && this.href)) {
                event.stopImmediatePropagation();
                event.preventDefault();
                return;
            }
            // Save current selected state to toggle, since an external event listener
            // may also change the selected state on click.
            const wasSelected = this.selected;
            afterDispatch(event, () => {
                if (!this.toggle || this.disabled || event.defaultPrevented) {
                    return;
                }
                this.selected = !wasSelected;
                this.dispatchEvent(new InputEvent('input', { bubbles: true, composed: true }));
                // Bubbles but does not compose to mimic native browser <input> & <select>
                // Additionally, native change event is not an InputEvent.
                this.dispatchEvent(new Event('change', { bubbles: true }));
            });
        });
    }
    willUpdate() {
        // Link buttons cannot be disabled or soft-disabled.
        if (this.href) {
            this.disabled = false;
            this.softDisabled = false;
        }
    }
    render() {
        const tag = this.href ? i `div` : i `button`;
        // Needed for closure conformance
        const { ariaLabel, ariaHasPopup, ariaExpanded } = this;
        const hasToggledAriaLabel = ariaLabel && this.ariaLabelSelected;
        const ariaPressedValue = !this.toggle ? A : this.selected;
        let ariaLabelValue = A;
        if (!this.href) {
            ariaLabelValue =
                hasToggledAriaLabel && this.selected
                    ? this.ariaLabelSelected
                    : ariaLabel;
        }
        return u `<${tag}
        class="icon-button ${e(this.getRenderClasses())}"
        id="button"
        aria-label="${ariaLabelValue || A}"
        aria-haspopup="${(!this.href && ariaHasPopup) || A}"
        aria-expanded="${(!this.href && ariaExpanded) || A}"
        aria-pressed="${ariaPressedValue}"
        aria-disabled=${(!this.href && this.softDisabled) || A}
        ?disabled="${!this.href && this.disabled}">
        ${this.renderFocusRing()}
        ${this.renderRipple()}
        ${!this.selected ? this.renderIcon() : A}
        ${this.selected ? this.renderSelectedIcon() : A}
        ${this.href ? this.renderLink() : this.renderTouchTarget()}
  </${tag}>`;
    }
    renderLink() {
        // Needed for closure conformance
        const { ariaLabel } = this;
        return b `
      <a
        class="link"
        id="link"
        href="${this.href}"
        download="${this.download || A}"
        target="${this.target || A}"
        aria-label="${ariaLabel || A}">
        ${this.renderTouchTarget()}
      </a>
    `;
    }
    getRenderClasses() {
        return {
            'flip-icon': this.flipIcon,
            'selected': this.toggle && this.selected,
        };
    }
    renderIcon() {
        return b `<span class="icon"><slot></slot></span>`;
    }
    renderSelectedIcon() {
        // Use default slot as fallback to not require specifying multiple icons
        return b `<span class="icon icon--selected"
      ><slot name="selected"><slot></slot></slot
    ></span>`;
    }
    renderTouchTarget() {
        return b `<span class="touch"></span>`;
    }
    renderFocusRing() {
        // TODO(b/310046938): use the same id for both elements
        return b `<md-focus-ring
      part="focus-ring"
      for=${this.href ? 'link' : 'button'}></md-focus-ring>`;
    }
    renderRipple() {
        const isRippleDisabled = !this.href && (this.disabled || this.softDisabled);
        // TODO(b/310046938): use the same id for both elements
        return b `<md-ripple
      for=${this.href ? 'link' : A}
      ?disabled="${isRippleDisabled}"></md-ripple>`;
    }
    connectedCallback() {
        this.flipIcon = isRtl(this, this.flipIconInRtl);
        super.connectedCallback();
    }
}
/** @nocollapse */
IconButton.shadowRootOptions = {
    mode: 'open',
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, attribute: 'soft-disabled', reflect: true })
], IconButton.prototype, "softDisabled", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'flip-icon-in-rtl' })
], IconButton.prototype, "flipIconInRtl", void 0);
__decorate([
    n$3()
], IconButton.prototype, "href", void 0);
__decorate([
    n$3()
], IconButton.prototype, "download", void 0);
__decorate([
    n$3()
], IconButton.prototype, "target", void 0);
__decorate([
    n$3({ attribute: 'aria-label-selected' })
], IconButton.prototype, "ariaLabelSelected", void 0);
__decorate([
    n$3({ type: Boolean })
], IconButton.prototype, "toggle", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], IconButton.prototype, "selected", void 0);
__decorate([
    r$2()
], IconButton.prototype, "flipIcon", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./iconbutton/internal/shared-styles.css.
const styles$g = i$7 `:host{display:inline-flex;outline:none;-webkit-tap-highlight-color:rgba(0,0,0,0);height:var(--_container-height);width:var(--_container-width);justify-content:center}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_container-height))/2) max(0px,(48px - var(--_container-width))/2)}md-focus-ring{--md-focus-ring-shape-start-start: var(--_container-shape-start-start);--md-focus-ring-shape-start-end: var(--_container-shape-start-end);--md-focus-ring-shape-end-end: var(--_container-shape-end-end);--md-focus-ring-shape-end-start: var(--_container-shape-end-start)}:host(:is([disabled],[soft-disabled])){pointer-events:none}.icon-button{place-items:center;background:none;border:none;box-sizing:border-box;cursor:pointer;display:flex;place-content:center;outline:none;padding:0;position:relative;text-decoration:none;user-select:none;z-index:0;flex:1;border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-start-radius:var(--_container-shape-end-start);border-end-end-radius:var(--_container-shape-end-end)}.icon ::slotted(*){font-size:var(--_icon-size);height:var(--_icon-size);width:var(--_icon-size);font-weight:inherit}md-ripple{z-index:-1;border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-start-radius:var(--_container-shape-end-start);border-end-end-radius:var(--_container-shape-end-end)}.flip-icon .icon{transform:scaleX(-1)}.icon{display:inline-flex}.link{display:grid;height:100%;outline:none;place-items:center;position:absolute;width:100%}.touch{position:absolute;height:max(48px,100%);width:max(48px,100%)}:host([touch-target=none]) .touch{display:none}@media(forced-colors: active){:host(:is([disabled],[soft-disabled])){--_disabled-icon-color: GrayText;--_disabled-icon-opacity: 1}}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./iconbutton/internal/standard-styles.css.
const styles$f = i$7 `:host{--_disabled-icon-color: var(--md-icon-button-disabled-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-icon-opacity: var(--md-icon-button-disabled-icon-opacity, 0.38);--_icon-size: var(--md-icon-button-icon-size, 24px);--_selected-focus-icon-color: var(--md-icon-button-selected-focus-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-icon-color: var(--md-icon-button-selected-hover-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-state-layer-color: var(--md-icon-button-selected-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-state-layer-opacity: var(--md-icon-button-selected-hover-state-layer-opacity, 0.08);--_selected-icon-color: var(--md-icon-button-selected-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-icon-color: var(--md-icon-button-selected-pressed-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-state-layer-color: var(--md-icon-button-selected-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-state-layer-opacity: var(--md-icon-button-selected-pressed-state-layer-opacity, 0.12);--_state-layer-height: var(--md-icon-button-state-layer-height, 40px);--_state-layer-shape: var(--md-icon-button-state-layer-shape, var(--md-sys-shape-corner-full, 9999px));--_state-layer-width: var(--md-icon-button-state-layer-width, 40px);--_focus-icon-color: var(--md-icon-button-focus-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-icon-color: var(--md-icon-button-hover-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-color: var(--md-icon-button-hover-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-opacity: var(--md-icon-button-hover-state-layer-opacity, 0.08);--_icon-color: var(--md-icon-button-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-icon-color: var(--md-icon-button-pressed-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-color: var(--md-icon-button-pressed-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-opacity: var(--md-icon-button-pressed-state-layer-opacity, 0.12);--_container-shape-start-start: 0;--_container-shape-start-end: 0;--_container-shape-end-end: 0;--_container-shape-end-start: 0;--_container-height: 0;--_container-width: 0;height:var(--_state-layer-height);width:var(--_state-layer-width)}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_state-layer-height))/2) max(0px,(48px - var(--_state-layer-width))/2)}md-focus-ring{--md-focus-ring-shape-start-start: var(--_state-layer-shape);--md-focus-ring-shape-start-end: var(--_state-layer-shape);--md-focus-ring-shape-end-end: var(--_state-layer-shape);--md-focus-ring-shape-end-start: var(--_state-layer-shape)}.standard{background-color:rgba(0,0,0,0);color:var(--_icon-color);--md-ripple-hover-color: var(--_hover-state-layer-color);--md-ripple-hover-opacity: var(--_hover-state-layer-opacity);--md-ripple-pressed-color: var(--_pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_pressed-state-layer-opacity)}.standard:hover{color:var(--_hover-icon-color)}.standard:focus{color:var(--_focus-icon-color)}.standard:active{color:var(--_pressed-icon-color)}.standard:is(:disabled,[aria-disabled=true]){color:var(--_disabled-icon-color)}md-ripple{border-radius:var(--_state-layer-shape)}.standard:is(:disabled,[aria-disabled=true]){opacity:var(--_disabled-icon-opacity)}.selected{--md-ripple-hover-color: var(--_selected-hover-state-layer-color);--md-ripple-hover-opacity: var(--_selected-hover-state-layer-opacity);--md-ripple-pressed-color: var(--_selected-pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_selected-pressed-state-layer-opacity)}.selected:not(:disabled,[aria-disabled=true]){color:var(--_selected-icon-color)}.selected:not(:disabled,[aria-disabled=true]):hover{color:var(--_selected-hover-icon-color)}.selected:not(:disabled,[aria-disabled=true]):focus{color:var(--_selected-focus-icon-color)}.selected:not(:disabled,[aria-disabled=true]):active{color:var(--_selected-pressed-icon-color)}
`;

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-icon-button
 * @summary Icon buttons help people take supplementary actions with a single
 * tap.
 *
 * __Emphasis:__ Low emphasis – For optional or supplementary actions with the
 * least amount of prominence.
 *
 * __Rationale:__ The most compact and unobtrusive type of button, icon buttons
 * are used for optional supplementary actions such as "Bookmark" or "Star."
 *
 * __Example usages:__
 * - Add to Favorites
 * - Print
 *
 * @final
 * @suppress {visibility}
 */
class OscdIconButton extends ScopedElementsMixin(IconButton) {
    getRenderClasses() {
        return {
            ...super.getRenderClasses(),
            standard: true,
        };
    }
}
OscdIconButton.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
};
OscdIconButton.styles = [styles$g, styles$f];

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A divider component.
 */
class Divider extends i$4 {
    constructor() {
        super(...arguments);
        /**
         * Indents the divider with equal padding on both sides.
         */
        this.inset = false;
        /**
         * Indents the divider with padding on the leading side.
         */
        this.insetStart = false;
        /**
         * Indents the divider with padding on the trailing side.
         */
        this.insetEnd = false;
    }
}
__decorate([
    n$3({ type: Boolean, reflect: true })
], Divider.prototype, "inset", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true, attribute: 'inset-start' })
], Divider.prototype, "insetStart", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true, attribute: 'inset-end' })
], Divider.prototype, "insetEnd", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./divider/internal/divider-styles.css.
const styles$e = i$7 `:host{box-sizing:border-box;color:var(--md-divider-color, var(--md-sys-color-outline-variant, #cac4d0));display:flex;height:var(--md-divider-thickness, 1px);width:100%}:host([inset]),:host([inset-start]){padding-inline-start:16px}:host([inset]),:host([inset-end]){padding-inline-end:16px}:host::before{background:currentColor;content:"";height:100%;width:100%}@media(forced-colors: active){:host::before{background:CanvasText}}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-divider
 * @summary A divider is a thin line that groups content in lists and
 * containers.
 *
 * list items or define tappable regions in an accordion.
 *
 * @final
 * @suppress {visibility}
 */
class OscdDivider extends Divider {
}
OscdDivider.styles = [styles$e];

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A field component.
 */
class Field extends i$4 {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.error = false;
        this.focused = false;
        this.label = '';
        this.noAsterisk = false;
        this.populated = false;
        this.required = false;
        this.resizable = false;
        this.supportingText = '';
        this.errorText = '';
        this.count = -1;
        this.max = -1;
        /**
         * Whether or not the field has leading content.
         */
        this.hasStart = false;
        /**
         * Whether or not the field has trailing content.
         */
        this.hasEnd = false;
        this.isAnimating = false;
        /**
         * When set to true, the error text's `role="alert"` will be removed, then
         * re-added after an animation frame. This will re-announce an error message
         * to screen readers.
         */
        this.refreshErrorAlert = false;
        this.disableTransitions = false;
    }
    get counterText() {
        // Count and max are typed as number, but can be set to null when Lit removes
        // their attributes. These getters coerce back to a number for calculations.
        const countAsNumber = this.count ?? -1;
        const maxAsNumber = this.max ?? -1;
        // Counter does not show if count is negative, or max is negative or 0.
        if (countAsNumber < 0 || maxAsNumber <= 0) {
            return '';
        }
        return `${countAsNumber} / ${maxAsNumber}`;
    }
    get supportingOrErrorText() {
        return this.error && this.errorText ? this.errorText : this.supportingText;
    }
    /**
     * Re-announces the field's error supporting text to screen readers.
     *
     * Error text announces to screen readers anytime it is visible and changes.
     * Use the method to re-announce the message when the text has not changed,
     * but announcement is still needed (such as for `reportValidity()`).
     */
    reannounceError() {
        this.refreshErrorAlert = true;
    }
    update(props) {
        // Client-side property updates
        const isDisabledChanging = props.has('disabled') && props.get('disabled') !== undefined;
        if (isDisabledChanging) {
            this.disableTransitions = true;
        }
        // When disabling, remove focus styles if focused.
        if (this.disabled && this.focused) {
            props.set('focused', true);
            this.focused = false;
        }
        // Animate if focused or populated change.
        this.animateLabelIfNeeded({
            wasFocused: props.get('focused'),
            wasPopulated: props.get('populated'),
        });
        super.update(props);
    }
    render() {
        const floatingLabel = this.renderLabel(/*isFloating*/ true);
        const restingLabel = this.renderLabel(/*isFloating*/ false);
        const outline = this.renderOutline?.(floatingLabel);
        const classes = {
            'disabled': this.disabled,
            'disable-transitions': this.disableTransitions,
            'error': this.error && !this.disabled,
            'focused': this.focused,
            'with-start': this.hasStart,
            'with-end': this.hasEnd,
            'populated': this.populated,
            'resizable': this.resizable,
            'required': this.required,
            'no-label': !this.label,
        };
        return b `
      <div class="field ${e(classes)}">
        <div class="container-overflow">
          ${this.renderBackground?.()}
          <slot name="container"></slot>
          ${this.renderStateLayer?.()} ${this.renderIndicator?.()} ${outline}
          <div class="container">
            <div class="start">
              <slot name="start"></slot>
            </div>
            <div class="middle">
              <div class="label-wrapper">
                ${restingLabel} ${outline ? A : floatingLabel}
              </div>
              <div class="content">
                <slot></slot>
              </div>
            </div>
            <div class="end">
              <slot name="end"></slot>
            </div>
          </div>
        </div>
        ${this.renderSupportingText()}
      </div>
    `;
    }
    updated(changed) {
        if (changed.has('supportingText') ||
            changed.has('errorText') ||
            changed.has('count') ||
            changed.has('max')) {
            this.updateSlottedAriaDescribedBy();
        }
        if (this.refreshErrorAlert) {
            // The past render cycle removed the role="alert" from the error message.
            // Re-add it after an animation frame to re-announce the error.
            requestAnimationFrame(() => {
                this.refreshErrorAlert = false;
            });
        }
        if (this.disableTransitions) {
            requestAnimationFrame(() => {
                this.disableTransitions = false;
            });
        }
    }
    renderSupportingText() {
        const { supportingOrErrorText, counterText } = this;
        if (!supportingOrErrorText && !counterText) {
            return A;
        }
        // Always render the supporting text span so that our `space-around`
        // container puts the counter at the end.
        const start = b `<span>${supportingOrErrorText}</span>`;
        // Conditionally render counter so we don't render the extra `gap`.
        // TODO(b/244473435): add aria-label and announcements
        const end = counterText
            ? b `<span class="counter">${counterText}</span>`
            : A;
        // Announce if there is an error and error text visible.
        // If refreshErrorAlert is true, do not announce. This will remove the
        // role="alert" attribute. Another render cycle will happen after an
        // animation frame to re-add the role.
        const shouldErrorAnnounce = this.error && this.errorText && !this.refreshErrorAlert;
        const role = shouldErrorAnnounce ? 'alert' : A;
        return b `
      <div class="supporting-text" role=${role}>${start}${end}</div>
      <slot
        name="aria-describedby"
        @slotchange=${this.updateSlottedAriaDescribedBy}></slot>
    `;
    }
    updateSlottedAriaDescribedBy() {
        for (const element of this.slottedAriaDescribedBy) {
            D(b `${this.supportingOrErrorText} ${this.counterText}`, element);
            element.setAttribute('hidden', '');
        }
    }
    renderLabel(isFloating) {
        if (!this.label) {
            return A;
        }
        let visible;
        if (isFloating) {
            // Floating label is visible when focused/populated or when animating.
            visible = this.focused || this.populated || this.isAnimating;
        }
        else {
            // Resting label is visible when unfocused. It is never visible while
            // animating.
            visible = !this.focused && !this.populated && !this.isAnimating;
        }
        const classes = {
            'hidden': !visible,
            'floating': isFloating,
            'resting': !isFloating,
        };
        // Add '*' if a label is present and the field is required
        const labelText = `${this.label}${this.required && !this.noAsterisk ? '*' : ''}`;
        return b `
      <span class="label ${e(classes)}" aria-hidden=${!visible}
        >${labelText}</span
      >
    `;
    }
    animateLabelIfNeeded({ wasFocused, wasPopulated, }) {
        if (!this.label) {
            return;
        }
        wasFocused ??= this.focused;
        wasPopulated ??= this.populated;
        const wasFloating = wasFocused || wasPopulated;
        const shouldBeFloating = this.focused || this.populated;
        if (wasFloating === shouldBeFloating) {
            return;
        }
        const keyframes = this.getLabelKeyframes();
        if (!keyframes.length) {
            return;
        }
        this.isAnimating = true;
        this.labelAnimation?.cancel();
        // Only one label is visible at a time for clearer text rendering.
        // The floating label is visible and used during animation. At the end of
        // the animation, it will either remain visible (if floating) or hide and
        // the resting label will be shown.
        //
        // We don't use forward filling because if the dimensions of the text field
        // change (leading icon removed, density changes, etc), then the animation
        // will be inaccurate.
        //
        // Re-calculating the animation each time will prevent any visual glitches
        // from appearing.
        // TODO(b/241113345): use animation tokens
        this.labelAnimation = this.floatingLabelEl?.animate(keyframes, {
            duration: 150,
            easing: EASING.STANDARD,
        });
        this.labelAnimation?.addEventListener('finish', () => {
            // At the end of the animation, update the visible label.
            this.isAnimating = false;
        });
    }
    getLabelKeyframes() {
        const { floatingLabelEl, restingLabelEl } = this;
        if (!floatingLabelEl || !restingLabelEl) {
            return [];
        }
        const { x: floatingX, y: floatingY, height: floatingHeight, } = floatingLabelEl.getBoundingClientRect();
        const { x: restingX, y: restingY, height: restingHeight, } = restingLabelEl.getBoundingClientRect();
        const floatingScrollWidth = floatingLabelEl.scrollWidth;
        const restingScrollWidth = restingLabelEl.scrollWidth;
        // If either label has no dimensions (e.g., display: none), skip animation
        if (floatingScrollWidth === 0 || restingScrollWidth === 0) {
            return [];
        }
        // Scale by width ratio instead of font size since letter-spacing will scale
        // incorrectly. Using the width we can better approximate the adjusted
        // scale and compensate for tracking and overflow.
        // (use scrollWidth instead of width to account for clipped labels)
        const scale = restingScrollWidth / floatingScrollWidth;
        const xDelta = restingX - floatingX;
        // The line-height of the resting and floating label are different. When
        // we move the floating label down to the resting label's position, it won't
        // exactly match because of this. We need to adjust by half of what the
        // final scaled floating label's height will be.
        const yDelta = restingY -
            floatingY +
            Math.round((restingHeight - floatingHeight * scale) / 2);
        // Create the two transforms: floating to resting (using the calculations
        // above), and resting to floating (re-setting the transform to initial
        // values).
        const restTransform = `translateX(${xDelta}px) translateY(${yDelta}px) scale(${scale})`;
        const floatTransform = `translateX(0) translateY(0) scale(1)`;
        // Constrain the floating labels width to a scaled percentage of the
        // resting label's width. This will prevent long clipped labels from
        // overflowing the container.
        const restingClientWidth = restingLabelEl.clientWidth;
        const isRestingClipped = restingScrollWidth > restingClientWidth;
        const width = isRestingClipped ? `${restingClientWidth / scale}px` : '';
        if (this.focused || this.populated) {
            return [
                { transform: restTransform, width },
                { transform: floatTransform, width },
            ];
        }
        return [
            { transform: floatTransform, width },
            { transform: restTransform, width },
        ];
    }
    getSurfacePositionClientRect() {
        return this.containerEl.getBoundingClientRect();
    }
}
__decorate([
    n$3({ type: Boolean })
], Field.prototype, "disabled", void 0);
__decorate([
    n$3({ type: Boolean })
], Field.prototype, "error", void 0);
__decorate([
    n$3({ type: Boolean })
], Field.prototype, "focused", void 0);
__decorate([
    n$3()
], Field.prototype, "label", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-asterisk' })
], Field.prototype, "noAsterisk", void 0);
__decorate([
    n$3({ type: Boolean })
], Field.prototype, "populated", void 0);
__decorate([
    n$3({ type: Boolean })
], Field.prototype, "required", void 0);
__decorate([
    n$3({ type: Boolean })
], Field.prototype, "resizable", void 0);
__decorate([
    n$3({ attribute: 'supporting-text' })
], Field.prototype, "supportingText", void 0);
__decorate([
    n$3({ attribute: 'error-text' })
], Field.prototype, "errorText", void 0);
__decorate([
    n$3({ type: Number })
], Field.prototype, "count", void 0);
__decorate([
    n$3({ type: Number })
], Field.prototype, "max", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-start' })
], Field.prototype, "hasStart", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-end' })
], Field.prototype, "hasEnd", void 0);
__decorate([
    o$2({ slot: 'aria-describedby' })
], Field.prototype, "slottedAriaDescribedBy", void 0);
__decorate([
    r$2()
], Field.prototype, "isAnimating", void 0);
__decorate([
    r$2()
], Field.prototype, "refreshErrorAlert", void 0);
__decorate([
    r$2()
], Field.prototype, "disableTransitions", void 0);
__decorate([
    e$4('.label.floating')
], Field.prototype, "floatingLabelEl", void 0);
__decorate([
    e$4('.label.resting')
], Field.prototype, "restingLabelEl", void 0);
__decorate([
    e$4('.container')
], Field.prototype, "containerEl", void 0);

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * An outlined field component.
 */
class OutlinedField extends Field {
    renderOutline(floatingLabel) {
        return b `
      <div class="outline">
        <div class="outline-start"></div>
        <div class="outline-notch">
          <div class="outline-panel-inactive"></div>
          <div class="outline-panel-active"></div>
          <div class="outline-label">${floatingLabel}</div>
        </div>
        <div class="outline-end"></div>
      </div>
    `;
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./field/internal/outlined-styles.css.
const styles$d = i$7 `@layer styles{:host{--_bottom-space: var(--md-outlined-field-bottom-space, 16px);--_content-color: var(--md-outlined-field-content-color, var(--md-sys-color-on-surface, #1d1b20));--_content-font: var(--md-outlined-field-content-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_content-line-height: var(--md-outlined-field-content-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_content-size: var(--md-outlined-field-content-size, var(--md-sys-typescale-body-large-size, 1rem));--_content-space: var(--md-outlined-field-content-space, 16px);--_content-weight: var(--md-outlined-field-content-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_disabled-content-color: var(--md-outlined-field-disabled-content-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-content-opacity: var(--md-outlined-field-disabled-content-opacity, 0.38);--_disabled-label-text-color: var(--md-outlined-field-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-outlined-field-disabled-label-text-opacity, 0.38);--_disabled-leading-content-color: var(--md-outlined-field-disabled-leading-content-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-leading-content-opacity: var(--md-outlined-field-disabled-leading-content-opacity, 0.38);--_disabled-outline-color: var(--md-outlined-field-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-opacity: var(--md-outlined-field-disabled-outline-opacity, 0.12);--_disabled-outline-width: var(--md-outlined-field-disabled-outline-width, 1px);--_disabled-supporting-text-color: var(--md-outlined-field-disabled-supporting-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-supporting-text-opacity: var(--md-outlined-field-disabled-supporting-text-opacity, 0.38);--_disabled-trailing-content-color: var(--md-outlined-field-disabled-trailing-content-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-trailing-content-opacity: var(--md-outlined-field-disabled-trailing-content-opacity, 0.38);--_error-content-color: var(--md-outlined-field-error-content-color, var(--md-sys-color-on-surface, #1d1b20));--_error-focus-content-color: var(--md-outlined-field-error-focus-content-color, var(--md-sys-color-on-surface, #1d1b20));--_error-focus-label-text-color: var(--md-outlined-field-error-focus-label-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-leading-content-color: var(--md-outlined-field-error-focus-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-focus-outline-color: var(--md-outlined-field-error-focus-outline-color, var(--md-sys-color-error, #b3261e));--_error-focus-supporting-text-color: var(--md-outlined-field-error-focus-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-trailing-content-color: var(--md-outlined-field-error-focus-trailing-content-color, var(--md-sys-color-error, #b3261e));--_error-hover-content-color: var(--md-outlined-field-error-hover-content-color, var(--md-sys-color-on-surface, #1d1b20));--_error-hover-label-text-color: var(--md-outlined-field-error-hover-label-text-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-leading-content-color: var(--md-outlined-field-error-hover-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-hover-outline-color: var(--md-outlined-field-error-hover-outline-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-supporting-text-color: var(--md-outlined-field-error-hover-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-hover-trailing-content-color: var(--md-outlined-field-error-hover-trailing-content-color, var(--md-sys-color-on-error-container, #410e0b));--_error-label-text-color: var(--md-outlined-field-error-label-text-color, var(--md-sys-color-error, #b3261e));--_error-leading-content-color: var(--md-outlined-field-error-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-outline-color: var(--md-outlined-field-error-outline-color, var(--md-sys-color-error, #b3261e));--_error-supporting-text-color: var(--md-outlined-field-error-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-trailing-content-color: var(--md-outlined-field-error-trailing-content-color, var(--md-sys-color-error, #b3261e));--_focus-content-color: var(--md-outlined-field-focus-content-color, var(--md-sys-color-on-surface, #1d1b20));--_focus-label-text-color: var(--md-outlined-field-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_focus-leading-content-color: var(--md-outlined-field-focus-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-outline-color: var(--md-outlined-field-focus-outline-color, var(--md-sys-color-primary, #6750a4));--_focus-outline-width: var(--md-outlined-field-focus-outline-width, 3px);--_focus-supporting-text-color: var(--md-outlined-field-focus-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-trailing-content-color: var(--md-outlined-field-focus-trailing-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-content-color: var(--md-outlined-field-hover-content-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-label-text-color: var(--md-outlined-field-hover-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-leading-content-color: var(--md-outlined-field-hover-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-outline-color: var(--md-outlined-field-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-outline-width: var(--md-outlined-field-hover-outline-width, 1px);--_hover-supporting-text-color: var(--md-outlined-field-hover-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-trailing-content-color: var(--md-outlined-field-hover-trailing-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_label-text-color: var(--md-outlined-field-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_label-text-font: var(--md-outlined-field-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-outlined-field-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_label-text-padding-bottom: var(--md-outlined-field-label-text-padding-bottom, 8px);--_label-text-populated-line-height: var(--md-outlined-field-label-text-populated-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_label-text-populated-size: var(--md-outlined-field-label-text-populated-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_label-text-size: var(--md-outlined-field-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_label-text-weight: var(--md-outlined-field-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_leading-content-color: var(--md-outlined-field-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_leading-space: var(--md-outlined-field-leading-space, 16px);--_outline-color: var(--md-outlined-field-outline-color, var(--md-sys-color-outline, #79747e));--_outline-label-padding: var(--md-outlined-field-outline-label-padding, 4px);--_outline-width: var(--md-outlined-field-outline-width, 1px);--_supporting-text-color: var(--md-outlined-field-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_supporting-text-font: var(--md-outlined-field-supporting-text-font, var(--md-sys-typescale-body-small-font, var(--md-ref-typeface-plain, Roboto)));--_supporting-text-leading-space: var(--md-outlined-field-supporting-text-leading-space, 16px);--_supporting-text-line-height: var(--md-outlined-field-supporting-text-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_supporting-text-size: var(--md-outlined-field-supporting-text-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_supporting-text-top-space: var(--md-outlined-field-supporting-text-top-space, 4px);--_supporting-text-trailing-space: var(--md-outlined-field-supporting-text-trailing-space, 16px);--_supporting-text-weight: var(--md-outlined-field-supporting-text-weight, var(--md-sys-typescale-body-small-weight, var(--md-ref-typeface-weight-regular, 400)));--_top-space: var(--md-outlined-field-top-space, 16px);--_trailing-content-color: var(--md-outlined-field-trailing-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_trailing-space: var(--md-outlined-field-trailing-space, 16px);--_with-leading-content-leading-space: var(--md-outlined-field-with-leading-content-leading-space, 12px);--_with-trailing-content-trailing-space: var(--md-outlined-field-with-trailing-content-trailing-space, 12px);--_container-shape-start-start: var(--md-outlined-field-container-shape-start-start, var(--md-outlined-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_container-shape-start-end: var(--md-outlined-field-container-shape-start-end, var(--md-outlined-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_container-shape-end-end: var(--md-outlined-field-container-shape-end-end, var(--md-outlined-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_container-shape-end-start: var(--md-outlined-field-container-shape-end-start, var(--md-outlined-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)))}.outline{border-color:var(--_outline-color);border-radius:inherit;display:flex;pointer-events:none;height:100%;position:absolute;width:100%;z-index:1}.outline-start::before,.outline-start::after,.outline-panel-inactive::before,.outline-panel-inactive::after,.outline-panel-active::before,.outline-panel-active::after,.outline-end::before,.outline-end::after{border:inherit;content:"";inset:0;position:absolute}.outline-start,.outline-end{border:inherit;border-radius:inherit;box-sizing:border-box;position:relative}.outline-start::before,.outline-start::after,.outline-end::before,.outline-end::after{border-bottom-style:solid;border-top-style:solid}.outline-start::after,.outline-end::after{opacity:0;transition:opacity 150ms cubic-bezier(0.2, 0, 0, 1)}.focused .outline-start::after,.focused .outline-end::after{opacity:1}.outline-start::before,.outline-start::after{border-inline-start-style:solid;border-inline-end-style:none;border-start-start-radius:inherit;border-start-end-radius:0;border-end-start-radius:inherit;border-end-end-radius:0;margin-inline-end:var(--_outline-label-padding)}.outline-end{flex-grow:1;margin-inline-start:calc(-1*var(--_outline-label-padding))}.outline-end::before,.outline-end::after{border-inline-start-style:none;border-inline-end-style:solid;border-start-start-radius:0;border-start-end-radius:inherit;border-end-start-radius:0;border-end-end-radius:inherit}.outline-notch{align-items:flex-start;border:inherit;display:flex;margin-inline-start:calc(-1*var(--_outline-label-padding));margin-inline-end:var(--_outline-label-padding);max-width:calc(100% - var(--_leading-space) - var(--_trailing-space));padding:0 var(--_outline-label-padding);position:relative}.no-label .outline-notch{display:none}.outline-panel-inactive,.outline-panel-active{border:inherit;border-bottom-style:solid;inset:0;position:absolute}.outline-panel-inactive::before,.outline-panel-inactive::after,.outline-panel-active::before,.outline-panel-active::after{border-top-style:solid;border-bottom:none;bottom:auto;transform:scaleX(1);transition:transform 150ms cubic-bezier(0.2, 0, 0, 1)}.outline-panel-inactive::before,.outline-panel-active::before{right:50%;transform-origin:top left}.outline-panel-inactive::after,.outline-panel-active::after{left:50%;transform-origin:top right}.populated .outline-panel-inactive::before,.populated .outline-panel-inactive::after,.populated .outline-panel-active::before,.populated .outline-panel-active::after,.focused .outline-panel-inactive::before,.focused .outline-panel-inactive::after,.focused .outline-panel-active::before,.focused .outline-panel-active::after{transform:scaleX(0)}.outline-panel-active{opacity:0;transition:opacity 150ms cubic-bezier(0.2, 0, 0, 1)}.focused .outline-panel-active{opacity:1}.outline-label{display:flex;max-width:100%;transform:translateY(calc(-100% + var(--_label-text-padding-bottom)))}.outline-start,.field:not(.with-start) .content ::slotted(*){padding-inline-start:max(var(--_leading-space),max(var(--_container-shape-start-start),var(--_container-shape-end-start)) + var(--_outline-label-padding))}.field:not(.with-start) .label-wrapper{margin-inline-start:max(var(--_leading-space),max(var(--_container-shape-start-start),var(--_container-shape-end-start)) + var(--_outline-label-padding))}.field:not(.with-end) .content ::slotted(*){padding-inline-end:max(var(--_trailing-space),max(var(--_container-shape-start-end),var(--_container-shape-end-end)))}.field:not(.with-end) .label-wrapper{margin-inline-end:max(var(--_trailing-space),max(var(--_container-shape-start-end),var(--_container-shape-end-end)))}.outline-start::before,.outline-end::before,.outline-panel-inactive,.outline-panel-inactive::before,.outline-panel-inactive::after{border-width:var(--_outline-width)}:hover .outline{border-color:var(--_hover-outline-color);color:var(--_hover-outline-color)}:hover .outline-start::before,:hover .outline-end::before,:hover .outline-panel-inactive,:hover .outline-panel-inactive::before,:hover .outline-panel-inactive::after{border-width:var(--_hover-outline-width)}.focused .outline{border-color:var(--_focus-outline-color);color:var(--_focus-outline-color)}.outline-start::after,.outline-end::after,.outline-panel-active,.outline-panel-active::before,.outline-panel-active::after{border-width:var(--_focus-outline-width)}.disabled .outline{border-color:var(--_disabled-outline-color);color:var(--_disabled-outline-color)}.disabled .outline-start,.disabled .outline-end,.disabled .outline-panel-inactive{opacity:var(--_disabled-outline-opacity)}.disabled .outline-start::before,.disabled .outline-end::before,.disabled .outline-panel-inactive,.disabled .outline-panel-inactive::before,.disabled .outline-panel-inactive::after{border-width:var(--_disabled-outline-width)}.error .outline{border-color:var(--_error-outline-color);color:var(--_error-outline-color)}.error:hover .outline{border-color:var(--_error-hover-outline-color);color:var(--_error-hover-outline-color)}.error.focused .outline{border-color:var(--_error-focus-outline-color);color:var(--_error-focus-outline-color)}.resizable .container{bottom:var(--_focus-outline-width);inset-inline-end:var(--_focus-outline-width);clip-path:inset(var(--_focus-outline-width) 0 0 var(--_focus-outline-width))}.resizable .container>*{top:var(--_focus-outline-width);inset-inline-start:var(--_focus-outline-width)}.resizable .container:dir(rtl){clip-path:inset(var(--_focus-outline-width) var(--_focus-outline-width) 0 0)}}@layer hcm{@media(forced-colors: active){.disabled .outline{border-color:GrayText;color:GrayText}.disabled :is(.outline-start,.outline-end,.outline-panel-inactive){opacity:1}}}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./field/internal/shared-styles.css.
const styles$c = i$7 `:host{display:inline-flex;resize:both}.field{display:flex;flex:1;flex-direction:column;writing-mode:horizontal-tb;max-width:100%}.container-overflow{border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-end-radius:var(--_container-shape-end-end);border-end-start-radius:var(--_container-shape-end-start);display:flex;height:100%;position:relative}.container{align-items:center;border-radius:inherit;display:flex;flex:1;max-height:100%;min-height:100%;min-width:min-content;position:relative}.field,.container-overflow{resize:inherit}.resizable:not(.disabled) .container{resize:inherit;overflow:hidden}.disabled{pointer-events:none}slot[name=container]{border-radius:inherit}slot[name=container]::slotted(*){border-radius:inherit;inset:0;pointer-events:none;position:absolute}@layer styles{.start,.middle,.end{display:flex;box-sizing:border-box;height:100%;position:relative}.start{color:var(--_leading-content-color)}.end{color:var(--_trailing-content-color)}.start,.end{align-items:center;justify-content:center}.with-start .start{margin-inline:var(--_with-leading-content-leading-space) var(--_content-space)}.with-end .end{margin-inline:var(--_content-space) var(--_with-trailing-content-trailing-space)}.middle{align-items:stretch;align-self:baseline;flex:1}.content{color:var(--_content-color);display:flex;flex:1;opacity:0;transition:opacity 83ms cubic-bezier(0.2, 0, 0, 1)}.no-label .content,.focused .content,.populated .content{opacity:1;transition-delay:67ms}:is(.disabled,.disable-transitions) .content{transition:none}.content ::slotted(*){all:unset;color:currentColor;font-family:var(--_content-font);font-size:var(--_content-size);line-height:var(--_content-line-height);font-weight:var(--_content-weight);width:100%;overflow-wrap:revert;white-space:revert}.content ::slotted(:not(textarea)){padding-top:var(--_top-space);padding-bottom:var(--_bottom-space)}.content ::slotted(textarea){margin-top:var(--_top-space);margin-bottom:var(--_bottom-space)}:hover .content{color:var(--_hover-content-color)}:hover .start{color:var(--_hover-leading-content-color)}:hover .end{color:var(--_hover-trailing-content-color)}.focused .content{color:var(--_focus-content-color)}.focused .start{color:var(--_focus-leading-content-color)}.focused .end{color:var(--_focus-trailing-content-color)}.disabled .content{color:var(--_disabled-content-color)}.disabled.no-label .content,.disabled.focused .content,.disabled.populated .content{opacity:var(--_disabled-content-opacity)}.disabled .start{color:var(--_disabled-leading-content-color);opacity:var(--_disabled-leading-content-opacity)}.disabled .end{color:var(--_disabled-trailing-content-color);opacity:var(--_disabled-trailing-content-opacity)}.error .content{color:var(--_error-content-color)}.error .start{color:var(--_error-leading-content-color)}.error .end{color:var(--_error-trailing-content-color)}.error:hover .content{color:var(--_error-hover-content-color)}.error:hover .start{color:var(--_error-hover-leading-content-color)}.error:hover .end{color:var(--_error-hover-trailing-content-color)}.error.focused .content{color:var(--_error-focus-content-color)}.error.focused .start{color:var(--_error-focus-leading-content-color)}.error.focused .end{color:var(--_error-focus-trailing-content-color)}}@layer hcm{@media(forced-colors: active){.disabled :is(.start,.content,.end){color:GrayText;opacity:1}}}@layer styles{.label{box-sizing:border-box;color:var(--_label-text-color);overflow:hidden;max-width:100%;text-overflow:ellipsis;white-space:nowrap;z-index:1;font-family:var(--_label-text-font);font-size:var(--_label-text-size);line-height:var(--_label-text-line-height);font-weight:var(--_label-text-weight);width:min-content}.label-wrapper{inset:0;pointer-events:none;position:absolute}.label.resting{position:absolute;top:var(--_top-space)}.label.floating{font-size:var(--_label-text-populated-size);line-height:var(--_label-text-populated-line-height);transform-origin:top left}.label.hidden{opacity:0}.no-label .label{display:none}.label-wrapper{inset:0;position:absolute;text-align:initial}:hover .label{color:var(--_hover-label-text-color)}.focused .label{color:var(--_focus-label-text-color)}.disabled .label{color:var(--_disabled-label-text-color)}.disabled .label:not(.hidden){opacity:var(--_disabled-label-text-opacity)}.error .label{color:var(--_error-label-text-color)}.error:hover .label{color:var(--_error-hover-label-text-color)}.error.focused .label{color:var(--_error-focus-label-text-color)}}@layer hcm{@media(forced-colors: active){.disabled .label:not(.hidden){color:GrayText;opacity:1}}}@layer styles{.supporting-text{color:var(--_supporting-text-color);display:flex;font-family:var(--_supporting-text-font);font-size:var(--_supporting-text-size);line-height:var(--_supporting-text-line-height);font-weight:var(--_supporting-text-weight);gap:16px;justify-content:space-between;padding-inline-start:var(--_supporting-text-leading-space);padding-inline-end:var(--_supporting-text-trailing-space);padding-top:var(--_supporting-text-top-space)}.supporting-text :nth-child(2){flex-shrink:0}:hover .supporting-text{color:var(--_hover-supporting-text-color)}.focus .supporting-text{color:var(--_focus-supporting-text-color)}.disabled .supporting-text{color:var(--_disabled-supporting-text-color);opacity:var(--_disabled-supporting-text-opacity)}.error .supporting-text{color:var(--_error-supporting-text-color)}.error:hover .supporting-text{color:var(--_error-hover-supporting-text-color)}.error.focus .supporting-text{color:var(--_error-focus-supporting-text-color)}}@layer hcm{@media(forced-colors: active){.disabled .supporting-text{color:GrayText;opacity:1}}}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-outlined-field
 * TODO(b/228525797): add docs
 * @final
 * @suppress {visibility}
 */
class OscdOutlinedField extends OutlinedField {
}
OscdOutlinedField.styles = [styles$c, styles$d];

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A symbol property used to create a constraint validation `Validator`.
 * Required for all `mixinConstraintValidation()` elements.
 */
const createValidator = Symbol('createValidator');
/**
 * A symbol property used to return an anchor for constraint validation popups.
 * Required for all `mixinConstraintValidation()` elements.
 */
const getValidityAnchor = Symbol('getValidityAnchor');
// Private symbol members, used to avoid name clashing.
const privateValidator = Symbol('privateValidator');
const privateSyncValidity = Symbol('privateSyncValidity');
const privateCustomValidationMessage = Symbol('privateCustomValidationMessage');
/**
 * Mixes in constraint validation APIs for an element.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Constraint_validation
 * for more details.
 *
 * Implementations must provide a validator to cache and compute its validity,
 * along with a shadow root element to anchor validation popups to.
 *
 * @example
 * ```ts
 * const baseClass = mixinConstraintValidation(
 *   mixinFormAssociated(mixinElementInternals(LitElement))
 * );
 *
 * class MyCheckbox extends baseClass {
 *   \@property({type: Boolean}) checked = false;
 *   \@property({type: Boolean}) required = false;
 *
 *   [createValidator]() {
 *     return new CheckboxValidator(() => this);
 *   }
 *
 *   [getValidityAnchor]() {
 *     return this.renderRoot.querySelector('.root');
 *   }
 * }
 * ```
 *
 * @param base The class to mix functionality into.
 * @return The provided class with `ConstraintValidation` mixed in.
 */
function mixinConstraintValidation(base) {
    var _a;
    class ConstraintValidationElement extends base {
        constructor() {
            super(...arguments);
            /**
             * Needed for Safari, see https://bugs.webkit.org/show_bug.cgi?id=261432
             * Replace with this[internals].validity.customError when resolved.
             */
            this[_a] = '';
        }
        get validity() {
            this[privateSyncValidity]();
            return this[internals].validity;
        }
        get validationMessage() {
            this[privateSyncValidity]();
            return this[internals].validationMessage;
        }
        get willValidate() {
            this[privateSyncValidity]();
            return this[internals].willValidate;
        }
        checkValidity() {
            this[privateSyncValidity]();
            return this[internals].checkValidity();
        }
        reportValidity() {
            this[privateSyncValidity]();
            return this[internals].reportValidity();
        }
        setCustomValidity(error) {
            this[privateCustomValidationMessage] = error;
            this[privateSyncValidity]();
        }
        requestUpdate(name, oldValue, options) {
            super.requestUpdate(name, oldValue, options);
            this[privateSyncValidity]();
        }
        firstUpdated(changed) {
            super.firstUpdated(changed);
            // Sync the validity again when the element first renders, since the
            // validity anchor is now available.
            //
            // Elements that `delegatesFocus: true` to an `<input>` will throw an
            // error in Chrome and Safari when a form tries to submit or call
            // `form.reportValidity()`:
            // "An invalid form control with name='' is not focusable"
            //
            // The validity anchor MUST be provided in `internals.setValidity()` and
            // MUST be the `<input>` element rendered.
            //
            // See https://lit.dev/playground/#gist=6c26e418e0010f7a5aac15005cde8bde
            // for a reproduction.
            this[privateSyncValidity]();
        }
        [(_a = privateCustomValidationMessage, privateSyncValidity)]() {
            if (!this[privateValidator]) {
                this[privateValidator] = this[createValidator]();
            }
            const { validity, validationMessage: nonCustomValidationMessage } = this[privateValidator].getValidity();
            const customError = !!this[privateCustomValidationMessage];
            const validationMessage = this[privateCustomValidationMessage] || nonCustomValidationMessage;
            this[internals].setValidity({ ...validity, customError }, validationMessage, this[getValidityAnchor]() ?? undefined);
        }
        [createValidator]() {
            throw new Error('Implement [createValidator]');
        }
        [getValidityAnchor]() {
            throw new Error('Implement [getValidityAnchor]');
        }
    }
    return ConstraintValidationElement;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A symbol property used for a callback when validity has been reported.
 */
const onReportValidity = Symbol('onReportValidity');
// Private symbol members, used to avoid name clashing.
const privateCleanupFormListeners = Symbol('privateCleanupFormListeners');
const privateDoNotReportInvalid = Symbol('privateDoNotReportInvalid');
const privateIsSelfReportingValidity = Symbol('privateIsSelfReportingValidity');
const privateCallOnReportValidity = Symbol('privateCallOnReportValidity');
/**
 * Mixes in a callback for constraint validation when validity should be
 * styled and reported to the user.
 *
 * This is commonly used in text-field-like controls that display error styles
 * and error messages.
 *
 * @example
 * ```ts
 * const baseClass = mixinOnReportValidity(
 *   mixinConstraintValidation(
 *     mixinFormAssociated(mixinElementInternals(LitElement)),
 *   ),
 * );
 *
 * class MyField extends baseClass {
 *   \@property({type: Boolean}) error = false;
 *   \@property() errorMessage = '';
 *
 *   [onReportValidity](invalidEvent: Event | null) {
 *     this.error = !!invalidEvent;
 *     this.errorMessage = this.validationMessage;
 *
 *     // Optionally prevent platform popup from displaying
 *     invalidEvent?.preventDefault();
 *   }
 * }
 * ```
 *
 * @param base The class to mix functionality into.
 * @return The provided class with `OnReportValidity` mixed in.
 */
function mixinOnReportValidity(base) {
    var _a, _b, _c;
    class OnReportValidityElement extends base {
        // Mixins must have a constructor with `...args: any[]`
        // tslint:disable-next-line:no-any
        constructor(...args) {
            super(...args);
            /**
             * Used to clean up event listeners when a new form is associated.
             */
            this[_a] = new AbortController();
            /**
             * Used to determine if an invalid event should report validity. Invalid
             * events from `checkValidity()` do not trigger reporting.
             */
            this[_b] = false;
            /**
             * Used to determine if the control is reporting validity from itself, or
             * if a `<form>` is causing the validity report. Forms have different
             * control focusing behavior.
             */
            this[_c] = false;
            this.addEventListener('invalid', (invalidEvent) => {
                // Listen for invalid events dispatched by a `<form>` when it tries to
                // submit and the element is invalid. We ignore events dispatched when
                // calling `checkValidity()` as well as untrusted events, since the
                // `reportValidity()` and `<form>`-dispatched events are always
                // trusted.
                if (this[privateDoNotReportInvalid] || !invalidEvent.isTrusted) {
                    return;
                }
                this.addEventListener('invalid', () => {
                    // A normal bubbling phase event listener. By adding it here, we
                    // ensure it's the last event listener that is called during the
                    // bubbling phase.
                    this[privateCallOnReportValidity](invalidEvent);
                }, { once: true });
            }, {
                // Listen during the capture phase, which will happen before the
                // bubbling phase. That way, we can add a final event listener that
                // will run after other event listeners, and we can check if it was
                // default prevented. This works because invalid does not bubble.
                capture: true,
            });
        }
        checkValidity() {
            this[privateDoNotReportInvalid] = true;
            const valid = super.checkValidity();
            this[privateDoNotReportInvalid] = false;
            return valid;
        }
        reportValidity() {
            this[privateIsSelfReportingValidity] = true;
            const valid = super.reportValidity();
            // Constructor's invalid listener will handle reporting invalid events.
            if (valid) {
                this[privateCallOnReportValidity](null);
            }
            this[privateIsSelfReportingValidity] = false;
            return valid;
        }
        [(_a = privateCleanupFormListeners, _b = privateDoNotReportInvalid, _c = privateIsSelfReportingValidity, privateCallOnReportValidity)](invalidEvent) {
            // Since invalid events do not bubble to parent listeners, and because
            // our invalid listeners are added lazily after other listeners, we can
            // reliably read `defaultPrevented` synchronously without worrying
            // about waiting for another listener that could cancel it.
            const wasCanceled = invalidEvent?.defaultPrevented;
            if (wasCanceled) {
                return;
            }
            this[onReportValidity](invalidEvent);
            // If an implementation calls invalidEvent.preventDefault() to stop the
            // platform popup from displaying, focusing is also prevented, so we need
            // to manually focus.
            const implementationCanceledFocus = !wasCanceled && invalidEvent?.defaultPrevented;
            if (!implementationCanceledFocus) {
                return;
            }
            // The control should be focused when:
            // - `control.reportValidity()` is called (self-reporting).
            // - a form is reporting validity for its controls and this is the first
            //   invalid control.
            if (this[privateIsSelfReportingValidity] ||
                isFirstInvalidControlInForm(this[internals].form, this)) {
                this.focus();
            }
        }
        [onReportValidity](invalidEvent) {
            throw new Error('Implement [onReportValidity]');
        }
        formAssociatedCallback(form) {
            // can't use super.formAssociatedCallback?.() due to closure
            if (super.formAssociatedCallback) {
                super.formAssociatedCallback(form);
            }
            // Clean up previous form listeners.
            this[privateCleanupFormListeners].abort();
            if (!form) {
                return;
            }
            this[privateCleanupFormListeners] = new AbortController();
            // Add a listener that fires when the form runs constraint validation and
            // the control is valid, so that it may remove its error styles.
            //
            // This happens on `form.reportValidity()` and `form.requestSubmit()`
            // (both when the submit fails and passes).
            addFormReportValidListener(this, form, () => {
                this[privateCallOnReportValidity](null);
            }, this[privateCleanupFormListeners].signal);
        }
    }
    return OnReportValidityElement;
}
/**
 * Add a listener that fires when a form runs constraint validation on a control
 * and it is valid. This is needed to clear previously invalid styles.
 *
 * @param control The control of the form to listen for valid events.
 * @param form The control's form that can run constraint validation.
 * @param onControlValid A listener that is called when the form runs constraint
 *     validation and the control is valid.
 * @param cleanup A cleanup signal to remove the listener.
 */
function addFormReportValidListener(control, form, onControlValid, cleanup) {
    const validateHooks = getFormValidateHooks(form);
    // When a form validates its controls, check if an invalid event is dispatched
    // on the control. If it is not, then inform the control to report its valid
    // state.
    let controlFiredInvalid = false;
    let cleanupInvalidListener;
    let isNextSubmitFromHook = false;
    validateHooks.addEventListener('before', () => {
        isNextSubmitFromHook = true;
        cleanupInvalidListener = new AbortController();
        controlFiredInvalid = false;
        control.addEventListener('invalid', () => {
            controlFiredInvalid = true;
        }, {
            signal: cleanupInvalidListener.signal,
        });
    }, { signal: cleanup });
    validateHooks.addEventListener('after', () => {
        isNextSubmitFromHook = false;
        cleanupInvalidListener?.abort();
        if (controlFiredInvalid) {
            return;
        }
        onControlValid();
    }, { signal: cleanup });
    // The above hooks handle imperatively submitting the form, but not
    // declaratively submitting the form. This happens when:
    // 1. A non-custom element `<button type="submit">` is clicked.
    // 2. Enter is pressed on a non-custom element text editable `<input>`.
    form.addEventListener('submit', () => {
        // This submit was from `form.requestSubmit()`, which already calls the
        // listener.
        if (isNextSubmitFromHook) {
            return;
        }
        onControlValid();
    }, {
        signal: cleanup,
    });
    // Note: it is a known limitation that we cannot detect if a form tries to
    // submit declaratively, but fails to do so because an unrelated sibling
    // control failed its constraint validation.
    //
    // Since we cannot detect when that happens, a previously invalid control may
    // not clear its error styling when it becomes valid again.
    //
    // To work around this, call `form.reportValidity()` when submitting a form
    // declaratively. This can be down on the `<button type="submit">`'s click or
    // the text editable `<input>`'s 'Enter' keydown.
}
const FORM_VALIDATE_HOOKS = new WeakMap();
/**
 * Get a hooks `EventTarget` that dispatches 'before' and 'after' events that
 * fire before a form runs constraint validation and immediately after it
 * finishes running constraint validation on its controls.
 *
 * This happens during `form.reportValidity()` and `form.requestSubmit()`.
 *
 * @param form The form to get or set up hooks for.
 * @return A hooks `EventTarget` to add listeners to.
 */
function getFormValidateHooks(form) {
    if (!FORM_VALIDATE_HOOKS.has(form)) {
        // Patch form methods to add event listener hooks. These are needed to react
        // to form behaviors that do not dispatch events, such as a form asking its
        // controls to report their validity.
        //
        // We should only patch the methods once, since multiple controls and other
        // forces may want to patch this method. We cannot reliably clean it up if
        // there are multiple patched and re-patched methods referring holding
        // references to each other.
        //
        // Instead, we never clean up the patch but add and clean up event listeners
        // added to the hooks after the patch.
        const hooks = new EventTarget();
        FORM_VALIDATE_HOOKS.set(form, hooks);
        // Add hooks to support notifying before and after a form has run constraint
        // validation on its controls.
        // Note: `form.submit()` does not run constraint validation per spec.
        for (const methodName of ['reportValidity', 'requestSubmit']) {
            const superMethod = form[methodName];
            form[methodName] = function () {
                hooks.dispatchEvent(new Event('before'));
                const result = Reflect.apply(superMethod, this, arguments);
                hooks.dispatchEvent(new Event('after'));
                return result;
            };
        }
    }
    return FORM_VALIDATE_HOOKS.get(form);
}
/**
 * Checks if a control is the first invalid control in a form.
 *
 * @param form The control's form. When `null`, the control doesn't have a form
 *     and the method returns true.
 * @param control The control to check.
 * @return True if there is no form or if the control is the form's first
 *     invalid control.
 */
function isFirstInvalidControlInForm(form, control) {
    if (!form) {
        return true;
    }
    let firstInvalidControl;
    for (const element of form.elements) {
        if (element.matches(':invalid')) {
            firstInvalidControl = element;
            break;
        }
    }
    return firstInvalidControl === control;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A class that computes and caches `ValidityStateFlags` for a component with
 * a given `State` interface.
 *
 * Cached performance before computing validity is important since constraint
 * validation must be checked frequently and synchronously when properties
 * change.
 *
 * @template State The expected interface of properties relevant to constraint
 *     validation.
 */
class Validator {
    /**
     * Creates a new validator.
     *
     * @param getCurrentState A callback that returns the current state of
     *     constraint validation-related properties.
     */
    constructor(getCurrentState) {
        this.getCurrentState = getCurrentState;
        /**
         * The current validity state and message. This is cached and returns if
         * constraint validation state does not change.
         */
        this.currentValidity = {
            validity: {},
            validationMessage: '',
        };
    }
    /**
     * Returns the current `ValidityStateFlags` and validation message for the
     * validator.
     *
     * If the constraint validation state has not changed, this will return a
     * cached result. This is important since `getValidity()` can be called
     * frequently in response to synchronous property changes.
     *
     * @return The current validity and validation message.
     */
    getValidity() {
        const state = this.getCurrentState();
        const hasStateChanged = !this.prevState || !this.equals(this.prevState, state);
        if (!hasStateChanged) {
            return this.currentValidity;
        }
        const { validity, validationMessage } = this.computeValidity(state);
        this.prevState = this.copy(state);
        this.currentValidity = {
            validationMessage,
            validity: {
                // Change any `ValidityState` instances into `ValidityStateFlags` since
                // `ValidityState` cannot be easily `{...spread}`.
                badInput: validity.badInput,
                customError: validity.customError,
                patternMismatch: validity.patternMismatch,
                rangeOverflow: validity.rangeOverflow,
                rangeUnderflow: validity.rangeUnderflow,
                stepMismatch: validity.stepMismatch,
                tooLong: validity.tooLong,
                tooShort: validity.tooShort,
                typeMismatch: validity.typeMismatch,
                valueMissing: validity.valueMissing,
            },
        };
        return this.currentValidity;
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A validator that provides constraint validation that emulates `<select>`
 * validation.
 */
class SelectValidator extends Validator {
    computeValidity(state) {
        if (!this.selectControl) {
            // Lazily create the platform select
            this.selectControl = document.createElement('select');
        }
        D(b `<option value=${state.value}></option>`, this.selectControl);
        this.selectControl.value = state.value;
        this.selectControl.required = state.required;
        return {
            validity: this.selectControl.validity,
            validationMessage: this.selectControl.validationMessage,
        };
    }
    equals(prev, next) {
        return prev.value === next.value && prev.required === next.required;
    }
    copy({ value, required }) {
        return { value, required };
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Given a list of select options, this function will return an array of
 * SelectOptionRecords that are selected.
 *
 * @return An array of SelectOptionRecords describing the options that are
 * selected.
 */
function getSelectedItems(items) {
    const selectedItemRecords = [];
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.selected) {
            selectedItemRecords.push([item, i]);
        }
    }
    return selectedItemRecords;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
var _a$1;
const VALUE = Symbol('value');
// Separate variable needed for closure.
const selectBaseClass = mixinDelegatesAria(mixinOnReportValidity(mixinConstraintValidation(mixinFormAssociated(mixinElementInternals(i$4)))));
/**
 * @fires change {Event} The native `change` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event)
 * --bubbles
 * @fires input {InputEvent} The native `input` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event)
 * --bubbles --composed
 * @fires opening {Event} Fired when the select's menu is about to open.
 * @fires opened {Event} Fired when the select's menu has finished animations
 * and opened.
 * @fires closing {Event} Fired when the select's menu is about to close.
 * @fires closed {Event} Fired when the select's menu has finished animations
 * and closed.
 */
class Select extends selectBaseClass {
    /**
     * The value of the currently selected option.
     *
     * Note: For SSR, set `[selected]` on the requested option and `displayText`
     * rather than setting `value` setting `value` will incur a DOM query.
     */
    get value() {
        return this[VALUE];
    }
    set value(value) {
        this.lastUserSetValue = value;
        this.select(value);
    }
    get options() {
        // NOTE: this does a DOM query.
        return (this.menu?.items ?? []);
    }
    /**
     * The index of the currently selected option.
     *
     * Note: For SSR, set `[selected]` on the requested option and `displayText`
     * rather than setting `selectedIndex` setting `selectedIndex` will incur a
     * DOM query.
     */
    get selectedIndex() {
        // tslint:disable-next-line:enforce-name-casing
        const [_option, index] = (this.getSelectedOptions() ?? [])[0] ?? [];
        return index ?? -1;
    }
    set selectedIndex(index) {
        this.lastUserSetSelectedIndex = index;
        this.selectIndex(index);
    }
    /**
     * Returns an array of selected options.
     *
     * NOTE: md-select only supports single selection.
     */
    get selectedOptions() {
        return (this.getSelectedOptions() ?? []).map(([option]) => option);
    }
    get hasError() {
        return this.error || this.nativeError;
    }
    constructor() {
        super();
        /**
         * Opens the menu synchronously with no animation.
         */
        this.quick = false;
        /**
         * Whether or not the select is required.
         */
        this.required = false;
        /**
         * The error message that replaces supporting text when `error` is true. If
         * `errorText` is an empty string, then the supporting text will continue to
         * show.
         *
         * This error message overrides the error message displayed by
         * `reportValidity()`.
         */
        this.errorText = '';
        /**
         * The floating label for the field.
         */
        this.label = '';
        /**
         * Disables the asterisk on the floating label, when the select is
         * required.
         */
        this.noAsterisk = false;
        /**
         * Conveys additional information below the select, such as how it should
         * be used.
         */
        this.supportingText = '';
        /**
         * Gets or sets whether or not the select is in a visually invalid state.
         *
         * This error state overrides the error state controlled by
         * `reportValidity()`.
         */
        this.error = false;
        /**
         * Whether or not the underlying md-menu should be position: fixed to display
         * in a top-level manner, or position: absolute.
         *
         * position:fixed is useful for cases where select is inside of another
         * element with stacking context and hidden overflows such as `md-dialog`.
         */
        this.menuPositioning = 'popover';
        /**
         * Clamps the menu-width to the width of the select.
         */
        this.clampMenuWidth = false;
        /**
         * The max time between the keystrokes of the typeahead select / menu behavior
         * before it clears the typeahead buffer.
         */
        this.typeaheadDelay = DEFAULT_TYPEAHEAD_BUFFER_TIME;
        /**
         * Whether or not the text field has a leading icon. Used for SSR.
         */
        this.hasLeadingIcon = false;
        /**
         * Text to display in the field. Only set for SSR.
         */
        this.displayText = '';
        /**
         * Whether the menu should be aligned to the start or the end of the select's
         * textbox.
         */
        this.menuAlign = 'start';
        this[_a$1] = '';
        /**
         * Used for initializing select when the user sets the `value` directly.
         */
        this.lastUserSetValue = null;
        /**
         * Used for initializing select when the user sets the `selectedIndex`
         * directly.
         */
        this.lastUserSetSelectedIndex = null;
        /**
         * Used for `input` and `change` event change detection.
         */
        this.lastSelectedOption = null;
        // tslint:disable-next-line:enforce-name-casing
        this.lastSelectedOptionRecords = [];
        /**
         * Whether or not a native error has been reported via `reportValidity()`.
         */
        this.nativeError = false;
        /**
         * The validation message displayed from a native error via
         * `reportValidity()`.
         */
        this.nativeErrorText = '';
        this.focused = false;
        this.open = false;
        this.defaultFocus = FocusState.NONE;
        // Have to keep track of previous open because it's state and private and thus
        // cannot be tracked in PropertyValues<this> map.
        this.prevOpen = this.open;
        this.selectWidth = 0;
        this.addEventListener('focus', this.handleFocus.bind(this));
        this.addEventListener('blur', this.handleBlur.bind(this));
    }
    /**
     * Selects an option given the value of the option, and updates MdSelect's
     * value.
     */
    select(value) {
        const optionToSelect = this.options.find((option) => option.value === value);
        if (optionToSelect) {
            this.selectItem(optionToSelect);
        }
    }
    /**
     * Selects an option given the index of the option, and updates MdSelect's
     * value.
     */
    selectIndex(index) {
        const optionToSelect = this.options[index];
        if (optionToSelect) {
            this.selectItem(optionToSelect);
        }
    }
    /**
     * Reset the select to its default value.
     */
    reset() {
        for (const option of this.options) {
            option.selected = option.hasAttribute('selected');
        }
        this.updateValueAndDisplayText();
        this.nativeError = false;
        this.nativeErrorText = '';
    }
    /** Shows the picker. If it's already open, this is a no-op. */
    showPicker() {
        this.open = true;
    }
    [(_a$1 = VALUE, onReportValidity)](invalidEvent) {
        // Prevent default pop-up behavior.
        invalidEvent?.preventDefault();
        const prevMessage = this.getErrorText();
        this.nativeError = !!invalidEvent;
        this.nativeErrorText = this.validationMessage;
        if (prevMessage === this.getErrorText()) {
            this.field?.reannounceError();
        }
    }
    update(changed) {
        // In SSR the options will be ready to query, so try to figure out what
        // the value and display text should be.
        if (!this.hasUpdated) {
            this.initUserSelection();
        }
        // We have just opened the menu.
        // We are only able to check for the select's rect in `update()` instead of
        // having to wait for `updated()` because the menu can never be open on
        // first render since it is not settable and Lit SSR does not support click
        // events which would open the menu.
        if (this.prevOpen !== this.open && this.open) {
            const selectRect = this.getBoundingClientRect();
            this.selectWidth = selectRect.width;
        }
        this.prevOpen = this.open;
        super.update(changed);
    }
    render() {
        return b `
      <span
        class="select ${e(this.getRenderClasses())}"
        @focusout=${this.handleFocusout}>
        ${this.renderField()} ${this.renderMenu()}
      </span>
    `;
    }
    async firstUpdated(changed) {
        await this.menu?.updateComplete;
        // If this has been handled on update already due to SSR, try again.
        if (!this.lastSelectedOptionRecords.length) {
            this.initUserSelection();
        }
        // Case for when the DOM is streaming, there are no children, and a child
        // has [selected] set on it, we need to wait for DOM to render something.
        if (!this.lastSelectedOptionRecords.length &&
            true &&
            !this.options.length) {
            setTimeout(() => {
                this.updateValueAndDisplayText();
            });
        }
        super.firstUpdated(changed);
    }
    getRenderClasses() {
        return {
            'disabled': this.disabled,
            'error': this.error,
            'open': this.open,
        };
    }
    renderField() {
        const ariaLabel = this.ariaLabel || this.label;
        return u `
      <${this.fieldTag}
          aria-haspopup="listbox"
          role="combobox"
          part="field"
          id="field"
          tabindex=${this.disabled ? '-1' : '0'}
          aria-label=${ariaLabel || A}
          aria-describedby="description"
          aria-expanded=${this.open ? 'true' : 'false'}
          aria-controls="listbox"
          class="field"
          label=${this.label}
          ?no-asterisk=${this.noAsterisk}
          .focused=${this.focused || this.open}
          .populated=${!!this.displayText}
          .disabled=${this.disabled}
          .required=${this.required}
          .error=${this.hasError}
          ?has-start=${this.hasLeadingIcon}
          has-end
          supporting-text=${this.supportingText}
          error-text=${this.getErrorText()}
          @keydown=${this.handleKeydown}
          @click=${this.handleClick}>
         ${this.renderFieldContent()}
         <div id="description" slot="aria-describedby"></div>
      </${this.fieldTag}>`;
    }
    renderFieldContent() {
        return [
            this.renderLeadingIcon(),
            this.renderLabel(),
            this.renderTrailingIcon(),
        ];
    }
    renderLeadingIcon() {
        return b `
      <span class="icon leading" slot="start">
        <slot name="leading-icon" @slotchange=${this.handleIconChange}></slot>
      </span>
    `;
    }
    renderTrailingIcon() {
        return b `
      <span class="icon trailing" slot="end">
        <slot name="trailing-icon" @slotchange=${this.handleIconChange}>
          <svg height="5" viewBox="7 10 10 5" focusable="false">
            <polygon
              class="down"
              stroke="none"
              fill-rule="evenodd"
              points="7 10 12 15 17 10"></polygon>
            <polygon
              class="up"
              stroke="none"
              fill-rule="evenodd"
              points="7 15 12 10 17 15"></polygon>
          </svg>
        </slot>
      </span>
    `;
    }
    renderLabel() {
        // need to render &nbsp; so that line-height can apply and give it a
        // non-zero height
        return b `<div id="label">${this.displayText || b `&nbsp;`}</div>`;
    }
    renderMenu() {
        const ariaLabel = this.label || this.ariaLabel;
        return b `<div class="menu-wrapper">
      <md-menu
        id="listbox"
        .defaultFocus=${this.defaultFocus}
        role="listbox"
        tabindex="-1"
        aria-label=${ariaLabel || A}
        stay-open-on-focusout
        part="menu"
        exportparts="focus-ring: menu-focus-ring"
        anchor="field"
        style=${o$1({
            '--__menu-min-width': `${this.selectWidth}px`,
            '--__menu-max-width': this.clampMenuWidth
                ? `${this.selectWidth}px`
                : undefined,
        })}
        no-navigation-wrap
        .open=${this.open}
        .quick=${this.quick}
        .positioning=${this.menuPositioning}
        .typeaheadDelay=${this.typeaheadDelay}
        .anchorCorner=${this.menuAlign === 'start' ? 'end-start' : 'end-end'}
        .menuCorner=${this.menuAlign === 'start' ? 'start-start' : 'start-end'}
        @opening=${this.handleOpening}
        @opened=${this.redispatchEvent}
        @closing=${this.redispatchEvent}
        @closed=${this.handleClosed}
        @close-menu=${this.handleCloseMenu}
        @request-selection=${this.handleRequestSelection}
        @request-deselection=${this.handleRequestDeselection}>
        ${this.renderMenuContent()}
      </md-menu>
    </div>`;
    }
    renderMenuContent() {
        return b `<slot></slot>`;
    }
    /**
     * Handles opening the select on keydown and typahead selection when the menu
     * is closed.
     */
    handleKeydown(event) {
        if (this.open || this.disabled || !this.menu) {
            return;
        }
        const typeaheadController = this.menu.typeaheadController;
        const isOpenKey = event.code === 'Space' ||
            event.code === 'ArrowDown' ||
            event.code === 'ArrowUp' ||
            event.code === 'End' ||
            event.code === 'Home' ||
            event.code === 'Enter';
        // Do not open if currently typing ahead because the user may be typing the
        // spacebar to match a word with a space
        if (!typeaheadController.isTypingAhead && isOpenKey) {
            event.preventDefault();
            this.open = true;
            // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/#kbd_label
            switch (event.code) {
                case 'Space':
                case 'ArrowDown':
                case 'Enter':
                    // We will handle focusing last selected item in this.handleOpening()
                    this.defaultFocus = FocusState.NONE;
                    break;
                case 'End':
                    this.defaultFocus = FocusState.LAST_ITEM;
                    break;
                case 'ArrowUp':
                case 'Home':
                    this.defaultFocus = FocusState.FIRST_ITEM;
                    break;
            }
            return;
        }
        const isPrintableKey = event.key.length === 1;
        // Handles typing ahead when the menu is closed by delegating the event to
        // the underlying menu's typeaheadController
        if (isPrintableKey) {
            typeaheadController.onKeydown(event);
            event.preventDefault();
            const { lastActiveRecord } = typeaheadController;
            if (!lastActiveRecord) {
                return;
            }
            this.labelEl?.setAttribute?.('aria-live', 'polite');
            const hasChanged = this.selectItem(lastActiveRecord[TYPEAHEAD_RECORD.ITEM]);
            if (hasChanged) {
                this.dispatchInteractionEvents();
            }
        }
    }
    handleClick() {
        this.open = !this.open;
    }
    handleFocus() {
        this.focused = true;
    }
    handleBlur() {
        this.focused = false;
    }
    /**
     * Handles closing the menu when the focus leaves the select's subtree.
     */
    handleFocusout(event) {
        // Don't close the menu if we are switching focus between menu,
        // select-option, and field
        if (event.relatedTarget && isElementInSubtree(event.relatedTarget, this)) {
            return;
        }
        this.open = false;
    }
    /**
     * Gets a list of all selected select options as a list item record array.
     *
     * @return An array of selected list option records.
     */
    getSelectedOptions() {
        if (!this.menu) {
            this.lastSelectedOptionRecords = [];
            return null;
        }
        const items = this.menu.items;
        this.lastSelectedOptionRecords = getSelectedItems(items);
        return this.lastSelectedOptionRecords;
    }
    async getUpdateComplete() {
        await this.menu?.updateComplete;
        return super.getUpdateComplete();
    }
    /**
     * Gets the selected options from the DOM, and updates the value and display
     * text to the first selected option's value and headline respectively.
     *
     * @return Whether or not the selected option has changed since last update.
     */
    updateValueAndDisplayText() {
        const selectedOptions = this.getSelectedOptions() ?? [];
        // Used to determine whether or not we need to fire an input / change event
        // which fire whenever the option element changes (value or selectedIndex)
        // on user interaction.
        let hasSelectedOptionChanged = false;
        if (selectedOptions.length) {
            const [firstSelectedOption] = selectedOptions[0];
            hasSelectedOptionChanged =
                this.lastSelectedOption !== firstSelectedOption;
            this.lastSelectedOption = firstSelectedOption;
            this[VALUE] = firstSelectedOption.value;
            this.displayText = firstSelectedOption.displayText;
        }
        else {
            hasSelectedOptionChanged = this.lastSelectedOption !== null;
            this.lastSelectedOption = null;
            this[VALUE] = '';
            this.displayText = '';
        }
        return hasSelectedOptionChanged;
    }
    /**
     * Focuses and activates the last selected item upon opening, and resets other
     * active items.
     */
    async handleOpening(e) {
        this.labelEl?.removeAttribute?.('aria-live');
        this.redispatchEvent(e);
        // FocusState.NONE means we want to handle focus ourselves and focus the
        // last selected item.
        if (this.defaultFocus !== FocusState.NONE) {
            return;
        }
        const items = this.menu.items;
        const activeItem = getActiveItem(items)?.item;
        let [selectedItem] = this.lastSelectedOptionRecords[0] ?? [null];
        // This is true if the user keys through the list but clicks out of the menu
        // thus no close-menu event is fired by an item and we can't clean up in
        // handleCloseMenu.
        if (activeItem && activeItem !== selectedItem) {
            activeItem.tabIndex = -1;
        }
        // in the case that nothing is selected, focus the first item
        selectedItem = selectedItem ?? items[0];
        if (selectedItem) {
            selectedItem.tabIndex = 0;
            selectedItem.focus();
        }
    }
    redispatchEvent(e) {
        redispatchEvent(this, e);
    }
    handleClosed(e) {
        this.open = false;
        this.redispatchEvent(e);
    }
    /**
     * Determines the reason for closing, and updates the UI accordingly.
     */
    handleCloseMenu(event) {
        const reason = event.detail.reason;
        const item = event.detail.itemPath[0];
        this.open = false;
        let hasChanged = false;
        if (reason.kind === 'click-selection') {
            hasChanged = this.selectItem(item);
        }
        else if (reason.kind === 'keydown' && isSelectableKey(reason.key)) {
            hasChanged = this.selectItem(item);
        }
        else {
            // This can happen on ESC being pressed
            item.tabIndex = -1;
            item.blur();
        }
        // Dispatch interaction events since selection has been made via keyboard
        // or mouse.
        if (hasChanged) {
            this.dispatchInteractionEvents();
        }
    }
    /**
     * Selects a given option, deselects other options, and updates the UI.
     *
     * @return Whether the last selected option has changed.
     */
    selectItem(item) {
        const selectedOptions = this.getSelectedOptions() ?? [];
        selectedOptions.forEach(([option]) => {
            if (item !== option) {
                option.selected = false;
                option.tabIndex = -1;
            }
        });
        item.selected = true;
        item.tabIndex = 0;
        return this.updateValueAndDisplayText();
    }
    /**
     * Handles updating selection when an option element requests selection via
     * property / attribute change.
     */
    handleRequestSelection(event) {
        const requestingOptionEl = event.target;
        // No-op if this item is already selected.
        if (this.lastSelectedOptionRecords.some(([option]) => option === requestingOptionEl)) {
            return;
        }
        this.selectItem(requestingOptionEl);
    }
    /**
     * Handles updating selection when an option element requests deselection via
     * property / attribute change.
     */
    handleRequestDeselection(event) {
        const requestingOptionEl = event.target;
        // No-op if this item is not even in the list of tracked selected items.
        if (!this.lastSelectedOptionRecords.some(([option]) => option === requestingOptionEl)) {
            return;
        }
        this.updateValueAndDisplayText();
    }
    /**
     * Attempts to initialize the selected option from user-settable values like
     * SSR, setting `value`, or `selectedIndex` at startup.
     */
    initUserSelection() {
        // User has set `.value` directly, but internals have not yet booted up.
        if (this.lastUserSetValue && !this.lastSelectedOptionRecords.length) {
            this.select(this.lastUserSetValue);
            // User has set `.selectedIndex` directly, but internals have not yet
            // booted up.
        }
        else if (this.lastUserSetSelectedIndex !== null &&
            !this.lastSelectedOptionRecords.length) {
            this.selectIndex(this.lastUserSetSelectedIndex);
            // Regular boot up!
        }
        else {
            this.updateValueAndDisplayText();
        }
    }
    handleIconChange() {
        this.hasLeadingIcon = this.leadingIcons.length > 0;
    }
    /**
     * Dispatches the `input` and `change` events.
     */
    dispatchInteractionEvents() {
        this.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        this.dispatchEvent(new Event('change', { bubbles: true }));
    }
    getErrorText() {
        return this.error ? this.errorText : this.nativeErrorText;
    }
    [getFormValue]() {
        return this.value;
    }
    formResetCallback() {
        this.reset();
    }
    formStateRestoreCallback(state) {
        this.value = state;
    }
    click() {
        this.field?.click();
    }
    [createValidator]() {
        return new SelectValidator(() => this);
    }
    [getValidityAnchor]() {
        return this.field;
    }
}
/** @nocollapse */
Select.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean })
], Select.prototype, "quick", void 0);
__decorate([
    n$3({ type: Boolean })
], Select.prototype, "required", void 0);
__decorate([
    n$3({ type: String, attribute: 'error-text' })
], Select.prototype, "errorText", void 0);
__decorate([
    n$3()
], Select.prototype, "label", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-asterisk' })
], Select.prototype, "noAsterisk", void 0);
__decorate([
    n$3({ type: String, attribute: 'supporting-text' })
], Select.prototype, "supportingText", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], Select.prototype, "error", void 0);
__decorate([
    n$3({ attribute: 'menu-positioning' })
], Select.prototype, "menuPositioning", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'clamp-menu-width' })
], Select.prototype, "clampMenuWidth", void 0);
__decorate([
    n$3({ type: Number, attribute: 'typeahead-delay' })
], Select.prototype, "typeaheadDelay", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-leading-icon' })
], Select.prototype, "hasLeadingIcon", void 0);
__decorate([
    n$3({ attribute: 'display-text' })
], Select.prototype, "displayText", void 0);
__decorate([
    n$3({ attribute: 'menu-align' })
], Select.prototype, "menuAlign", void 0);
__decorate([
    n$3()
], Select.prototype, "value", null);
__decorate([
    n$3({ type: Number, attribute: 'selected-index' })
], Select.prototype, "selectedIndex", null);
__decorate([
    r$2()
], Select.prototype, "nativeError", void 0);
__decorate([
    r$2()
], Select.prototype, "nativeErrorText", void 0);
__decorate([
    r$2()
], Select.prototype, "focused", void 0);
__decorate([
    r$2()
], Select.prototype, "open", void 0);
__decorate([
    r$2()
], Select.prototype, "defaultFocus", void 0);
__decorate([
    e$4('.field')
], Select.prototype, "field", void 0);
__decorate([
    e$4('md-menu')
], Select.prototype, "menu", void 0);
__decorate([
    e$4('#label')
], Select.prototype, "labelEl", void 0);
__decorate([
    o$2({ slot: 'leading-icon', flatten: true })
], Select.prototype, "leadingIcons", void 0);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// tslint:disable-next-line:enforce-comments-on-exported-symbols
class OutlinedSelect extends Select {
    constructor() {
        super(...arguments);
        this.fieldTag = i `md-outlined-field`;
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./select/internal/outlined-select-styles.css.
const styles$b = i$7 `:host{--_text-field-disabled-input-text-color: var(--md-outlined-select-text-field-disabled-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-input-text-opacity: var(--md-outlined-select-text-field-disabled-input-text-opacity, 0.38);--_text-field-disabled-label-text-color: var(--md-outlined-select-text-field-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-label-text-opacity: var(--md-outlined-select-text-field-disabled-label-text-opacity, 0.38);--_text-field-disabled-leading-icon-color: var(--md-outlined-select-text-field-disabled-leading-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-leading-icon-opacity: var(--md-outlined-select-text-field-disabled-leading-icon-opacity, 0.38);--_text-field-disabled-outline-color: var(--md-outlined-select-text-field-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-outline-opacity: var(--md-outlined-select-text-field-disabled-outline-opacity, 0.12);--_text-field-disabled-outline-width: var(--md-outlined-select-text-field-disabled-outline-width, 1px);--_text-field-disabled-supporting-text-color: var(--md-outlined-select-text-field-disabled-supporting-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-supporting-text-opacity: var(--md-outlined-select-text-field-disabled-supporting-text-opacity, 0.38);--_text-field-disabled-trailing-icon-color: var(--md-outlined-select-text-field-disabled-trailing-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-trailing-icon-opacity: var(--md-outlined-select-text-field-disabled-trailing-icon-opacity, 0.38);--_text-field-error-focus-input-text-color: var(--md-outlined-select-text-field-error-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-error-focus-label-text-color: var(--md-outlined-select-text-field-error-focus-label-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-focus-leading-icon-color: var(--md-outlined-select-text-field-error-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-error-focus-outline-color: var(--md-outlined-select-text-field-error-focus-outline-color, var(--md-sys-color-error, #b3261e));--_text-field-error-focus-supporting-text-color: var(--md-outlined-select-text-field-error-focus-supporting-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-focus-trailing-icon-color: var(--md-outlined-select-text-field-error-focus-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_text-field-error-hover-input-text-color: var(--md-outlined-select-text-field-error-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-error-hover-label-text-color: var(--md-outlined-select-text-field-error-hover-label-text-color, var(--md-sys-color-on-error-container, #410e0b));--_text-field-error-hover-leading-icon-color: var(--md-outlined-select-text-field-error-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-error-hover-outline-color: var(--md-outlined-select-text-field-error-hover-outline-color, var(--md-sys-color-on-error-container, #410e0b));--_text-field-error-hover-supporting-text-color: var(--md-outlined-select-text-field-error-hover-supporting-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-hover-trailing-icon-color: var(--md-outlined-select-text-field-error-hover-trailing-icon-color, var(--md-sys-color-on-error-container, #410e0b));--_text-field-error-input-text-color: var(--md-outlined-select-text-field-error-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-error-label-text-color: var(--md-outlined-select-text-field-error-label-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-leading-icon-color: var(--md-outlined-select-text-field-error-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-error-outline-color: var(--md-outlined-select-text-field-error-outline-color, var(--md-sys-color-error, #b3261e));--_text-field-error-supporting-text-color: var(--md-outlined-select-text-field-error-supporting-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-trailing-icon-color: var(--md-outlined-select-text-field-error-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_text-field-focus-input-text-color: var(--md-outlined-select-text-field-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-focus-label-text-color: var(--md-outlined-select-text-field-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_text-field-focus-leading-icon-color: var(--md-outlined-select-text-field-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-focus-outline-color: var(--md-outlined-select-text-field-focus-outline-color, var(--md-sys-color-primary, #6750a4));--_text-field-focus-outline-width: var(--md-outlined-select-text-field-focus-outline-width, 3px);--_text-field-focus-supporting-text-color: var(--md-outlined-select-text-field-focus-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-focus-trailing-icon-color: var(--md-outlined-select-text-field-focus-trailing-icon-color, var(--md-sys-color-primary, #6750a4));--_text-field-hover-input-text-color: var(--md-outlined-select-text-field-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-hover-label-text-color: var(--md-outlined-select-text-field-hover-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-hover-leading-icon-color: var(--md-outlined-select-text-field-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-hover-outline-color: var(--md-outlined-select-text-field-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-hover-outline-width: var(--md-outlined-select-text-field-hover-outline-width, 1px);--_text-field-hover-supporting-text-color: var(--md-outlined-select-text-field-hover-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-hover-trailing-icon-color: var(--md-outlined-select-text-field-hover-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-input-text-color: var(--md-outlined-select-text-field-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-input-text-font: var(--md-outlined-select-text-field-input-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_text-field-input-text-line-height: var(--md-outlined-select-text-field-input-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_text-field-input-text-size: var(--md-outlined-select-text-field-input-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_text-field-input-text-weight: var(--md-outlined-select-text-field-input-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_text-field-label-text-color: var(--md-outlined-select-text-field-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-label-text-font: var(--md-outlined-select-text-field-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_text-field-label-text-line-height: var(--md-outlined-select-text-field-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_text-field-label-text-populated-line-height: var(--md-outlined-select-text-field-label-text-populated-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_text-field-label-text-populated-size: var(--md-outlined-select-text-field-label-text-populated-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_text-field-label-text-size: var(--md-outlined-select-text-field-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_text-field-label-text-weight: var(--md-outlined-select-text-field-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_text-field-leading-icon-color: var(--md-outlined-select-text-field-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-leading-icon-size: var(--md-outlined-select-text-field-leading-icon-size, 24px);--_text-field-outline-color: var(--md-outlined-select-text-field-outline-color, var(--md-sys-color-outline, #79747e));--_text-field-outline-width: var(--md-outlined-select-text-field-outline-width, 1px);--_text-field-supporting-text-color: var(--md-outlined-select-text-field-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-supporting-text-font: var(--md-outlined-select-text-field-supporting-text-font, var(--md-sys-typescale-body-small-font, var(--md-ref-typeface-plain, Roboto)));--_text-field-supporting-text-line-height: var(--md-outlined-select-text-field-supporting-text-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_text-field-supporting-text-size: var(--md-outlined-select-text-field-supporting-text-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_text-field-supporting-text-weight: var(--md-outlined-select-text-field-supporting-text-weight, var(--md-sys-typescale-body-small-weight, var(--md-ref-typeface-weight-regular, 400)));--_text-field-trailing-icon-color: var(--md-outlined-select-text-field-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-trailing-icon-size: var(--md-outlined-select-text-field-trailing-icon-size, 24px);--_text-field-container-shape-start-start: var(--md-outlined-select-text-field-container-shape-start-start, var(--md-outlined-select-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_text-field-container-shape-start-end: var(--md-outlined-select-text-field-container-shape-start-end, var(--md-outlined-select-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_text-field-container-shape-end-end: var(--md-outlined-select-text-field-container-shape-end-end, var(--md-outlined-select-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_text-field-container-shape-end-start: var(--md-outlined-select-text-field-container-shape-end-start, var(--md-outlined-select-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--md-outlined-field-container-shape-end-end: var(--_text-field-container-shape-end-end);--md-outlined-field-container-shape-end-start: var(--_text-field-container-shape-end-start);--md-outlined-field-container-shape-start-end: var(--_text-field-container-shape-start-end);--md-outlined-field-container-shape-start-start: var(--_text-field-container-shape-start-start);--md-outlined-field-content-color: var(--_text-field-input-text-color);--md-outlined-field-content-font: var(--_text-field-input-text-font);--md-outlined-field-content-line-height: var(--_text-field-input-text-line-height);--md-outlined-field-content-size: var(--_text-field-input-text-size);--md-outlined-field-content-weight: var(--_text-field-input-text-weight);--md-outlined-field-disabled-content-color: var(--_text-field-disabled-input-text-color);--md-outlined-field-disabled-content-opacity: var(--_text-field-disabled-input-text-opacity);--md-outlined-field-disabled-label-text-color: var(--_text-field-disabled-label-text-color);--md-outlined-field-disabled-label-text-opacity: var(--_text-field-disabled-label-text-opacity);--md-outlined-field-disabled-leading-content-color: var(--_text-field-disabled-leading-icon-color);--md-outlined-field-disabled-leading-content-opacity: var(--_text-field-disabled-leading-icon-opacity);--md-outlined-field-disabled-outline-color: var(--_text-field-disabled-outline-color);--md-outlined-field-disabled-outline-opacity: var(--_text-field-disabled-outline-opacity);--md-outlined-field-disabled-outline-width: var(--_text-field-disabled-outline-width);--md-outlined-field-disabled-supporting-text-color: var(--_text-field-disabled-supporting-text-color);--md-outlined-field-disabled-supporting-text-opacity: var(--_text-field-disabled-supporting-text-opacity);--md-outlined-field-disabled-trailing-content-color: var(--_text-field-disabled-trailing-icon-color);--md-outlined-field-disabled-trailing-content-opacity: var(--_text-field-disabled-trailing-icon-opacity);--md-outlined-field-error-content-color: var(--_text-field-error-input-text-color);--md-outlined-field-error-focus-content-color: var(--_text-field-error-focus-input-text-color);--md-outlined-field-error-focus-label-text-color: var(--_text-field-error-focus-label-text-color);--md-outlined-field-error-focus-leading-content-color: var(--_text-field-error-focus-leading-icon-color);--md-outlined-field-error-focus-outline-color: var(--_text-field-error-focus-outline-color);--md-outlined-field-error-focus-supporting-text-color: var(--_text-field-error-focus-supporting-text-color);--md-outlined-field-error-focus-trailing-content-color: var(--_text-field-error-focus-trailing-icon-color);--md-outlined-field-error-hover-content-color: var(--_text-field-error-hover-input-text-color);--md-outlined-field-error-hover-label-text-color: var(--_text-field-error-hover-label-text-color);--md-outlined-field-error-hover-leading-content-color: var(--_text-field-error-hover-leading-icon-color);--md-outlined-field-error-hover-outline-color: var(--_text-field-error-hover-outline-color);--md-outlined-field-error-hover-supporting-text-color: var(--_text-field-error-hover-supporting-text-color);--md-outlined-field-error-hover-trailing-content-color: var(--_text-field-error-hover-trailing-icon-color);--md-outlined-field-error-label-text-color: var(--_text-field-error-label-text-color);--md-outlined-field-error-leading-content-color: var(--_text-field-error-leading-icon-color);--md-outlined-field-error-outline-color: var(--_text-field-error-outline-color);--md-outlined-field-error-supporting-text-color: var(--_text-field-error-supporting-text-color);--md-outlined-field-error-trailing-content-color: var(--_text-field-error-trailing-icon-color);--md-outlined-field-focus-content-color: var(--_text-field-focus-input-text-color);--md-outlined-field-focus-label-text-color: var(--_text-field-focus-label-text-color);--md-outlined-field-focus-leading-content-color: var(--_text-field-focus-leading-icon-color);--md-outlined-field-focus-outline-color: var(--_text-field-focus-outline-color);--md-outlined-field-focus-outline-width: var(--_text-field-focus-outline-width);--md-outlined-field-focus-supporting-text-color: var(--_text-field-focus-supporting-text-color);--md-outlined-field-focus-trailing-content-color: var(--_text-field-focus-trailing-icon-color);--md-outlined-field-hover-content-color: var(--_text-field-hover-input-text-color);--md-outlined-field-hover-label-text-color: var(--_text-field-hover-label-text-color);--md-outlined-field-hover-leading-content-color: var(--_text-field-hover-leading-icon-color);--md-outlined-field-hover-outline-color: var(--_text-field-hover-outline-color);--md-outlined-field-hover-outline-width: var(--_text-field-hover-outline-width);--md-outlined-field-hover-supporting-text-color: var(--_text-field-hover-supporting-text-color);--md-outlined-field-hover-trailing-content-color: var(--_text-field-hover-trailing-icon-color);--md-outlined-field-label-text-color: var(--_text-field-label-text-color);--md-outlined-field-label-text-font: var(--_text-field-label-text-font);--md-outlined-field-label-text-line-height: var(--_text-field-label-text-line-height);--md-outlined-field-label-text-populated-line-height: var(--_text-field-label-text-populated-line-height);--md-outlined-field-label-text-populated-size: var(--_text-field-label-text-populated-size);--md-outlined-field-label-text-size: var(--_text-field-label-text-size);--md-outlined-field-label-text-weight: var(--_text-field-label-text-weight);--md-outlined-field-leading-content-color: var(--_text-field-leading-icon-color);--md-outlined-field-outline-color: var(--_text-field-outline-color);--md-outlined-field-outline-width: var(--_text-field-outline-width);--md-outlined-field-supporting-text-color: var(--_text-field-supporting-text-color);--md-outlined-field-supporting-text-font: var(--_text-field-supporting-text-font);--md-outlined-field-supporting-text-line-height: var(--_text-field-supporting-text-line-height);--md-outlined-field-supporting-text-size: var(--_text-field-supporting-text-size);--md-outlined-field-supporting-text-weight: var(--_text-field-supporting-text-weight);--md-outlined-field-trailing-content-color: var(--_text-field-trailing-icon-color)}[has-start] .icon.leading{font-size:var(--_text-field-leading-icon-size);height:var(--_text-field-leading-icon-size);width:var(--_text-field-leading-icon-size)}.icon.trailing{font-size:var(--_text-field-trailing-icon-size);height:var(--_text-field-trailing-icon-size);width:var(--_text-field-trailing-icon-size)}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./select/internal/shared-styles.css.
const styles$a = i$7 `:host{color:unset;min-width:210px;display:flex}.field{cursor:default;outline:none}.select{position:relative;flex-direction:column}.icon.trailing svg,.icon ::slotted(*){fill:currentColor}.icon ::slotted(*){width:inherit;height:inherit;font-size:inherit}.icon slot{display:flex;height:100%;width:100%;align-items:center;justify-content:center}.icon.trailing :is(.up,.down){opacity:0;transition:opacity 75ms linear 75ms}.select:not(.open) .down,.select.open .up{opacity:1}.field,.select,md-menu{min-width:inherit;width:inherit;max-width:inherit;display:flex}md-menu{min-width:var(--__menu-min-width);max-width:var(--__menu-max-width, inherit)}.menu-wrapper{width:0px;height:0px;max-width:inherit}md-menu ::slotted(:not[disabled]){cursor:pointer}.field,.select{width:100%}:host{display:inline-flex}:host([disabled]){pointer-events:none}
`;

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
class InternalOutlinedSelect extends OutlinedSelect {
}
InternalOutlinedSelect.styles = [styles$a, styles$b];
/**
 * @tagname oscd-outlined-select
 * @summary
 * Select menus display a list of choices on temporary surfaces and display the
 * currently selected menu item above the menu.
 *
 * The select component allows users to choose a value from a fixed list of
 * available options. Composed of an interactive anchor button and a menu, it is
 * analogous to the native HTML `<select>` element. This is the "outlined"
 * variant.
 *
 * @example
 * ```html
 * <oscd-outlined-select label="fruits">
 *   <!-- An empty selected option will give select an "un-filled" state -->
 *   <md-select-option selected></md-select-option>
 *   <md-select-option value="apple" headline="Apple"></md-select-option>
 *   <md-select-option value="banana" headline="Banana"></md-select-option>
 *   <md-select-option value="kiwi" headline="Kiwi"></md-select-option>
 *   <md-select-option value="orange" headline="Orange"></md-select-option>
 *   <md-select-option value="tomato" headline="Tomato"></md-select-option>
 * </oscd-outlined-select>
 * ```
 *
 * @final
 * @suppress {visibility}
 */
class OscdOutlinedSelect extends ScopedElementsMixin(InternalOutlinedSelect) {
}
OscdOutlinedSelect.scopedElements = {
    'md-menu': OscdMenu,
    'md-outlined-field': OscdOutlinedField,
};
OscdOutlinedSelect.styles = [styles$a, styles$b];

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Creates an event fired by a SelectOption to request selection from md-select.
 * Typically fired after `selected` changes from `false` to `true`.
 */
function createRequestSelectionEvent() {
    return new Event('request-selection', {
        bubbles: true,
        composed: true,
    });
}
/**
 * Creates an event fired by a SelectOption to request deselection from
 * md-select. Typically fired after `selected` changes from `true` to `false`.
 */
function createRequestDeselectionEvent() {
    return new Event('request-deselection', {
        bubbles: true,
        composed: true,
    });
}
/**
 * A controller that provides most functionality and md-select compatibility for
 * an element that implements the SelectOption interface.
 */
class SelectOptionController {
    /**
     * The recommended role of the select option.
     */
    get role() {
        return this.menuItemController.role;
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot, and if there are
     * no slotted elements into headline, then it checks the _default_ slot, and
     * then the `"supporting-text"` slot if nothing is in _default_.
     */
    get typeaheadText() {
        return this.menuItemController.typeaheadText;
    }
    setTypeaheadText(text) {
        this.menuItemController.setTypeaheadText(text);
    }
    /**
     * The text that is displayed in the select field when selected. If not set,
     * defaults to the textContent of the item slotted into the `"headline"` slot,
     * and if there are no slotted elements into headline, then it checks the
     * _default_ slot, and then the `"supporting-text"` slot if nothing is in
     * _default_.
     */
    get displayText() {
        if (this.internalDisplayText !== null) {
            return this.internalDisplayText;
        }
        return this.menuItemController.typeaheadText;
    }
    setDisplayText(text) {
        this.internalDisplayText = text;
    }
    /**
     * @param host The SelectOption in which to attach this controller to.
     * @param config The object that configures this controller's behavior.
     */
    constructor(host, config) {
        this.host = host;
        this.internalDisplayText = null;
        this.firstUpdate = true;
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */
        this.onClick = () => {
            this.menuItemController.onClick();
        };
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */
        this.onKeydown = (e) => {
            this.menuItemController.onKeydown(e);
        };
        this.lastSelected = this.host.selected;
        this.menuItemController = new MenuItemController(host, config);
        host.addController(this);
    }
    hostUpdate() {
        if (this.lastSelected !== this.host.selected) {
            this.host.ariaSelected = this.host.selected ? 'true' : 'false';
        }
    }
    hostUpdated() {
        // Do not dispatch event on first update / boot-up.
        if (this.lastSelected !== this.host.selected && !this.firstUpdate) {
            // This section is really useful for when the user sets selected on the
            // option programmatically. Most other cases (click and keyboard) are
            // handled by md-select because it needs to coordinate the
            // single-selection behavior.
            if (this.host.selected) {
                this.host.dispatchEvent(createRequestSelectionEvent());
            }
            else {
                this.host.dispatchEvent(createRequestDeselectionEvent());
            }
        }
        this.lastSelected = this.host.selected;
        this.firstUpdate = false;
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const selectOptionBaseClass = mixinDelegatesAria(i$4);
/**
 * @fires close-menu {CustomEvent<{initiator: SelectOption, reason: Reason, itemPath: SelectOption[]}>}
 * Closes the encapsulating menu on closable interaction. --bubbles --composed
 * @fires request-selection {Event} Requests the parent md-select to select this
 * element (and deselect others if single-selection) when `selected` changed to
 * `true`. --bubbles --composed
 * @fires request-deselection {Event} Requests the parent md-select to deselect
 * this element when `selected` changed to `false`. --bubbles --composed
 */
class SelectOptionEl extends selectOptionBaseClass {
    constructor() {
        super(...arguments);
        /**
         * Disables the item and makes it non-selectable and non-interactive.
         */
        this.disabled = false;
        /**
         * READONLY: self-identifies as a menu item and sets its identifying attribute
         */
        this.isMenuItem = true;
        /**
         * Sets the item in the selected visual state when a submenu is opened.
         */
        this.selected = false;
        /**
         * Form value of the option.
         */
        this.value = '';
        this.type = 'option';
        this.selectOptionController = new SelectOptionController(this, {
            getHeadlineElements: () => {
                return this.headlineElements;
            },
            getSupportingTextElements: () => {
                return this.supportingTextElements;
            },
            getDefaultElements: () => {
                return this.defaultElements;
            },
            getInteractiveElement: () => this.listItemRoot,
        });
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot.
     */
    get typeaheadText() {
        return this.selectOptionController.typeaheadText;
    }
    set typeaheadText(text) {
        this.selectOptionController.setTypeaheadText(text);
    }
    /**
     * The text that is displayed in the select field when selected. If not set,
     * defaults to the textContent of the item slotted into the `"headline"` slot.
     */
    get displayText() {
        return this.selectOptionController.displayText;
    }
    set displayText(text) {
        this.selectOptionController.setDisplayText(text);
    }
    render() {
        return this.renderListItem(b `
      <md-item>
        <div slot="container">
          ${this.renderRipple()} ${this.renderFocusRing()}
        </div>
        <slot name="start" slot="start"></slot>
        <slot name="end" slot="end"></slot>
        ${this.renderBody()}
      </md-item>
    `);
    }
    /**
     * Renders the root list item.
     *
     * @param content the child content of the list item.
     */
    renderListItem(content) {
        return b `
      <li
        id="item"
        tabindex=${this.disabled ? -1 : 0}
        role=${this.selectOptionController.role}
        aria-label=${this.ariaLabel || A}
        aria-selected=${this.ariaSelected || A}
        aria-checked=${this.ariaChecked || A}
        aria-expanded=${this.ariaExpanded || A}
        aria-haspopup=${this.ariaHasPopup || A}
        class="list-item ${e(this.getRenderClasses())}"
        @click=${this.selectOptionController.onClick}
        @keydown=${this.selectOptionController.onKeydown}
        >${content}</li
      >
    `;
    }
    /**
     * Handles rendering of the ripple element.
     */
    renderRipple() {
        return b ` <md-ripple
      part="ripple"
      for="item"
      ?disabled=${this.disabled}></md-ripple>`;
    }
    /**
     * Handles rendering of the focus ring.
     */
    renderFocusRing() {
        return b ` <md-focus-ring
      part="focus-ring"
      for="item"
      inward></md-focus-ring>`;
    }
    /**
     * Classes applied to the list item root.
     */
    getRenderClasses() {
        return {
            'disabled': this.disabled,
            'selected': this.selected,
        };
    }
    /**
     * Handles rendering the headline and supporting text.
     */
    renderBody() {
        return b `
      <slot></slot>
      <slot name="overline" slot="overline"></slot>
      <slot name="headline" slot="headline"></slot>
      <slot name="supporting-text" slot="supporting-text"></slot>
      <slot
        name="trailing-supporting-text"
        slot="trailing-supporting-text"></slot>
    `;
    }
    focus() {
        // TODO(b/300334509): needed for some cases where delegatesFocus doesn't
        // work programmatically like in FF and select-option
        this.listItemRoot?.focus();
    }
}
/** @nocollapse */
SelectOptionEl.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, reflect: true })
], SelectOptionEl.prototype, "disabled", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'md-menu-item', reflect: true })
], SelectOptionEl.prototype, "isMenuItem", void 0);
__decorate([
    n$3({ type: Boolean })
], SelectOptionEl.prototype, "selected", void 0);
__decorate([
    n$3()
], SelectOptionEl.prototype, "value", void 0);
__decorate([
    e$4('.list-item')
], SelectOptionEl.prototype, "listItemRoot", void 0);
__decorate([
    o$2({ slot: 'headline' })
], SelectOptionEl.prototype, "headlineElements", void 0);
__decorate([
    o$2({ slot: 'supporting-text' })
], SelectOptionEl.prototype, "supportingTextElements", void 0);
__decorate([
    n$2({ slot: '' })
], SelectOptionEl.prototype, "defaultElements", void 0);
__decorate([
    n$3({ attribute: 'typeahead-text' })
], SelectOptionEl.prototype, "typeaheadText", null);
__decorate([
    n$3({ attribute: 'display-text' })
], SelectOptionEl.prototype, "displayText", null);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-select-option
 * @summary
 * Select menus display a list of choices on temporary surfaces and display the
 * currently selected menu item above the menu.
 *
 * The select component allows users to choose a value from a fixed list of
 * available options. Composed of an interactive anchor button and a menu, it is
 * analogous to the native HTML `<select>` element. This is the option that
 * can be placed inside of an md-select.
 *
 * This component is a subclass of `md-menu-item` and can accept the same slots,
 * properties, and events as `md-menu-item`.
 *
 * @example
 * ```html
 * <md-outlined-select label="fruits">
 *   <!-- An empty selected option will give select an "un-filled" state -->
 *   <oscd-select-option selected></oscd-select-option>
 *   <oscd-select-option value="apple" headline="Apple"></oscd-select-option>
 *   <oscd-select-option value="banana" headline="Banana"></oscd-select-option>
 *   <oscd-select-option value="kiwi" headline="Kiwi"></oscd-select-option>
 *   <oscd-select-option value="orange" headline="Orange"></oscd-select-option>
 *   <oscd-select-option value="tomato" headline="Tomato"></oscd-select-option>
 * </md-outlined-select>
 * ```
 *
 * @final
 * @suppress {visibility}
 */
class OscdSelectOption extends ScopedElementsMixin(SelectOptionEl) {
}
OscdSelectOption.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
    'md-item': OscdItem,
};
OscdSelectOption.styles = [styles$p];

const services = ['GOOSE', 'SV', 'Report'];

/** True on Apple platforms, where shortcuts use Command instead of Ctrl. */
function isApple(platform = navigator.platform) {
    return /Mac|iPhone|iPad/.test(platform);
}
/** A shortcut as shown in tooltips: `Ctrl+F`, or `⌘F` on Apple platforms. */
function shortcut(key, apple = isApple()) {
    return apple ? `\u2318${key}` : `Ctrl+${key}`;
}
/** Actions of Ctrl (Command) key combinations, by lower case key. */
const withModifier = {
    f: 'search',
    '=': 'zoom-in',
    '+': 'zoom-in',
    '-': 'zoom-out',
    '0': 'zoom-fit',
    '[': 'previous-substation',
    ']': 'next-substation',
    g: 'toggle-goose',
    s: 'toggle-sv',
    r: 'toggle-report',
    l: 'toggle-labels',
};
/** Actions of single keys, used outside text fields. */
const single = {
    '/': 'search',
    '+': 'zoom-in',
    '=': 'zoom-in',
    '-': 'zoom-out',
    '0': 'zoom-fit',
    f: 'toggle-filter',
    l: 'toggle-labels',
};
/**
 * The map action of a key press, if any. Single keys only act outside text
 * fields; Ctrl+Shift+F is left to the OpenSCD shell (its plugin search),
 * and Alt combinations to the browser.
 */
function shortcutAction(event, inTextField) {
    if (event.altKey) {
        return undefined;
    }
    const key = event.key.toLowerCase();
    if (event.ctrlKey || event.metaKey) {
        if (event.shiftKey && key === 'f') {
            return undefined;
        }
        return withModifier[key];
    }
    return inTextField ? undefined : single[key];
}

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const r=o=>void 0===o.strings,m={},p=(o,t=m)=>o._$AH=t;

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const l=e$2(class extends i$3{constructor(r$1){if(super(r$1),r$1.type!==t.PROPERTY&&r$1.type!==t.ATTRIBUTE&&r$1.type!==t.BOOLEAN_ATTRIBUTE)throw Error("The `live` directive is not allowed on child or event bindings");if(!r(r$1))throw Error("`live` bindings can only contain a single expression")}render(r){return r}update(i,[t$1]){if(t$1===E||t$1===A)return t$1;const o=i.element,l=i.name;if(i.type===t.PROPERTY){if(t$1===o[l])return E}else if(i.type===t.BOOLEAN_ATTRIBUTE){if(!!t$1===o.hasAttribute(l))return E}else if(i.type===t.ATTRIBUTE&&o.getAttribute(l)===t$1+"")return E;return p(i),t$1}});

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const stringConverter = {
    fromAttribute(value) {
        return value ?? '';
    },
    toAttribute(value) {
        return value || null;
    },
};

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A validator that provides constraint validation that emulates `<input>` and
 * `<textarea>` validation.
 */
class TextFieldValidator extends Validator {
    computeValidity({ state, renderedControl }) {
        let inputOrTextArea = renderedControl;
        if (isInputState(state) && !inputOrTextArea) {
            // Get cached <input> or create it.
            inputOrTextArea = this.inputControl || document.createElement('input');
            // Cache the <input> to re-use it next time.
            this.inputControl = inputOrTextArea;
        }
        else if (!inputOrTextArea) {
            // Get cached <textarea> or create it.
            inputOrTextArea =
                this.textAreaControl || document.createElement('textarea');
            // Cache the <textarea> to re-use it next time.
            this.textAreaControl = inputOrTextArea;
        }
        // Set this variable so we can check it for input-specific properties.
        const input = isInputState(state)
            ? inputOrTextArea
            : null;
        // Set input's "type" first, since this can change the other properties
        if (input) {
            input.type = state.type;
        }
        if (inputOrTextArea.value !== state.value) {
            // Only programmatically set the value if there's a difference. When using
            // the rendered control, the value will always be up to date. Setting the
            // property (even if it's the same string) will reset the internal <input>
            // dirty flag, making minlength and maxlength validation reset.
            inputOrTextArea.value = state.value;
        }
        inputOrTextArea.required = state.required;
        // The following IDLAttribute properties will always hydrate an attribute,
        // even if set to a the default value ('' or -1). The presence of the
        // attribute triggers constraint validation, so we must remove the attribute
        // when empty.
        if (input) {
            const inputState = state;
            if (inputState.pattern) {
                input.pattern = inputState.pattern;
            }
            else {
                input.removeAttribute('pattern');
            }
            if (inputState.min) {
                input.min = inputState.min;
            }
            else {
                input.removeAttribute('min');
            }
            if (inputState.max) {
                input.max = inputState.max;
            }
            else {
                input.removeAttribute('max');
            }
            if (inputState.step) {
                input.step = inputState.step;
            }
            else {
                input.removeAttribute('step');
            }
        }
        // Use -1 to represent no minlength and maxlength, which is what the
        // platform input returns. However, it will throw an error if you try to
        // manually set it to -1.
        //
        // While the type is `number`, it may actually be `null` at runtime.
        // `null > -1` is true since `null` coerces to `0`, so we default null and
        // undefined to -1.
        //
        // We set attributes instead of properties since setting a property may
        // throw an out of bounds error in relation to the other property.
        // Attributes will not throw errors while the state is updating.
        if ((state.minLength ?? -1) > -1) {
            inputOrTextArea.setAttribute('minlength', String(state.minLength));
        }
        else {
            inputOrTextArea.removeAttribute('minlength');
        }
        if ((state.maxLength ?? -1) > -1) {
            inputOrTextArea.setAttribute('maxlength', String(state.maxLength));
        }
        else {
            inputOrTextArea.removeAttribute('maxlength');
        }
        return {
            validity: inputOrTextArea.validity,
            validationMessage: inputOrTextArea.validationMessage,
        };
    }
    equals({ state: prev }, { state: next }) {
        // Check shared input and textarea properties
        const inputOrTextAreaEqual = prev.type === next.type &&
            prev.value === next.value &&
            prev.required === next.required &&
            prev.minLength === next.minLength &&
            prev.maxLength === next.maxLength;
        if (!isInputState(prev) || !isInputState(next)) {
            // Both are textareas, all relevant properties are equal.
            return inputOrTextAreaEqual;
        }
        // Check additional input-specific properties.
        return (inputOrTextAreaEqual &&
            prev.pattern === next.pattern &&
            prev.min === next.min &&
            prev.max === next.max &&
            prev.step === next.step);
    }
    copy({ state }) {
        // Don't hold a reference to the rendered control when copying since we
        // don't use it when checking if the state changed.
        return {
            state: isInputState(state)
                ? this.copyInput(state)
                : this.copyTextArea(state),
            renderedControl: null,
        };
    }
    copyInput(state) {
        const { type, pattern, min, max, step } = state;
        return {
            ...this.copySharedState(state),
            type,
            pattern,
            min,
            max,
            step,
        };
    }
    copyTextArea(state) {
        return {
            ...this.copySharedState(state),
            type: state.type,
        };
    }
    copySharedState({ value, required, minLength, maxLength, }) {
        return { value, required, minLength, maxLength };
    }
}
function isInputState(state) {
    return state.type !== 'textarea';
}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const textFieldBaseClass = mixinDelegatesAria(mixinOnReportValidity(mixinConstraintValidation(mixinFormAssociated(mixinElementInternals(i$4)))));
/**
 * A text field component.
 *
 * @fires select {Event} The native `select` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/select_event)
 * --bubbles
 * @fires change {Event} The native `change` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event)
 * --bubbles
 * @fires input {InputEvent} The native `input` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event)
 * --bubbles --composed
 */
class TextField extends textFieldBaseClass {
    constructor() {
        super(...arguments);
        /**
         * Gets or sets whether or not the text field is in a visually invalid state.
         *
         * This error state overrides the error state controlled by
         * `reportValidity()`.
         */
        this.error = false;
        /**
         * The error message that replaces supporting text when `error` is true. If
         * `errorText` is an empty string, then the supporting text will continue to
         * show.
         *
         * This error message overrides the error message displayed by
         * `reportValidity()`.
         */
        this.errorText = '';
        /**
         * The floating Material label of the textfield component. It informs the user
         * about what information is requested for a text field. It is aligned with
         * the input text, is always visible, and it floats when focused or when text
         * is entered into the textfield. This label also sets accessibilty labels,
         * but the accessible label is overriden by `aria-label`.
         *
         * Learn more about floating labels from the Material Design guidelines:
         * https://m3.material.io/components/text-fields/guidelines
         */
        this.label = '';
        /**
         * Disables the asterisk on the floating label, when the text field is
         * required.
         */
        this.noAsterisk = false;
        /**
         * Indicates that the user must specify a value for the input before the
         * owning form can be submitted and will render an error state when
         * `reportValidity()` is invoked when value is empty. Additionally the
         * floating label will render an asterisk `"*"` when true.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required
         */
        this.required = false;
        /**
         * The current value of the text field. It is always a string.
         */
        this.value = '';
        /**
         * An optional prefix to display before the input value.
         */
        this.prefixText = '';
        /**
         * An optional suffix to display after the input value.
         */
        this.suffixText = '';
        /**
         * Whether or not the text field has a leading icon. Used for SSR.
         */
        this.hasLeadingIcon = false;
        /**
         * Whether or not the text field has a trailing icon. Used for SSR.
         */
        this.hasTrailingIcon = false;
        /**
         * Conveys additional information below the text field, such as how it should
         * be used.
         */
        this.supportingText = '';
        /**
         * Override the input text CSS `direction`. Useful for RTL languages that use
         * LTR notation for fractions.
         */
        this.textDirection = '';
        /**
         * The number of rows to display for a `type="textarea"` text field.
         * Defaults to 2.
         */
        this.rows = 2;
        /**
         * The number of cols to display for a `type="textarea"` text field.
         * Defaults to 20.
         */
        this.cols = 20;
        // <input> properties
        this.inputMode = '';
        /**
         * Defines the greatest value in the range of permitted values.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#max
         */
        this.max = '';
        /**
         * The maximum number of characters a user can enter into the text field. Set
         * to -1 for none.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#maxlength
         */
        this.maxLength = -1;
        /**
         * Defines the most negative value in the range of permitted values.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#min
         */
        this.min = '';
        /**
         * The minimum number of characters a user can enter into the text field. Set
         * to -1 for none.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#minlength
         */
        this.minLength = -1;
        /**
         * When true, hide the spinner for `type="number"` text fields.
         */
        this.noSpinner = false;
        /**
         * A regular expression that the text field's value must match to pass
         * constraint validation.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#pattern
         */
        this.pattern = '';
        /**
         * Defines the text displayed in the textfield when it has no value. Provides
         * a brief hint to the user as to the expected type of data that should be
         * entered into the control. Unlike `label`, the placeholder is not visible
         * and does not float when the textfield has a value.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/placeholder
         */
        this.placeholder = '';
        /**
         * Indicates whether or not a user should be able to edit the text field's
         * value.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#readonly
         */
        this.readOnly = false;
        /**
         * Indicates that input accepts multiple email addresses.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#multiple
         */
        this.multiple = false;
        /**
         * Returns or sets the element's step attribute, which works with min and max
         * to limit the increments at which a numeric or date-time value can be set.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#step
         */
        this.step = '';
        /**
         * The `<input>` type to use, defaults to "text". The type greatly changes how
         * the text field behaves.
         *
         * Text fields support a limited number of `<input>` types:
         *
         * - text
         * - textarea
         * - email
         * - number
         * - password
         * - search
         * - tel
         * - url
         *
         * See
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types
         * for more details on each input type.
         */
        this.type = 'text';
        /**
         * Describes what, if any, type of autocomplete functionality the input
         * should provide.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
         */
        this.autocomplete = '';
        /**
         * Returns true when the text field has been interacted with. Native
         * validation errors only display in response to user interactions.
         */
        this.dirty = false;
        this.focused = false;
        /**
         * Whether or not a native error has been reported via `reportValidity()`.
         */
        this.nativeError = false;
        /**
         * The validation message displayed from a native error via
         * `reportValidity()`.
         */
        this.nativeErrorText = '';
    }
    /**
     * Gets or sets the direction in which selection occurred.
     */
    get selectionDirection() {
        return this.getInputOrTextarea().selectionDirection;
    }
    set selectionDirection(value) {
        this.getInputOrTextarea().selectionDirection = value;
    }
    /**
     * Gets or sets the end position or offset of a text selection.
     */
    get selectionEnd() {
        return this.getInputOrTextarea().selectionEnd;
    }
    set selectionEnd(value) {
        this.getInputOrTextarea().selectionEnd = value;
    }
    /**
     * Gets or sets the starting position or offset of a text selection.
     */
    get selectionStart() {
        return this.getInputOrTextarea().selectionStart;
    }
    set selectionStart(value) {
        this.getInputOrTextarea().selectionStart = value;
    }
    /**
     * The text field's value as a number.
     */
    get valueAsNumber() {
        const input = this.getInput();
        if (!input) {
            return NaN;
        }
        return input.valueAsNumber;
    }
    set valueAsNumber(value) {
        const input = this.getInput();
        if (!input) {
            return;
        }
        input.valueAsNumber = value;
        this.value = input.value;
    }
    /**
     * The text field's value as a Date.
     */
    get valueAsDate() {
        const input = this.getInput();
        if (!input) {
            return null;
        }
        return input.valueAsDate;
    }
    set valueAsDate(value) {
        const input = this.getInput();
        if (!input) {
            return;
        }
        input.valueAsDate = value;
        this.value = input.value;
    }
    get hasError() {
        return this.error || this.nativeError;
    }
    /**
     * Selects all the text in the text field.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/select
     */
    select() {
        this.getInputOrTextarea().select();
    }
    setRangeText(...args) {
        // Calling setRangeText with 1 vs 3-4 arguments has different behavior.
        // Use spread syntax and type casting to ensure correct usage.
        this.getInputOrTextarea().setRangeText(...args);
        this.value = this.getInputOrTextarea().value;
    }
    /**
     * Sets the start and end positions of a selection in the text field.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
     *
     * @param start The offset into the text field for the start of the selection.
     * @param end The offset into the text field for the end of the selection.
     * @param direction The direction in which the selection is performed.
     */
    setSelectionRange(start, end, direction) {
        this.getInputOrTextarea().setSelectionRange(start, end, direction);
    }
    /**
     * Shows the browser picker for an input element of type "date", "time", etc.
     *
     * For a full list of supported types, see:
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/showPicker#browser_compatibility
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/showPicker
     */
    showPicker() {
        const input = this.getInput();
        if (!input) {
            return;
        }
        input.showPicker();
    }
    /**
     * Decrements the value of a numeric type text field by `step` or `n` `step`
     * number of times.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/stepDown
     *
     * @param stepDecrement The number of steps to decrement, defaults to 1.
     */
    stepDown(stepDecrement) {
        const input = this.getInput();
        if (!input) {
            return;
        }
        input.stepDown(stepDecrement);
        this.value = input.value;
    }
    /**
     * Increments the value of a numeric type text field by `step` or `n` `step`
     * number of times.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/stepUp
     *
     * @param stepIncrement The number of steps to increment, defaults to 1.
     */
    stepUp(stepIncrement) {
        const input = this.getInput();
        if (!input) {
            return;
        }
        input.stepUp(stepIncrement);
        this.value = input.value;
    }
    /**
     * Reset the text field to its default value.
     */
    reset() {
        this.dirty = false;
        this.value = this.getAttribute('value') ?? '';
        this.nativeError = false;
        this.nativeErrorText = '';
    }
    attributeChangedCallback(attribute, newValue, oldValue) {
        if (attribute === 'value' && this.dirty) {
            // After user input, changing the value attribute no longer updates the
            // text field's value (until reset). This matches native <input> behavior.
            return;
        }
        super.attributeChangedCallback(attribute, newValue, oldValue);
    }
    render() {
        const classes = {
            'disabled': this.disabled,
            'error': !this.disabled && this.hasError,
            'textarea': this.type === 'textarea',
            'no-spinner': this.noSpinner,
        };
        return b `
      <span class="text-field ${e(classes)}">
        ${this.renderField()}
      </span>
    `;
    }
    updated(changedProperties) {
        // Keep changedProperties arg so that subclasses may call it
        // If a property such as `type` changes and causes the internal <input>
        // value to change without dispatching an event, re-sync it.
        const value = this.getInputOrTextarea().value;
        if (this.value !== value) {
            // Note this is typically inefficient in updated() since it schedules
            // another update. However, it is needed for the <input> to fully render
            // before checking its value.
            this.value = value;
        }
    }
    renderField() {
        return u `<${this.fieldTag}
      class="field"
      count=${this.value.length}
      ?disabled=${this.disabled}
      ?error=${this.hasError}
      error-text=${this.getErrorText()}
      ?focused=${this.focused}
      ?has-end=${this.hasTrailingIcon}
      ?has-start=${this.hasLeadingIcon}
      label=${this.label}
      ?no-asterisk=${this.noAsterisk}
      max=${this.maxLength}
      ?populated=${!!this.value}
      ?required=${this.required}
      ?resizable=${this.type === 'textarea'}
      supporting-text=${this.supportingText}
    >
      ${this.renderLeadingIcon()}
      ${this.renderInputOrTextarea()}
      ${this.renderTrailingIcon()}
      <div id="description" slot="aria-describedby"></div>
      <slot name="container" slot="container"></slot>
    </${this.fieldTag}>`;
    }
    renderLeadingIcon() {
        return b `
      <span class="icon leading" slot="start">
        <slot name="leading-icon" @slotchange=${this.handleIconChange}></slot>
      </span>
    `;
    }
    renderTrailingIcon() {
        return b `
      <span class="icon trailing" slot="end">
        <slot name="trailing-icon" @slotchange=${this.handleIconChange}></slot>
      </span>
    `;
    }
    renderInputOrTextarea() {
        const style = { 'direction': this.textDirection };
        const ariaLabel = this.ariaLabel || this.label || A;
        // lit-anaylzer `autocomplete` types are too strict
        // tslint:disable-next-line:no-any
        const autocomplete = this.autocomplete;
        // These properties may be set to null if the attribute is removed, and
        // `null > -1` is incorrectly `true`.
        const hasMaxLength = (this.maxLength ?? -1) > -1;
        const hasMinLength = (this.minLength ?? -1) > -1;
        if (this.type === 'textarea') {
            return b `
        <textarea
          class="input"
          style=${o$1(style)}
          aria-describedby="description"
          aria-invalid=${this.hasError}
          aria-label=${ariaLabel}
          autocomplete=${autocomplete || A}
          name=${this.name || A}
          ?disabled=${this.disabled}
          maxlength=${hasMaxLength ? this.maxLength : A}
          minlength=${hasMinLength ? this.minLength : A}
          placeholder=${this.placeholder || A}
          ?readonly=${this.readOnly}
          ?required=${this.required}
          rows=${this.rows}
          cols=${this.cols}
          .value=${l(this.value)}
          @change=${this.redispatchEvent}
          @focus=${this.handleFocusChange}
          @blur=${this.handleFocusChange}
          @input=${this.handleInput}
          @select=${this.redispatchEvent}></textarea>
      `;
        }
        const prefix = this.renderPrefix();
        const suffix = this.renderSuffix();
        // TODO(b/243805848): remove `as unknown as number` and `as any` once lit
        // analyzer is fixed
        // tslint:disable-next-line:no-any
        const inputMode = this.inputMode;
        return b `
      <div class="input-wrapper">
        ${prefix}
        <input
          class="input"
          style=${o$1(style)}
          aria-describedby="description"
          aria-invalid=${this.hasError}
          aria-label=${ariaLabel}
          autocomplete=${autocomplete || A}
          name=${this.name || A}
          ?disabled=${this.disabled}
          inputmode=${inputMode || A}
          max=${(this.max || A)}
          maxlength=${hasMaxLength ? this.maxLength : A}
          min=${(this.min || A)}
          minlength=${hasMinLength ? this.minLength : A}
          pattern=${this.pattern || A}
          placeholder=${this.placeholder || A}
          ?readonly=${this.readOnly}
          ?required=${this.required}
          ?multiple=${this.multiple}
          step=${(this.step || A)}
          type=${this.type}
          .value=${l(this.value)}
          @change=${this.redispatchEvent}
          @focus=${this.handleFocusChange}
          @blur=${this.handleFocusChange}
          @input=${this.handleInput}
          @select=${this.redispatchEvent} />
        ${suffix}
      </div>
    `;
    }
    renderPrefix() {
        return this.renderAffix(this.prefixText, /* isSuffix */ false);
    }
    renderSuffix() {
        return this.renderAffix(this.suffixText, /* isSuffix */ true);
    }
    renderAffix(text, isSuffix) {
        if (!text) {
            return A;
        }
        const classes = {
            'suffix': isSuffix,
            'prefix': !isSuffix,
        };
        return b `<span class="${e(classes)}">${text}</span>`;
    }
    getErrorText() {
        return this.error ? this.errorText : this.nativeErrorText;
    }
    handleFocusChange() {
        // When calling focus() or reportValidity() during change, it's possible
        // for blur to be called after the new focus event. Rather than set
        // `this.focused` to true/false on focus/blur, we always set it to whether
        // or not the input itself is focused.
        this.focused = this.inputOrTextarea?.matches(':focus') ?? false;
    }
    handleInput(event) {
        this.dirty = true;
        this.value = event.target.value;
    }
    redispatchEvent(event) {
        redispatchEvent(this, event);
    }
    getInputOrTextarea() {
        if (!this.inputOrTextarea) {
            // If the input is not yet defined, synchronously render.
            // e.g.
            // const textField = document.createElement('md-outlined-text-field');
            // document.body.appendChild(textField);
            // textField.focus(); // synchronously render
            this.connectedCallback();
            this.scheduleUpdate();
        }
        if (this.isUpdatePending) {
            // If there are pending updates, synchronously perform them. This ensures
            // that constraint validation properties (like `required`) are synced
            // before interacting with input APIs that depend on them.
            this.scheduleUpdate();
        }
        return this.inputOrTextarea;
    }
    getInput() {
        if (this.type === 'textarea') {
            return null;
        }
        return this.getInputOrTextarea();
    }
    handleIconChange() {
        this.hasLeadingIcon = this.leadingIcons.length > 0;
        this.hasTrailingIcon = this.trailingIcons.length > 0;
    }
    [getFormValue]() {
        return this.value;
    }
    formResetCallback() {
        this.reset();
    }
    formStateRestoreCallback(state) {
        this.value = state;
    }
    focus() {
        // Required for the case that the user slots a focusable element into the
        // leading icon slot such as an iconbutton due to how delegatesFocus works.
        this.getInputOrTextarea().focus();
    }
    [createValidator]() {
        return new TextFieldValidator(() => ({
            state: this,
            renderedControl: this.inputOrTextarea,
        }));
    }
    [getValidityAnchor]() {
        return this.inputOrTextarea;
    }
    [onReportValidity](invalidEvent) {
        // Prevent default pop-up behavior.
        invalidEvent?.preventDefault();
        const prevMessage = this.getErrorText();
        this.nativeError = !!invalidEvent;
        this.nativeErrorText = this.validationMessage;
        if (prevMessage === this.getErrorText()) {
            this.field?.reannounceError();
        }
    }
}
/** @nocollapse */
TextField.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, reflect: true })
], TextField.prototype, "error", void 0);
__decorate([
    n$3({ attribute: 'error-text' })
], TextField.prototype, "errorText", void 0);
__decorate([
    n$3()
], TextField.prototype, "label", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-asterisk' })
], TextField.prototype, "noAsterisk", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], TextField.prototype, "required", void 0);
__decorate([
    n$3()
], TextField.prototype, "value", void 0);
__decorate([
    n$3({ attribute: 'prefix-text' })
], TextField.prototype, "prefixText", void 0);
__decorate([
    n$3({ attribute: 'suffix-text' })
], TextField.prototype, "suffixText", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-leading-icon' })
], TextField.prototype, "hasLeadingIcon", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-trailing-icon' })
], TextField.prototype, "hasTrailingIcon", void 0);
__decorate([
    n$3({ attribute: 'supporting-text' })
], TextField.prototype, "supportingText", void 0);
__decorate([
    n$3({ attribute: 'text-direction' })
], TextField.prototype, "textDirection", void 0);
__decorate([
    n$3({ type: Number })
], TextField.prototype, "rows", void 0);
__decorate([
    n$3({ type: Number })
], TextField.prototype, "cols", void 0);
__decorate([
    n$3({ reflect: true })
], TextField.prototype, "inputMode", void 0);
__decorate([
    n$3()
], TextField.prototype, "max", void 0);
__decorate([
    n$3({ type: Number })
], TextField.prototype, "maxLength", void 0);
__decorate([
    n$3()
], TextField.prototype, "min", void 0);
__decorate([
    n$3({ type: Number })
], TextField.prototype, "minLength", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-spinner' })
], TextField.prototype, "noSpinner", void 0);
__decorate([
    n$3()
], TextField.prototype, "pattern", void 0);
__decorate([
    n$3({ reflect: true, converter: stringConverter })
], TextField.prototype, "placeholder", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], TextField.prototype, "readOnly", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], TextField.prototype, "multiple", void 0);
__decorate([
    n$3()
], TextField.prototype, "step", void 0);
__decorate([
    n$3({ reflect: true })
], TextField.prototype, "type", void 0);
__decorate([
    n$3({ reflect: true })
], TextField.prototype, "autocomplete", void 0);
__decorate([
    r$2()
], TextField.prototype, "dirty", void 0);
__decorate([
    r$2()
], TextField.prototype, "focused", void 0);
__decorate([
    r$2()
], TextField.prototype, "nativeError", void 0);
__decorate([
    r$2()
], TextField.prototype, "nativeErrorText", void 0);
__decorate([
    e$4('.input')
], TextField.prototype, "inputOrTextarea", void 0);
__decorate([
    e$4('.field')
], TextField.prototype, "field", void 0);
__decorate([
    o$2({ slot: 'leading-icon' })
], TextField.prototype, "leadingIcons", void 0);
__decorate([
    o$2({ slot: 'trailing-icon' })
], TextField.prototype, "trailingIcons", void 0);

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * An outlined text field component
 */
class OutlinedTextField extends TextField {
    constructor() {
        super(...arguments);
        this.fieldTag = i `md-outlined-field`;
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./textfield/internal/outlined-styles.css.
const styles$9 = i$7 `:host{--_caret-color: var(--md-outlined-text-field-caret-color, var(--md-sys-color-primary, #6750a4));--_disabled-input-text-color: var(--md-outlined-text-field-disabled-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-input-text-opacity: var(--md-outlined-text-field-disabled-input-text-opacity, 0.38);--_disabled-label-text-color: var(--md-outlined-text-field-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-outlined-text-field-disabled-label-text-opacity, 0.38);--_disabled-leading-icon-color: var(--md-outlined-text-field-disabled-leading-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-leading-icon-opacity: var(--md-outlined-text-field-disabled-leading-icon-opacity, 0.38);--_disabled-outline-color: var(--md-outlined-text-field-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-opacity: var(--md-outlined-text-field-disabled-outline-opacity, 0.12);--_disabled-outline-width: var(--md-outlined-text-field-disabled-outline-width, 1px);--_disabled-supporting-text-color: var(--md-outlined-text-field-disabled-supporting-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-supporting-text-opacity: var(--md-outlined-text-field-disabled-supporting-text-opacity, 0.38);--_disabled-trailing-icon-color: var(--md-outlined-text-field-disabled-trailing-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-trailing-icon-opacity: var(--md-outlined-text-field-disabled-trailing-icon-opacity, 0.38);--_error-focus-caret-color: var(--md-outlined-text-field-error-focus-caret-color, var(--md-sys-color-error, #b3261e));--_error-focus-input-text-color: var(--md-outlined-text-field-error-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_error-focus-label-text-color: var(--md-outlined-text-field-error-focus-label-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-leading-icon-color: var(--md-outlined-text-field-error-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-focus-outline-color: var(--md-outlined-text-field-error-focus-outline-color, var(--md-sys-color-error, #b3261e));--_error-focus-supporting-text-color: var(--md-outlined-text-field-error-focus-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-trailing-icon-color: var(--md-outlined-text-field-error-focus-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_error-hover-input-text-color: var(--md-outlined-text-field-error-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_error-hover-label-text-color: var(--md-outlined-text-field-error-hover-label-text-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-leading-icon-color: var(--md-outlined-text-field-error-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-hover-outline-color: var(--md-outlined-text-field-error-hover-outline-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-supporting-text-color: var(--md-outlined-text-field-error-hover-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-hover-trailing-icon-color: var(--md-outlined-text-field-error-hover-trailing-icon-color, var(--md-sys-color-on-error-container, #410e0b));--_error-input-text-color: var(--md-outlined-text-field-error-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_error-label-text-color: var(--md-outlined-text-field-error-label-text-color, var(--md-sys-color-error, #b3261e));--_error-leading-icon-color: var(--md-outlined-text-field-error-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-outline-color: var(--md-outlined-text-field-error-outline-color, var(--md-sys-color-error, #b3261e));--_error-supporting-text-color: var(--md-outlined-text-field-error-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-trailing-icon-color: var(--md-outlined-text-field-error-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_focus-input-text-color: var(--md-outlined-text-field-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_focus-label-text-color: var(--md-outlined-text-field-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_focus-leading-icon-color: var(--md-outlined-text-field-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-outline-color: var(--md-outlined-text-field-focus-outline-color, var(--md-sys-color-primary, #6750a4));--_focus-outline-width: var(--md-outlined-text-field-focus-outline-width, 3px);--_focus-supporting-text-color: var(--md-outlined-text-field-focus-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-trailing-icon-color: var(--md-outlined-text-field-focus-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-input-text-color: var(--md-outlined-text-field-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-label-text-color: var(--md-outlined-text-field-hover-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-leading-icon-color: var(--md-outlined-text-field-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-outline-color: var(--md-outlined-text-field-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-outline-width: var(--md-outlined-text-field-hover-outline-width, 1px);--_hover-supporting-text-color: var(--md-outlined-text-field-hover-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-trailing-icon-color: var(--md-outlined-text-field-hover-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-color: var(--md-outlined-text-field-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_input-text-font: var(--md-outlined-text-field-input-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_input-text-line-height: var(--md-outlined-text-field-input-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_input-text-placeholder-color: var(--md-outlined-text-field-input-text-placeholder-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-prefix-color: var(--md-outlined-text-field-input-text-prefix-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-size: var(--md-outlined-text-field-input-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_input-text-suffix-color: var(--md-outlined-text-field-input-text-suffix-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-weight: var(--md-outlined-text-field-input-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_label-text-color: var(--md-outlined-text-field-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_label-text-font: var(--md-outlined-text-field-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-outlined-text-field-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_label-text-populated-line-height: var(--md-outlined-text-field-label-text-populated-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_label-text-populated-size: var(--md-outlined-text-field-label-text-populated-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_label-text-size: var(--md-outlined-text-field-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_label-text-weight: var(--md-outlined-text-field-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_leading-icon-color: var(--md-outlined-text-field-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_leading-icon-size: var(--md-outlined-text-field-leading-icon-size, 24px);--_outline-color: var(--md-outlined-text-field-outline-color, var(--md-sys-color-outline, #79747e));--_outline-width: var(--md-outlined-text-field-outline-width, 1px);--_supporting-text-color: var(--md-outlined-text-field-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_supporting-text-font: var(--md-outlined-text-field-supporting-text-font, var(--md-sys-typescale-body-small-font, var(--md-ref-typeface-plain, Roboto)));--_supporting-text-line-height: var(--md-outlined-text-field-supporting-text-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_supporting-text-size: var(--md-outlined-text-field-supporting-text-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_supporting-text-weight: var(--md-outlined-text-field-supporting-text-weight, var(--md-sys-typescale-body-small-weight, var(--md-ref-typeface-weight-regular, 400)));--_trailing-icon-color: var(--md-outlined-text-field-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_trailing-icon-size: var(--md-outlined-text-field-trailing-icon-size, 24px);--_container-shape-start-start: var(--md-outlined-text-field-container-shape-start-start, var(--md-outlined-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_container-shape-start-end: var(--md-outlined-text-field-container-shape-start-end, var(--md-outlined-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_container-shape-end-end: var(--md-outlined-text-field-container-shape-end-end, var(--md-outlined-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_container-shape-end-start: var(--md-outlined-text-field-container-shape-end-start, var(--md-outlined-text-field-container-shape, var(--md-sys-shape-corner-extra-small, 4px)));--_icon-input-space: var(--md-outlined-text-field-icon-input-space, 16px);--_leading-space: var(--md-outlined-text-field-leading-space, 16px);--_trailing-space: var(--md-outlined-text-field-trailing-space, 16px);--_top-space: var(--md-outlined-text-field-top-space, 16px);--_bottom-space: var(--md-outlined-text-field-bottom-space, 16px);--_input-text-prefix-trailing-space: var(--md-outlined-text-field-input-text-prefix-trailing-space, 2px);--_input-text-suffix-leading-space: var(--md-outlined-text-field-input-text-suffix-leading-space, 2px);--_focus-caret-color: var(--md-outlined-text-field-focus-caret-color, var(--md-sys-color-primary, #6750a4));--_with-leading-icon-leading-space: var(--md-outlined-text-field-with-leading-icon-leading-space, 12px);--_with-trailing-icon-trailing-space: var(--md-outlined-text-field-with-trailing-icon-trailing-space, 12px);--md-outlined-field-bottom-space: var(--_bottom-space);--md-outlined-field-container-shape-end-end: var(--_container-shape-end-end);--md-outlined-field-container-shape-end-start: var(--_container-shape-end-start);--md-outlined-field-container-shape-start-end: var(--_container-shape-start-end);--md-outlined-field-container-shape-start-start: var(--_container-shape-start-start);--md-outlined-field-content-color: var(--_input-text-color);--md-outlined-field-content-font: var(--_input-text-font);--md-outlined-field-content-line-height: var(--_input-text-line-height);--md-outlined-field-content-size: var(--_input-text-size);--md-outlined-field-content-space: var(--_icon-input-space);--md-outlined-field-content-weight: var(--_input-text-weight);--md-outlined-field-disabled-content-color: var(--_disabled-input-text-color);--md-outlined-field-disabled-content-opacity: var(--_disabled-input-text-opacity);--md-outlined-field-disabled-label-text-color: var(--_disabled-label-text-color);--md-outlined-field-disabled-label-text-opacity: var(--_disabled-label-text-opacity);--md-outlined-field-disabled-leading-content-color: var(--_disabled-leading-icon-color);--md-outlined-field-disabled-leading-content-opacity: var(--_disabled-leading-icon-opacity);--md-outlined-field-disabled-outline-color: var(--_disabled-outline-color);--md-outlined-field-disabled-outline-opacity: var(--_disabled-outline-opacity);--md-outlined-field-disabled-outline-width: var(--_disabled-outline-width);--md-outlined-field-disabled-supporting-text-color: var(--_disabled-supporting-text-color);--md-outlined-field-disabled-supporting-text-opacity: var(--_disabled-supporting-text-opacity);--md-outlined-field-disabled-trailing-content-color: var(--_disabled-trailing-icon-color);--md-outlined-field-disabled-trailing-content-opacity: var(--_disabled-trailing-icon-opacity);--md-outlined-field-error-content-color: var(--_error-input-text-color);--md-outlined-field-error-focus-content-color: var(--_error-focus-input-text-color);--md-outlined-field-error-focus-label-text-color: var(--_error-focus-label-text-color);--md-outlined-field-error-focus-leading-content-color: var(--_error-focus-leading-icon-color);--md-outlined-field-error-focus-outline-color: var(--_error-focus-outline-color);--md-outlined-field-error-focus-supporting-text-color: var(--_error-focus-supporting-text-color);--md-outlined-field-error-focus-trailing-content-color: var(--_error-focus-trailing-icon-color);--md-outlined-field-error-hover-content-color: var(--_error-hover-input-text-color);--md-outlined-field-error-hover-label-text-color: var(--_error-hover-label-text-color);--md-outlined-field-error-hover-leading-content-color: var(--_error-hover-leading-icon-color);--md-outlined-field-error-hover-outline-color: var(--_error-hover-outline-color);--md-outlined-field-error-hover-supporting-text-color: var(--_error-hover-supporting-text-color);--md-outlined-field-error-hover-trailing-content-color: var(--_error-hover-trailing-icon-color);--md-outlined-field-error-label-text-color: var(--_error-label-text-color);--md-outlined-field-error-leading-content-color: var(--_error-leading-icon-color);--md-outlined-field-error-outline-color: var(--_error-outline-color);--md-outlined-field-error-supporting-text-color: var(--_error-supporting-text-color);--md-outlined-field-error-trailing-content-color: var(--_error-trailing-icon-color);--md-outlined-field-focus-content-color: var(--_focus-input-text-color);--md-outlined-field-focus-label-text-color: var(--_focus-label-text-color);--md-outlined-field-focus-leading-content-color: var(--_focus-leading-icon-color);--md-outlined-field-focus-outline-color: var(--_focus-outline-color);--md-outlined-field-focus-outline-width: var(--_focus-outline-width);--md-outlined-field-focus-supporting-text-color: var(--_focus-supporting-text-color);--md-outlined-field-focus-trailing-content-color: var(--_focus-trailing-icon-color);--md-outlined-field-hover-content-color: var(--_hover-input-text-color);--md-outlined-field-hover-label-text-color: var(--_hover-label-text-color);--md-outlined-field-hover-leading-content-color: var(--_hover-leading-icon-color);--md-outlined-field-hover-outline-color: var(--_hover-outline-color);--md-outlined-field-hover-outline-width: var(--_hover-outline-width);--md-outlined-field-hover-supporting-text-color: var(--_hover-supporting-text-color);--md-outlined-field-hover-trailing-content-color: var(--_hover-trailing-icon-color);--md-outlined-field-label-text-color: var(--_label-text-color);--md-outlined-field-label-text-font: var(--_label-text-font);--md-outlined-field-label-text-line-height: var(--_label-text-line-height);--md-outlined-field-label-text-populated-line-height: var(--_label-text-populated-line-height);--md-outlined-field-label-text-populated-size: var(--_label-text-populated-size);--md-outlined-field-label-text-size: var(--_label-text-size);--md-outlined-field-label-text-weight: var(--_label-text-weight);--md-outlined-field-leading-content-color: var(--_leading-icon-color);--md-outlined-field-leading-space: var(--_leading-space);--md-outlined-field-outline-color: var(--_outline-color);--md-outlined-field-outline-width: var(--_outline-width);--md-outlined-field-supporting-text-color: var(--_supporting-text-color);--md-outlined-field-supporting-text-font: var(--_supporting-text-font);--md-outlined-field-supporting-text-line-height: var(--_supporting-text-line-height);--md-outlined-field-supporting-text-size: var(--_supporting-text-size);--md-outlined-field-supporting-text-weight: var(--_supporting-text-weight);--md-outlined-field-top-space: var(--_top-space);--md-outlined-field-trailing-content-color: var(--_trailing-icon-color);--md-outlined-field-trailing-space: var(--_trailing-space);--md-outlined-field-with-leading-content-leading-space: var(--_with-leading-icon-leading-space);--md-outlined-field-with-trailing-content-trailing-space: var(--_with-trailing-icon-trailing-space)}
`;

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./textfield/internal/shared-styles.css.
const styles$8 = i$7 `:host{display:inline-flex;outline:none;resize:both;text-align:start;-webkit-tap-highlight-color:rgba(0,0,0,0)}.text-field,.field{width:100%}.text-field{display:inline-flex}.field{cursor:text}.disabled .field{cursor:default}.text-field,.textarea .field{resize:inherit}slot[name=container]{border-radius:inherit}.icon{color:currentColor;display:flex;align-items:center;justify-content:center;fill:currentColor;position:relative}.icon ::slotted(*){display:flex;position:absolute}[has-start] .icon.leading{font-size:var(--_leading-icon-size);height:var(--_leading-icon-size);width:var(--_leading-icon-size)}[has-end] .icon.trailing{font-size:var(--_trailing-icon-size);height:var(--_trailing-icon-size);width:var(--_trailing-icon-size)}.input-wrapper{display:flex}.input-wrapper>*{all:inherit;padding:0}.input{caret-color:var(--_caret-color);overflow-x:hidden;text-align:inherit}.input::placeholder{color:currentColor;opacity:1}.input::-webkit-calendar-picker-indicator{display:none}.input::-webkit-search-decoration,.input::-webkit-search-cancel-button{display:none}@media(forced-colors: active){.input{background:none}}.no-spinner .input::-webkit-inner-spin-button,.no-spinner .input::-webkit-outer-spin-button{display:none}.no-spinner .input[type=number]{-moz-appearance:textfield}:focus-within .input{caret-color:var(--_focus-caret-color)}.error:focus-within .input{caret-color:var(--_error-focus-caret-color)}.text-field:not(.disabled) .prefix{color:var(--_input-text-prefix-color)}.text-field:not(.disabled) .suffix{color:var(--_input-text-suffix-color)}.text-field:not(.disabled) .input::placeholder{color:var(--_input-text-placeholder-color)}.prefix,.suffix{text-wrap:nowrap;width:min-content}.prefix{padding-inline-end:var(--_input-text-prefix-trailing-space)}.suffix{padding-inline-start:var(--_input-text-suffix-leading-space)}
`;

function renderDefaultLeadingIcon() {
    return b `<oscd-icon slot="leading-icon">search</oscd-icon>`;
}
class OutlinedSearchField extends OutlinedTextField {
    constructor() {
        super();
        this.clearLabel = 'Clear search';
        this.addEventListener('focus', this.handleFocus.bind(this));
        this.addEventListener('blur', this.handleBlur.bind(this));
    }
    handleFocus() {
        this.placeholder = '';
    }
    handleBlur() {
        this.placeholder = 'Search';
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        // The search icon is always present, either as consumer content or as the
        // default rendered by renderLeadingIcon().
        this.hasLeadingIcon = true;
        this.hasTrailingIcon =
            this.hasCustomSlot('trailing-icon') || Boolean(this.value);
    }
    clear() {
        this.value = '';
        this.dispatchEvent(new InputEvent('input', { bubbles: true, composed: true }));
        this.focus();
    }
    renderDefaultClearFieldIconButton() {
        if (!this.value) {
            return b ``;
        }
        return b `<oscd-icon-button
      class="default-clear-button"
      slot="trailing-icon"
      aria-label=${this.clearLabel}
      @click=${() => this.clear()}
      ><oscd-icon>close</oscd-icon></oscd-icon-button
    >`;
    }
    renderTrailingIcon() {
        return b `
      <span class="icon trailing" slot="end">
        <slot name="trailing-icon"></slot>
        ${this.hasCustomSlot('trailing-icon')
            ? A
            : this.renderDefaultClearFieldIconButton()}
      </span>
    `;
    }
    renderLeadingIcon() {
        return b `
      <span class="icon leading" slot="start">
        <slot name="leading-icon"></slot>
        ${this.hasCustomSlot('leading-icon')
            ? A
            : renderDefaultLeadingIcon()}
      </span>
    `;
    }
    hasCustomSlot(slotName) {
        return this.querySelector(`[slot="${slotName}"]`) !== null;
    }
}
OutlinedSearchField.styles = [
    styles$8,
    styles$9,
    i$7 `
      :host {
        --md-outlined-text-field-input-text-placeholder-color: var(
          --oscd-search-field-placeholder-color,
          color-mix(
            in srgb,
            var(
                --md-outlined-text-field-input-text-color,
                var(--md-sys-color-on-surface, #1d1b20)
              )
              50%,
            transparent
          )
        );
      }
    `,
];
__decorate([
    n$3({ type: String })
], OutlinedSearchField.prototype, "clearLabel", void 0);

/**
 * @tag oscd-outlined-search-field
 * @summary An `oscd-outlined-text-field` specialized for search input.
 *
 * Behaves like a standard outlined text field, but comes by default with a
 * leading search icon and a trailing "clear" button (shown once
 * [[`value`]] is non-empty), a placeholder rendered at 50% opacity (relative
 * to the input text color) that is hidden while the field has focus.
 *
 * The default leading/trailing icons can be overridden by slotting content
 * into the `leading-icon`/`trailing-icon` slots, exactly as with
 * `oscd-outlined-text-field`. The placeholder color can be overridden via
 * `--oscd-search-field-placeholder-color`.
 *
 * Like the outlined text field it wraps, the container has no background by
 * default. Container styling is available through the wrapped field's
 * supported `--md-outlined-text-field-*` tokens.
 * */
class OscdOutlinedSearchField extends ScopedElementsMixin(OutlinedSearchField) {
    constructor() {
        super(...arguments);
        this.fieldTag = i `oscd-outlined-field`;
    }
}
OscdOutlinedSearchField.scopedElements = {
    'oscd-outlined-field': OscdOutlinedField,
    'oscd-icon': OscdIcon,
    'oscd-icon-button': OscdIconButton,
};

/**
 * How well a name matches a query (lower is better): 0 exact, 1 starts with
 * it, 2 one of the name's parts (split at `_`, `-`, `.`, spaces or case
 * changes) starts with it, 3 contains it, 4 only the description contains
 * it; `undefined` when it does not match. Case is ignored.
 */
function matchRank({ name, desc = '' }, query) {
    const q = query.trim().toLowerCase();
    if (q === '') {
        return undefined;
    }
    const lower = name.toLowerCase();
    if (lower === q) {
        return 0;
    }
    if (lower.startsWith(q)) {
        return 1;
    }
    const parts = name
        .split(/[\s_.-]+|(?<=[a-z])(?=[A-Z])/)
        .map(part => part.toLowerCase());
    if (parts.some(part => part.startsWith(q))) {
        return 2;
    }
    if (lower.includes(q)) {
        return 3;
    }
    return desc.toLowerCase().includes(q) ? 4 : undefined;
}
/**
 * IEDs matching a query, best first: by match rank, then IEDs on the
 * substation shown, then by name.
 */
function searchIeds(ieds, query, shownSubstation, limit = 8) {
    return ieds
        .map(ied => ({ ied, rank: matchRank(ied, query) }))
        .filter((match) => match.rank !== undefined)
        .sort((a, b) => a.rank - b.rank ||
        Number(b.ied.substation === shownSubstation) -
            Number(a.ied.substation === shownSubstation) ||
        a.ied.name.localeCompare(b.ied.name, undefined, { numeric: true }))
        .slice(0, limit)
        .map(({ ied }) => ied);
}

/**
 * Search field finding IEDs placed on the diagrams: typing a few characters
 * lists the best matches in a menu below the field. Enter picks the best
 * match; the down arrow moves into the menu to pick another one.
 *
 * @fires map-ied-locate - detail: the picked `SearchableIed`
 */
class MapIedSearch extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        /** IEDs that can be found. */
        this.ieds = [];
        this.text = '';
        this.open = false;
    }
    /** Matches of the current text. */
    get results() {
        return searchIeds(this.ieds, this.text, this.substation);
    }
    /** Focuses the field and selects its text, also before it first rendered. */
    focus() {
        const { field } = this;
        field.focus();
        field.updateComplete.then(() => {
            field.focus();
            field.select();
        });
    }
    pick(ied) {
        this.open = false;
        this.text = '';
        this.dispatchEvent(new CustomEvent('map-ied-locate', {
            detail: ied,
            bubbles: true,
            composed: true,
        }));
    }
    handleInput(event) {
        this.text = event.target.value;
        this.open = this.text.trim() !== '';
    }
    handleKeydown(event) {
        const [best] = this.results;
        if (event.key === 'Enter') {
            event.preventDefault();
            if (best && this.text.trim() !== '') {
                this.pick(best);
            }
        }
        else if (event.key === 'ArrowDown' && best) {
            // Into the menu, which handles its own arrow keys from there.
            event.preventDefault();
            this.open = true;
            this.updateComplete.then(() => this.renderRoot.querySelector('oscd-menu-item')?.focus());
        }
        else if (event.key === 'Escape') {
            // Escape first closes the menu, then clears the text.
            event.stopPropagation();
            if (this.open) {
                this.open = false;
            }
            else {
                this.text = '';
            }
        }
    }
    /** A result was picked, by click or keyboard. */
    handleCloseMenu(event) {
        const name = event.detail.initiator?.dataset.name;
        const ied = this.results.find(result => result.name === name);
        if (ied) {
            this.pick(ied);
        }
    }
    renderResult(ied) {
        const other = ied.substation !== this.substation;
        // Descriptions repeating the name add nothing.
        const desc = ied.desc !== ied.name ? ied.desc : undefined;
        const detail = [desc, other ? ied.substation : '']
            .filter(Boolean)
            .join(' · ');
        return b `<oscd-menu-item class="result" data-name=${ied.name}>
      <div slot="headline">${ied.name}</div>
      ${detail ? b `<div slot="supporting-text">${detail}</div>` : A}
    </oscd-menu-item>`;
    }
    render() {
        const { results } = this;
        return b `<oscd-outlined-search-field
        id="field"
        placeholder=${msg(str `Find IED (${shortcut('F')})`)}
        aria-label=${msg('Find IED')}
        aria-keyshortcuts="Control+F /"
        title=${msg(str `Find IED (${shortcut('F')} or /)`)}
        .value=${this.text}
        @input=${this.handleInput}
        @keydown=${this.handleKeydown}
      ></oscd-outlined-search-field>
      <oscd-menu
        anchor="field"
        positioning="popover"
        default-focus="none"
        skip-restore-focus
        .open=${this.open}
        @close-menu=${this.handleCloseMenu}
        @closed=${() => {
            this.open = false;
        }}
      >
        ${results.length > 0
            ? results.map(ied => this.renderResult(ied))
            : b `<oscd-menu-item class="none" disabled
              ><div slot="headline">${msg('No IED found')}</div></oscd-menu-item
            >`}
      </oscd-menu>`;
    }
}
MapIedSearch.scopedElements = {
    'oscd-outlined-search-field': OscdOutlinedSearchField,
    'oscd-menu': OscdMenu,
    'oscd-menu-item': OscdMenuItem,
};
MapIedSearch.styles = i$7 `
    :host {
      display: inline-block;
    }

    oscd-outlined-search-field {
      width: 220px;
      --md-outlined-field-top-space: 6px;
      --md-outlined-field-bottom-space: 6px;
      --md-outlined-text-field-container-shape: 20px;
    }

    oscd-menu {
      min-width: 220px;
    }
  `;
__decorate([
    n$3({ attribute: false })
], MapIedSearch.prototype, "ieds", void 0);
__decorate([
    n$3({ type: String })
], MapIedSearch.prototype, "substation", void 0);
__decorate([
    r$2()
], MapIedSearch.prototype, "text", void 0);
__decorate([
    r$2()
], MapIedSearch.prototype, "open", void 0);
__decorate([
    e$4('oscd-outlined-search-field')
], MapIedSearch.prototype, "field", void 0);

/**
 * Indexes every `GSE` and `SMV` address in the Communication section in one
 * pass, keyed by IED name, access point, logical device and control block
 * name. This replaces a document-wide query per control block.
 */
function commAddressIndex(doc) {
    const index = new Map();
    doc
        .querySelectorAll(':root > Communication > SubNetwork > ConnectedAP > GSE, :root > Communication > SubNetwork > ConnectedAP > SMV')
        .forEach((address) => {
        const connectedAp = address.parentElement;
        const key = addressKey(address.tagName, connectedAp.getAttribute('iedName'), connectedAp.getAttribute('apName'), address.getAttribute('ldInst'), address.getAttribute('cbName'));
        if (!index.has(key)) {
            index.set(key, address);
        }
    });
    return index;
}
function addressKey(tag, iedName, apName, ldInst, cbName) {
    return [tag, iedName, apName, ldInst, cbName].join('|');
}
/**
 * Finds the `GSE`/`SMV` address of a GOOSE or SV control block, also looking
 * at access points that serve this one through `ServerAt`. Mirrors
 * `controlBlockGseOrSmv` from `@openscd/scl-lib` but uses a prebuilt index.
 */
function findCommAddress(controlBlock, index) {
    const tag = controlBlock.tagName === 'GSEControl'
        ? 'GSE'
        : controlBlock.tagName === 'SampledValueControl'
            ? 'SMV'
            : null;
    const ied = controlBlock.closest('IED');
    const apName = controlBlock.closest('AccessPoint')?.getAttribute('name');
    const ldInst = controlBlock.closest('LDevice')?.getAttribute('inst');
    if (tag === null || !ied || !apName || !ldInst) {
        return null;
    }
    const serverAtApNames = Array.from(ied.querySelectorAll(`:scope > AccessPoint > ServerAt[apName="${apName}"]`)).map(serverAt => serverAt.parentElement.getAttribute('name'));
    const iedName = ied.getAttribute('name');
    const cbName = controlBlock.getAttribute('name');
    for (const ap of [apName, ...serverAtApNames]) {
        const address = index.get(addressKey(tag, iedName, ap, ldInst, cbName));
        if (address) {
            return address;
        }
    }
    return null;
}
/** Reads the communication parameters of a `GSE` or `SMV` address element. */
function readCommParams(address) {
    if (!address) {
        return {};
    }
    const param = (type) => address
        .querySelector(`:scope > Address > P[type="${type}"]`)
        ?.textContent?.trim() || undefined;
    const time = (tag) => address.querySelector(`:scope > ${tag}`)?.textContent?.trim() || undefined;
    const params = {
        vlanId: param('VLAN-ID'),
        vlanPriority: param('VLAN-PRIORITY'),
        appId: param('APPID'),
        macAddress: param('MAC-Address'),
        minTime: time('MinTime'),
        maxTime: time('MaxTime'),
    };
    return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined));
}
/** Splits comma separated user input into trimmed, non-empty tokens. */
function parseCsvTokens(text) {
    return text
        .split(',')
        .map(token => token.trim())
        .filter(token => token !== '');
}
/**
 * Parses a VLAN identifier as stored in SCL. SCL stores the VLAN-ID as
 * hexadecimal without a `0x` prefix; an explicit `0x` prefix is also accepted.
 */
function parseVlanRaw(text) {
    const value = text?.trim() ?? '';
    const match = /^(?:0x)?([0-9a-f]+)$/i.exec(value);
    return match ? Number.parseInt(match[1], 16) : null;
}
/**
 * Parses a VLAN identifier typed by a user: decimal unless prefixed with `0x`
 * or containing a hexadecimal letter.
 */
function parseVlanToken(text) {
    const value = text?.trim() ?? '';
    return (parsePriority(value) ??
        (/^[0-9a-f]+$/i.test(value) ? Number.parseInt(value, 16) : null));
}
/** Parses a VLAN priority (decimal, or hexadecimal with `0x`). */
function parsePriority(text) {
    const value = text?.trim() ?? '';
    if (/^0x[0-9a-f]+$/i.test(value)) {
        return Number.parseInt(value.slice(2), 16);
    }
    if (/^[0-9]+$/.test(value)) {
        return Number.parseInt(value, 10);
    }
    return null;
}
/** Formats a VLAN identifier as three hexadecimal digits, `0x065`. */
function formatVlanId(value) {
    return `0x${value.toString(16).toUpperCase().padStart(3, '0')}`;
}
/** Formats a raw SCL VLAN identifier as `0x065 (101)`. */
function formatVlan(raw) {
    const value = parseVlanRaw(raw);
    return value === null ? raw : `${formatVlanId(value)} (${value})`;
}

function emptyFilter() {
    return {
        services: [...services],
        incoming: true,
        outgoing: true,
        sourceIed: '',
        targetIed: '',
        controlBlock: '',
        vlans: [],
        priorities: [],
        types: [],
    };
}
/** Shows a hidden service or hides a shown one, keeping the services' order. */
function toggleService(shown, service) {
    return shown.includes(service)
        ? shown.filter(s => s !== service)
        : services.filter(s => s === service || shown.includes(s));
}
/** True when any of the filter panel's criteria are set. */
function isFilterActive(filter) {
    return (filter.sourceIed.trim() !== '' ||
        filter.targetIed.trim() !== '' ||
        filter.controlBlock.trim() !== '' ||
        filter.vlans.length > 0 ||
        filter.priorities.length > 0 ||
        filter.types.length > 0);
}
/**
 * How many of the filter panel's criteria are set: each name field, and the
 * VLAN, priority and manufacturer/type selections, count once.
 */
function activeCriteria(filter) {
    return [
        filter.sourceIed.trim() !== '',
        filter.targetIed.trim() !== '',
        filter.controlBlock.trim() !== '',
        filter.vlans.length > 0,
        filter.priorities.length > 0,
        filter.types.length > 0,
    ].filter(Boolean).length;
}
/** Clears the filter panel's criteria, keeping services and IED selection. */
function clearCriteria(filter) {
    const empty = emptyFilter();
    return {
        ...filter,
        sourceIed: empty.sourceIed,
        targetIed: empty.targetIed,
        controlBlock: empty.controlBlock,
        vlans: empty.vlans,
        priorities: empty.priorities,
        types: empty.types,
    };
}
/** Key identifying an IED's manufacturer and type. */
function typeKey(ied) {
    return `${ied.getAttribute('manufacturer') ?? ''}|${ied.getAttribute('type') ?? ''}`;
}
function matchesTerms(value, terms) {
    const tokens = terms.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (tokens.length === 0) {
        return true;
    }
    const lower = value.toLowerCase();
    return tokens.some(token => lower.includes(token));
}
/**
 * VLAN and priority criteria only apply to GOOSE and SV, as reports carry no
 * VLAN: reports are not hidden by them.
 */
function matchesNumber(connection, selected, value) {
    if (selected.length === 0 || connection.service === 'Report') {
        return true;
    }
    return value !== null && selected.includes(value);
}
function matchesFilter(connection, filter) {
    const { source, target } = connection;
    if (!filter.services.includes(connection.service)) {
        return false;
    }
    if (filter.ied !== undefined) {
        const incoming = filter.incoming && target.name === filter.ied;
        const outgoing = filter.outgoing && source.name === filter.ied;
        if (!incoming && !outgoing) {
            return false;
        }
    }
    if (filter.types.length > 0) {
        const types = [typeKey(source.ied), typeKey(target.ied)];
        if (!types.some(key => filter.types.includes(key))) {
            return false;
        }
    }
    return (matchesTerms(source.name, filter.sourceIed) &&
        matchesTerms(target.name, filter.targetIed) &&
        matchesTerms(connection.controlBlock.getAttribute('name') ?? '', filter.controlBlock) &&
        matchesNumber(connection, filter.vlans, parseVlanRaw(connection.comm.vlanId)) &&
        matchesNumber(connection, filter.priorities, parsePriority(connection.comm.vlanPriority)));
}
function filterConnections(connections, filter) {
    return connections.filter(connection => matchesFilter(connection, filter));
}
function emptyOptions() {
    return {
        vlans: [],
        priorities: [],
        manufacturers: new Map(),
        counts: { vlans: new Map(), priorities: new Map(), types: new Map() },
    };
}
/**
 * The part of a filter that decides which values the filter panel offers:
 * shown services and the selected IED with its directions. With an IED
 * selected, only what its own connections use is offered.
 */
function scopeFilter(filter) {
    const { services: shown, ied, incoming, outgoing } = filter;
    return { ...emptyFilter(), services: shown, ied, incoming, outgoing };
}
function increment(counts, key) {
    counts.set(key, (counts.get(key) ?? 0) + 1);
}
/**
 * Values found in the given connections, with how many connections use
 * each. Values already selected in `selected` are always offered so they can
 * be cleared.
 */
function filterOptions(connections, selected) {
    const options = emptyOptions();
    const { counts } = options;
    const types = new Map();
    const addType = (key) => {
        const [manufacturer, type] = key.split('|');
        if (!types.has(manufacturer)) {
            types.set(manufacturer, new Set());
        }
        types.get(manufacturer).add(type);
    };
    connections.forEach(({ comm, source, target }) => {
        const vlan = parseVlanRaw(comm.vlanId);
        if (vlan !== null) {
            increment(counts.vlans, vlan);
        }
        const priority = parsePriority(comm.vlanPriority);
        if (priority !== null) {
            increment(counts.priorities, priority);
        }
        new Set([typeKey(source.ied), typeKey(target.ied)]).forEach((key) => {
            increment(counts.types, key);
            addType(key);
        });
    });
    const vlans = new Set(counts.vlans.keys());
    const priorities = new Set(counts.priorities.keys());
    selected?.vlans.forEach(vlan => vlans.add(vlan));
    selected?.priorities.forEach(priority => priorities.add(priority));
    selected?.types.forEach(addType);
    const byNumber = (a, b) => a - b;
    options.vlans = Array.from(vlans).sort(byNumber);
    options.priorities = Array.from(priorities).sort(byNumber);
    options.manufacturers = new Map(Array.from(types.keys())
        .sort()
        .map(manufacturer => [
        manufacturer,
        Array.from(types.get(manufacturer)).sort(),
    ]));
    return options;
}
/**
 * Parses comma separated user input into the available values it names,
 * sorted and without duplicates. Unknown or invalid tokens are dropped.
 */
function parseSelection(text, available, parse) {
    const selected = new Set();
    parseCsvTokens(text).forEach((token) => {
        const value = parse(token);
        if (value !== null && available.includes(value)) {
            selected.add(value);
        }
    });
    return Array.from(selected).sort((a, b) => a - b);
}
function parseVlanSelection(text, available) {
    return parseSelection(text, available, parseVlanToken);
}
function parsePrioritySelection(text, available) {
    return parseSelection(text, available, parsePriority);
}
/** Adds or removes a value, keeping the selection sorted. */
function toggleValue(selection, value) {
    return selection.includes(value)
        ? selection.filter(v => v !== value)
        : [...selection, value].sort((a, b) => a - b);
}

const formatIcons = {
    svg: 'polyline',
    png: 'image',
    pdf: 'picture_as_pdf',
};
const minGridSize = 4;
const maxGridSize = 128;
/** Factor one zoom button press scales the diagram by. */
const zoomFactor = 1.25;
/** Scales a grid size, keeping it within limits and to one decimal. */
function zoomGridSize(gridSize, factor) {
    return Math.min(maxGridSize, Math.max(minGridSize, Math.round(gridSize * factor * 10) / 10));
}
const serviceIcons = {
    GOOSE: 'gooseIcon',
    SV: 'smvIcon',
    Report: 'reportIcon',
};
/** Keys toggling each service together with Ctrl (Command). */
const serviceKeys = {
    GOOSE: 'G',
    SV: 'S',
    Report: 'R',
};
const serviceLabels = {
    GOOSE: () => msg('GOOSE'),
    SV: () => msg('Sampled Values'),
    Report: () => msg('Reports'),
};
/**
 * Toolbar above the map: service toggles, the selected IED with direction
 * toggles, zoom, label visibility and the filter panel toggle.
 *
 * Stateless: it renders the given filter and view, and requests changes with
 * `map-filter-change` and `map-view-change` events carrying partial updates.
 *
 * @fires map-filter-change - detail: changed `ConnectionFilter` fields
 * @fires map-view-change - detail: changed `MapView` fields
 * @fires map-zoom-fit - the whole diagram should be fitted into view
 * @fires map-export - detail: `{ scope, format }` of an export to save
 * @fires map-fullscreen - full screen should be entered or left
 * @fires map-ied-locate - detail: an IED picked in the search field
 */
class MapToolbar extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        /** How many of the filter panel's criteria narrow the shown connections. */
        this.filterCount = 0;
        /** IEDs placed on the document's diagrams, offered by the search. */
        this.ieds = [];
        /** Whether the map is shown full screen. */
        this.fullscreen = false;
        /** Names of the document's substations, offered when there are several. */
        this.substations = [];
        this.exportOpen = false;
    }
    /** Moves the focus to the IED search field. */
    focusSearch() {
        this.renderRoot.querySelector('map-ied-search')?.focus();
    }
    changeFilter(detail) {
        this.dispatchEvent(new CustomEvent('map-filter-change', {
            detail,
            bubbles: true,
            composed: true,
        }));
    }
    requestExport(scope, format) {
        this.exportOpen = false;
        this.dispatchEvent(new CustomEvent('map-export', {
            detail: { scope, format },
            bubbles: true,
            composed: true,
        }));
    }
    renderExportItem(scope, format, headline, supporting) {
        return b `<oscd-menu-item
      class="export-item"
      data-export="${scope}-${format}"
      @click=${() => this.requestExport(scope, format)}
    >
      <oscd-icon slot="start">${formatIcons[format]}</oscd-icon>
      <div slot="headline">${headline}</div>
      <div slot="supporting-text">${supporting}</div>
    </oscd-menu-item>`;
    }
    renderExport() {
        return b `<span class="export-anchor">
      <oscd-icon-button
        id="export-button"
        class="export"
        aria-label=${msg('Export image')}
        title=${msg('Export image')}
        aria-haspopup="menu"
        aria-expanded=${this.exportOpen ? 'true' : 'false'}
        @click=${() => {
            this.exportOpen = !this.exportOpen;
        }}
        ><oscd-icon>download</oscd-icon></oscd-icon-button
      >
      <oscd-menu
        anchor="export-button"
        positioning="popover"
        anchor-corner="end-end"
        menu-corner="start-end"
        .open=${this.exportOpen}
        @closed=${() => {
            this.exportOpen = false;
        }}
      >
        <div class="menu-heading">${msg('Whole diagram')}</div>
        ${this.renderExportItem('diagram', 'svg', msg('SVG'), msg('Vector drawing, scales without loss'))}
        ${this.renderExportItem('diagram', 'png', msg('PNG'), msg('Picture for documents and email'))}
        ${this.renderExportItem('diagram', 'pdf', msg('PDF'), msg('Vector document for printing and sharing'))}
        <oscd-divider></oscd-divider>
        <div class="menu-heading">${msg('Visible area')}</div>
        ${this.renderExportItem('view', 'svg', msg('SVG'), msg('What you see, as a vector drawing'))}
        ${this.renderExportItem('view', 'png', msg('PNG'), msg('What you see, as a picture'))}
        ${this.renderExportItem('view', 'pdf', msg('PDF'), msg('What you see, as a document'))}
      </oscd-menu>
    </span>`;
    }
    changeView(detail) {
        this.dispatchEvent(new CustomEvent('map-view-change', { detail, bubbles: true, composed: true }));
    }
    handleServiceClick(service) {
        this.changeFilter({
            services: toggleService(this.filter.services, service),
        });
    }
    handleZoom(factor) {
        const gridSize = zoomGridSize(this.view.gridSize, factor);
        if (gridSize !== this.view.gridSize) {
            this.changeView({ gridSize });
        }
    }
    filterLabel() {
        const action = this.view.filterOpen
            ? msg('Close the filter panel')
            : msg('Filter connections');
        if (this.filterCount === 0) {
            return action;
        }
        return this.filterCount === 1
            ? msg(str `${action} (1 filter active)`)
            : msg(str `${action} (${this.filterCount} filters active)`);
    }
    renderSubstations() {
        if (this.substations.length < 2) {
            return A;
        }
        const shown = this.substations.includes(this.view.substation ?? '')
            ? this.view.substation
            : this.substations[0];
        return b `<oscd-outlined-select
      class="substation"
      aria-label=${msg('Substation')}
      aria-keyshortcuts="Control+[ Control+]"
      title=${msg(str `Substation (${shortcut('[')} previous, ${shortcut(']')} next)`)}
      .value=${shown ?? ''}
      @change=${(event) => this.changeView({
            substation: event.target.value,
        })}
    >
      ${this.substations.map(name => b `<oscd-select-option
            value=${name}
            ?selected=${name === shown}
            ><div slot="headline">${name}</div></oscd-select-option
          >`)}
    </oscd-outlined-select>`;
    }
    renderServices() {
        return b `<oscd-chip-set class="services" aria-label=${msg('Services')}>
      ${services.map(service => b `<oscd-filter-chip
            class="service ${service.toLowerCase()}"
            data-service=${service}
            .label=${serviceLabels[service]()}
            .selected=${this.filter.services.includes(service)}
            title=${msg(str `Show or hide ${serviceLabels[service]()} (${shortcut(serviceKeys[service])})`)}
            aria-keyshortcuts="Control+${serviceKeys[service]}"
            @click=${() => this.handleServiceClick(service)}
          >
            <oscd-icon slot="icon">${serviceIcons[service]}</oscd-icon>
          </oscd-filter-chip>`)}
    </oscd-chip-set>`;
    }
    renderSelection() {
        const { ied, incoming, outgoing } = this.filter;
        if (ied === undefined) {
            return A;
        }
        return b `<oscd-chip-set class="selection" aria-label=${msg('Selected IED')}>
      <oscd-input-chip
        class="selected-ied"
        .label=${msg(str `IED ${ied}`)}
        @remove=${(event) => {
            event.preventDefault();
            this.changeFilter({ ied: undefined });
        }}
      ></oscd-input-chip>
      <oscd-filter-chip
        class="incoming"
        .label=${msg('Receives')}
        .selected=${incoming}
        @click=${() => this.changeFilter({ incoming: !incoming })}
      ></oscd-filter-chip>
      <oscd-filter-chip
        class="outgoing"
        .label=${msg('Sends')}
        .selected=${outgoing}
        @click=${() => this.changeFilter({ outgoing: !outgoing })}
      ></oscd-filter-chip>
    </oscd-chip-set>`;
    }
    renderViewControls() {
        const { gridSize, showLabels, filterOpen } = this.view;
        const fullscreenLabel = this.fullscreen
            ? msg('Exit full screen')
            : msg('Full screen');
        return b `<div class="view">
      <map-ied-search
        .ieds=${this.ieds}
        .substation=${this.view.substation ?? this.substations[0]}
      ></map-ied-search>
      <oscd-icon-button
        class="zoom-out"
        aria-label=${msg('Zoom out')}
        aria-keyshortcuts="Control+- -"
        title=${msg(str `Zoom out (${shortcut('-')} or -)`)}
        ?disabled=${gridSize <= minGridSize}
        @click=${() => this.handleZoom(1 / zoomFactor)}
        ><oscd-icon>zoom_out</oscd-icon></oscd-icon-button
      >
      <oscd-icon-button
        class="zoom-in"
        aria-label=${msg('Zoom in')}
        aria-keyshortcuts="Control+= +"
        title=${msg(str `Zoom in (${shortcut('=')} or +)`)}
        ?disabled=${gridSize >= maxGridSize}
        @click=${() => this.handleZoom(zoomFactor)}
        ><oscd-icon>zoom_in</oscd-icon></oscd-icon-button
      >
      <oscd-icon-button
        class="zoom-fit"
        aria-label=${msg('Zoom to fit')}
        aria-keyshortcuts="Control+0 0"
        title=${msg(str `Zoom to fit (${shortcut('0')} or 0)`)}
        @click=${() => this.dispatchEvent(new CustomEvent('map-zoom-fit', { bubbles: true, composed: true }))}
        ><oscd-icon>fit_screen</oscd-icon></oscd-icon-button
      >
      ${this.renderExport()}
      <oscd-icon-button
        class="fullscreen"
        aria-label=${fullscreenLabel}
        title=${fullscreenLabel}
        @click=${() => this.dispatchEvent(new CustomEvent('map-fullscreen', { bubbles: true, composed: true }))}
        ><oscd-icon
          >${this.fullscreen ? 'fullscreen_exit' : 'fullscreen'}</oscd-icon
        ></oscd-icon-button
      >
      <oscd-icon-button
        class="labels"
        toggle
        .selected=${showLabels}
        aria-label=${msg('Show labels')}
        aria-keyshortcuts="Control+L L"
        title=${msg(str `Show labels (${shortcut('L')} or L)`)}
        @click=${() => this.changeView({ showLabels: !showLabels })}
        ><oscd-icon>font_download_off</oscd-icon
        ><oscd-icon slot="selected">font_download</oscd-icon></oscd-icon-button
      >
      <span
        class=${e({
            'filter-toggle': true,
            open: filterOpen,
            active: this.filterCount > 0,
        })}
      >
        <oscd-icon-button
          class="filter"
          toggle
          .selected=${filterOpen}
          aria-label=${this.filterLabel()}
          aria-keyshortcuts="F"
          title=${msg(str `${this.filterLabel()} (F)`)}
          @click=${() => this.changeView({ filterOpen: !filterOpen })}
          ><oscd-icon>filter_alt</oscd-icon
          ><oscd-icon slot="selected">filter_alt</oscd-icon></oscd-icon-button
        >
        ${this.filterCount > 0
            ? b `<span class="badge" aria-hidden="true">${this.filterCount}</span>`
            : A}
      </span>
    </div>`;
    }
    render() {
        return b `<nav aria-label=${msg('Communication map toolbar')}>
      ${this.renderSubstations()} ${this.renderServices()}
      ${this.renderSelection()}
      <span class="spacer"></span>
      ${this.renderViewControls()}
    </nav>`;
    }
}
MapToolbar.scopedElements = {
    'oscd-chip-set': OscdChipSet,
    'oscd-filter-chip': OscdFilterChip,
    'oscd-input-chip': OscdInputChip,
    'oscd-icon': OscdIcon,
    'oscd-icon-button': OscdIconButton,
    'oscd-outlined-select': OscdOutlinedSelect,
    'oscd-select-option': OscdSelectOption,
    'oscd-menu': OscdMenu,
    'oscd-menu-item': OscdMenuItem,
    'oscd-divider': OscdDivider,
    'map-ied-search': MapIedSearch,
};
MapToolbar.styles = i$7 `
    :host {
      display: block;
    }

    nav {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      padding: 4px 8px;
    }

    .spacer {
      flex: 1;
    }

    .view {
      display: flex;
      align-items: center;
    }

    map-ied-search {
      margin-right: 8px;
    }

    .export-anchor {
      position: relative;
      display: inline-flex;
    }

    .menu-heading {
      padding: 8px 16px 4px;
      color: var(--oscd-base01);
      font-size: 0.8em;
      font-weight: 500;
      letter-spacing: 0.05em;
      text-transform: uppercase;
    }

    .substation {
      min-width: 160px;
      --md-outlined-field-top-space: 6px;
      --md-outlined-field-bottom-space: 6px;
    }

    .service.goose {
      --md-filter-chip-icon-color: var(--oscd-map-goose-color);
      --md-filter-chip-selected-leading-icon-color: var(--oscd-map-goose-color);
    }

    .service.sv {
      --md-filter-chip-icon-color: var(--oscd-map-sv-color);
      --md-filter-chip-selected-leading-icon-color: var(--oscd-map-sv-color);
    }

    .service.report {
      --md-filter-chip-icon-color: var(--oscd-map-report-color);
      --md-filter-chip-selected-leading-icon-color: var(
        --oscd-map-report-color
      );
    }

    .filter-toggle {
      position: relative;
      display: inline-flex;
      border-radius: 50%;
    }

    /* Open panel: a tinted disc behind the button. */
    .filter-toggle.open {
      background: color-mix(in srgb, var(--oscd-primary) 18%, transparent);
    }

    /* Active filters: the funnel takes the primary colour, with a count. */
    .filter-toggle.active {
      --md-icon-button-icon-color: var(--oscd-primary);
      --md-icon-button-hover-icon-color: var(--oscd-primary);
      --md-icon-button-selected-icon-color: var(--oscd-primary);
      --md-icon-button-selected-hover-icon-color: var(--oscd-primary);
    }

    .badge {
      position: absolute;
      top: 2px;
      right: 2px;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      box-sizing: border-box;
      border-radius: 8px;
      background: var(--oscd-secondary);
      color: var(--oscd-base3);
      font-size: 11px;
      font-weight: 500;
      line-height: 16px;
      text-align: center;
      pointer-events: none;
    }
  `;
__decorate([
    n$3({ attribute: false })
], MapToolbar.prototype, "filter", void 0);
__decorate([
    n$3({ attribute: false })
], MapToolbar.prototype, "view", void 0);
__decorate([
    n$3({ type: Number })
], MapToolbar.prototype, "filterCount", void 0);
__decorate([
    n$3({ attribute: false })
], MapToolbar.prototype, "ieds", void 0);
__decorate([
    n$3({ type: Boolean })
], MapToolbar.prototype, "fullscreen", void 0);
__decorate([
    n$3({ attribute: false })
], MapToolbar.prototype, "substations", void 0);
__decorate([
    r$2()
], MapToolbar.prototype, "exportOpen", void 0);

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Dispatches a click event to the given element that triggers a native action,
 * but is not composed and therefore is not seen outside the element.
 *
 * This is useful for responding to an external click event on the host element
 * that should trigger an internal action like a button click.
 *
 * Note, a helper is provided because setting this up correctly is a bit tricky.
 * In particular, calling `click` on an element creates a composed event, which
 * is not desirable, and a manually dispatched event must specifically be a
 * `MouseEvent` to trigger a native action.
 *
 * @example
 * hostClickListener = (event: MouseEvent) {
 *   if (isActivationClick(event)) {
 *     this.dispatchActivationClick(this.buttonElement);
 *   }
 * }
 *
 */
function dispatchActivationClick(element) {
    const event = new MouseEvent('click', { bubbles: true });
    element.dispatchEvent(event);
    return event;
}
/**
 * Returns true if the click event should trigger an activation behavior. The
 * behavior is defined by the element and is whatever it should do when
 * clicked.
 *
 * Typically when an element needs to handle a click, the click is generated
 * from within the element and an event listener within the element implements
 * the needed behavior; however, it's possible to fire a click directly
 * at the element that the element should handle. This method helps
 * distinguish these "external" clicks.
 *
 * An "external" click can be triggered in a number of ways: via a click
 * on an associated label for a form  associated element, calling
 * `element.click()`, or calling
 * `element.dispatchEvent(new MouseEvent('click', ...))`.
 *
 * Also works around Firefox issue
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1804576 by squelching
 * events for a microtask after called.
 *
 * @example
 * hostClickListener = (event: MouseEvent) {
 *   if (isActivationClick(event)) {
 *     this.dispatchActivationClick(this.buttonElement);
 *   }
 * }
 *
 */
function isActivationClick(event) {
    // Event must start at the event target.
    if (event.currentTarget !== event.target) {
        return false;
    }
    // Event must not be retargeted from shadowRoot.
    if (event.composedPath()[0] !== event.target) {
        return false;
    }
    // Target must not be disabled; this should only occur for a synthetically
    // dispatched click.
    if (event.target.disabled) {
        return false;
    }
    // This is an activation if the event should not be squelched.
    return !squelchEvent(event);
}
// TODO(https://bugzilla.mozilla.org/show_bug.cgi?id=1804576)
//  Remove when Firefox bug is addressed.
function squelchEvent(event) {
    const squelched = isSquelchingEvents;
    if (squelched) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    squelchEventsForMicrotask();
    return squelched;
}
// Ignore events for one microtask only.
let isSquelchingEvents = false;
async function squelchEventsForMicrotask() {
    isSquelchingEvents = true;
    // Need to pause for just one microtask.
    // tslint:disable-next-line
    await null;
    isSquelchingEvents = false;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A validator that provides constraint validation that emulates
 * `<input type="checkbox">` validation.
 */
class CheckboxValidator extends Validator {
    computeValidity(state) {
        if (!this.checkboxControl) {
            // Lazily create the platform input
            this.checkboxControl = document.createElement('input');
            this.checkboxControl.type = 'checkbox';
        }
        this.checkboxControl.checked = state.checked;
        this.checkboxControl.required = state.required;
        return {
            validity: this.checkboxControl.validity,
            validationMessage: this.checkboxControl.validationMessage,
        };
    }
    equals(prev, next) {
        return prev.checked === next.checked && prev.required === next.required;
    }
    copy({ checked, required }) {
        return { checked, required };
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const checkboxBaseClass = mixinDelegatesAria(mixinConstraintValidation(mixinFormAssociated(mixinElementInternals(i$4))));
/**
 * A checkbox component.
 *
 *
 * @fires change {Event} The native `change` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event)
 * --bubbles
 * @fires input {InputEvent} The native `input` event on
 * [`<input>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event)
 * --bubbles --composed
 */
class Checkbox extends checkboxBaseClass {
    constructor() {
        super();
        /**
         * Whether or not the checkbox is selected.
         */
        this.checked = false;
        /**
         * Whether or not the checkbox is indeterminate.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#indeterminate_state_checkboxes
         */
        this.indeterminate = false;
        /**
         * When true, require the checkbox to be selected when participating in
         * form submission.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#validation
         */
        this.required = false;
        /**
         * The value of the checkbox that is submitted with a form when selected.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#value
         */
        this.value = 'on';
        this.prevChecked = false;
        this.prevDisabled = false;
        this.prevIndeterminate = false;
        {
            this.addEventListener('click', (event) => {
                if (!isActivationClick(event) || !this.input) {
                    return;
                }
                this.focus();
                dispatchActivationClick(this.input);
            });
        }
    }
    update(changed) {
        if (changed.has('checked') ||
            changed.has('disabled') ||
            changed.has('indeterminate')) {
            this.prevChecked = changed.get('checked') ?? this.checked;
            this.prevDisabled = changed.get('disabled') ?? this.disabled;
            this.prevIndeterminate =
                changed.get('indeterminate') ?? this.indeterminate;
        }
        super.update(changed);
    }
    render() {
        const prevNone = !this.prevChecked && !this.prevIndeterminate;
        const prevChecked = this.prevChecked && !this.prevIndeterminate;
        const prevIndeterminate = this.prevIndeterminate;
        const isChecked = this.checked && !this.indeterminate;
        const isIndeterminate = this.indeterminate;
        const containerClasses = e({
            'disabled': this.disabled,
            'selected': isChecked || isIndeterminate,
            'unselected': !isChecked && !isIndeterminate,
            'checked': isChecked,
            'indeterminate': isIndeterminate,
            'prev-unselected': prevNone,
            'prev-checked': prevChecked,
            'prev-indeterminate': prevIndeterminate,
            'prev-disabled': this.prevDisabled,
        });
        // Needed for closure conformance
        const { ariaLabel, ariaInvalid } = this;
        // Note: <input> needs to be rendered before the <svg> for
        // form.reportValidity() to work in Chrome.
        return b `
      <div class="container ${containerClasses}">
        <input
          type="checkbox"
          id="input"
          aria-checked=${isIndeterminate ? 'mixed' : A}
          aria-label=${ariaLabel || A}
          aria-invalid=${ariaInvalid || A}
          ?disabled=${this.disabled}
          ?required=${this.required}
          .indeterminate=${this.indeterminate}
          .checked=${this.checked}
          @input=${this.handleInput}
          @change=${this.handleChange} />

        <div class="outline"></div>
        <div class="background"></div>
        <md-focus-ring part="focus-ring" for="input"></md-focus-ring>
        <md-ripple for="input" ?disabled=${this.disabled}></md-ripple>
        <svg class="icon" viewBox="0 0 18 18" aria-hidden="true">
          <rect class="mark short" />
          <rect class="mark long" />
        </svg>
      </div>
    `;
    }
    handleInput(event) {
        const target = event.target;
        this.checked = target.checked;
        this.indeterminate = target.indeterminate;
        // <input> 'input' event bubbles and is composed, don't re-dispatch it.
    }
    handleChange(event) {
        // <input> 'change' event is not composed, re-dispatch it.
        redispatchEvent(this, event);
    }
    [getFormValue]() {
        if (!this.checked || this.indeterminate) {
            return null;
        }
        return this.value;
    }
    [getFormState]() {
        return String(this.checked);
    }
    formResetCallback() {
        // The checked property does not reflect, so the original attribute set by
        // the user is used to determine the default value.
        this.checked = this.hasAttribute('checked');
    }
    formStateRestoreCallback(state) {
        this.checked = state === 'true';
    }
    [createValidator]() {
        return new CheckboxValidator(() => this);
    }
    [getValidityAnchor]() {
        return this.input;
    }
}
/** @nocollapse */
Checkbox.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean })
], Checkbox.prototype, "checked", void 0);
__decorate([
    n$3({ type: Boolean })
], Checkbox.prototype, "indeterminate", void 0);
__decorate([
    n$3({ type: Boolean })
], Checkbox.prototype, "required", void 0);
__decorate([
    n$3()
], Checkbox.prototype, "value", void 0);
__decorate([
    r$2()
], Checkbox.prototype, "prevChecked", void 0);
__decorate([
    r$2()
], Checkbox.prototype, "prevDisabled", void 0);
__decorate([
    r$2()
], Checkbox.prototype, "prevIndeterminate", void 0);
__decorate([
    e$4('input')
], Checkbox.prototype, "input", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./checkbox/internal/checkbox-styles.css.
const styles$7 = i$7 `:host{border-start-start-radius:var(--md-checkbox-container-shape-start-start, var(--md-checkbox-container-shape, 2px));border-start-end-radius:var(--md-checkbox-container-shape-start-end, var(--md-checkbox-container-shape, 2px));border-end-end-radius:var(--md-checkbox-container-shape-end-end, var(--md-checkbox-container-shape, 2px));border-end-start-radius:var(--md-checkbox-container-shape-end-start, var(--md-checkbox-container-shape, 2px));display:inline-flex;height:var(--md-checkbox-container-size, 18px);position:relative;vertical-align:top;width:var(--md-checkbox-container-size, 18px);-webkit-tap-highlight-color:rgba(0,0,0,0);cursor:pointer}:host([disabled]){cursor:default}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--md-checkbox-container-size, 18px))/2)}md-focus-ring{height:44px;inset:unset;width:44px}input{appearance:none;height:48px;margin:0;opacity:0;outline:none;position:absolute;width:48px;z-index:1;cursor:inherit}:host([touch-target=none]) input{height:100%;width:100%}.container{border-radius:inherit;display:flex;height:100%;place-content:center;place-items:center;position:relative;width:100%}.outline,.background,.icon{inset:0;position:absolute}.outline,.background{border-radius:inherit}.outline{border-color:var(--md-checkbox-outline-color, var(--md-sys-color-on-surface-variant, #49454f));border-style:solid;border-width:var(--md-checkbox-outline-width, 2px);box-sizing:border-box}.background{background-color:var(--md-checkbox-selected-container-color, var(--md-sys-color-primary, #6750a4))}.background,.icon{opacity:0;transition-duration:150ms,50ms;transition-property:transform,opacity;transition-timing-function:cubic-bezier(0.3, 0, 0.8, 0.15),linear;transform:scale(0.6)}:where(.selected) :is(.background,.icon){opacity:1;transition-duration:350ms,50ms;transition-timing-function:cubic-bezier(0.05, 0.7, 0.1, 1),linear;transform:scale(1)}md-ripple{border-radius:var(--md-checkbox-state-layer-shape, var(--md-sys-shape-corner-full, 9999px));height:var(--md-checkbox-state-layer-size, 40px);inset:unset;width:var(--md-checkbox-state-layer-size, 40px);--md-ripple-hover-color: var(--md-checkbox-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-hover-opacity: var(--md-checkbox-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-checkbox-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--md-ripple-pressed-opacity: var(--md-checkbox-pressed-state-layer-opacity, 0.12)}.selected md-ripple{--md-ripple-hover-color: var(--md-checkbox-selected-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--md-ripple-hover-opacity: var(--md-checkbox-selected-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-checkbox-selected-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-pressed-opacity: var(--md-checkbox-selected-pressed-state-layer-opacity, 0.12)}.icon{fill:var(--md-checkbox-selected-icon-color, var(--md-sys-color-on-primary, #fff));height:var(--md-checkbox-icon-size, 18px);width:var(--md-checkbox-icon-size, 18px)}.mark.short{height:2px;transition-property:transform,height;width:2px}.mark.long{height:2px;transition-property:transform,width;width:10px}.mark{animation-duration:150ms;animation-timing-function:cubic-bezier(0.3, 0, 0.8, 0.15);transition-duration:150ms;transition-timing-function:cubic-bezier(0.3, 0, 0.8, 0.15)}.selected .mark{animation-duration:350ms;animation-timing-function:cubic-bezier(0.05, 0.7, 0.1, 1);transition-duration:350ms;transition-timing-function:cubic-bezier(0.05, 0.7, 0.1, 1)}.checked .mark,.prev-checked.unselected .mark{transform:scaleY(-1) translate(7px, -14px) rotate(45deg)}.checked .mark.short,.prev-checked.unselected .mark.short{height:5.6568542495px}.checked .mark.long,.prev-checked.unselected .mark.long{width:11.313708499px}.indeterminate .mark,.prev-indeterminate.unselected .mark{transform:scaleY(-1) translate(4px, -10px) rotate(0deg)}.prev-unselected .mark{transition-property:none}.prev-unselected.checked .mark.long{animation-name:prev-unselected-to-checked}@keyframes prev-unselected-to-checked{from{width:0}}:where(:hover) .outline{border-color:var(--md-checkbox-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));border-width:var(--md-checkbox-hover-outline-width, 2px)}:where(:hover) .background{background:var(--md-checkbox-selected-hover-container-color, var(--md-sys-color-primary, #6750a4))}:where(:hover) .icon{fill:var(--md-checkbox-selected-hover-icon-color, var(--md-sys-color-on-primary, #fff))}:where(:focus-within) .outline{border-color:var(--md-checkbox-focus-outline-color, var(--md-sys-color-on-surface, #1d1b20));border-width:var(--md-checkbox-focus-outline-width, 2px)}:where(:focus-within) .background{background:var(--md-checkbox-selected-focus-container-color, var(--md-sys-color-primary, #6750a4))}:where(:focus-within) .icon{fill:var(--md-checkbox-selected-focus-icon-color, var(--md-sys-color-on-primary, #fff))}:where(:active) .outline{border-color:var(--md-checkbox-pressed-outline-color, var(--md-sys-color-on-surface, #1d1b20));border-width:var(--md-checkbox-pressed-outline-width, 2px)}:where(:active) .background{background:var(--md-checkbox-selected-pressed-container-color, var(--md-sys-color-primary, #6750a4))}:where(:active) .icon{fill:var(--md-checkbox-selected-pressed-icon-color, var(--md-sys-color-on-primary, #fff))}:where(.disabled,.prev-disabled) :is(.background,.icon,.mark){animation-duration:0s;transition-duration:0s}:where(.disabled) .outline{border-color:var(--md-checkbox-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));border-width:var(--md-checkbox-disabled-outline-width, 2px);opacity:var(--md-checkbox-disabled-container-opacity, 0.38)}:where(.selected.disabled) .outline{visibility:hidden}:where(.selected.disabled) .background{background:var(--md-checkbox-selected-disabled-container-color, var(--md-sys-color-on-surface, #1d1b20));opacity:var(--md-checkbox-selected-disabled-container-opacity, 0.38)}:where(.disabled) .icon{fill:var(--md-checkbox-selected-disabled-icon-color, var(--md-sys-color-surface, #fef7ff))}@media(forced-colors: active){.background{background-color:CanvasText}.selected.disabled .background{background-color:GrayText;opacity:1}.outline{border-color:CanvasText}.disabled .outline{border-color:GrayText;opacity:1}.icon{fill:Canvas}}
`;

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-checkbox
 * @summary Checkboxes allow users to select one or more items from a set.
 * Checkboxes can turn an option on or off.
 *
 * Use checkboxes to:
 * - Select one or more options from a list
 * - Present a list containing sub-selections
 * - Turn an item on or off in a desktop environment
 *
 * @final
 * @suppress {visibility}
 */
class OscdCheckbox extends ScopedElementsMixin(Checkbox) {
}
OscdCheckbox.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
};
OscdCheckbox.styles = [styles$7];

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const NAVIGABLE_KEY_SET = new Set(Object.values(NavigableKeys));
// tslint:disable-next-line:enforce-comments-on-exported-symbols
class List extends i$4 {
    /** @export */
    get items() {
        return this.listController.items;
    }
    constructor() {
        super();
        this.listController = new ListController({
            isItem: (item) => item.hasAttribute('md-list-item'),
            getPossibleItems: () => this.slotItems,
            isRtl: () => getComputedStyle(this).direction === 'rtl',
            deactivateItem: (item) => {
                item.tabIndex = -1;
            },
            activateItem: (item) => {
                item.tabIndex = 0;
            },
            isNavigableKey: (key) => NAVIGABLE_KEY_SET.has(key),
            isActivatable: (item) => !item.disabled && item.type !== 'text',
        });
        this.internals = 
        // Cast needed for closure
        this.attachInternals();
        {
            this.internals.role = 'list';
            this.addEventListener('keydown', this.listController.handleKeydown);
        }
    }
    render() {
        return b `
      <slot
        @deactivate-items=${this.listController.onDeactivateItems}
        @request-activation=${this.listController.onRequestActivation}
        @slotchange=${this.listController.onSlotchange}>
      </slot>
    `;
    }
    /**
     * Activates the next item in the list. If at the end of the list, the first
     * item will be activated.
     *
     * @return The activated list item or `null` if there are no items.
     */
    activateNextItem() {
        return this.listController.activateNextItem();
    }
    /**
     * Activates the previous item in the list. If at the start of the list, the
     * last item will be activated.
     *
     * @return The activated list item or `null` if there are no items.
     */
    activatePreviousItem() {
        return this.listController.activatePreviousItem();
    }
}
__decorate([
    o$2({ flatten: true })
], List.prototype, "slotItems", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./list/internal/list-styles.css.
const styles$6 = i$7 `:host{background:var(--md-list-container-color, var(--md-sys-color-surface, #fef7ff));color:unset;display:flex;flex-direction:column;outline:none;padding:8px 0;position:relative}
`;

/*
 * GENERATED SOURCE FILE. DO NOT MODIFY.
 * Modifications will be overwritten.
 * To prevent this file from being overwritten, remove this comment entirely.
 */
/**
 * @tagname oscd-list
 * @summary Lists are continuous, vertical indexes of text or images.
 *
 * Lists consist of one or more list items, and can contain actions represented
 * by icons and text. List items come in three sizes: one-line, two-line, and
 * three-line.
 *
 * __Takeaways:__
 *
 * - Lists should be sorted in logical ways that make content easy to scan, such
 *   as alphabetical, numerical, chronological, or by user preference.
 * - Lists present content in a way that makes it easy to identify a specific
 *   item in a collection and act on it.
 * - Lists should present icons, text, and actions in a consistent format.
 *
 * @final
 * @suppress {visibility}
 */
class OscdList extends List {
}
OscdList.styles = [styles$6];

// Separate variable needed for closure.
const listItemBaseClass = mixinDelegatesAria(i$4);
/**
 * @fires request-activation {Event} Requests the list to set `tabindex=0` on
 * the item and focus it. Used internally for list keyboard navigation; most
 * applications do not need to listen for this event. It is exposed for
 * authors building their own list-item replacements or wrapping items in a
 * custom controller. --bubbles --composed
 */
class ListItemEl extends listItemBaseClass {
    constructor() {
        super(...arguments);
        /**
         * Disables the item and makes it non-selectable and non-interactive.
         */
        this.disabled = false;
        /**
         * Sets the behavior of the list item, defaults to "text". Change to "link" or
         * "button" for interactive items.
         */
        this.type = 'text';
        /**
         * READONLY. Sets the `md-list-item` attribute on the element.
         */
        this.isListItem = true;
        /**
         * Sets the underlying `HTMLAnchorElement`'s `href` resource attribute.
         */
        this.href = '';
        /**
         * Sets the underlying `HTMLAnchorElement`'s `target` attribute when `href` is
         * set.
         */
        this.target = '';
    }
    get isDisabled() {
        return this.disabled && this.type !== 'link';
    }
    willUpdate(changed) {
        if (this.href) {
            this.type = 'link';
        }
        super.willUpdate(changed);
    }
    render() {
        return this.renderListItem(b `
      <md-item>
        <div slot="container">
          ${this.renderRipple()} ${this.renderFocusRing()}
        </div>
        <slot name="start" slot="start"></slot>
        <slot name="end" slot="end"></slot>
        ${this.renderBody()}
      </md-item>
    `);
    }
    /**
     * Renders the root list item.
     *
     * @param content the child content of the list item.
     */
    renderListItem(content) {
        const isAnchor = this.type === 'link';
        let tag;
        switch (this.type) {
            case 'link':
                tag = i `a`;
                break;
            case 'button':
                tag = i `button`;
                break;
            default:
            case 'text':
                tag = i `li`;
                break;
        }
        const isInteractive = this.type !== 'text';
        // TODO(b/265339866): announce "button"/"link" inside of a list item. Until
        // then all are "listitem" roles for correct announcement.
        const target = isAnchor && !!this.target ? this.target : A;
        return u `
      <${tag}
        id="item"
        tabindex="${this.isDisabled || !isInteractive ? -1 : 0}"
        ?disabled=${this.isDisabled}
        role="listitem"
        aria-selected=${this.ariaSelected || A}
        aria-checked=${this.ariaChecked || A}
        aria-expanded=${this.ariaExpanded || A}
        aria-haspopup=${this.ariaHasPopup || A}
        class="list-item ${e(this.getRenderClasses())}"
        href=${this.href || A}
        target=${target}
        @focus=${this.onFocus}
      >${content}</${tag}>
    `;
    }
    /**
     * Handles rendering of the ripple element.
     */
    renderRipple() {
        if (this.type === 'text') {
            return A;
        }
        return b ` <md-ripple
      part="ripple"
      for="item"
      ?disabled=${this.isDisabled}></md-ripple>`;
    }
    /**
     * Handles rendering of the focus ring.
     */
    renderFocusRing() {
        if (this.type === 'text') {
            return A;
        }
        return b ` <md-focus-ring
      @visibility-changed=${this.onFocusRingVisibilityChanged}
      part="focus-ring"
      for="item"
      inward></md-focus-ring>`;
    }
    onFocusRingVisibilityChanged(e) { }
    /**
     * Classes applied to the list item root.
     */
    getRenderClasses() {
        return { 'disabled': this.isDisabled };
    }
    /**
     * Handles rendering the headline and supporting text.
     */
    renderBody() {
        return b `
      <slot></slot>
      <slot name="overline" slot="overline"></slot>
      <slot name="headline" slot="headline"></slot>
      <slot name="supporting-text" slot="supporting-text"></slot>
      <slot
        name="trailing-supporting-text"
        slot="trailing-supporting-text"></slot>
    `;
    }
    onFocus() {
        if (this.tabIndex !== -1) {
            return;
        }
        // Handles the case where the user clicks on the element and then tabs.
        this.dispatchEvent(createRequestActivationEvent());
    }
    focus() {
        // TODO(b/300334509): needed for some cases where delegatesFocus doesn't
        // work programmatically like in FF and select-option
        this.listItemRoot?.focus();
    }
    click() {
        if (!this.listItemRoot) {
            // If the element has not finished rendering, call super to ensure click
            // events are dispatched.
            super.click();
            return;
        }
        // Forward click to the element to ensure link <a>.click() works correctly.
        this.listItemRoot.click();
    }
}
/** @nocollapse */
ListItemEl.shadowRootOptions = {
    ...i$4.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, reflect: true })
], ListItemEl.prototype, "disabled", void 0);
__decorate([
    n$3({ reflect: true })
], ListItemEl.prototype, "type", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'md-list-item', reflect: true })
], ListItemEl.prototype, "isListItem", void 0);
__decorate([
    n$3()
], ListItemEl.prototype, "href", void 0);
__decorate([
    n$3()
], ListItemEl.prototype, "target", void 0);
__decorate([
    e$4('.list-item')
], ListItemEl.prototype, "listItemRoot", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./list/internal/listitem/list-item-styles.css.
const styles$5 = i$7 `:host{display:flex;-webkit-tap-highlight-color:rgba(0,0,0,0);--md-ripple-hover-color: var(--md-list-item-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-hover-opacity: var(--md-list-item-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-list-item-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-pressed-opacity: var(--md-list-item-pressed-state-layer-opacity, 0.12)}:host(:is([type=button]:not([disabled]),[type=link])){cursor:pointer}md-focus-ring{z-index:1;--md-focus-ring-shape: 8px}a,button,li{background:none;border:none;cursor:inherit;padding:0;margin:0;text-align:unset;text-decoration:none}.list-item{border-radius:inherit;display:flex;flex:1;max-width:inherit;min-width:inherit;outline:none;-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%}.list-item.interactive{cursor:pointer}.list-item.disabled{opacity:var(--md-list-item-disabled-opacity, 0.3);pointer-events:none}[slot=container]{pointer-events:none}md-ripple{border-radius:inherit}md-item{border-radius:inherit;flex:1;height:100%;color:var(--md-list-item-label-text-color, var(--md-sys-color-on-surface, #1d1b20));font-family:var(--md-list-item-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-list-item-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));line-height:var(--md-list-item-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));font-weight:var(--md-list-item-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));min-height:var(--md-list-item-one-line-container-height, 56px);padding-top:var(--md-list-item-top-space, 12px);padding-bottom:var(--md-list-item-bottom-space, 12px);padding-inline-start:var(--md-list-item-leading-space, 16px);padding-inline-end:var(--md-list-item-trailing-space, 16px)}md-item[multiline]{min-height:var(--md-list-item-two-line-container-height, 72px)}[slot=supporting-text]{color:var(--md-list-item-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-list-item-supporting-text-font, var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-list-item-supporting-text-size, var(--md-sys-typescale-body-medium-size, 0.875rem));line-height:var(--md-list-item-supporting-text-line-height, var(--md-sys-typescale-body-medium-line-height, 1.25rem));font-weight:var(--md-list-item-supporting-text-weight, var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400)))}[slot=trailing-supporting-text]{color:var(--md-list-item-trailing-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-list-item-trailing-supporting-text-font, var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-list-item-trailing-supporting-text-size, var(--md-sys-typescale-label-small-size, 0.6875rem));line-height:var(--md-list-item-trailing-supporting-text-line-height, var(--md-sys-typescale-label-small-line-height, 1rem));font-weight:var(--md-list-item-trailing-supporting-text-weight, var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500)))}:is([slot=start],[slot=end])::slotted(*){fill:currentColor}[slot=start]{color:var(--md-list-item-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f))}[slot=end]{color:var(--md-list-item-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f))}@media(forced-colors: active){.disabled slot{color:GrayText}.list-item.disabled{color:GrayText;opacity:1}}
`;

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-list-item
 * @summary
 * Lists are continuous, vertical indexes of text or images. Items are placed
 * inside the list.
 *
 * Lists consist of one or more list items, and can contain actions represented
 * by icons and text. List items come in three sizes: one-line, two-line, and
 * three-line.
 *
 * __Takeaways:__
 *
 * - Lists should be sorted in logical ways that make content easy to scan, such
 *   as alphabetical, numerical, chronological, or by user preference.
 * - Lists present content in a way that makes it easy to identify a specific
 *   item in a collection and act on it.
 * - Lists should present icons, text, and actions in a consistent format.
 *
 * Acceptable slot child variants are:
 *
 * - `img[slot=end]`
 * - `img[slot=start]`
 *
 *  @example
 * ```html
 * <oscd-list-item
 *     headline="User Name"
 *     supportingText="user@name.com">
 *   <md-icon slot="start">account_circle</md-icon>
 *   <md-icon slot="end">check</md-icon>
 * </oscd-list-item>
 * ```
 *
 * @example
 *
 * @final
 * @suppress {visibility}
 */
class OscdListItem extends ScopedElementsMixin(ListItemEl) {
}
OscdListItem.scopedElements = {
    'md-ripple': OscdRipple,
    'md-item': OscdItem,
    'md-focus-ring': OscdFocusRing,
};
OscdListItem.styles = [styles$5];

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tag oscd-outlined-text-field
 * @summary A Material Design outlined text field component.
 * This component is a wrapper around the `OutlinedTextField` from Material Web Components,
 * providing a scoped element that uses the `OscdOutlinedField` as its field.
 * @final
 * @suppress {visibility}
 */
class OscdOutlinedTextField extends ScopedElementsMixin(OutlinedTextField) {
    constructor() {
        super(...arguments);
        this.fieldTag = i `oscd-outlined-field`;
    }
}
OscdOutlinedTextField.styles = [styles$8, styles$9];
OscdOutlinedTextField.scopedElements = {
    'oscd-outlined-field': OscdOutlinedField,
};

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A property symbol that indicates whether or not a `Focusable` element can be
 * focused.
 */
const isFocusable$1 = Symbol('isFocusable');
const privateIsFocusable = Symbol('privateIsFocusable');
const externalTabIndex = Symbol('externalTabIndex');
const isUpdatingTabIndex = Symbol('isUpdatingTabIndex');
const updateTabIndex = Symbol('updateTabIndex');
/**
 * Mixes in focusable functionality for a class.
 *
 * Elements can enable and disable their focusability with the `isFocusable`
 * symbol property. Changing `tabIndex` will trigger a lit render, meaning
 * `this.tabIndex` can be used in template expressions.
 *
 * This mixin will preserve externally-set tabindices. If an element turns off
 * focusability, but a user sets `tabindex="0"`, it will still be focusable.
 *
 * To remove user overrides and restore focusability control to the element,
 * remove the `tabindex` attribute.
 *
 * @param base The class to mix functionality into.
 * @return The provided class with `Focusable` mixed in.
 */
function mixinFocusable(base) {
    var _a, _b, _c;
    class FocusableElement extends base {
        constructor() {
            super(...arguments);
            this[_a] = true;
            this[_b] = null;
            this[_c] = false;
        }
        get [isFocusable$1]() {
            return this[privateIsFocusable];
        }
        set [isFocusable$1](value) {
            if (this[isFocusable$1] === value) {
                return;
            }
            this[privateIsFocusable] = value;
            this[updateTabIndex]();
        }
        connectedCallback() {
            super.connectedCallback();
            this[updateTabIndex]();
        }
        attributeChangedCallback(name, old, value) {
            if (name !== 'tabindex') {
                super.attributeChangedCallback(name, old, value);
                return;
            }
            this.requestUpdate('tabIndex', Number(old ?? -1));
            if (this[isUpdatingTabIndex]) {
                // Not an externally-initiated update.
                return;
            }
            if (!this.hasAttribute('tabindex')) {
                // User removed the attribute, can now use internal tabIndex
                this[externalTabIndex] = null;
                this[updateTabIndex]();
                return;
            }
            this[externalTabIndex] = this.tabIndex;
        }
        [(_a = privateIsFocusable, _b = externalTabIndex, _c = isUpdatingTabIndex, updateTabIndex)]() {
            const internalTabIndex = this[isFocusable$1] ? 0 : -1;
            const computedTabIndex = this[externalTabIndex] ?? internalTabIndex;
            this[isUpdatingTabIndex] = true;
            this.tabIndex = computedTabIndex;
            this[isUpdatingTabIndex] = false;
        }
    }
    __decorate([
        n$3({ noAccessor: true })
    ], FocusableElement.prototype, "tabIndex", void 0);
    return FocusableElement;
}

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A validator that provides constraint validation that emulates
 * `<input type="radio">` validation.
 */
class RadioValidator extends Validator {
    computeValidity(states) {
        if (!this.radioElement) {
            // Lazily create the radio element
            this.radioElement = document.createElement('input');
            this.radioElement.type = 'radio';
            // A name is required for validation to run
            this.radioElement.name = 'group';
        }
        let isRequired = false;
        let isChecked = false;
        for (const { checked, required } of states) {
            if (required) {
                isRequired = true;
            }
            if (checked) {
                isChecked = true;
            }
        }
        // Firefox v119 doesn't compute grouped radio validation correctly while
        // they are detached from the DOM, which is why we don't render multiple
        // virtual <input>s. Instead, we can check the required/checked states and
        // grab the i18n'd validation message if the value is missing.
        this.radioElement.checked = isChecked;
        this.radioElement.required = isRequired;
        return {
            validity: {
                valueMissing: isRequired && !isChecked,
            },
            validationMessage: this.radioElement.validationMessage,
        };
    }
    equals(prevGroup, nextGroup) {
        if (prevGroup.length !== nextGroup.length) {
            return false;
        }
        for (let i = 0; i < prevGroup.length; i++) {
            const prev = prevGroup[i];
            const next = nextGroup[i];
            if (prev.checked !== next.checked || prev.required !== next.required) {
                return false;
            }
        }
        return true;
    }
    copy(states) {
        // Cast as unknown since typescript does not have enough information to
        // infer that the array always has at least one element.
        return states.map(({ checked, required }) => ({
            checked,
            required,
        }));
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A `ReactiveController` that provides root node-scoped single selection for
 * elements, similar to native `<input type="radio">` selection.
 *
 * To use, elements should add the controller and call
 * `selectionController.handleCheckedChange()` in a getter/setter. This must
 * be synchronous to match native behavior.
 *
 * @example
 * const CHECKED = Symbol('checked');
 *
 * class MyToggle extends LitElement {
 *   get checked() { return this[CHECKED]; }
 *   set checked(checked: boolean) {
 *     const oldValue = this.checked;
 *     if (oldValue === checked) {
 *       return;
 *     }
 *
 *     this[CHECKED] = checked;
 *     this.selectionController.handleCheckedChange();
 *     this.requestUpdate('checked', oldValue);
 *   }
 *
 *   [CHECKED] = false;
 *
 *   private selectionController = new SingleSelectionController(this);
 *
 *   constructor() {
 *     super();
 *     this.addController(this.selectionController);
 *   }
 * }
 */
class SingleSelectionController {
    /**
     * All single selection elements in the host element's root with the same
     * `name` attribute, including the host element.
     */
    get controls() {
        const name = this.host.getAttribute('name');
        if (!name || !this.root || !this.host.isConnected) {
            return [this.host];
        }
        // Cast as unknown since there is not enough information for typescript to
        // know that there is always at least one element (the host).
        return Array.from(this.root.querySelectorAll(`[name="${name}"]`));
    }
    constructor(host) {
        this.host = host;
        this.focused = false;
        this.root = null;
        this.handleFocusIn = () => {
            this.focused = true;
            this.updateTabIndices();
        };
        this.handleFocusOut = () => {
            this.focused = false;
            this.updateTabIndices();
        };
        /**
         * Handles arrow key events from the host. Using the arrow keys will
         * select and check the next or previous sibling with the host's
         * `name` attribute.
         */
        this.handleKeyDown = (event) => {
            const isDown = event.key === 'ArrowDown';
            const isUp = event.key === 'ArrowUp';
            const isLeft = event.key === 'ArrowLeft';
            const isRight = event.key === 'ArrowRight';
            // Ignore non-arrow keys
            if (!isLeft && !isRight && !isDown && !isUp) {
                return;
            }
            // Don't try to select another sibling if there aren't any.
            const siblings = this.controls;
            if (!siblings.length) {
                return;
            }
            // Prevent default interactions on the element for arrow keys,
            // since this controller will introduce new behavior.
            event.preventDefault();
            // Check if moving forwards or backwards
            const isRtl = getComputedStyle(this.host).direction === 'rtl';
            const forwards = isRtl ? isLeft || isDown : isRight || isDown;
            const hostIndex = siblings.indexOf(this.host);
            let nextIndex = forwards ? hostIndex + 1 : hostIndex - 1;
            // Search for the next sibling that is not disabled to select.
            // If we return to the host index, there is nothing to select.
            while (nextIndex !== hostIndex) {
                if (nextIndex >= siblings.length) {
                    // Return to start if moving past the last item.
                    nextIndex = 0;
                }
                else if (nextIndex < 0) {
                    // Go to end if moving before the first item.
                    nextIndex = siblings.length - 1;
                }
                // Check if the next sibling is disabled. If so,
                // move the index and continue searching.
                const nextSibling = siblings[nextIndex];
                if (nextSibling.hasAttribute('disabled')) {
                    if (forwards) {
                        nextIndex++;
                    }
                    else {
                        nextIndex--;
                    }
                    continue;
                }
                // Uncheck and remove focusability from other siblings.
                for (const sibling of siblings) {
                    if (sibling !== nextSibling) {
                        sibling.checked = false;
                        sibling.tabIndex = -1;
                        sibling.blur();
                    }
                }
                // The next sibling should be checked, focused and dispatch a change event
                nextSibling.checked = true;
                nextSibling.tabIndex = 0;
                nextSibling.focus();
                // Fire a change event since the change is triggered by a user action.
                // This matches native <input type="radio"> behavior.
                nextSibling.dispatchEvent(new Event('change', { bubbles: true }));
                break;
            }
        };
    }
    hostConnected() {
        this.host.addEventListener('keydown', this.handleKeyDown);
        this.host.addEventListener('focusin', this.handleFocusIn);
        this.host.addEventListener('focusout', this.handleFocusOut);
        // Update siblings after a microtask to allow other synchronous connected
        // callbacks to settle before triggering additional Lit updates. This avoids
        // stack overflow issues when too many elements are being rendered and
        // connected at the same time.
        queueMicrotask(() => {
            // Update for the newly added host.
            this.root = this.host.getRootNode();
            if (this.host.checked) {
                // Uncheck other siblings when attached if already checked. This mimics
                // native <input type="radio"> behavior.
                this.uncheckSiblings();
            }
            this.updateTabIndices();
        });
    }
    hostDisconnected() {
        this.host.removeEventListener('keydown', this.handleKeyDown);
        this.host.removeEventListener('focusin', this.handleFocusIn);
        this.host.removeEventListener('focusout', this.handleFocusOut);
        // Update siblings after a microtask to allow other synchronous disconnected
        // callbacks to settle before triggering additional Lit updates. This avoids
        // stack overflow issues when too many elements are being rendered and
        // connected at the same time.
        queueMicrotask(() => {
            // Update for siblings that are still connected.
            this.updateTabIndices();
            this.root = null;
        });
    }
    /**
     * Should be called whenever the host's `checked` property changes
     * synchronously.
     */
    handleCheckedChange() {
        if (!this.host.checked) {
            return;
        }
        this.uncheckSiblings();
        this.updateTabIndices();
    }
    uncheckSiblings() {
        for (const sibling of this.controls) {
            if (sibling !== this.host) {
                sibling.checked = false;
            }
        }
    }
    /**
     * Updates the `tabindex` of the host and its siblings.
     */
    updateTabIndices() {
        // There are three tabindex states for a group of elements:
        // 1. If any are checked, that element is focusable.
        const siblings = this.controls;
        const checkedSibling = siblings.find((sibling) => sibling.checked);
        // 2. If an element is focused, the others are no longer focusable.
        if (checkedSibling || this.focused) {
            const focusable = checkedSibling || this.host;
            focusable.tabIndex = 0;
            for (const sibling of siblings) {
                if (sibling !== focusable) {
                    sibling.tabIndex = -1;
                }
            }
            return;
        }
        // 3. If none are checked or focused, all are focusable.
        for (const sibling of siblings) {
            sibling.tabIndex = 0;
        }
    }
}

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
var _a;
const CHECKED = Symbol('checked');
let maskId = 0;
// Separate variable needed for closure.
const radioBaseClass = mixinConstraintValidation(mixinFormAssociated(mixinElementInternals(mixinFocusable(i$4))));
/**
 * A radio component.
 *
 * @fires input {InputEvent} Dispatched when the value changes from user
 * interaction. --bubbles
 * @fires change {Event} Dispatched when the value changes from user
 * interaction. --bubbles --composed
 */
class Radio extends radioBaseClass {
    /**
     * Whether or not the radio is selected.
     */
    get checked() {
        return this[CHECKED];
    }
    set checked(checked) {
        const wasChecked = this.checked;
        if (wasChecked === checked) {
            return;
        }
        this[CHECKED] = checked;
        this.requestUpdate('checked', wasChecked);
        this.selectionController.handleCheckedChange();
    }
    constructor() {
        super();
        // Unique maskId is required because of a Safari bug that fail to persist
        // reference to the mask. This should be removed once the bug is fixed.
        this.maskId = `cutout${++maskId}`;
        this[_a] = false;
        /**
         * Whether or not the radio is required. If any radio is required in a group,
         * all radios are implicitly required.
         */
        this.required = false;
        /**
         * The element value to use in form submission when checked.
         */
        this.value = 'on';
        this.selectionController = new SingleSelectionController(this);
        this.addController(this.selectionController);
        {
            this[internals].role = 'radio';
            this.addEventListener('click', this.handleClick.bind(this));
            this.addEventListener('keydown', this.handleKeydown.bind(this));
        }
    }
    render() {
        const classes = { 'checked': this.checked };
        return b `
      <div class="container ${e(classes)}" aria-hidden="true">
        <md-ripple
          part="ripple"
          .control=${this}
          ?disabled=${this.disabled}></md-ripple>
        <md-focus-ring part="focus-ring" .control=${this}></md-focus-ring>
        <svg class="icon" viewBox="0 0 20 20">
          <mask id="${this.maskId}">
            <rect width="100%" height="100%" fill="white" />
            <circle cx="10" cy="10" r="8" fill="black" />
          </mask>
          <circle
            class="outer circle"
            cx="10"
            cy="10"
            r="10"
            mask="url(#${this.maskId})" />
          <circle class="inner circle" cx="10" cy="10" r="5" />
        </svg>

        <div class="touch-target"></div>
      </div>
    `;
    }
    updated() {
        this[internals].ariaChecked = String(this.checked);
    }
    async handleClick(event) {
        if (this.disabled) {
            return;
        }
        // allow event to propagate to user code after a microtask.
        await 0;
        if (event.defaultPrevented) {
            return;
        }
        if (isActivationClick(event)) {
            this.focus();
        }
        // Per spec, clicking on a radio input always selects it.
        this.checked = true;
        this.dispatchEvent(new Event('change', { bubbles: true }));
        this.dispatchEvent(new InputEvent('input', { bubbles: true, composed: true }));
    }
    async handleKeydown(event) {
        // allow event to propagate to user code after a microtask.
        await 0;
        if (event.key !== ' ' || event.defaultPrevented) {
            return;
        }
        this.click();
    }
    [(_a = CHECKED, getFormValue)]() {
        return this.checked ? this.value : null;
    }
    [getFormState]() {
        return String(this.checked);
    }
    formResetCallback() {
        // The checked property does not reflect, so the original attribute set by
        // the user is used to determine the default value.
        this.checked = this.hasAttribute('checked');
    }
    formStateRestoreCallback(state) {
        this.checked = state === 'true';
    }
    [createValidator]() {
        return new RadioValidator(() => {
            if (!this.selectionController) {
                // Validation runs on superclass construction, so selection controller
                // might not actually be ready until this class constructs.
                return [this];
            }
            return this.selectionController.controls;
        });
    }
    [getValidityAnchor]() {
        return this.container;
    }
}
__decorate([
    n$3({ type: Boolean })
], Radio.prototype, "checked", null);
__decorate([
    n$3({ type: Boolean })
], Radio.prototype, "required", void 0);
__decorate([
    n$3()
], Radio.prototype, "value", void 0);
__decorate([
    e$4('.container')
], Radio.prototype, "container", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./radio/internal/radio-styles.css.
const styles$4 = i$7 `@layer{:host{display:inline-flex;height:var(--md-radio-icon-size, 20px);outline:none;position:relative;vertical-align:top;width:var(--md-radio-icon-size, 20px);-webkit-tap-highlight-color:rgba(0,0,0,0);cursor:pointer;--md-ripple-hover-color: var(--md-radio-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-hover-opacity: var(--md-radio-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-radio-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--md-ripple-pressed-opacity: var(--md-radio-pressed-state-layer-opacity, 0.12)}:host([disabled]){cursor:default}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--md-radio-icon-size, 20px))/2)}.container{display:flex;height:100%;place-content:center;place-items:center;width:100%}md-focus-ring{height:44px;inset:unset;width:44px}.checked{--md-ripple-hover-color: var(--md-radio-selected-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--md-ripple-hover-opacity: var(--md-radio-selected-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-radio-selected-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-pressed-opacity: var(--md-radio-selected-pressed-state-layer-opacity, 0.12)}.touch-target{height:48px;position:absolute;width:48px}:host([touch-target=none]) .touch-target{display:none}md-ripple{border-radius:50%;height:var(--md-radio-state-layer-size, 40px);inset:unset;width:var(--md-radio-state-layer-size, 40px)}.icon{fill:var(--md-radio-icon-color, var(--md-sys-color-on-surface-variant, #49454f));inset:0;position:absolute}.outer.circle{transition:fill 50ms linear}.inner.circle{opacity:0;transform-origin:center;transition:opacity 50ms linear}.checked .icon{fill:var(--md-radio-selected-icon-color, var(--md-sys-color-primary, #6750a4))}.checked .inner.circle{animation:inner-circle-grow 300ms cubic-bezier(0.05, 0.7, 0.1, 1);opacity:1}@keyframes inner-circle-grow{from{transform:scale(0)}to{transform:scale(1)}}:host([disabled]) .circle{animation-duration:0s;transition-duration:0s}:host(:hover) .icon{fill:var(--md-radio-hover-icon-color, var(--md-sys-color-on-surface, #1d1b20))}:host(:focus-within) .icon{fill:var(--md-radio-focus-icon-color, var(--md-sys-color-on-surface, #1d1b20))}:host(:active) .icon{fill:var(--md-radio-pressed-icon-color, var(--md-sys-color-on-surface, #1d1b20))}:host([disabled]) .icon{fill:var(--md-radio-disabled-unselected-icon-color, var(--md-sys-color-on-surface, #1d1b20));opacity:var(--md-radio-disabled-unselected-icon-opacity, 0.38)}:host(:hover) .checked .icon{fill:var(--md-radio-selected-hover-icon-color, var(--md-sys-color-primary, #6750a4))}:host(:focus-within) .checked .icon{fill:var(--md-radio-selected-focus-icon-color, var(--md-sys-color-primary, #6750a4))}:host(:active) .checked .icon{fill:var(--md-radio-selected-pressed-icon-color, var(--md-sys-color-primary, #6750a4))}:host([disabled]) .checked .icon{fill:var(--md-radio-disabled-selected-icon-color, var(--md-sys-color-on-surface, #1d1b20));opacity:var(--md-radio-disabled-selected-icon-opacity, 0.38)}}@layer hcm{@media(forced-colors: active){.icon{fill:CanvasText}:host([disabled]) .icon{fill:GrayText;opacity:1}}}
`;

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-radio
 * @summary Radio buttons allow users to select one option from a set.
 *
 * Radio buttons are the recommended way to allow users to make a single
 * selection from a list of options.
 *
 * Only one radio button can be selected at a time.
 *
 * Use radio buttons to:
 * - Select a single option from a set
 * - Expose all available options
 *
 * @final
 * @suppress {visibility}
 */
class OscdRadio extends ScopedElementsMixin(Radio) {
}
OscdRadio.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
};
OscdRadio.styles = [styles$4];

const DEFAULT_REGEX = /.*/i;
function searchRegex(filter) {
    if (!filter) {
        return /.*/i;
    }
    const terms = filter
        .replace(/[.+^${}()|[\]\\]/g, '\\$&')
        .trim()
        .match(/(?:[^\s"']+|['"][^'"]*["'])+/g) ?? [];
    const expandedTerms = terms.map(term => term.replace(/\*/g, '.*').replace(/\?/g, '.{1}').replace(/"|'/g, ''));
    const regexString = expandedTerms.map(term => `(?=.*${term})`);
    return new RegExp(`${regexString.join('')}.*`, 'i');
}
function debounce(callback, delay = 100) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback(...args);
        }, delay);
    };
}
// Base class for all filterable list components
class FilterListBase extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        /** Whether list items can be filtered on `headline` and `supportingText` */
        this.filterable = false;
        /** Placeholder for search input field */
        this.searchhelper = 'search';
        this._searchValue = '';
        this._cachedRegex = DEFAULT_REGEX;
    }
    /** Current search filter value. Updates search regex when changed. */
    set searchValue(value) {
        const oldVal = this._searchValue;
        if (oldVal === value) {
            return;
        }
        this._searchValue = value ?? '';
        this.searchRegex = searchRegex(value);
    }
    get searchValue() {
        return this._searchValue;
    }
    get searchRegex() {
        return this._cachedRegex;
    }
    set searchRegex(value) {
        if (value && value instanceof RegExp) {
            this._cachedRegex = value;
        }
        else {
            this._cachedRegex = DEFAULT_REGEX;
        }
    }
    onFilter() {
        if (!this.searchInput) {
            return;
        }
        this.searchValue = this.searchInput.value;
    }
    renderSearchField() {
        return this.filterable
            ? b `<oscd-outlined-text-field
          .value=${this._searchValue}
          placeholder="${this.searchhelper}"
          @input="${debounce(() => this.onFilter())}"
        >
          <oscd-icon slot="leading-icon">search</oscd-icon>
        </oscd-outlined-text-field>`
            : b ``;
    }
}
__decorate([
    n$3({ type: Boolean })
], FilterListBase.prototype, "filterable", void 0);
__decorate([
    n$3({ type: String })
], FilterListBase.prototype, "searchhelper", void 0);
__decorate([
    e$4('oscd-outlined-text-field')
], FilterListBase.prototype, "searchInput", void 0);
__decorate([
    r$2()
], FilterListBase.prototype, "_searchValue", void 0);
__decorate([
    n$3({ type: String })
], FilterListBase.prototype, "searchValue", null);

function renderListItemCheckbox(item) {
    return b `<oscd-checkbox
    slot="start"
    ?checked=${item.selected}
    ?disabled=${item.disabled}
  ></oscd-checkbox>`;
}
function renderListItemRadioButton(item, name) {
    return b `<oscd-radio
    slot="start"
    name=${name}
    ?checked=${item.selected}
    ?disabled=${item.disabled}
  ></oscd-radio>`;
}
/**
 * @tag oscd-selection-list
 *  List component to select from a set of options
 * */
class OscdSelectionList extends FilterListBase {
    constructor() {
        super(...arguments);
        this.multiselect = false;
        // @property({ type: String })
        // name: string =
        //   `oscd-selection-list-${Math.random().toString(36).substr(2, 9)}`;
        this.items = [];
    }
    get selectedElements() {
        const elements = [];
        this.items.forEach(item => {
            if (item.selected && item.attachedElement) {
                elements.push(item.attachedElement);
            }
        });
        return elements;
    }
    renderListItem(item) {
        return b `<oscd-list-item
      type="button"
      @click=${() => {
            item.selected = !item.selected;
            if (!this.multiselect) {
                this.items.forEach(i => {
                    if (i !== item) {
                        i.selected = false;
                    }
                });
            }
            this.dispatchEvent(newSelectionListChangeEvent(this.selectedElements));
            this.requestUpdate('items');
        }}
      class="${e({
            hidden: !this.searchRegex?.test(`${item.headline} ${item.supportingText ?? ''}`),
        })}"
    >
      ${this.multiselect
            ? renderListItemCheckbox(item)
            : renderListItemRadioButton(item, 'radio-group')}

      <div slot="headline">${item.headline}</div>
      ${item.supportingText
            ? b `<div slot="supporting-text">${item.supportingText}</div>`
            : b ``}
    </oscd-list-item>`;
    }
    render() {
        return b `<section>
      ${this.renderSearchField()}
      <oscd-list class="listitems">
        ${this.items.map(item => this.renderListItem(item))}</oscd-list
      >
    </section>`;
    }
}
OscdSelectionList.scopedElements = {
    'oscd-outlined-text-field': OscdOutlinedTextField,
    'oscd-icon': OscdIcon,
    'oscd-list': OscdList,
    'oscd-list-item': OscdListItem,
    'oscd-checkbox': OscdCheckbox,
    'oscd-radio': OscdRadio,
};
OscdSelectionList.styles = i$7 `
    section {
      display: flex;
      flex-direction: column;
    }

    oscd-outlined-text-field {
      background-color: var(--md-sys-color-surface, #fef7ff);
      --md-outlined-text-field-container-shape: 32px;
      padding: 8px;
    }

    .listitems {
      flex: auto;
    }

    oscd-radio {
      --md-radio-hover-state-layer-opacity: 0;
      --md-radio-pressed-state-layer-opacity: 0;
      --md-radio-selected-hover-state-layer-opacity: 0;
      --md-radio-selected-pressed-state-layer-opacity: 0;
    }

    oscd-checkbox {
      --md-checkbox-hover-state-layer-opacity: 0;
      --md-checkbox-pressed-state-layer-opacity: 0;
      --md-checkbox-selected-hover-state-layer-opacity: 0;
      --md-checkbox-selected-pressed-state-layer-opacity: 0;
    }

    .hidden {
      display: none;
    }
  `;
__decorate([
    n$3({ type: Boolean })
], OscdSelectionList.prototype, "multiselect", void 0);
__decorate([
    n$3({ type: Array })
], OscdSelectionList.prototype, "items", void 0);
__decorate([
    n$3({ type: Array })
], OscdSelectionList.prototype, "selectedElements", null);
function newSelectionListChangeEvent(selectedElements, eventInitDict) {
    return new CustomEvent('selection-list-change', {
        bubbles: true,
        composed: true,
        ...eventInitDict,
        detail: { selectedElements, ...eventInitDict?.detail },
    });
}

/**
 * Internal base class for `oscd-tree-item`.
 *
 * ## Leading icon alignment
 *
 * A leading icon (the `start` slot) is rendered inside a fixed-width leading
 * column whose size defaults to the tree's `--oscd-tree-indent-step`. This is
 * deliberate: it makes a leading icon occupy **exactly one indent step**, so an
 * icon-less descendant — which the tree indents by one step per level — lands
 * its text precisely under its iconed ancestor's text, at any depth, with no
 * per-row tuning. Rows without a leading icon collapse the column to zero and
 * rely on the tree's indentation instead.
 *
 * Because the leading column and the indent step are fused, a single knob
 * (`--oscd-tree-indent-step`) controls both per-level indentation and the
 * leading icon column, and the two can never drift out of alignment. Set it
 * large enough to comfortably hold the icon (e.g. `40px`); the visual gap
 * between the icon and the text is the leftover space, `step - icon size`.
 *
 * @slot start - Optional leading content such as an icon.
 * @slot headline - Primary row text.
 * @slot supporting-text - Secondary row text.
 * @slot end - Optional trailing content such as status or actions.
 */
class TreeItem extends i$4 {
    constructor() {
        super(...arguments);
        /**
         * Whether the row content should render selected styling.
         */
        this.selected = false;
        /**
         * Whether the row content represents the active tree row.
         */
        this.active = false;
        /**
         * Whether the row content should render disabled styling.
         */
        this.disabled = false;
        /**
         * Whether the `start` slot currently holds a leading icon. Drives the
         * fixed-width leading column so icon-less rows collapse it to zero.
         */
        this.hasLeadingContent = false;
    }
    connectedCallback() {
        super.connectedCallback();
        // Set the initial state synchronously from light-DOM children so the
        // first render already has the correct leading-column width — the
        // `slotchange` event only fires post-render and races the first paint,
        // letting an unclipped icon spill into `.text` for one frame.
        this.hasLeadingContent = this.querySelector('[slot="start"]') !== null;
    }
    handleStartSlotChange(event) {
        // Keeps state correct if `start`'s content changes after connect (e.g. a
        // reused row whose `renderItem` conditionally adds/removes an icon).
        this.hasLeadingContent =
            event.target.assignedElements({ flatten: true })
                .length > 0;
    }
    render() {
        return b `<div part="content" class="content">
      <span
        part="leading"
        class="leading ${this.hasLeadingContent ? 'has-leading' : ''}"
      >
        <slot name="start" @slotchange=${this.handleStartSlotChange}></slot>
      </span>
      <span part="text" class="text">
        <span part="headline" class="headline"
          ><slot name="headline"></slot
        ></span>
        <span part="supporting-text" class="supporting-text"
          ><slot name="supporting-text"></slot
        ></span>
      </span>
      <slot name="end"></slot>
    </div>`;
    }
}
TreeItem.styles = i$7 `
    :host {
      box-sizing: border-box;
      display: block;
      min-width: 0;
      color: inherit;
    }

    :host([disabled]) {
      opacity: var(--md-list-item-disabled-opacity, 0.3);
    }

    :host([selected]) .headline {
      /*
       * Falls back to currentColor (like the resting ".headline" rule below)
       * rather than a fixed on-surface ink, so the label tracks whatever
       * "color" the containing row already resolved to for its selected
       * state (e.g. Tree.js's selected/active row rules), instead of
       * silently overriding it with an unrelated fixed color.
       */
      color: var(
        --oscd-tree-item-selected-headline-color,
        var(--md-list-item-label-text-color, currentColor)
      );
      font-weight: var(
        --oscd-tree-item-selected-headline-weight,
        var(--md-sys-typescale-body-large-weight-prominent, 500)
      );
    }

    /*
     * Like the selected headline rule above, falls back to currentColor so
     * the supporting text also tracks the row's selected-state color instead
     * of staying pinned to the resting on-surface-variant grey (which has
     * poor contrast once the row's background switches to a selected color).
     */
    :host([selected]) .supporting-text {
      color: var(
        --oscd-tree-item-selected-supporting-text-color,
        var(--md-list-item-supporting-text-color, currentColor)
      );
    }

    .content {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      min-width: 0;
      min-height: var(--md-list-item-one-line-container-height, 56px);
      width: 100%;
    }

    /*
     * Leading icon column. A leading icon occupies exactly one indent step so
     * that icon-less descendants (indented one step per level by the tree)
     * align their text under an iconed ancestor's text at any depth. Rows
     * without a leading icon collapse this column to zero and rely on the
     * tree's indentation instead. Override --oscd-tree-item-leading-size only
     * if you must decouple it from --oscd-tree-indent-step; keeping them equal
     * is what preserves the alignment.
     */
    .leading {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex: 0 0 auto;
      inline-size: 0;
    }

    .leading.has-leading {
      inline-size: var(
        --oscd-tree-item-leading-size,
        var(--oscd-tree-indent-step, 24px)
      );
    }

    .text {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      justify-content: center;
      min-width: 0;
    }

    .headline,
    .supporting-text {
      display: block;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .headline {
      color: var(--md-list-item-label-text-color, currentColor);
      font-family: var(--md-list-item-label-text-font, inherit);
      font-size: var(--md-list-item-label-text-size, 1rem);
      font-weight: var(--md-list-item-label-text-weight, 400);
      line-height: var(--md-list-item-label-text-line-height, 1.5rem);
    }

    .supporting-text {
      color: var(
        --md-list-item-supporting-text-color,
        var(--md-sys-color-on-surface-variant, #49454f)
      );
      font-family: var(--md-list-item-supporting-text-font, inherit);
      font-size: var(--md-list-item-supporting-text-size, 0.875rem);
      font-weight: var(--md-list-item-supporting-text-weight, 400);
      line-height: var(--md-list-item-supporting-text-line-height, 1.25rem);
    }

    ::slotted([slot='start']),
    ::slotted([slot='end']) {
      flex: 0 0 auto;
    }

    ::slotted([slot='start']) {
      color: var(
        --md-list-item-leading-icon-color,
        var(--md-sys-color-on-surface-variant, #49454f)
      );
    }

    ::slotted([slot='end']) {
      margin-inline-start: var(--oscd-tree-item-gap, 16px);
      color: var(
        --md-list-item-trailing-icon-color,
        var(--md-sys-color-on-surface-variant, #49454f)
      );
    }
  `;
__decorate([
    n$3({ type: Boolean, reflect: true })
], TreeItem.prototype, "selected", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], TreeItem.prototype, "active", void 0);
__decorate([
    n$3({ type: Boolean, reflect: true })
], TreeItem.prototype, "disabled", void 0);
__decorate([
    r$2()
], TreeItem.prototype, "hasLeadingContent", void 0);

/**
 * Default content component for rows rendered inside `oscd-tree`.
 *
 * `oscd-tree-item` is intended to be returned from an `oscd-tree` `renderItem`
 * callback. It renders the caller-visible row content only. The parent
 * `oscd-tree` owns the tree row frame, indentation, expand/collapse affordance,
 * selection affordance, keyboard handling, and ARIA attributes.
 *
 * Use the `headline` slot for the primary label, `supporting-text` for
 * secondary/path text, `start` for an optional leading icon, and `end` for
 * optional trailing status or actions.
 *
 * ## Leading icon alignment
 *
 * When only some rows carry a leading icon (e.g. top-level rows have icons but
 * their children do not), you usually want the icon-less children's text to sit
 * directly under their iconed parent's text. This works automatically: a
 * leading icon occupies exactly one indent step, so an icon-less child —
 * indented one step by the tree — aligns its text with the parent's, at any
 * depth, with no per-row configuration.
 *
 * The leading icon column and the per-level indentation are both driven by the
 * single `--oscd-tree-indent-step` custom property (default `24px`), so they can
 * never drift out of alignment. Set it large enough to comfortably hold your
 * icon — e.g. `--oscd-tree-indent-step: 40px` — which also widens the gap
 * between the icon and the text (the gap is `step - icon size`). The rarely
 * needed `--oscd-tree-item-leading-size` can decouple just the column width, but
 * keeping it equal to the indent step is what preserves the alignment.
 *
 * Text and icon styling uses the embedded `--md-list-item-*` tokens directly.
 *
 * @example
 * ```ts
 * const renderItem = ({ node, selected, active, disabled }) => html`
 *   <oscd-tree-item
 *     ?selected=${selected}
 *     ?active=${active}
 *     ?disabled=${disabled}
 *   >
 *     <oscd-icon slot="start">lan</oscd-icon>
 *     <span slot="headline">${node.label}</span>
 *     <span slot="supporting-text">${node.path}</span>
 *     ${selected ? html`<oscd-icon slot="end">check</oscd-icon>` : ''}
 *   </oscd-tree-item>
 * `;
 * ```
 *
 * @slot start - Optional leading content such as an icon.
 * @slot headline - Primary row text.
 * @slot supporting-text - Secondary row text.
 * @slot end - Optional trailing content such as status or actions.
 *
 * @tagname oscd-tree-item
 */
class OscdTreeItem extends TreeItem {
}

const fallbackRenderItem = ({ node, id, selected, active, disabled, }) => b `<oscd-tree-item
    ?selected=${selected}
    ?active=${active}
    ?disabled=${disabled}
  >
    <span slot="headline">${'label' in node ? String(node.label) : id}</span>
  </oscd-tree-item>`;
const idSeparator = '/';
function childState(node) {
    if (node.children === undefined) {
        return 'unknown';
    }
    return node.children.length > 0 ? 'branch' : 'leaf';
}
/**
 * Internal base class for `oscd-tree`.
 */
class Tree extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        /**
         * Structured tree data to render.
         */
        this.data = [];
        /**
         * Selected node identifiers.
         *
         * This state is controlled by the caller and may be persisted outside the
         * tree, but it must be scoped to the data set/context that produced the IDs.
         * Reset or re-key persisted selected IDs when `data` changes to a different
         * logical tree, otherwise unrelated nodes with matching IDs may appear
         * selected.
         */
        this.selectedIds = [];
        /**
         * Expanded node identifiers.
         *
         * This state is controlled by the caller and may be persisted outside the
         * tree, but it must be scoped to the data set/context that produced the IDs.
         * Reset or re-key persisted expanded IDs when `data` changes to a different
         * logical tree, otherwise unrelated nodes with matching IDs may appear
         * expanded.
         */
        this.expandedIds = [];
        /**
         * Selection behavior.
         */
        this.selectionMode = 'none';
        /**
         * Icon shown on the expand/collapse toggle when a branch is collapsed.
         *
         * Any icon name understood by `oscd-icon` (a Material Symbol name or a
         * registered SCL icon) may be used. Defaults to `chevron_right`.
         */
        this.collapseIcon = 'chevron_right';
        /**
         * Icon shown on the expand/collapse toggle when a branch is expanded.
         *
         * Any icon name understood by `oscd-icon` (a Material Symbol name or a
         * registered SCL icon) may be used. Defaults to `expand_more`.
         */
        this.expandIcon = 'expand_more';
        /**
         * Placement of the expand/collapse toggle within each row.
         *
         * `'leading'` (default) renders the toggle before the row content.
         * `'trailing'` renders it after the content, right-aligned so the toggles
         * line up on the trailing edge regardless of nesting depth. Keyboard
         * expansion (`ArrowRight`/`ArrowLeft`) is unaffected by this option.
         */
        this.togglePosition = 'leading';
        /** Currently active keyboard row. Controlled by the caller when needed. */
        this.activeId = null;
        /**
         * Whether focusing the active row should scroll it into the nearest
         * scrollable ancestor when it is outside the visible area.
         */
        this.scrollActiveIntoView = true;
        this.handleTreeKeyDown = (event) => {
            if (event.target !== this) {
                return;
            }
            const rows = this.navigableRows();
            const rowIndex = rows.findIndex(row => row.id === this.activeId);
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    this.navigateNext(rows, rowIndex);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    this.navigatePrevious(rows, rowIndex);
                    break;
                case 'Home':
                    event.preventDefault();
                    this.activeId = this.getFirstNodeId();
                    break;
                case 'End':
                    event.preventDefault();
                    this.activeId = this.getLastNodeId();
                    break;
                case 'Enter': {
                    const activeRow = rows[rowIndex];
                    if (activeRow) {
                        event.preventDefault();
                        this.toggleSelection(activeRow);
                    }
                    break;
                }
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.tabIndex = 0;
        this.addEventListener('keydown', this.handleTreeKeyDown);
    }
    disconnectedCallback() {
        this.removeEventListener('keydown', this.handleTreeKeyDown);
        super.disconnectedCallback();
    }
    willUpdate(changedProperties) {
        if (!changedProperties.has('activeId') || this.activeId === null) {
            return;
        }
        const isNavigable = this.navigableRows().some(row => row.id === this.activeId);
        if (!isNavigable) {
            console.warn(`Ignoring invalid oscd-tree activeId: ${this.activeId}`);
            this.activeId = changedProperties.get('activeId') ?? null;
        }
    }
    /** Returns the first visible, enabled row ID, or null when none exists. */
    getFirstNodeId() {
        return this.navigableRows()[0]?.id ?? null;
    }
    /** Returns the last visible, enabled row ID, or null when none exists. */
    getLastNodeId() {
        const rows = this.navigableRows();
        return rows[rows.length - 1]?.id ?? null;
    }
    /**
     * Expands a node by ID.
     */
    expand(id) {
        if (!this.expandedIds.includes(id)) {
            this.setExpandedIds([...this.expandedIds, id]);
        }
    }
    /**
     * Collapses a node by ID.
     */
    collapse(id) {
        if (this.expandedIds.includes(id)) {
            this.setExpandedIds(this.expandedIds.filter(expandedId => expandedId !== id));
        }
    }
    /**
     * Toggles a node expansion state by ID.
     */
    toggle(id) {
        const row = this.visibleRows().find(candidate => candidate.id === id);
        if (!row) {
            return;
        }
        this.toggleExpansion(row);
    }
    rowId(node, indexPath) {
        return (node.id ??
            this.getNodeId?.(node, indexPath) ??
            indexPath.join(idSeparator));
    }
    visibleRows() {
        const expandedIds = new Set(this.expandedIds);
        const rows = [];
        const walk = (nodes, level, parentIds, indexPath) => {
            if (!nodes) {
                return;
            }
            const ariaSetSize = nodes.length;
            nodes.forEach((node, index) => {
                const childIndexPath = [...indexPath, index];
                const id = this.rowId(node, childIndexPath);
                rows.push({
                    node,
                    id,
                    htmlId: `tree-row-${rows.length}`,
                    level,
                    parentIds,
                    ariaPositionInSet: index + 1,
                    ariaSetSize,
                });
                if (expandedIds.has(id) && node.children) {
                    walk(node.children, level + 1, [...parentIds, id], childIndexPath);
                }
            });
        };
        walk(this.data, 1, [], []);
        return rows;
    }
    navigableRows() {
        return this.visibleRows().filter(row => !this.isRowDisabled(row));
    }
    renderContext(row) {
        const selected = this.selectedIds.includes(row.id);
        return {
            node: row.node,
            id: row.id,
            level: row.level,
            expanded: this.expandedIds.includes(row.id),
            selected,
            active: this.activeId === row.id,
            childrenState: childState(row.node),
            selectable: this.selectionMode !== 'none' && this.isRowSelectable(row),
            disabled: this.isRowDisabled(row),
        };
    }
    accessibleLabel(row) {
        if (this.getNodeLabel) {
            return this.getNodeLabel(row.node, row.id);
        }
        if ('label' in row.node && row.node.label !== undefined) {
            return String(row.node.label);
        }
        return row.id;
    }
    isRowSelectable(row) {
        return this.isSelectable ? this.isSelectable(row.node) : true;
    }
    isRowDisabled(row) {
        return this.isDisabled ? this.isDisabled(row.node) : false;
    }
    setExpandedIds(expandedIds) {
        this.expandedIds = expandedIds;
        this.dispatchEvent(new CustomEvent('expanded-ids-changed', {
            detail: { expandedIds },
        }));
    }
    setSelectedIds(selectedIds, targetNode) {
        const previousSelectedIds = this.selectedIds;
        this.selectedIds = selectedIds;
        this.dispatchEvent(new CustomEvent('selected-ids-changed', {
            detail: {
                selectedIds,
                previousSelectedIds,
                targetNode,
            },
        }));
    }
    fireNodeEvent(name, row, options) {
        const event = new CustomEvent(name, {
            bubbles: true,
            cancelable: options?.cancelable ?? false,
            detail: {
                node: row.node,
                id: row.id,
            },
        });
        return this.dispatchEvent(event);
    }
    toggleExpansion(row) {
        if (this.isRowDisabled(row) || childState(row.node) === 'leaf') {
            return;
        }
        const expanded = this.expandedIds.includes(row.id);
        if (expanded) {
            this.setExpandedIds(this.expandedIds.filter(expandedId => expandedId !== row.id));
            this.fireNodeEvent('node-collapse', row);
            this.fireNodeEvent('node-toggle', row);
            return;
        }
        if (!this.fireNodeEvent('node-expand', row, { cancelable: true })) {
            return;
        }
        this.setExpandedIds([...this.expandedIds, row.id]);
        this.fireNodeEvent('node-toggle', row);
    }
    toggleSelection(row) {
        if (this.selectionMode === 'none' ||
            this.isRowDisabled(row) ||
            !this.isRowSelectable(row)) {
            return;
        }
        if (this.selectionMode === 'single') {
            this.setSelectedIds([row.id], row.node);
            return;
        }
        const selected = this.selectedIds.includes(row.id);
        this.setSelectedIds(selected
            ? this.selectedIds.filter(selectedId => selectedId !== row.id)
            : [...this.selectedIds, row.id], row.node);
    }
    activateRow(row) {
        this.activeId = row.id;
        this.fireNodeEvent('node-click', row);
    }
    handleRowClick(row, event) {
        if (this.isRowDisabled(row)) {
            event.preventDefault();
            return;
        }
        this.activateRow(row);
        if (childState(row.node) !== 'leaf') {
            this.toggleExpansion(row);
            return;
        }
        this.toggleSelection(row);
    }
    handleToggleClick(row, event) {
        event.stopPropagation();
        this.activeId = row.id;
        this.toggleExpansion(row);
    }
    handleKeyDown(row, event) {
        event.stopPropagation();
        const rows = this.navigableRows();
        const rowIndex = rows.findIndex(candidate => candidate.id === row.id);
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                this.navigateNext(rows, rowIndex);
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.navigatePrevious(rows, rowIndex);
                break;
            case 'Home':
                event.preventDefault();
                this.activeId = this.getFirstNodeId();
                break;
            case 'End':
                event.preventDefault();
                this.activeId = this.getLastNodeId();
                break;
            case 'ArrowRight':
                event.preventDefault();
                this.stepIn(row, rows, rowIndex);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                this.stepOut(row);
                break;
            case 'Enter':
                event.preventDefault();
                this.activeId = row.id;
                this.toggleSelection(row);
                break;
            case ' ':
                event.preventDefault();
                this.toggleSelection(row);
                break;
        }
    }
    navigateNext(rows, rowIndex) {
        const nextRow = rows[rowIndex < 0 ? 0 : rowIndex + 1];
        if (!nextRow) {
            this.dispatchEvent(new CustomEvent('navigation-boundary', {
                detail: { direction: 'last' },
            }));
            return;
        }
        this.activeId = nextRow.id;
        this.dispatchEvent(new CustomEvent('active-changed', {
            detail: { activeId: nextRow.id },
        }));
    }
    navigatePrevious(rows, rowIndex) {
        const previousRow = rows[rowIndex < 0 ? rows.length - 1 : rowIndex - 1];
        if (!previousRow) {
            this.dispatchEvent(new CustomEvent('navigation-boundary', {
                detail: { direction: 'first' },
            }));
            return;
        }
        this.activeId = previousRow.id;
        this.dispatchEvent(new CustomEvent('active-changed', {
            detail: { activeId: previousRow.id },
        }));
    }
    stepIn(row, rows, rowIndex) {
        const state = childState(row.node);
        if (state === 'leaf') {
            return;
        }
        if (!this.expandedIds.includes(row.id)) {
            this.toggleExpansion(row);
            return;
        }
        const nextRow = rows[rowIndex + 1];
        if (nextRow?.parentIds[nextRow.parentIds.length - 1] === row.id) {
            this.activeId = nextRow.id;
        }
    }
    stepOut(row) {
        if (this.expandedIds.includes(row.id)) {
            this.toggleExpansion(row);
            return;
        }
        const parentId = row.parentIds[row.parentIds.length - 1];
        if (parentId) {
            this.activeId = parentId;
        }
    }
    renderSelection(row) {
        if (this.selectionMode !== 'multiple' || !this.isRowSelectable(row)) {
            return A;
        }
        const selected = this.selectedIds.includes(row.id);
        return b `<span
      part="selection"
      class="selection"
      aria-hidden="true"
      data-selected=${selected ? 'true' : 'false'}
      ><oscd-checkbox
        tabindex="-1"
        ?checked=${selected}
        ?disabled=${this.isRowDisabled(row)}
      ></oscd-checkbox
    ></span>`;
    }
    renderToggle(row, context) {
        const expandable = context.childrenState !== 'leaf';
        const expanded = context.expanded;
        if (!expandable && this.renderLeafAccessory) {
            const accessory = this.renderLeafAccessory(context);
            if (accessory !== A && accessory != null && accessory !== false) {
                return b `<div
          part="accessory"
          class="accessory"
          @click=${(event) => event.stopPropagation()}
          @keydown=${(event) => this.handleAccessoryKeydown(event)}
        >
          ${accessory}
        </div>`;
            }
        }
        return b `<button
      part="toggle"
      class="toggle ${expandable ? '' : 'leaf-toggle'}"
      ?disabled=${!expandable || context.disabled}
      aria-label=${expanded ? 'Collapse' : 'Expand'}
      tabindex="-1"
      @click=${(event) => this.handleToggleClick(row, event)}
    >
      ${expandable
            ? b `<oscd-icon
              >${expanded ? this.expandIcon : this.collapseIcon}</oscd-icon
            >`
            : A}
    </button>`;
    }
    // Keep Enter/Space activations of a leaf accessory (e.g. a pin button) from
    // bubbling to the row's keyboard handler; arrow keys still bubble so tree
    // navigation continues to work while an accessory is focused.
    // eslint-disable-next-line class-methods-use-this
    handleAccessoryKeydown(event) {
        if (event.key === 'Enter' ||
            event.key === ' ' ||
            event.key === 'Spacebar') {
            event.stopPropagation();
        }
    }
    renderRow(row) {
        const context = this.renderContext(row);
        const state = context.childrenState;
        const selected = context.selected;
        const disabled = context.disabled;
        const active = context.active;
        return b `<div
      id=${row.htmlId}
      part="row"
      class="row"
      role="treeitem"
      tabindex=${active ? '0' : '-1'}
      aria-level=${row.level}
      aria-posinset=${row.ariaPositionInSet}
      aria-setsize=${row.ariaSetSize}
      aria-label=${this.accessibleLabel(row)}
      aria-expanded=${state === 'leaf' ? A : context.expanded}
      aria-selected=${context.selectable ? selected : A}
      aria-disabled=${disabled ? 'true' : A}
      data-active=${active ? 'true' : 'false'}
      data-selected=${selected ? 'true' : 'false'}
      data-selection-mode=${this.selectionMode}
      data-disabled=${disabled ? 'true' : 'false'}
      style=${`--_level: ${row.level};`}
      @click=${(event) => this.handleRowClick(row, event)}
      @keydown=${(event) => this.handleKeyDown(row, event)}
    >
      <oscd-ripple for=${row.htmlId} ?disabled=${disabled}></oscd-ripple>
      <oscd-focus-ring for=${row.htmlId} inward></oscd-focus-ring>
      <span part="indent" class="indent" aria-hidden="true"></span>
      ${this.togglePosition === 'leading'
            ? this.renderToggle(row, context)
            : A}
      ${this.renderSelection(row)}
      <span part="content" class="content"
        >${(this.renderItem ?? fallbackRenderItem)(context)}</span
      >
      ${this.togglePosition === 'trailing'
            ? this.renderToggle(row, context)
            : A}
    </div>`;
    }
    updated() {
        const focusedAccessory = this.renderRoot instanceof ShadowRoot
            ? this.renderRoot.activeElement?.closest('.accessory')
            : null;
        if (focusedAccessory) {
            return;
        }
        const activeRow = this.renderRoot.querySelector('.row[data-active="true"]');
        if (activeRow && this.matches(':focus-within')) {
            activeRow.focus();
            if (this.scrollActiveIntoView) {
                activeRow.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
        }
    }
    render() {
        const rows = this.visibleRows();
        return b `<div part="tree" class="tree" role="tree">
      ${rows.map(row => this.renderRow(row))}
    </div>`;
    }
}
Tree.scopedElements = {
    'oscd-checkbox': OscdCheckbox,
    'oscd-focus-ring': OscdFocusRing,
    'oscd-icon': OscdIcon,
    'oscd-ripple': OscdRipple,
    'oscd-tree-item': OscdTreeItem,
};
Tree.styles = i$7 `
    :host {
      display: block;
      /*
       * Allow the tree to shrink below its content's intrinsic (max-content)
       * width when placed in a flex or grid container. Without this, a single
       * long row label leaks its max-content width up the layout chain and
       * sizes every row to it, pushing trailing toggles/accessories out of a
       * width-constrained parent and defeating the per-row ellipsis. Keeping
       * this on the host makes the tree a well-behaved flex/grid child by
       * default for every consumer.
       */
      min-width: 0;
      outline: none;
    }

    .tree {
      display: flex;
      flex-direction: column;
      min-width: 0;
      color: var(--oscd-tree-color, var(--md-sys-color-on-surface, #1d1b20));
      font-family: var(
        --oscd-tree-font-family,
        var(--md-sys-typescale-body-large-font, Roboto)
      );
      gap: var(--oscd-tree-row-gap, 0);
    }

    .row {
      position: relative;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      min-width: 0;
      min-height: var(--oscd-tree-row-height, 44px);
      border-radius: var(
        --oscd-tree-row-shape,
        var(--md-sys-shape-corner-small, 4px)
      );
      color: inherit;
      cursor: default;
      outline: none;
      padding-inline-start: var(--oscd-tree-row-padding-start, 16px);
      padding-inline-end: var(--oscd-tree-row-padding-end, 8px);
      user-select: none;
    }

    :host(:focus-within) .row[data-active='true'] {
      outline: var(--oscd-tree-row-active-border-width, 1px) solid
        var(--oscd-tree-row-active-border-color, currentColor);
      outline-offset: -1px;
      color: var(--oscd-tree-row-active-text-color, inherit);
    }

    oscd-ripple,
    oscd-focus-ring {
      border-radius: var(
        --oscd-tree-row-shape,
        var(--md-sys-shape-corner-small, 4px)
      );
    }

    oscd-focus-ring {
      z-index: 1;
      --md-focus-ring-shape: var(
        --oscd-tree-row-shape,
        var(--md-sys-shape-corner-small, 4px)
      );
    }

    .row[data-disabled='true'] {
      cursor: default;
    }

    .row[data-selection-mode='single'][data-selected='true'] {
      color: var(
        --oscd-tree-row-selected-text-color,
        var(--md-sys-color-on-primary, #fff)
      );
      background: var(
        --oscd-tree-row-selected-color,
        var(--md-sys-color-primary, #6750a4)
      );
    }

    .row[data-selection-mode='single'][data-selected='true']:hover:not(
        [data-disabled='true']
      ) {
      background: var(
        --oscd-tree-row-selected-hover-color,
        var(
          --oscd-tree-row-selected-color,
          var(--md-sys-color-primary, #6750a4)
        )
      );
    }

    /*
     * When a selected row is also the keyboard-active row while the tree has
     * focus, the ":host(:focus-within) .row[data-active='true']" rule above
     * has higher specificity than the selected-row rule and would otherwise
     * win the cascade for "color", overriding the selected text color with
     * "inherit" while leaving the selected background untouched. Restate the
     * selected text color here, at higher specificity than both rules, so a
     * focused+selected row keeps its selected-background/selected-foreground
     * pairing while still showing the active outline.
     */
    :host(:focus-within)
      .row[data-selection-mode='single'][data-selected='true'][data-active='true'] {
      color: var(
        --oscd-tree-row-selected-text-color,
        var(--md-sys-color-on-primary, #fff)
      );
    }

    .indent {
      flex: 0 0
        calc(max(0, var(--_level) - 1) * var(--oscd-tree-indent-step, 24px));
      inline-size: calc(
        max(0, var(--_level) - 1) * var(--oscd-tree-indent-step, 24px)
      );
    }

    .toggle {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 var(--oscd-tree-toggle-size, 32px);
      inline-size: var(--oscd-tree-toggle-size, 32px);
      block-size: var(--oscd-tree-toggle-size, 32px);
      border: 0;
      border-radius: 50%;
      padding: 0;
      color: inherit;
      background: transparent;
      cursor: pointer;
    }

    .leaf-toggle {
      flex-basis: var(
        --oscd-tree-leaf-toggle-size,
        var(--oscd-tree-toggle-size, 32px)
      );
      inline-size: var(
        --oscd-tree-leaf-toggle-size,
        var(--oscd-tree-toggle-size, 32px)
      );
    }

    .toggle:disabled {
      cursor: default;
      opacity: 0;
    }

    :host([toggle-position='trailing']) .toggle {
      margin-inline-start: var(--oscd-tree-trailing-toggle-gap, 4px);
    }

    :host([toggle-position='trailing']) .leaf-toggle {
      margin-inline-start: var(
        --oscd-tree-leaf-toggle-gap,
        var(--oscd-tree-trailing-toggle-gap, 4px)
      );
    }

    .accessory {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 var(--oscd-tree-toggle-size, 32px);
      inline-size: var(--oscd-tree-toggle-size, 32px);
      block-size: var(--oscd-tree-toggle-size, 32px);
      /*
       * Accessory visibility at rest. Defaults to fully opaque so accessories
       * are always shown; consumers can set --oscd-tree-accessory-rest-opacity
       * to 0 for a reveal-on-interaction pattern. Row hover and keyboard focus
       * within the accessory always force it fully visible so it stays
       * discoverable and keyboard-accessible.
       */
      opacity: var(--oscd-tree-accessory-rest-opacity, 1);
      transition: opacity 0.1s ease-in-out;
    }

    .row:hover .accessory,
    .accessory:focus-within {
      opacity: 1;
    }

    :host([toggle-position='trailing']) .accessory {
      margin-inline-start: var(--oscd-tree-trailing-toggle-gap, 4px);
    }

    .accessory button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      inline-size: var(--oscd-tree-toggle-size, 32px);
      block-size: var(--oscd-tree-toggle-size, 32px);
      border: 0;
      border-radius: 50%;
      padding: 0;
      color: inherit;
      background: transparent;
      cursor: pointer;
    }

    .selection {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 var(--oscd-tree-selection-size, 48px);
      inline-size: var(--oscd-tree-selection-size, 48px);
      pointer-events: none;
    }

    .selection oscd-checkbox {
      pointer-events: none;
      --md-focus-ring-width: 0;
      --md-ripple-hover-opacity: 0;
      --md-ripple-pressed-opacity: 0;
    }

    .content {
      display: block;
      flex: 1 1 auto;
      min-width: 0;
    }
  `;
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "data", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "selectedIds", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "expandedIds", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "renderItem", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "renderLeafAccessory", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "getNodeId", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "getNodeLabel", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "isSelectable", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "isDisabled", void 0);
__decorate([
    n$3()
], Tree.prototype, "selectionMode", void 0);
__decorate([
    n$3({ attribute: 'collapse-icon' })
], Tree.prototype, "collapseIcon", void 0);
__decorate([
    n$3({ attribute: 'expand-icon' })
], Tree.prototype, "expandIcon", void 0);
__decorate([
    n$3({ reflect: true, attribute: 'toggle-position' })
], Tree.prototype, "togglePosition", void 0);
__decorate([
    n$3({ attribute: false })
], Tree.prototype, "activeId", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'scroll-active-into-view' })
], Tree.prototype, "scrollActiveIntoView", void 0);

/**
 * Displays hierarchical data as an accessible, keyboard-navigable tree.
 *
 * `oscd-tree` is data-driven: callers provide nested node data through `data`,
 * and the tree manages expansion, selection, active-row navigation, row
 * indentation, and ARIA attributes. Row content stays flexible through the
 * `renderItem` callback.
 *
 * The tree owns the row frame. This includes indentation, expand/collapse
 * affordances, selection affordances, keyboard handling, focus handling, and
 * accessibility attributes. `renderItem` only supplies the content rendered
 * inside each row frame.
 *
 * The expand/collapse toggle is customizable: `collapseIcon` and `expandIcon`
 * override the icon names (defaults `chevron_right` / `expand_more`), and
 * `togglePosition` places the toggle either `'leading'` (default) or
 * `'trailing'`, in which case toggles line up on the row's trailing edge
 * regardless of nesting depth. Keyboard expansion is unaffected by the toggle
 * position.
 *
 * Leaf rows have no toggle. `renderLeafAccessory` can render an interactive
 * accessory (such as a pin/unpin button) into a leaf row's toggle column so it
 * aligns with the chevrons of expandable rows. The tree isolates pointer and
 * `Enter`/`Space` interaction on the accessory so activating it does not select
 * the row; a returned focusable element adds one tab stop per row.
 *
 * A leading icon (the `start` slot of `oscd-tree-item`) occupies exactly one
 * indent step, so when only some rows have icons (e.g. iconed parents with
 * icon-less children) the children's text aligns automatically under the
 * parent's text at any depth. The single `--oscd-tree-indent-step` property
 * (default `24px`) drives both indentation and the leading icon column; set it
 * large enough to hold your icon (e.g. `40px`) when using leading icons. See
 * {@link OscdTreeItem} for details.
 *
 * Row ripple and focus styling uses the embedded `--md-ripple-*` and
 * `--md-focus-ring-*` tokens directly.
 *
 * Every node may provide a stable `id`. If no ID is supplied, the tree uses
 * `getNodeId` when provided, then falls back to an index-path ID such as
 * `0/1/2`. Index-path IDs are convenient for static demos but are not stable
 * when nodes are inserted, removed, sorted, filtered, or lazily loaded, and
 * should not be persisted.
 *
 * `selectedIds` and `expandedIds` are controlled state. They can be persisted
 * by the caller, but persisted IDs must be scoped to the data set/context that
 * produced them. Reset or re-key those arrays when `data` changes to a
 * different logical tree, otherwise unrelated nodes with matching IDs may
 * appear selected or expanded.
 *
 * `children` has three meanings:
 *
 * - `children === undefined`: children are unknown or not loaded yet.
 * - `children === []`: children are known and the node is a leaf.
 * - `children.length > 0`: children are known and the node is a branch.
 *
 * Expansion of nodes with unknown children can be intercepted with the
 * cancelable `node-expand` event.
 *
 * @example
 * ```ts
 * type Node = TreeNode & {
 *   label: string;
 *   children?: Node[];
 * };
 *
 * const data: Node[] = [
 *   {
 *     id: 'ied:PUB_A',
 *     label: 'PUB_A',
 *     children: [{ id: 'ln:TCTR1', label: 'TCTR1', children: [] }],
 *   },
 * ];
 *
 * html`
 *   <oscd-tree
 *     .data=${data}
 *     .expandedIds=${['ied:PUB_A']}
 *     .renderItem=${({ node }) => html`
 *       <oscd-tree-item>
 *         <span slot="headline">${node.label}</span>
 *       </oscd-tree-item>
 *     `}
 *   ></oscd-tree>
 * `;
 * ```
 *
 * @fires selected-ids-changed - Fired when user interaction changes selected IDs.
 * @fires expanded-ids-changed - Fired when expansion state changes.
 * @fires node-click - Fired when a row is clicked.
 * @fires node-expand - Cancelable event fired before a row expands.
 * @fires node-collapse - Fired after a row collapses.
 * @fires node-toggle - Fired after a row expansion state toggles.
 *
 * @tagname oscd-tree
 */
class OscdTree extends Tree {
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./button/internal/shared-styles.css.
const styles$3 = i$7 `:host{border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-start-radius:var(--_container-shape-end-start);border-end-end-radius:var(--_container-shape-end-end);box-sizing:border-box;cursor:pointer;display:inline-flex;gap:8px;min-height:var(--_container-height);outline:none;padding-block:calc((var(--_container-height) - max(var(--_label-text-line-height),var(--_icon-size)))/2);padding-inline-start:var(--_leading-space);padding-inline-end:var(--_trailing-space);place-content:center;place-items:center;position:relative;font-family:var(--_label-text-font);font-size:var(--_label-text-size);line-height:var(--_label-text-line-height);font-weight:var(--_label-text-weight);text-overflow:ellipsis;text-wrap:nowrap;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);vertical-align:top;--md-ripple-hover-color: var(--_hover-state-layer-color);--md-ripple-pressed-color: var(--_pressed-state-layer-color);--md-ripple-hover-opacity: var(--_hover-state-layer-opacity);--md-ripple-pressed-opacity: var(--_pressed-state-layer-opacity)}md-focus-ring{--md-focus-ring-shape-start-start: var(--_container-shape-start-start);--md-focus-ring-shape-start-end: var(--_container-shape-start-end);--md-focus-ring-shape-end-end: var(--_container-shape-end-end);--md-focus-ring-shape-end-start: var(--_container-shape-end-start)}:host(:is([disabled],[soft-disabled])){cursor:default;pointer-events:none}.button{border-radius:inherit;cursor:inherit;display:inline-flex;align-items:center;justify-content:center;border:none;outline:none;-webkit-appearance:none;vertical-align:middle;background:rgba(0,0,0,0);text-decoration:none;min-width:calc(64px - var(--_leading-space) - var(--_trailing-space));width:100%;z-index:0;height:100%;font:inherit;color:var(--_label-text-color);padding:0;gap:inherit;text-transform:inherit}.button::-moz-focus-inner{padding:0;border:0}:host(:hover) .button{color:var(--_hover-label-text-color)}:host(:focus-within) .button{color:var(--_focus-label-text-color)}:host(:active) .button{color:var(--_pressed-label-text-color)}.background{background:var(--_container-color);border-radius:inherit;inset:0;position:absolute}.label{overflow:hidden}:is(.button,.label,.label slot),.label ::slotted(*){text-overflow:inherit}:host(:is([disabled],[soft-disabled])) .label{color:var(--_disabled-label-text-color);opacity:var(--_disabled-label-text-opacity)}:host(:is([disabled],[soft-disabled])) .background{background:var(--_disabled-container-color);opacity:var(--_disabled-container-opacity)}@media(forced-colors: active){.background{border:1px solid CanvasText}:host(:is([disabled],[soft-disabled])){--_disabled-icon-color: GrayText;--_disabled-icon-opacity: 1;--_disabled-container-opacity: 1;--_disabled-label-text-color: GrayText;--_disabled-label-text-opacity: 1}}:host([has-icon]:not([trailing-icon])){padding-inline-start:var(--_with-leading-icon-leading-space);padding-inline-end:var(--_with-leading-icon-trailing-space)}:host([has-icon][trailing-icon]){padding-inline-start:var(--_with-trailing-icon-leading-space);padding-inline-end:var(--_with-trailing-icon-trailing-space)}::slotted([slot=icon]){display:inline-flex;position:relative;writing-mode:horizontal-tb;fill:currentColor;flex-shrink:0;color:var(--_icon-color);font-size:var(--_icon-size);inline-size:var(--_icon-size);block-size:var(--_icon-size)}:host(:hover) ::slotted([slot=icon]){color:var(--_hover-icon-color)}:host(:focus-within) ::slotted([slot=icon]){color:var(--_focus-icon-color)}:host(:active) ::slotted([slot=icon]){color:var(--_pressed-icon-color)}:host(:is([disabled],[soft-disabled])) ::slotted([slot=icon]){color:var(--_disabled-icon-color);opacity:var(--_disabled-icon-opacity)}.touch{position:absolute;top:50%;height:48px;left:0;right:0;transform:translateY(-50%)}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_container-height))/2) 0}:host([touch-target=none]) .touch{display:none}
`;

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const buttonBaseClass = mixinDelegatesAria(mixinFormSubmitter(mixinFormAssociated(mixinElementInternals(i$4))));
/**
 * A button component.
 */
class Button extends buttonBaseClass {
    constructor() {
        super();
        /**
         * Whether or not the button is "soft-disabled" (disabled but still
         * focusable).
         *
         * Use this when a button needs increased visibility when disabled. See
         * https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_disabled_controls
         * for more guidance on when this is needed.
         */
        this.softDisabled = false;
        /**
         * The URL that the link button points to.
         */
        this.href = '';
        /**
         * The filename to use when downloading the linked resource.
         * If not specified, the browser will determine a filename.
         * This is only applicable when the button is used as a link (`href` is set).
         */
        this.download = '';
        /**
         * Where to display the linked `href` URL for a link button. Common options
         * include `_blank` to open in a new tab.
         */
        this.target = '';
        /**
         * Whether to render the icon at the inline end of the label rather than the
         * inline start.
         *
         * _Note:_ Link buttons cannot have trailing icons.
         */
        this.trailingIcon = false;
        /**
         * Whether to display the icon or not.
         */
        this.hasIcon = false;
        {
            this.addEventListener('click', this.handleClick.bind(this));
        }
    }
    focus() {
        this.buttonElement?.focus();
    }
    blur() {
        this.buttonElement?.blur();
    }
    render() {
        const isRippleDisabled = this.disabled || this.softDisabled;
        const buttonOrLink = this.href ? this.renderLink() : this.renderButton();
        // TODO(b/310046938): due to a limitation in focus ring/ripple, we can't use
        // the same ID for different elements, so we change the ID instead.
        const buttonId = this.href ? 'link' : 'button';
        return b `
      ${this.renderElevationOrOutline?.()}
      <div class="background"></div>
      <md-focus-ring part="focus-ring" for=${buttonId}></md-focus-ring>
      <md-ripple
        part="ripple"
        for=${buttonId}
        ?disabled="${isRippleDisabled}"></md-ripple>
      ${buttonOrLink}
    `;
    }
    renderButton() {
        // Needed for closure conformance
        const { ariaLabel, ariaHasPopup, ariaExpanded } = this;
        return b `<button
      id="button"
      class="button"
      ?disabled=${this.disabled}
      aria-disabled=${this.softDisabled || A}
      aria-label="${ariaLabel || A}"
      aria-haspopup="${ariaHasPopup || A}"
      aria-expanded="${ariaExpanded || A}">
      ${this.renderContent()}
    </button>`;
    }
    renderLink() {
        // Needed for closure conformance
        const { ariaLabel, ariaHasPopup, ariaExpanded } = this;
        return b `<a
      id="link"
      class="button"
      aria-label="${ariaLabel || A}"
      aria-haspopup="${ariaHasPopup || A}"
      aria-expanded="${ariaExpanded || A}"
      aria-disabled=${this.disabled || this.softDisabled || A}
      tabindex="${this.disabled && !this.softDisabled ? -1 : A}"
      href=${this.href}
      download=${this.download || A}
      target=${this.target || A}
      >${this.renderContent()}
    </a>`;
    }
    renderContent() {
        const icon = b `<slot
      name="icon"
      @slotchange="${this.handleSlotChange}"></slot>`;
        return b `
      <span class="touch"></span>
      ${this.trailingIcon ? A : icon}
      <span class="label"><slot></slot></span>
      ${this.trailingIcon ? icon : A}
    `;
    }
    handleClick(event) {
        // If the button is soft-disabled or a disabled link, we need to explicitly
        // prevent the click from propagating to other event listeners as well as
        // prevent the default action.
        if (this.softDisabled || (this.disabled && this.href)) {
            event.stopImmediatePropagation();
            event.preventDefault();
            return;
        }
        if (!isActivationClick(event) || !this.buttonElement) {
            return;
        }
        this.focus();
        dispatchActivationClick(this.buttonElement);
    }
    handleSlotChange() {
        this.hasIcon = this.assignedIcons.length > 0;
    }
}
/** @nocollapse */
Button.shadowRootOptions = {
    mode: 'open',
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean, attribute: 'soft-disabled', reflect: true })
], Button.prototype, "softDisabled", void 0);
__decorate([
    n$3()
], Button.prototype, "href", void 0);
__decorate([
    n$3()
], Button.prototype, "download", void 0);
__decorate([
    n$3()
], Button.prototype, "target", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'trailing-icon', reflect: true })
], Button.prototype, "trailingIcon", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'has-icon', reflect: true })
], Button.prototype, "hasIcon", void 0);
__decorate([
    e$4('.button')
], Button.prototype, "buttonElement", void 0);
__decorate([
    o$2({ slot: 'icon', flatten: true })
], Button.prototype, "assignedIcons", void 0);

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A text button component.
 */
class TextButton extends Button {
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./button/internal/text-styles.css.
const styles$2 = i$7 `:host{--_container-height: var(--md-text-button-container-height, 40px);--_disabled-label-text-color: var(--md-text-button-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-text-button-disabled-label-text-opacity, 0.38);--_focus-label-text-color: var(--md-text-button-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_hover-label-text-color: var(--md-text-button-hover-label-text-color, var(--md-sys-color-primary, #6750a4));--_hover-state-layer-color: var(--md-text-button-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--_hover-state-layer-opacity: var(--md-text-button-hover-state-layer-opacity, 0.08);--_label-text-color: var(--md-text-button-label-text-color, var(--md-sys-color-primary, #6750a4));--_label-text-font: var(--md-text-button-label-text-font, var(--md-sys-typescale-label-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-text-button-label-text-line-height, var(--md-sys-typescale-label-large-line-height, 1.25rem));--_label-text-size: var(--md-text-button-label-text-size, var(--md-sys-typescale-label-large-size, 0.875rem));--_label-text-weight: var(--md-text-button-label-text-weight, var(--md-sys-typescale-label-large-weight, var(--md-ref-typeface-weight-medium, 500)));--_pressed-label-text-color: var(--md-text-button-pressed-label-text-color, var(--md-sys-color-primary, #6750a4));--_pressed-state-layer-color: var(--md-text-button-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--_pressed-state-layer-opacity: var(--md-text-button-pressed-state-layer-opacity, 0.12);--_disabled-icon-color: var(--md-text-button-disabled-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-icon-opacity: var(--md-text-button-disabled-icon-opacity, 0.38);--_focus-icon-color: var(--md-text-button-focus-icon-color, var(--md-sys-color-primary, #6750a4));--_hover-icon-color: var(--md-text-button-hover-icon-color, var(--md-sys-color-primary, #6750a4));--_icon-color: var(--md-text-button-icon-color, var(--md-sys-color-primary, #6750a4));--_icon-size: var(--md-text-button-icon-size, 18px);--_pressed-icon-color: var(--md-text-button-pressed-icon-color, var(--md-sys-color-primary, #6750a4));--_container-shape-start-start: var(--md-text-button-container-shape-start-start, var(--md-text-button-container-shape, var(--md-sys-shape-corner-full, 9999px)));--_container-shape-start-end: var(--md-text-button-container-shape-start-end, var(--md-text-button-container-shape, var(--md-sys-shape-corner-full, 9999px)));--_container-shape-end-end: var(--md-text-button-container-shape-end-end, var(--md-text-button-container-shape, var(--md-sys-shape-corner-full, 9999px)));--_container-shape-end-start: var(--md-text-button-container-shape-end-start, var(--md-text-button-container-shape, var(--md-sys-shape-corner-full, 9999px)));--_leading-space: var(--md-text-button-leading-space, 12px);--_trailing-space: var(--md-text-button-trailing-space, 12px);--_with-leading-icon-leading-space: var(--md-text-button-with-leading-icon-leading-space, 12px);--_with-leading-icon-trailing-space: var(--md-text-button-with-leading-icon-trailing-space, 16px);--_with-trailing-icon-leading-space: var(--md-text-button-with-trailing-icon-leading-space, 16px);--_with-trailing-icon-trailing-space: var(--md-text-button-with-trailing-icon-trailing-space, 12px);--_container-color: none;--_disabled-container-color: none;--_disabled-container-opacity: 0}
`;

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-text-button
 * @summary Buttons help people take action, such as sending an email, sharing a
 * document, or liking a comment.
 *
 * __Emphasis:__ Low emphasis – For optional or supplementary actions with the
 * least amount of prominence
 *
 * __Rationale:__ Text buttons have less visual prominence, so should be used
 * for low emphasis actions, such as an alternative option.
 *
 * __Example usages:__
 * - Learn more
 * - View all
 * - Change account
 * - Turn on
 *
 * @final
 * @suppress {visibility}
 */
class OscdTextButton extends ScopedElementsMixin(TextButton) {
}
OscdTextButton.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
};
OscdTextButton.styles = [styles$3, styles$2];

/** True when an ExtRef is bound to source data (or is a ClientLN). */
function isBound(input) {
    if (input.tagName === 'ClientLN') {
        return true;
    }
    return ['iedName', 'ldInst', 'lnClass', 'doName'].every(attr => input.hasAttribute(attr));
}
function descOrValue(element) {
    return (element.getAttribute('desc') ||
        element.querySelector(':scope > DAI[name="d"] > Val')?.textContent ||
        undefined);
}
/**
 * Collects the `desc` (or `d` value) of the LDevice, LN, DOI, SDIs and DAI an
 * FCDA points to in its own IED.
 */
function fcdaDescriptions(fcda) {
    const ied = fcda.closest('IED');
    const ldInst = fcda.getAttribute('ldInst');
    if (!ied || !ldInst) {
        return {};
    }
    const lDevice = ied.querySelector(`:scope > AccessPoint > Server > LDevice[inst="${ldInst}"]`);
    const anyLn = Array.from(lDevice?.querySelectorAll(':scope > LN0, :scope > LN') ?? []).find(ln => (ln.getAttribute('prefix') ?? '') === (fcda.getAttribute('prefix') ?? '') &&
        ln.getAttribute('lnClass') === fcda.getAttribute('lnClass') &&
        (ln.getAttribute('inst') ?? '') === (fcda.getAttribute('lnInst') ?? ''));
    if (!lDevice || !anyLn) {
        return {};
    }
    const descs = {};
    const ldDesc = lDevice.getAttribute('desc');
    if (ldDesc) {
        descs.LDevice = ldDesc;
    }
    const lnDesc = anyLn.getAttribute('desc');
    if (lnDesc) {
        descs.LN = lnDesc;
    }
    const [doName, ...sdoNames] = (fcda.getAttribute('doName') ?? '').split('.');
    const daNames = fcda.getAttribute('daName')?.split('.') ?? [];
    const doi = anyLn.querySelector(`:scope > DOI[name="${doName}"]`);
    if (!doi) {
        return descs;
    }
    const doiDesc = descOrValue(doi);
    if (doiDesc) {
        descs.DOI = doiDesc;
    }
    let parent = doi;
    const sdiDescs = [];
    for (const sdiName of [...sdoNames, ...daNames.slice(0, -1)]) {
        const sdi = parent.querySelector(`:scope > SDI[name="${sdiName}"]`);
        if (!sdi) {
            break;
        }
        parent = sdi;
        const sdiDesc = descOrValue(sdi);
        if (sdiDesc) {
            sdiDescs.push(sdiDesc);
        }
    }
    if (sdiDescs.length > 0) {
        descs.SDI = sdiDescs;
    }
    const daName = daNames[daNames.length - 1];
    const daiDesc = daName
        ? parent
            .querySelector(`:scope > DAI[name="${daName}"]`)
            ?.getAttribute('desc')
        : undefined;
    if (daiDesc) {
        descs.DAI = daiDesc;
    }
    return descs;
}
/**
 * Describes the source data of an input. For an ExtRef the FCDA in the
 * control block's data set is looked up to add its instance descriptions.
 */
function inputSource(input, controlBlock) {
    const ln = `${input.getAttribute('prefix') ?? ''}${input.getAttribute('lnClass') ?? ''}${input.getAttribute('lnInst') ?? ''}`;
    if (input.tagName === 'ClientLN') {
        return { reference: ln };
    }
    const daName = input.getAttribute('daName');
    const reference = `${input.getAttribute('ldInst') ?? ''}/${ln}.${input.getAttribute('doName') ?? ''}${daName ? `.${daName}` : ''}`;
    const dataSetName = controlBlock.getAttribute('datSet');
    const fcda = dataSetName
        ? Array.from(controlBlock.parentElement?.querySelectorAll(`:scope > DataSet[name="${dataSetName}"] > FCDA`) ?? []).find(candidate => matchDataAttributes(input, candidate))
        : undefined;
    if (!fcda) {
        return { reference };
    }
    const desc = Object.values(fcdaDescriptions(fcda)).flat().join(' > ');
    return desc ? { reference, desc } : { reference };
}
/** Describes the receiving side of an input: its `intAddr` or identity. */
function inputDestination(input) {
    const desc = input.getAttribute('desc') || undefined;
    if (input.tagName === 'ClientLN') {
        return { reference: desc ?? `${identity(input)}` };
    }
    const reference = input.getAttribute('intAddr') || `${identity(input)}`;
    return desc ? { reference, desc } : { reference };
}
/**
 * Finds the subscriber's supervision LN (`LGOS` for GOOSE, `LSVS` for SV)
 * whose `setSrcRef` points to the control block.
 */
function existingSupervision(controlBlock, subscriber) {
    const supervision = {
        GSEControl: ['LGOS', 'GoCBRef'],
        SampledValueControl: ['LSVS', 'SvCBRef'],
    };
    const kind = supervision[controlBlock.tagName];
    if (!kind) {
        return null;
    }
    const [lnClass, doName] = kind;
    const objRef = controlBlockObjRef(controlBlock);
    const value = Array.from(subscriber.querySelectorAll(`:scope > AccessPoint > Server > LDevice > LN[lnClass="${lnClass}"] > DOI[name="${doName}"] > DAI[name="setSrcRef"] > Val`)).find(val => val.textContent?.trim() === objRef);
    return value?.closest('LN') ?? null;
}
/** Short title of a connection: `source:controlBlock ⮕ target`. */
function connectionTitle(connection) {
    return `${connection.source.name}:${connection.controlBlock.getAttribute('name') ?? ''} ⮕ ${connection.target.name}`;
}
function inputLine(input, controlBlock) {
    const describe = ({ reference, desc }) => desc ? `${reference} (${desc})` : reference;
    return `${describe(inputSource(input, controlBlock))} ⮕ ${describe(inputDestination(input))}`;
}
/** Multi-line tooltip: the title followed by one line per bound input. */
function connectionTooltip(connection) {
    const lines = connection.inputs
        .filter(isBound)
        .map(input => `  ${inputLine(input, connection.controlBlock)}`);
    return [connectionTitle(connection), ...lines].join('\n');
}

/**
 * A row of the manufacturer tree: name and, dimmed, its count. Rendered
 * inside the tree's shadow root, so styled inline.
 */
function renderTypeNode({ node }) {
    return b `<span
    style="display: flex; gap: 8px; align-items: baseline; width: 100%"
    ><span style="flex: 1; overflow: hidden; text-overflow: ellipsis"
      >${node.label}</span
    ><span style="flex: none; opacity: 0.7; font-size: 0.85em"
      >${node.detail}</span
    ></span
  >`;
}
function connectionCount(count) {
    return count === 1 ? msg('1 connection') : msg(str `${count} connections`);
}
/**
 * Side panel narrowing the shown connections, and listing them.
 *
 * Criteria are grouped in collapsible sections showing how many values are
 * selected. Text criteria match IED and control block names. VLANs and
 * priorities can be typed as comma separated values or ticked; both stay in
 * sync. The values offered come from `options`: with an IED selected, the
 * host passes only what that IED's connections use. The connection list
 * gives keyboard access to every shown connection, including those whose
 * IEDs are not placed on a diagram.
 *
 * @fires map-filter-change - detail: changed `ConnectionFilter` fields
 * @fires map-view-change - detail: `{ filterOpen: false }` when closed
 * @fires map-connection-select - detail: `{ id }` of a listed connection
 */
class MapFilterPanel extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        this.options = emptyOptions();
        /** Connections shown with the current filter. */
        this.connections = [];
        /** Ids of the shown connections drawn on a diagram. */
        this.drawn = new Set();
        /** VLAN input as typed, kept while it parses to the selected VLANs. */
        this.vlanText = '';
        this.priorityText = '';
        /** Folded sections; all but the name criteria start folded. */
        this.collapsed = new Set([
            'vlans',
            'priorities',
            'manufacturers',
            'connections',
        ]);
        /** Manufacturers whose types are listed. */
        this.expanded = new Set();
    }
    willUpdate(changed) {
        if (!changed.has('filter')) {
            return;
        }
        const { vlans, priorities } = this.filter;
        if (parseVlanSelection(this.vlanText, this.options.vlans).join() !==
            vlans.join()) {
            this.vlanText = vlans.join(', ');
        }
        if (parsePrioritySelection(this.priorityText, this.options.priorities).join() !==
            priorities.join()) {
            this.priorityText = priorities.join(', ');
        }
    }
    emit(type, detail) {
        this.dispatchEvent(new CustomEvent(type, { detail, bubbles: true, composed: true }));
    }
    changeFilter(detail) {
        this.emit('map-filter-change', detail);
    }
    handleTextInput(criterion, event) {
        const { value } = event.target;
        this.changeFilter({ [criterion]: value });
    }
    handleVlanInput(event) {
        this.vlanText = event.target.value;
        this.changeFilter({
            vlans: parseVlanSelection(this.vlanText, this.options.vlans),
        });
    }
    handlePriorityInput(event) {
        this.priorityText = event.target.value;
        this.changeFilter({
            priorities: parsePrioritySelection(this.priorityText, this.options.priorities),
        });
    }
    toggleSection(section, event) {
        const { open } = event.target;
        if (open === !this.collapsed.has(section)) {
            return;
        }
        const collapsed = new Set(this.collapsed);
        if (open) {
            collapsed.delete(section);
        }
        else {
            collapsed.add(section);
        }
        this.collapsed = collapsed;
    }
    renderSection(section, title, badge, content) {
        return b `<details
      class="section ${section}"
      ?open=${!this.collapsed.has(section)}
      @toggle=${(event) => this.toggleSection(section, event)}
    >
      <summary>
        <oscd-icon class="chevron">chevron_right</oscd-icon>
        <span class="title">${title}</span>
        ${badge ? b `<span class="badge">${badge}</span>` : A}
      </summary>
      <div class="section-body">${content}</div>
    </details>`;
    }
    renderTextField(criterion, label) {
        return b `<oscd-outlined-text-field
      class=${criterion}
      .label=${label}
      .value=${this.filter[criterion]}
      title=${msg('Space separated, any term matches')}
      @input=${(event) => this.handleTextInput(criterion, event)}
    ></oscd-outlined-text-field>`;
    }
    renderNames() {
        const { sourceIed, targetIed, controlBlock } = this.filter;
        const active = [sourceIed, targetIed, controlBlock].filter(text => text.trim() !== '').length;
        return this.renderSection('names', msg('Names'), active ? `${active}` : undefined, b `<p class="hint">${msg('Space separated terms, any term matches')}</p>
        ${this.renderTextField('sourceIed', msg('Source IED'))}
        ${this.renderTextField('targetIed', msg('Target IED'))}
        ${this.renderTextField('controlBlock', msg('Control block'))}`);
    }
    renderVlans() {
        const { vlans, counts } = this.options;
        if (vlans.length === 0) {
            return A;
        }
        const selected = this.filter.vlans;
        return this.renderSection('vlans', msg('VLANs'), selected.length
            ? msg(str `${selected.length} of ${vlans.length}`)
            : `${vlans.length}`, b `<oscd-outlined-text-field
          class="vlan-text"
          .label=${msg('VLAN IDs')}
          .value=${this.vlanText}
          supporting-text=${msg('Comma separated, decimal or hex (0x65)')}
          @input=${this.handleVlanInput}
        ></oscd-outlined-text-field>
        <div class="bulk">
          <oscd-text-button
            class="vlans-all"
            ?disabled=${selected.length === vlans.length}
            @click=${() => this.changeFilter({ vlans: [...vlans] })}
            >${msg('Select all')}</oscd-text-button
          >
          <oscd-text-button
            class="vlans-none"
            ?disabled=${selected.length === 0}
            @click=${() => this.changeFilter({ vlans: [] })}
            >${msg('Clear')}</oscd-text-button
          >
        </div>
        <oscd-selection-list
          class="vlan-options"
          multiselect
          filterable
          searchhelper=${msg('Filter VLANs')}
          aria-label=${msg('VLAN IDs')}
          .items=${vlans.map((vlan) => ({
            headline: `${formatVlanId(vlan)} (${vlan})`,
            supportingText: connectionCount(counts.vlans.get(vlan) ?? 0),
            selected: selected.includes(vlan),
        }))}
          @selection-list-change=${(event) => {
            const { items } = event.target;
            this.changeFilter({
                vlans: vlans.filter((_, k) => items[k]?.selected),
            });
        }}
        ></oscd-selection-list>`);
    }
    renderPriorities() {
        const { priorities, counts } = this.options;
        if (priorities.length === 0) {
            return A;
        }
        const selected = this.filter.priorities;
        return this.renderSection('priorities', msg('VLAN priorities'), selected.length ? `${selected.length}` : undefined, b `<oscd-outlined-text-field
          class="priority-text"
          .label=${msg('VLAN priorities')}
          .value=${this.priorityText}
          supporting-text=${msg('Comma separated')}
          @input=${this.handlePriorityInput}
        ></oscd-outlined-text-field>
        <oscd-chip-set aria-label=${msg('VLAN priorities')}>
          ${priorities.map(priority => b `<oscd-filter-chip
                data-priority=${priority}
                .label=${`${priority} (${counts.priorities.get(priority) ?? 0})`}
                .selected=${selected.includes(priority)}
                @click=${() => this.changeFilter({
            priorities: toggleValue(selected, priority),
        })}
              ></oscd-filter-chip>`)}
        </oscd-chip-set>`);
    }
    renderManufacturers() {
        const { manufacturers, counts } = this.options;
        if (manufacturers.size === 0) {
            return A;
        }
        const selected = this.filter.types;
        const data = Array.from(manufacturers, ([manufacturer, types]) => {
            const keys = types.map(type => `${manufacturer}|${type}`);
            const chosen = keys.filter(key => selected.includes(key)).length;
            return {
                id: `manufacturer:${manufacturer}`,
                label: manufacturer || msg('Unknown manufacturer'),
                detail: chosen
                    ? msg(str `${chosen} of ${types.length} selected`)
                    : types.length === 1
                        ? msg('1 type')
                        : msg(str `${types.length} types`),
                children: types.map((type, k) => ({
                    id: keys[k],
                    label: type || msg('Unknown type'),
                    detail: connectionCount(counts.types.get(keys[k]) ?? 0),
                    // An empty list marks a leaf (no list: not loaded yet).
                    children: [],
                })),
            };
        });
        // Manufacturers with selected types are shown expanded.
        const expanded = new Set(this.expanded);
        data.forEach(({ id, children }) => {
            if (children?.some(child => selected.includes(child.id ?? ''))) {
                expanded.add(id);
            }
        });
        return this.renderSection('manufacturers', msg('Manufacturers and types'), selected.length ? `${selected.length}` : undefined, b `<oscd-tree
        class="types"
        aria-label=${msg('Manufacturers and types')}
        selectionMode="multiple"
        .data=${data}
        .selectedIds=${selected}
        .expandedIds=${Array.from(expanded)}
        .isSelectable=${(node) => node.children?.length === 0}
        .renderItem=${renderTypeNode}
        @selected-ids-changed=${(event) => this.changeFilter({ types: event.detail.selectedIds })}
        @expanded-ids-changed=${(event) => {
            this.expanded = new Set(event.detail.expandedIds);
        }}
      ></oscd-tree>`);
    }
    renderConnection(connection) {
        const onDiagram = this.drawn.has(connection.id);
        const inputs = connection.inputs.length;
        return b `<oscd-list-item
      type="button"
      data-id=${connection.id}
      class=${this.selectedConnection === connection.id ? 'selected' : ''}
      @click=${() => this.emit('map-connection-select', { id: connection.id })}
    >
      <oscd-icon slot="start">${serviceIcons[connection.service]}</oscd-icon>
      <div slot="headline">${connectionTitle(connection)}</div>
      <div slot="supporting-text">
        ${inputs === 1 ? msg('1 input') : msg(str `${inputs} inputs`)}${onDiagram
            ? A
            : b ` · ${msg('not on the diagram')}`}
      </div>
    </oscd-list-item>`;
    }
    renderScope() {
        const { ied } = this.filter;
        if (ied === undefined) {
            return A;
        }
        return b `<p class="scope">
      <oscd-icon>filter_center_focus</oscd-icon>
      <span>${msg(str `Showing the options used by IED ${ied}`)}</span>
    </p>`;
    }
    render() {
        const count = this.connections.length;
        return b `<aside aria-label=${msg('Filter connections')}>
      <header>
        <h2>${msg('Filter connections')}</h2>
        <oscd-icon-button
          class="reset"
          aria-label=${msg('Reset filter')}
          title=${msg('Reset filter')}
          ?disabled=${!isFilterActive(this.filter)}
          @click=${() => this.changeFilter(clearCriteria(this.filter))}
          ><oscd-icon>restart_alt</oscd-icon></oscd-icon-button
        >
        <oscd-icon-button
          class="close"
          aria-label=${msg('Close')}
          title=${msg('Close')}
          @click=${() => this.emit('map-view-change', { filterOpen: false })}
          ><oscd-icon>close</oscd-icon></oscd-icon-button
        >
      </header>
      <div class="scroll">
        ${this.renderScope()} ${this.renderNames()} ${this.renderVlans()}
        ${this.renderPriorities()} ${this.renderManufacturers()}
        ${this.renderSection('connections', count === 1 ? msg('1 connection') : msg(str `${count} connections`), undefined, b `<oscd-list class="connections">
            ${this.connections.map(connection => this.renderConnection(connection))}
          </oscd-list>`)}
      </div>
    </aside>`;
    }
}
MapFilterPanel.scopedElements = {
    'oscd-checkbox': OscdCheckbox,
    'oscd-chip-set': OscdChipSet,
    'oscd-filter-chip': OscdFilterChip,
    'oscd-icon': OscdIcon,
    'oscd-icon-button': OscdIconButton,
    'oscd-list': OscdList,
    'oscd-list-item': OscdListItem,
    'oscd-outlined-text-field': OscdOutlinedTextField,
    'oscd-text-button': OscdTextButton,
    'oscd-selection-list': OscdSelectionList,
    'oscd-tree': OscdTree,
};
MapFilterPanel.styles = i$7 `
    :host {
      display: block;
      overflow: hidden;
      background: var(--oscd-base3);
      color: var(--oscd-base00);
    }

    /* The header stays put; only the criteria and connections scroll. */
    aside {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .scroll {
      flex: auto;
      min-height: 0;
      overflow: auto;
    }

    header {
      flex: none;
      display: flex;
      align-items: center;
      padding: 4px 8px 4px 16px;
      background: var(--oscd-base3);
      border-bottom: 1px solid var(--oscd-base2);
    }

    h2 {
      flex: 1;
      margin: 0;
      font-size: 1.1em;
      font-weight: 500;
    }

    .scope {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 8px 16px 0;
      padding: 8px 12px;
      border-radius: var(--oscd-shape);
      background: var(--oscd-base2);
      font-size: 0.9em;
    }

    .section {
      border-bottom: 1px solid var(--oscd-base2);
    }

    summary {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 10px 16px 10px 8px;
      cursor: pointer;
      list-style: none;
      font-weight: 500;
    }

    summary::-webkit-details-marker {
      display: none;
    }

    .chevron {
      transition: transform 0.15s;
    }

    .section[open] .chevron {
      transform: rotate(90deg);
    }

    .title {
      flex: 1;
    }

    .badge {
      padding: 0 8px;
      border-radius: 10px;
      background: var(--oscd-base2);
      color: var(--oscd-base01);
      font-size: 0.8em;
      font-weight: 500;
      line-height: 20px;
    }

    .section-body {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 0 16px 12px;
    }

    .section.connections .section-body {
      padding: 0 0 8px;
    }

    .hint {
      margin: 0;
      font-size: 0.85em;
      color: var(--oscd-base01);
    }

    .bulk {
      display: flex;
      justify-content: flex-end;
      margin: -4px 0;
    }

    /* Long VLAN lists scroll inside the section, below its filter field. */
    .vlan-options {
      max-height: 320px;
      overflow: auto;
      border: 1px solid var(--oscd-base2);
      border-radius: var(--oscd-shape);
    }

    .types {
      border: 1px solid var(--oscd-base2);
      border-radius: var(--oscd-shape);
    }

    .count {
      flex: none;
      margin-left: 8px;
      color: var(--oscd-base01);
      font-size: 0.85em;
      font-variant-numeric: tabular-nums;
    }

    oscd-list-item.selected {
      --md-list-item-label-text-color: var(--oscd-primary);
    }
  `;
__decorate([
    n$3({ attribute: false })
], MapFilterPanel.prototype, "filter", void 0);
__decorate([
    n$3({ attribute: false })
], MapFilterPanel.prototype, "options", void 0);
__decorate([
    n$3({ attribute: false })
], MapFilterPanel.prototype, "connections", void 0);
__decorate([
    n$3({ attribute: false })
], MapFilterPanel.prototype, "drawn", void 0);
__decorate([
    n$3({ attribute: false })
], MapFilterPanel.prototype, "selectedConnection", void 0);
__decorate([
    r$2()
], MapFilterPanel.prototype, "vlanText", void 0);
__decorate([
    r$2()
], MapFilterPanel.prototype, "priorityText", void 0);
__decorate([
    r$2()
], MapFilterPanel.prototype, "collapsed", void 0);
__decorate([
    r$2()
], MapFilterPanel.prototype, "expanded", void 0);

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The default dialog open animation.
 */
const DIALOG_DEFAULT_OPEN_ANIMATION = {
    dialog: [
        [
            // Dialog slide down
            [{ 'transform': 'translateY(-50px)' }, { 'transform': 'translateY(0)' }],
            { duration: 500, easing: EASING.EMPHASIZED },
        ],
    ],
    scrim: [
        [
            // Scrim fade in
            [{ 'opacity': 0 }, { 'opacity': 0.32 }],
            { duration: 500, easing: 'linear' },
        ],
    ],
    container: [
        [
            // Container fade in
            [{ 'opacity': 0 }, { 'opacity': 1 }],
            { duration: 50, easing: 'linear', pseudoElement: '::before' },
        ],
        [
            // Container grow
            // Note: current spec says to grow from 0dp->100% and shrink from
            // 100%->35%. We change this to 35%->100% to simplify the animation that
            // is supposed to clip content as it grows. From 0dp it's possible to see
            // text/actions appear before the container has fully grown.
            [{ 'height': '35%' }, { 'height': '100%' }],
            { duration: 500, easing: EASING.EMPHASIZED, pseudoElement: '::before' },
        ],
    ],
    headline: [
        [
            // Headline fade in
            [{ 'opacity': 0 }, { 'opacity': 0, offset: 0.2 }, { 'opacity': 1 }],
            { duration: 250, easing: 'linear', fill: 'forwards' },
        ],
    ],
    content: [
        [
            // Content fade in
            [{ 'opacity': 0 }, { 'opacity': 0, offset: 0.2 }, { 'opacity': 1 }],
            { duration: 250, easing: 'linear', fill: 'forwards' },
        ],
    ],
    actions: [
        [
            // Actions fade in
            [{ 'opacity': 0 }, { 'opacity': 0, offset: 0.5 }, { 'opacity': 1 }],
            { duration: 300, easing: 'linear', fill: 'forwards' },
        ],
    ],
};
/**
 * The default dialog close animation.
 */
const DIALOG_DEFAULT_CLOSE_ANIMATION = {
    dialog: [
        [
            // Dialog slide up
            [{ 'transform': 'translateY(0)' }, { 'transform': 'translateY(-50px)' }],
            { duration: 150, easing: EASING.EMPHASIZED_ACCELERATE },
        ],
    ],
    scrim: [
        [
            // Scrim fade out
            [{ 'opacity': 0.32 }, { 'opacity': 0 }],
            { duration: 150, easing: 'linear' },
        ],
    ],
    container: [
        [
            // Container shrink
            [{ 'height': '100%' }, { 'height': '35%' }],
            {
                duration: 150,
                easing: EASING.EMPHASIZED_ACCELERATE,
                pseudoElement: '::before',
            },
        ],
        [
            // Container fade out
            [{ 'opacity': '1' }, { 'opacity': '0' }],
            { delay: 100, duration: 50, easing: 'linear', pseudoElement: '::before' },
        ],
    ],
    headline: [
        [
            // Headline fade out
            [{ 'opacity': 1 }, { 'opacity': 0 }],
            { duration: 100, easing: 'linear', fill: 'forwards' },
        ],
    ],
    content: [
        [
            // Content fade out
            [{ 'opacity': 1 }, { 'opacity': 0 }],
            { duration: 100, easing: 'linear', fill: 'forwards' },
        ],
    ],
    actions: [
        [
            // Actions fade out
            [{ 'opacity': 1 }, { 'opacity': 0 }],
            { duration: 100, easing: 'linear', fill: 'forwards' },
        ],
    ],
};

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const dialogBaseClass = mixinDelegatesAria(i$4);
/**
 * A dialog component.
 *
 * @fires open {Event} Dispatched when the dialog is opening before any animations.
 * @fires opened {Event} Dispatched when the dialog has opened after any animations.
 * @fires close {Event} Dispatched when the dialog is closing before any animations.
 * @fires closed {Event} Dispatched when the dialog has closed after any animations.
 * @fires cancel {Event} Dispatched when the dialog has been canceled by clicking
 * on the scrim or pressing Escape.
 */
class Dialog extends dialogBaseClass {
    // We do not use `delegatesFocus: true` due to a Chromium bug with
    // selecting text.
    // See https://bugs.chromium.org/p/chromium/issues/detail?id=950357
    /**
     * Opens the dialog when set to `true` and closes it when set to `false`.
     */
    get open() {
        return this.isOpen;
    }
    set open(open) {
        if (open === this.isOpen) {
            return;
        }
        this.isOpen = open;
        if (open) {
            this.setAttribute('open', '');
            this.show();
        }
        else {
            this.removeAttribute('open');
            this.close();
        }
    }
    constructor() {
        super();
        /**
         * Skips the opening and closing animations.
         */
        this.quick = false;
        /**
         * Gets or sets the dialog's return value, usually to indicate which button
         * a user pressed to close it.
         *
         * https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/returnValue
         */
        this.returnValue = '';
        /**
         * Disables focus trapping, which by default keeps keyboard Tab navigation
         * within the dialog.
         *
         * When disabled, after focusing the last element of a dialog, pressing Tab
         * again will release focus from the window back to the browser (such as the
         * URL bar).
         *
         * Focus trapping is recommended for accessibility, and should not typically
         * be disabled. Only turn this off if the use case of a dialog is more
         * accessible without focus trapping.
         */
        this.noFocusTrap = false;
        /**
         * Gets the opening animation for a dialog. Set to a new function to customize
         * the animation.
         */
        this.getOpenAnimation = () => DIALOG_DEFAULT_OPEN_ANIMATION;
        /**
         * Gets the closing animation for a dialog. Set to a new function to customize
         * the animation.
         */
        this.getCloseAnimation = () => DIALOG_DEFAULT_CLOSE_ANIMATION;
        this.isOpen = false;
        this.isOpening = false;
        this.isConnectedPromise = this.getIsConnectedPromise();
        this.isAtScrollTop = false;
        this.isAtScrollBottom = false;
        this.nextClickIsFromContent = false;
        // Dialogs should not be SSR'd while open, so we can just use runtime checks.
        this.hasHeadline = false;
        this.hasActions = false;
        this.hasIcon = false;
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=1512224
        // Chrome v120 has a bug where escape keys do not trigger cancels. If we get
        // a dialog "close" event that is triggered without a "cancel" after an escape
        // keydown, then we need to manually trigger our closing logic.
        //
        // This bug occurs when pressing escape to close a dialog without first
        // interacting with the dialog's content.
        //
        // Cleanup tracking:
        // https://github.com/material-components/material-web/issues/5330
        // This can be removed when full CloseWatcher support added and the above bug
        // in Chromium is fixed to fire 'cancel' with one escape press and close with
        // multiple.
        this.escapePressedWithoutCancel = false;
        // This TreeWalker is used to walk through a dialog's children to find
        // focusable elements. TreeWalker is faster than `querySelectorAll('*')`.
        // We check for isServer because there isn't a "document" during an SSR
        // run.
        this.treewalker = document.createTreeWalker(this, NodeFilter.SHOW_ELEMENT);
        {
            this.addEventListener('submit', this.handleSubmit);
        }
    }
    /**
     * Opens the dialog and fires a cancelable `open` event. After a dialog's
     * animation, an `opened` event is fired.
     *
     * Add an `autofocus` attribute to a child of the dialog that should
     * receive focus after opening.
     *
     * @return A Promise that resolves after the animation is finished and the
     *     `opened` event was fired.
     */
    async show() {
        this.isOpening = true;
        // Dialogs can be opened before being attached to the DOM, so we need to
        // wait until we're connected before calling `showModal()`.
        await this.isConnectedPromise;
        await this.updateComplete;
        const dialog = this.dialog;
        // Check if already opened or if `dialog.close()` was called while awaiting.
        if (dialog.open || !this.isOpening) {
            this.isOpening = false;
            return;
        }
        const preventOpen = !this.dispatchEvent(new Event('open', { cancelable: true }));
        if (preventOpen) {
            this.open = false;
            this.isOpening = false;
            return;
        }
        // All Material dialogs are modal.
        dialog.showModal();
        this.open = true;
        // Reset scroll position if re-opening a dialog with the same content.
        if (this.scroller) {
            this.scroller.scrollTop = 0;
        }
        // Native modal dialogs ignore autofocus and instead force focus to the
        // first focusable child. Override this behavior if there is a child with
        // an autofocus attribute.
        this.querySelector('[autofocus]')?.focus();
        await this.animateDialog(this.getOpenAnimation());
        this.dispatchEvent(new Event('opened'));
        this.isOpening = false;
    }
    /**
     * Closes the dialog and fires a cancelable `close` event. After a dialog's
     * animation, a `closed` event is fired.
     *
     * @param returnValue A return value usually indicating which button was used
     *     to close a dialog. If a dialog is canceled by clicking the scrim or
     *     pressing Escape, it will not change the return value after closing.
     * @return A Promise that resolves after the animation is finished and the
     *     `closed` event was fired.
     */
    async close(returnValue = this.returnValue) {
        this.isOpening = false;
        if (!this.isConnected) {
            // Disconnected dialogs do not fire close events or animate.
            this.open = false;
            return;
        }
        await this.updateComplete;
        const dialog = this.dialog;
        // Check if already closed or if `dialog.show()` was called while awaiting.
        if (!dialog.open || this.isOpening) {
            this.open = false;
            return;
        }
        const prevReturnValue = this.returnValue;
        this.returnValue = returnValue;
        const preventClose = !this.dispatchEvent(new Event('close', { cancelable: true }));
        if (preventClose) {
            this.returnValue = prevReturnValue;
            return;
        }
        await this.animateDialog(this.getCloseAnimation());
        dialog.close(returnValue);
        this.open = false;
        this.dispatchEvent(new Event('closed'));
    }
    connectedCallback() {
        super.connectedCallback();
        this.isConnectedPromiseResolve();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.isConnectedPromise = this.getIsConnectedPromise();
    }
    render() {
        const scrollable = this.open && !(this.isAtScrollTop && this.isAtScrollBottom);
        const classes = {
            'has-headline': this.hasHeadline,
            'has-actions': this.hasActions,
            'has-icon': this.hasIcon,
            'scrollable': scrollable,
            'show-top-divider': scrollable && !this.isAtScrollTop,
            'show-bottom-divider': scrollable && !this.isAtScrollBottom,
        };
        // The focus trap sentinels are only added after the dialog opens, since
        // dialog.showModal() will try to autofocus them, even with tabindex="-1".
        const showFocusTrap = this.open && !this.noFocusTrap;
        const focusTrap = b `
      <div
        class="focus-trap"
        tabindex="0"
        aria-hidden="true"
        @focus=${this.handleFocusTrapFocus}></div>
    `;
        const { ariaLabel } = this;
        return b `
      <div class="scrim"></div>
      <dialog
        class=${e(classes)}
        aria-label=${ariaLabel || A}
        aria-labelledby=${this.hasHeadline ? 'headline' : A}
        role=${this.type === 'alert' ? 'alertdialog' : A}
        @cancel=${this.handleCancel}
        @click=${this.handleDialogClick}
        @close=${this.handleClose}
        @keydown=${this.handleKeydown}
        .returnValue=${this.returnValue || A}>
        ${showFocusTrap ? focusTrap : A}
        <div class="container" @click=${this.handleContentClick}>
          <div class="headline">
            <div class="icon" aria-hidden="true">
              <slot name="icon" @slotchange=${this.handleIconChange}></slot>
            </div>
            <h2 id="headline" aria-hidden=${!this.hasHeadline || A}>
              <slot
                name="headline"
                @slotchange=${this.handleHeadlineChange}></slot>
            </h2>
            <md-divider></md-divider>
          </div>
          <div class="scroller">
            <div class="content">
              <div class="top anchor"></div>
              <slot name="content"></slot>
              <div class="bottom anchor"></div>
            </div>
          </div>
          <div class="actions">
            <md-divider></md-divider>
            <slot name="actions" @slotchange=${this.handleActionsChange}></slot>
          </div>
        </div>
        ${showFocusTrap ? focusTrap : A}
      </dialog>
    `;
    }
    firstUpdated() {
        this.intersectionObserver = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                this.handleAnchorIntersection(entry);
            }
        }, { root: this.scroller });
        this.intersectionObserver.observe(this.topAnchor);
        this.intersectionObserver.observe(this.bottomAnchor);
    }
    handleDialogClick() {
        if (this.nextClickIsFromContent) {
            // Avoid doing a layout calculation below if we know the click came from
            // content.
            this.nextClickIsFromContent = false;
            return;
        }
        // Click originated on the backdrop. Native `<dialog>`s will not cancel,
        // but Material dialogs do.
        const preventDefault = !this.dispatchEvent(new Event('cancel', { cancelable: true }));
        if (preventDefault) {
            return;
        }
        this.close();
    }
    handleContentClick() {
        this.nextClickIsFromContent = true;
    }
    handleSubmit(event) {
        const form = event.target;
        const { submitter } = event;
        if (form.getAttribute('method') !== 'dialog' || !submitter) {
            return;
        }
        // Close reason is the submitter's value attribute, or the dialog's
        // `returnValue` if there is no attribute.
        this.close(submitter.getAttribute('value') ?? this.returnValue);
    }
    handleCancel(event) {
        if (event.target !== this.dialog) {
            // Ignore any cancel events dispatched by content.
            return;
        }
        this.escapePressedWithoutCancel = false;
        const preventDefault = !redispatchEvent(this, event);
        // We always prevent default on the original dialog event since we'll
        // animate closing it before it actually closes.
        event.preventDefault();
        if (preventDefault) {
            return;
        }
        this.close();
    }
    handleClose() {
        if (!this.escapePressedWithoutCancel) {
            return;
        }
        this.escapePressedWithoutCancel = false;
        this.dialog?.dispatchEvent(new Event('cancel', { cancelable: true }));
    }
    handleKeydown(event) {
        if (event.key !== 'Escape') {
            return;
        }
        // An escape key was pressed. If a "close" event fires next without a
        // "cancel" event first, then we know we're in the Chrome v120 bug.
        this.escapePressedWithoutCancel = true;
        // Wait a full task for the cancel/close event listeners to fire, then
        // reset the flag.
        setTimeout(() => {
            this.escapePressedWithoutCancel = false;
        });
    }
    async animateDialog(animation) {
        // Always cancel the previous animations. Animations can include `fill`
        // modes that need to be cleared when `quick` is toggled. If not, content
        // that faded out will remain hidden when a `quick` dialog re-opens after
        // previously opening and closing without `quick`.
        this.cancelAnimations?.abort();
        this.cancelAnimations = new AbortController();
        if (this.quick) {
            return;
        }
        const { dialog, scrim, container, headline, content, actions } = this;
        if (!dialog || !scrim || !container || !headline || !content || !actions) {
            return;
        }
        const { container: containerAnimate, dialog: dialogAnimate, scrim: scrimAnimate, headline: headlineAnimate, content: contentAnimate, actions: actionsAnimate, } = animation;
        const elementAndAnimation = [
            [dialog, dialogAnimate ?? []],
            [scrim, scrimAnimate ?? []],
            [container, containerAnimate ?? []],
            [headline, headlineAnimate ?? []],
            [content, contentAnimate ?? []],
            [actions, actionsAnimate ?? []],
        ];
        const animations = [];
        for (const [element, animation] of elementAndAnimation) {
            for (const animateArgs of animation) {
                const animation = element.animate(...animateArgs);
                this.cancelAnimations.signal.addEventListener('abort', () => {
                    animation.cancel();
                });
                animations.push(animation);
            }
        }
        await Promise.all(animations.map((animation) => animation.finished.catch(() => {
            // Ignore intentional AbortErrors when calling `animation.cancel()`.
        })));
    }
    handleHeadlineChange(event) {
        const slot = event.target;
        this.hasHeadline = slot.assignedElements().length > 0;
    }
    handleActionsChange(event) {
        const slot = event.target;
        this.hasActions = slot.assignedElements().length > 0;
    }
    handleIconChange(event) {
        const slot = event.target;
        this.hasIcon = slot.assignedElements().length > 0;
    }
    handleAnchorIntersection(entry) {
        const { target, isIntersecting } = entry;
        if (target === this.topAnchor) {
            this.isAtScrollTop = isIntersecting;
        }
        if (target === this.bottomAnchor) {
            this.isAtScrollBottom = isIntersecting;
        }
    }
    getIsConnectedPromise() {
        return new Promise((resolve) => {
            this.isConnectedPromiseResolve = resolve;
        });
    }
    handleFocusTrapFocus(event) {
        const [firstFocusableChild, lastFocusableChild] = this.getFirstAndLastFocusableChildren();
        if (!firstFocusableChild || !lastFocusableChild) {
            // When a dialog does not have focusable children, the dialog itself
            // receives focus.
            this.dialog?.focus();
            return;
        }
        // To determine which child to focus, we need to know which focus trap
        // received focus...
        const isFirstFocusTrap = event.target === this.firstFocusTrap;
        const isLastFocusTrap = !isFirstFocusTrap;
        // ...and where the focus came from (what was previously focused).
        const focusCameFromFirstChild = event.relatedTarget === firstFocusableChild;
        const focusCameFromLastChild = event.relatedTarget === lastFocusableChild;
        // Although this is a focus trap, focus can come from outside the trap.
        // This can happen when elements are programmatically `focus()`'d. It also
        // happens when focus leaves and returns to the window, such as clicking on
        // the browser's URL bar and pressing Tab, or switching focus between
        // iframes.
        const focusCameFromOutsideDialog = !focusCameFromFirstChild && !focusCameFromLastChild;
        // Focus the dialog's first child when we reach the end of the dialog and
        // focus is moving forward. Or, when focus is moving forwards into the
        // dialog from outside of the window.
        const shouldFocusFirstChild = (isLastFocusTrap && focusCameFromLastChild) ||
            (isFirstFocusTrap && focusCameFromOutsideDialog);
        if (shouldFocusFirstChild) {
            firstFocusableChild.focus();
            return;
        }
        // Focus the dialog's last child when we reach the beginning of the dialog
        // and focus is moving backward. Or, when focus is moving backwards into the
        // dialog from outside of the window.
        const shouldFocusLastChild = (isFirstFocusTrap && focusCameFromFirstChild) ||
            (isLastFocusTrap && focusCameFromOutsideDialog);
        if (shouldFocusLastChild) {
            lastFocusableChild.focus();
            return;
        }
        // The booleans above are verbose for readability, but code executation
        // won't actually reach here.
    }
    getFirstAndLastFocusableChildren() {
        if (!this.treewalker) {
            return [null, null];
        }
        let firstFocusableChild = null;
        let lastFocusableChild = null;
        // Reset the current node back to the root host element.
        this.treewalker.currentNode = this.treewalker.root;
        while (this.treewalker.nextNode()) {
            // Cast as Element since the TreeWalker filter only accepts Elements.
            const nextChild = this.treewalker.currentNode;
            if (!isFocusable(nextChild)) {
                continue;
            }
            if (!firstFocusableChild) {
                firstFocusableChild = nextChild;
            }
            lastFocusableChild = nextChild;
        }
        // We set lastFocusableChild immediately after finding a
        // firstFocusableChild, which means the pair is either both null or both
        // non-null. Cast since TypeScript does not recognize this.
        return [firstFocusableChild, lastFocusableChild];
    }
}
__decorate([
    n$3({ type: Boolean })
], Dialog.prototype, "open", null);
__decorate([
    n$3({ type: Boolean })
], Dialog.prototype, "quick", void 0);
__decorate([
    n$3({ attribute: false })
], Dialog.prototype, "returnValue", void 0);
__decorate([
    n$3()
], Dialog.prototype, "type", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'no-focus-trap' })
], Dialog.prototype, "noFocusTrap", void 0);
__decorate([
    e$4('dialog')
], Dialog.prototype, "dialog", void 0);
__decorate([
    e$4('.scrim')
], Dialog.prototype, "scrim", void 0);
__decorate([
    e$4('.container')
], Dialog.prototype, "container", void 0);
__decorate([
    e$4('.headline')
], Dialog.prototype, "headline", void 0);
__decorate([
    e$4('.content')
], Dialog.prototype, "content", void 0);
__decorate([
    e$4('.actions')
], Dialog.prototype, "actions", void 0);
__decorate([
    r$2()
], Dialog.prototype, "isAtScrollTop", void 0);
__decorate([
    r$2()
], Dialog.prototype, "isAtScrollBottom", void 0);
__decorate([
    e$4('.scroller')
], Dialog.prototype, "scroller", void 0);
__decorate([
    e$4('.top.anchor')
], Dialog.prototype, "topAnchor", void 0);
__decorate([
    e$4('.bottom.anchor')
], Dialog.prototype, "bottomAnchor", void 0);
__decorate([
    e$4('.focus-trap')
], Dialog.prototype, "firstFocusTrap", void 0);
__decorate([
    r$2()
], Dialog.prototype, "hasHeadline", void 0);
__decorate([
    r$2()
], Dialog.prototype, "hasActions", void 0);
__decorate([
    r$2()
], Dialog.prototype, "hasIcon", void 0);
function isFocusable(element) {
    // Check if the element is a known built-in focusable element:
    // - <a> and <area> with `href` attributes.
    // - Form controls that are not disabled.
    // - `contenteditable` elements.
    // - Anything with a non-negative `tabindex`.
    const knownFocusableElements = ':is(button,input,select,textarea,object,:is(a,area)[href],[tabindex],[contenteditable=true])';
    const notDisabled = ':not(:disabled,[disabled])';
    const notNegativeTabIndex = ':not([tabindex^="-"])';
    if (element.matches(knownFocusableElements + notDisabled + notNegativeTabIndex)) {
        return true;
    }
    const isCustomElement = element.localName.includes('-');
    if (!isCustomElement) {
        return false;
    }
    // If a custom element does not have a tabindex, it may still be focusable
    // if it delegates focus with a shadow root. We also need to check again if
    // the custom element is a disabled form control.
    if (!element.matches(notDisabled)) {
        return false;
    }
    return element.shadowRoot?.delegatesFocus ?? false;
}

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./dialog/internal/dialog-styles.css.
const styles$1 = i$7 `:host{border-start-start-radius:var(--md-dialog-container-shape-start-start, var(--md-dialog-container-shape, var(--md-sys-shape-corner-extra-large, 28px)));border-start-end-radius:var(--md-dialog-container-shape-start-end, var(--md-dialog-container-shape, var(--md-sys-shape-corner-extra-large, 28px)));border-end-end-radius:var(--md-dialog-container-shape-end-end, var(--md-dialog-container-shape, var(--md-sys-shape-corner-extra-large, 28px)));border-end-start-radius:var(--md-dialog-container-shape-end-start, var(--md-dialog-container-shape, var(--md-sys-shape-corner-extra-large, 28px)));display:contents;margin:auto;max-height:min(560px,100% - 48px);max-width:min(560px,100% - 48px);min-height:140px;min-width:280px;position:fixed;height:fit-content;width:fit-content}dialog{background:rgba(0,0,0,0);border:none;border-radius:inherit;flex-direction:column;height:inherit;margin:inherit;max-height:inherit;max-width:inherit;min-height:inherit;min-width:inherit;outline:none;overflow:visible;padding:0;width:inherit}dialog[open]{display:flex}::backdrop{background:none}.scrim{background:var(--md-sys-color-scrim, #000);display:none;inset:0;opacity:32%;pointer-events:none;position:fixed;z-index:1}:host([open]) .scrim{display:flex}h2{all:unset;align-self:stretch}.headline{align-items:center;color:var(--md-dialog-headline-color, var(--md-sys-color-on-surface, #1d1b20));display:flex;flex-direction:column;font-family:var(--md-dialog-headline-font, var(--md-sys-typescale-headline-small-font, var(--md-ref-typeface-brand, Roboto)));font-size:var(--md-dialog-headline-size, var(--md-sys-typescale-headline-small-size, 1.5rem));line-height:var(--md-dialog-headline-line-height, var(--md-sys-typescale-headline-small-line-height, 2rem));font-weight:var(--md-dialog-headline-weight, var(--md-sys-typescale-headline-small-weight, var(--md-ref-typeface-weight-regular, 400)));position:relative}slot[name=headline]::slotted(*){align-items:center;align-self:stretch;box-sizing:border-box;display:flex;gap:8px;padding:24px 24px 0}.icon{display:flex}slot[name=icon]::slotted(*){color:var(--md-dialog-icon-color, var(--md-sys-color-secondary, #625b71));fill:currentColor;font-size:var(--md-dialog-icon-size, 24px);margin-top:24px;height:var(--md-dialog-icon-size, 24px);width:var(--md-dialog-icon-size, 24px)}.has-icon slot[name=headline]::slotted(*){justify-content:center;padding-top:16px}.scrollable slot[name=headline]::slotted(*){padding-bottom:16px}.scrollable.has-headline slot[name=content]::slotted(*){padding-top:8px}.container{border-radius:inherit;display:flex;flex-direction:column;flex-grow:1;overflow:hidden;position:relative;transform-origin:top}.container::before{background:var(--md-dialog-container-color, var(--md-sys-color-surface-container-high, #ece6f0));border-radius:inherit;content:"";inset:0;position:absolute}.scroller{display:flex;flex:1;flex-direction:column;overflow:hidden;z-index:1}.scrollable .scroller{overflow-y:scroll}.content{color:var(--md-dialog-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-dialog-supporting-text-font, var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-dialog-supporting-text-size, var(--md-sys-typescale-body-medium-size, 0.875rem));line-height:var(--md-dialog-supporting-text-line-height, var(--md-sys-typescale-body-medium-line-height, 1.25rem));flex:1;font-weight:var(--md-dialog-supporting-text-weight, var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400)));height:min-content;position:relative}slot[name=content]::slotted(*){box-sizing:border-box;padding:24px}.anchor{position:absolute}.top.anchor{top:0}.bottom.anchor{bottom:0}.actions{position:relative}slot[name=actions]::slotted(*){box-sizing:border-box;display:flex;gap:8px;justify-content:flex-end;padding:16px 24px 24px}.has-actions slot[name=content]::slotted(*){padding-bottom:8px}md-divider{display:none;position:absolute}.has-headline.show-top-divider .headline md-divider,.has-actions.show-bottom-divider .actions md-divider{display:flex}.headline md-divider{bottom:0}.actions md-divider{top:0}@media(forced-colors: active){dialog{outline:2px solid WindowText}}
`;

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-dialog
 * @summary Dialogs can require an action, communicate information, or help
 * users accomplish a task. There are two types of dialogs: basic and
 * full-screen.
 *
 * A dialog is a modal window that appears in front of app content to provide
 * critical information or ask for a decision. Dialogs disable all app
 * functionality when they appear, and remain on screen until confirmed,
 * dismissed, or a required action has been taken.
 *
 * Dialogs are purposefully interruptive, so they should be used sparingly.
 * A less disruptive alternative is to use a menu, which provides options
 * without interrupting a user’s experience.
 *
 * On mobile devices only, complex dialogs should be displayed fullscreen.
 *
 * __Example usages:__
 * - Common use cases for basic dialogs include alerts, quick selection, and
 * confirmation.
 * - More complex dialogs may contain actions that require a series of tasks
 * to complete. One example is creating a calendar entry with the event title,
 * date, location, and time.
 *
 * @final
 * @suppress {visibility}
 */
class OscdDialog extends ScopedElementsMixin(Dialog) {
}
OscdDialog.scopedElements = {
    'md-divider': OscdDivider,
};
OscdDialog.styles = [styles$1];

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Separate variable needed for closure.
const switchBaseClass = mixinDelegatesAria(mixinConstraintValidation(mixinFormAssociated(mixinElementInternals(i$4))));
/**
 * @fires input {InputEvent} Fired whenever `selected` changes due to user
 * interaction (bubbles and composed).
 * @fires change {Event} Fired whenever `selected` changes due to user
 * interaction (bubbles).
 */
class Switch extends switchBaseClass {
    constructor() {
        super();
        /**
         * Puts the switch in the selected state and sets the form submission value to
         * the `value` property.
         */
        this.selected = false;
        /**
         * Shows both the selected and deselected icons.
         */
        this.icons = false;
        /**
         * Shows only the selected icon, and not the deselected icon. If `true`,
         * overrides the behavior of the `icons` property.
         */
        this.showOnlySelectedIcon = false;
        /**
         * When true, require the switch to be selected when participating in
         * form submission.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#validation
         */
        this.required = false;
        /**
         * The value associated with this switch on form submission. `null` is
         * submitted when `selected` is `false`.
         */
        this.value = 'on';
        // This click listener does not currently need dispatch hooks since it does
        // not check `event.defaultPrevented`.
        this.addEventListener('click', (event) => {
            if (!isActivationClick(event) || !this.input) {
                return;
            }
            this.focus();
            dispatchActivationClick(this.input);
        });
        // Add the aria keyboard interaction pattern for switch and the Enter key.
        // See https://www.w3.org/WAI/ARIA/apg/patterns/switch/.
        setupDispatchHooks(this, 'keydown');
        this.addEventListener('keydown', (event) => {
            afterDispatch(event, () => {
                const ignoreEvent = event.defaultPrevented || event.key !== 'Enter';
                if (ignoreEvent || this.disabled || !this.input) {
                    return;
                }
                this.input.click();
            });
        });
    }
    render() {
        return b `
      <div class="switch ${e(this.getRenderClasses())}">
        <input
          id="switch"
          class="touch"
          type="checkbox"
          role="switch"
          aria-label=${this.ariaLabel || A}
          ?checked=${this.selected}
          ?disabled=${this.disabled}
          ?required=${this.required}
          @input=${this.handleInput}
          @change=${this.handleChange} />

        <md-focus-ring part="focus-ring" for="switch"></md-focus-ring>
        <span class="track"> ${this.renderHandle()} </span>
      </div>
    `;
    }
    getRenderClasses() {
        return {
            'selected': this.selected,
            'unselected': !this.selected,
            'disabled': this.disabled,
        };
    }
    renderHandle() {
        const classes = {
            'with-icon': this.showOnlySelectedIcon ? this.selected : this.icons,
        };
        return b `
      ${this.renderTouchTarget()}
      <span class="handle-container">
        <md-ripple for="switch" ?disabled="${this.disabled}"></md-ripple>
        <span class="handle ${e(classes)}">
          ${this.shouldShowIcons() ? this.renderIcons() : b ``}
        </span>
      </span>
    `;
    }
    renderIcons() {
        return b `
      <div class="icons">
        ${this.renderOnIcon()}
        ${this.showOnlySelectedIcon ? b `` : this.renderOffIcon()}
      </div>
    `;
    }
    /**
     * https://fonts.google.com/icons?selected=Material%20Symbols%20Outlined%3Acheck%3AFILL%400%3Bwght%40500%3BGRAD%400%3Bopsz%4024
     */
    renderOnIcon() {
        return b `
      <slot class="icon icon--on" name="on-icon">
        <svg viewBox="0 0 24 24">
          <path
            d="M9.55 18.2 3.65 12.3 5.275 10.675 9.55 14.95 18.725 5.775 20.35 7.4Z" />
        </svg>
      </slot>
    `;
    }
    /**
     * https://fonts.google.com/icons?selected=Material%20Symbols%20Outlined%3Aclose%3AFILL%400%3Bwght%40500%3BGRAD%400%3Bopsz%4024
     */
    renderOffIcon() {
        return b `
      <slot class="icon icon--off" name="off-icon">
        <svg viewBox="0 0 24 24">
          <path
            d="M6.4 19.2 4.8 17.6 10.4 12 4.8 6.4 6.4 4.8 12 10.4 17.6 4.8 19.2 6.4 13.6 12 19.2 17.6 17.6 19.2 12 13.6Z" />
        </svg>
      </slot>
    `;
    }
    renderTouchTarget() {
        return b `<span class="touch"></span>`;
    }
    shouldShowIcons() {
        return this.icons || this.showOnlySelectedIcon;
    }
    handleInput(event) {
        const target = event.target;
        this.selected = target.checked;
        // <input> 'input' event bubbles and is composed, don't re-dispatch it.
    }
    handleChange(event) {
        // <input> 'change' event is not composed, re-dispatch it.
        redispatchEvent(this, event);
    }
    [getFormValue]() {
        return this.selected ? this.value : null;
    }
    [getFormState]() {
        return String(this.selected);
    }
    formResetCallback() {
        // The selected property does not reflect, so the original attribute set by
        // the user is used to determine the default value.
        this.selected = this.hasAttribute('selected');
    }
    formStateRestoreCallback(state) {
        this.selected = state === 'true';
    }
    [createValidator]() {
        return new CheckboxValidator(() => ({
            checked: this.selected,
            required: this.required,
        }));
    }
    [getValidityAnchor]() {
        return this.input;
    }
}
/** @nocollapse */
Switch.shadowRootOptions = {
    mode: 'open',
    delegatesFocus: true,
};
__decorate([
    n$3({ type: Boolean })
], Switch.prototype, "selected", void 0);
__decorate([
    n$3({ type: Boolean })
], Switch.prototype, "icons", void 0);
__decorate([
    n$3({ type: Boolean, attribute: 'show-only-selected-icon' })
], Switch.prototype, "showOnlySelectedIcon", void 0);
__decorate([
    n$3({ type: Boolean })
], Switch.prototype, "required", void 0);
__decorate([
    n$3()
], Switch.prototype, "value", void 0);
__decorate([
    e$4('input')
], Switch.prototype, "input", void 0);

/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./switch/internal/switch-styles.css.
const styles = i$7 `@layer styles, hcm;@layer styles{:host{display:inline-flex;outline:none;vertical-align:top;-webkit-tap-highlight-color:rgba(0,0,0,0);cursor:pointer}:host([disabled]){cursor:default}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--md-switch-track-height, 32px))/2) 0px}md-focus-ring{--md-focus-ring-shape-start-start: var(--md-switch-track-shape-start-start, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)));--md-focus-ring-shape-start-end: var(--md-switch-track-shape-start-end, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)));--md-focus-ring-shape-end-end: var(--md-switch-track-shape-end-end, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)));--md-focus-ring-shape-end-start: var(--md-switch-track-shape-end-start, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)))}.switch{align-items:center;display:inline-flex;flex-shrink:0;position:relative;width:var(--md-switch-track-width, 52px);height:var(--md-switch-track-height, 32px);border-start-start-radius:var(--md-switch-track-shape-start-start, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)));border-start-end-radius:var(--md-switch-track-shape-start-end, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)));border-end-end-radius:var(--md-switch-track-shape-end-end, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)));border-end-start-radius:var(--md-switch-track-shape-end-start, var(--md-switch-track-shape, var(--md-sys-shape-corner-full, 9999px)))}input{appearance:none;height:max(100%,var(--md-switch-touch-target-size, 48px));outline:none;margin:0;position:absolute;width:max(100%,var(--md-switch-touch-target-size, 48px));z-index:1;cursor:inherit;top:50%;left:50%;transform:translate(-50%, -50%)}:host([touch-target=none]) input{display:none}}@layer styles{.track{position:absolute;width:100%;height:100%;box-sizing:border-box;border-radius:inherit;display:flex;justify-content:center;align-items:center}.track::before{content:"";display:flex;position:absolute;height:100%;width:100%;border-radius:inherit;box-sizing:border-box;transition-property:opacity,background-color;transition-timing-function:linear;transition-duration:67ms}.disabled .track{background-color:rgba(0,0,0,0);border-color:rgba(0,0,0,0)}.disabled .track::before,.disabled .track::after{transition:none;opacity:var(--md-switch-disabled-track-opacity, 0.12)}.disabled .track::before{background-clip:content-box}.selected .track::before{background-color:var(--md-switch-selected-track-color, var(--md-sys-color-primary, #6750a4))}.selected:hover .track::before{background-color:var(--md-switch-selected-hover-track-color, var(--md-sys-color-primary, #6750a4))}.selected:focus-within .track::before{background-color:var(--md-switch-selected-focus-track-color, var(--md-sys-color-primary, #6750a4))}.selected:active .track::before{background-color:var(--md-switch-selected-pressed-track-color, var(--md-sys-color-primary, #6750a4))}.selected.disabled .track{background-clip:border-box}.selected.disabled .track::before{background-color:var(--md-switch-disabled-selected-track-color, var(--md-sys-color-on-surface, #1d1b20))}.unselected .track::before{background-color:var(--md-switch-track-color, var(--md-sys-color-surface-container-highest, #e6e0e9));border-color:var(--md-switch-track-outline-color, var(--md-sys-color-outline, #79747e));border-style:solid;border-width:var(--md-switch-track-outline-width, 2px)}.unselected:hover .track::before{background-color:var(--md-switch-hover-track-color, var(--md-sys-color-surface-container-highest, #e6e0e9));border-color:var(--md-switch-hover-track-outline-color, var(--md-sys-color-outline, #79747e))}.unselected:focus-visible .track::before{background-color:var(--md-switch-focus-track-color, var(--md-sys-color-surface-container-highest, #e6e0e9));border-color:var(--md-switch-focus-track-outline-color, var(--md-sys-color-outline, #79747e))}.unselected:active .track::before{background-color:var(--md-switch-pressed-track-color, var(--md-sys-color-surface-container-highest, #e6e0e9));border-color:var(--md-switch-pressed-track-outline-color, var(--md-sys-color-outline, #79747e))}.unselected.disabled .track::before{background-color:var(--md-switch-disabled-track-color, var(--md-sys-color-surface-container-highest, #e6e0e9));border-color:var(--md-switch-disabled-track-outline-color, var(--md-sys-color-on-surface, #1d1b20))}}@layer hcm{@media(forced-colors: active){.selected .track::before{background:ButtonText;border-color:ButtonText}.disabled .track::before{border-color:GrayText;opacity:1}.disabled.selected .track::before{background:GrayText}}}@layer styles{.handle-container{display:flex;place-content:center;place-items:center;position:relative;transition:margin 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275)}.selected .handle-container{margin-inline-start:calc(var(--md-switch-track-width, 52px) - var(--md-switch-track-height, 32px))}.unselected .handle-container{margin-inline-end:calc(var(--md-switch-track-width, 52px) - var(--md-switch-track-height, 32px))}.disabled .handle-container{transition:none}.handle{border-start-start-radius:var(--md-switch-handle-shape-start-start, var(--md-switch-handle-shape, var(--md-sys-shape-corner-full, 9999px)));border-start-end-radius:var(--md-switch-handle-shape-start-end, var(--md-switch-handle-shape, var(--md-sys-shape-corner-full, 9999px)));border-end-end-radius:var(--md-switch-handle-shape-end-end, var(--md-switch-handle-shape, var(--md-sys-shape-corner-full, 9999px)));border-end-start-radius:var(--md-switch-handle-shape-end-start, var(--md-switch-handle-shape, var(--md-sys-shape-corner-full, 9999px)));height:var(--md-switch-handle-height, 16px);width:var(--md-switch-handle-width, 16px);transform-origin:center;transition-property:height,width;transition-duration:250ms,250ms;transition-timing-function:cubic-bezier(0.2, 0, 0, 1),cubic-bezier(0.2, 0, 0, 1);z-index:0}.handle::before{content:"";display:flex;inset:0;position:absolute;border-radius:inherit;box-sizing:border-box;transition:background-color 67ms linear}.disabled .handle,.disabled .handle::before{transition:none}.selected .handle{height:var(--md-switch-selected-handle-height, 24px);width:var(--md-switch-selected-handle-width, 24px)}.handle.with-icon{height:var(--md-switch-with-icon-handle-height, 24px);width:var(--md-switch-with-icon-handle-width, 24px)}.selected:not(.disabled):active .handle,.unselected:not(.disabled):active .handle{height:var(--md-switch-pressed-handle-height, 28px);width:var(--md-switch-pressed-handle-width, 28px);transition-timing-function:linear;transition-duration:100ms}.selected .handle::before{background-color:var(--md-switch-selected-handle-color, var(--md-sys-color-on-primary, #fff))}.selected:hover .handle::before{background-color:var(--md-switch-selected-hover-handle-color, var(--md-sys-color-primary-container, #eaddff))}.selected:focus-within .handle::before{background-color:var(--md-switch-selected-focus-handle-color, var(--md-sys-color-primary-container, #eaddff))}.selected:active .handle::before{background-color:var(--md-switch-selected-pressed-handle-color, var(--md-sys-color-primary-container, #eaddff))}.selected.disabled .handle::before{background-color:var(--md-switch-disabled-selected-handle-color, var(--md-sys-color-surface, #fef7ff));opacity:var(--md-switch-disabled-selected-handle-opacity, 1)}.unselected .handle::before{background-color:var(--md-switch-handle-color, var(--md-sys-color-outline, #79747e))}.unselected:hover .handle::before{background-color:var(--md-switch-hover-handle-color, var(--md-sys-color-on-surface-variant, #49454f))}.unselected:focus-within .handle::before{background-color:var(--md-switch-focus-handle-color, var(--md-sys-color-on-surface-variant, #49454f))}.unselected:active .handle::before{background-color:var(--md-switch-pressed-handle-color, var(--md-sys-color-on-surface-variant, #49454f))}.unselected.disabled .handle::before{background-color:var(--md-switch-disabled-handle-color, var(--md-sys-color-on-surface, #1d1b20));opacity:var(--md-switch-disabled-handle-opacity, 0.38)}md-ripple{border-radius:var(--md-switch-state-layer-shape, var(--md-sys-shape-corner-full, 9999px));height:var(--md-switch-state-layer-size, 40px);inset:unset;width:var(--md-switch-state-layer-size, 40px)}.selected md-ripple{--md-ripple-hover-color: var(--md-switch-selected-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--md-ripple-pressed-color: var(--md-switch-selected-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--md-ripple-hover-opacity: var(--md-switch-selected-hover-state-layer-opacity, 0.08);--md-ripple-pressed-opacity: var(--md-switch-selected-pressed-state-layer-opacity, 0.12)}.unselected md-ripple{--md-ripple-hover-color: var(--md-switch-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-pressed-color: var(--md-switch-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-hover-opacity: var(--md-switch-hover-state-layer-opacity, 0.08);--md-ripple-pressed-opacity: var(--md-switch-pressed-state-layer-opacity, 0.12)}}@layer hcm{@media(forced-colors: active){.unselected .handle::before{background:ButtonText}.disabled .handle::before{opacity:1}.disabled.unselected .handle::before{background:GrayText}}}@layer styles{.icons{position:relative;height:100%;width:100%}.icon{position:absolute;inset:0;margin:auto;display:flex;align-items:center;justify-content:center;fill:currentColor;transition:fill 67ms linear,opacity 33ms linear,transform 167ms cubic-bezier(0.2, 0, 0, 1);opacity:0}.disabled .icon{transition:none}.selected .icon--on,.unselected .icon--off{opacity:1}.unselected .handle:not(.with-icon) .icon--on{transform:rotate(-45deg)}.icon--off{width:var(--md-switch-icon-size, 16px);height:var(--md-switch-icon-size, 16px);color:var(--md-switch-icon-color, var(--md-sys-color-surface-container-highest, #e6e0e9))}.unselected:hover .icon--off{color:var(--md-switch-hover-icon-color, var(--md-sys-color-surface-container-highest, #e6e0e9))}.unselected:focus-within .icon--off{color:var(--md-switch-focus-icon-color, var(--md-sys-color-surface-container-highest, #e6e0e9))}.unselected:active .icon--off{color:var(--md-switch-pressed-icon-color, var(--md-sys-color-surface-container-highest, #e6e0e9))}.unselected.disabled .icon--off{color:var(--md-switch-disabled-icon-color, var(--md-sys-color-surface-container-highest, #e6e0e9));opacity:var(--md-switch-disabled-icon-opacity, 0.38)}.icon--on{width:var(--md-switch-selected-icon-size, 16px);height:var(--md-switch-selected-icon-size, 16px);color:var(--md-switch-selected-icon-color, var(--md-sys-color-on-primary-container, #21005d))}.selected:hover .icon--on{color:var(--md-switch-selected-hover-icon-color, var(--md-sys-color-on-primary-container, #21005d))}.selected:focus-within .icon--on{color:var(--md-switch-selected-focus-icon-color, var(--md-sys-color-on-primary-container, #21005d))}.selected:active .icon--on{color:var(--md-switch-selected-pressed-icon-color, var(--md-sys-color-on-primary-container, #21005d))}.selected.disabled .icon--on{color:var(--md-switch-disabled-selected-icon-color, var(--md-sys-color-on-surface, #1d1b20));opacity:var(--md-switch-disabled-selected-icon-opacity, 0.38)}}@layer hcm{@media(forced-colors: active){.icon--off{fill:Canvas}.icon--on{fill:ButtonText}.disabled.unselected .icon--off,.disabled.selected .icon--on{opacity:1}.disabled .icon--on{fill:GrayText}}}
`;

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @license
 * Copyright 2026 OMICRON electronics GmbH
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @tagname oscd-switch
 * @summary Switches toggle the state of a single item on or off.
 *
 * There's one type of switch in Material. Use this selection control when the
 * user needs to toggle a single item on or off.
 *
 * @final
 * @suppress {visibility}
 */
class OscdSwitch extends ScopedElementsMixin(Switch) {
}
OscdSwitch.scopedElements = {
    'md-ripple': OscdRipple,
    'md-focus-ring': OscdFocusRing,
};
OscdSwitch.styles = [styles];

/**
 * Preferences remembered per browser. Storage may be unavailable (private
 * mode, blocked or full): reading then gives nothing and writing does
 * nothing, as all stored values are optional.
 */
/** The stored value, or `null` when there is none or storage is unavailable. */
function readStored(key) {
    try {
        return localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
/** Stores a value if storage is available. */
function writeStored(key, value) {
    try {
        localStorage.setItem(key, value);
    }
    catch {
        // Unavailable: the preference is just not remembered.
    }
}

/** Browser storage key remembering whether message information is shown. */
const detailsStorageKey = 'oscd-editor-map-communication:message-information';
/** Browser storage key remembering whether quality inputs are shown. */
const qualityStorageKey = 'oscd-editor-map-communication:show-quality';
/** A remembered on/off choice; off unless stored as on. */
function loadChoice(key) {
    return readStored(key) === 'on';
}
function saveChoice(key, on) {
    writeStored(key, on ? 'on' : 'off');
}
/** True for inputs bound to a quality attribute (`q`). */
function isQualityInput(input) {
    const daName = input.getAttribute('daName') ?? '';
    return daName === 'q' || daName.endsWith('.q');
}
/**
 * Dialog with the details of one connection: communication parameters,
 * subscription supervision and the mapping of each input, with actions to
 * remove single inputs or all of them.
 *
 * @fires map-remove-inputs - detail: `{ inputs }` the user asked to remove
 * @fires map-connection-close - the dialog was closed
 */
class MapConnectionDialog extends ScopedElementsMixin(i$4) {
    constructor() {
        super(...arguments);
        /** Whether quality inputs are listed; remembered per browser. */
        this.showQuality = loadChoice(qualityStorageKey);
        /** Whether message information is expanded; remembered per browser. */
        this.detailsOpen = loadChoice(detailsStorageKey);
    }
    handleDetailsToggle(event) {
        const { open } = event.target;
        if (open === this.detailsOpen) {
            return;
        }
        this.detailsOpen = open;
        saveChoice(detailsStorageKey, open);
    }
    handleClosed() {
        this.dispatchEvent(new CustomEvent('map-connection-close', { bubbles: true, composed: true }));
    }
    removeInputs(inputs) {
        this.dispatchEvent(new CustomEvent('map-remove-inputs', {
            detail: { inputs },
            bubbles: true,
            composed: true,
        }));
    }
    detailRows(connection) {
        const { controlBlock, comm } = connection;
        const rows = [
            [msg('Data set'), controlBlock.getAttribute('datSet')],
            [msg('Configuration revision'), controlBlock.getAttribute('confRev')],
            [msg('GOOSE ID'), controlBlock.getAttribute('appID')],
            [msg('SMV ID'), controlBlock.getAttribute('smvID')],
            [msg('Report ID'), controlBlock.getAttribute('rptID')],
            [msg('VLAN ID'), comm.vlanId ? formatVlan(comm.vlanId) : undefined],
            [msg('VLAN priority'), comm.vlanPriority],
            [msg('Application ID'), comm.appId],
            [msg('MAC address'), comm.macAddress],
            [msg('Minimum time'), comm.minTime],
            [msg('Maximum time'), comm.maxTime],
        ];
        return rows.filter((row) => !!row[1]);
    }
    /** Key values shown on the folded message information. */
    detailPreview(connection) {
        const { controlBlock, comm } = connection;
        const values = [
            comm.vlanId ? `VLAN ${formatVlan(comm.vlanId)}` : undefined,
            comm.appId ? `APPID ${comm.appId}` : undefined,
            comm.macAddress,
            controlBlock.getAttribute('datSet') ?? undefined,
        ].filter((value) => !!value);
        return values.slice(0, 3).join(' · ');
    }
    renderDetails(connection) {
        return b `<table class="details">
      <tbody>
        ${this.detailRows(connection).map(([label, value]) => b `<tr>
                <th scope="row">${label}</th>
                <td>${value}</td>
              </tr>`)}
      </tbody>
    </table>`;
    }
    renderSupervision(connection) {
        const supervision = existingSupervision(connection.controlBlock, connection.target.ied);
        if (!supervision) {
            return A;
        }
        const desc = supervision.getAttribute('desc') ??
            supervision.querySelector(':scope > DOI')?.getAttribute('desc');
        const name = `${supervision.closest('LDevice')?.getAttribute('inst') ?? ''}/${supervision.getAttribute('prefix') ?? ''}${supervision.getAttribute('lnClass')}${supervision.getAttribute('inst') ?? ''}`;
        return b `<p class="supervision">
      <oscd-icon>monitor_heart</oscd-icon>
      ${msg(str `Supervision: ${name}`)}${desc ? ` (${desc})` : A}
    </p>`;
    }
    renderText({ reference, desc }) {
        return b `<span class="reference">${reference}</span>${desc
            ? b `<span class="desc">${desc}</span>`
            : A}`;
    }
    renderInputs(connection) {
        const inputs = connection.inputs
            .filter(isBound)
            .filter(input => this.showQuality || !isQualityInput(input));
        return b `<table class="inputs">
      <thead>
        <tr>
          <th scope="col">${msg('Source')}</th>
          <th scope="col">${msg('Destination')}</th>
          <th scope="col"><span class="visually-hidden">${msg('Remove')}</span></th>
        </tr>
      </thead>
      <tbody>
        ${inputs.map(input => b `<tr>
              <td>${this.renderText(inputSource(input, connection.controlBlock))}</td>
              <td>${this.renderText(inputDestination(input))}</td>
              <td>
                <oscd-icon-button
                  class="remove-input"
                  aria-label=${msg('Remove input')}
                  title=${msg('Remove input')}
                  @click=${() => this.removeInputs([input])}
                  ><oscd-icon>delete</oscd-icon></oscd-icon-button
                >
              </td>
            </tr>`)}
      </tbody>
    </table>`;
    }
    renderContent(connection) {
        return b `<div slot="headline" class="headline">
        <oscd-icon>${serviceIcons[connection.service]}</oscd-icon>
        ${connectionTitle(connection)}
      </div>
      <div slot="content" class="content">
        ${this.renderSupervision(connection)}
        <details
          ?open=${this.detailsOpen}
          @toggle=${this.handleDetailsToggle}
        >
          <summary title=${this.detailsOpen
            ? msg('Hide message information')
            : msg('Show message information')}>
            <oscd-icon class="chevron">chevron_right</oscd-icon>
            <span class="summary-title">${msg('Message information')}</span>
            ${this.detailsOpen
            ? A
            : b `<span class="preview">${this.detailPreview(connection)}</span>`}
          </summary>
          ${this.renderDetails(connection)}
        </details>
        <label class="quality">
          ${msg('Show quality')}
          <oscd-switch
            .selected=${this.showQuality}
            @change=${(event) => {
            this.showQuality = event.target.selected;
            saveChoice(qualityStorageKey, this.showQuality);
        }}
          ></oscd-switch>
        </label>
        ${this.renderInputs(connection)}
      </div>
      <div slot="actions">
        <oscd-text-button
          class="remove-all"
          @click=${() => this.removeInputs(connection.inputs)}
          >${msg('Remove all')}<oscd-icon slot="icon"
            >delete_forever</oscd-icon
          ></oscd-text-button
        >
        <oscd-text-button class="close" @click=${() => this.dialog.close()}
          >${msg('Close')}</oscd-text-button
        >
      </div>`;
    }
    render() {
        const { connection } = this;
        return b `<oscd-dialog
      .open=${connection !== undefined}
      @closed=${this.handleClosed}
    >
      ${connection ? this.renderContent(connection) : A}
    </oscd-dialog>`;
    }
}
MapConnectionDialog.scopedElements = {
    'oscd-dialog': OscdDialog,
    'oscd-icon': OscdIcon,
    'oscd-icon-button': OscdIconButton,
    'oscd-switch': OscdSwitch,
    'oscd-text-button': OscdTextButton,
};
MapConnectionDialog.styles = i$7 `
    oscd-dialog {
      width: min(calc(100vw - 48px), 1100px);
      max-width: min(calc(100vw - 48px), 1100px);
      max-height: calc(100vh - 48px);
      --md-dialog-headline-size: 1.5rem;
      --md-dialog-supporting-text-size: 1rem;
      --md-dialog-supporting-text-line-height: 1.5rem;
    }

    .content {
      font-size: 1rem;
      color: var(--oscd-base00);
    }

    .headline {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .supervision {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0 0 8px;
    }

    details {
      margin-bottom: 12px;
      border: 1px solid var(--oscd-base2);
      border-radius: var(--oscd-shape, 4px);
    }

    /* A full width row with a chevron: clearly something to open. */
    summary {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px 8px 8px;
      cursor: pointer;
      list-style: none;
      border-radius: var(--oscd-shape, 4px);
    }

    summary::-webkit-details-marker {
      display: none;
    }

    summary:hover {
      background: var(--oscd-base2);
    }

    summary:focus-visible {
      outline: 2px solid var(--oscd-primary);
      outline-offset: -2px;
    }

    .chevron {
      flex: none;
      transition: transform 0.15s;
    }

    details[open] .chevron {
      transform: rotate(90deg);
    }

    .summary-title {
      flex: none;
      font-weight: 500;
    }

    .preview {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--oscd-base01);
      font-size: 0.9em;
    }

    details .details {
      margin: 0 12px 8px 32px;
    }

    .details {
      width: auto;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th,
    td {
      padding: 6px 12px;
      text-align: left;
      vertical-align: top;
    }

    .details th {
      font-weight: 500;
      white-space: nowrap;
    }

    .inputs thead th {
      border-bottom: 1px solid var(--oscd-base1);
      font-weight: 500;
    }

    .inputs tbody tr:nth-child(even) {
      background: var(--oscd-base2);
    }

    .reference {
      display: block;
      font-family: var(--oscd-text-font-mono);
      font-size: 0.95em;
      color: var(--oscd-base02);
      word-break: break-all;
    }

    .desc {
      display: block;
      font-size: 0.9em;
      color: var(--oscd-base01);
    }

    .quality {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }

    .remove-all {
      --md-text-button-label-text-color: var(--oscd-error);
      --md-text-button-icon-color: var(--oscd-error);
    }

    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
    }
  `;
__decorate([
    n$3({ attribute: false })
], MapConnectionDialog.prototype, "connection", void 0);
__decorate([
    r$2()
], MapConnectionDialog.prototype, "showQuality", void 0);
__decorate([
    r$2()
], MapConnectionDialog.prototype, "detailsOpen", void 0);
__decorate([
    e$4('oscd-dialog')
], MapConnectionDialog.prototype, "dialog", void 0);

const lDevicePath = ':root > IED > AccessPoint > Server > LDevice';
/**
 * Maps IED names to the SLD `Reference type="IED"` elements placing them on a
 * diagram. A reference's `id` is the IED's identity, which is its name. The
 * first reference wins if an IED is placed more than once.
 */
function iedReferenceMap(doc) {
    const map = new Map();
    iedReferences(doc).forEach((reference) => {
        const id = reference.getAttributeNS(sldNs, 'id');
        if (id && !map.has(id)) {
            map.set(id, reference);
        }
    });
    return map;
}
function serviceOf(controlBlock) {
    if (controlBlock.tagName === 'GSEControl') {
        return 'GOOSE';
    }
    if (controlBlock.tagName === 'SampledValueControl') {
        return 'SV';
    }
    return 'Report';
}
/** `serviceType` values an ExtRef may carry for a given control block kind. */
const extRefServiceTypes = {
    GSEControl: 'GOOSE',
    SampledValueControl: 'SMV',
};
function extRefKey(iedName, ldInst, prefix, lnClass, lnInst, cbName) {
    return [iedName, ldInst, prefix, lnClass, lnInst, cbName].join('|');
}
/**
 * Indexes every ExtRef naming a source control block (`srcCBName`, Edition 2)
 * by the control block it refers to. `srcLDInst` falls back to `ldInst` and
 * `srcLNClass` to `LLN0`, as in IEC 61850-6.
 */
function indexExtRefs(doc) {
    const index = new Map();
    doc
        .querySelectorAll(`${lDevicePath} > LN0 > Inputs > ExtRef[srcCBName], ${lDevicePath} > LN > Inputs > ExtRef[srcCBName]`)
        .forEach((extRef) => {
        const iedName = extRef.getAttribute('iedName');
        const ldInst = extRef.getAttribute('srcLDInst') ?? extRef.getAttribute('ldInst');
        if (!iedName || !ldInst) {
            return;
        }
        const key = extRefKey(iedName, ldInst, extRef.getAttribute('srcPrefix') ?? '', extRef.getAttribute('srcLNClass') ?? 'LLN0', extRef.getAttribute('srcLNInst') ?? '', extRef.getAttribute('srcCBName'));
        const bucket = index.get(key);
        if (bucket) {
            bucket.push(extRef);
        }
        else {
            index.set(key, [extRef]);
        }
    });
    return index;
}
function controlBlockKey(iedName, controlBlock) {
    const anyLn = controlBlock.parentElement;
    return extRefKey(iedName, controlBlock.closest('LDevice')?.getAttribute('inst') ?? '', anyLn.getAttribute('prefix') ?? '', anyLn.getAttribute('lnClass') ?? '', anyLn.getAttribute('inst') ?? '', controlBlock.getAttribute('name') ?? '');
}
function matchesServiceType(extRef, controlBlock) {
    const serviceType = extRef.getAttribute('serviceType');
    return (serviceType === null ||
        serviceType === extRefServiceTypes[controlBlock.tagName]);
}
/** Groups inputs by the IED they live in (ExtRef) or name (ClientLN). */
function groupByTarget(inputs, targetName) {
    const groups = new Map();
    inputs.forEach((input) => {
        const name = targetName(input);
        if (!name) {
            return;
        }
        const group = groups.get(name);
        if (group) {
            group.push(input);
        }
        else {
            groups.set(name, [input]);
        }
    });
    return groups;
}
/**
 * Builds every connection in the document in a single pass over control
 * blocks, ExtRefs and ClientLNs:
 * - GOOSE / SV: `GSEControl` / `SampledValueControl` in `LN0` matched against
 *   subscribing `ExtRef` elements (Edition 2 `src*` attributes)
 * - Report: `ReportControl` (in `LN0` or `LN`) to each `ClientLN`
 *
 * Inputs are grouped per target IED. Targets that are not IEDs in this
 * document are ignored.
 */
function buildConnections(doc) {
    const ieds = new Map();
    doc.querySelectorAll(':root > IED[name]').forEach((ied) => {
        ieds.set(ied.getAttribute('name'), ied);
    });
    const references = iedReferenceMap(doc);
    const extRefs = indexExtRefs(doc);
    const addresses = commAddressIndex(doc);
    const endpoint = (name) => {
        const ied = ieds.get(name);
        return ied ? { ied, name, reference: references.get(name) ?? null } : null;
    };
    const connections = [];
    const addConnections = (controlBlock, source, groups, comm) => {
        const cbIdentity = identity(controlBlock);
        groups.forEach((inputs, targetName) => {
            const target = endpoint(targetName);
            if (!target) {
                return;
            }
            connections.push({
                id: `${cbIdentity}→${targetName}`,
                service: serviceOf(controlBlock),
                controlBlock,
                comm,
                source,
                target,
                inputs,
            });
        });
    };
    doc
        .querySelectorAll(`${lDevicePath} > LN0 > GSEControl, ${lDevicePath} > LN0 > SampledValueControl, ${lDevicePath} > LN0 > ReportControl, ${lDevicePath} > LN > ReportControl`)
        .forEach((controlBlock) => {
        const sourceName = controlBlock.closest('IED').getAttribute('name');
        const source = sourceName ? endpoint(sourceName) : null;
        if (!source) {
            return;
        }
        if (controlBlock.tagName === 'ReportControl') {
            const clientLns = Array.from(controlBlock.querySelectorAll(':scope > RptEnabled > ClientLN'));
            addConnections(controlBlock, source, groupByTarget(clientLns, clientLn => clientLn.getAttribute('iedName')), {});
            return;
        }
        const subscribers = (extRefs.get(controlBlockKey(source.name, controlBlock)) ?? []).filter(extRef => matchesServiceType(extRef, controlBlock));
        if (subscribers.length === 0) {
            return;
        }
        addConnections(controlBlock, source, groupByTarget(subscribers, extRef => extRef.closest('IED').getAttribute('name')), readCommParams(findCommAddress(controlBlock, addresses)));
    });
    return connections;
}

/** A CSS attribute selector matching an element id exactly. */
function idSelector(id) {
    return `[id=${JSON.stringify(id)}]`;
}
/**
 * CSS for the SLD viewer's shadow root that fades the primary diagram
 * (equipment, wiring, bays, voltage levels and their labels) so the IEDs and
 * connections stand out. IED symbols, the labels of the given IEDs and the
 * elements with the given ids (highlighted equipment) keep full strength.
 *
 * The viewer nests IEDs and equipment inside bay and voltage level groups,
 * so groups cannot be faded as a whole (their opacity would apply to the
 * IEDs too). Instead every drawn shape outside IED groups and symbol
 * definitions is faded. That rule has no specificity, so the rules keeping
 * labels and highlights at full strength always win.
 */
function fadeRules(ieds, keep = []) {
    const kept = [...ieds.map(name => `label:${name}`), ...keep].map(id => `#sld g${idSelector(id)} *`);
    return [
        ':where(#sld g:not(.ied):not(defs *)) > :where(:not(g, title)) {',
        '  opacity: var(--oscd-map-diagram-opacity, 0.7);',
        '}',
        kept.length > 0 ? `${kept.join(',\n')} { opacity: 1; }` : '',
    ]
        .filter(Boolean)
        .join('\n');
}

/**
 * Exports the map as drawn: the single line diagram with the connections on
 * top, as a self-contained SVG, a PNG or a PDF.
 *
 * The diagram and the overlay are styled by stylesheets in shadow roots and
 * by theme variables, which a standalone file cannot see. Every exported
 * element therefore gets its computed presentation inlined, so the file
 * looks like the screen in any viewer.
 */
const svgNs = 'http://www.w3.org/2000/svg';
/** Presentation properties copied from the screen into the exported file. */
const presentation = [
    'fill',
    'fill-opacity',
    'stroke',
    'stroke-width',
    'stroke-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'opacity',
    'color',
    'font-family',
    'font-size',
    'font-weight',
    'shape-rendering',
];
/** Interaction-only parts of the diagram and overlay, left out of exports. */
const interactive = '.hit, .handle, .preview, .port, title, style';
/**
 * Copies `source`'s computed presentation onto `clone`, recursively, and
 * drops what is hidden or only there for interaction. Both trees must have
 * the same shape.
 */
function inlineStyles(source, clone) {
    const style = getComputedStyle(source);
    const declarations = presentation
        .map(property => [property, style.getPropertyValue(property)])
        .filter(([, value]) => value !== '')
        .map(([property, value]) => `${property}: ${value}`);
    clone.setAttribute('style', declarations.join('; '));
    clone.removeAttribute('class');
    const sources = Array.from(source.children);
    const clones = Array.from(clone.children);
    sources.forEach((child, i) => {
        const copy = clones[i];
        const hidden = getComputedStyle(child);
        if (child.matches(interactive) ||
            hidden.display === 'none' ||
            hidden.visibility === 'hidden') {
            copy.remove();
            return;
        }
        inlineStyles(child, copy);
    });
}
/** A styled, standalone copy of a rendered SVG's content. */
function exportedGroup(svg) {
    const group = document.createElementNS(svgNs, 'g');
    const clone = svg.cloneNode(true);
    inlineStyles(svg, clone);
    group.setAttribute('style', clone.getAttribute('style') ?? '');
    group.append(...Array.from(clone.childNodes));
    return group;
}
/**
 * Builds a standalone SVG of the given layers (bottom first) drawn in one
 * coordinate system, cropped to `viewBox` and `scale` pixels per unit.
 */
function composeSvg(layers, [x, y, width, height], scale, background) {
    const root = document.createElementNS(svgNs, 'svg');
    root.setAttribute('xmlns', svgNs);
    root.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    root.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
    root.setAttribute('width', `${Math.round(width * scale)}`);
    root.setAttribute('height', `${Math.round(height * scale)}`);
    const backdrop = document.createElementNS(svgNs, 'rect');
    backdrop.setAttribute('x', `${x}`);
    backdrop.setAttribute('y', `${y}`);
    backdrop.setAttribute('width', `${width}`);
    backdrop.setAttribute('height', `${height}`);
    backdrop.setAttribute('fill', background);
    root.append(backdrop, ...layers.map(exportedGroup));
    return new XMLSerializer().serializeToString(root);
}
/**
 * The part of a diagram of `dimensions` grid units visible in a viewport,
 * given the bounding rectangles of the viewport and of the diagram on
 * screen.
 */
function visibleBox(viewport, diagram, gridSize, [width, height]) {
    const clamp = (value, max) => Math.min(max, Math.max(0, value));
    const x0 = clamp((viewport.left - diagram.left) / gridSize, width);
    const y0 = clamp((viewport.top - diagram.top) / gridSize, height);
    const x1 = clamp((viewport.right - diagram.left) / gridSize, width);
    const y1 = clamp((viewport.bottom - diagram.top) / gridSize, height);
    return [x0, y0, x1 - x0, y1 - y0];
}
/** Largest image side in pixels; larger exports are scaled down to fit. */
const maxPngSize = 8192;
/**
 * Draws an SVG document onto a canvas of `width` × `height` CSS pixels
 * times `pixelRatio`, scaled down if a side would exceed `maxPngSize`.
 */
async function renderCanvas(svgText, width, height, pixelRatio) {
    const ratio = Math.min(pixelRatio, maxPngSize / Math.max(1, width), maxPngSize / Math.max(1, height));
    const url = URL.createObjectURL(new Blob([svgText], { type: 'image/svg+xml' }));
    try {
        const image = new Image();
        image.src = url;
        await image.decode();
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(width * ratio));
        canvas.height = Math.max(1, Math.round(height * ratio));
        canvas
            .getContext('2d')
            .drawImage(image, 0, 0, canvas.width, canvas.height);
        return canvas;
    }
    finally {
        URL.revokeObjectURL(url);
    }
}
/** Renders an SVG document to a PNG of at most `maxPngSize` per side. */
async function svgToPng(svgText, width, height, pixelRatio = 2) {
    const canvas = await renderCanvas(svgText, width, height, pixelRatio);
    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('PNG could not be created')), 'image/png');
    });
}
/** Points per CSS pixel (72 / 96). */
const pointsPerPixel = 0.75;
async function deflate(bytes) {
    const stream = new Blob([bytes])
        .stream()
        .pipeThrough(new CompressionStream('deflate'));
    return new Uint8Array(await new Response(stream).arrayBuffer());
}
/**
 * Writes a one page PDF showing an RGB image (`rgb`, `columns` × `rows`
 * pixels, losslessly compressed) over a page of `width` × `height` points.
 * No library is needed: the file is a catalog, a page tree, one page, the
 * image and the content stream drawing it.
 */
async function imagePdf(rgb, columns, rows, width, height) {
    const encoder = new TextEncoder();
    const image = await deflate(rgb);
    const w = Number(width.toFixed(2));
    const h = Number(height.toFixed(2));
    const content = encoder.encode(`q ${w} 0 0 ${h} 0 0 cm /Im0 Do Q`);
    const objects = [
        ['<< /Type /Catalog /Pages 2 0 R >>'],
        ['<< /Type /Pages /Kids [3 0 R] /Count 1 >>'],
        [
            `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${w} ${h}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>`,
        ],
        [
            `<< /Type /XObject /Subtype /Image /Width ${columns} /Height ${rows} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /FlateDecode /Length ${image.length} >>\nstream\n`,
            image,
            '\nendstream',
        ],
        [`<< /Length ${content.length} >>\nstream\n`, content, '\nendstream'],
    ];
    const parts = [];
    let offset = 0;
    const write = (part) => {
        const bytes = typeof part === 'string' ? encoder.encode(part) : part;
        parts.push(bytes);
        offset += bytes.length;
    };
    write('%PDF-1.4\n%\u00e2\u00e3\u00cf\u00d3\n');
    const offsets = objects.map((object, k) => {
        const start = offset;
        write(`${k + 1} 0 obj\n`);
        object.forEach(write);
        write('\nendobj\n');
        return start;
    });
    const xref = offset;
    write([
        'xref',
        `0 ${objects.length + 1}`,
        '0000000000 65535 f ',
        ...offsets.map(start => `${String(start).padStart(10, '0')} 00000 n `),
        'trailer',
        `<< /Size ${objects.length + 1} /Root 1 0 R >>`,
        'startxref',
        `${xref}`,
        '%%EOF',
        '',
    ].join('\n'));
    return new Blob(parts, { type: 'application/pdf' });
}
/**
 * Converts an SVG document to a one page PDF the size of the drawing
 * (`width` × `height` CSS pixels). The drawing is embedded as a lossless
 * image at three times screen resolution (about 290 dpi at actual size),
 * so the PDF needs no fonts or external libraries.
 */
async function svgToPdf(svgText, width, height, pixelRatio = 3) {
    const canvas = await renderCanvas(svgText, width, height, pixelRatio);
    const { data } = canvas
        .getContext('2d')
        .getImageData(0, 0, canvas.width, canvas.height);
    const rgb = new Uint8Array(canvas.width * canvas.height * 3);
    for (let source = 0, target = 0; source < data.length; source += 4) {
        rgb[target++] = data[source];
        rgb[target++] = data[source + 1];
        rgb[target++] = data[source + 2];
    }
    return imagePdf(rgb, canvas.width, canvas.height, Math.max(1, width * pointsPerPixel), Math.max(1, height * pointsPerPixel));
}
/** A file name for an export, from the document and substation names. */
function exportFileName(docName, substation, scope, format) {
    const base = (docName ?? '').replace(/\.[^.]*$/, '') || 'communication';
    const parts = [base, substation, 'communication'];
    if (scope === 'view') {
        parts.push('view');
    }
    return `${parts
        .filter(Boolean)
        .join('-')
        .replace(/[^\w.-]+/g, '_')}.${format}`;
}
/** Offers a file to the user to save. */
function saveFile(blob, name) {
    const link = document.createElement('a');
    link.download = name;
    link.href = URL.createObjectURL(blob);
    link.style.display = 'none';
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 5000);
}

/**
 * Edits removing inputs of a connection:
 * - `ClientLN` elements are removed from their report control block
 * - `ExtRef` elements are unsubscribed with `@openscd/scl-lib`, which keeps
 *   ExtRefs used for later binding (`intAddr`), removes emptied `Inputs` and
 *   removes subscription supervision no longer needed
 */
function removeInputsEdits(inputs) {
    const clientLns = inputs
        .filter(input => input.tagName === 'ClientLN')
        .map(node => ({ node }));
    const extRefs = inputs.filter(input => input.tagName === 'ExtRef');
    return [...clientLns, ...(extRefs.length > 0 ? unsubscribe(extRefs) : [])];
}

/** Namespace of the deprecated attribute based SLD layout format. */
const legacySldNs = 'https://transpower.co.nz/SCL/SSD/SLD/v0';
/**
 * True when the document still uses the deprecated SLD layout format and has
 * no IEDs placed in the current format, so it has to be converted with the SLD
 * editor before it can be mapped.
 */
function hasLegacySldLayout(doc) {
    const usesLegacyFormat = doc.getElementsByTagNameNS(legacySldNs, '*').length > 0 ||
        Array.from(doc.querySelectorAll(':root > Substation')).some(substation => Array.from(substation.attributes).some(attribute => attribute.namespaceURI === legacySldNs));
    return usesLegacyFormat && iedReferences(doc).length === 0;
}

const equipmentSelector = 'ConductingEquipment, PowerTransformer';
/**
 * Returns the primary equipment within `scope` that has an `LNode` allocated
 * to the named IED.
 */
function linkedEquipment(scope, iedName) {
    const equipment = new Set();
    scope.querySelectorAll(`LNode[iedName="${iedName}"]`).forEach((lNode) => {
        const owner = lNode.closest(equipmentSelector);
        if (owner) {
            equipment.add(owner);
        }
    });
    return Array.from(equipment);
}

/**
 * Shared vocabulary and geometry of connection routing.
 *
 * Coordinates are in grid cells of the single line diagram, y pointing
 * down. An IED placed at `[x, y]` occupies the cell `[x, x + 1] × [y, y + 1]`
 * and connects through the midpoints of its four faces. Routes are
 * orthogonal polylines from the source IED's face to the target IED's face;
 * this module turns them into SVG (rounded corners, arrowheads) and
 * provides the simple face choice used where no search is made.
 *
 * How routes are found is described in `connection-routing.ts` and
 * `docs/routing.md`.
 *
 * Pure functions only: no DOM, no Lit.
 */
const eps$2 = 1e-6;
const cornerRadius = 0.15;
const arrowLength = 0.16;
const arrowHalfWidth = 0.08;
/** Drops repeated points and points in the middle of straight runs. */
function simplify(points) {
    const result = [];
    points.forEach((point) => {
        const last = result[result.length - 1];
        if (last &&
            Math.abs(last[0] - point[0]) < eps$2 &&
            Math.abs(last[1] - point[1]) < eps$2) {
            return;
        }
        const previous = result[result.length - 2];
        if (previous &&
            last &&
            ((Math.abs(previous[0] - last[0]) < eps$2 &&
                Math.abs(last[0] - point[0]) < eps$2) ||
                (Math.abs(previous[1] - last[1]) < eps$2 &&
                    Math.abs(last[1] - point[1]) < eps$2))) {
            result[result.length - 1] = point;
            return;
        }
        result.push(point);
    });
    return result;
}
/**
 * The faces a connection leaves its source and enters its target by when
 * no search is made, from the relative positions of the two cells (as the
 * original communication editor did): vertically between rows, over the
 * top within a row, around the west side between neighbouring rows of one
 * column.
 */
function faceDirections([sx, sy], [tx, ty]) {
    const dy = sy - ty;
    if (dy === 0 && sx !== tx) {
        return { source: 'n', target: 'n' };
    }
    if (Math.abs(dy) === 1) {
        if (sx === tx) {
            return { source: 'w', target: 'w' };
        }
        return { source: dy > 0 ? 'n' : 's', target: sx < tx ? 'w' : 'e' };
    }
    return dy > 0 ? { source: 'n', target: 's' } : { source: 's', target: 'n' };
}
/** The point on a cell's face at the given fraction along it. */
function facePoint([x, y], face, offset) {
    switch (face) {
        case 'n':
            return [x + offset, y];
        case 's':
            return [x + offset, y + 1];
        case 'w':
            return [x, y + offset];
        default:
            return [x + 1, y + offset];
    }
}
/**
 * The fixed Z or L shaped route between two attachment points on the given
 * faces (see `faceDirections`).
 */
function routePoints(start, end, faces) {
    const [x1, y1] = start;
    const [x2, y2] = end;
    if (faces.source === 'n' && faces.target === 'n') {
        const top = y1 - 0.5;
        return [start, [x1, top], [x2, top], end];
    }
    if (faces.source === 'w') {
        const left = x1 - 0.5;
        return [start, [left, y1], [left, y2], end];
    }
    if (faces.target === 'e' || faces.target === 'w') {
        return [start, [x1, y2], end];
    }
    if (x1 === x2) {
        return [start, end];
    }
    const middle = (y1 + y2) / 2;
    return [start, [x1, middle], [x2, middle], end];
}
/** The face of its target a route's last segment enters by. */
function entryFace(points) {
    const [x1, y1] = points[points.length - 2];
    const [x2, y2] = points[points.length - 1];
    if (Math.abs(x1 - x2) < eps$2) {
        return y2 > y1 ? 'n' : 's';
    }
    return x2 > x1 ? 'w' : 'e';
}
function format(value) {
    return String(Number(value.toFixed(3)));
}
function pointText([x, y]) {
    return `${format(x)},${format(y)}`;
}
function distance([ax, ay], [bx, by]) {
    return Math.abs(ax - bx) + Math.abs(ay - by);
}
function unit([ax, ay], [bx, by]) {
    const length = distance([ax, ay], [bx, by]);
    return [(bx - ax) / length, (by - ay) / length];
}
/**
 * Draws an orthogonal polyline with rounded corners. A corner's radius is
 * limited so that arcs never overrun a segment: an end segment may be used
 * fully by its one corner, an inner segment is shared by two.
 */
function roundedPath(points, radius = cornerRadius) {
    const commands = [`M${pointText(points[0])}`];
    const last = points.length - 1;
    const allowance = (from) => {
        const length = distance(points[from], points[from + 1]);
        return from === 0 || from + 1 === last ? length : length / 2;
    };
    for (let i = 1; i < last; i += 1) {
        const corner = points[i];
        const dirIn = unit(points[i - 1], corner);
        const dirOut = unit(corner, points[i + 1]);
        const r = Math.min(radius, allowance(i - 1), allowance(i));
        const start = [corner[0] - dirIn[0] * r, corner[1] - dirIn[1] * r];
        const end = [corner[0] + dirOut[0] * r, corner[1] + dirOut[1] * r];
        const sweep = dirIn[0] * dirOut[1] - dirIn[1] * dirOut[0] > 0 ? 1 : 0;
        commands.push(`L${pointText(start)}`, `A${format(r)},${format(r)} 0 0 ${sweep} ${pointText(end)}`);
    }
    commands.push(`L${pointText(points[last])}`);
    return commands.join('');
}
/** An arrowhead with its tip at `tip`, entering the target through `face`. */
function arrowPath([x, y], face) {
    const l = arrowLength;
    const w = arrowHalfWidth;
    const corners = {
        n: [
            [x - w, y - l],
            [x + w, y - l],
        ],
        s: [
            [x - w, y + l],
            [x + w, y + l],
        ],
        e: [
            [x + l, y + w],
            [x + l, y - w],
        ],
        w: [
            [x - l, y + w],
            [x - l, y - w],
        ],
    };
    const [a, b] = corners[face];
    return `M${pointText([x, y])}L${pointText(a)}L${pointText(b)}Z`;
}
/** A routed connection drawn along `points`. */
function drawRoute(id, points) {
    return {
        id,
        points,
        path: roundedPath(points),
        arrow: arrowPath(points[points.length - 1], entryFace(points)),
    };
}

/**
 * Stage 1 of connection routing: finding a path for every connection.
 *
 * ## The lattice
 *
 * The diagram is searched on a lattice with nodes every half grid cell, so
 * that cell `[x, x + 1] × [y, y + 1]` has nodes on its corners, at the
 * midpoints of its borders and at its centre. Lattice index `(i, j)` is the
 * point `(i / 2, j / 2)`; even indices lie on cell borders, odd ones inside
 * cells. Lines may run along cell borders (between symbols) and through the
 * middle of empty cells.
 *
 * Every obstacle is rasterised onto the lattice once:
 * - symbols (IEDs, equipment) block the nodes inside their cells, and with
 *   `strictBorders` also the borders and corners squeezed between two
 *   symbols, where a line would be drawn on top of their outlines;
 * - labels mark their nodes as expensive to cross;
 * - wires (busbars, primary connections) and container borders (bays,
 *   voltage levels) mark their nodes, per orientation, as expensive to run
 *   along.
 *
 * ## The search
 *
 * Each connection is searched with A* over states (node, heading): the
 * heading is needed to charge for turns. A path starts at the midpoint of
 * one of the source IED's faces heading straight out, and ends at the
 * midpoint of one of the target IED's faces heading straight in, where the
 * arrowhead is drawn. Faces covered by a label just outside the IED (its own
 * name, usually) are not used, so arrows do not run into text.
 *
 * A step of half a cell costs 0.5 plus, as configured in `GridCosts`:
 * a turn; running along a cell border next to a symbol (`hug`, so lines keep
 * to the middle of the channels between symbols); crossing a label; running
 * along a wire or a container border; sharing a street with more lines than
 * fit (`congestion` beyond `capacity`); and crossing another line
 * (`crossing`, per line crossed).
 *
 * The heuristic is the remaining distance plus the turns still needed given
 * the current heading. It never overestimates, so with `weight` 1 the
 * search finds a cheapest path; a weight above 1 makes it greedier and much
 * faster, at the price of occasional detours.
 *
 * ## Several connections
 *
 * Connections are routed shortest first. Every routed path is recorded on
 * the lattice, so later connections pay for crossing or crowding it. As the
 * first connections cannot know about the later ones, `passes` above 1 rip
 * every connection up again and reroute it knowing where all the others go
 * (with `refineWeight`, usually 1 for an exact search).
 *
 * The cost of a search is bounded three ways: it is limited to a `window`
 * around the connection's ends (widened if that fails), to a `budget` of
 * expanded states, after which the connection is searched again ignoring
 * the other lines (cheap, as nothing then makes detours worthwhile), and
 * finally, if the IEDs are walled in, the fixed shape of `routePoints` is
 * drawn.
 */
/** Plain costs: shortest paths with few turns, avoiding labels and wires. */
const defaultGridCosts = {
    bend: 0.8,
    interior: 0.1,
    congestion: 0.6,
    capacity: 4,
    narrowCapacity: 1,
    crossing: 0.3,
    label: 1.5,
    wire: 0.8,
    border: 0,
    hug: 0,
};
/** Headings, indexed as in the search states. */
const directions = [
    { face: 'n', dx: 0, dy: -1 },
    { face: 'e', dx: 1, dy: 0 },
    { face: 's', dx: 0, dy: 1 },
    { face: 'w', dx: -1, dy: 0 },
];
const opposite = { n: 's', s: 'n', e: 'w', w: 'e' };
/** Binary min-heap of integer items keyed by a float priority. */
class Heap {
    constructor() {
        this.items = [];
        this.priorities = [];
    }
    get size() {
        return this.items.length;
    }
    clear() {
        this.items.length = 0;
        this.priorities.length = 0;
    }
    push(item, priority) {
        const { items, priorities } = this;
        let i = items.length;
        items.push(item);
        priorities.push(priority);
        while (i > 0) {
            const parent = (i - 1) >> 1;
            if (priorities[parent] <= priority) {
                break;
            }
            items[i] = items[parent];
            priorities[i] = priorities[parent];
            i = parent;
        }
        items[i] = item;
        priorities[i] = priority;
    }
    pop() {
        const { items, priorities } = this;
        const top = items[0];
        const item = items.pop();
        const priority = priorities.pop();
        const n = items.length;
        if (n > 0) {
            let i = 0;
            for (;;) {
                let child = 2 * i + 1;
                if (child >= n) {
                    break;
                }
                if (child + 1 < n && priorities[child + 1] < priorities[child]) {
                    child += 1;
                }
                if (priorities[child] >= priority) {
                    break;
                }
                items[i] = items[child];
                priorities[i] = priorities[child];
                i = child;
            }
            items[i] = item;
            priorities[i] = priority;
        }
        return top;
    }
}
/**
 * `gridRoute` one connection at a time: yields after each search, so a
 * caller can spread the work over several frames. Returns the routes.
 */
function* gridRouteSteps(inputs, [width, height], obstacles, options = {}) {
    const costs = { ...defaultGridCosts, ...options.costs };
    let weight = options.weight ?? 1;
    const windowMargin = (options.window ?? 0) * 2;
    const budget = options.budget ?? 0;
    const columns = Math.round(width * 2) + 1;
    const rows = Math.round(height * 2) + 1;
    const nodes = columns * rows;
    const index = (i, j) => j * columns + i;
    const inside = (i, j) => i >= 0 && j >= 0 && i < columns && j < rows;
    // Rasterise the obstacles.
    const blocked = new Uint8Array(nodes);
    const labelled = new Uint8Array(nodes);
    /**
     * Nodes on lines that should not be run along, per orientation: bits 1
     * (horizontal) and 2 (vertical) for wires, 4 and 8 for container borders.
     */
    const lined = new Uint8Array(nodes);
    const markLine = (x, y, w, h, bits) => {
        const horizontal = h === 0;
        const fixed = Math.round((horizontal ? y : x) * 2);
        const from = Math.ceil((horizontal ? x : y) * 2);
        const to = Math.floor((horizontal ? x + w : y + h) * 2);
        for (let k = from; k <= to; k += 1) {
            const [i, j] = horizontal ? [k, fixed] : [fixed, k];
            if (inside(i, j)) {
                lined[index(i, j)] |= horizontal ? bits : bits << 1;
            }
        }
    };
    obstacles.forEach(({ rect: [x, y, w, h], kind }) => {
        if (kind === 'border') {
            markLine(x, y, w, 0, 4);
            markLine(x, y + h, w, 0, 4);
            markLine(x, y, 0, h, 4);
            markLine(x + w, y, 0, h, 4);
            return;
        }
        if (kind === 'wire') {
            markLine(x, y, w, h, 1);
            return;
        }
        // Nodes strictly inside the rectangle.
        const target = kind === 'label' ? labelled : blocked;
        const i0 = Math.max(0, Math.floor(x * 2) + 1);
        const i1 = Math.min(columns - 1, Math.ceil((x + w) * 2) - 1);
        const j0 = Math.max(0, Math.floor(y * 2) + 1);
        const j1 = Math.min(rows - 1, Math.ceil((y + h) * 2) - 1);
        for (let i = i0; i <= i1; i += 1) {
            for (let j = j0; j <= j1; j += 1) {
                target[index(i, j)] = 1;
            }
        }
    });
    if (options.strictBorders) {
        const symbols = blocked.slice();
        const symbol = (i, j) => inside(i, j) ? symbols[index(i, j)] : 0;
        for (let j = 0; j < rows; j += 1) {
            for (let i = 0; i < columns; i += 1) {
                const corner = i % 2 === 0 && j % 2 === 0;
                const between = corner
                    ? symbol(i - 1, j - 1) +
                        symbol(i + 1, j - 1) +
                        symbol(i - 1, j + 1) +
                        symbol(i + 1, j + 1) >=
                        3
                    : i % 2 === 0
                        ? symbol(i - 1, j) && symbol(i + 1, j)
                        : j % 2 === 0 && symbol(i, j - 1) && symbol(i, j + 1);
                if (between) {
                    blocked[index(i, j)] = 1;
                }
            }
        }
    }
    const isSymbol = (i, j) => inside(i, j) && blocked[index(i, j)] === 1;
    /**
     * For a step along a cell border, the centres of the two cells on either
     * side of it; `undefined` for steps through cell interiors.
     */
    const sides = (i, j, dir) => {
        const { dx, dy } = directions[dir];
        if (dx !== 0) {
            if (j % 2 === 1) {
                return undefined;
            }
            const ci = i % 2 === 1 ? i : i + dx;
            return [
                [ci, j - 1],
                [ci, j + 1],
            ];
        }
        if (i % 2 === 1) {
            return undefined;
        }
        const cj = j % 2 === 1 ? j : j + dy;
        return [
            [i - 1, cj],
            [i + 1, cj],
        ];
    };
    /** A step along a border with a symbol on at least one side. */
    const hugs = (i, j, dir) => sides(i, j, dir)?.some(([ci, cj]) => isSymbol(ci, cj)) ?? false;
    /** A step along a border squeezed between two symbols. */
    const isNarrow = (i, j, dir) => sides(i, j, dir)?.every(([ci, cj]) => isSymbol(ci, cj)) ?? false;
    /**
     * Routes using each lattice edge and passing each node, with how often:
     * edge key = lower node * 2 + (vertical ? 1 : 0), node key = node * 2 +
     * (passed vertically ? 1 : 0).
     */
    const edgeUsers = new Map();
    const nodeUsers = new Map();
    const use = (users, key, route, delta) => {
        let counts = users.get(key);
        if (!counts) {
            counts = new Map();
            users.set(key, counts);
        }
        const count = (counts.get(route) ?? 0) + delta;
        if (count > 0) {
            counts.set(route, count);
        }
        else {
            counts.delete(route);
        }
    };
    /** How many routes other than `route` are recorded. */
    const others = (users, route) => users ? users.size - (users.has(route) ? 1 : 0) : 0;
    const edgeKey = (node, dir) => {
        const { dx, dy } = directions[dir];
        const lower = dx < 0 ? node - 1 : dy < 0 ? node - columns : node;
        return lower * 2 + (dy !== 0 ? 1 : 0);
    };
    /** The usable face midpoints of an IED at grid position `[x, y]`. */
    const portsOf = ([x, y]) => {
        const ci = Math.round(x * 2) + 1;
        const cj = Math.round(y * 2) + 1;
        const ports = directions
            .map(({ face, dx, dy }, dir) => {
            const i = ci + dx;
            const j = cj + dy;
            return { face, dir, i, j, node: index(i, j) };
        })
            .filter(({ i, j }) => inside(i, j));
        // Faces with a label right outside are only used when all have one.
        const clear = ports.filter(({ i, j, dir }) => {
            const oi = i + directions[dir].dx;
            const oj = j + directions[dir].dy;
            return !inside(oi, oj) || labelled[index(oi, oj)] === 0;
        });
        return clear.length > 0 ? clear : ports;
    };
    // Search state arrays, reset lazily through `touched`.
    const gScore = new Float64Array(nodes * 4).fill(Infinity);
    const parent = new Int32Array(nodes * 4).fill(-1);
    const closed = new Uint8Array(nodes * 4);
    const touched = [];
    const heap = new Heap();
    /**
     * A* from the source ports to the target ports. Returns the goal state, or
     * -1 when none was reached within the bounds (or budget). `relaxed`
     * ignores other routes and the budget.
     */
    const search = (sources, targets, route, bounds, relaxed = false) => {
        touched.forEach((state) => {
            gScore[state] = Infinity;
            parent[state] = -1;
            closed[state] = 0;
        });
        touched.length = 0;
        heap.clear();
        const goals = new Map(targets.map(port => [port.node, port]));
        // The target IED's centre.
        const ti = targets.reduce((sum, t) => sum + t.i, 0) / targets.length;
        const tj = targets.reduce((sum, t) => sum + t.j, 0) / targets.length;
        /**
         * Lower bound of the remaining cost: the distance to the target's ports
         * plus the turns still needed. Two turns when the target lies behind
         * along the heading's axis, one when it lies off that axis.
         */
        const heuristic = (node, heading) => {
            const i = node % columns;
            const j = (node - i) / columns;
            const dx = ti - i;
            const dy = tj - j;
            const farX = Math.abs(dx) > 1;
            const farY = Math.abs(dy) > 1;
            let turns = 0;
            if (farX || farY) {
                const { dx: hx, dy: hy } = directions[heading];
                const ahead = hx * dx + hy * dy;
                const alongX = hx !== 0;
                if (farX && farY) {
                    turns = ahead < 0 ? 2 : 1;
                }
                else if (farX === alongX) {
                    turns = ahead > 0 ? 0 : 2;
                }
                else {
                    turns = 1;
                }
            }
            const distance = Math.max(0, Math.abs(dx) + Math.abs(dy) - 1) * 0.5;
            return (distance + turns * costs.bend) * weight;
        };
        sources.forEach(({ node, dir }) => {
            const state = node * 4 + dir;
            gScore[state] = 0;
            touched.push(state);
            heap.push(state, heuristic(node, dir));
        });
        let expanded = 0;
        while (heap.size > 0) {
            const state = heap.pop();
            if (closed[state]) {
                continue;
            }
            closed[state] = 1;
            expanded += 1;
            if (budget > 0 && !relaxed && expanded > budget) {
                return -1;
            }
            const node = state >> 2;
            const heading = state & 3;
            // A target face is reached heading straight into the IED.
            const goal = goals.get(node);
            if (goal && directions[heading].face === opposite[goal.face]) {
                return state;
            }
            const i = node % columns;
            const j = (node - i) / columns;
            for (let dir = 0; dir < 4; dir += 1) {
                if (dir === (heading + 2) % 4) {
                    continue;
                }
                const { dx, dy } = directions[dir];
                const ni = i + dx;
                const nj = j + dy;
                if (!inside(ni, nj) ||
                    (bounds &&
                        (ni < bounds[0] || nj < bounds[1] || ni > bounds[2] || nj > bounds[3]))) {
                    continue;
                }
                const next = index(ni, nj);
                if (blocked[next]) {
                    continue;
                }
                const vertical = dy !== 0;
                let step = 0.5;
                if ((vertical ? i : j) % 2 === 1) {
                    step += costs.interior;
                }
                if (labelled[next]) {
                    step += costs.label;
                }
                if (costs.hug > 0 && hugs(i, j, dir)) {
                    step += costs.hug;
                }
                const wire = vertical ? 2 : 1;
                if (lined[node] & lined[next] & wire) {
                    step += costs.wire;
                }
                if (lined[node] & lined[next] & (wire << 2)) {
                    step += costs.border;
                }
                if (!relaxed) {
                    const sharing = others(edgeUsers.get(edgeKey(node, dir)), route);
                    if (sharing > 0) {
                        const capacity = isNarrow(i, j, dir)
                            ? costs.narrowCapacity
                            : costs.capacity;
                        step += Math.max(0, sharing - capacity + 1) * costs.congestion;
                    }
                    // Lines passing the next node the other way are crossed.
                    step +=
                        others(nodeUsers.get(next * 2 + (vertical ? 0 : 1)), route) *
                            costs.crossing;
                }
                if (dir !== heading) {
                    step += costs.bend;
                }
                const nextState = next * 4 + dir;
                const g = gScore[state] + step;
                if (g < gScore[nextState]) {
                    if (gScore[nextState] === Infinity && parent[nextState] === -1) {
                        touched.push(nextState);
                    }
                    gScore[nextState] = g;
                    parent[nextState] = state;
                    heap.push(nextState, g + heuristic(next, dir));
                }
            }
        }
        return -1;
    };
    const toPoint = (node) => {
        const i = node % columns;
        return [i / 2, (node - i) / columns / 2];
    };
    // Shortest connections first: they have the fewest alternatives.
    const order = inputs
        .map((input, k) => ({
        input,
        k,
        distance: Math.abs(input.source.position[0] - input.target.position[0]) +
            Math.abs(input.source.position[1] - input.target.position[1]),
    }))
        .sort((a, b) => a.distance - b.distance);
    const results = new Array(inputs.length);
    /** Edge and node keys each route recorded, to rip it up again. */
    const usage = [];
    const routeOne = (input, k) => {
        usage[k]?.edges.forEach(edge => use(edgeUsers, edge, k, -1));
        usage[k]?.nodes.forEach(node => use(nodeUsers, node, k, -1));
        usage[k] = { edges: [], nodes: [] };
        const sources = portsOf(input.source.position);
        const targets = portsOf(input.target.position);
        let bounds = null;
        if (windowMargin > 0) {
            const ends = [...sources, ...targets];
            bounds = [
                Math.min(...ends.map(p => p.i)) - windowMargin,
                Math.min(...ends.map(p => p.j)) - windowMargin,
                Math.max(...ends.map(p => p.i)) + windowMargin,
                Math.max(...ends.map(p => p.j)) + windowMargin,
            ];
        }
        let goal = search(sources, targets, k, bounds);
        if (goal === -1 && bounds) {
            goal = search(sources, targets, k, null);
        }
        if (goal === -1 && budget > 0) {
            // Out of budget, typically surrounded by other lines: ignore them.
            goal = search(sources, targets, k, null, true);
        }
        if (goal === -1) {
            // Walled in: draw the fixed shape.
            const faces = faceDirections(input.source.position, input.target.position);
            results[k] = {
                id: input.id,
                points: routePoints(facePoint(input.source.position, faces.source, 0.5), facePoint(input.target.position, faces.target, 0.5), faces),
                found: false,
            };
            return;
        }
        const states = [];
        for (let state = goal; state !== -1; state = parent[state]) {
            states.unshift(state);
        }
        for (let n = 1; n < states.length; n += 1) {
            const from = states[n - 1] >> 2;
            const dir = states[n] & 3;
            const edge = edgeKey(from, dir);
            use(edgeUsers, edge, k, 1);
            usage[k].edges.push(edge);
            for (const node of [from, states[n] >> 2]) {
                const key = node * 2 + (directions[dir].dy !== 0 ? 1 : 0);
                use(nodeUsers, key, k, 1);
                usage[k].nodes.push(key);
            }
        }
        results[k] = {
            id: input.id,
            points: states.map(state => toPoint(state >> 2)),
            found: true,
        };
    };
    const passes = Math.max(1, options.passes ?? 1);
    for (let pass = 0; pass < passes; pass += 1) {
        if (pass > 0) {
            weight = options.refineWeight ?? weight;
        }
        for (const { input, k } of order) {
            routeOne(input, k);
            yield;
        }
    }
    return results;
}

/**
 * Stage 2 of connection routing (see `connection-routing.ts` and
 * `docs/routing.md`): orders routes that share a path, so the parallel
 * lanes they get when nudged apart do not cross needlessly.
 *
 * Two routes running together along a path must keep one side each: the
 * route that joins the path from the left (relative to the direction of
 * travel) and leaves it to the left stays left all along, also around
 * bends. Routes joining from one side and leaving to the other have to
 * cross once; the order is then chosen by where they leave. This is the
 * ordering step of orthogonal connector routing (Wybrow, Marriott and
 * Stuckey, 2009).
 */
/** Spacing of the routing lattice the routes are drawn on. */
const step = 0.5;
const eps$1 = 1e-6;
function key([x, y]) {
    return `${Math.round(x * 1000)},${Math.round(y * 1000)}`;
}
/** Points of a route at every lattice coordinate it passes. */
function densify(points) {
    const simple = simplify(points);
    const dense = simple.slice(0, 1);
    for (let i = 1; i < simple.length; i += 1) {
        const [x1, y1] = simple[i - 1];
        const [x2, y2] = simple[i];
        const horizontal = Math.abs(y1 - y2) < eps$1;
        const [from, to] = horizontal ? [x1, x2] : [y1, y2];
        const direction = Math.sign(to - from);
        for (let at = direction > 0
            ? Math.floor(from / step + eps$1 + 1) * step
            : Math.ceil(from / step - eps$1 - 1) * step; direction * (to - at) > eps$1; at += direction * step) {
            dense.push(horizontal ? [at, y1] : [x1, at]);
        }
        dense.push(simple[i]);
    }
    return dense;
}
/** Key of the lattice edge between two points, independent of direction. */
function edgeKey(a, b) {
    const [p, q] = a[0] + a[1] <= b[0] + b[1] ? [a, b] : [b, a];
    return `${key(p)}|${key(q)}`;
}
function sideOf(direction, from, to) {
    if (!to) {
        return 0;
    }
    const vx = to[0] - from[0];
    const vy = to[1] - from[1];
    return Math.sign(direction[0] * vy - direction[1] * vx);
}
function along(from, to) {
    return [Math.sign(to[0] - from[0]), Math.sign(to[1] - from[1])];
}
/** Computes the order of every pair of routes along their shared paths. */
function orderRoutes(routes) {
    const dense = routes.map(densify);
    const keys = dense.map(points => points.map(key));
    /** Edge key to the routes using it and where. */
    const edges = new Map();
    dense.forEach((points, route) => {
        for (let index = 0; index + 1 < points.length; index += 1) {
            const edge = edgeKey(points[index], points[index + 1]);
            if (!edges.has(edge)) {
                edges.set(edge, []);
            }
            edges.get(edge).push({ route, index });
        }
    });
    const order = new Map();
    const set = (a, b, edge, value) => {
        order.set(`${edge}|${a}|${b}`, value);
        order.set(`${edge}|${b}|${a}`, -value);
    };
    edges.forEach((users, edge) => {
        for (let u = 0; u < users.length; u += 1) {
            for (let v = u + 1; v < users.length; v += 1) {
                const a = users[u];
                const b = users[v];
                if (a.route === b.route || order.has(`${edge}|${a.route}|${b.route}`)) {
                    continue;
                }
                const A = dense[a.route];
                const B = dense[b.route];
                const ka = keys[a.route];
                const kb = keys[b.route];
                // B's index of A's node at a.index, and B's direction relative to A.
                const forward = kb[b.index] === ka[a.index];
                const sign = forward ? 1 : -1;
                let i0 = a.index;
                let j0 = forward ? b.index : b.index + 1;
                let i1 = a.index + 1;
                let j1 = j0 + sign;
                while (i0 > 0 && kb[j0 - sign] !== undefined && ka[i0 - 1] === kb[j0 - sign]) {
                    i0 -= 1;
                    j0 -= sign;
                }
                while (i1 + 1 < A.length &&
                    kb[j1 + sign] !== undefined &&
                    ka[i1 + 1] === kb[j1 + sign]) {
                    i1 += 1;
                    j1 += sign;
                }
                const enter = along(A[i0], A[i0 + 1]);
                const leave = along(A[i1 - 1], A[i1]);
                const start = sideOf(enter, A[i0], A[i0 - 1]) - sideOf(enter, A[i0], B[j0 - sign]);
                const end = sideOf(leave, A[i1], A[i1 + 1]) - sideOf(leave, A[i1], B[j1 + sign]);
                // Positive: A runs on the left of B, seen in A's direction of travel.
                const left = Math.sign(end) || Math.sign(start) || (a.route < b.route ? 1 : -1);
                for (let i = i0; i < i1; i += 1) {
                    const [dx, dy] = along(A[i], A[i + 1]);
                    // The left normal (-dy, dx) points to larger coordinates when its
                    // components sum to a positive value.
                    set(a.route, b.route, edgeKey(A[i], A[i + 1]), left * Math.sign(dx - dy));
                }
            }
        }
    });
    return {
        compare: (a, b, edge) => order.get(`${edge}|${a}|${b}`) ?? 0,
    };
}

/**
 * Stage 3 of connection routing: spreading lines that share a street into
 * parallel lanes (see `connection-routing.ts` and `docs/routing.md`).
 *
 * The searched paths run on lattice lines, so lines sharing a street are
 * drawn on top of each other until they are nudged apart here. Lanes are
 * positioned across the free room of their channel, in the order stage 2
 * decided, and every corner follows its two shifted segments.
 */
const eps = 1e-6;
/** Closest two lanes may be drawn. */
const minSpacing = 0.08;
/**
 * Separates collinear, overlapping segments of different groups into
 * parallel lanes, like the nudging step of orthogonal connector routers.
 *
 * Segments are grouped by orientation and coordinate (one lattice line).
 * On a line, overlapping runs of one group form a cluster, and overlapping
 * clusters get different lanes: in the given `order` (a longest path
 * through the "runs below" relation), or without one, the lowest free lane
 * (interval colouring). Each connected set of clusters is centred on the
 * original line, as far as the room between symbols (and, with
 * `neighbours`, lanes on nearby parallel lines) allows. Corners move to the
 * intersection of their shifted segments; end points slide along the IED
 * face.
 */
function nudgeRoutes(routes, { spacing = 0.14, maxWidth = 0.7, obstacles = [], clearance = 0.1, order, neighbours = false, } = {}) {
    const simplified = routes.map(route => simplify(route.points));
    const offsets = simplified.map(points => new Array(Math.max(0, points.length - 1)).fill(0));
    const groups = new Map();
    simplified.forEach((points, route) => {
        for (let segment = 1; segment < points.length; segment += 1) {
            const [x1, y1] = points[segment - 1];
            const [x2, y2] = points[segment];
            const horizontal = Math.abs(y1 - y2) < eps;
            const key = horizontal
                ? `h${y1.toFixed(3)}`
                : `v${x1.toFixed(3)}`;
            const run = {
                route,
                segment: segment - 1,
                from: horizontal ? Math.min(x1, x2) : Math.min(y1, y2),
                to: horizontal ? Math.max(x1, x2) : Math.max(y1, y2),
            };
            if (!groups.has(key)) {
                groups.set(key, []);
            }
            groups.get(key).push(run);
        }
    });
    /** Free room below and above a line over an interval, capped at half the width. */
    const room = (horizontal, at, from, to) => {
        let below = maxWidth / 2 + clearance;
        let above = maxWidth / 2 + clearance;
        obstacles.forEach(([x, y, w, h]) => {
            const [lo, hi, near, far] = horizontal ? [x, x + w, y, y + h] : [y, y + h, x, x + w];
            if (hi <= from + eps || lo >= to - eps) {
                return;
            }
            if (far <= at + eps) {
                below = Math.min(below, at - far);
            }
            else if (near >= at - eps) {
                above = Math.min(above, near - at);
            }
            else {
                // The line crosses the symbol: nothing to fit lanes against.
                below = maxWidth / 2 + clearance;
                above = maxWidth / 2 + clearance;
            }
        });
        // Negative room means the line itself is too close to a symbol.
        return [below - clearance, above - clearance];
    };
    /** Parallel lines with their extents, by orientation. */
    const lines = { h: [], v: [] };
    groups.forEach((runs, key) => {
        const at = Number(key.slice(1));
        runs.forEach(({ from, to }) => lines[key[0]].push({ at, from, to }));
    });
    /** Room up to the nearest neighbouring line, shared half and half. */
    const neighbourRoom = (horizontal, at, from, to) => {
        let below = Infinity;
        let above = Infinity;
        lines[horizontal ? 'h' : 'v'].forEach((line) => {
            if (Math.abs(line.at - at) < eps ||
                Math.abs(line.at - at) > 1 + eps ||
                line.to <= from + eps ||
                line.from >= to - eps) {
                return;
            }
            const half = Math.abs(line.at - at) / 2 - spacing / 2;
            if (line.at < at) {
                below = Math.min(below, half);
            }
            else {
                above = Math.min(above, half);
            }
        });
        return [below, above];
    };
    /** Order of two runs on a line: positive when `a` belongs at larger offsets. */
    const compareRuns = (a, b, horizontal, at) => {
        if (!order) {
            return 0;
        }
        const from = Math.max(a.from, b.from);
        const to = Math.min(a.to, b.to);
        if (to - from < eps) {
            return 0;
        }
        const start = Math.floor(((from + to) / 2) * 2) / 2;
        const p = horizontal ? [start, at] : [at, start];
        const q = horizontal ? [start + 0.5, at] : [at, start + 0.5];
        return order.compare(a.route, b.route, edgeKey(p, q));
    };
    groups.forEach((runs, key) => {
        const horizontalGroup = key.startsWith('h');
        const at = Number(key.slice(1));
        // Cluster overlapping runs of the same bundle so they share one lane.
        const clusters = [];
        runs
            .sort((a, b) => a.from - b.from)
            .forEach((run) => {
            const bundle = routes[run.route].bundle;
            const cluster = clusters.find(c => c.bundle === bundle && run.from <= c.to + eps && run.to >= c.from - eps);
            if (cluster) {
                cluster.from = Math.min(cluster.from, run.from);
                cluster.to = Math.max(cluster.to, run.to);
                cluster.runs.push(run);
            }
            else {
                clusters.push({ bundle, from: run.from, to: run.to, runs: [run] });
            }
        });
        if (clusters.length < 2) {
            return;
        }
        // Interval colouring, then centre each connected component of clusters.
        clusters.sort((a, b) => a.from - b.from || b.to - a.to);
        let component = [];
        let componentEnd = -Infinity;
        const lanes = new Map();
        const flush = () => {
            if (component.length === 0) {
                return;
            }
            if (order) {
                assignOrderedLanes(component, lanes, (a, b) => {
                    for (const ra of a.runs) {
                        for (const rb of b.runs) {
                            const value = compareRuns(ra, rb, horizontalGroup, at);
                            if (value !== 0) {
                                return value;
                            }
                        }
                    }
                    return 0;
                });
            }
            else {
                const laneEnds = [];
                component.forEach((cluster) => {
                    let lane = laneEnds.findIndex(end => end < cluster.from - eps);
                    if (lane === -1) {
                        lane = laneEnds.length;
                        laneEnds.push(cluster.to);
                    }
                    else {
                        laneEnds[lane] = cluster.to;
                    }
                    lanes.set(cluster, lane);
                });
            }
            const count = Math.max(...component.map(c => lanes.get(c))) + 1;
            const from = Math.min(...component.map(c => c.from));
            const to = Math.max(...component.map(c => c.to));
            let [below, above] = room(horizontalGroup, at, from, to);
            if (neighbours) {
                const [nearBelow, nearAbove] = neighbourRoom(horizontalGroup, at, from, to);
                below = Math.min(below, nearBelow);
                above = Math.min(above, nearAbove);
            }
            // Keep lanes distinguishable even where symbols leave no room.
            const step = Math.max(minSpacing, Math.min(spacing, Math.max(0, below + above) / Math.max(1, count - 1)));
            // Centre the lanes, then shift them into the free room if needed.
            const half = (step * (count - 1)) / 2;
            // Lanes span [centre - half, centre + half], within [-below, above]
            // when they fit.
            const centre = half * 2 <= below + above
                ? Math.min(Math.max(0, half - below), above - half)
                : (above - below) / 2;
            component.forEach((cluster) => {
                const offset = centre + (lanes.get(cluster) - (count - 1) / 2) * step;
                cluster.runs.forEach((run) => {
                    offsets[run.route][run.segment] = offset;
                });
            });
        };
        clusters.forEach((cluster) => {
            if (cluster.from > componentEnd + eps) {
                flush();
                component = [];
                componentEnd = -Infinity;
            }
            component.push(cluster);
            componentEnd = Math.max(componentEnd, cluster.to);
        });
        flush();
    });
    return simplified.map((points, route) => {
        if (points.length < 2) {
            return points;
        }
        const shift = offsets[route];
        const horizontal = (segment) => Math.abs(points[segment][1] - points[segment + 1][1]) < eps;
        return points.map(([x, y], i) => {
            const before = i - 1;
            const after = i;
            let [nx, ny] = [x, y];
            for (const segment of [before, after]) {
                if (segment < 0 || segment >= shift.length) {
                    continue;
                }
                if (horizontal(segment)) {
                    ny = y + shift[segment];
                }
                else {
                    nx = x + shift[segment];
                }
            }
            return [nx, ny];
        });
    });
}
/**
 * Assigns lanes so that every pair of overlapping clusters gets different
 * lanes, in the order `compare` asks for (ties broken by position):
 * a longest-path layering of the "below" relation.
 */
function assignOrderedLanes(clusters, lanes, compare) {
    const below = new Map(clusters.map(c => [c, []]));
    const indegree = new Map(clusters.map(c => [c, 0]));
    clusters.forEach((a, i) => {
        clusters.slice(i + 1).forEach((b) => {
            if (Math.min(a.to, b.to) - Math.max(a.from, b.from) < -eps) {
                return;
            }
            const value = compare(a, b) || -1;
            const [low, high] = value < 0 ? [a, b] : [b, a];
            below.get(low).push(high);
            indegree.set(high, indegree.get(high) + 1);
        });
    });
    const lane = new Map(clusters.map(c => [c, 0]));
    const remaining = new Set(clusters);
    while (remaining.size > 0) {
        // Take a cluster nothing remaining must go below; on a cycle, the one
        // with the fewest such constraints.
        let next;
        remaining.forEach((c) => {
            if (!next || indegree.get(c) < indegree.get(next)) {
                next = c;
            }
        });
        remaining.delete(next);
        lanes.set(next, lane.get(next));
        below.get(next).forEach((high) => {
            if (remaining.has(high)) {
                indegree.set(high, indegree.get(high) - 1);
                lane.set(high, Math.max(lane.get(high), lane.get(next) + 1));
            }
        });
    }
}

/**
 * Routes the connections drawn between IEDs on the single line diagram.
 *
 * The aim is a diagram where every connection can be followed and picked:
 * lines avoid IEDs, equipment, labels and busbars, cross each other as
 * little as possible, and lines sharing a path run side by side in lanes
 * instead of on top of each other. The approach follows orthogonal
 * connector routing (Wybrow, Marriott and Stuckey, *Orthogonal connector
 * routing*, 2009, as used by libavoid) in three stages:
 *
 * 1. **Search** (`grid-router.ts`): every connection gets a path on a
 *    half-cell lattice with A*, preferring the middle of the channels
 *    between symbols. Paths may share streets; crossing other lines is
 *    expensive. A second pass reroutes every connection knowing where all
 *    the others go.
 * 2. **Order** (`ordering.ts`): where paths share a stretch, which one runs
 *    on which side is decided from where they join and leave it, so lines
 *    running together do not cross needlessly, also around bends.
 * 3. **Nudge** (`nudge.ts`): shared stretches are spread into parallel lanes
 *    in that order, across the free room of their channel.
 *
 * The result is drawn with rounded corners and an arrowhead at the target
 * (`routing.ts`). `docs/routing.md` explains the choices and how they were
 * measured.
 *
 * Searching takes about a tenth of a second for fifty connections, so the
 * plugin draws `quickRoute` at once and replaces it with the result of
 * `routeConnectionsAsync`, which yields to the browser between searches.
 */
/**
 * Search settings. Measured on real substation files (see
 * `docs/routing.md`): turns and crossings are expensive, lines keep off
 * symbol outlines, labels, busbars and bay borders, and the second pass
 * searches exactly.
 */
const routingSettings = {
    costs: {
        bend: 1.2,
        interior: 0,
        hug: 0.35,
        crossing: 1.5,
        congestion: 0.4,
        capacity: 6,
        narrowCapacity: 1,
        label: 2.5,
        wire: 2,
        border: 0.6,
    },
    strictBorders: true,
    passes: 2,
    window: 4,
    weight: 1.2,
    refineWeight: 1,
    budget: 10000,
};
/** Connections above which the search is cheaper: one pass, less budget. */
const largeRouting = 150;
/** Search settings for a number of connections. */
function settingsFor(connections) {
    return connections > largeRouting
        ? { ...routingSettings, passes: 1, budget: 3000 }
        : routingSettings;
}
/** Symbol rectangles, which lanes must keep clear of. */
function symbolRects(obstacles) {
    return obstacles
        .filter(obstacle => (obstacle.kind ?? 'symbol') === 'symbol')
        .map(obstacle => obstacle.rect);
}
/** Stages 2 and 3: orders and nudges searched paths, then draws them. */
function lanes(routes, obstacles) {
    const order = orderRoutes(routes.map(route => route.points));
    const points = nudgeRoutes(routes.map(route => ({ points: route.points, bundle: route.id })), {
        spacing: 0.16,
        maxWidth: 0.8,
        order,
        neighbours: true,
        obstacles: symbolRects(obstacles),
    });
    return routes.map((route, k) => drawRoute(route.id, points[k]));
}
function nextTask() {
    return new Promise((resolve) => {
        setTimeout(resolve, 0);
    });
}
/**
 * `routeConnections` in time slices: yields to the browser every `slice`
 * milliseconds between searches, so the page stays responsive.
 */
async function routeConnectionsAsync(inputs, context, { slice = 12, signal } = {}) {
    const steps = gridRouteSteps(inputs, context.dimensions, context.obstacles, settingsFor(inputs.length));
    let started = performance.now();
    let step = steps.next();
    while (!step.done) {
        if (performance.now() - started >= slice) {
            await nextTask();
            if (signal?.aborted) {
                return undefined;
            }
            started = performance.now();
        }
        step = steps.next();
    }
    return signal?.aborted ? undefined : lanes(step.value, context.obstacles);
}
/**
 * A preview drawn while the connections are searched, in a few
 * milliseconds: fixed Z and L shapes between faces chosen from the IEDs'
 * relative positions (`faceDirections`), attachments spread along each face
 * in the order of where they head, and overlapping lines nudged apart. It
 * does not avoid symbols or labels.
 */
function quickRoute(inputs, context) {
    const faces = inputs.map(({ source, target }) => faceDirections(source.position, target.position));
    // Order the attachments on each face by the other end's position along
    // the face, so lines leaving one face do not cross right away.
    const attachments = new Map();
    inputs.forEach(({ source, target }, k) => {
        for (const end of ['source', 'target']) {
            const [self, other] = end === 'source' ? [source, target] : [target, source];
            const face = faces[k][end];
            const axis = face === 'n' || face === 's' ? 0 : 1;
            const key = `${self.key}|${face}`;
            if (!attachments.has(key)) {
                attachments.set(key, []);
            }
            attachments.get(key).push({
                k,
                end,
                along: other.position[axis] + (end === 'target' ? 0.001 : 0),
            });
        }
    });
    const offsets = inputs.map(() => ({ source: 0.5, target: 0.5 }));
    attachments.forEach((list) => {
        list
            .sort((a, b) => a.along - b.along || a.k - b.k)
            .forEach(({ k, end }, i) => {
            offsets[k][end] = (2 * i + 1) / (2 * list.length);
        });
    });
    const shapes = inputs.map(({ source, target }, k) => routePoints(facePoint(source.position, faces[k].source, offsets[k].source), facePoint(target.position, faces[k].target, offsets[k].target), faces[k]));
    const points = nudgeRoutes(shapes.map((route, k) => ({ points: route, bundle: inputs[k].id })), { spacing: 0.12, obstacles: symbolRects(context.obstacles) });
    return inputs.map(({ id }, k) => drawRoute(id, points[k]));
}

/**
 * Internal palette for the communication map, following the OpenSCD theming
 * model (`@openscd/oscd-api` docs/theming.md).
 *
 * The root component initialises internal `--oscd-*` tokens from the
 * distro-provided `--oscd-theme-*` tokens with Solarized defaults, so
 * sub-components only ever reference the internal tokens. The service colours
 * are exposed as `--oscd-editor-map-communication-*` hooks, which fall back to
 * Solarized accents.
 */
const themeStyles = i$7 `
  :host {
    --oscd-primary: var(--oscd-theme-primary, #2aa198);
    --oscd-secondary: var(--oscd-theme-secondary, #6c71c4);
    --oscd-error: var(--oscd-theme-error, #dc322f);

    --oscd-base03: var(--oscd-theme-base03, #002b36);
    --oscd-base02: var(--oscd-theme-base02, #073642);
    --oscd-base01: var(--oscd-theme-base01, #586e75);
    --oscd-base00: var(--oscd-theme-base00, #657b83);
    --oscd-base0: var(--oscd-theme-base0, #839496);
    --oscd-base1: var(--oscd-theme-base1, #93a1a1);
    --oscd-base2: var(--oscd-theme-base2, #eee8d5);
    --oscd-base3: var(--oscd-theme-base3, #fdf6e3);

    --oscd-shape: var(--oscd-theme-shape, 8px);

    --oscd-text-font: var(--oscd-theme-text-font, 'Roboto');
    --oscd-text-font-mono: var(--oscd-theme-text-font-mono, 'Roboto Mono');
    --oscd-icon-font: var(--oscd-theme-icon-font, 'Material Symbols Outlined');

    --md-sys-shape-corner-none: 0;
    --md-sys-shape-corner-extra-small: calc(0.5 * var(--oscd-shape));
    --md-sys-shape-corner-small: var(--oscd-shape);
    --md-sys-shape-corner-medium: calc(1.5 * var(--oscd-shape));
    --md-sys-shape-corner-large: calc(2 * var(--oscd-shape));
    --md-icon-font: var(--oscd-icon-font);

    --oscd-map-goose-color: var(
      --oscd-editor-map-communication-goose-color,
      #268bd2
    );
    --oscd-map-sv-color: var(--oscd-editor-map-communication-sv-color, #cb4b16);
    --oscd-map-report-color: var(
      --oscd-editor-map-communication-report-color,
      #859900
    );
    --oscd-map-diagram-opacity: var(
      --oscd-editor-map-communication-diagram-opacity,
      0.7
    );
    --oscd-map-highlight-color: var(
      --oscd-editor-map-communication-highlight-color,
      var(--oscd-secondary)
    );

    font-family: var(--oscd-text-font);
    color: var(--oscd-base00);
  }
`;

/** Routing results kept for quick switching between filters. */
const cacheSize = 16;
const storageKey = 'oscd-editor-map-communication';
/** Pointer travel (px) after which a press becomes a pan instead of a click. */
const panThreshold = 4;
/** Smallest grid size (px) an IED is shown at when located. */
const locateGridSize = 32;
/** How long a located IED pulses (ms). */
const flashDuration = 2400;
/** Free space kept around the diagram when fitting it into view (px). */
const fitMargin = 24;
function loadSettings() {
    try {
        const stored = JSON.parse(readStored(storageKey) ?? '{}');
        return typeof stored === 'object' && stored !== null ? stored : {};
    }
    catch {
        // Not JSON: start afresh.
        return {};
    }
}
function saveSettings(settings) {
    writeStored(storageKey, JSON.stringify(settings));
}
/** References of IEDs that exist in the document, by IED name. */
function placedIeds(doc) {
    const names = new Set(Array.from(doc.querySelectorAll(':root > IED'), ied => ied.getAttribute('name')));
    return new Map(Array.from(iedReferenceMap(doc)).filter(([name]) => names.has(name)));
}
/** Approximate box of an SLD label (text left-aligned, vertically centred). */
function labelRect([lx, ly], text, fontSize) {
    const width = text.length * fontSize * 0.55;
    return [lx + 0.1, ly - 0.5 - fontSize / 2, width, fontSize];
}
/**
 * Things drawn on a substation diagram that connections should avoid: IED
 * and equipment symbols, and their labels and those of bays and voltage
 * levels.
 */
function diagramObstacles(substation, placed, references = new Map()) {
    const obstacles = [];
    placed.forEach(([x, y], ied) => {
        obstacles.push({ ied, rect: [x, y, 1, 1] });
        const reference = references.get(ied);
        if (reference) {
            obstacles.push({
                ied,
                kind: 'label',
                rect: labelRect(attributes(reference).label, ied, 0.6),
            });
        }
    });
    substation
        .querySelectorAll('ConductingEquipment, PowerTransformer')
        .forEach((equipment) => {
        const { pos: [x, y], dim: [w, h], label, } = attributes(equipment);
        obstacles.push({ rect: [x, y, Math.max(1, w), Math.max(1, h)] });
        obstacles.push({
            kind: 'label',
            rect: labelRect(label, equipment.getAttribute('name') ?? '', 0.45),
        });
    });
    Array.from(substation.getElementsByTagNameNS(sldNs, 'Section')).forEach((section) => {
        const vertices = Array.from(section.getElementsByTagNameNS(sldNs, 'Vertex')).map(vertex => [
            Number(vertex.getAttributeNS(sldNs, 'x')),
            Number(vertex.getAttributeNS(sldNs, 'y')),
        ]);
        for (let v = 1; v < vertices.length; v += 1) {
            const [x1, y1] = vertices[v - 1];
            const [x2, y2] = vertices[v];
            if (x1 === x2 || y1 === y2) {
                obstacles.push({
                    kind: 'wire',
                    rect: [
                        Math.min(x1, x2),
                        Math.min(y1, y2),
                        Math.abs(x2 - x1),
                        Math.abs(y2 - y1),
                    ],
                });
            }
        }
    });
    substation.querySelectorAll('VoltageLevel, Bay').forEach((container) => {
        const { pos: [x, y], dim: [w, h], } = attributes(container);
        if (w > 0 && h > 0) {
            obstacles.push({ kind: 'border', rect: [x, y, w, h] });
        }
        obstacles.push({
            kind: 'label',
            rect: labelRect(attributes(container).label, container.getAttribute('name') ?? '', 0.6),
        });
    });
    return obstacles;
}
const highlightStyle = {
    fill: 'var(--oscd-map-highlight-color)',
    fillOpacity: 0.35,
};
/** An editor plugin mapping IEC 61850 communication onto the single line diagram. */
class OscdEditorMapCommunication extends ScopedElementsMixin(i$4) {
    constructor() {
        super();
        this.docVersion = -1;
        this.locale = 'en';
        /** Hands an exported file to the user; replaceable for tests. */
        this.saveExport = saveFile;
        this.filter = emptyFilter();
        this.view = { gridSize: 32, showLabels: true, filterOpen: false };
        /** Whether the map is shown full screen. */
        this.fullscreen = false;
        /** IEDs placed on the document's diagrams, for the search. */
        this.searchable = [];
        /** True while a slow router works in the background. */
        this.routing = false;
        /** Settles when the background routing started last has finished. */
        this.routingDone = Promise.resolve();
        /** Routed connections by layout key, most recent last. */
        this.routeCache = new Map();
        /** Counts document changes, so cached routes of older versions expire. */
        this.generation = 0;
        /** All connections of the document, rebuilt when the document changes. */
        this.connections = [];
        /** Connections shown with the current filter. */
        this.visibleConnections = [];
        this.connectionsById = new Map();
        /** IED names to the references placing them, for IEDs in the document. */
        this.references = new Map();
        this.legacyLayout = false;
        /** The document's substations. */
        this.substations = [];
        /** Fit the diagram into view after the next render (new document). */
        this.fitPending = false;
        /** Pointer press that may become a pan. */
        /**
         * True while the diagram is fitted into view: it is fitted again when the
         * view changes size (toolbar wrapping, full screen, window resizing) until
         * the user zooms or pans.
         */
        this.fitted = false;
        this.resizeObserver = new ResizeObserver(() => {
            if (this.fitted) {
                this.zoomToFit();
            }
        });
        /** Ids of the visible connections drawn on a diagram. */
        this.drawn = new Set();
        this.options = emptyOptions();
        this.handleFullscreenChange = () => {
            this.fullscreen = this.isFullscreen();
        };
        /** Fades the SLD viewer's diagram, keeping IEDs and highlights clear. */
        this.fadeSheet = new CSSStyleSheet();
        this.fadeText = '';
        /**
         * Handles the map's keyboard shortcuts while the map is shown and either
         * has focus or nothing does (the page itself, e.g. right after opening a
         * file). Keys pressed elsewhere, such as in the shell's own fields, are
         * left alone.
         */
        this.handleKeydown = (event) => {
            const path = event.composedPath();
            const origin = path[0];
            const unfocused = origin === document.body ||
                origin === document.documentElement ||
                origin === document;
            if ((!path.includes(this) && !unfocused) ||
                this.getClientRects().length === 0) {
                return;
            }
            if (event.key === 'Escape' && this.filter.ied !== undefined) {
                this.filter = { ...this.filter, ied: undefined };
                return;
            }
            const action = shortcutAction(event, !!origin?.closest?.('input, textarea, select, [contenteditable]'));
            if (!action) {
                return;
            }
            // The map takes these keys over from the browser while it has focus.
            event.preventDefault();
            event.stopPropagation();
            this.runShortcut(action);
        };
        this.describeConnection = (id) => {
            const connection = this.connectionsById.get(id);
            return connection ? connectionTooltip(connection) : '';
        };
        this.labelConnection = (id) => {
            const connection = this.connectionsById.get(id);
            return connection ? connectionTitle(connection) : id;
        };
        const settings = loadSettings();
        if (Array.isArray(settings.services)) {
            this.filter = {
                ...this.filter,
                services: services.filter(s => settings.services.includes(s)),
            };
        }
        this.view = {
            gridSize: typeof settings.gridSize === 'number' &&
                settings.gridSize >= minGridSize &&
                settings.gridSize <= maxGridSize
                ? settings.gridSize
                : this.view.gridSize,
            showLabels: settings.showLabels ?? this.view.showLabels,
            filterOpen: settings.filterOpen ?? this.view.filterOpen,
        };
    }
    connectedCallback() {
        super.connectedCallback();
        // On the document, so shortcuts also work before the map was clicked,
        // when the page itself has focus (see handleKeydown).
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    }
    /**
     * Whether this element is the one shown full screen. Inside a shadow root
     * (as in the OpenSCD shell) `document.fullscreenElement` is the outermost
     * host, so the element's own root is asked.
     */
    isFullscreen() {
        const root = this.getRootNode();
        return root.fullscreenElement === this;
    }
    /** Shows the map full screen, or leaves full screen. */
    async toggleFullscreen() {
        try {
            if (this.isFullscreen()) {
                await document.exitFullscreen();
            }
            else {
                await this.requestFullscreen();
            }
        }
        catch {
            // Full screen may be refused (no user gesture, or disallowed by the
            // embedding page): the map just stays as it is.
        }
    }
    /**
     * Shows an IED: switches to its substation, zooms in if the diagram is
     * shown small, centres the IED and makes it pulse for a moment.
     */
    async locateIed({ name, substation }) {
        if (this.shownSubstation()?.getAttribute('name') !== substation) {
            this.view = { ...this.view, substation };
            await this.updateComplete;
        }
        const placed = this.layout?.ieds.find(ied => ied.name === name);
        const viewport = this.viewport;
        if (!placed || !viewport) {
            return;
        }
        this.fitted = false;
        if (this.view.gridSize < locateGridSize) {
            this.view = { ...this.view, gridSize: locateGridSize };
            this.persist();
        }
        // Restart the pulse when the same IED is located again.
        this.flashIed = undefined;
        await this.updateComplete;
        const canvas = viewport.querySelector('.canvas').getBoundingClientRect();
        const bounds = viewport.getBoundingClientRect();
        const { gridSize } = this.view;
        const [x, y] = placed.position;
        viewport.scrollBy({
            left: canvas.left + (x + 0.5) * gridSize - (bounds.left + bounds.width / 2),
            top: canvas.top + (y + 0.5) * gridSize - (bounds.top + bounds.height / 2),
            behavior: 'smooth',
        });
        this.flashIed = name;
        clearTimeout(this.flashTimer);
        this.flashTimer = setTimeout(() => {
            this.flashIed = undefined;
        }, flashDuration);
    }
    disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
        clearTimeout(this.flashTimer);
        this.routingJob?.abort();
        this.routingJob = undefined;
        this.resizeObserver.disconnect();
        this.observed = undefined;
        super.disconnectedCallback();
    }
    willUpdate(changed) {
        const docChanged = changed.has('doc') || changed.has('docVersion');
        if (docChanged) {
            this.generation += 1;
            this.routeCache.clear();
            this.connections = this.doc ? buildConnections(this.doc) : [];
            this.references = this.doc ? placedIeds(this.doc) : new Map();
            this.legacyLayout = this.doc ? hasLegacySldLayout(this.doc) : false;
            this.connectionsById = new Map(this.connections.map(c => [c.id, c]));
            this.substations = this.doc
                ? Array.from(this.doc.querySelectorAll(':root > Substation'))
                : [];
            this.searchable = Array.from(this.references, ([name, reference]) => ({
                name,
                substation: reference.closest('Substation')?.getAttribute('name') ?? '',
                desc: this.doc
                    ?.querySelector(`:root > IED[name="${CSS.escape(name)}"]`)
                    ?.getAttribute('desc') ?? undefined,
            }));
            if (this.selectedConnection !== undefined &&
                !this.connectionsById.has(this.selectedConnection)) {
                this.selectedConnection = undefined;
            }
        }
        if (changed.has('doc')) {
            this.fitPending = this.doc !== undefined;
            if (this.filter.ied !== undefined) {
                this.filter = { ...this.filter, ied: undefined };
            }
        }
        const substationChanged = changed.has('view') &&
            changed.get('view')?.substation !== this.view.substation;
        if (docChanged ||
            substationChanged ||
            changed.has('filter')) {
            this.visibleConnections = filterConnections(this.connections, this.filter);
            this.options = filterOptions(filterConnections(this.connections, scopeFilter(this.filter)), this.filter);
            const substation = this.shownSubstation();
            this.layout = substation ? this.computeLayout(substation) : undefined;
            this.drawn = new Set(this.layout?.shapes.map(({ id }) => id));
        }
    }
    fadeDiagram() {
        const root = this.renderRoot.querySelector('sld-substation-viewer')
            ?.shadowRoot;
        if (!root || !this.layout) {
            return;
        }
        const text = fadeRules(this.layout.ieds.map(({ name }) => name), this.layout.highlight.map(({ id }) => id));
        if (text !== this.fadeText) {
            this.fadeText = text;
            this.fadeSheet.replaceSync(text);
        }
        if (!root.adoptedStyleSheets.includes(this.fadeSheet)) {
            root.adoptedStyleSheets = [...root.adoptedStyleSheets, this.fadeSheet];
        }
    }
    updated() {
        this.fadeDiagram();
        if (this.viewport !== this.observed) {
            if (this.observed) {
                this.resizeObserver.unobserve(this.observed);
            }
            this.observed = this.viewport;
            if (this.observed) {
                this.resizeObserver.observe(this.observed);
            }
        }
        if (this.fitPending && this.viewport && this.layout) {
            this.fitPending = false;
            this.zoomToFit();
        }
        this.startRouting();
    }
    /**
     * Searches the routes of the shown layout in the background (see
     * `connection-routing.ts`), replacing its quick preview when done.
     */
    startRouting() {
        const layout = this.layout;
        if (!layout?.pending) {
            if (this.routingJob) {
                this.routingJob.abort();
                this.routingJob = undefined;
                this.routing = false;
            }
            return;
        }
        if (this.routingJob && this.routingKey === layout.key) {
            return;
        }
        this.routingJob?.abort();
        const job = new AbortController();
        this.routingJob = job;
        this.routingKey = layout.key;
        this.routing = true;
        const { inputs, context, drawn } = layout.pending;
        this.routingDone = routeConnectionsAsync(inputs, context, {
            signal: job.signal,
        }).then((routed) => {
            if (!routed || job.signal.aborted) {
                return;
            }
            this.cacheRoutes(layout.key, routed);
            this.routingJob = undefined;
            this.routing = false;
            if (this.layout?.key === layout.key) {
                this.layout = {
                    ...this.layout,
                    shapes: this.toShapes(routed, drawn),
                    pending: undefined,
                };
            }
        });
    }
    cacheRoutes(key, routed) {
        this.routeCache.delete(key);
        this.routeCache.set(key, routed);
        if (this.routeCache.size > cacheSize) {
            this.routeCache.delete(this.routeCache.keys().next().value);
        }
    }
    toShapes(routed, drawn) {
        return routed.map((route, i) => ({ ...route, service: drawn[i].service }));
    }
    /** The substation selected in the view, or the first one. */
    shownSubstation() {
        return (this.substations.find(s => s.getAttribute('name') === this.view.substation) ?? this.substations[0]);
    }
    /** Performs a keyboard shortcut's action. */
    runShortcut(action) {
        const service = {
            'toggle-goose': 'GOOSE',
            'toggle-sv': 'SV',
            'toggle-report': 'Report',
        };
        if (service[action]) {
            this.filter = {
                ...this.filter,
                services: toggleService(this.filter.services, service[action]),
            };
            this.persist();
            return;
        }
        switch (action) {
            case 'search':
                this.renderRoot.querySelector('map-toolbar')?.focusSearch();
                break;
            case 'zoom-in':
                this.zoomAt(zoomFactor);
                break;
            case 'zoom-out':
                this.zoomAt(1 / zoomFactor);
                break;
            case 'zoom-fit':
                this.zoomToFit();
                break;
            case 'previous-substation':
            case 'next-substation':
                this.stepSubstation(action === 'next-substation' ? 1 : -1);
                break;
            case 'toggle-labels':
                this.view = { ...this.view, showLabels: !this.view.showLabels };
                this.persist();
                break;
            default:
                this.view = { ...this.view, filterOpen: !this.view.filterOpen };
                this.persist();
        }
    }
    /** Shows the next (1) or previous (-1) substation, wrapping around. */
    stepSubstation(step) {
        const count = this.substations.length;
        const shown = this.shownSubstation();
        if (count < 2 || !shown) {
            return;
        }
        const next = this.substations[(this.substations.indexOf(shown) + step + count) % count];
        this.view = { ...this.view, substation: next.getAttribute('name') ?? '' };
        this.fitPending = true;
    }
    handleFilterChange(event) {
        this.filter = { ...this.filter, ...event.detail };
        this.persist();
    }
    handleViewChange(event) {
        this.view = { ...this.view, ...event.detail };
        this.persist();
    }
    handleIedSelect(event) {
        const { name } = event.detail;
        this.filter = {
            ...this.filter,
            ied: this.filter.ied === name ? undefined : name,
        };
    }
    handleConnectionSelect(event) {
        const { id } = event.detail;
        this.selectedConnection = id;
    }
    handleConnectionClose() {
        this.selectedConnection = undefined;
    }
    handleRemoveInputs(event) {
        const { inputs } = event.detail;
        const edits = removeInputsEdits(inputs);
        if (edits.length === 0) {
            return;
        }
        const connection = this.selectedConnection
            ? this.connectionsById.get(this.selectedConnection)
            : undefined;
        const title = connection
            ? msg(str `Remove ${inputs.length} input(s) of ${connectionTitle(connection)}`)
            : msg('Remove inputs');
        this.dispatchEvent(newEditEventV2(edits, { title }));
    }
    /**
     * Zooms by `factor`, keeping the diagram point under the client position
     * (default: the viewport's centre) in place.
     */
    async zoomAt(factor, clientX, clientY) {
        this.fitted = false;
        const viewport = this.viewport;
        const canvas = viewport?.querySelector('.canvas');
        const gridSize = zoomGridSize(this.view.gridSize, factor);
        if (!viewport || !canvas || gridSize === this.view.gridSize) {
            return;
        }
        const bounds = viewport.getBoundingClientRect();
        const x = clientX ?? bounds.left + bounds.width / 2;
        const y = clientY ?? bounds.top + bounds.height / 2;
        const before = canvas.getBoundingClientRect();
        const scale = gridSize / this.view.gridSize;
        this.view = { ...this.view, gridSize };
        this.persist();
        await this.updateComplete;
        const after = canvas.getBoundingClientRect();
        viewport.scrollLeft += after.left + (x - before.left) * scale - x;
        viewport.scrollTop += after.top + (y - before.top) * scale - y;
    }
    /** Zooms so the whole diagram fits the viewport. */
    zoomToFit() {
        const viewport = this.viewport;
        if (!viewport || !this.layout) {
            return;
        }
        const [w, h] = this.layout.dimensions;
        const fit = Math.min((viewport.clientWidth - 2 * fitMargin) / Math.max(1, w), (viewport.clientHeight - 2 * fitMargin) / Math.max(1, h));
        if (!Number.isFinite(fit) || fit <= 0) {
            return;
        }
        const gridSize = Math.min(maxGridSize, Math.max(minGridSize, Math.floor(fit * 10) / 10));
        this.view = { ...this.view, gridSize };
        this.persist();
        viewport.scrollTo(0, 0);
        this.fitted = true;
    }
    /**
     * Exports the shown substation as drawn, connections included: the whole
     * diagram or the part visible in the viewport, as SVG or PNG.
     */
    async exportImage(scope, format) {
        const { layout, viewport } = this;
        const sld = this.renderRoot
            .querySelector('sld-substation-viewer')
            ?.shadowRoot?.querySelector('svg#sld');
        const overlay = this.renderRoot
            .querySelector('map-connection-layer')
            ?.shadowRoot?.querySelector('svg');
        if (!layout || !viewport || !sld || !overlay) {
            return;
        }
        const { gridSize } = this.view;
        const [columns, rows] = layout.dimensions;
        const box = scope === 'view'
            ? visibleBox(viewport.getBoundingClientRect(), sld.getBoundingClientRect(), gridSize, layout.dimensions)
            : [0, 0, columns, rows];
        const text = composeSvg([sld, overlay], box, gridSize, getComputedStyle(this).backgroundColor);
        const name = exportFileName(this.docName, layout.substation.getAttribute('name') ?? '', scope, format);
        const [width, height] = [box[2] * gridSize, box[3] * gridSize];
        const converters = {
            svg: async () => new Blob([text], { type: 'image/svg+xml' }),
            png: () => svgToPng(text, width, height),
            pdf: () => svgToPdf(text, width, height),
        };
        const blob = await converters[format]();
        this.saveExport(blob, name);
    }
    handleExport(event) {
        this.exportImage(event.detail.scope, event.detail.format);
    }
    handleWheel(event) {
        event.preventDefault();
        // Lines (Firefox) and pages are scaled to pixels.
        const unit = [1, 16, 400][event.deltaMode] ?? 1;
        const delta = Math.max(-200, Math.min(200, event.deltaY * unit));
        if (delta === 0) {
            return;
        }
        this.zoomAt(Math.exp(-delta * 0.002), event.clientX, event.clientY);
    }
    handlePointerDown(event) {
        // Left (primary) or middle (wheel) button press: may start a pan.
        if ((event.button !== 0 && event.button !== 1) || !this.viewport) {
            return;
        }
        if (event.button === 1) {
            // No auto-scroll cursor on middle click.
            event.preventDefault();
        }
        this.pan = {
            pointer: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            left: this.viewport.scrollLeft,
            top: this.viewport.scrollTop,
            moved: false,
        };
    }
    handlePointerMove(event) {
        const { pan, viewport } = this;
        if (!pan || !viewport || event.pointerId !== pan.pointer) {
            return;
        }
        const dx = event.clientX - pan.x;
        const dy = event.clientY - pan.y;
        if (!pan.moved && Math.hypot(dx, dy) < panThreshold) {
            return;
        }
        if (!pan.moved) {
            pan.moved = true;
            this.fitted = false;
            viewport.setPointerCapture?.(event.pointerId);
            viewport.classList.add('panning');
        }
        viewport.scrollLeft = pan.left - dx;
        viewport.scrollTop = pan.top - dy;
    }
    handlePointerUp(event) {
        const { pan, viewport } = this;
        if (!pan || event.pointerId !== pan.pointer) {
            return;
        }
        this.pan = undefined;
        viewport?.classList.remove('panning');
        if (pan.moved) {
            // The press was a pan: swallow the click that may follow it.
            const swallow = (click) => {
                click.stopPropagation();
                click.preventDefault();
            };
            window.addEventListener('click', swallow, { capture: true, once: true });
            setTimeout(() => window.removeEventListener('click', swallow, true), 0);
        }
    }
    persist() {
        saveSettings({
            services: this.filter.services,
            showLabels: this.view.showLabels,
            filterOpen: this.view.filterOpen,
            gridSize: this.view.gridSize,
        });
    }
    computeLayout(substation) {
        const placed = new Map();
        this.references.forEach((reference, name) => {
            if (reference.closest('Substation') === substation) {
                placed.set(name, attributes(reference).pos);
            }
        });
        const drawn = this.visibleConnections.filter(({ source, target }) => placed.has(source.name) && placed.has(target.name));
        const dimensions = attributes(substation).dim;
        const inputs = drawn.map(({ id, source, target }) => ({
            id,
            source: { key: source.name, position: placed.get(source.name) },
            target: { key: target.name, position: placed.get(target.name) },
        }));
        const context = {
            dimensions,
            obstacles: diagramObstacles(substation, placed, this.references),
        };
        const key = [
            this.generation,
            substation.getAttribute('name'),
            ...inputs.map(({ id }) => id),
        ].join('\u0000');
        const cached = this.routeCache.get(key);
        // Not routed yet: draw the quick preview and search in the background.
        const pending = !cached && inputs.length > 0;
        const routed = cached ?? quickRoute(inputs, context);
        const { ied } = this.filter;
        const highlight = ied === undefined
            ? []
            : linkedEquipment(substation, ied).map(equipment => ({
                id: `${identity(equipment)}`,
                style: highlightStyle,
            }));
        return {
            substation,
            dimensions,
            ieds: Array.from(placed, ([name, position]) => ({ name, position })),
            shapes: this.toShapes(routed, drawn),
            highlight,
            key,
            pending: pending ? { inputs, context, drawn } : undefined,
        };
    }
    renderEmpty(message) {
        return b `<p class="empty">${message}</p>`;
    }
    renderNotice() {
        if (!this.layout || this.layout.ieds.length === 0) {
            return b `<p class="notice">
        ${msg('No IEDs are placed on the diagram yet. Place them with the Single Line Diagram editor to see their communication.')}
      </p>`;
        }
        if (this.connections.length === 0) {
            return b `<p class="notice">
        ${msg('No GOOSE, Sampled Value or Report connections found.')}
      </p>`;
        }
        return A;
    }
    renderSubstation(layout) {
        const { substation, dimensions, ieds, shapes, highlight } = layout;
        return b `<section
      class="canvas"
      aria-label=${substation.getAttribute('name') ?? msg('Substation')}
    >
      <sld-substation-viewer
        .doc=${this.doc}
        .substation=${substation}
        .docVersion=${this.docVersion}
        .gridSize=${this.view.gridSize}
        .showLabels=${this.view.showLabels}
        .showIeds=${true}
        .highlight=${highlight}
      ></sld-substation-viewer>
      <map-connection-layer
        .dimensions=${dimensions}
        .gridSize=${this.view.gridSize}
        .ieds=${ieds}
        .connections=${shapes}
        .selectedIed=${this.filter.ied}
        .selectedConnection=${this.selectedConnection}
        .describe=${this.describeConnection}
        .label=${this.labelConnection}
        .flashIed=${this.flashIed}
      ></map-connection-layer>
    </section>`;
    }
    render() {
        const { doc } = this;
        if (!doc) {
            return this.renderEmpty(msg('No document loaded'));
        }
        if (!this.layout) {
            return this.renderEmpty(msg('No substation found in this document'));
        }
        if (this.legacyLayout) {
            return this.renderEmpty(msg('This file uses an outdated single line diagram format. Open it in the Single Line Diagram editor to convert it, then return here.'));
        }
        return b `<div
      class="map"
      @map-filter-change=${this.handleFilterChange}
      @map-view-change=${this.handleViewChange}
      @map-ied-select=${this.handleIedSelect}
      @map-connection-select=${this.handleConnectionSelect}
      @map-connection-close=${this.handleConnectionClose}
      @map-remove-inputs=${this.handleRemoveInputs}
    >
      <map-toolbar
        .filter=${this.filter}
        .view=${this.view}
        .filterCount=${activeCriteria(this.filter)}
        .substations=${this.substations.map(s => s.getAttribute('name') ?? '')}
        @map-zoom-fit=${() => this.zoomToFit()}
        @map-export=${this.handleExport}
        @map-fullscreen=${() => this.toggleFullscreen()}
        @map-ied-locate=${(event) => this.locateIed(event.detail)}
        .ieds=${this.searchable}
        .fullscreen=${this.fullscreen}
      ></map-toolbar>
      <div class="body">
        <div class="stage">
          ${this.renderNotice()}
          ${this.routing
            ? b `<p class="routing" role="status">
                ${msg('Optimising connection routes…')}
              </p>`
            : A}
          <main
            tabindex="0"
            aria-label=${msg('Diagram: drag to pan; wheel, + or - to zoom; 0 to fit; / to find an IED; F for the filter panel; L for labels')}
            @wheel=${this.handleWheel}
            @pointerdown=${this.handlePointerDown}
            @pointermove=${this.handlePointerMove}
            @pointerup=${this.handlePointerUp}
            @pointercancel=${this.handlePointerUp}
          >
            ${this.renderSubstation(this.layout)}
          </main>
        </div>
        ${this.view.filterOpen
            ? b `<map-filter-panel
              .filter=${this.filter}
              .options=${this.options}
              .connections=${this.visibleConnections}
              .drawn=${this.drawn}
              .selectedConnection=${this.selectedConnection}
            ></map-filter-panel>`
            : A}
      </div>
      <map-connection-dialog
        .connection=${this.selectedConnection
            ? this.connectionsById.get(this.selectedConnection)
            : undefined}
      ></map-connection-dialog>
    </div>`;
    }
}
OscdEditorMapCommunication.scopedElements = {
    'sld-substation-viewer': SldSubstationViewer,
    'map-connection-layer': MapConnectionLayer,
    'map-toolbar': MapToolbar,
    'map-filter-panel': MapFilterPanel,
    'map-connection-dialog': MapConnectionDialog,
};
OscdEditorMapCommunication.styles = [
    oscdMd3Mappings,
    themeStyles,
    i$7 `
      :host {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        /* Hosts sizing editors by their content still get a usable map. */
        min-height: 480px;
        background: var(--oscd-base3);
      }

      .map {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 0;
      }

      map-toolbar {
        flex: none;
        /* Keeps the search results above the map. */
        position: relative;
        z-index: 2;
        border-bottom: 1px solid var(--oscd-base2);
      }

      .body {
        flex: auto;
        display: flex;
        min-height: 0;
      }

      .stage {
        flex: auto;
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
      }

      main {
        flex: auto;
        display: flex;
        overflow: auto;
        min-height: 0;
        padding: 24px;
        cursor: grab;
        /* Panned by dragging and zoomed by the wheel: no scrollbars. */
        scrollbar-width: none;
        touch-action: none;
        user-select: none;
      }

      main::-webkit-scrollbar {
        display: none;
      }

      main:focus {
        outline: none;
      }

      main:focus-visible {
        outline: 2px solid var(--oscd-primary);
        outline-offset: -2px;
      }

      main.panning {
        cursor: grabbing;
      }

      map-filter-panel {
        flex: none;
        width: 380px;
        border-left: 1px solid var(--oscd-base2);
      }

      .canvas {
        position: relative;
        flex: none;
        width: fit-content;
        height: fit-content;
        /* Centred while smaller than the viewport, scrollable when larger. */
        margin: auto;
      }

      map-connection-layer {
        position: absolute;
        top: 0;
        left: 0;
      }

      .notice {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1;
        margin: 0;
        padding: 8px 16px;
        color: var(--oscd-base01);
        background: color-mix(in srgb, var(--oscd-base3) 85%, transparent);
        pointer-events: none;
      }

      .routing {
        position: absolute;
        right: 12px;
        bottom: 12px;
        z-index: 1;
        margin: 0;
        padding: 4px 12px;
        border-radius: 12px;
        background: var(--oscd-base2);
        color: var(--oscd-base01);
        font-size: 0.85em;
        pointer-events: none;
      }

      .empty {
        margin: 16px;
        color: var(--oscd-base01);
      }
    `,
];
__decorate([
    n$3({ attribute: false })
], OscdEditorMapCommunication.prototype, "doc", void 0);
__decorate([
    n$3({ attribute: false })
], OscdEditorMapCommunication.prototype, "docVersion", void 0);
__decorate([
    n$3({ type: String })
], OscdEditorMapCommunication.prototype, "locale", void 0);
__decorate([
    n$3({ type: String })
], OscdEditorMapCommunication.prototype, "docName", void 0);
__decorate([
    r$2()
], OscdEditorMapCommunication.prototype, "filter", void 0);
__decorate([
    r$2()
], OscdEditorMapCommunication.prototype, "view", void 0);
__decorate([
    r$2()
], OscdEditorMapCommunication.prototype, "selectedConnection", void 0);
__decorate([
    e$4('main')
], OscdEditorMapCommunication.prototype, "viewport", void 0);
__decorate([
    r$2()
], OscdEditorMapCommunication.prototype, "fullscreen", void 0);
__decorate([
    r$2()
], OscdEditorMapCommunication.prototype, "flashIed", void 0);
__decorate([
    r$2()
], OscdEditorMapCommunication.prototype, "routing", void 0);

export { OscdEditorMapCommunication as default };
//# sourceMappingURL=oscd-editor-map-communication.js.map
